/* eslint-disable */
// OR
/* eslint-env browser, jquery */
/* global DocumentTouch, ActiveXObject, jsVectorMap */
/* eslint-disable no-prototype-builtins, no-useless-escape, no-unused-vars, no-empty, no-cond-assign */

(function () {
  var e = {
      5657: function () {
        window.theme = {
          primary: "#3B7DDD",
          secondary: "#6c757d",
          success: "#1cbb8c",
          info: "#17a2b8",
          warning: "#fcb92c",
          danger: "#dc3545",
          white: "#fff",
          "gray-100": "#f8f9fa",
          "gray-200": "#e9ecef",
          "gray-300": "#dee2e6",
          "gray-400": "#ced4da",
          "gray-500": "#adb5bd",
          "gray-600": "#6c757d",
          "gray-700": "#495057",
          "gray-800": "#343a40",
          "gray-900": "#212529",
          black: "#000",
        };
      },
      7386: function () {
        jsVectorMap.addMap("world", {
          insets: [
            {
              width: 900,
              top: 0,
              left: 0,
              height: 440.70631074413296,
              bbox: [
                { y: -12671671.123330014, x: -20004297.151525836 },
                { y: 6930392.025135122, x: 20026572.39474939 },
              ],
            },
          ],
          paths: {
            BD: {
              path: "M651.84,230.21l-0.6,-2.0l-1.36,-1.71l-2.31,-0.11l-0.41,0.48l0.2,0.94l-0.53,0.99l-0.72,-0.36l-0.68,0.35l-1.2,-0.36l-0.37,-2.0l-0.81,-1.86l0.39,-1.46l-0.22,-0.47l-1.14,-0.53l0.29,-0.5l1.48,-0.94l0.03,-0.65l-1.55,-1.22l0.55,-1.14l1.61,0.94l1.04,0.15l0.18,1.54l0.34,0.35l5.64,0.63l-0.84,1.64l-1.22,0.34l-0.77,1.51l0.07,0.47l1.37,1.37l0.67,-0.19l0.42,-1.39l1.21,3.84l-0.03,1.21l-0.33,-0.15l-0.4,0.28Z",
              name: "Bangladesh",
            },
            BE: {
              path: "M429.29,144.05l1.91,0.24l2.1,-0.63l2.63,1.99l-0.21,1.66l-0.69,0.4l-0.18,1.2l-1.66,-1.13l-1.39,0.15l-2.73,-2.7l-1.17,-0.18l-0.16,-0.52l1.54,-0.5Z",
              name: "Belgium",
            },
            BF: {
              path: "M421.42,247.64l-0.11,0.95l0.34,1.16l1.4,1.71l0.07,1.1l0.32,0.37l2.55,0.51l-0.04,1.28l-0.38,0.53l-1.07,0.21l-0.72,1.18l-0.63,0.21l-3.22,-0.25l-0.94,0.39l-5.4,-0.05l-0.39,0.38l0.16,2.73l-1.23,-0.43l-1.17,0.1l-0.89,0.57l-2.27,-1.72l-0.13,-1.11l0.61,-0.96l0.02,-0.93l1.87,-1.98l0.44,-1.81l0.43,-0.39l1.28,0.26l1.05,-0.52l0.47,-0.73l1.84,-1.09l0.55,-0.83l2.2,-1.0l1.15,-0.3l0.72,0.45l1.13,-0.01Z",
              name: "Burkina Faso",
            },
            BG: {
              path: "M491.65,168.18l-0.86,0.88l-0.91,2.17l0.48,1.34l-1.6,-0.24l-2.55,0.95l-0.28,1.51l-1.8,0.22l-2.0,-1.0l-1.92,0.79l-1.42,-0.07l-0.15,-1.63l-1.05,-0.97l0.0,-0.8l1.2,-1.57l0.01,-0.56l-1.14,-1.23l-0.05,-0.94l0.88,0.97l0.88,-0.2l1.91,0.47l3.68,0.16l1.42,-0.81l2.72,-0.66l2.55,1.24Z",
              name: "Bulgaria",
            },
            BA: {
              path: "M463.49,163.65l2.1,0.5l1.72,-0.03l1.52,0.68l-0.36,0.78l0.08,0.45l1.04,1.02l-0.25,0.98l-1.81,1.15l-0.38,1.38l-1.67,-0.87l-0.89,-1.2l-2.11,-1.83l-1.63,-2.22l0.23,-0.57l0.48,0.38l0.55,-0.06l0.43,-0.51l0.94,-0.06Z",
              name: "Bosnia and Herz.",
            },
            BN: {
              path: "M707.48,273.58l0.68,-0.65l1.41,-0.91l-0.15,1.63l-0.81,-0.05l-0.61,0.58l-0.53,-0.6Z",
              name: "Brunei",
            },
            BO: {
              path: "M263.83,340.69l-3.09,-0.23l-0.38,0.23l-0.7,1.52l-1.31,-1.53l-3.28,-0.64l-2.37,2.4l-1.31,0.26l-0.88,-3.26l-1.3,-2.86l0.74,-2.37l-0.13,-0.43l-1.2,-1.01l-0.37,-1.89l-1.08,-1.55l1.45,-2.56l-0.96,-2.33l0.47,-1.06l-0.34,-0.73l0.91,-1.32l0.16,-3.84l0.5,-1.18l-1.81,-3.41l2.46,0.07l0.8,-0.85l3.4,-1.91l2.66,-0.35l-0.19,1.38l0.3,1.07l-0.05,1.97l2.72,2.27l2.88,0.49l0.89,0.86l1.79,0.58l0.98,0.7l1.71,0.05l1.17,0.61l0.6,2.7l-0.7,0.54l0.96,2.99l0.37,0.28l4.3,0.1l-0.25,1.2l0.27,1.02l1.43,0.9l0.5,1.35l-0.41,1.86l-0.65,1.08l0.12,1.35l-2.69,-1.65l-2.4,-0.03l-4.36,0.76l-1.49,2.5l-0.11,1.52l-0.75,2.37Z",
              name: "Bolivia",
            },
            JP: {
              path: "M781.12,166.87l1.81,0.68l1.62,-0.97l0.39,2.42l-3.35,0.75l-2.23,2.88l-3.63,-1.9l-0.56,0.2l-1.26,3.05l-2.16,0.03l-0.29,-2.51l1.08,-2.03l2.45,-0.16l0.37,-0.33l1.25,-5.94l2.47,2.71l2.03,1.12ZM773.56,187.34l-0.91,2.22l0.37,1.52l-1.14,1.75l-3.02,1.26l-4.58,0.27l-3.34,3.01l-1.25,-0.8l-0.09,-1.9l-0.46,-0.38l-4.35,0.62l-3.0,1.32l-2.85,0.05l-0.37,0.27l0.13,0.44l2.32,1.89l-1.54,4.34l-1.26,0.9l-0.79,-0.7l0.56,-2.27l-0.21,-0.45l-1.47,-0.75l-0.74,-1.4l2.12,-0.84l1.26,-1.7l2.45,-1.42l1.83,-1.91l4.78,-0.81l2.6,0.57l0.44,-0.21l2.39,-4.66l1.29,1.06l0.5,0.01l5.1,-4.02l1.69,-3.73l-0.38,-3.4l0.9,-1.61l2.14,-0.44l1.23,3.72l-0.07,2.18l-2.23,2.84l-0.04,3.16ZM757.78,196.26l0.19,0.56l-1.01,1.21l-1.16,-0.68l-1.28,0.65l-0.69,1.45l-1.02,-0.5l0.01,-0.93l1.14,-1.38l1.57,0.14l0.85,-0.98l1.4,0.46Z",
              name: "Japan",
            },
            BI: {
              path: "M495.45,295.49l-1.08,-2.99l1.14,-0.11l0.64,-1.19l0.76,0.09l0.65,1.83l-2.1,2.36Z",
              name: "Burundi",
            },
            BJ: {
              path: "M429.57,255.75l-0.05,0.8l0.5,1.34l-0.42,0.86l0.17,0.79l-1.81,2.12l-0.57,1.76l-0.08,5.42l-1.41,0.2l-0.48,-1.36l0.11,-5.71l-0.52,-0.7l-0.2,-1.35l-1.48,-1.48l0.21,-0.9l0.89,-0.43l0.42,-0.92l1.27,-0.36l1.22,-1.34l0.61,-0.0l1.62,1.24Z",
              name: "Benin",
            },
            BT: {
              path: "M650.32,213.86l0.84,0.71l-0.12,1.1l-3.76,-0.11l-1.57,0.4l-1.93,-0.87l1.48,-1.96l1.13,-0.57l1.63,0.57l1.33,0.08l0.99,0.65Z",
              name: "Bhutan",
            },
            JM: {
              path: "M228.38,239.28l-0.8,0.4l-2.26,-1.06l0.84,-0.23l2.14,0.3l1.17,0.56l-1.08,0.03Z",
              name: "Jamaica",
            },
            BW: {
              path: "M483.92,330.07l2.27,4.01l2.83,2.86l0.96,0.31l0.78,2.43l2.13,0.61l1.02,0.76l-3.0,1.64l-2.32,2.02l-1.54,2.69l-1.52,0.45l-0.64,1.94l-1.34,0.52l-1.85,-0.12l-1.21,-0.74l-1.35,-0.3l-1.22,0.62l-0.75,1.37l-2.31,1.9l-1.4,0.21l-0.35,-0.59l0.16,-1.75l-1.48,-2.54l-0.62,-0.43l-0.0,-7.1l2.08,-0.08l0.39,-0.4l0.07,-8.9l5.19,-0.93l0.8,0.89l0.51,0.07l1.5,-0.95l2.21,-0.49Z",
              name: "Botswana",
            },
            BR: {
              path: "M259.98,275.05l3.24,0.7l0.65,-0.53l4.55,-1.32l1.08,-1.06l-0.02,-0.63l0.55,-0.05l0.28,0.28l-0.26,0.87l0.22,0.48l0.73,0.32l0.4,0.81l-0.62,0.86l-0.4,2.13l0.82,2.56l1.69,1.43l1.43,0.2l3.17,-1.68l3.18,0.3l0.65,-0.75l-0.27,-0.92l1.9,-0.09l2.39,0.99l1.06,-0.61l0.84,0.78l1.2,-0.18l1.18,-1.06l0.84,-1.94l1.36,-2.11l0.37,-0.05l1.89,5.45l1.33,0.59l0.05,1.28l-1.77,1.94l0.02,0.56l1.02,0.87l4.07,0.36l0.08,2.16l0.66,0.29l1.74,-1.5l6.97,2.32l1.02,1.22l-0.35,1.18l0.49,0.5l2.81,-0.74l4.77,1.3l3.75,-0.08l3.57,2.0l3.29,2.86l1.93,0.72l2.12,0.12l0.71,0.62l1.21,4.51l-0.95,3.98l-4.72,5.06l-1.64,2.92l-1.72,2.05l-0.8,0.3l-0.72,2.03l0.18,4.75l-0.94,5.53l-0.81,1.13l-0.43,3.36l-2.55,3.5l-0.4,2.51l-1.86,1.04l-0.67,1.53l-2.54,0.01l-3.94,1.01l-1.83,1.2l-2.87,0.82l-3.03,2.19l-2.2,2.83l-0.36,2.0l0.4,1.58l-0.44,2.6l-0.51,1.2l-1.77,1.54l-2.75,4.78l-3.83,3.42l-1.24,2.74l-1.18,1.15l-0.36,-0.83l0.95,-1.14l0.01,-0.5l-1.52,-1.97l-4.56,-3.32l-1.03,-0.0l-2.38,-2.02l-0.81,-0.0l5.34,-5.45l3.77,-2.58l0.22,-2.46l-1.35,-1.81l-0.91,0.07l0.58,-2.33l0.01,-1.54l-1.11,-0.83l-1.75,0.3l-0.44,-3.11l-0.52,-0.95l-1.88,-0.88l-1.24,0.47l-2.17,-0.41l0.15,-3.21l-0.62,-1.34l0.66,-0.73l-0.22,-1.34l0.66,-1.13l0.44,-2.04l-0.61,-1.83l-1.4,-0.86l-0.2,-0.75l0.34,-1.39l-0.38,-0.5l-4.52,-0.1l-0.72,-2.22l0.59,-0.42l-0.03,-1.1l-0.5,-0.87l-0.32,-1.7l-1.45,-0.76l-1.63,-0.02l-1.05,-0.72l-1.6,-0.48l-1.13,-0.99l-2.69,-0.4l-2.47,-2.06l0.13,-4.35l-0.45,-0.45l-3.46,0.5l-3.44,1.94l-0.6,0.74l-2.9,-0.17l-1.47,0.42l-0.72,-0.18l0.15,-3.52l-0.63,-0.34l-1.94,1.41l-1.87,-0.06l-0.83,-1.18l-1.37,-0.26l0.21,-1.01l-1.35,-1.49l-0.88,-1.91l0.56,-0.6l-0.0,-0.81l1.29,-0.62l0.22,-0.43l-0.22,-1.19l0.61,-0.91l0.15,-0.99l2.65,-1.58l1.99,-0.47l0.42,-0.36l2.06,0.11l0.42,-0.33l1.19,-8.0l-0.41,-1.56l-1.1,-1.0l0.01,-1.33l1.91,-0.42l0.08,-0.96l-0.33,-0.43l-1.14,-0.2l-0.02,-0.83l4.47,0.05l0.82,-0.67l0.82,1.81l0.8,0.07l1.15,1.1l2.26,-0.05l0.71,-0.83l2.78,-0.96l0.48,-1.13l1.6,-0.64l0.24,-0.47l-0.48,-0.82l-1.83,-0.19l-0.36,-3.22Z",
              name: "Brazil",
            },
            BS: {
              path: "M226.4,223.87l-0.48,-1.15l-0.84,-0.75l0.36,-1.11l0.95,1.95l0.01,1.06ZM225.56,216.43l-1.87,0.29l-0.04,-0.22l0.74,-0.14l1.17,0.06Z",
              name: "Bahamas",
            },
            BY: {
              path: "M493.84,128.32l0.29,0.7l0.49,0.23l1.19,-0.38l2.09,0.72l0.19,1.26l-0.45,1.24l1.57,2.26l0.89,0.59l0.17,0.81l1.58,0.56l0.4,0.5l-0.53,0.41l-1.87,-0.11l-0.73,0.38l-0.13,0.52l1.04,2.74l-1.91,0.26l-0.89,0.99l-0.11,1.18l-2.73,-0.04l-0.53,-0.62l-0.52,-0.08l-0.75,0.46l-0.91,-0.42l-1.92,-0.07l-2.75,-0.79l-2.6,-0.28l-2.0,0.07l-1.5,0.92l-0.67,0.07l-0.08,-1.22l-0.59,-1.19l1.36,-0.88l0.01,-1.35l-0.7,-1.41l-0.07,-1.0l2.16,-0.02l2.72,-1.3l0.75,-2.04l1.91,-1.04l0.2,-0.41l-0.19,-1.25l3.8,-1.78l2.3,0.77Z",
              name: "Belarus",
            },
            BZ: {
              path: "M198.03,244.38l0.1,-4.49l0.69,-0.06l0.74,-1.3l0.34,0.28l-0.4,1.3l0.17,0.58l-0.34,2.25l-1.3,1.42Z",
              name: "Belize",
            },
            RU: {
              path: "M491.55,115.25l2.55,-1.85l-0.01,-0.65l-2.2,-1.5l7.32,-6.76l1.03,-2.11l-0.13,-0.49l-3.46,-2.52l0.86,-2.7l-2.11,-2.81l1.56,-3.67l-2.77,-4.52l2.15,-2.99l-0.08,-0.55l-3.65,-2.73l0.3,-2.54l1.81,-0.37l4.26,-1.77l2.42,-1.45l4.06,2.61l6.79,1.04l9.34,4.85l1.78,1.88l0.14,2.46l-2.55,2.02l-3.9,1.06l-11.07,-3.14l-2.06,0.53l-0.13,0.7l3.94,2.94l0.31,5.86l0.26,0.36l5.14,2.24l0.58,-0.29l0.32,-1.94l-1.35,-1.78l1.13,-1.09l6.13,2.42l2.11,-0.98l0.18,-0.56l-1.51,-2.67l5.41,-3.76l2.07,0.22l2.26,1.41l0.57,-0.16l1.46,-2.87l-0.05,-0.44l-1.92,-2.32l1.12,-2.32l-1.32,-2.27l5.87,1.16l1.04,1.75l-2.59,0.43l-0.33,0.4l0.02,2.36l2.46,1.83l3.87,-0.91l0.86,-2.8l13.69,-5.65l0.99,0.11l-1.92,2.06l0.23,0.67l3.11,0.45l2.0,-1.48l4.56,-0.12l3.64,-1.73l2.65,2.44l0.56,-0.01l2.85,-2.88l-0.01,-0.57l-2.35,-2.29l0.9,-1.01l7.14,1.3l3.41,1.36l9.05,4.97l0.51,-0.11l1.67,-2.27l-0.05,-0.53l-2.43,-2.21l-0.06,-0.78l-0.34,-0.36l-2.52,-0.36l0.64,-1.93l-1.32,-3.46l-0.06,-1.21l4.48,-4.06l1.69,-4.29l1.6,-0.81l6.23,1.18l0.44,2.21l-2.29,3.64l0.06,0.5l1.47,1.39l0.76,3.0l-0.56,6.03l2.69,2.82l-0.96,2.57l-4.86,5.95l0.23,0.64l2.86,0.61l0.42,-0.17l0.93,-1.4l2.64,-1.03l0.87,-2.24l2.09,-1.96l0.07,-0.5l-1.36,-2.28l1.09,-2.69l-0.32,-0.55l-2.47,-0.33l-0.5,-2.06l1.94,-4.38l-0.06,-0.42l-2.96,-3.4l4.12,-2.88l0.16,-0.4l-0.51,-2.93l0.54,-0.05l1.13,2.25l-0.96,4.35l0.27,0.47l2.68,0.84l0.5,-0.51l-1.02,-2.99l3.79,-1.66l5.01,-0.24l4.53,2.61l0.48,-0.06l0.07,-0.48l-2.18,-3.82l-0.23,-4.67l3.98,-0.9l5.97,0.21l5.49,-0.64l0.27,-0.65l-1.83,-2.31l2.56,-2.9l2.87,-0.17l4.8,-2.47l6.54,-0.67l1.03,-1.42l6.25,-0.45l2.32,1.11l5.53,-2.7l4.5,0.08l0.39,-0.28l0.66,-2.15l2.26,-2.12l5.69,-2.11l3.21,1.29l-2.46,0.94l-0.25,0.42l0.34,0.35l5.41,0.77l0.61,2.33l0.58,0.25l2.2,-1.22l7.13,0.07l5.51,2.47l1.79,1.72l-0.53,2.24l-9.16,4.15l-1.97,1.52l0.16,0.71l6.77,1.91l2.16,-0.78l1.13,2.74l0.67,0.11l1.01,-1.15l3.81,-0.73l7.7,0.77l0.54,1.99l0.36,0.29l10.47,0.71l0.43,-0.38l0.13,-3.23l4.87,0.78l3.95,-0.02l3.83,2.4l1.03,2.71l-1.35,1.79l0.02,0.5l3.15,3.64l4.07,1.96l0.53,-0.18l2.23,-4.47l3.95,1.93l4.16,-1.21l4.73,1.39l2.05,-1.26l3.94,0.62l0.43,-0.55l-1.68,-4.02l2.89,-1.8l22.31,3.03l2.16,2.75l6.55,3.51l10.29,-0.81l4.82,0.73l1.85,1.66l-0.29,3.08l0.25,0.41l3.08,1.26l3.56,-0.88l4.35,-0.11l4.8,0.87l4.57,-0.47l4.23,3.79l0.43,0.07l3.1,-1.4l0.16,-0.6l-1.88,-2.62l0.85,-1.52l7.71,1.21l5.22,-0.26l7.09,2.09l9.59,5.22l6.35,4.11l-0.2,2.38l1.88,1.41l0.6,-0.42l-0.48,-2.53l6.15,0.57l4.4,3.51l-1.97,1.43l-4.0,0.41l-0.36,0.39l-0.06,3.79l-0.74,0.62l-2.07,-0.11l-1.91,-1.39l-3.14,-1.11l-0.78,-1.85l-2.72,-0.68l-2.63,0.49l-1.04,-1.1l0.46,-1.31l-0.5,-0.51l-3.0,0.98l-0.22,0.58l0.99,1.7l-1.21,1.48l-3.04,1.68l-3.12,-0.28l-0.4,0.23l0.09,0.46l2.2,2.09l1.46,3.2l1.15,1.1l0.24,1.33l-0.42,0.67l-4.63,-0.77l-6.96,2.9l-2.19,0.44l-7.6,5.06l-0.84,1.45l-3.61,-2.37l-6.24,2.82l-0.94,-1.15l-0.53,-0.08l-2.28,1.52l-3.2,-0.49l-0.44,0.27l-0.78,2.37l-3.05,3.78l0.09,1.47l0.29,0.36l2.54,0.72l-0.29,4.53l-1.97,0.11l-0.35,0.26l-1.07,2.94l0.8,1.45l-3.91,1.58l-1.05,3.95l-3.48,0.77l-0.3,0.3l-0.72,3.29l-3.09,2.65l-0.7,-1.74l-2.44,-12.44l1.16,-4.71l2.04,-2.06l0.22,-1.64l3.8,-0.86l4.46,-4.61l4.28,-3.81l4.48,-3.01l2.17,-5.63l-0.42,-0.54l-3.04,0.33l-1.77,3.31l-5.86,3.86l-1.86,-4.25l-0.45,-0.23l-6.46,1.3l-6.47,6.44l-0.01,0.55l1.58,1.74l-8.24,1.17l0.15,-2.2l-0.34,-0.42l-3.89,-0.56l-3.25,1.81l-7.62,-0.62l-8.45,1.19l-17.71,15.41l0.22,0.7l3.74,0.41l1.36,2.17l2.43,0.76l1.88,-1.68l2.4,0.2l3.4,3.54l0.08,2.6l-1.95,3.42l-0.21,3.9l-1.1,5.06l-3.71,4.54l-0.87,2.21l-8.29,8.89l-3.19,1.7l-1.32,0.03l-1.45,-1.36l-0.49,-0.04l-2.27,1.5l0.41,-3.65l-0.59,-2.47l1.75,-0.89l2.91,0.53l0.42,-0.2l1.68,-3.03l0.87,-3.46l0.97,-1.18l1.32,-2.88l-0.45,-0.56l-4.14,0.95l-2.19,1.25l-3.41,-0.0l-1.06,-2.93l-2.97,-2.3l-4.28,-1.06l-1.75,-5.07l-2.66,-5.01l-2.29,-1.29l-3.75,-1.01l-3.44,0.08l-3.18,0.62l-2.24,1.77l0.05,0.66l1.18,0.69l0.02,1.43l-1.33,1.05l-2.26,3.51l-0.04,1.43l-3.16,1.84l-2.82,-1.16l-3.01,0.23l-1.35,-1.07l-1.5,-0.35l-3.9,2.31l-3.22,0.52l-2.27,0.79l-3.05,-0.51l-2.21,0.03l-1.48,-1.6l-2.6,-1.63l-2.63,-0.43l-5.46,1.01l-3.23,-1.25l-0.72,-2.57l-5.2,-1.24l-2.75,-1.36l-0.5,0.12l-2.59,3.45l0.84,2.1l-2.06,1.93l-3.41,-0.77l-2.42,-0.12l-1.83,-1.54l-2.53,-0.05l-2.42,-0.98l-3.86,1.57l-4.72,2.78l-3.3,0.75l-1.55,-1.92l-3.0,0.41l-1.11,-1.33l-1.62,-0.59l-1.31,-1.94l-1.38,-0.6l-3.7,0.79l-3.31,-1.83l-0.51,0.11l-0.99,1.29l-5.29,-8.05l-2.96,-2.48l0.65,-0.77l0.01,-0.51l-0.5,-0.11l-6.2,3.21l-1.84,0.15l0.15,-1.39l-0.26,-0.42l-3.22,-1.17l-2.46,0.7l-0.69,-3.16l-0.32,-0.31l-4.5,-0.75l-2.47,1.47l-6.19,1.27l-1.29,0.86l-9.51,1.3l-1.15,1.17l-0.03,0.53l1.47,1.9l-1.89,0.69l-0.22,0.56l0.31,0.6l-2.11,1.44l0.03,0.68l3.75,2.12l-0.39,0.98l-3.23,-0.13l-0.86,0.86l-3.09,-1.59l-3.97,0.07l-2.66,1.35l-8.32,-3.56l-4.07,0.06l-5.39,3.68l-0.39,2.0l-2.03,-1.5l-0.59,0.13l-2.0,3.59l0.57,0.93l-1.28,2.16l0.06,0.48l2.13,2.17l1.95,0.04l1.37,1.82l-0.23,1.46l0.25,0.43l0.83,0.33l-0.8,1.31l-2.49,0.62l-2.49,3.2l0.0,0.49l2.17,2.78l-0.15,2.18l2.5,3.24l-1.58,1.59l-0.7,-0.13l-1.63,-1.72l-2.29,-0.84l-0.94,-1.31l-2.34,-0.63l-1.48,0.4l-0.43,-0.47l-3.51,-1.48l-5.76,-1.01l-0.45,0.19l-2.89,-2.34l-2.9,-1.2l-1.53,-1.29l1.29,-0.43l2.08,-2.61l-0.05,-0.55l-0.89,-0.79l3.05,-1.06l0.27,-0.42l-0.07,-0.69l-0.49,-0.35l-1.73,0.39l0.04,-0.68l1.04,-0.72l2.66,-0.48l0.4,-1.32l-0.5,-1.6l0.92,-1.54l0.03,-1.17l-0.29,-0.37l-3.69,-1.06l-1.41,0.02l-1.42,-1.41l-2.19,0.38l-2.77,-1.01l-0.03,-0.59l-0.89,-1.43l-2.0,-0.32l-0.11,-0.54l0.49,-0.53l0.01,-0.53l-1.6,-1.9l-3.58,0.02l-0.88,0.73l-0.46,-0.07l-1.0,-2.79l2.22,-0.02l0.97,-0.74l0.07,-0.57l-0.9,-1.04l-1.35,-0.48l-0.11,-0.7l-0.95,-0.58l-1.38,-1.99l0.46,-0.98l-0.51,-1.96l-2.45,-0.84l-1.21,0.3l-0.46,-0.76l-2.46,-0.83l-0.72,-1.87l-0.21,-1.69l-0.99,-0.85l0.85,-1.17l-0.7,-3.21l1.66,-1.97l-0.16,-0.79ZM749.2,170.72l-0.6,0.4l-0.13,0.16l-0.01,-0.51l0.74,-0.05ZM874.85,67.94l-5.63,0.48l-0.26,-0.84l3.15,-1.89l1.94,0.01l3.19,1.16l-2.39,1.09ZM797.39,48.49l-2.0,1.36l-3.8,-0.42l-4.25,-1.8l0.35,-0.97l9.69,1.83ZM783.67,46.12l-1.63,3.09l-8.98,-0.13l-4.09,1.14l-4.54,-2.97l1.16,-3.01l3.05,-0.89l6.5,0.22l8.54,2.56ZM778.2,134.98l-0.56,-0.9l0.27,-0.12l0.29,1.01ZM778.34,135.48l0.94,3.53l-0.05,3.38l1.05,3.39l2.18,5.0l-2.89,-0.83l-0.49,0.26l-1.54,4.65l2.42,3.5l-0.04,1.13l-1.24,-1.24l-0.61,0.06l-1.09,1.61l-0.28,-1.61l0.27,-3.1l-0.28,-3.4l0.58,-2.47l0.11,-4.39l-1.46,-3.36l0.21,-4.32l2.15,-1.46l0.07,-0.34ZM771.95,56.61l1.76,-1.42l2.89,-0.42l3.28,1.71l0.14,0.6l-3.27,0.03l-4.81,-0.5ZM683.76,31.09l-13.01,1.93l4.03,-6.35l1.82,-0.56l1.73,0.34l5.99,2.98l-0.56,1.66ZM670.85,27.93l-5.08,0.64l-6.86,-1.57l-3.99,-2.05l-2.1,-4.16l-2.6,-0.87l5.72,-3.5l5.2,-1.28l4.69,2.85l5.59,5.4l-0.56,4.53ZM564.15,68.94l-0.64,0.17l-7.85,-0.57l-0.86,-2.04l-4.28,-1.17l-0.28,-1.94l2.27,-0.89l0.25,-0.39l-0.08,-2.38l4.81,-3.97l-0.15,-0.7l-1.47,-0.38l5.3,-3.81l0.15,-0.44l-0.58,-1.94l5.28,-2.51l8.21,-3.27l8.28,-0.96l4.35,-1.94l4.6,-0.64l1.36,1.61l-1.34,1.28l-16.43,4.94l-7.97,4.88l-7.74,9.63l0.66,4.14l4.16,3.27ZM548.81,18.48l-5.5,1.18l-0.58,1.02l-2.59,0.84l-2.13,-1.07l1.12,-1.42l-0.3,-0.65l-2.33,-0.07l1.68,-0.36l3.47,-0.06l0.42,1.29l0.66,0.16l1.38,-1.34l2.15,-0.88l2.94,1.01l-0.39,0.36ZM477.37,133.15l-4.08,0.05l-2.56,-0.32l0.33,-0.87l3.17,-1.03l3.24,0.96l-0.09,1.23Z",
              name: "Russia",
            },
            RW: {
              path: "M497.0,288.25l0.71,1.01l-0.11,1.09l-1.63,0.03l-1.04,1.39l-0.83,-0.11l0.51,-1.2l0.08,-1.34l0.42,-0.41l0.7,0.14l1.19,-0.61Z",
              name: "Rwanda",
            },
            RS: {
              path: "M469.4,163.99l0.42,-0.5l-0.01,-0.52l-1.15,-1.63l1.43,-0.62l1.33,0.12l1.17,1.06l0.46,1.13l1.34,0.64l0.35,1.35l1.46,0.9l0.76,-0.29l0.2,0.69l-0.48,0.78l0.22,1.12l1.05,1.22l-0.77,0.8l-0.37,1.52l-1.21,0.08l0.24,-0.64l-0.39,-0.54l-2.08,-1.64l-0.9,0.05l-0.48,0.94l-2.12,-1.37l0.53,-1.6l-1.11,-1.37l0.51,-1.1l-0.41,-0.57Z",
              name: "Serbia",
            },
            LT: {
              path: "M486.93,129.3l0.17,1.12l-1.81,0.98l-0.72,2.02l-2.47,1.18l-2.1,-0.02l-0.73,-1.05l-1.06,-0.3l-0.09,-1.87l-3.56,-1.13l-0.43,-2.36l2.48,-0.94l4.12,0.22l2.25,-0.31l0.52,0.69l1.24,0.21l2.19,1.56Z",
              name: "Lithuania",
            },
            LU: {
              path: "M436.08,149.45l-0.48,-0.07l0.3,-1.28l0.27,0.4l-0.09,0.96Z",
              name: "Luxembourg",
            },
            LR: {
              path: "M399.36,265.97l0.18,1.54l-0.48,0.99l0.08,0.47l2.47,1.8l-0.33,2.8l-2.65,-1.13l-5.78,-4.61l0.58,-1.32l2.1,-2.33l0.86,-0.22l0.77,1.14l-0.14,0.85l0.59,0.87l1.0,0.14l0.76,-0.99Z",
              name: "Liberia",
            },
            RO: {
              path: "M487.53,154.23l0.6,0.24l2.87,3.98l-0.17,2.69l0.45,1.42l1.32,0.81l1.35,-0.42l0.76,0.36l0.02,0.31l-0.83,0.45l-0.59,-0.22l-0.54,0.3l-0.62,3.3l-1.0,-0.22l-2.07,-1.13l-2.95,0.71l-1.25,0.76l-3.51,-0.15l-1.89,-0.47l-0.87,0.16l-0.82,-1.3l0.29,-0.26l-0.06,-0.64l-1.09,-0.34l-0.56,0.5l-1.05,-0.64l-0.39,-1.39l-1.36,-0.65l-0.35,-1.0l-0.83,-0.75l1.54,-0.54l2.66,-4.21l2.4,-1.24l2.96,0.34l1.48,0.73l0.79,-0.45l1.78,-0.3l0.75,-0.74l0.79,0.0Z",
              name: "Romania",
            },
            GW: {
              path: "M386.23,253.6l-0.29,0.84l0.15,0.6l-2.21,0.59l-0.86,0.96l-1.04,-0.83l-1.09,-0.23l-0.54,-1.06l-0.66,-0.49l2.41,-0.48l4.13,0.1Z",
              name: "Guinea-Bissau",
            },
            GT: {
              path: "M195.08,249.77l-2.48,-0.37l-1.03,-0.45l-1.14,-0.89l0.3,-0.99l-0.24,-0.68l0.96,-1.66l2.98,-0.01l0.4,-0.37l-0.19,-1.28l-1.67,-1.4l0.51,-0.4l0.0,-1.05l3.85,0.02l-0.21,4.53l0.4,0.43l1.46,0.38l-1.48,0.98l-0.35,0.7l0.12,0.57l-2.2,1.96Z",
              name: "Guatemala",
            },
            GR: {
              path: "M487.07,174.59l-0.59,1.43l-0.37,0.21l-2.84,-0.35l-3.03,0.77l-0.18,0.68l1.28,1.23l-0.61,0.23l-1.14,0.0l-1.2,-1.39l-0.63,0.03l-0.53,1.01l0.56,1.76l1.03,1.19l-0.56,0.38l-0.05,0.62l2.52,2.12l0.02,0.87l-1.78,-0.59l-0.48,0.56l0.5,1.0l-1.07,0.2l-0.3,0.53l0.75,2.01l-0.98,0.02l-1.84,-1.12l-1.37,-4.2l-2.21,-2.95l-0.11,-0.56l1.04,-1.28l0.2,-0.95l0.85,-0.66l0.03,-0.46l1.32,-0.21l1.01,-0.64l1.22,0.05l0.65,-0.56l2.26,-0.0l1.82,-0.75l1.85,1.0l2.28,-0.28l0.35,-0.39l0.01,-0.77l0.34,0.22ZM480.49,192.16l0.58,0.4l-0.68,-0.12l0.11,-0.28ZM482.52,192.82l2.51,0.06l0.24,0.32l-1.99,0.13l-0.77,-0.51Z",
              name: "Greece",
            },
            GQ: {
              path: "M448.79,279.62l0.02,2.22l-4.09,0.0l0.69,-2.27l3.38,0.05Z",
              name: "Eq. Guinea",
            },
            GY: {
              path: "M277.42,270.07l-0.32,1.83l-1.32,0.57l-0.23,0.46l-0.28,2.0l1.11,1.82l0.83,0.19l0.32,1.25l1.13,1.62l-1.21,-0.19l-1.08,0.71l-1.77,0.5l-0.44,0.46l-0.86,-0.09l-1.32,-1.01l-0.77,-2.27l0.36,-1.9l0.68,-1.23l-0.57,-1.17l-0.74,-0.43l0.12,-1.16l-0.9,-0.69l-1.1,0.09l-1.31,-1.48l0.53,-0.72l-0.04,-0.84l1.99,-0.86l0.05,-0.59l-0.71,-0.78l0.14,-0.57l1.66,-1.24l1.36,0.77l1.41,1.49l0.06,1.15l0.37,0.38l0.8,0.05l2.06,1.86Z",
              name: "Guyana",
            },
            GE: {
              path: "M521.71,168.93l5.29,0.89l4.07,2.01l1.41,-0.44l2.07,0.56l0.68,1.1l1.07,0.55l-0.12,0.59l0.98,1.29l-1.01,-0.13l-1.81,-0.83l-0.94,0.47l-3.23,0.43l-2.29,-1.39l-2.33,0.05l0.21,-0.97l-0.76,-2.26l-1.45,-1.12l-1.43,-0.39l-0.41,-0.42Z",
              name: "Georgia",
            },
            GB: {
              path: "M412.61,118.72l-2.19,3.22l-0.0,0.45l5.13,-0.3l-0.53,2.37l-2.2,3.12l0.29,0.63l2.37,0.21l2.33,4.3l1.76,0.69l2.2,5.12l2.94,0.77l-0.23,1.62l-1.15,0.88l-0.1,0.52l0.82,1.42l-1.86,1.43l-3.3,-0.02l-4.12,0.87l-1.04,-0.58l-0.47,0.06l-1.51,1.41l-2.12,-0.34l-1.86,1.18l-0.6,-0.29l3.19,-3.0l2.16,-0.69l0.28,-0.41l-0.34,-0.36l-3.73,-0.53l-0.4,-0.76l2.2,-0.87l0.17,-0.61l-1.26,-1.67l0.36,-1.7l3.38,0.28l0.43,-0.33l0.37,-1.99l-1.79,-2.49l-3.11,-0.72l-0.38,-0.59l0.79,-1.35l-0.04,-0.46l-0.82,-0.97l-0.61,0.01l-0.68,0.84l-0.1,-2.34l-1.23,-1.88l0.85,-3.47l1.77,-2.68l1.85,0.26l2.17,-0.22ZM406.26,132.86l-1.01,1.77l-1.57,-0.59l-1.16,0.01l0.37,-1.54l-0.39,-1.39l1.45,-0.1l2.3,1.84Z",
              name: "United Kingdom",
            },
            GA: {
              path: "M453.24,279.52l-0.08,0.98l0.7,1.29l2.36,0.24l-0.98,2.63l1.18,1.79l0.25,1.78l-0.29,1.52l-0.6,0.93l-1.84,-0.09l-1.23,-1.11l-0.66,0.23l-0.15,0.84l-1.42,0.26l-1.02,0.7l-0.11,0.52l0.77,1.35l-1.34,0.97l-3.94,-4.3l-1.44,-2.45l0.06,-0.6l0.54,-0.81l1.05,-3.46l4.17,-0.07l0.4,-0.4l-0.02,-2.66l2.39,0.21l1.25,-0.27Z",
              name: "Gabon",
            },
            GN: {
              path: "M391.8,254.11l0.47,0.8l1.11,-0.32l0.98,0.7l1.07,0.2l2.26,-1.22l0.64,0.44l1.13,1.56l-0.48,1.4l0.8,0.3l-0.08,0.48l0.46,0.68l-0.35,1.36l1.05,2.61l-1.0,0.69l0.03,1.41l-0.72,-0.06l-1.08,1.0l-0.24,-0.27l0.07,-1.11l-1.05,-1.54l-1.79,0.21l-0.35,-2.01l-1.6,-2.18l-2.0,-0.0l-1.31,0.54l-1.95,2.18l-1.86,-2.19l-1.2,-0.78l-0.3,-1.11l-0.8,-0.85l0.65,-0.72l0.81,-0.03l1.64,-0.8l0.23,-1.87l2.67,0.64l0.89,-0.3l1.21,0.15Z",
              name: "Guinea",
            },
            GM: {
              path: "M379.31,251.39l0.1,-0.35l2.43,-0.07l0.74,-0.61l0.51,-0.03l0.77,0.49l-1.03,-0.3l-1.87,0.9l-1.65,-0.04ZM384.03,250.91l0.91,0.05l0.75,-0.24l-0.59,0.31l-1.08,-0.13Z",
              name: "Gambia",
            },
            GL: {
              path: "M353.02,1.2l14.69,4.67l-3.68,1.89l-22.97,0.86l-0.36,0.27l0.12,0.43l1.55,1.18l8.79,-0.66l7.48,2.07l4.86,-1.77l1.66,1.73l-2.53,3.19l-0.01,0.48l0.46,0.15l6.35,-2.2l12.06,-2.31l7.24,1.13l1.09,1.99l-9.79,4.01l-1.44,1.32l-7.87,0.98l-0.35,0.41l0.38,0.38l5.07,0.24l-2.53,3.58l-2.07,3.81l0.08,6.05l2.57,3.11l-3.22,0.2l-4.12,1.66l-0.05,0.72l4.45,2.65l0.51,3.75l-2.3,0.4l-0.25,0.64l2.79,3.69l-4.82,0.31l-0.36,0.29l0.16,0.44l2.62,1.8l-0.59,1.22l-3.3,0.7l-3.45,0.01l-0.29,0.68l3.03,3.12l0.02,1.34l-4.4,-1.73l-1.72,1.35l0.15,0.66l3.31,1.15l3.13,2.71l0.81,3.16l-3.85,0.75l-4.89,-4.26l-0.47,-0.03l-0.17,0.44l0.79,2.86l-2.71,2.21l-0.13,0.44l0.37,0.27l8.73,0.34l-12.32,6.64l-7.24,1.48l-2.94,0.08l-2.69,1.75l-3.43,4.41l-5.24,2.84l-1.73,0.18l-7.12,2.1l-2.15,2.52l-0.13,2.99l-1.19,2.45l-4.01,3.09l-0.14,0.44l0.97,2.9l-2.28,6.48l-3.1,0.2l-3.83,-3.07l-4.86,-0.02l-2.25,-1.93l-1.7,-3.79l-4.3,-4.84l-1.21,-2.49l-0.44,-3.8l-3.32,-3.63l0.84,-2.86l-1.56,-1.7l2.28,-4.6l3.83,-1.74l1.03,-1.96l0.52,-3.47l-0.59,-0.41l-4.17,2.21l-2.07,0.58l-2.72,-1.28l-0.15,-2.71l0.85,-2.09l2.01,-0.06l5.06,1.2l0.46,-0.23l-0.14,-0.49l-6.54,-4.47l-2.67,0.55l-1.58,-0.86l2.56,-4.01l-0.03,-0.48l-1.5,-1.74l-4.98,-8.5l-3.13,-1.96l0.03,-1.88l-0.24,-0.37l-6.85,-3.02l-5.36,-0.38l-12.7,0.58l-2.78,-1.57l-3.66,-2.77l5.73,-1.45l5.0,-0.28l0.38,-0.38l-0.35,-0.41l-10.67,-1.38l-5.3,-2.06l0.25,-1.54l18.41,-5.26l1.22,-2.27l-0.25,-0.55l-6.14,-1.86l1.68,-1.77l8.55,-4.03l3.59,-0.63l0.3,-0.54l-0.88,-2.27l5.47,-1.47l7.65,-0.95l7.55,-0.05l3.04,1.85l6.48,-3.27l5.81,2.22l3.56,0.5l5.16,1.94l0.5,-0.21l-0.17,-0.52l-5.71,-3.13l0.28,-2.13l8.12,-3.6l8.7,0.28l3.35,-2.34l8.71,-0.6l19.93,0.8Z",
              name: "Greenland",
            },
            KW: {
              path: "M540.81,207.91l0.37,0.86l-0.17,0.76l0.6,1.53l-0.95,0.04l-0.82,-1.28l-1.57,-0.18l1.31,-1.88l1.22,0.17Z",
              name: "Kuwait",
            },
            GH: {
              path: "M420.53,257.51l-0.01,0.72l0.96,1.2l0.24,3.73l0.59,0.95l-0.51,2.1l0.19,1.41l1.02,2.21l-6.97,2.84l-1.8,-0.57l0.04,-0.89l-1.02,-2.04l0.61,-2.65l1.07,-2.32l-0.96,-6.47l5.01,0.07l0.94,-0.39l0.61,0.11Z",
              name: "Ghana",
            },
            OM: {
              path: "M568.09,230.93l-0.91,1.67l-1.22,0.04l-0.6,0.76l-0.41,1.51l0.27,1.58l-1.16,0.05l-1.56,0.97l-0.76,1.74l-1.62,0.05l-0.98,0.65l-0.17,1.15l-0.89,0.52l-1.49,-0.18l-2.4,0.94l-2.47,-5.4l7.35,-2.71l1.67,-5.23l-1.12,-2.09l0.05,-0.83l0.67,-1.0l0.07,-1.05l0.9,-0.42l-0.05,-2.07l0.7,-0.01l1.0,1.62l1.51,1.08l3.3,0.84l1.73,2.29l0.81,0.37l-1.23,2.35l-0.99,0.79Z",
              name: "Oman",
            },
            _2: {
              path: "M531.15,258.94l1.51,0.12l5.13,-0.95l5.3,-1.48l-0.01,4.4l-2.67,3.39l-1.85,0.01l-8.04,-2.94l-2.55,-3.17l1.12,-1.71l2.04,2.34Z",
              name: "Somaliland",
            },
            _1: {
              path: "M472.77,172.64l-1.08,-1.29l0.96,-0.77l0.29,-0.83l1.98,1.64l-0.36,0.67l-1.79,0.58Z",
              name: "Kosovo",
            },
            _0: {
              path: "M504.91,192.87l0.34,0.01l0.27,-0.07l-0.29,0.26l-0.31,-0.2Z",
              name: "N. Cyprus",
            },
            JO: {
              path: "M518.64,201.38l-5.14,1.56l-0.19,0.65l2.16,2.39l-0.89,1.14l-1.71,0.34l-1.71,1.8l-2.34,-0.37l1.21,-4.32l0.56,-4.07l2.8,0.94l4.46,-2.71l0.79,2.66Z",
              name: "Jordan",
            },
            HR: {
              path: "M455.59,162.84l1.09,0.07l-0.82,0.94l-0.27,-1.01ZM456.96,162.92l0.62,-0.41l1.73,0.45l0.42,-0.4l-0.01,-0.59l0.86,-0.52l0.2,-1.05l1.63,-0.68l2.57,1.68l2.07,0.6l0.87,-0.31l1.05,1.57l-0.52,0.63l-1.05,-0.56l-1.68,0.04l-2.1,-0.5l-1.29,0.06l-0.57,0.49l-0.59,-0.47l-0.62,0.16l-0.46,1.7l1.79,2.42l2.79,2.75l-1.18,-0.87l-2.21,-0.87l-1.67,-1.78l0.13,-0.63l-1.05,-1.19l-0.32,-1.27l-1.42,-0.43Z",
              name: "Croatia",
            },
            HT: {
              path: "M237.05,238.38l-1.16,0.43l-0.91,-0.55l0.05,-0.2l2.02,0.31ZM237.53,238.43l1.06,0.12l-0.05,0.01l-1.01,-0.12ZM239.25,238.45l0.79,-0.51l0.06,-0.62l-1.02,-1.0l0.02,-0.82l-0.3,-0.4l-0.93,-0.32l3.16,0.45l0.02,1.84l-0.48,0.34l-0.08,0.58l0.54,0.72l-1.78,-0.26Z",
              name: "Haiti",
            },
            HU: {
              path: "M462.08,157.89l0.65,-1.59l-0.09,-0.44l0.64,-0.0l0.39,-0.34l0.1,-0.69l1.75,0.87l2.32,-0.37l0.43,-0.66l3.49,-0.78l0.69,-0.78l0.57,-0.14l2.57,0.93l0.67,-0.23l1.03,0.65l0.08,0.37l-1.42,0.71l-2.59,4.14l-1.8,0.53l-1.68,-0.1l-2.74,1.23l-1.85,-0.54l-2.54,-1.66l-0.66,-1.1Z",
              name: "Hungary",
            },
            HN: {
              path: "M199.6,249.52l-1.7,-1.21l0.06,-0.94l3.04,-2.14l2.37,0.28l1.27,-0.09l1.1,-0.52l1.3,0.28l1.14,-0.25l1.38,0.37l2.23,1.37l-2.36,0.93l-1.23,-0.39l-0.88,1.3l-1.28,0.99l-0.98,-0.22l-0.42,0.52l-0.96,0.05l-0.36,0.41l0.04,0.88l-0.52,0.6l-0.3,0.04l-0.3,-0.55l-0.66,-0.31l0.11,-0.67l-0.48,-0.65l-0.87,-0.26l-0.73,0.2Z",
              name: "Honduras",
            },
            PR: {
              path: "M256.17,238.73l-0.26,0.27l-2.83,0.05l-0.07,-0.55l1.95,-0.1l1.22,0.33Z",
              name: "Puerto Rico",
            },
            PS: {
              path: "M509.21,203.07l0.1,-0.06l-0.02,0.03l-0.09,0.03ZM509.36,202.91l-0.02,-0.63l-0.33,-0.16l0.31,-1.09l0.24,0.1l-0.2,1.78Z",
              name: "Palestine",
            },
            PT: {
              path: "M401.84,187.38l-0.64,0.47l-1.13,-0.35l-0.91,0.17l0.28,-1.78l-0.24,-1.78l-1.25,-0.56l-0.45,-0.84l0.17,-1.66l1.01,-1.18l0.69,-2.92l-0.04,-1.39l-0.59,-1.9l1.3,-0.85l0.84,1.35l3.1,-0.3l0.46,0.99l-1.05,0.94l-0.03,2.16l-0.41,0.57l-0.08,1.1l-0.79,0.18l-0.26,0.59l0.91,1.6l-0.63,1.75l0.76,1.09l-1.1,1.52l0.07,1.05Z",
              name: "Portugal",
            },
            PY: {
              path: "M274.9,336.12l0.74,1.52l-0.16,3.45l0.32,0.41l2.64,0.5l1.11,-0.47l1.4,0.59l0.36,0.6l0.53,3.42l1.27,0.4l0.98,-0.38l0.51,0.27l-0.0,1.18l-1.21,5.32l-2.09,1.9l-1.8,0.4l-4.71,-0.98l2.2,-3.63l-0.32,-1.5l-2.78,-1.28l-3.03,-1.94l-2.07,-0.44l-4.34,-4.06l0.91,-2.9l0.08,-1.42l1.07,-2.04l4.13,-0.72l2.18,0.03l2.05,1.17l0.03,0.59Z",
              name: "Paraguay",
            },
            PA: {
              path: "M213.8,263.68l0.26,-1.52l-0.36,-0.26l-0.01,-0.49l0.44,-0.1l0.93,1.4l1.26,0.03l0.77,0.49l1.38,-0.23l2.51,-1.11l0.86,-0.72l3.45,0.85l1.4,1.18l0.41,1.74l-0.21,0.34l-0.53,-0.12l-0.47,0.29l-0.16,0.6l-0.68,-1.28l0.45,-0.49l-0.19,-0.66l-0.47,-0.13l-0.54,-0.84l-1.5,-0.75l-1.1,0.16l-0.75,0.99l-1.62,0.84l-0.18,0.96l0.85,0.97l-0.58,0.45l-0.69,0.08l-0.34,-1.18l-1.27,0.03l-0.71,-1.05l-2.59,-0.46Z",
              name: "Panama",
            },
            PG: {
              path: "M808.58,298.86l2.54,2.56l-0.13,0.26l-0.33,0.12l-0.87,-0.78l-1.22,-2.16ZM801.41,293.04l0.5,0.29l0.26,0.27l-0.49,-0.35l-0.27,-0.21ZM803.17,294.58l0.59,0.5l0.08,1.06l-0.29,-0.91l-0.38,-0.65ZM796.68,298.41l0.52,0.75l1.43,-0.19l2.27,-1.81l-0.01,-1.43l1.12,0.16l-0.04,1.1l-0.7,1.28l-1.12,0.18l-0.62,0.79l-2.46,1.11l-1.17,-0.0l-3.08,-1.25l3.41,0.0l0.45,-0.68ZM789.15,303.55l2.31,1.8l1.59,2.61l1.34,0.13l-0.06,0.66l0.31,0.43l1.06,0.24l0.06,0.65l2.25,1.05l-1.22,0.13l-0.72,-0.63l-4.56,-0.65l-3.22,-2.87l-1.49,-2.34l-3.27,-1.1l-2.38,0.72l-1.59,0.86l-0.2,0.42l0.27,1.55l-1.55,0.68l-1.36,-0.4l-2.21,-0.09l-0.08,-15.41l8.39,2.93l2.95,2.4l0.6,1.64l4.02,1.49l0.31,0.68l-1.76,0.21l-0.33,0.52l0.55,1.68Z",
              name: "Papua New Guinea",
            },
            PE: {
              path: "M244.96,295.21l-1.26,-0.07l-0.57,0.42l-1.93,0.45l-2.98,1.75l-0.36,1.36l-0.58,0.8l0.12,1.37l-1.24,0.59l-0.22,1.22l-0.62,0.84l1.04,2.27l1.28,1.44l-0.41,0.84l0.32,0.57l1.48,0.13l1.16,1.37l2.21,0.07l1.63,-1.08l-0.13,3.02l0.3,0.4l1.14,0.29l1.31,-0.34l1.9,3.59l-0.48,0.85l-0.17,3.85l-0.94,1.59l0.35,0.75l-0.47,1.07l0.98,1.97l-2.1,3.82l-0.98,0.5l-2.17,-1.28l-0.39,-1.16l-4.95,-2.58l-4.46,-2.79l-1.84,-1.51l-0.91,-1.84l0.3,-0.96l-2.11,-3.33l-4.82,-9.68l-1.04,-1.2l-0.87,-1.94l-3.4,-2.48l0.58,-1.18l-1.13,-2.23l0.66,-1.49l1.45,-1.15l-0.6,0.98l0.07,0.92l0.47,0.36l1.74,0.03l0.97,1.17l0.54,0.07l1.42,-1.03l0.6,-1.84l1.42,-2.02l3.04,-1.04l2.73,-2.62l0.86,-1.74l-0.1,-1.87l1.44,1.02l0.9,1.25l1.06,0.59l1.7,2.73l1.86,0.31l1.45,-0.61l0.96,0.39l1.36,-0.19l1.45,0.89l-1.4,2.21l0.31,0.61l0.59,0.05l0.47,0.5Z",
              name: "Peru",
            },
            PK: {
              path: "M615.09,192.34l-1.83,1.81l-2.6,0.39l-3.73,-0.68l-1.58,1.33l-0.09,0.42l1.77,4.39l1.7,1.23l-1.69,1.27l-0.12,2.14l-2.33,2.64l-1.6,2.8l-2.46,2.67l-3.03,-0.07l-2.76,2.83l0.05,0.6l1.5,1.11l0.26,1.9l1.44,1.5l0.37,1.68l-5.01,-0.01l-1.78,1.7l-1.42,-0.52l-0.76,-1.87l-2.27,-2.15l-11.61,0.86l0.71,-2.34l3.43,-1.32l0.25,-0.44l-0.21,-1.24l-1.2,-0.65l-0.28,-2.46l-2.29,-1.14l-1.28,-1.94l2.82,0.94l2.62,-0.38l1.42,0.33l0.76,-0.56l1.71,0.19l3.25,-1.14l0.27,-0.36l0.08,-2.19l1.18,-1.32l1.68,0.0l0.58,-0.82l1.6,-0.3l1.19,0.16l0.98,-0.78l0.02,-1.88l0.93,-1.47l1.48,-0.66l0.19,-0.55l-0.66,-1.25l2.04,-0.11l0.69,-1.01l-0.02,-1.16l1.11,-1.06l-0.17,-1.78l-0.49,-1.03l1.15,-0.98l5.42,-0.91l2.6,-0.82l1.6,1.16l0.97,2.34l3.45,0.97Z",
              name: "Pakistan",
            },
            PH: {
              path: "M737.01,263.84l0.39,2.97l-0.44,1.18l-0.55,-1.53l-0.67,-0.14l-1.17,1.28l0.65,2.09l-0.42,0.69l-2.48,-1.23l-0.57,-1.49l0.65,-1.03l-0.1,-0.54l-1.59,-1.19l-0.56,0.08l-0.65,0.87l-1.23,0.0l-1.58,0.97l0.83,-1.8l2.56,-1.42l0.65,0.84l0.45,0.13l1.9,-0.69l0.56,-1.11l1.5,-0.06l0.38,-0.43l-0.09,-1.19l1.21,0.71l0.36,2.02ZM733.59,256.58l0.05,0.75l0.08,0.26l-0.8,-0.42l-0.18,-0.71l0.85,0.12ZM734.08,256.1l-0.12,-1.12l-1.0,-1.27l1.36,0.03l0.53,0.73l0.51,2.04l-1.27,-0.4ZM733.76,257.68l0.38,0.98l-0.32,0.15l-0.07,-1.13ZM724.65,238.43l1.46,0.7l0.72,-0.31l-0.32,1.17l0.79,1.71l-0.57,1.84l-1.53,1.04l-0.39,2.25l0.56,2.04l1.63,0.57l1.16,-0.27l2.71,1.23l-0.19,1.08l0.76,0.84l-0.08,0.36l-1.4,-0.9l-0.88,-1.27l-0.66,0.0l-0.38,0.55l-1.6,-1.31l-2.15,0.36l-0.87,-0.39l0.07,-0.61l0.66,-0.55l-0.01,-0.62l-0.75,-0.59l-0.72,0.44l-0.74,-0.87l-0.39,-2.49l0.32,0.27l0.66,-0.28l0.26,-3.97l0.7,-2.02l1.14,0.0ZM731.03,258.87l-0.88,0.85l-1.19,1.94l-1.05,-1.19l0.93,-1.1l0.32,-1.47l0.52,-0.06l-0.27,1.15l0.22,0.45l0.49,-0.12l1.0,-1.32l-0.08,0.85ZM726.83,255.78l0.83,0.38l1.17,-0.0l-0.02,0.48l-2.0,1.4l0.03,-2.26ZM724.81,252.09l-0.38,1.27l-1.42,-1.95l1.2,0.05l0.6,0.63ZM716.55,261.82l1.1,-0.95l0.03,-0.03l-0.28,0.36l-0.85,0.61ZM719.22,259.06l0.04,-0.06l0.8,-1.53l0.16,0.75l-1.0,0.84Z",
              name: "Philippines",
            },
            PL: {
              path: "M468.44,149.42l-1.11,-1.54l-1.86,-0.33l-0.48,-1.05l-1.72,-0.37l-0.65,0.69l-0.72,-0.36l0.11,-0.61l-0.33,-0.46l-1.75,-0.27l-1.04,-0.93l-0.94,-1.94l0.16,-1.22l-0.62,-1.8l-0.78,-1.07l0.57,-1.04l-0.48,-1.43l1.41,-0.83l6.91,-2.71l2.14,0.5l0.52,0.91l5.51,0.44l4.55,-0.05l1.07,0.31l0.48,0.84l0.15,1.58l0.65,1.2l-0.01,0.99l-1.27,0.58l-0.19,0.54l0.73,1.48l0.08,1.55l1.2,2.76l-0.17,0.58l-1.23,0.44l-2.27,2.72l0.18,0.95l-1.97,-1.03l-1.98,0.4l-1.36,-0.28l-1.24,0.58l-1.07,-0.97l-1.16,0.24Z",
              name: "Poland",
            },
            ZM: {
              path: "M481.47,313.3l0.39,0.31l2.52,0.14l0.99,1.17l2.01,0.35l1.4,-0.64l0.69,1.17l1.78,0.33l1.84,2.35l2.23,0.18l0.4,-0.43l-0.21,-2.74l-0.62,-0.3l-0.48,0.32l-1.98,-1.17l0.72,-5.29l-0.51,-1.18l0.57,-1.3l3.68,-0.62l0.26,0.63l1.21,0.63l0.9,-0.22l2.16,0.67l1.33,0.71l1.07,1.02l0.56,1.87l-0.88,2.7l0.43,2.09l-0.73,0.87l-0.76,2.37l0.59,0.68l-6.6,1.83l-0.29,0.44l0.19,1.45l-1.68,0.35l-1.43,1.02l-0.38,0.87l-0.87,0.26l-3.48,3.69l-4.16,-0.53l-1.52,-1.0l-1.77,-0.13l-1.83,0.52l-3.04,-3.4l0.11,-7.59l4.82,0.03l0.39,-0.49l-0.18,-0.76l0.33,-0.83l-0.4,-1.36l0.24,-1.05Z",
              name: "Zambia",
            },
            EH: {
              path: "M384.42,230.28l0.25,-0.79l1.06,-1.29l0.8,-3.51l3.38,-2.78l0.7,-1.81l0.06,4.84l-1.98,0.2l-0.94,1.59l0.39,3.56l-3.7,-0.01ZM392.01,218.1l0.7,-1.8l1.77,-0.24l2.09,0.34l0.95,-0.62l1.28,-0.07l-0.0,2.51l-6.79,-0.12Z",
              name: "W. Sahara",
            },
            EE: {
              path: "M485.71,115.04l2.64,0.6l2.56,0.11l-1.6,1.91l0.61,3.54l-0.81,0.87l-1.78,-0.01l-3.22,-1.76l-1.8,0.45l0.21,-1.53l-0.58,-0.41l-0.69,0.34l-1.26,-1.03l-0.17,-1.63l2.83,-0.92l3.05,-0.52Z",
              name: "Estonia",
            },
            EG: {
              path: "M492.06,205.03l1.46,0.42l2.95,-1.64l2.04,-0.21l1.53,0.3l0.59,1.19l0.69,0.04l0.41,-0.64l1.81,0.58l1.95,0.16l1.04,-0.51l1.42,4.08l-2.03,4.54l-1.66,-1.77l-1.76,-3.85l-0.64,-0.12l-0.36,0.67l1.04,2.88l3.44,6.95l1.78,3.04l2.03,2.65l-0.36,0.53l0.23,2.01l2.7,2.19l-28.41,0.0l0.0,-18.96l-0.73,-2.2l0.59,-1.56l-0.32,-1.26l0.68,-0.99l3.06,-0.04l4.82,1.52Z",
              name: "Egypt",
            },
            ZA: {
              path: "M467.14,373.21l-0.13,-1.96l-0.68,-1.56l0.7,-0.68l-0.13,-2.33l-4.56,-8.19l0.77,-0.86l0.6,0.45l0.69,1.31l2.83,0.72l1.5,-0.26l2.24,-1.39l0.19,-9.55l1.35,2.3l-0.21,1.5l0.61,1.2l0.4,0.19l1.79,-0.27l2.6,-2.07l0.69,-1.32l0.96,-0.48l2.19,1.04l2.04,0.13l1.77,-0.65l0.85,-2.12l1.38,-0.33l1.59,-2.76l2.15,-1.89l3.41,-1.87l2.0,0.45l1.02,-0.28l0.99,0.2l1.75,5.29l-0.38,3.25l-0.81,-0.23l-1.0,0.46l-0.87,1.68l-0.05,1.16l1.97,1.84l1.47,-0.29l0.69,-1.18l1.09,0.01l-0.76,3.69l-0.58,1.09l-2.2,1.79l-3.17,4.76l-2.8,2.83l-3.57,2.88l-2.53,1.05l-1.22,0.14l-0.51,0.7l-1.18,-0.32l-1.39,0.5l-2.59,-0.52l-1.61,0.33l-1.18,-0.11l-2.55,1.1l-2.1,0.44l-1.6,1.07l-0.85,0.05l-0.93,-0.89l-0.93,-0.15l-0.97,-1.13l-0.25,0.05ZM491.45,364.19l0.62,-0.93l1.48,-0.59l1.18,-2.19l-0.07,-0.49l-1.99,-1.69l-1.66,0.56l-1.43,1.14l-1.34,1.73l0.02,0.51l1.88,2.11l1.31,-0.16Z",
              name: "South Africa",
            },
            EC: {
              path: "M231.86,285.53l0.29,1.59l-0.69,1.45l-2.61,2.51l-3.13,1.11l-1.53,2.18l-0.49,1.68l-1.0,0.73l-1.02,-1.11l-1.78,-0.16l0.67,-1.15l-0.24,-0.86l1.25,-2.13l-0.54,-1.09l-0.67,-0.08l-0.72,0.87l-0.87,-0.64l0.35,-0.69l-0.36,-1.96l0.81,-0.51l0.45,-1.51l0.92,-1.57l-0.07,-0.97l2.65,-1.33l2.75,1.35l0.77,1.05l2.12,0.35l0.76,-0.32l1.96,1.21Z",
              name: "Ecuador",
            },
            AL: {
              path: "M470.32,171.8l0.74,0.03l0.92,0.89l-0.17,1.95l0.36,1.28l1.01,0.82l-1.82,2.83l-0.19,-0.61l-1.25,-0.89l-0.18,-1.2l0.53,-2.82l-0.54,-1.47l0.6,-0.83Z",
              name: "Albania",
            },
            AO: {
              path: "M461.55,300.03l1.26,3.15l1.94,2.36l2.47,-0.53l1.25,0.32l0.44,-0.18l0.93,-1.92l1.31,-0.08l0.41,-0.44l0.47,-0.0l-0.1,0.41l0.39,0.49l2.65,-0.02l0.03,1.19l0.48,1.01l-0.34,1.52l0.18,1.55l0.83,1.04l-0.13,2.85l0.54,0.39l3.96,-0.41l-0.1,1.79l0.39,1.05l-0.24,1.43l-4.7,-0.03l-0.4,0.39l-0.12,8.13l2.92,3.49l-3.83,0.88l-5.89,-0.36l-1.88,-1.24l-10.47,0.22l-1.3,-1.01l-1.85,-0.16l-2.4,0.77l-0.15,-1.06l0.33,-2.16l1.0,-3.45l1.35,-3.2l2.24,-2.8l0.33,-2.06l-0.13,-1.53l-0.8,-1.08l-1.21,-2.87l0.87,-1.62l-1.27,-4.12l-1.17,-1.53l2.47,-0.63l7.03,0.03ZM451.71,298.87l-0.47,-1.25l1.25,-1.11l0.32,0.3l-0.99,1.03l-0.12,1.03Z",
              name: "Angola",
            },
            KZ: {
              path: "M552.8,172.89l0.46,-1.27l-0.48,-1.05l-2.96,-1.19l-1.06,-2.58l-1.37,-0.87l-0.03,-0.3l1.95,0.23l0.45,-0.38l0.08,-1.96l1.75,-0.41l2.1,0.45l0.48,-0.33l0.45,-3.04l-0.45,-2.09l-0.41,-0.31l-2.42,0.15l-2.36,-0.73l-2.87,1.37l-2.17,0.61l-0.85,-0.34l0.13,-1.61l-1.6,-2.12l-2.02,-0.08l-1.78,-1.82l1.29,-2.18l-0.57,-0.95l1.62,-2.91l2.21,1.63l0.63,-0.27l0.29,-2.22l4.92,-3.43l3.71,-0.08l8.4,3.6l2.92,-1.36l3.77,-0.06l3.11,1.66l0.51,-0.11l0.6,-0.81l3.31,0.13l0.39,-0.25l0.63,-1.57l-0.17,-0.5l-3.5,-1.98l1.87,-1.27l-0.13,-1.03l1.98,-0.72l0.18,-0.62l-1.59,-2.06l0.81,-0.82l9.23,-1.18l1.33,-0.88l6.18,-1.26l2.26,-1.42l4.08,0.68l0.73,3.33l0.51,0.3l2.48,-0.8l2.79,1.02l-0.17,1.56l0.43,0.44l2.55,-0.24l4.89,-2.53l0.03,0.32l3.15,2.61l5.56,8.47l0.65,0.02l1.12,-1.46l3.15,1.74l3.76,-0.78l1.15,0.49l1.14,1.8l1.84,0.76l0.99,1.29l3.35,-0.25l1.02,1.52l-1.6,1.81l-1.93,0.28l-0.34,0.38l-0.11,3.05l-1.13,1.16l-4.75,-1.0l-0.46,0.27l-1.76,5.47l-1.1,0.59l-4.91,1.23l-0.27,0.54l2.1,4.97l-1.37,0.63l-0.23,0.41l0.13,1.13l-0.88,-0.25l-1.42,-1.13l-7.89,-0.4l-0.92,0.31l-3.73,-1.22l-1.42,0.63l-0.53,1.66l-3.72,-0.94l-1.85,0.43l-0.76,1.4l-4.65,2.62l-1.13,2.08l-0.44,0.01l-0.92,-1.4l-2.87,-0.09l-0.45,-2.14l-0.38,-0.32l-0.8,-0.01l0.0,-2.96l-3.0,-2.22l-7.31,0.58l-2.35,-2.68l-6.71,-3.69l-6.45,1.83l-0.29,0.39l0.1,10.85l-0.7,0.08l-1.62,-2.17l-1.83,-0.96l-3.11,0.59l-0.64,0.51Z",
              name: "Kazakhstan",
            },
            ET: {
              path: "M516.04,247.79l1.1,0.84l1.63,-0.45l0.68,0.47l1.63,0.03l2.01,0.94l1.73,1.66l1.64,2.07l-1.52,2.04l0.16,1.72l0.39,0.38l2.05,0.0l-0.36,1.03l2.86,3.58l8.32,3.08l1.31,0.02l-6.32,6.75l-3.1,0.11l-2.36,1.77l-1.47,0.04l-0.86,0.79l-1.38,-0.0l-1.32,-0.81l-2.29,1.05l-0.76,0.98l-3.29,-0.41l-3.07,-2.07l-1.8,-0.07l-0.62,-0.6l0.0,-1.24l-0.28,-0.38l-1.15,-0.37l-1.4,-2.59l-1.19,-0.68l-0.47,-1.0l-1.27,-1.23l-1.16,-0.22l0.43,-0.72l1.45,-0.28l0.41,-0.95l-0.03,-2.21l0.68,-2.44l1.05,-0.63l1.43,-3.06l1.57,-1.37l1.02,-2.51l0.35,-1.88l2.52,0.46l0.44,-0.24l0.58,-1.43Z",
              name: "Ethiopia",
            },
            ZW: {
              path: "M498.91,341.09l-1.11,-0.22l-0.92,0.28l-2.09,-0.44l-1.5,-1.11l-1.89,-0.43l-0.62,-1.4l-0.01,-0.84l-0.3,-0.38l-0.97,-0.25l-2.71,-2.74l-1.92,-3.32l3.83,0.45l3.73,-3.82l1.08,-0.44l0.26,-0.77l1.25,-0.9l1.41,-0.26l0.5,0.89l1.99,-0.05l1.72,1.17l1.11,0.17l1.05,0.66l0.01,2.99l-0.59,3.76l0.38,0.86l-0.23,1.23l-0.39,0.35l-0.63,1.81l-2.43,2.75Z",
              name: "Zimbabwe",
            },
            ES: {
              path: "M416.0,169.21l1.07,1.17l4.61,1.38l1.06,-0.57l2.6,1.26l2.71,-0.3l0.09,1.12l-2.14,1.8l-3.11,0.61l-0.31,0.31l-0.2,0.89l-1.54,1.69l-0.97,2.4l0.84,1.74l-1.32,1.27l-0.48,1.68l-1.88,0.65l-1.66,2.07l-5.36,-0.01l-1.79,1.08l-0.89,0.98l-0.88,-0.17l-0.79,-0.82l-0.68,-1.59l-2.37,-0.63l-0.11,-0.5l1.21,-1.82l-0.77,-1.13l0.61,-1.68l-0.76,-1.62l0.87,-0.49l0.09,-1.25l0.42,-0.6l0.03,-2.11l0.99,-0.69l0.13,-0.5l-1.03,-1.73l-1.46,-0.11l-0.61,0.38l-1.06,0.0l-0.52,-1.23l-0.53,-0.21l-1.32,0.67l-0.01,-1.49l-0.75,-0.96l3.03,-1.88l2.99,0.53l3.32,-0.02l2.63,0.51l6.01,-0.06Z",
              name: "Spain",
            },
            ER: {
              path: "M520.38,246.23l3.42,2.43l3.5,3.77l0.84,0.54l-0.95,-0.01l-3.51,-3.89l-2.33,-1.15l-1.73,-0.07l-0.91,-0.51l-1.26,0.51l-1.34,-1.02l-0.61,0.17l-0.66,1.61l-2.35,-0.43l-0.17,-0.67l1.29,-5.29l0.61,-0.61l1.95,-0.53l0.87,-1.01l1.17,2.41l0.68,2.33l1.49,1.43Z",
              name: "Eritrea",
            },
            ME: {
              path: "M468.91,172.53l-1.22,-1.02l0.47,-1.81l0.89,-0.72l2.26,1.51l-0.5,0.57l-0.75,-0.27l-1.14,1.73Z",
              name: "Montenegro",
            },
            MD: {
              path: "M488.41,153.73l1.4,-0.27l1.72,0.93l1.07,0.15l0.85,0.65l-0.14,0.84l0.96,0.85l1.12,2.47l-1.15,-0.07l-0.66,-0.41l-0.52,0.25l-0.09,0.86l-1.08,1.89l-0.27,-0.86l0.25,-1.34l-0.16,-1.6l-3.29,-4.34Z",
              name: "Moldova",
            },
            MG: {
              path: "M545.91,319.14l0.4,3.03l0.62,1.21l-0.21,1.02l-0.57,-0.8l-0.69,-0.01l-0.47,0.76l0.41,2.12l-0.18,0.87l-0.73,0.78l-0.15,2.14l-4.71,15.2l-1.06,2.88l-3.92,1.64l-3.12,-1.49l-0.6,-1.21l-0.19,-2.4l-0.86,-2.05l-0.21,-1.77l0.38,-1.62l1.21,-0.75l0.01,-0.76l1.19,-2.04l0.23,-1.66l-1.06,-2.99l-0.19,-2.21l0.81,-1.33l0.32,-1.46l4.63,-1.22l3.44,-3.0l0.85,-1.4l-0.08,-0.7l0.78,-0.04l1.38,-1.77l0.13,-1.64l0.45,-0.61l1.16,1.69l0.59,1.6Z",
              name: "Madagascar",
            },
            MA: {
              path: "M378.78,230.02l0.06,-0.59l0.92,-0.73l0.82,-1.37l-0.09,-1.04l0.79,-1.7l1.31,-1.58l0.96,-0.59l0.66,-1.55l0.09,-1.47l0.81,-1.48l1.72,-1.07l1.55,-2.69l1.16,-0.96l2.44,-0.39l1.94,-1.82l1.31,-0.78l2.09,-2.28l-0.51,-3.65l1.24,-3.7l1.5,-1.75l4.46,-2.57l2.37,-4.47l1.44,0.01l1.68,1.21l2.32,-0.19l3.47,0.65l0.8,1.54l0.16,1.71l0.86,2.96l0.56,0.59l-0.26,0.61l-3.05,0.44l-1.26,1.05l-1.33,0.22l-0.33,0.37l-0.09,1.78l-2.68,1.0l-1.07,1.42l-4.47,1.13l-4.04,2.01l-0.54,4.64l-1.15,0.06l-0.92,0.61l-1.96,-0.35l-2.42,0.54l-0.74,1.9l-0.86,0.4l-1.14,3.26l-3.53,3.01l-0.8,3.55l-0.96,1.1l-0.29,0.82l-4.95,0.18Z",
              name: "Morocco",
            },
            UZ: {
              path: "M598.64,172.75l-1.63,1.52l0.06,0.64l1.85,1.12l1.97,-0.64l2.21,1.17l-2.52,1.68l-2.59,-0.22l-0.18,-0.41l0.46,-1.23l-0.45,-0.53l-3.35,0.69l-2.1,3.51l-1.87,-0.12l-1.03,1.51l0.22,0.55l1.64,0.62l0.46,1.83l-1.19,2.49l-2.66,-0.53l0.05,-1.36l-0.26,-0.39l-3.3,-1.23l-2.56,-1.4l-4.4,-3.34l-1.34,-3.14l-1.08,-0.6l-2.58,0.13l-0.69,-0.44l-0.47,-2.52l-3.37,-1.6l-0.43,0.05l-2.07,1.72l-2.1,1.01l-0.21,0.47l0.28,1.01l-1.91,0.03l-0.09,-10.5l5.99,-1.7l6.19,3.54l2.71,2.84l7.05,-0.67l2.71,2.01l-0.17,2.81l0.39,0.42l0.9,0.02l0.44,2.14l0.38,0.32l2.94,0.09l0.95,1.42l1.28,-0.24l1.05,-2.04l4.43,-2.5Z",
              name: "Uzbekistan",
            },
            MM: {
              path: "M673.9,230.21l-1.97,1.57l-0.57,0.96l-1.4,0.6l-1.36,1.05l-1.99,0.36l-1.08,2.66l-0.91,0.4l-0.19,0.55l1.21,2.27l2.52,3.43l-0.79,1.91l-0.74,0.41l-0.17,0.52l0.65,1.37l1.61,1.95l0.25,2.58l0.9,2.13l-1.92,3.57l0.68,-2.25l-0.81,-1.74l0.19,-2.65l-1.05,-1.53l-1.24,-6.17l-1.12,-2.26l-0.6,-0.13l-4.34,3.02l-2.39,-0.65l0.77,-2.84l-0.52,-2.61l-1.91,-2.96l0.25,-0.75l-0.29,-0.51l-1.33,-0.3l-1.61,-1.93l-0.1,-1.3l0.82,-0.24l0.04,-1.64l1.02,-0.52l0.21,-0.45l-0.23,-0.95l0.54,-0.96l0.08,-2.22l1.46,0.45l0.47,-0.2l1.12,-2.19l0.16,-1.35l1.33,-2.16l-0.0,-1.52l2.89,-1.66l1.63,0.44l0.5,-0.44l-0.17,-1.4l0.64,-0.36l0.08,-1.04l0.77,-0.11l0.71,1.35l1.06,0.69l-0.03,3.86l-2.38,2.37l-0.3,3.15l0.46,0.43l2.28,-0.38l0.51,2.08l1.47,0.67l-0.6,1.8l0.19,0.48l2.97,1.48l1.64,-0.55l0.02,0.32Z",
              name: "Myanmar",
            },
            ML: {
              path: "M392.61,254.08l-0.19,-2.37l-0.99,-0.87l-0.44,-1.3l-0.09,-1.28l0.81,-0.58l0.35,-1.24l2.37,0.65l1.31,-0.47l0.86,0.15l0.66,-0.56l9.83,-0.04l0.38,-0.28l0.56,-1.8l-0.44,-0.65l-2.35,-21.95l3.27,-0.04l16.7,11.38l0.74,1.31l2.5,1.09l0.02,1.38l0.44,0.39l2.34,-0.21l0.01,5.38l-1.28,1.61l-0.26,1.49l-5.31,0.57l-1.07,0.92l-2.9,0.1l-0.86,-0.48l-1.38,0.36l-2.4,1.08l-0.6,0.87l-1.85,1.09l-0.43,0.7l-0.79,0.39l-1.44,-0.21l-0.81,0.84l-0.34,1.64l-1.91,2.02l-0.06,1.03l-0.67,1.22l0.13,1.16l-0.97,0.39l-0.23,-0.64l-0.52,-0.24l-1.35,0.4l-0.34,0.55l-2.69,-0.28l-0.37,-0.35l-0.02,-0.9l-0.65,-0.35l0.45,-0.64l-0.03,-0.53l-2.12,-2.44l-0.76,-0.01l-2.0,1.16l-0.78,-0.15l-0.8,-0.67l-1.21,0.23Z",
              name: "Mali",
            },
            MN: {
              path: "M676.61,146.48l3.81,1.68l5.67,-1.0l2.37,0.41l2.34,1.5l1.79,1.75l2.29,-0.03l3.12,0.52l2.47,-0.81l3.41,-0.59l3.53,-2.21l1.25,0.29l1.53,1.13l2.27,-0.21l-2.66,5.01l0.64,1.68l0.47,0.21l1.32,-0.38l2.38,0.48l2.02,-1.11l1.76,0.89l2.06,2.02l-0.13,0.53l-1.72,-0.29l-3.77,0.46l-1.88,0.99l-1.76,1.99l-3.71,1.17l-2.45,1.6l-3.83,-0.87l-0.41,0.17l-1.31,1.99l1.04,2.24l-1.52,0.9l-1.74,1.57l-2.79,1.02l-3.78,0.13l-4.05,1.05l-2.77,1.52l-1.16,-0.85l-2.94,0.0l-3.62,-1.79l-2.58,-0.49l-3.4,0.41l-5.12,-0.67l-2.63,0.06l-1.31,-1.6l-1.4,-3.0l-1.48,-0.33l-3.13,-1.94l-6.16,-0.93l-0.71,-1.06l0.86,-3.82l-1.93,-2.71l-3.5,-1.18l-1.95,-1.58l-0.5,-1.72l2.34,-0.52l4.75,-2.8l3.62,-1.47l2.18,0.97l2.46,0.05l1.81,1.53l2.46,0.12l3.95,0.71l2.43,-2.28l0.08,-0.48l-0.9,-1.72l2.24,-2.98l2.62,1.27l4.94,1.17l0.43,2.24Z",
              name: "Mongolia",
            },
            MK: {
              path: "M472.8,173.98l0.49,-0.71l3.57,-0.71l1.0,0.77l0.13,1.45l-0.65,0.53l-1.15,-0.05l-1.12,0.67l-1.39,0.22l-0.79,-0.55l-0.29,-1.03l0.19,-0.6Z",
              name: "Macedonia",
            },
            MW: {
              path: "M505.5,309.31l0.85,1.95l0.15,2.86l-0.69,1.65l0.71,1.8l0.06,1.28l0.49,0.64l0.07,1.06l0.4,0.55l0.8,-0.23l0.55,0.61l0.69,-0.21l0.34,0.6l0.19,2.94l-1.04,0.62l-0.54,1.25l-1.11,-1.08l-0.16,-1.56l0.51,-1.31l-0.32,-1.3l-0.99,-0.65l-0.82,0.12l-2.36,-1.64l0.63,-1.96l0.82,-1.18l-0.46,-2.01l0.9,-2.86l-0.94,-2.51l0.96,0.18l0.29,0.4Z",
              name: "Malawi",
            },
            MR: {
              path: "M407.36,220.66l-2.58,0.03l-0.39,0.44l2.42,22.56l0.36,0.43l-0.39,1.24l-9.75,0.04l-0.56,0.53l-0.91,-0.11l-1.27,0.45l-1.61,-0.66l-0.97,0.03l-0.36,0.29l-0.38,1.35l-0.42,0.23l-2.93,-3.4l-2.96,-1.52l-1.62,-0.03l-1.27,0.54l-1.12,-0.2l-0.65,0.4l-0.08,-0.49l0.68,-1.29l0.31,-2.43l-0.57,-3.91l0.23,-1.21l-0.69,-1.5l-1.15,-1.02l0.25,-0.39l9.58,0.02l0.4,-0.45l-0.46,-3.68l0.47,-1.04l2.12,-0.21l0.36,-0.4l-0.08,-6.4l7.81,0.13l0.41,-0.4l0.01,-3.31l7.76,5.35Z",
              name: "Mauritania",
            },
            UG: {
              path: "M498.55,276.32l0.7,-0.46l1.65,0.5l1.96,-0.57l1.7,0.01l1.45,-0.98l0.91,1.33l1.33,3.95l-2.57,4.03l-1.46,-0.4l-2.54,0.91l-1.37,1.61l-0.01,0.81l-2.42,-0.01l-2.26,1.01l-0.17,-1.59l0.58,-1.04l0.14,-1.94l1.37,-2.28l1.78,-1.58l-0.17,-0.65l-0.72,-0.24l0.13,-2.43Z",
              name: "Uganda",
            },
            MY: {
              path: "M717.47,273.46l-1.39,0.65l-2.12,-0.41l-2.88,-0.0l-0.38,0.28l-0.84,2.75l-0.99,0.96l-1.21,3.29l-1.73,0.45l-2.45,-0.68l-1.39,0.31l-1.33,1.15l-1.59,-0.14l-1.41,0.44l-1.44,-1.19l-0.18,-0.73l1.34,0.53l1.93,-0.47l0.75,-2.22l4.02,-1.03l2.75,-3.21l0.82,0.94l0.64,-0.05l0.4,-0.65l0.96,0.06l0.42,-0.36l0.24,-2.68l1.81,-1.64l1.21,-1.86l0.63,-0.01l1.07,1.05l0.34,1.28l3.44,1.35l-0.06,0.35l-1.37,0.1l-0.35,0.54l0.32,0.88ZM673.68,269.59l0.17,1.09l0.47,0.33l1.65,-0.3l0.87,-0.94l1.61,1.52l0.98,1.56l-0.12,2.81l0.41,2.29l0.95,0.9l0.88,2.44l-1.27,0.12l-5.1,-3.67l-0.34,-1.29l-1.37,-1.59l-0.33,-1.97l-0.88,-1.4l0.25,-1.68l-0.46,-1.05l1.63,0.84Z",
              name: "Malaysia",
            },
            MX: {
              path: "M133.12,200.41l0.2,0.47l9.63,3.33l6.96,-0.02l0.4,-0.4l0.0,-0.74l3.77,0.0l3.55,2.93l1.39,2.83l1.52,1.04l2.08,0.82l0.47,-0.14l1.46,-2.0l1.73,-0.04l1.59,0.98l2.05,3.35l1.47,1.56l1.26,3.14l2.18,1.02l2.26,0.58l-1.18,3.72l-0.42,5.04l1.79,4.89l1.62,1.89l0.61,1.52l1.2,1.42l2.55,0.66l1.37,1.1l7.54,-1.89l1.86,-1.3l1.14,-4.3l4.1,-1.21l3.57,-0.11l0.32,0.3l-0.06,0.94l-1.26,1.45l-0.67,1.71l0.38,0.7l-0.72,2.27l-0.49,-0.3l-1.0,0.08l-1.0,1.39l-0.47,-0.11l-0.53,0.47l-4.26,-0.02l-0.4,0.4l-0.0,1.06l-1.1,0.26l0.1,0.44l1.82,1.44l0.56,0.91l-3.19,0.21l-1.21,2.09l0.24,0.72l-0.2,0.44l-2.24,-2.18l-1.45,-0.93l-2.22,-0.69l-1.52,0.22l-3.07,1.16l-10.55,-3.85l-2.86,-1.96l-3.78,-0.92l-1.08,-1.19l-2.62,-1.43l-1.18,-1.54l-0.38,-0.81l0.66,-0.63l-0.18,-0.53l0.52,-0.76l0.01,-0.91l-2.0,-3.82l-2.21,-2.63l-2.53,-2.09l-1.19,-1.62l-2.2,-1.17l-0.3,-0.43l0.34,-1.48l-0.21,-0.45l-1.23,-0.6l-1.36,-1.2l-0.59,-1.78l-1.54,-0.47l-2.44,-2.55l-0.16,-0.9l-1.33,-2.03l-0.84,-1.99l-0.16,-1.33l-1.81,-1.1l-0.97,0.05l-1.31,-0.7l-0.57,0.22l-0.4,1.12l0.72,3.77l3.51,3.89l0.28,0.78l0.53,0.26l0.41,1.43l1.33,1.73l1.58,1.41l0.8,2.39l1.43,2.41l0.13,1.32l0.37,0.36l1.04,0.08l1.67,2.28l-0.85,0.76l-0.66,-1.51l-1.68,-1.54l-2.91,-1.87l0.06,-1.82l-0.54,-1.68l-2.91,-2.03l-0.55,0.09l-1.95,-1.1l-0.88,-0.94l0.68,-0.08l0.93,-1.01l0.08,-1.78l-1.93,-1.94l-1.46,-0.77l-3.75,-7.56l4.88,-0.42Z",
              name: "Mexico",
            },
            VU: {
              path: "M839.04,322.8l0.22,1.14l-0.44,0.03l-0.2,-1.45l0.42,0.27Z",
              name: "Vanuatu",
            },
            FR: {
              path: "M444.48,172.62l-0.64,1.78l-0.58,-0.31l-0.49,-1.72l0.4,-0.89l1.0,-0.72l0.3,1.85ZM429.64,147.1l1.78,1.58l1.46,-0.13l2.1,1.42l1.35,0.27l1.23,0.83l3.04,0.5l-1.03,1.85l-0.3,2.12l-0.41,0.32l-0.95,-0.24l-0.5,0.43l0.06,0.61l-1.81,1.92l-0.04,1.42l0.55,0.38l0.88,-0.36l0.61,0.97l-0.03,1.0l0.57,0.91l-0.75,1.09l0.65,2.39l1.27,0.57l-0.18,0.82l-2.01,1.53l-4.77,-0.8l-3.82,1.0l-0.53,1.85l-2.49,0.34l-2.71,-1.31l-1.16,0.57l-4.31,-1.29l-0.72,-0.86l1.19,-1.78l0.39,-6.45l-2.58,-3.3l-1.9,-1.66l-3.72,-1.23l-0.19,-1.72l2.81,-0.61l4.12,0.81l0.47,-0.48l-0.6,-2.77l1.94,0.95l5.83,-2.54l0.92,-2.74l1.6,-0.49l0.24,0.78l1.36,0.33l1.05,1.19ZM289.01,278.39l-0.81,0.8l-0.78,0.12l-0.5,-0.66l-0.56,-0.1l-0.91,0.6l-0.46,-0.22l1.09,-2.96l-0.96,-1.77l-0.17,-1.49l1.07,-1.77l2.32,0.75l2.51,2.01l0.3,0.74l-2.14,3.96Z",
              name: "France",
            },
            FI: {
              path: "M492.17,76.39l-0.23,3.5l3.52,2.63l-2.08,2.88l-0.02,0.44l2.8,4.56l-1.59,3.31l2.16,3.24l-0.94,2.39l0.14,0.47l3.44,2.51l-0.77,1.62l-7.52,6.95l-4.5,0.31l-4.38,1.37l-3.8,0.74l-1.44,-1.96l-2.17,-1.11l0.5,-3.66l-1.16,-3.33l1.09,-2.08l2.21,-2.42l5.67,-4.32l1.64,-0.83l0.21,-0.42l-0.46,-2.02l-3.38,-1.89l-0.75,-1.43l-0.22,-6.74l-6.79,-4.8l0.8,-0.62l2.54,2.12l3.46,-0.12l3.0,0.96l2.51,-2.11l1.17,-3.08l3.55,-1.38l2.76,1.53l-0.95,2.79Z",
              name: "Finland",
            },
            FJ: {
              path: "M871.53,326.34l-2.8,1.05l-0.08,-0.23l2.97,-1.21l-0.1,0.39ZM867.58,329.25l0.43,0.37l-0.27,0.88l-1.24,0.28l-1.04,-0.24l-0.14,-0.66l0.63,-0.58l0.92,0.26l0.7,-0.31Z",
              name: "Fiji",
            },
            FK: {
              path: "M274.36,425.85l1.44,1.08l-0.47,0.73l-3.0,0.89l-0.96,-1.0l-0.52,-0.05l-1.83,1.29l-0.73,-0.88l2.46,-1.64l1.93,0.76l1.67,-1.19Z",
              name: "Falkland Is.",
            },
            NI: {
              path: "M202.33,252.67l0.81,-0.18l1.03,-1.02l-0.04,-0.88l0.68,-0.0l0.63,-0.54l0.97,0.22l1.53,-1.26l0.58,-0.99l1.17,0.34l2.41,-0.94l0.13,1.32l-0.81,1.94l0.1,2.74l-0.36,0.37l-0.11,1.75l-0.47,0.81l0.18,1.14l-1.73,-0.85l-0.71,0.27l-1.47,-0.6l-0.52,0.16l-4.01,-3.81Z",
              name: "Nicaragua",
            },
            NL: {
              path: "M430.31,143.39l0.6,-0.5l2.13,-4.8l3.2,-1.33l1.74,0.08l0.33,0.8l-0.59,2.92l-0.5,0.99l-1.26,0.0l-0.4,0.45l0.33,2.7l-2.2,-1.78l-2.62,0.58l-0.75,-0.11Z",
              name: "Netherlands",
            },
            NO: {
              path: "M491.44,67.41l6.8,2.89l-2.29,0.86l-0.15,0.65l2.33,2.38l-4.98,1.79l0.84,-2.45l-0.18,-0.48l-3.55,-1.8l-3.89,1.52l-1.42,3.38l-2.12,1.72l-2.64,-1.0l-3.11,0.21l-2.66,-2.22l-0.5,-0.01l-1.41,1.1l-1.44,0.17l-0.35,0.35l-0.32,2.47l-4.32,-0.64l-0.44,0.29l-0.58,2.11l-2.45,0.2l-4.15,7.68l-3.88,5.76l0.78,1.62l-0.64,1.16l-2.24,-0.06l-0.38,0.24l-1.66,3.89l0.15,5.17l1.57,2.04l-0.78,4.16l-2.02,2.48l-0.85,1.63l-1.3,-1.75l-0.58,-0.07l-4.87,4.19l-3.1,0.79l-3.16,-1.7l-0.85,-3.77l-0.77,-8.55l2.14,-2.31l6.55,-3.27l5.02,-4.17l10.63,-13.84l10.98,-8.7l5.35,-1.91l4.34,0.12l3.69,-3.64l4.49,0.19l4.37,-0.89ZM484.55,20.04l4.26,1.75l-3.1,2.55l-7.1,0.65l-7.08,-0.9l-0.37,-1.31l-0.37,-0.29l-3.44,-0.1l-2.08,-2.0l6.87,-1.44l3.9,1.31l2.39,-1.64l6.13,1.4ZM481.69,33.93l-4.45,1.74l-3.54,-0.99l1.12,-0.9l0.05,-0.58l-1.06,-1.22l4.22,-0.89l1.09,1.97l2.57,0.87ZM466.44,24.04l7.43,3.77l-5.41,1.86l-1.58,4.08l-2.26,1.2l-1.12,4.11l-2.61,0.18l-4.79,-2.86l1.84,-1.54l-0.1,-0.68l-3.69,-1.53l-4.77,-4.51l-1.73,-3.89l6.11,-1.82l1.54,1.92l3.57,-0.08l1.2,-1.96l3.32,-0.18l3.05,1.92Z",
              name: "Norway",
            },
            NA: {
              path: "M474.26,330.66l-0.97,0.04l-0.38,0.4l-0.07,8.9l-2.09,0.08l-0.39,0.4l-0.0,17.42l-1.98,1.23l-1.17,0.17l-2.44,-0.66l-0.48,-1.13l-0.99,-0.74l-0.54,0.05l-0.9,1.01l-1.53,-1.68l-0.93,-1.88l-1.99,-8.56l-0.06,-3.12l-0.33,-1.52l-2.3,-3.34l-1.91,-4.83l-1.96,-2.43l-0.12,-1.57l2.33,-0.79l1.43,0.07l1.81,1.13l10.23,-0.25l1.84,1.23l5.87,0.35ZM474.66,330.64l6.51,-1.6l1.9,0.39l-1.69,0.4l-1.31,0.83l-1.12,-0.94l-4.29,0.92Z",
              name: "Namibia",
            },
            NC: {
              path: "M838.78,341.24l-0.33,0.22l-2.9,-1.75l-3.26,-3.37l1.65,0.83l4.85,4.07Z",
              name: "New Caledonia",
            },
            NE: {
              path: "M454.75,226.53l1.33,1.37l0.48,0.07l1.27,-0.7l0.53,3.52l0.94,0.83l0.17,0.92l0.81,0.69l-0.44,0.95l-0.96,5.26l-0.13,3.22l-3.04,2.31l-1.22,3.57l1.02,1.24l-0.0,1.46l0.39,0.4l1.13,0.04l-0.9,1.25l-1.47,-2.42l-0.86,-0.29l-2.09,1.37l-1.74,-0.67l-1.45,-0.17l-0.85,0.35l-1.36,-0.07l-1.64,1.09l-1.06,0.05l-2.94,-1.28l-1.44,0.59l-1.01,-0.03l-0.97,-0.94l-2.7,-0.98l-2.69,0.3l-0.87,0.64l-0.47,1.6l-0.75,1.16l-0.12,1.53l-1.57,-1.1l-1.31,0.24l0.03,-0.81l-0.32,-0.41l-2.59,-0.52l-0.15,-1.16l-1.35,-1.6l-0.29,-1.0l0.13,-0.84l1.29,-0.08l1.08,-0.92l3.31,-0.22l2.22,-0.41l0.32,-0.34l0.2,-1.47l1.39,-1.88l-0.01,-5.66l3.36,-1.12l7.24,-5.12l8.42,-4.92l3.69,1.06Z",
              name: "Niger",
            },
            NG: {
              path: "M456.32,253.89l0.64,0.65l-0.28,1.04l-2.11,2.01l-2.03,5.18l-1.37,1.16l-1.15,3.18l-1.33,0.66l-1.46,-0.97l-1.21,0.16l-1.38,1.36l-0.91,0.24l-1.79,4.06l-2.33,0.81l-1.11,-0.07l-0.86,0.5l-1.71,-0.05l-1.19,-1.39l-0.89,-1.89l-1.77,-1.66l-3.95,-0.08l0.07,-5.21l0.42,-1.43l1.95,-2.3l-0.14,-0.91l0.43,-1.18l-0.53,-1.41l0.25,-2.92l0.72,-1.07l0.32,-1.34l0.46,-0.39l2.47,-0.28l2.34,0.89l1.15,1.02l1.28,0.04l1.22,-0.58l3.03,1.27l1.49,-0.14l1.36,-1.0l1.33,0.07l0.82,-0.35l3.45,0.8l1.82,-1.32l1.84,2.67l0.66,0.16Z",
              name: "Nigeria",
            },
            NZ: {
              path: "M857.8,379.65l1.86,3.12l0.44,0.18l0.3,-0.38l0.03,-1.23l0.38,0.27l0.57,2.31l2.02,0.94l1.81,0.27l1.57,-1.06l0.7,0.18l-1.15,3.59l-1.98,0.11l-0.74,1.2l0.2,1.11l-2.42,3.98l-1.49,0.92l-1.04,-0.85l1.21,-2.05l-0.81,-2.01l-2.63,-1.25l0.04,-0.57l1.82,-1.19l0.43,-2.34l-0.16,-2.03l-0.95,-1.82l-0.06,-0.72l-3.11,-3.64l-0.79,-1.52l1.56,1.45l1.76,0.66l0.65,2.34ZM853.83,393.59l0.57,1.24l0.59,0.16l1.42,-0.97l0.46,0.79l0.0,1.03l-2.47,3.48l-1.26,1.2l-0.06,0.5l0.55,0.87l-1.41,0.07l-2.33,1.38l-2.03,5.02l-3.02,2.16l-2.06,-0.06l-1.71,-1.04l-2.47,-0.2l-0.27,-0.73l1.22,-2.1l3.05,-2.94l1.62,-0.59l4.02,-2.82l1.57,-1.67l1.07,-2.16l0.88,-0.7l0.48,-1.75l1.24,-0.97l0.35,0.79Z",
              name: "New Zealand",
            },
            NP: {
              path: "M641.14,213.62l0.01,3.19l-1.74,0.04l-4.8,-0.86l-1.58,-1.39l-3.37,-0.34l-7.65,-3.7l0.8,-2.09l2.33,-1.7l1.77,0.75l2.49,1.76l1.38,0.41l0.99,1.35l1.9,0.52l1.99,1.17l5.49,0.9Z",
              name: "Nepal",
            },
            CI: {
              path: "M407.4,259.27l0.86,0.42l0.56,0.9l1.13,0.53l1.19,-0.61l0.97,-0.08l1.42,0.54l0.6,3.24l-1.03,2.08l-0.65,2.84l1.06,2.33l-0.06,0.53l-2.54,-0.47l-1.66,0.03l-3.06,0.46l-4.11,1.6l0.32,-3.06l-1.18,-1.31l-1.32,-0.66l0.42,-0.85l-0.2,-1.4l0.5,-0.67l0.01,-1.59l0.84,-0.32l0.26,-0.5l-1.15,-3.01l0.12,-0.5l0.51,-0.25l0.66,0.31l1.93,0.02l0.67,-0.71l0.71,-0.14l0.25,0.69l0.57,0.22l1.4,-0.61Z",
              name: "Côte d'Ivoire",
            },
            CH: {
              path: "M444.62,156.35l-0.29,0.87l0.18,0.53l1.13,0.58l1.0,0.1l-0.1,0.65l-0.79,0.38l-1.72,-0.37l-0.45,0.23l-0.45,1.04l-0.75,0.06l-0.84,-0.4l-1.32,1.0l-0.96,0.12l-0.88,-0.55l-0.81,-1.3l-0.49,-0.16l-0.63,0.26l0.02,-0.65l1.71,-1.66l0.1,-0.56l0.93,0.08l0.58,-0.46l1.99,0.02l0.66,-0.61l2.19,0.79Z",
              name: "Switzerland",
            },
            CO: {
              path: "M242.07,254.93l-1.7,0.59l-0.59,1.18l-1.7,1.69l-0.38,1.93l-0.67,1.43l0.31,0.57l1.03,0.13l0.25,0.9l0.57,0.64l-0.04,2.34l1.64,1.42l3.16,-0.24l1.26,0.28l1.67,2.06l0.41,0.13l4.09,-0.39l0.45,0.22l-0.92,1.95l-0.2,1.8l0.52,1.83l0.75,1.05l-1.12,1.1l0.07,0.63l0.84,0.51l0.74,1.29l-0.39,-0.45l-0.59,-0.01l-0.71,0.74l-4.71,-0.05l-0.4,0.41l0.03,1.57l0.33,0.39l1.11,0.2l-1.68,0.4l-0.29,0.38l-0.01,1.82l1.16,1.14l0.34,1.25l-1.05,7.05l-1.04,-0.87l1.26,-1.99l-0.13,-0.56l-2.18,-1.23l-1.38,0.2l-1.14,-0.38l-1.27,0.61l-1.55,-0.26l-1.38,-2.46l-1.23,-0.75l-0.85,-1.2l-1.67,-1.19l-0.86,0.13l-2.11,-1.32l-1.01,0.31l-1.8,-0.29l-0.52,-0.91l-3.09,-1.68l0.77,-0.52l-0.1,-1.12l0.41,-0.64l1.34,-0.32l2.0,-2.88l-0.11,-0.57l-0.66,-0.43l0.39,-1.38l-0.52,-2.1l0.49,-0.83l-0.4,-2.13l-0.97,-1.35l0.17,-0.66l0.86,-0.08l0.47,-0.75l-0.46,-1.63l1.41,-0.07l1.8,-1.69l0.93,-0.24l0.3,-0.38l0.45,-2.76l1.22,-1.0l1.44,-0.04l0.45,-0.5l1.91,0.12l2.93,-1.84l1.15,-1.14l0.91,0.46l-0.25,0.45Z",
              name: "Colombia",
            },
            CN: {
              path: "M740.23,148.97l4.57,1.3l2.8,2.17l0.98,2.9l0.38,0.27l3.8,0.0l2.32,-1.28l3.29,-0.75l-0.96,2.09l-1.02,1.28l-0.85,3.4l-1.52,2.73l-2.76,-0.5l-2.4,1.13l-0.21,0.45l0.64,2.57l-0.32,3.2l-0.94,0.06l-0.37,0.89l-0.91,-1.01l-0.64,0.07l-0.92,1.57l-3.73,1.25l-0.26,0.48l0.26,1.06l-1.5,-0.08l-1.09,-0.86l-0.56,0.06l-1.67,2.06l-2.7,1.56l-2.03,1.88l-3.4,0.83l-1.93,1.4l-1.15,0.34l0.33,-0.7l-0.41,-0.89l1.79,-1.79l0.02,-0.54l-1.32,-1.56l-0.48,-0.1l-2.24,1.09l-2.83,2.06l-1.51,1.83l-2.28,0.13l-1.55,1.49l-0.04,0.5l1.32,1.97l2.0,0.58l0.31,1.35l1.98,0.84l3.0,-1.96l2.0,1.02l1.49,0.11l0.22,0.83l-3.37,0.86l-1.12,1.48l-2.5,1.52l-1.29,1.99l0.14,0.56l2.57,1.48l0.97,2.7l3.17,4.63l-0.03,1.66l-1.35,0.65l-0.2,0.51l0.6,1.47l1.4,0.91l-0.89,3.82l-1.43,0.38l-3.85,6.44l-2.27,3.11l-6.78,4.57l-2.73,0.29l-1.45,1.04l-0.62,-0.61l-0.55,-0.01l-1.36,1.25l-3.39,1.27l-2.61,0.4l-1.1,2.79l-0.81,0.09l-0.49,-1.42l0.5,-0.85l-0.25,-0.59l-3.36,-0.84l-1.3,0.4l-2.31,-0.62l-0.94,-0.84l0.33,-1.28l-0.3,-0.49l-2.19,-0.46l-1.13,-0.93l-0.47,-0.02l-2.06,1.36l-4.29,0.28l-2.76,1.05l-0.28,0.43l0.32,2.53l-0.59,-0.03l-0.19,-1.34l-0.55,-0.34l-1.68,0.7l-2.46,-1.23l0.62,-1.87l-0.26,-0.51l-1.37,-0.44l-0.54,-2.22l-0.45,-0.3l-2.13,0.35l0.24,-2.48l2.39,-2.4l0.03,-4.31l-1.19,-0.92l-0.78,-1.49l-0.41,-0.21l-1.41,0.19l-1.98,-0.3l0.46,-1.07l-1.17,-1.7l-0.55,-0.11l-1.63,1.05l-2.25,-0.57l-2.89,1.73l-2.25,1.98l-1.75,0.29l-1.17,-0.71l-3.31,-0.65l-1.48,0.79l-1.04,1.27l-0.12,-1.17l-0.54,-0.34l-1.44,0.54l-5.55,-0.86l-1.98,-1.16l-1.89,-0.54l-0.99,-1.35l-1.34,-0.37l-2.55,-1.79l-2.01,-0.84l-1.21,0.56l-5.57,-3.45l-0.53,-2.31l1.19,0.25l0.48,-0.37l0.08,-1.42l-0.98,-1.56l0.15,-2.44l-2.69,-3.32l-4.12,-1.23l-0.67,-2.0l-1.92,-1.48l-0.38,-0.7l-0.51,-3.01l-1.52,-0.66l-0.7,0.13l-0.48,-2.05l0.55,-0.51l-0.09,-0.82l2.03,-1.19l1.6,-0.54l2.56,0.38l0.42,-0.22l0.85,-1.7l3.0,-0.33l1.1,-1.26l4.05,-1.77l0.39,-0.91l-0.17,-1.44l1.45,-0.67l0.2,-0.52l-2.07,-4.9l4.51,-1.12l1.37,-0.73l1.89,-5.51l4.98,0.86l1.51,-1.7l0.11,-2.87l1.99,-0.38l1.83,-2.06l0.49,-0.13l0.68,2.08l2.23,1.77l3.44,1.16l1.55,2.29l-0.92,3.49l0.96,1.67l6.54,1.13l2.95,1.87l1.47,0.35l1.06,2.62l1.53,1.91l3.05,0.08l5.14,0.67l3.37,-0.41l2.36,0.43l3.65,1.8l3.06,0.04l1.45,0.88l2.87,-1.59l3.95,-1.02l3.83,-0.14l3.06,-1.14l1.77,-1.6l1.72,-1.01l0.17,-0.49l-1.1,-2.05l1.02,-1.54l4.02,0.8l2.45,-1.61l3.76,-1.19l1.96,-2.13l1.63,-0.83l3.51,-0.4l1.92,0.34l0.46,-0.3l0.17,-1.5l-2.27,-2.22l-2.11,-1.09l-2.18,1.11l-2.32,-0.47l-1.29,0.32l-0.4,-0.82l2.73,-5.16l3.02,1.06l3.53,-2.06l0.18,-1.68l2.16,-3.35l1.49,-1.35l-0.03,-1.85l-1.07,-0.85l1.54,-1.26l2.98,-0.59l3.23,-0.09l3.64,0.99l2.04,1.16l3.29,6.71l0.92,3.19ZM696.92,237.31l-1.87,1.08l-1.63,-0.64l-0.06,-1.79l1.03,-0.98l2.58,-0.69l1.16,0.05l0.3,0.54l-0.98,1.06l-0.53,1.37Z",
              name: "China",
            },
            CM: {
              path: "M457.92,257.49l1.05,1.91l-1.4,0.16l-1.05,-0.23l-0.45,0.22l-0.54,1.19l0.08,0.45l1.48,1.47l1.05,0.45l1.01,2.46l-1.52,2.99l-0.68,0.68l-0.13,3.69l2.38,3.84l1.09,0.8l0.24,2.48l-3.67,-1.14l-11.27,-0.13l0.23,-1.79l-0.98,-1.66l-1.19,-0.54l-0.44,-0.97l-0.6,-0.42l1.71,-4.27l0.75,-0.13l1.38,-1.36l0.65,-0.03l1.71,0.99l1.93,-1.12l1.14,-3.18l1.38,-1.17l2.0,-5.14l2.17,-2.13l0.3,-1.64l-0.86,-0.88l0.03,-0.33l0.94,1.28l0.07,3.22Z",
              name: "Cameroon",
            },
            CL: {
              path: "M246.5,429.18l-3.14,1.83l-0.57,3.16l-0.64,0.05l-2.68,-1.06l-2.82,-2.33l-3.04,-1.89l-0.69,-1.85l0.63,-2.14l-1.21,-2.11l-0.31,-5.37l1.01,-2.91l2.57,-2.38l-0.18,-0.68l-3.16,-0.77l2.05,-2.47l0.77,-4.65l2.32,0.9l0.54,-0.29l1.31,-6.31l-0.22,-0.44l-1.68,-0.8l-0.56,0.28l-0.7,3.36l-0.81,-0.22l1.56,-9.41l1.15,-2.24l-0.71,-2.82l-0.18,-2.84l1.01,-0.33l3.26,-9.14l1.07,-4.22l-0.56,-4.21l0.74,-2.34l-0.29,-3.27l1.46,-3.34l2.04,-16.59l-0.66,-7.76l1.03,-0.53l0.54,-0.9l0.79,1.14l0.32,1.78l1.25,1.16l-0.69,2.55l1.33,2.9l0.97,3.59l0.46,0.29l1.5,-0.3l0.11,0.23l-0.76,2.44l-2.57,1.23l-0.23,0.37l0.08,4.33l-0.46,0.77l0.56,1.21l-1.58,1.51l-1.68,2.62l-0.89,2.47l0.2,2.7l-1.48,2.73l1.12,5.09l0.64,0.61l-0.01,2.29l-1.38,2.68l0.01,2.4l-1.89,2.04l0.02,2.75l0.69,2.57l-1.43,1.13l-1.26,5.68l0.39,3.51l-0.97,0.89l0.58,3.5l1.02,1.14l-0.65,1.02l0.15,0.57l1.0,0.53l0.16,0.69l-1.03,0.85l0.26,1.75l-0.89,4.03l-1.31,2.66l0.24,1.75l-0.71,1.83l-1.99,1.7l0.3,3.67l0.88,1.19l1.58,0.01l0.01,2.21l1.04,1.95l5.98,0.63ZM248.69,430.79l0.0,7.33l0.4,0.4l3.52,0.05l-0.44,0.75l-1.94,0.98l-2.49,-0.37l-1.88,-1.06l-2.55,-0.49l-5.59,-3.71l-2.38,-2.63l4.1,2.48l3.32,1.23l0.45,-0.12l1.29,-1.57l0.83,-2.32l2.05,-1.24l1.31,0.29Z",
              name: "Chile",
            },
            CA: {
              path: "M280.06,145.6l-1.67,2.88l0.07,0.49l0.5,0.04l1.46,-0.98l1.0,0.42l-0.56,0.72l0.17,0.62l2.22,0.89l1.35,-0.71l1.95,0.78l-0.66,2.01l0.5,0.51l1.32,-0.42l0.98,3.17l-0.91,2.41l-0.8,0.08l-1.23,-0.45l0.47,-2.25l-0.89,-0.83l-0.48,0.06l-2.78,2.63l-0.34,-0.02l1.02,-0.85l-0.14,-0.69l-2.4,-0.77l-7.4,0.08l-0.17,-0.41l1.3,-0.94l0.02,-0.64l-0.73,-0.58l1.85,-1.74l2.57,-5.16l1.47,-1.79l1.99,-1.05l0.46,0.06l-1.53,2.45ZM68.32,74.16l4.13,0.95l4.02,2.14l2.61,0.4l2.47,-1.89l2.88,-1.31l3.85,0.48l3.71,-1.94l3.82,-1.04l1.56,1.68l0.49,0.08l1.87,-1.04l0.65,-1.98l1.24,0.35l4.16,3.94l0.54,0.01l2.75,-2.49l0.26,2.59l0.49,0.35l3.08,-0.73l1.04,-1.27l2.73,0.23l3.83,1.86l5.86,1.61l3.47,0.75l2.44,-0.26l2.73,1.78l-2.98,1.81l-0.19,0.41l0.31,0.32l4.53,0.92l6.87,-0.5l2.0,-0.69l2.49,2.39l0.53,0.02l2.72,-2.16l-0.02,-0.64l-2.16,-1.54l1.15,-1.06l4.83,-0.61l1.84,0.95l2.48,2.31l3.01,-0.23l4.55,1.92l3.85,-0.67l3.61,0.1l0.41,-0.44l-0.25,-2.36l1.79,-0.61l3.49,1.32l-0.01,3.77l0.31,0.39l0.45,-0.22l1.48,-3.16l1.74,0.1l0.41,-0.3l1.13,-4.37l-2.78,-3.11l-2.8,-1.74l0.19,-4.64l2.71,-3.07l2.98,0.67l2.41,1.95l3.19,4.8l-1.99,1.97l0.21,0.68l4.33,0.84l-0.01,4.15l0.25,0.37l0.44,-0.09l3.07,-3.15l2.54,2.39l-0.61,3.33l2.42,2.88l0.61,0.0l2.61,-3.08l1.88,-3.82l0.17,-4.58l6.72,0.94l3.13,2.04l0.13,1.82l-1.76,2.19l-0.01,0.49l1.66,2.16l-0.26,1.71l-4.68,2.8l-3.28,0.61l-2.47,-1.2l-0.55,0.23l-0.73,2.04l-2.38,3.43l-0.74,1.77l-2.74,2.57l-3.44,0.25l-2.21,1.78l-0.28,2.53l-2.82,0.55l-3.12,3.22l-2.72,4.31l-1.03,3.17l-0.14,4.31l0.33,0.41l3.44,0.57l2.24,5.95l0.45,0.23l3.4,-0.69l4.52,1.51l2.43,1.31l1.91,1.73l3.1,0.96l2.62,1.46l6.6,0.54l-0.35,2.74l0.81,3.53l1.81,3.78l3.83,3.3l0.45,0.04l2.1,-1.28l1.37,-3.69l-1.31,-5.38l-1.45,-1.58l3.57,-1.47l2.84,-2.46l1.52,-2.8l-0.25,-2.55l-1.7,-3.07l-2.85,-2.61l2.8,-3.95l-1.08,-3.37l-0.79,-5.67l1.36,-0.7l6.76,1.41l2.12,-0.96l5.12,3.36l1.05,1.61l4.08,0.26l-0.06,2.87l0.83,4.7l0.3,0.32l2.16,0.54l1.73,2.06l0.5,0.09l3.63,-2.03l2.52,-4.19l1.26,-1.32l7.6,11.72l-0.92,2.04l0.16,0.51l3.3,1.97l2.22,1.98l4.1,0.98l1.43,0.99l0.95,2.79l2.1,0.68l0.84,1.08l0.17,3.45l-3.37,2.26l-4.22,1.24l-3.06,2.63l-4.06,0.51l-5.35,-0.69l-6.39,0.2l-2.3,2.41l-3.26,1.51l-6.47,7.15l-0.06,0.48l0.44,0.19l2.13,-0.52l4.17,-4.24l5.12,-2.62l3.52,-0.3l1.69,1.21l-2.12,2.21l0.81,3.47l1.02,2.61l3.47,1.6l4.14,-0.45l2.15,-2.8l0.26,1.48l1.14,0.8l-2.56,1.69l-5.5,1.82l-2.54,1.27l-2.74,2.15l-1.4,-0.16l-0.07,-2.01l4.14,-2.44l0.18,-0.45l-0.39,-0.29l-6.63,0.45l-1.39,-1.49l-0.14,-4.43l-1.11,-0.91l-1.82,0.39l-0.66,-0.66l-0.6,0.03l-1.91,2.39l-0.82,2.52l-0.8,1.27l-1.67,0.56l-0.46,0.76l-8.31,0.07l-1.21,0.62l-2.35,1.97l-0.71,-0.14l-1.37,0.96l-1.12,-0.48l-4.74,1.26l-0.9,1.17l0.21,0.62l1.73,0.3l-1.81,0.31l-1.85,0.81l-2.11,-0.13l-2.95,1.78l-0.69,-0.09l1.39,-2.1l1.73,-1.21l0.1,-2.29l1.16,-1.99l0.49,0.53l2.03,0.42l1.2,-1.16l0.02,-0.47l-2.66,-3.51l-2.28,-0.61l-5.64,-0.71l-0.4,-0.57l-0.79,0.13l0.2,-0.41l-0.22,-0.55l-0.68,-0.26l0.19,-1.26l-0.78,-0.73l0.31,-0.64l-0.29,-0.57l-2.6,-0.44l-0.75,-1.63l-0.94,-0.66l-4.31,-0.65l-1.13,1.19l-1.48,0.59l-0.85,1.06l-2.83,-0.76l-2.09,0.39l-2.39,-0.97l-4.24,-0.7l-0.57,-0.4l-0.41,-1.63l-0.4,-0.3l-0.85,0.02l-0.39,0.4l-0.01,0.85l-69.13,-0.01l-6.51,-4.52l-4.5,-1.38l-1.26,-2.66l0.33,-1.93l-0.23,-0.43l-3.01,-1.35l-0.55,-2.77l-2.89,-2.38l-0.04,-1.45l1.39,-1.83l-0.28,-2.55l-4.16,-2.2l-4.07,-6.6l-4.02,-3.22l-1.3,-1.88l-0.5,-0.13l-2.51,1.21l-2.23,1.87l-3.85,-3.88l-2.44,-1.04l-2.22,-0.13l0.03,-37.49ZM260.37,148.65l3.04,0.76l2.26,1.2l-3.78,-0.95l-1.53,-1.01ZM249.4,3.81l6.68,0.49l5.32,0.79l4.26,1.57l-0.07,1.1l-5.85,2.53l-6.02,1.21l-2.39,1.39l-0.18,0.45l0.39,0.29l4.01,-0.02l-4.65,2.82l-4.2,1.74l-4.19,4.59l-5.03,0.92l-1.67,1.15l-7.47,0.59l-0.37,0.37l0.32,0.42l2.41,0.49l-0.81,0.47l-0.12,0.59l1.83,2.41l-2.02,1.59l-3.81,1.51l-1.32,2.16l-3.38,1.53l-0.22,0.48l0.35,1.19l0.4,0.29l3.88,-0.18l0.03,0.61l-6.33,2.95l-6.41,-1.4l-7.43,0.79l-3.72,-0.62l-4.4,-0.25l-0.23,-1.83l4.29,-1.11l0.28,-0.51l-1.1,-3.45l1.0,-0.25l6.58,2.28l0.47,-0.16l-0.05,-0.49l-3.41,-3.45l-3.58,-0.98l1.48,-1.55l4.34,-1.29l0.97,-2.19l-0.16,-0.48l-3.42,-2.13l-0.81,-2.26l6.2,0.22l2.24,0.58l3.91,-2.1l0.2,-0.43l-0.35,-0.32l-5.64,-0.67l-8.73,0.36l-4.26,-1.9l-2.12,-2.4l-2.78,-1.66l-0.41,-1.52l3.31,-1.03l2.93,-0.2l4.91,-0.99l3.7,-2.27l2.87,0.3l2.62,1.67l0.56,-0.14l1.82,-3.2l3.13,-0.94l4.44,-0.69l7.53,-0.26l1.48,0.67l7.19,-1.06l10.8,0.79ZM203.85,57.54l0.01,0.42l1.97,2.97l0.68,-0.02l2.24,-3.72l5.95,-1.86l4.01,4.64l-0.35,2.91l0.5,0.43l4.95,-1.36l2.32,-1.8l5.31,2.28l3.27,2.11l0.3,1.84l0.48,0.33l4.42,-0.99l2.64,2.87l5.97,1.77l2.06,1.72l2.11,3.71l-4.19,1.86l-0.01,0.73l5.9,2.83l3.94,0.94l3.78,3.95l3.46,0.25l-0.63,2.37l-4.11,4.47l-2.76,-1.56l-3.9,-3.94l-3.59,0.41l-0.33,0.34l-0.19,2.72l2.63,2.38l3.42,1.89l0.94,0.97l1.55,3.75l-0.7,2.29l-2.74,-0.92l-6.25,-3.15l-0.51,0.13l0.05,0.52l6.07,5.69l0.18,0.59l-6.09,-1.39l-5.31,-2.24l-2.63,-1.66l0.6,-0.77l-0.12,-0.6l-7.39,-4.01l-0.59,0.37l0.03,0.79l-6.73,0.6l-1.69,-1.1l1.36,-2.46l4.51,-0.07l5.15,-0.52l0.31,-0.6l-0.74,-1.3l0.78,-1.84l3.21,-4.05l-0.67,-2.35l-1.11,-1.6l-3.84,-2.1l-4.35,-1.28l0.91,-0.63l0.06,-0.61l-2.65,-2.75l-2.34,-0.36l-1.89,-1.46l-0.53,0.03l-1.24,1.23l-4.36,0.55l-9.04,-0.99l-9.26,-1.98l-1.6,-1.22l2.22,-1.77l0.13,-0.44l-0.38,-0.27l-3.22,-0.02l-0.72,-4.25l1.83,-4.04l2.42,-1.85l5.5,-1.1l-1.39,2.35ZM261.19,159.33l2.07,0.61l1.44,-0.04l-1.15,0.63l-2.94,-1.23l-0.4,-0.68l0.36,-0.37l0.61,1.07ZM230.83,84.39l-2.37,0.18l-0.49,-1.63l0.93,-2.09l1.94,-0.51l1.62,0.99l0.02,1.52l-1.66,1.54ZM229.43,58.25l0.11,0.65l-4.87,-0.21l-2.72,0.62l-3.1,-2.57l0.08,-1.26l0.86,-0.23l5.57,0.51l4.08,2.5ZM222.0,105.02l-0.72,1.49l-0.63,-0.19l-0.48,-0.84l0.81,-0.99l0.65,0.05l0.37,0.46ZM183.74,38.32l2.9,1.7l4.79,-0.01l1.84,1.46l-0.49,1.68l0.23,0.48l2.82,1.14l1.76,1.26l7.01,0.65l4.1,-1.1l5.03,-0.43l3.93,0.35l2.48,1.77l0.46,1.7l-1.3,1.1l-3.56,1.01l-3.23,-0.59l-7.17,0.76l-5.09,0.09l-3.99,-0.6l-6.42,-1.54l-0.79,-2.51l-0.3,-2.49l-2.64,-2.5l-5.32,-0.72l-2.52,-1.4l0.68,-1.57l4.78,0.31ZM207.38,91.35l0.4,1.56l0.56,0.26l1.06,-0.52l1.32,0.96l5.42,2.57l0.2,1.68l0.46,0.35l1.68,-0.28l1.15,0.85l-1.55,0.87l-3.61,-0.88l-1.32,-1.69l-0.57,-0.06l-2.45,2.1l-3.12,1.79l-0.7,-1.87l-0.42,-0.26l-2.16,0.24l1.39,-1.39l0.32,-3.14l0.76,-3.35l1.18,0.22ZM215.49,102.6l-2.67,1.95l-1.4,-0.07l-0.3,-0.58l1.53,-1.48l2.84,0.18ZM202.7,24.12l2.53,1.59l-2.87,1.4l-4.53,4.05l-4.25,0.38l-5.03,-0.68l-2.45,-2.04l0.03,-1.62l1.82,-1.37l0.14,-0.45l-0.38,-0.27l-4.45,0.04l-2.59,-1.76l-1.41,-2.29l1.57,-2.32l1.62,-1.66l2.44,-0.39l0.25,-0.65l-0.6,-0.74l4.86,-0.25l3.24,3.11l8.16,2.3l1.9,3.61ZM187.47,59.2l-2.76,3.49l-2.38,-0.15l-1.44,-3.84l0.04,-2.2l1.19,-1.88l2.3,-1.23l5.07,0.17l4.11,1.02l-3.24,3.72l-2.88,0.89ZM186.07,48.79l-1.08,1.53l-3.34,-0.34l-2.56,-1.1l1.03,-1.75l3.25,-1.23l1.95,1.58l0.75,1.3ZM185.71,35.32l-5.3,-0.2l-0.32,-0.71l4.31,0.07l1.3,0.84ZM180.68,32.48l-3.34,1.0l-1.79,-1.1l-0.98,-1.87l-0.15,-1.73l4.1,0.53l2.67,1.7l-0.51,1.47ZM180.9,76.31l-1.1,1.08l-3.13,-1.23l-2.12,0.43l-2.71,-1.57l1.72,-1.09l1.55,-1.72l3.81,1.9l1.98,2.2ZM169.74,54.87l2.96,0.97l4.17,-0.57l0.41,0.88l-2.14,2.11l0.09,0.64l3.55,1.92l-0.4,3.72l-3.79,1.65l-2.17,-0.35l-1.72,-1.74l-6.02,-3.5l0.03,-0.85l4.68,0.54l0.4,-0.21l-0.05,-0.45l-2.48,-2.81l2.46,-1.95ZM174.45,40.74l1.37,1.73l0.07,2.44l-1.05,3.45l-3.79,0.47l-2.32,-0.69l0.05,-2.64l-0.44,-0.41l-3.68,0.35l-0.12,-3.1l2.45,0.1l3.67,-1.73l3.41,0.29l0.37,-0.26ZM170.05,31.55l0.67,1.56l-3.33,-0.49l-4.22,-1.77l-4.35,-0.16l1.4,-0.94l-0.06,-0.7l-2.81,-1.23l-0.12,-1.39l4.39,0.68l6.62,1.98l1.81,2.47ZM134.5,58.13l-1.02,1.82l0.45,0.58l5.4,-1.39l3.33,2.29l0.49,-0.03l2.6,-2.23l1.94,1.32l2.0,4.5l0.7,0.06l1.3,-2.29l-1.63,-4.46l1.69,-0.54l2.31,0.71l2.65,1.81l2.49,7.92l8.48,4.27l-0.19,1.35l-3.79,0.33l-0.26,0.67l1.4,1.49l-0.58,1.1l-4.23,-0.64l-4.43,-1.19l-3.0,0.28l-4.66,1.47l-10.52,1.04l-1.43,-2.02l-3.42,-1.2l-2.21,0.43l-2.51,-2.86l4.84,-1.05l3.6,0.19l3.27,-0.78l0.31,-0.39l-0.31,-0.39l-4.84,-1.06l-8.79,0.27l-0.85,-1.07l5.26,-1.66l0.27,-0.45l-0.4,-0.34l-3.8,0.06l-3.81,-1.06l1.81,-3.01l1.66,-1.79l6.48,-2.81l1.97,0.71ZM158.7,56.61l-1.7,2.44l-3.2,-2.75l0.37,-0.3l3.11,-0.18l1.42,0.79ZM149.61,42.73l1.01,1.89l0.5,0.18l2.14,-0.82l2.23,0.19l0.36,2.04l-1.33,2.09l-8.28,0.76l-6.35,2.15l-3.41,0.1l-0.19,-0.96l4.9,-2.08l0.23,-0.46l-0.41,-0.31l-11.25,0.59l-2.89,-0.74l3.04,-4.44l2.14,-1.32l6.81,1.69l4.58,3.06l4.37,0.39l0.36,-0.63l-3.36,-4.6l1.85,-1.53l2.18,0.51l0.77,2.26ZM144.76,34.41l-4.36,1.44l-3.0,-1.4l1.46,-1.24l3.47,-0.52l2.96,0.71l-0.52,1.01ZM145.13,29.83l-1.9,0.66l-3.67,-0.0l2.27,-1.61l3.3,0.95ZM118.92,65.79l-6.03,2.02l-1.33,-1.9l-5.38,-2.28l2.59,-5.05l2.16,-3.14l-0.02,-0.48l-1.97,-2.41l7.64,-0.7l3.6,1.02l6.3,0.27l4.42,2.95l-2.53,0.98l-6.24,3.43l-3.1,3.28l-0.11,2.01ZM129.54,35.53l-0.28,3.37l-1.72,1.62l-2.33,0.28l-4.61,2.19l-3.86,0.76l-2.64,-0.87l3.72,-3.4l5.01,-3.34l3.72,0.07l3.0,-0.67ZM111.09,152.69l-0.67,0.24l-3.85,-1.37l-0.83,-1.17l-2.12,-1.07l-0.66,-1.02l-2.4,-0.55l-0.74,-1.71l6.02,1.45l2.0,2.55l2.52,1.39l0.73,1.27ZM87.8,134.64l0.89,0.29l1.86,-0.21l-0.65,3.34l1.69,2.33l-1.31,-1.33l-0.99,-1.62l-1.17,-0.98l-0.33,-1.82Z",
              name: "Canada",
            },
            CG: {
              path: "M466.72,276.48l-0.1,1.03l-1.25,2.97l-0.19,3.62l-0.46,1.78l-0.23,0.63l-1.61,1.19l-1.21,1.39l-1.09,2.43l0.04,2.09l-3.25,3.24l-0.5,-0.24l-0.5,-0.83l-1.36,-0.02l-0.98,0.89l-1.68,-0.99l-1.54,1.24l-1.52,-1.96l1.57,-1.14l0.11,-0.52l-0.77,-1.35l2.1,-0.66l0.39,-0.73l1.05,0.82l2.21,0.11l1.12,-1.37l0.37,-1.81l-0.27,-2.09l-1.13,-1.5l1.0,-2.69l-0.13,-0.45l-0.92,-0.58l-1.6,0.17l-0.51,-0.94l0.1,-0.61l2.75,0.09l3.97,1.24l0.51,-0.33l0.17,-1.28l1.24,-2.21l1.28,-1.14l2.76,0.49Z",
              name: "Congo",
            },
            CF: {
              path: "M461.16,278.2l-0.26,-1.19l-1.09,-0.77l-0.84,-1.17l-0.29,-1.0l-1.04,-1.15l0.08,-3.43l0.58,-0.49l1.16,-2.35l1.85,-0.17l0.61,-0.62l0.97,0.58l3.15,-0.96l2.48,-1.92l0.02,-0.96l2.81,0.02l2.36,-1.17l1.93,-2.85l1.16,-0.93l1.11,-0.3l0.27,0.86l1.34,1.47l-0.39,2.01l0.3,1.01l4.01,2.75l0.17,0.93l2.63,2.31l0.6,1.44l2.08,1.4l-3.84,-0.21l-1.94,0.88l-1.23,-0.49l-2.67,1.2l-1.29,-0.18l-0.51,0.36l-0.6,1.22l-3.35,-0.65l-1.57,-0.91l-2.42,-0.83l-1.45,0.91l-0.97,1.27l-0.26,1.56l-3.22,-0.43l-1.49,1.33l-0.94,1.62Z",
              name: "Central African Rep.",
            },
            CD: {
              path: "M487.01,272.38l2.34,-0.14l1.35,1.84l1.34,0.45l0.86,-0.39l1.21,0.12l1.07,-0.41l0.54,0.89l2.04,1.54l-0.14,2.72l0.7,0.54l-1.38,1.13l-1.53,2.54l-0.17,2.05l-0.59,1.08l-0.02,1.72l-0.72,0.84l-0.66,3.01l0.63,1.32l-0.44,4.26l0.64,1.47l-0.37,1.22l0.86,1.8l1.53,1.41l0.3,1.26l0.44,0.5l-4.08,0.75l-0.92,1.81l0.51,1.34l-0.74,5.43l0.17,0.38l2.45,1.46l0.54,-0.1l0.12,1.62l-1.28,-0.01l-1.85,-2.35l-1.94,-0.45l-0.48,-1.13l-0.55,-0.2l-1.41,0.74l-1.71,-0.3l-1.01,-1.18l-2.49,-0.19l-0.44,-0.77l-1.98,-0.21l-2.88,0.36l0.11,-2.41l-0.85,-1.13l-0.16,-1.36l0.32,-1.73l-0.46,-0.89l-0.04,-1.49l-0.4,-0.39l-2.53,0.02l0.1,-0.41l-0.39,-0.49l-1.28,0.01l-0.43,0.45l-1.62,0.32l-0.83,1.79l-1.09,-0.28l-2.4,0.52l-1.37,-1.91l-1.3,-3.3l-0.38,-0.27l-7.39,-0.03l-2.46,0.42l0.5,-0.45l0.37,-1.47l0.66,-0.38l0.92,0.08l0.73,-0.82l0.87,0.02l0.31,0.68l1.4,0.36l3.59,-3.63l0.01,-2.23l1.02,-2.29l2.69,-2.39l0.43,-0.99l0.49,-1.96l0.17,-3.51l1.25,-2.95l0.36,-3.14l0.86,-1.13l1.1,-0.66l3.57,1.73l3.65,0.73l0.46,-0.21l0.8,-1.46l1.24,0.19l2.61,-1.17l0.81,0.44l1.04,-0.03l0.59,-0.66l0.7,-0.16l1.81,0.25Z",
              name: "Dem. Rep. Congo",
            },
            CZ: {
              path: "M458.46,144.88l1.22,1.01l1.47,0.23l0.13,0.93l1.36,0.68l0.54,-0.2l0.24,-0.55l1.15,0.25l0.53,1.09l1.68,0.18l0.6,0.84l-1.04,0.73l-0.96,1.28l-1.6,0.17l-0.55,0.56l-1.04,-0.46l-1.05,0.15l-2.12,-0.96l-1.05,0.34l-1.2,1.12l-1.56,-0.87l-2.57,-2.1l-0.53,-1.88l4.7,-2.52l0.71,0.26l0.9,-0.28Z",
              name: "Czech Rep.",
            },
            CY: {
              path: "M504.36,193.47l0.43,0.28l-1.28,0.57l-0.92,-0.28l-0.24,-0.46l2.01,-0.13Z",
              name: "Cyprus",
            },
            CR: {
              path: "M211.34,258.05l0.48,0.99l1.6,1.6l-0.54,0.45l0.29,1.42l-0.25,1.19l-1.09,-0.59l-0.05,-1.25l-2.46,-1.42l-0.28,-0.77l-0.66,-0.45l-0.45,-0.0l-0.11,1.04l-1.32,-0.95l0.31,-1.3l-0.36,-0.6l0.31,-0.27l1.42,0.58l1.29,-0.14l0.56,0.56l0.74,0.17l0.55,-0.27Z",
              name: "Costa Rica",
            },
            CU: {
              path: "M221.21,227.25l1.27,1.02l2.19,-0.28l4.43,3.33l2.08,0.43l-0.1,0.38l0.36,0.5l1.75,0.1l1.48,0.84l-3.11,0.51l-4.15,-0.03l0.77,-0.67l-0.04,-0.64l-1.2,-0.74l-1.49,-0.16l-0.7,-0.61l-0.56,-1.4l-0.4,-0.25l-1.34,0.1l-2.2,-0.66l-0.88,-0.58l-3.18,-0.4l-0.27,-0.16l0.58,-0.74l-0.36,-0.29l-2.72,-0.05l-1.7,1.29l-0.91,0.03l-0.61,0.69l-1.01,0.22l1.11,-1.29l1.01,-0.52l3.69,-1.01l3.98,0.21l2.21,0.84Z",
              name: "Cuba",
            },
            SZ: {
              path: "M500.35,351.36l0.5,2.04l-0.38,0.89l-1.05,0.21l-1.23,-1.2l-0.02,-0.64l0.83,-1.57l1.34,0.27Z",
              name: "Swaziland",
            },
            SY: {
              path: "M511.0,199.79l0.05,-1.33l0.54,-1.36l1.28,-0.99l0.13,-0.45l-0.41,-1.11l-1.14,-0.36l-0.19,-1.74l0.52,-1.0l1.29,-1.21l0.2,-1.18l0.59,0.23l2.62,-0.76l1.36,0.52l2.06,-0.01l2.95,-1.08l3.25,-0.26l-0.67,0.94l-1.28,0.66l-0.21,0.4l0.23,2.01l-0.88,3.19l-10.15,5.73l-2.15,-0.85Z",
              name: "Syria",
            },
            KG: {
              path: "M621.35,172.32l-3.87,1.69l-0.96,1.18l-3.04,0.34l-1.13,1.86l-2.36,-0.35l-1.99,0.63l-2.39,1.4l0.06,0.95l-0.4,0.37l-4.52,0.43l-3.02,-0.93l-2.37,0.17l0.11,-0.79l2.32,0.42l1.13,-0.88l1.99,0.2l3.21,-2.14l-0.03,-0.69l-2.97,-1.57l-1.94,0.65l-1.22,-0.74l1.71,-1.58l-0.12,-0.67l-0.36,-0.15l0.32,-0.77l1.36,-0.35l4.02,1.02l0.49,-0.3l0.35,-1.59l1.09,-0.48l3.42,1.22l1.11,-0.31l7.64,0.39l1.16,1.0l1.23,0.39Z",
              name: "Kyrgyzstan",
            },
            KE: {
              path: "M506.26,284.69l1.87,-2.56l0.93,-2.15l-1.38,-4.08l-1.06,-1.6l2.82,-2.75l0.79,0.26l0.12,1.41l0.86,0.83l1.9,0.11l3.28,2.13l3.57,0.44l1.05,-1.12l1.96,-0.9l0.82,0.68l1.16,0.09l-1.78,2.45l0.03,9.12l1.3,1.94l-1.37,0.78l-0.67,1.03l-1.08,0.46l-0.34,1.67l-0.81,1.07l-0.45,1.55l-0.68,0.56l-3.2,-2.23l-0.35,-1.58l-8.86,-4.98l0.14,-1.6l-0.57,-1.04Z",
              name: "Kenya",
            },
            SS: {
              path: "M481.71,263.34l1.07,-0.72l1.2,-3.18l1.36,-0.26l1.61,1.99l0.87,0.34l1.1,-0.41l1.5,0.07l0.57,0.53l2.49,0.0l0.44,-0.63l1.07,-0.4l0.45,-0.84l0.59,-0.33l1.9,1.33l1.6,-0.2l2.83,-3.33l-0.32,-2.21l1.59,-0.52l-0.24,1.6l0.3,1.83l1.35,1.18l0.2,1.87l0.35,0.41l0.02,1.53l-0.23,0.47l-1.42,0.25l-0.85,1.44l0.3,0.6l1.4,0.16l1.11,1.08l0.59,1.13l1.03,0.53l1.28,2.36l-4.41,3.98l-1.74,0.01l-1.89,0.55l-1.47,-0.52l-1.15,0.57l-2.96,-2.62l-1.3,0.49l-1.06,-0.15l-0.79,0.39l-0.82,-0.22l-1.8,-2.7l-1.91,-1.1l-0.66,-1.5l-2.62,-2.32l-0.18,-0.94l-2.37,-1.6Z",
              name: "S. Sudan",
            },
            SR: {
              path: "M283.12,270.19l2.1,0.53l-1.08,1.95l0.2,1.72l0.93,1.49l-0.59,2.03l-0.43,0.71l-1.12,-0.42l-1.32,0.22l-0.93,-0.2l-0.46,0.26l-0.25,0.73l0.33,0.7l-0.89,-0.13l-1.39,-1.97l-0.31,-1.34l-0.97,-0.31l-0.89,-1.47l0.35,-1.61l1.45,-0.82l0.33,-1.87l2.61,0.44l0.57,-0.47l1.75,-0.16Z",
              name: "Suriname",
            },
            KH: {
              path: "M689.52,249.39l0.49,1.45l-0.28,2.74l-4.0,1.86l-0.16,0.6l0.68,0.95l-2.06,0.17l-2.05,0.97l-1.82,-0.32l-2.12,-3.7l-0.55,-2.85l1.4,-1.85l3.02,-0.45l2.23,0.35l2.01,0.98l0.51,-0.14l0.95,-1.48l1.74,0.74Z",
              name: "Cambodia",
            },
            SV: {
              path: "M195.8,250.13l1.4,-1.19l2.24,1.45l0.98,-0.27l0.44,0.2l-0.27,1.05l-1.14,-0.03l-3.64,-1.21Z",
              name: "El Salvador",
            },
            SK: {
              path: "M476.82,151.17l-1.14,1.9l-2.73,-0.92l-0.82,0.2l-0.74,0.8l-3.46,0.73l-0.47,0.69l-1.76,0.33l-1.88,-1.0l-0.18,-0.81l0.38,-0.75l1.87,-0.32l1.74,-1.89l0.83,0.16l0.79,-0.34l1.51,1.04l1.34,-0.63l1.25,0.3l1.65,-0.42l1.81,0.95Z",
              name: "Slovakia",
            },
            KR: {
              path: "M737.51,185.84l0.98,-0.1l0.87,-1.17l2.69,-0.32l0.33,-0.29l1.76,2.79l0.58,1.76l0.02,3.12l-0.8,1.32l-2.21,0.55l-1.93,1.13l-1.8,0.19l-0.2,-1.1l0.43,-2.28l-0.95,-2.56l1.43,-0.37l0.23,-0.62l-1.43,-2.06Z",
              name: "Korea",
            },
            SI: {
              path: "M456.18,162.07l-0.51,-1.32l0.18,-1.05l1.69,0.2l1.42,-0.71l2.09,-0.07l0.62,-0.51l0.21,0.47l-1.61,0.67l-0.44,1.34l-0.66,0.24l-0.26,0.82l-1.22,-0.49l-0.84,0.46l-0.69,-0.04Z",
              name: "Slovenia",
            },
            KP: {
              path: "M736.77,185.16l-0.92,-0.42l-0.88,0.62l-1.21,-0.88l0.96,-1.15l0.59,-2.59l-0.46,-0.74l-2.09,-0.77l1.64,-1.52l2.72,-1.58l1.58,-1.91l1.11,0.78l2.17,0.11l0.41,-0.5l-0.3,-1.22l3.52,-1.18l0.94,-1.4l0.98,1.08l-2.19,2.18l0.01,2.14l-1.06,0.54l-1.41,1.4l-1.7,0.52l-1.25,1.09l-0.14,1.98l0.94,0.45l1.15,1.04l-0.13,0.26l-2.6,0.29l-1.13,1.29l-1.22,0.08Z",
              name: "Dem. Rep. Korea",
            },
            SO: {
              path: "M525.13,288.48l-1.13,-1.57l-0.03,-8.86l2.66,-3.38l1.67,-0.13l2.13,-1.69l3.41,-0.23l7.08,-7.55l2.91,-3.69l0.08,-4.82l2.98,-0.67l1.24,-0.86l0.45,-0.0l-0.2,3.0l-1.21,3.62l-2.73,5.97l-2.13,3.65l-5.03,6.16l-8.56,6.4l-2.78,3.08l-0.8,1.56Z",
              name: "Somalia",
            },
            SN: {
              path: "M390.09,248.21l0.12,1.55l0.49,1.46l0.96,0.82l0.05,1.28l-1.26,-0.19l-0.75,0.33l-1.84,-0.61l-5.84,-0.13l-2.54,0.51l-0.22,-1.03l1.77,0.04l2.01,-0.91l1.03,0.48l1.09,0.04l1.29,-0.62l0.14,-0.58l-0.51,-0.74l-1.81,0.25l-1.13,-0.63l-0.79,0.04l-0.72,0.61l-2.31,0.06l-0.92,-1.77l-0.81,-0.64l0.64,-0.35l2.46,-3.74l1.04,0.19l1.38,-0.56l1.19,-0.02l2.72,1.37l3.03,3.48Z",
              name: "Senegal",
            },
            SL: {
              path: "M394.46,264.11l-1.73,1.98l-0.58,1.33l-2.07,-1.06l-1.22,-1.26l-0.65,-2.39l1.16,-0.96l0.67,-1.17l1.21,-0.52l1.66,0.0l1.03,1.64l0.52,2.41Z",
              name: "Sierra Leone",
            },
            SB: {
              path: "M826.69,311.6l-0.61,0.09l-0.2,-0.33l0.37,0.15l0.44,0.09ZM824.18,307.38l-0.26,-0.3l-0.31,-0.91l0.03,0.0l0.54,1.21ZM823.04,309.33l-1.66,-0.22l-0.2,-0.52l1.16,0.28l0.69,0.46ZM819.28,304.68l1.14,0.65l0.02,0.03l-0.81,-0.44l-0.35,-0.23Z",
              name: "Solomon Is.",
            },
            SA: {
              path: "M537.53,210.34l2.0,0.24l0.9,1.32l1.49,-0.06l0.87,2.08l1.29,0.76l0.51,0.99l1.56,1.03l-0.1,1.9l0.32,0.9l1.58,2.47l0.76,0.53l0.7,-0.04l1.68,4.23l7.53,1.33l0.51,-0.29l0.77,1.25l-1.55,4.87l-7.29,2.52l-7.3,1.03l-2.34,1.17l-1.88,2.74l-0.76,0.28l-0.82,-0.78l-0.91,0.12l-2.88,-0.51l-3.51,0.25l-0.86,-0.56l-0.57,0.15l-0.66,1.27l0.16,1.11l-0.43,0.32l-0.93,-1.4l-0.33,-1.16l-1.23,-0.88l-1.27,-2.06l-0.78,-2.22l-1.73,-1.79l-1.14,-0.48l-1.54,-2.31l-0.21,-3.41l-1.44,-2.93l-1.27,-1.16l-1.33,-0.57l-1.31,-3.37l-0.77,-0.67l-0.97,-1.97l-2.8,-4.03l-1.06,-0.17l0.37,-1.96l0.2,-0.72l2.74,0.3l1.08,-0.84l0.6,-0.94l1.74,-0.35l0.65,-1.03l0.71,-0.4l0.1,-0.62l-2.06,-2.28l4.39,-1.22l0.48,-0.37l2.77,0.69l3.66,1.9l7.03,5.5l4.87,0.3Z",
              name: "Saudi Arabia",
            },
            SE: {
              path: "M480.22,89.3l-4.03,1.17l-2.43,2.86l0.26,2.57l-8.77,6.64l-1.78,5.79l1.78,2.68l2.22,1.96l-2.07,3.77l-2.72,1.13l-0.95,6.04l-1.29,3.01l-2.74,-0.31l-0.4,0.22l-1.31,2.59l-2.34,0.13l-0.75,-3.09l-2.08,-4.03l-1.83,-4.96l1.0,-1.93l2.14,-2.7l0.83,-4.45l-1.6,-2.17l-0.15,-4.94l1.48,-3.39l2.58,-0.15l0.87,-1.59l-0.78,-1.57l3.76,-5.59l4.04,-7.48l2.17,0.01l0.39,-0.29l0.57,-2.07l4.37,0.64l0.46,-0.34l0.33,-2.56l1.1,-0.13l6.94,4.87l0.06,6.32l0.66,1.36Z",
              name: "Sweden",
            },
            SD: {
              path: "M505.98,259.4l-0.34,-0.77l-1.17,-0.9l-0.26,-1.61l0.29,-1.81l-0.34,-0.46l-1.16,-0.17l-0.54,0.59l-1.23,0.11l-0.28,0.65l0.53,0.65l0.17,1.22l-2.44,3.0l-0.96,0.19l-2.39,-1.4l-0.95,0.52l-0.38,0.78l-1.11,0.41l-0.29,0.5l-1.94,0.0l-0.54,-0.52l-1.81,-0.09l-0.95,0.4l-2.45,-2.35l-2.07,0.54l-0.73,1.26l-0.6,2.1l-1.25,0.58l-0.75,-0.62l0.27,-2.65l-1.48,-1.78l-0.22,-1.48l-0.92,-0.96l-0.02,-1.29l-0.57,-1.16l-0.68,-0.16l0.69,-1.29l-0.18,-1.14l0.65,-0.62l0.03,-0.55l-0.36,-0.41l1.55,-2.97l1.91,0.16l0.43,-0.4l-0.1,-10.94l2.49,-0.01l0.4,-0.4l-0.0,-4.82l29.02,0.0l0.64,2.04l-0.49,0.66l0.36,2.69l0.93,3.16l2.12,1.55l-0.89,1.04l-1.72,0.39l-0.98,0.9l-1.43,5.65l0.24,1.15l-0.38,2.06l-0.96,2.38l-1.53,1.31l-1.32,2.91l-1.22,0.86l-0.37,1.34Z",
              name: "Sudan",
            },
            DO: {
              path: "M241.8,239.2l0.05,-0.65l-0.46,-0.73l0.42,-0.44l0.19,-1.0l-0.09,-1.53l1.66,0.01l1.99,0.63l0.33,0.67l1.28,0.19l0.33,0.76l1.0,0.08l0.8,0.62l-0.45,0.51l-1.13,-0.47l-1.88,-0.01l-1.27,0.59l-0.75,-0.55l-1.01,0.54l-0.79,1.4l-0.23,-0.61Z",
              name: "Dominican Rep.",
            },
            DJ: {
              path: "M528.43,256.18l-0.45,0.66l-0.58,-0.25l-1.51,0.13l-0.18,-1.01l1.45,-1.95l0.83,0.17l0.77,-0.44l0.2,1.0l-1.2,0.51l-0.06,0.7l0.73,0.47Z",
              name: "Djibouti",
            },
            DK: {
              path: "M452.28,129.07l-1.19,2.24l-2.13,-1.6l-0.23,-0.95l2.98,-0.95l0.57,1.26ZM447.74,126.31l-0.26,0.57l-0.88,-0.07l-1.8,2.53l0.48,1.69l-1.09,0.36l-1.61,-0.39l-0.89,-1.69l-0.07,-3.43l0.96,-1.73l2.02,-0.2l1.09,-1.07l1.33,-0.67l-0.05,1.06l-0.73,1.41l0.3,1.0l1.2,0.64Z",
              name: "Denmark",
            },
            DE: {
              path: "M453.14,155.55l-0.55,-0.36l-1.2,-0.1l-1.87,0.57l-2.13,-0.13l-0.56,0.63l-0.86,-0.6l-0.96,0.09l-2.57,-0.93l-0.85,0.67l-1.47,-0.02l0.24,-1.75l1.23,-2.14l-0.28,-0.59l-3.52,-0.58l-0.92,-0.66l0.12,-1.2l-0.48,-0.88l0.27,-2.17l-0.37,-3.03l1.41,-0.22l0.63,-1.26l0.66,-3.19l-0.41,-1.18l0.26,-0.39l1.66,-0.15l0.33,0.54l0.62,0.07l1.7,-1.69l-0.54,-3.02l1.37,0.33l1.31,-0.37l0.31,1.18l2.25,0.71l-0.02,0.92l0.5,0.4l2.55,-0.65l1.34,-0.87l2.57,1.24l1.06,0.98l0.48,1.44l-0.57,0.74l-0.0,0.48l0.87,1.15l0.57,1.64l-0.14,1.29l0.82,1.7l-1.5,-0.07l-0.56,0.57l-4.47,2.15l-0.22,0.54l0.68,2.26l2.58,2.16l-0.66,1.11l-0.79,0.36l-0.23,0.43l0.32,1.87Z",
              name: "Germany",
            },
            YE: {
              path: "M528.27,246.72l0.26,-0.42l-0.22,-1.01l0.19,-1.5l0.92,-0.69l-0.07,-1.35l0.39,-0.75l1.01,0.47l3.34,-0.27l3.76,0.41l0.95,0.81l1.36,-0.58l1.74,-2.62l2.18,-1.09l6.86,-0.94l2.48,5.41l-1.64,0.76l-0.56,1.9l-6.23,2.16l-2.29,1.8l-1.93,0.05l-1.41,1.02l-4.24,0.74l-1.72,1.49l-3.28,0.19l-0.52,-1.18l0.02,-1.51l-1.34,-3.29Z",
              name: "Yemen",
            },
            AT: {
              path: "M462.89,152.8l0.04,2.25l-1.07,0.0l-0.33,0.63l0.36,0.51l-1.04,2.13l-2.02,0.07l-1.33,0.7l-5.29,-0.99l-0.47,-0.93l-0.44,-0.21l-2.47,0.55l-0.42,0.51l-3.18,-0.81l0.43,-0.91l1.12,0.78l0.6,-0.17l0.25,-0.58l1.93,0.12l1.86,-0.56l1.0,0.08l0.68,0.57l0.62,-0.15l0.26,-0.77l-0.3,-1.78l0.8,-0.44l0.68,-1.15l1.52,0.85l0.47,-0.06l1.34,-1.25l0.64,-0.17l1.81,0.92l1.28,-0.11l0.7,0.37Z",
              name: "Austria",
            },
            DZ: {
              path: "M441.46,188.44l-0.32,1.07l0.39,2.64l-0.54,2.16l-1.58,1.82l0.37,2.39l1.91,1.55l0.18,0.8l1.42,1.03l1.84,7.23l0.12,1.16l-0.57,5.0l0.2,1.51l-0.87,0.99l-0.02,0.51l1.41,1.86l0.14,1.2l0.89,1.48l0.5,0.16l0.98,-0.41l1.73,1.08l0.82,1.23l-8.22,4.81l-7.23,5.11l-3.43,1.13l-2.3,0.21l-0.28,-1.59l-2.56,-1.09l-0.67,-1.25l-26.12,-17.86l0.01,-3.47l3.77,-1.88l2.44,-0.41l2.12,-0.75l1.08,-1.42l2.81,-1.05l0.35,-2.08l1.33,-0.29l1.04,-0.94l3.47,-0.69l0.46,-1.08l-0.1,-0.45l-0.58,-0.52l-0.82,-2.81l-0.19,-1.83l-0.78,-1.49l2.03,-1.31l2.63,-0.48l1.7,-1.22l2.31,-0.84l8.24,-0.73l1.49,0.38l2.28,-1.1l2.46,-0.02l0.92,0.6l1.35,-0.05Z",
              name: "Algeria",
            },
            US: {
              path: "M892.72,99.2l1.31,0.53l1.41,-0.37l1.89,0.98l1.89,0.42l-1.32,0.58l-2.9,-1.53l-2.08,0.22l-0.26,-0.15l0.07,-0.67ZM183.22,150.47l0.37,1.47l1.12,0.85l4.23,0.7l2.39,0.98l2.17,-0.38l1.85,0.5l-1.55,0.65l-3.49,2.61l-0.16,0.77l0.5,0.39l2.33,-0.61l1.77,1.02l5.15,-2.4l-0.31,0.65l0.25,0.56l1.36,0.38l1.71,1.16l4.7,-0.88l0.67,0.85l1.31,0.21l0.58,0.58l-1.34,0.17l-2.18,-0.32l-3.6,0.89l-2.71,3.25l0.35,0.9l0.59,-0.0l0.55,-0.6l-1.36,4.65l0.29,3.09l0.67,1.58l0.61,0.45l1.77,-0.44l1.6,-1.96l0.14,-2.21l-0.82,-1.96l0.11,-1.13l1.19,-2.37l0.44,-0.33l0.48,0.75l0.4,-0.29l0.4,-1.37l0.6,-0.47l0.24,-0.8l1.69,0.49l1.65,1.08l-0.03,2.37l-1.27,1.13l-0.0,1.13l0.87,0.36l1.66,-1.29l0.5,0.17l0.5,2.6l-2.49,3.75l0.17,0.61l1.54,0.62l1.48,0.17l1.92,-0.44l4.72,-2.15l2.16,-1.8l-0.05,-1.24l0.75,-0.22l3.92,0.36l2.12,-1.05l0.21,-0.4l-0.28,-1.48l3.27,-2.4l8.32,-0.02l0.56,-0.82l1.9,-0.77l0.93,-1.51l0.74,-2.37l1.58,-1.98l0.92,0.62l1.47,-0.47l0.8,0.66l-0.0,4.09l1.96,2.6l-2.34,1.31l-5.37,2.09l-1.83,2.72l0.02,1.79l0.83,1.59l0.54,0.23l-6.19,0.94l-2.2,0.89l-0.23,0.48l0.45,0.29l2.99,-0.46l-2.19,0.56l-1.13,0.0l-0.15,-0.32l-0.48,0.08l-0.76,0.82l0.22,0.67l0.32,0.06l-0.41,1.62l-1.27,1.58l-1.48,-1.07l-0.49,-0.04l-0.16,0.46l0.52,1.58l0.61,0.59l0.03,0.79l-0.95,1.38l-1.21,-1.22l-0.27,-2.27l-0.35,-0.35l-0.42,0.25l-0.48,1.27l0.33,1.41l-0.97,-0.27l-0.48,0.24l0.18,0.5l1.52,0.83l0.1,2.52l0.79,0.51l0.52,3.42l-1.42,1.88l-2.47,0.8l-1.71,1.66l-1.31,0.25l-1.27,1.03l-0.43,0.99l-2.69,1.78l-2.64,3.03l-0.45,2.12l0.45,2.08l0.85,2.38l1.09,1.9l0.04,1.2l1.16,3.06l-0.18,2.69l-0.55,1.43l-0.47,0.21l-0.89,-0.23l-0.49,-1.18l-0.87,-0.56l-2.75,-5.16l0.48,-1.68l-0.72,-1.78l-2.01,-2.38l-1.12,-0.53l-2.72,1.18l-1.47,-1.35l-1.57,-0.68l-2.99,0.31l-2.17,-0.3l-2.0,0.19l-1.15,0.46l-0.19,0.58l0.39,0.63l0.14,1.34l-0.84,-0.2l-0.84,0.46l-1.58,-0.07l-2.08,-1.44l-2.09,0.33l-1.91,-0.62l-3.73,0.84l-2.39,2.07l-2.54,1.22l-1.45,1.41l-0.61,1.38l0.34,3.71l-0.29,0.02l-3.5,-1.33l-1.25,-3.11l-1.44,-1.5l-2.24,-3.56l-1.76,-1.09l-2.27,-0.01l-1.71,2.07l-1.76,-0.69l-1.16,-0.74l-1.52,-2.98l-3.93,-3.16l-4.34,-0.0l-0.4,0.4l-0.0,0.74l-6.5,0.02l-9.02,-3.14l-0.34,-0.71l-5.7,0.49l-0.43,-1.29l-1.62,-1.61l-1.14,-0.38l-0.55,-0.88l-1.28,-0.13l-1.01,-0.77l-2.22,-0.27l-0.43,-0.3l-0.36,-1.58l-2.4,-2.83l-2.01,-3.85l-0.06,-0.9l-2.92,-3.26l-0.33,-2.29l-1.3,-1.66l0.52,-2.37l-0.09,-2.57l-0.78,-2.3l0.95,-2.82l0.61,-5.68l-0.47,-4.27l-1.46,-4.08l3.19,0.79l1.26,2.83l0.69,0.08l0.69,-1.14l-1.1,-4.79l68.76,-0.0l0.4,-0.4l0.14,-0.86ZM32.44,67.52l1.73,1.97l0.55,0.05l0.99,-0.79l3.65,0.24l-0.09,0.62l0.32,0.45l3.83,0.77l2.61,-0.43l5.19,1.4l4.84,0.43l1.89,0.57l3.42,-0.7l6.14,1.87l-0.03,38.06l0.38,0.4l2.39,0.11l2.31,0.98l3.9,3.99l0.55,0.04l2.4,-2.03l2.16,-1.04l1.2,1.71l3.95,3.14l4.09,6.63l4.2,2.29l0.06,1.83l-1.02,1.23l-1.16,-1.08l-2.04,-1.03l-0.67,-2.89l-3.28,-3.03l-1.65,-3.57l-6.35,-0.32l-2.82,-1.01l-5.26,-3.85l-6.77,-2.04l-3.53,0.3l-4.81,-1.69l-3.25,-1.63l-2.78,0.8l-0.28,0.46l0.44,2.21l-3.91,0.96l-2.26,1.27l-2.3,0.65l-0.27,-1.65l1.05,-3.42l2.49,-1.09l0.16,-0.6l-0.69,-0.96l-0.55,-0.1l-3.19,2.12l-1.78,2.56l-3.55,2.61l-0.04,0.61l1.56,1.52l-2.07,2.29l-5.11,2.57l-0.77,1.66l-3.76,1.77l-0.92,1.73l-2.69,1.38l-1.81,-0.22l-6.95,3.32l-3.97,0.91l4.85,-2.5l2.59,-1.86l3.26,-0.52l1.19,-1.4l3.42,-2.1l2.59,-2.27l0.42,-2.68l1.23,-2.1l-0.04,-0.46l-0.45,-0.11l-2.68,1.03l-0.63,-0.49l-0.53,0.03l-1.05,1.04l-1.36,-1.54l-0.66,0.08l-0.32,0.62l-0.58,-1.14l-0.56,-0.16l-2.41,1.42l-1.07,-0.0l-0.17,-1.75l0.3,-1.71l-1.61,-1.33l-3.41,0.59l-1.96,-1.63l-1.57,-0.84l-0.15,-2.21l-1.7,-1.43l0.82,-1.88l1.99,-2.12l0.88,-1.92l1.71,-0.24l2.04,0.51l1.87,-1.77l1.91,0.25l1.91,-1.23l0.17,-0.43l-0.47,-1.82l-1.07,-0.7l1.39,-1.17l0.12,-0.45l-0.39,-0.26l-1.65,0.07l-2.66,0.88l-0.75,0.78l-1.92,-0.8l-3.46,0.44l-3.44,-0.91l-1.06,-1.61l-2.65,-1.99l2.91,-1.43l5.5,-2.0l1.52,0.0l-0.26,1.62l0.41,0.46l5.29,-0.16l0.3,-0.65l-2.03,-2.59l-3.14,-1.68l-1.79,-2.12l-2.4,-1.83l-3.09,-1.24l1.04,-1.69l4.23,-0.14l3.36,-2.07l0.73,-2.27l2.39,-1.99l2.42,-0.52l4.65,-1.97l2.46,0.23l3.71,-2.35l3.5,0.89ZM37.6,123.41l-2.25,1.23l-0.95,-0.69l-0.29,-1.24l3.21,-1.63l1.42,0.21l0.67,0.7l-1.8,1.42ZM31.06,234.03l0.98,0.47l0.74,0.87l-1.77,1.07l-0.44,-1.53l0.49,-0.89ZM29.34,232.07l0.18,0.05l0.08,0.05l-0.16,0.03l-0.11,-0.14ZM25.16,230.17l0.05,-0.03l0.18,0.22l-0.13,-0.01l-0.1,-0.18ZM5.89,113.26l-1.08,0.41l-2.21,-1.12l1.53,-0.4l1.62,0.28l0.14,0.83Z",
              name: "United States",
            },
            LV: {
              path: "M489.16,122.85l0.96,0.66l0.22,1.65l0.68,1.76l-3.65,1.7l-2.23,-1.58l-1.29,-0.26l-0.68,-0.77l-2.42,0.34l-4.16,-0.23l-2.47,0.9l0.06,-1.98l1.13,-2.06l1.95,-1.02l2.12,2.58l2.01,-0.07l0.38,-0.33l0.44,-2.52l1.76,-0.53l3.06,1.7l2.15,0.07Z",
              name: "Latvia",
            },
            UY: {
              path: "M286.85,372.74l-0.92,1.5l-2.59,1.44l-1.69,-0.52l-1.42,0.26l-2.39,-1.19l-1.52,0.08l-1.27,-1.3l0.16,-1.5l0.56,-0.79l-0.02,-2.73l1.21,-4.74l1.19,-0.21l2.37,2.0l1.08,0.03l4.36,3.17l1.22,1.6l-0.96,1.5l0.61,1.4Z",
              name: "Uruguay",
            },
            LB: {
              path: "M510.37,198.01l-0.88,0.51l1.82,-3.54l0.62,0.08l0.22,0.61l-1.13,0.88l-0.65,1.47Z",
              name: "Lebanon",
            },
            LA: {
              path: "M689.54,248.53l-1.76,-0.74l-0.49,0.15l-0.94,1.46l-1.32,-0.64l0.62,-0.98l0.11,-2.17l-2.04,-2.42l-0.25,-2.65l-1.9,-2.1l-2.15,-0.31l-0.78,0.91l-1.12,0.06l-1.05,-0.4l-2.06,1.2l-0.04,-1.59l0.61,-2.68l-0.36,-0.49l-1.35,-0.1l-0.11,-1.23l-0.96,-0.88l1.96,-1.89l0.39,0.36l1.33,0.07l0.42,-0.45l-0.34,-2.66l0.7,-0.21l1.28,1.81l1.11,2.35l0.36,0.23l2.82,0.02l0.71,1.67l-1.39,0.65l-0.72,0.93l0.13,0.6l2.91,1.51l3.6,5.25l1.88,1.78l0.56,1.62l-0.35,1.96Z",
              name: "Lao PDR",
            },
            TW: {
              path: "M724.01,226.68l-0.74,1.48l-0.9,-1.52l-0.25,-1.74l1.38,-2.44l1.73,-1.74l0.64,0.44l-1.85,5.52Z",
              name: "Taiwan",
            },
            TT: {
              path: "M266.64,259.32l0.28,-1.16l1.13,-0.22l-0.06,1.2l-1.35,0.18Z",
              name: "Trinidad and Tobago",
            },
            TR: {
              path: "M513.21,175.47l3.64,1.17l3.05,-0.44l2.1,0.26l3.11,-1.56l2.46,-0.13l2.19,1.33l0.33,0.82l-0.22,1.33l0.25,0.44l2.28,1.13l-1.17,0.57l-0.21,0.45l0.75,3.2l-0.41,1.16l1.13,1.92l-0.55,0.22l-0.9,-0.67l-2.91,-0.37l-1.24,0.46l-4.23,0.41l-2.81,1.05l-1.91,0.01l-1.52,-0.53l-2.58,0.75l-0.66,-0.45l-0.62,0.3l-0.12,1.45l-0.89,0.84l-0.47,-0.67l0.79,-1.3l-0.41,-0.2l-1.43,0.23l-2.0,-0.63l-2.02,1.65l-3.51,0.3l-2.13,-1.53l-2.7,-0.1l-0.86,1.24l-1.38,0.27l-2.29,-1.44l-2.71,-0.01l-1.37,-2.65l-1.68,-1.52l1.07,-1.99l-0.09,-0.49l-1.27,-1.12l2.37,-2.41l3.7,-0.11l1.28,-2.24l4.49,0.37l3.21,-1.97l2.81,-0.82l3.99,-0.06l4.29,2.07ZM488.79,176.72l-1.72,1.31l-0.5,-0.88l1.37,-2.57l-0.7,-0.85l1.7,-0.63l1.8,0.34l0.46,1.17l1.76,0.78l-2.87,0.32l-1.3,1.01Z",
              name: "Turkey",
            },
            LK: {
              path: "M624.16,268.99l-1.82,0.48l-0.99,-1.67l-0.42,-3.46l0.95,-3.43l1.21,0.98l2.26,4.19l-0.34,2.33l-0.85,0.58Z",
              name: "Sri Lanka",
            },
            TN: {
              path: "M448.1,188.24l-1.0,1.27l-0.02,1.32l0.84,0.88l-0.28,2.09l-1.53,1.32l-0.12,0.42l0.48,1.54l1.42,0.32l0.53,1.11l0.9,0.52l-0.11,1.67l-3.54,2.64l-0.1,2.38l-0.58,0.3l-0.96,-4.45l-1.54,-1.25l-0.16,-0.78l-1.92,-1.56l-0.18,-1.76l1.51,-1.62l0.59,-2.34l-0.38,-2.78l0.42,-1.21l2.45,-1.05l1.29,0.26l-0.06,1.11l0.58,0.38l1.47,-0.73Z",
              name: "Tunisia",
            },
            TL: {
              path: "M734.55,307.93l-0.1,-0.97l4.5,-0.86l-2.82,1.28l-1.59,0.55Z",
              name: "Timor-Leste",
            },
            TM: {
              path: "M553.03,173.76l-0.04,0.34l-0.09,-0.22l0.13,-0.12ZM555.87,172.66l0.45,-0.1l1.48,0.74l2.06,2.43l4.07,-0.18l0.38,-0.51l-0.32,-1.19l1.92,-0.94l1.91,-1.59l2.94,1.39l0.43,2.47l1.19,0.67l2.58,-0.13l0.62,0.4l1.32,3.12l4.54,3.44l2.67,1.45l3.06,1.14l-0.04,1.05l-1.33,-0.75l-0.59,0.19l-0.32,0.84l-2.2,0.81l-0.46,2.13l-1.21,0.74l-1.91,0.42l-0.73,1.33l-1.56,0.31l-2.22,-0.94l-0.2,-2.17l-0.38,-0.36l-1.73,-0.09l-2.76,-2.46l-2.14,-0.4l-2.84,-1.48l-1.78,-0.27l-1.24,0.53l-1.57,-0.08l-2.0,1.69l-1.7,0.43l-0.36,-1.58l0.36,-2.98l-0.22,-0.4l-1.65,-0.84l0.54,-1.69l-0.34,-0.52l-1.22,-0.13l0.36,-1.64l2.22,0.59l2.2,-0.95l0.12,-0.65l-1.77,-1.74l-0.66,-1.57Z",
              name: "Turkmenistan",
            },
            TJ: {
              path: "M597.75,178.82l-2.54,-0.44l-0.47,0.34l-0.24,1.7l0.43,0.45l2.64,-0.22l3.18,0.95l4.39,-0.41l0.56,2.37l0.52,0.29l0.67,-0.24l1.11,0.49l0.21,2.13l-3.76,-0.21l-1.8,1.32l-1.76,0.74l-0.61,-0.58l0.21,-2.23l-0.64,-0.49l-0.07,-0.93l-1.36,-0.66l-0.45,0.07l-1.08,1.01l-0.55,1.48l-1.31,-0.05l-0.95,1.16l-0.9,-0.35l-1.86,0.74l1.26,-2.83l-0.54,-2.17l-1.67,-0.82l0.33,-0.66l2.18,-0.04l1.19,-1.63l0.76,-1.79l2.43,-0.5l-0.26,1.0l0.73,1.05Z",
              name: "Tajikistan",
            },
            LS: {
              path: "M491.06,363.48l-0.49,0.15l-1.49,-1.67l1.1,-1.43l2.19,-1.44l1.51,1.27l-0.98,1.82l-1.23,0.38l-0.62,0.93Z",
              name: "Lesotho",
            },
            TH: {
              path: "M670.27,255.86l-1.41,3.87l0.15,2.0l0.38,0.36l1.38,0.07l0.9,2.04l0.55,2.34l1.4,1.44l1.61,0.38l0.96,0.97l-0.5,0.64l-1.1,0.2l-0.34,-1.18l-2.04,-1.1l-0.63,0.23l-0.63,-0.62l-0.48,-1.3l-2.56,-2.63l-0.73,0.41l0.95,-3.89l2.16,-4.22ZM670.67,254.77l-0.92,-2.18l-0.26,-2.61l-2.14,-3.06l0.71,-0.49l0.89,-2.59l-3.61,-5.45l0.87,-0.51l1.05,-2.58l1.74,-0.18l2.6,-1.59l0.76,0.56l0.13,1.39l0.37,0.36l1.23,0.09l-0.51,2.28l0.05,2.42l0.6,0.34l2.43,-1.42l0.77,0.39l1.47,-0.07l0.71,-0.88l1.48,0.14l1.71,1.88l0.25,2.65l1.92,2.11l-0.1,1.89l-0.61,0.86l-2.22,-0.33l-3.5,0.64l-1.6,2.12l0.36,2.58l-1.51,-0.79l-1.84,-0.01l0.28,-1.52l-0.4,-0.47l-2.21,0.01l-0.4,0.37l-0.19,2.74l-0.34,0.93Z",
              name: "Thailand",
            },
            TF: {
              path: "M596.68,420.38l-3.2,0.18l-0.05,-1.26l0.39,-1.41l1.3,0.78l2.08,0.35l-0.52,1.36Z",
              name: "Fr. S. Antarctic Lands",
            },
            TG: {
              path: "M422.7,257.63l-0.09,1.23l1.53,1.52l0.08,1.09l0.5,0.65l-0.11,5.62l0.49,1.47l-1.31,0.35l-1.02,-2.13l-0.18,-1.12l0.53,-2.19l-0.63,-1.16l-0.22,-3.68l-1.01,-1.4l0.07,-0.28l1.37,0.03Z",
              name: "Togo",
            },
            TD: {
              path: "M480.25,235.49l0.12,9.57l-2.1,0.05l-1.14,1.89l-0.69,1.63l0.34,0.73l-0.66,0.91l0.24,0.89l-0.86,1.95l0.45,0.5l0.6,-0.1l0.34,0.64l0.03,1.38l0.9,1.04l-1.45,0.43l-1.27,1.03l-1.83,2.76l-2.16,1.07l-2.31,-0.15l-0.86,0.25l-0.26,0.49l0.17,0.61l-2.11,1.68l-2.85,0.87l-1.09,-0.57l-0.73,0.66l-1.12,0.1l-1.1,-3.12l-1.25,-0.64l-1.22,-1.22l0.29,-0.64l3.01,0.04l0.35,-0.6l-1.3,-2.2l-0.08,-3.31l-0.97,-1.66l0.22,-1.04l-0.38,-0.48l-1.22,-0.04l0.0,-1.25l-0.98,-1.07l0.96,-3.01l3.25,-2.65l0.13,-3.33l0.95,-5.18l0.52,-1.07l-0.1,-0.48l-0.91,-0.78l-0.2,-0.96l-0.8,-0.58l-0.55,-3.65l2.1,-1.2l19.57,9.83Z",
              name: "Chad",
            },
            LY: {
              path: "M483.48,203.15l-0.75,1.1l0.29,1.39l-0.6,1.83l0.73,2.14l0.0,24.12l-2.48,0.01l-0.41,0.85l-19.41,-9.76l-4.41,2.28l-1.37,-1.33l-3.82,-1.1l-1.14,-1.65l-1.98,-1.23l-1.22,0.32l-0.66,-1.11l-0.17,-1.26l-1.28,-1.69l0.87,-1.19l-0.07,-4.34l0.43,-2.27l-0.86,-3.45l1.13,-0.76l0.22,-1.16l-0.2,-1.03l3.48,-2.61l0.29,-1.94l2.45,0.8l1.18,-0.21l1.98,0.44l3.15,1.18l1.37,2.54l5.72,1.67l2.64,1.35l1.61,-0.72l1.29,-1.34l-0.44,-2.34l0.66,-1.13l1.67,-1.21l1.57,-0.35l3.14,0.53l1.08,1.28l3.99,0.78l0.36,0.54Z",
              name: "Libya",
            },
            AE: {
              path: "M550.76,223.97l1.88,-0.4l3.84,0.02l4.78,-4.75l0.19,0.36l0.26,1.58l-0.81,0.01l-0.39,0.35l-0.08,2.04l-0.81,0.63l-0.01,0.96l-0.66,0.99l-0.39,1.41l-7.08,-1.25l-0.7,-1.96Z",
              name: "United Arab Emirates",
            },
            VE: {
              path: "M240.68,256.69l0.53,0.75l-0.02,1.06l-1.07,1.78l0.95,2.0l0.42,0.22l1.4,-0.44l0.56,-1.83l-0.77,-1.17l-0.1,-1.47l2.82,-0.93l0.26,-0.49l-0.28,-0.96l0.3,-0.28l0.66,1.31l1.96,0.26l1.4,1.22l0.08,0.68l0.39,0.35l4.81,-0.22l1.49,1.11l1.92,0.31l1.67,-0.84l0.22,-0.6l3.44,-0.14l-0.17,0.55l0.86,1.19l2.19,0.35l1.67,1.1l0.37,1.86l0.41,0.32l1.55,0.17l-1.66,1.35l-0.22,0.92l0.65,0.97l-1.67,0.54l-0.3,0.4l0.04,0.99l-0.56,0.57l-0.01,0.55l1.85,2.27l-0.66,0.69l-4.47,1.29l-0.72,0.54l-3.69,-0.9l-0.71,0.27l-0.02,0.7l0.91,0.53l-0.08,1.54l0.35,1.58l0.35,0.31l1.66,0.17l-1.3,0.52l-0.48,1.13l-2.68,0.91l-0.6,0.77l-1.57,0.13l-1.17,-1.13l-0.8,-2.52l-1.25,-1.26l1.02,-1.23l-1.29,-2.95l0.18,-1.62l1.0,-2.21l-0.2,-0.49l-1.14,-0.46l-4.02,0.36l-1.82,-2.1l-1.57,-0.33l-2.99,0.22l-1.06,-0.97l0.25,-1.23l-0.2,-1.01l-0.59,-0.69l-0.29,-1.06l-1.08,-0.39l0.78,-2.79l1.9,-2.11Z",
              name: "Venezuela",
            },
            AF: {
              path: "M600.7,188.88l-1.57,1.3l-0.1,0.48l0.8,2.31l-1.09,1.04l-0.03,1.27l-0.48,0.71l-2.16,-0.08l-0.37,0.59l0.78,1.48l-1.38,0.69l-1.06,1.69l0.06,1.7l-0.65,0.52l-0.91,-0.21l-1.91,0.36l-0.48,0.77l-1.88,0.13l-1.4,1.56l-0.18,2.32l-2.91,1.02l-1.65,-0.23l-0.71,0.55l-1.41,-0.3l-2.41,0.39l-3.52,-1.17l1.96,-2.35l-0.21,-1.78l-0.3,-0.34l-1.63,-0.4l-0.19,-1.58l-0.75,-2.03l0.95,-1.36l-0.19,-0.6l-0.73,-0.28l1.47,-4.8l2.14,0.9l2.12,-0.36l0.74,-1.34l1.77,-0.39l1.54,-0.92l0.63,-2.31l1.87,-0.5l0.49,-0.81l0.94,0.56l2.13,0.11l2.55,0.92l1.95,-0.83l0.65,0.43l0.56,-0.13l0.69,-1.12l1.57,-0.08l0.72,-1.66l0.79,-0.74l0.8,0.39l-0.17,0.56l0.71,0.58l-0.08,2.39l1.11,0.95ZM601.37,188.71l1.73,-0.71l1.43,-1.18l4.03,0.35l-2.23,0.74l-4.95,0.8Z",
              name: "Afghanistan",
            },
            IQ: {
              path: "M530.82,187.47l0.79,0.66l1.26,-0.28l1.46,3.08l1.63,0.94l0.14,1.23l-1.22,1.05l-0.53,2.52l1.73,2.67l3.12,1.62l1.15,1.88l-0.38,1.85l0.39,0.48l0.41,-0.0l0.02,1.07l0.76,0.94l-2.47,-0.1l-1.71,2.44l-4.31,-0.2l-7.02,-5.48l-3.73,-1.94l-2.88,-0.73l-0.85,-2.87l5.45,-3.02l0.95,-3.43l-0.19,-1.96l1.27,-0.7l1.22,-1.7l0.87,-0.36l2.69,0.34Z",
              name: "Iraq",
            },
            IS: {
              path: "M384.14,88.06l-0.37,2.61l2.54,2.51l-2.9,2.75l-9.19,3.4l-9.25,-1.66l1.7,-1.22l-0.1,-0.7l-4.05,-1.47l2.96,-0.53l0.33,-0.43l-0.11,-1.2l-0.33,-0.36l-4.67,-0.85l1.28,-2.04l3.45,-0.56l3.77,2.72l0.44,0.02l3.64,-2.16l3.3,1.08l3.98,-2.16l3.58,0.26Z",
              name: "Iceland",
            },
            IR: {
              path: "M533.43,187.16l-1.27,-2.15l0.42,-0.98l-0.71,-3.04l1.03,-0.5l0.33,0.83l1.26,1.35l2.05,0.51l1.11,-0.16l2.89,-2.11l0.62,-0.14l0.39,0.46l-0.72,1.2l0.06,0.49l1.56,1.53l0.65,0.04l0.67,1.81l2.56,0.83l1.87,1.48l3.69,0.49l3.91,-0.76l0.47,-0.73l2.17,-0.6l1.66,-1.54l1.51,0.08l1.18,-0.53l1.59,0.24l2.83,1.48l1.88,0.3l2.77,2.47l1.77,0.18l0.18,1.99l-1.68,5.49l0.24,0.5l0.61,0.23l-0.82,1.48l0.8,2.18l0.19,1.71l0.3,0.34l1.63,0.4l0.15,1.32l-2.15,2.35l-0.01,0.53l2.21,3.03l2.34,1.24l0.06,2.14l1.24,0.72l0.11,0.69l-3.31,1.27l-1.08,3.03l-9.68,-1.68l-0.99,-3.05l-1.43,-0.73l-2.17,0.46l-2.47,1.26l-2.83,-0.82l-2.46,-2.02l-2.41,-0.8l-3.42,-6.06l-0.48,-0.2l-1.18,0.39l-1.44,-0.82l-0.5,0.08l-0.65,0.74l-0.97,-1.01l-0.02,-1.31l-0.71,-0.39l0.26,-1.81l-1.29,-2.11l-3.13,-1.63l-1.58,-2.43l0.5,-1.9l1.31,-1.26l-0.19,-1.66l-1.74,-1.1l-1.57,-3.3Z",
              name: "Iran",
            },
            AM: {
              path: "M536.99,182.33l-0.28,0.03l-1.23,-2.13l-0.93,0.01l-0.62,-0.66l-0.69,-0.07l-0.96,-0.81l-1.56,-0.62l0.19,-1.12l-0.26,-0.79l2.72,-0.36l1.09,1.01l-0.17,0.92l1.02,0.78l-0.47,0.62l0.08,0.56l2.04,1.23l0.04,1.4Z",
              name: "Armenia",
            },
            IT: {
              path: "M451.59,158.63l3.48,0.94l-0.21,1.17l0.3,0.83l-1.49,-0.24l-2.04,1.1l-0.21,0.39l0.13,1.45l-0.25,1.12l0.82,1.57l2.39,1.63l1.31,2.54l2.79,2.43l2.05,0.08l0.21,0.23l-0.39,0.33l0.09,0.67l4.05,1.97l2.17,1.76l-0.16,0.36l-1.17,-1.08l-2.18,-0.49l-0.44,0.2l-1.05,1.91l0.14,0.54l1.57,0.95l-0.19,0.98l-1.06,0.33l-1.25,2.34l-0.37,0.08l0.0,-0.33l1.0,-2.45l-1.73,-3.17l-1.12,-0.51l-0.88,-1.33l-1.51,-0.51l-1.27,-1.25l-1.75,-0.18l-4.12,-3.21l-1.62,-1.65l-1.03,-3.19l-3.53,-1.36l-1.3,0.51l-1.69,1.41l0.16,-0.72l-0.28,-0.47l-1.14,-0.33l-0.53,-1.96l0.72,-0.78l0.04,-0.48l-0.65,-1.17l0.8,0.39l1.4,-0.23l1.11,-0.84l0.52,0.35l1.19,-0.1l0.75,-1.2l1.53,0.33l1.36,-0.56l0.35,-1.14l1.08,0.32l0.68,-0.64l1.98,-0.44l0.42,0.82ZM459.19,184.75l-0.65,1.65l0.32,1.05l-0.31,0.89l-1.5,-0.85l-4.5,-1.67l0.19,-0.82l2.67,0.23l3.78,-0.48ZM443.93,176.05l1.18,1.66l-0.3,3.32l-1.06,-0.01l-0.77,0.73l-0.53,-0.44l-0.1,-3.37l-0.39,-1.22l1.04,0.01l0.92,-0.68Z",
              name: "Italy",
            },
            VN: {
              path: "M690.56,230.25l-2.7,1.82l-2.09,2.46l-0.63,1.95l4.31,6.45l2.32,1.65l1.43,1.94l1.11,4.59l-0.32,4.24l-1.93,1.54l-2.84,1.61l-2.11,2.15l-2.73,2.06l-0.59,-1.05l0.63,-1.53l-0.13,-0.47l-1.34,-1.04l1.51,-0.71l2.55,-0.18l0.3,-0.63l-0.82,-1.14l4.0,-2.07l0.31,-3.05l-0.57,-1.77l0.42,-2.66l-0.73,-1.97l-1.86,-1.76l-3.63,-5.29l-2.72,-1.46l0.36,-0.47l1.5,-0.64l0.21,-0.52l-0.97,-2.27l-0.37,-0.24l-2.83,-0.02l-2.24,-3.9l0.83,-0.4l4.39,-0.29l2.06,-1.31l1.15,0.89l1.88,0.4l-0.17,1.51l1.35,1.16l1.67,0.45Z",
              name: "Vietnam",
            },
            AR: {
              path: "M249.29,428.93l-2.33,-0.52l-5.83,-0.43l-0.89,-1.66l0.05,-2.37l-0.45,-0.4l-1.43,0.18l-0.67,-0.91l-0.2,-3.13l1.88,-1.47l0.79,-2.04l-0.25,-1.7l1.3,-2.68l0.91,-4.15l-0.22,-1.69l0.85,-0.45l0.2,-0.44l-0.27,-1.16l-0.98,-0.68l0.59,-0.92l-0.05,-0.5l-1.04,-1.07l-0.52,-3.1l0.97,-0.86l-0.42,-3.58l1.2,-5.43l1.38,-0.98l0.16,-0.43l-0.75,-2.79l-0.01,-2.43l1.78,-1.75l0.06,-2.57l1.43,-2.85l0.01,-2.58l-0.69,-0.74l-1.09,-4.52l1.47,-2.7l-0.18,-2.79l0.85,-2.35l1.59,-2.46l1.73,-1.64l0.05,-0.52l-0.6,-0.84l0.44,-0.85l-0.07,-4.19l2.7,-1.44l0.86,-2.75l-0.21,-0.71l1.76,-2.01l2.9,0.57l1.38,1.78l0.68,-0.08l0.87,-1.87l2.39,0.09l4.95,4.77l2.17,0.49l3.0,1.92l2.47,1.0l0.25,0.82l-2.37,3.93l0.23,0.59l5.39,1.16l2.12,-0.44l2.45,-2.16l0.5,-2.38l0.76,-0.31l0.98,1.2l-0.04,1.8l-3.67,2.51l-2.85,2.66l-3.43,3.88l-1.3,5.07l0.01,2.72l-0.54,0.73l-0.36,3.28l3.14,2.64l-0.16,2.11l1.4,1.11l-0.1,1.09l-2.29,3.52l-3.55,1.49l-4.92,0.6l-2.71,-0.29l-0.43,0.51l0.5,1.65l-0.49,2.1l0.38,1.42l-1.19,0.83l-2.36,0.38l-2.3,-1.04l-1.38,0.83l0.41,3.64l1.69,0.91l1.4,-0.71l0.36,0.76l-2.04,0.86l-2.01,1.89l-0.97,4.63l-2.34,0.1l-2.09,1.78l-0.61,2.75l2.46,2.31l2.17,0.63l-0.7,2.32l-2.83,1.73l-1.73,3.86l-2.17,1.22l-1.16,1.67l0.75,3.76l1.04,1.28ZM256.71,438.88l-2.0,0.15l-1.4,-1.22l-3.82,-0.1l-0.0,-5.83l1.6,3.05l3.26,2.07l3.08,0.78l-0.71,1.1Z",
              name: "Argentina",
            },
            AU: {
              path: "M705.8,353.26l0.26,0.04l0.17,-0.47l-0.48,-1.42l0.92,1.11l0.45,0.15l0.27,-0.39l-0.1,-1.56l-1.98,-3.63l1.09,-3.31l-0.24,-1.57l0.34,-0.62l0.38,1.06l0.43,-0.19l0.99,-1.7l1.91,-0.83l1.29,-1.15l1.81,-0.91l0.96,-0.17l0.92,0.26l1.92,-0.95l1.47,-0.28l1.03,-0.8l1.43,0.04l2.78,-0.84l1.36,-1.15l0.71,-1.45l1.41,-1.26l0.3,-2.58l1.27,-1.59l0.78,1.65l0.54,0.19l1.07,-0.51l0.15,-0.6l-0.73,-1.0l0.45,-0.71l0.78,0.39l0.58,-0.3l0.28,-1.82l1.87,-2.14l1.12,-0.39l0.28,-0.58l0.62,0.17l0.53,-0.73l1.87,-0.57l1.65,1.05l1.35,1.48l3.39,0.38l0.43,-0.54l-0.46,-1.23l1.05,-1.79l1.04,-0.61l0.14,-0.55l-0.25,-0.41l0.88,-1.17l1.31,-0.77l1.3,0.27l2.1,-0.48l0.31,-0.4l-0.05,-1.3l-0.92,-0.77l1.48,0.56l1.41,1.07l2.11,0.65l0.81,-0.2l1.4,0.7l1.69,-0.66l0.8,0.19l0.64,-0.33l0.71,0.77l-1.33,1.94l-0.71,0.07l-0.35,0.51l0.24,0.86l-1.52,2.35l0.12,1.05l2.15,1.65l1.97,0.85l3.04,2.36l1.97,0.65l0.55,0.88l2.72,0.85l1.84,-1.1l2.07,-5.97l-0.42,-3.59l0.3,-1.73l0.47,-0.87l-0.31,-0.68l1.09,-3.28l0.46,-0.47l0.4,0.71l0.16,1.51l0.65,0.52l0.16,1.04l0.85,1.21l0.12,2.38l0.9,2.0l0.57,0.18l1.3,-0.78l1.69,1.7l-0.2,1.08l0.53,2.2l0.39,1.3l0.68,0.48l0.6,1.95l-0.19,1.48l0.81,1.76l6.01,3.69l-0.11,0.76l1.38,1.58l0.95,2.77l0.58,0.22l0.72,-0.41l0.8,0.9l0.61,0.01l0.46,2.41l4.81,4.71l0.66,2.02l-0.07,3.31l1.14,2.2l-0.13,2.24l-1.1,3.68l0.03,1.64l-0.47,1.89l-1.05,2.4l-1.9,1.47l-1.72,3.51l-2.38,6.09l-0.24,2.82l-1.14,0.8l-2.85,0.15l-2.31,1.19l-2.51,2.25l-3.09,-1.57l0.3,-1.15l-0.54,-0.47l-1.5,0.63l-2.01,1.94l-7.12,-2.18l-1.48,-1.63l-1.14,-3.74l-1.45,-1.26l-1.81,-0.26l0.56,-1.18l-0.61,-2.1l-0.72,-0.1l-1.14,1.82l-0.9,0.21l0.63,-0.82l0.36,-1.55l0.92,-1.31l-0.13,-2.34l-0.7,-0.22l-2.0,2.34l-1.51,0.93l-0.94,2.01l-1.35,-0.81l-0.02,-1.52l-1.57,-2.04l-1.09,-0.88l0.24,-0.33l-0.14,-0.59l-3.21,-1.69l-1.83,-0.12l-2.54,-1.35l-4.58,0.28l-6.02,1.9l-2.53,-0.13l-2.62,1.41l-2.13,0.63l-1.49,2.6l-3.49,0.31l-2.29,-0.5l-3.48,0.43l-1.6,1.47l-0.81,-0.04l-2.37,1.63l-3.26,-0.1l-3.72,-2.21l0.04,-1.05l1.19,-0.46l0.49,-0.89l0.21,-2.97l-0.28,-1.64l-1.34,-2.86l-0.38,-1.47l0.05,-1.72l-0.95,-1.7l-0.18,-0.97l-1.01,-0.99l-0.29,-1.98l-1.13,-1.75ZM784.92,393.44l2.65,1.02l3.23,-0.96l1.09,0.14l0.15,3.06l-0.85,1.13l-0.17,1.63l-0.87,-0.24l-1.57,1.91l-1.68,-0.18l-1.4,-2.36l-0.37,-2.04l-1.39,-2.51l0.04,-0.8l1.15,0.18Z",
              name: "Australia",
            },
            IL: {
              path: "M507.76,203.05l0.4,-0.78l0.18,0.4l-0.33,1.03l0.52,0.44l0.68,-0.22l-0.86,3.6l-1.16,-3.32l0.59,-0.74l-0.03,-0.41ZM508.73,200.34l0.37,-1.02l0.64,0.0l0.52,-0.51l-0.49,1.53l-0.56,-0.24l-0.48,0.23Z",
              name: "Israel",
            },
            IN: {
              path: "M623.34,207.03l-1.24,1.04l-0.97,2.55l0.22,0.51l8.04,3.87l3.42,0.37l1.57,1.38l4.92,0.88l2.18,-0.04l0.38,-0.3l0.29,-1.24l-0.32,-1.64l0.14,-0.87l0.82,-0.31l0.45,2.48l2.28,1.02l1.77,-0.38l4.14,0.1l0.38,-0.36l0.18,-1.66l-0.5,-0.65l1.37,-0.29l2.25,-1.99l2.7,-1.62l1.93,0.62l1.8,-0.98l0.79,1.14l-0.68,0.91l0.26,0.63l2.42,0.36l0.09,0.47l-0.83,0.75l0.13,1.07l-1.52,-0.29l-3.24,1.86l-0.13,1.78l-1.32,2.14l-0.18,1.39l-0.93,1.82l-1.64,-0.5l-0.52,0.37l-0.09,2.63l-0.56,1.11l0.19,0.81l-0.53,0.27l-1.18,-3.73l-1.08,-0.27l-0.38,0.31l-0.24,1.0l-0.66,-0.66l0.54,-1.06l1.22,-0.34l1.15,-2.25l-0.24,-0.56l-1.57,-0.47l-4.34,-0.28l-0.18,-1.56l-0.35,-0.35l-1.11,-0.12l-1.91,-1.12l-0.56,0.17l-0.88,1.82l0.11,0.49l1.36,1.07l-1.09,0.69l-0.69,1.11l0.18,0.56l1.24,0.57l-0.32,1.54l0.85,1.94l0.36,2.01l-0.22,0.59l-4.58,0.52l-0.33,0.42l0.13,1.8l-1.17,1.36l-3.65,1.81l-2.79,3.03l-4.32,3.28l-0.18,1.27l-4.65,1.79l-0.77,2.16l0.64,5.3l-1.06,2.49l-0.01,3.94l-1.24,0.28l-1.14,1.93l0.39,0.84l-1.68,0.53l-1.04,1.83l-0.65,0.47l-2.06,-2.05l-2.1,-6.02l-2.2,-3.64l-1.05,-4.75l-2.29,-3.57l-1.76,-8.2l0.01,-3.11l-0.49,-2.53l-0.55,-0.29l-3.53,1.52l-1.53,-0.27l-2.86,-2.77l0.85,-0.67l0.08,-0.55l-0.74,-1.03l-2.67,-2.06l1.24,-1.32l5.34,0.01l0.39,-0.49l-0.5,-2.29l-1.42,-1.46l-0.27,-1.93l-1.43,-1.2l2.31,-2.37l3.05,0.06l2.62,-2.85l1.6,-2.81l2.4,-2.73l0.07,-2.04l1.97,-1.48l-0.02,-0.65l-1.93,-1.31l-0.82,-1.78l-0.8,-2.21l0.9,-0.89l3.59,0.65l2.92,-0.42l2.33,-2.19l2.31,2.85l-0.24,2.13l0.99,1.59l-0.05,0.82l-1.34,-0.28l-0.47,0.48l0.7,3.06l2.62,1.99l2.99,1.65Z",
              name: "India",
            },
            TZ: {
              path: "M495.56,296.42l2.8,-3.12l-0.02,-0.81l-0.64,-1.3l0.68,-0.52l0.14,-1.47l-0.76,-1.25l0.31,-0.11l2.26,0.03l-0.51,2.76l0.76,1.3l0.5,0.12l1.05,-0.53l1.19,-0.12l0.61,0.24l1.43,-0.62l0.1,-0.67l-0.71,-0.62l1.57,-1.7l8.65,4.86l0.32,1.53l3.34,2.33l-1.05,2.8l0.13,1.61l1.63,1.12l-0.6,1.76l-0.01,2.33l1.89,4.03l0.57,0.43l-1.46,1.08l-2.61,0.94l-1.43,-0.04l-1.06,0.77l-2.29,0.36l-2.87,-0.68l-0.83,0.07l-0.63,-0.75l-0.31,-2.78l-1.32,-1.35l-3.25,-0.77l-3.96,-1.58l-1.18,-2.41l-0.32,-1.75l-1.76,-1.49l0.42,-1.05l-0.44,-0.89l0.08,-0.96l-0.46,-0.58l0.06,-0.56Z",
              name: "Tanzania",
            },
            AZ: {
              path: "M539.29,175.73l1.33,0.32l1.94,-1.8l2.3,3.34l1.43,0.43l-1.26,0.15l-0.35,0.32l-0.8,3.14l-0.99,0.96l0.05,1.11l-1.26,-1.13l0.7,-1.18l-0.04,-0.47l-0.74,-0.86l-1.48,0.15l-2.34,1.71l-0.03,-1.27l-2.03,-1.35l0.47,-0.62l-0.08,-0.56l-1.03,-0.79l0.29,-0.43l-0.14,-0.58l-1.13,-0.86l1.89,0.68l1.69,0.06l0.37,-0.87l-0.81,-1.37l0.42,0.06l1.63,1.72ZM533.78,180.57l0.61,0.46l0.69,-0.0l0.59,1.15l-0.68,-0.15l-1.21,-1.45Z",
              name: "Azerbaijan",
            },
            IE: {
              path: "M405.08,135.42l0.35,2.06l-1.75,2.78l-4.22,1.88l-2.84,-0.4l1.73,-3.0l-1.18,-3.53l4.6,-3.74l0.32,1.15l-0.49,1.74l0.4,0.51l1.47,-0.04l1.6,0.6Z",
              name: "Ireland",
            },
            ID: {
              path: "M756.47,287.89l0.69,4.01l2.79,1.78l0.51,-0.1l2.04,-2.59l2.71,-1.43l2.05,-0.0l3.9,1.73l2.46,0.45l0.08,15.12l-1.75,-1.54l-2.54,-0.51l-0.88,0.71l-2.32,0.06l0.69,-1.33l1.45,-0.64l0.23,-0.46l-0.65,-2.74l-1.24,-2.21l-5.04,-2.29l-2.09,-0.23l-3.68,-2.27l-0.55,0.13l-0.65,1.07l-0.52,0.12l-0.55,-1.89l-1.21,-0.78l1.84,-0.62l1.72,0.05l0.39,-0.52l-0.21,-0.66l-0.38,-0.28l-3.45,-0.0l-1.13,-1.48l-2.1,-0.43l-0.52,-0.6l2.69,-0.48l1.28,-0.78l3.66,0.94l0.3,0.71ZM757.91,300.34l-0.62,0.82l-0.1,-0.8l0.59,-1.12l0.13,1.1ZM747.38,292.98l0.34,0.72l-1.22,-0.57l-4.68,-0.1l0.27,-0.62l2.78,-0.09l2.52,0.67ZM741.05,285.25l-0.67,-2.88l0.64,-2.01l0.41,0.86l1.21,0.18l0.16,0.7l-0.1,1.68l-0.84,-0.16l-0.46,0.3l-0.34,1.34ZM739.05,293.5l-0.5,0.44l-1.34,-0.36l-0.17,-0.37l1.73,-0.08l0.27,0.36ZM721.45,284.51l-0.19,1.97l2.24,2.23l0.54,0.02l1.27,-1.07l2.75,-0.5l-0.9,1.21l-2.11,0.93l-0.16,0.6l2.22,3.01l-0.3,1.07l1.36,1.74l-2.26,0.85l-0.28,-0.31l0.12,-1.19l-1.64,-1.34l0.17,-2.23l-0.56,-0.39l-1.67,0.76l-0.23,0.39l0.3,6.17l-1.1,0.25l-0.69,-0.47l0.64,-2.21l-0.39,-2.42l-0.39,-0.34l-0.8,-0.01l-0.58,-1.29l0.98,-1.6l0.35,-1.96l1.32,-3.87ZM728.59,296.27l0.38,0.49l-0.02,1.28l-0.88,0.49l-0.53,-0.47l1.04,-1.79ZM729.04,286.98l0.27,-0.05l-0.02,0.13l-0.24,-0.08ZM721.68,284.05l0.16,-0.32l1.89,-1.65l1.83,0.68l3.16,0.35l2.94,-0.1l2.39,-1.66l-1.73,2.13l-1.66,0.43l-2.41,-0.48l-4.17,0.13l-2.39,0.51ZM730.55,310.47l1.11,-1.93l2.03,-0.82l0.08,0.62l-1.45,1.67l-1.77,0.46ZM728.12,305.88l-0.1,0.38l-3.46,0.66l-2.91,-0.27l-0.0,-0.25l1.54,-0.41l1.66,0.73l1.67,-0.19l1.61,-0.65ZM722.9,310.24l-0.64,0.03l-2.26,-1.2l1.11,-0.24l1.78,1.41ZM716.26,305.77l0.88,0.51l1.28,-0.17l0.2,0.35l-4.65,0.73l0.39,-0.67l1.15,-0.02l0.75,-0.73ZM711.66,293.84l-0.38,-0.16l-2.54,1.01l-1.12,-1.44l-1.69,-0.13l-1.16,-0.75l-3.04,0.77l-1.1,-1.15l-3.31,-0.11l-0.35,-3.05l-1.35,-0.95l-1.11,-1.98l-0.33,-2.06l0.27,-2.14l0.9,-1.01l0.37,1.15l2.09,1.49l1.53,-0.48l1.82,0.08l1.38,-1.19l1.0,-0.18l2.28,0.67l2.26,-0.53l1.52,-3.64l1.01,-0.99l0.78,-2.57l4.1,0.3l-1.11,1.77l0.02,0.46l1.7,2.2l-0.23,1.39l2.07,1.71l-2.33,0.42l-0.88,1.9l0.1,2.05l-2.4,1.9l-0.06,2.45l-0.7,2.79ZM692.58,302.03l0.35,0.26l4.8,0.25l0.78,-0.97l4.17,1.09l1.13,1.68l3.69,0.45l2.13,1.04l-1.8,0.6l-2.77,-0.99l-4.8,-0.12l-5.24,-1.41l-1.84,-0.25l-1.11,0.3l-4.26,-0.97l-0.7,-1.14l-1.59,-0.13l1.18,-1.65l2.74,0.13l2.87,1.13l0.26,0.68ZM685.53,299.17l-2.22,0.04l-2.06,-2.03l-3.15,-2.01l-2.93,-3.51l-3.11,-5.33l-2.2,-2.12l-1.64,-4.06l-2.32,-1.69l-1.27,-2.07l-1.96,-1.5l-2.51,-2.65l-0.11,-0.66l4.81,0.53l2.15,2.38l3.31,2.74l2.35,2.66l2.7,0.17l1.95,1.59l1.54,2.17l1.59,0.95l-0.84,1.71l0.15,0.52l1.44,0.87l0.79,0.1l0.4,1.58l0.87,1.4l1.96,0.39l1.0,1.31l-0.6,3.01l-0.09,3.5Z",
              name: "Indonesia",
            },
            UA: {
              path: "M492.5,162.44l1.28,-2.49l1.82,0.19l0.66,-0.23l0.09,-0.71l-0.25,-0.75l-0.79,-0.72l-0.33,-1.21l-0.86,-0.62l-0.02,-1.19l-1.13,-0.86l-1.15,-0.19l-2.04,-1.0l-1.66,0.32l-0.66,0.47l-0.92,-0.0l-0.84,0.78l-2.48,0.7l-1.18,-0.71l-3.07,-0.36l-0.89,0.43l-0.24,-0.55l-1.11,-0.7l0.35,-0.93l1.26,-1.02l-0.54,-1.23l2.04,-2.43l1.4,-0.62l0.25,-1.19l-1.04,-2.39l0.83,-0.13l1.28,-0.84l1.8,-0.07l2.47,0.26l2.86,0.81l1.88,0.06l0.86,0.44l1.04,-0.41l0.77,0.66l2.18,-0.15l0.92,0.3l0.52,-0.34l0.15,-1.53l0.56,-0.54l2.85,-0.05l0.84,-0.72l3.04,-0.18l1.23,1.46l-0.48,0.77l0.21,1.03l0.36,0.32l1.8,0.14l0.93,2.08l3.18,1.15l1.94,-0.45l1.67,1.49l1.4,-0.03l3.35,0.96l0.02,0.54l-0.96,1.59l0.47,1.97l-0.26,0.7l-2.36,0.28l-1.29,0.89l-0.23,1.38l-1.83,0.27l-1.58,0.97l-2.41,0.21l-2.16,1.17l-0.21,0.38l0.34,2.26l1.23,0.75l2.13,-0.08l-0.14,0.31l-2.65,0.53l-3.23,1.69l-0.87,-0.39l0.42,-1.1l-0.25,-0.52l-2.21,-0.73l2.35,-1.06l0.12,-0.65l-0.93,-0.82l-3.62,-0.74l-0.13,-0.89l-0.46,-0.34l-2.61,0.59l-0.91,1.69l-1.71,2.04l-0.86,-0.4l-1.62,0.27Z",
              name: "Ukraine",
            },
            QA: {
              path: "M549.33,221.64l-0.76,-0.23l-0.14,-1.64l0.84,-1.29l0.47,0.52l0.04,1.34l-0.45,1.3Z",
              name: "Qatar",
            },
            MZ: {
              path: "M508.58,318.75l-0.34,-2.57l0.51,-2.05l3.55,0.63l2.5,-0.38l1.02,-0.76l1.49,0.01l2.74,-0.98l1.66,-1.2l0.5,9.24l0.41,1.23l-0.68,1.67l-0.93,1.71l-1.5,1.5l-5.16,2.28l-2.78,2.73l-1.02,0.53l-1.71,1.8l-0.98,0.57l-0.35,2.41l1.16,1.94l0.49,2.17l0.43,0.31l-0.06,2.06l-0.39,1.17l0.5,0.72l-0.25,0.73l-0.92,0.83l-5.12,2.39l-1.22,1.36l0.21,1.13l0.58,0.39l-0.11,0.72l-1.22,-0.01l-0.73,-2.97l0.42,-3.09l-1.78,-5.37l2.49,-2.81l0.69,-1.89l0.44,-0.43l0.28,-1.53l-0.39,-0.93l0.59,-3.65l-0.01,-3.26l-1.49,-1.16l-1.2,-0.22l-1.74,-1.17l-1.92,0.01l-0.29,-2.08l7.06,-1.96l1.28,1.09l0.89,-0.1l0.67,0.44l0.1,0.73l-0.51,1.29l0.19,1.81l1.75,1.83l0.65,-0.13l0.71,-1.65l1.17,-0.86l-0.26,-3.47l-1.05,-1.85l-1.04,-0.94Z",
              name: "Mozambique",
            },
          },
          height: 440.70631074413296,
          width: 900,
          projection: { type: "mill", centralMeridian: 11.5 },
        });
      },
      1807: function (e) {
        var t = !(
          "undefined" == typeof window ||
          !window.document ||
          !window.document.createElement
        );
        e.exports = t;
      },
      7757: function (e, t, n) {
        e.exports = (function (e) {
          function t(e, t) {
            return e((t = { exports: {} }), t.exports), t.exports;
          }
          function n(e) {
            return (e && e.default) || e;
          }
          e = e && e.hasOwnProperty("default") ? e.default : e;
          var i = {
              aliceblue: [240, 248, 255],
              antiquewhite: [250, 235, 215],
              aqua: [0, 255, 255],
              aquamarine: [127, 255, 212],
              azure: [240, 255, 255],
              beige: [245, 245, 220],
              bisque: [255, 228, 196],
              black: [0, 0, 0],
              blanchedalmond: [255, 235, 205],
              blue: [0, 0, 255],
              blueviolet: [138, 43, 226],
              brown: [165, 42, 42],
              burlywood: [222, 184, 135],
              cadetblue: [95, 158, 160],
              chartreuse: [127, 255, 0],
              chocolate: [210, 105, 30],
              coral: [255, 127, 80],
              cornflowerblue: [100, 149, 237],
              cornsilk: [255, 248, 220],
              crimson: [220, 20, 60],
              cyan: [0, 255, 255],
              darkblue: [0, 0, 139],
              darkcyan: [0, 139, 139],
              darkgoldenrod: [184, 134, 11],
              darkgray: [169, 169, 169],
              darkgreen: [0, 100, 0],
              darkgrey: [169, 169, 169],
              darkkhaki: [189, 183, 107],
              darkmagenta: [139, 0, 139],
              darkolivegreen: [85, 107, 47],
              darkorange: [255, 140, 0],
              darkorchid: [153, 50, 204],
              darkred: [139, 0, 0],
              darksalmon: [233, 150, 122],
              darkseagreen: [143, 188, 143],
              darkslateblue: [72, 61, 139],
              darkslategray: [47, 79, 79],
              darkslategrey: [47, 79, 79],
              darkturquoise: [0, 206, 209],
              darkviolet: [148, 0, 211],
              deeppink: [255, 20, 147],
              deepskyblue: [0, 191, 255],
              dimgray: [105, 105, 105],
              dimgrey: [105, 105, 105],
              dodgerblue: [30, 144, 255],
              firebrick: [178, 34, 34],
              floralwhite: [255, 250, 240],
              forestgreen: [34, 139, 34],
              fuchsia: [255, 0, 255],
              gainsboro: [220, 220, 220],
              ghostwhite: [248, 248, 255],
              gold: [255, 215, 0],
              goldenrod: [218, 165, 32],
              gray: [128, 128, 128],
              green: [0, 128, 0],
              greenyellow: [173, 255, 47],
              grey: [128, 128, 128],
              honeydew: [240, 255, 240],
              hotpink: [255, 105, 180],
              indianred: [205, 92, 92],
              indigo: [75, 0, 130],
              ivory: [255, 255, 240],
              khaki: [240, 230, 140],
              lavender: [230, 230, 250],
              lavenderblush: [255, 240, 245],
              lawngreen: [124, 252, 0],
              lemonchiffon: [255, 250, 205],
              lightblue: [173, 216, 230],
              lightcoral: [240, 128, 128],
              lightcyan: [224, 255, 255],
              lightgoldenrodyellow: [250, 250, 210],
              lightgray: [211, 211, 211],
              lightgreen: [144, 238, 144],
              lightgrey: [211, 211, 211],
              lightpink: [255, 182, 193],
              lightsalmon: [255, 160, 122],
              lightseagreen: [32, 178, 170],
              lightskyblue: [135, 206, 250],
              lightslategray: [119, 136, 153],
              lightslategrey: [119, 136, 153],
              lightsteelblue: [176, 196, 222],
              lightyellow: [255, 255, 224],
              lime: [0, 255, 0],
              limegreen: [50, 205, 50],
              linen: [250, 240, 230],
              magenta: [255, 0, 255],
              maroon: [128, 0, 0],
              mediumaquamarine: [102, 205, 170],
              mediumblue: [0, 0, 205],
              mediumorchid: [186, 85, 211],
              mediumpurple: [147, 112, 219],
              mediumseagreen: [60, 179, 113],
              mediumslateblue: [123, 104, 238],
              mediumspringgreen: [0, 250, 154],
              mediumturquoise: [72, 209, 204],
              mediumvioletred: [199, 21, 133],
              midnightblue: [25, 25, 112],
              mintcream: [245, 255, 250],
              mistyrose: [255, 228, 225],
              moccasin: [255, 228, 181],
              navajowhite: [255, 222, 173],
              navy: [0, 0, 128],
              oldlace: [253, 245, 230],
              olive: [128, 128, 0],
              olivedrab: [107, 142, 35],
              orange: [255, 165, 0],
              orangered: [255, 69, 0],
              orchid: [218, 112, 214],
              palegoldenrod: [238, 232, 170],
              palegreen: [152, 251, 152],
              paleturquoise: [175, 238, 238],
              palevioletred: [219, 112, 147],
              papayawhip: [255, 239, 213],
              peachpuff: [255, 218, 185],
              peru: [205, 133, 63],
              pink: [255, 192, 203],
              plum: [221, 160, 221],
              powderblue: [176, 224, 230],
              purple: [128, 0, 128],
              rebeccapurple: [102, 51, 153],
              red: [255, 0, 0],
              rosybrown: [188, 143, 143],
              royalblue: [65, 105, 225],
              saddlebrown: [139, 69, 19],
              salmon: [250, 128, 114],
              sandybrown: [244, 164, 96],
              seagreen: [46, 139, 87],
              seashell: [255, 245, 238],
              sienna: [160, 82, 45],
              silver: [192, 192, 192],
              skyblue: [135, 206, 235],
              slateblue: [106, 90, 205],
              slategray: [112, 128, 144],
              slategrey: [112, 128, 144],
              snow: [255, 250, 250],
              springgreen: [0, 255, 127],
              steelblue: [70, 130, 180],
              tan: [210, 180, 140],
              teal: [0, 128, 128],
              thistle: [216, 191, 216],
              tomato: [255, 99, 71],
              turquoise: [64, 224, 208],
              violet: [238, 130, 238],
              wheat: [245, 222, 179],
              white: [255, 255, 255],
              whitesmoke: [245, 245, 245],
              yellow: [255, 255, 0],
              yellowgreen: [154, 205, 50],
            },
            a = t(function (e) {
              var t = {};
              for (var n in i) i.hasOwnProperty(n) && (t[i[n]] = n);
              var a = (e.exports = {
                rgb: { channels: 3, labels: "rgb" },
                hsl: { channels: 3, labels: "hsl" },
                hsv: { channels: 3, labels: "hsv" },
                hwb: { channels: 3, labels: "hwb" },
                cmyk: { channels: 4, labels: "cmyk" },
                xyz: { channels: 3, labels: "xyz" },
                lab: { channels: 3, labels: "lab" },
                lch: { channels: 3, labels: "lch" },
                hex: { channels: 1, labels: ["hex"] },
                keyword: { channels: 1, labels: ["keyword"] },
                ansi16: { channels: 1, labels: ["ansi16"] },
                ansi256: { channels: 1, labels: ["ansi256"] },
                hcg: { channels: 3, labels: ["h", "c", "g"] },
                apple: { channels: 3, labels: ["r16", "g16", "b16"] },
                gray: { channels: 1, labels: ["gray"] },
              });
              for (var r in a)
                if (a.hasOwnProperty(r)) {
                  if (!("channels" in a[r]))
                    throw new Error("missing channels property: " + r);
                  if (!("labels" in a[r]))
                    throw new Error("missing channel labels property: " + r);
                  if (a[r].labels.length !== a[r].channels)
                    throw new Error("channel and label counts mismatch: " + r);
                  var l = a[r].channels,
                    o = a[r].labels;
                  delete a[r].channels,
                    delete a[r].labels,
                    Object.defineProperty(a[r], "channels", { value: l }),
                    Object.defineProperty(a[r], "labels", { value: o });
                }
              function s(e, t) {
                return (
                  Math.pow(e[0] - t[0], 2) +
                  Math.pow(e[1] - t[1], 2) +
                  Math.pow(e[2] - t[2], 2)
                );
              }
              (a.rgb.hsl = function (e) {
                var t,
                  n,
                  i = e[0] / 255,
                  a = e[1] / 255,
                  r = e[2] / 255,
                  l = Math.min(i, a, r),
                  o = Math.max(i, a, r),
                  s = o - l;
                return (
                  o === l
                    ? (t = 0)
                    : i === o
                    ? (t = (a - r) / s)
                    : a === o
                    ? (t = 2 + (r - i) / s)
                    : r === o && (t = 4 + (i - a) / s),
                  (t = Math.min(60 * t, 360)) < 0 && (t += 360),
                  (n = (l + o) / 2),
                  [
                    t,
                    100 *
                      (o === l ? 0 : n <= 0.5 ? s / (o + l) : s / (2 - o - l)),
                    100 * n,
                  ]
                );
              }),
                (a.rgb.hsv = function (e) {
                  var t,
                    n,
                    i,
                    a,
                    r,
                    l = e[0] / 255,
                    o = e[1] / 255,
                    s = e[2] / 255,
                    d = Math.max(l, o, s),
                    u = d - Math.min(l, o, s),
                    c = function (e) {
                      return (d - e) / 6 / u + 0.5;
                    };
                  return (
                    0 === u
                      ? (a = r = 0)
                      : ((r = u / d),
                        (t = c(l)),
                        (n = c(o)),
                        (i = c(s)),
                        l === d
                          ? (a = i - n)
                          : o === d
                          ? (a = 1 / 3 + t - i)
                          : s === d && (a = 2 / 3 + n - t),
                        a < 0 ? (a += 1) : a > 1 && (a -= 1)),
                    [360 * a, 100 * r, 100 * d]
                  );
                }),
                (a.rgb.hwb = function (e) {
                  var t = e[0],
                    n = e[1],
                    i = e[2];
                  return [
                    a.rgb.hsl(e)[0],
                    (1 / 255) * Math.min(t, Math.min(n, i)) * 100,
                    100 * (i = 1 - (1 / 255) * Math.max(t, Math.max(n, i))),
                  ];
                }),
                (a.rgb.cmyk = function (e) {
                  var t,
                    n = e[0] / 255,
                    i = e[1] / 255,
                    a = e[2] / 255;
                  return [
                    100 *
                      ((1 - n - (t = Math.min(1 - n, 1 - i, 1 - a))) /
                        (1 - t) || 0),
                    100 * ((1 - i - t) / (1 - t) || 0),
                    100 * ((1 - a - t) / (1 - t) || 0),
                    100 * t,
                  ];
                }),
                (a.rgb.keyword = function (e) {
                  var n = t[e];
                  if (n) return n;
                  var a,
                    r = 1 / 0;
                  for (var l in i)
                    if (i.hasOwnProperty(l)) {
                      var o = s(e, i[l]);
                      o < r && ((r = o), (a = l));
                    }
                  return a;
                }),
                (a.keyword.rgb = function (e) {
                  return i[e];
                }),
                (a.rgb.xyz = function (e) {
                  var t = e[0] / 255,
                    n = e[1] / 255,
                    i = e[2] / 255;
                  return [
                    100 *
                      (0.4124 *
                        (t =
                          t > 0.04045
                            ? Math.pow((t + 0.055) / 1.055, 2.4)
                            : t / 12.92) +
                        0.3576 *
                          (n =
                            n > 0.04045
                              ? Math.pow((n + 0.055) / 1.055, 2.4)
                              : n / 12.92) +
                        0.1805 *
                          (i =
                            i > 0.04045
                              ? Math.pow((i + 0.055) / 1.055, 2.4)
                              : i / 12.92)),
                    100 * (0.2126 * t + 0.7152 * n + 0.0722 * i),
                    100 * (0.0193 * t + 0.1192 * n + 0.9505 * i),
                  ];
                }),
                (a.rgb.lab = function (e) {
                  var t = a.rgb.xyz(e),
                    n = t[0],
                    i = t[1],
                    r = t[2];
                  return (
                    (i /= 100),
                    (r /= 108.883),
                    (n =
                      (n /= 95.047) > 0.008856
                        ? Math.pow(n, 1 / 3)
                        : 7.787 * n + 16 / 116),
                    [
                      116 *
                        (i =
                          i > 0.008856
                            ? Math.pow(i, 1 / 3)
                            : 7.787 * i + 16 / 116) -
                        16,
                      500 * (n - i),
                      200 *
                        (i -
                          (r =
                            r > 0.008856
                              ? Math.pow(r, 1 / 3)
                              : 7.787 * r + 16 / 116)),
                    ]
                  );
                }),
                (a.hsl.rgb = function (e) {
                  var t,
                    n,
                    i,
                    a,
                    r,
                    l = e[0] / 360,
                    o = e[1] / 100,
                    s = e[2] / 100;
                  if (0 === o) return [(r = 255 * s), r, r];
                  (t = 2 * s - (n = s < 0.5 ? s * (1 + o) : s + o - s * o)),
                    (a = [0, 0, 0]);
                  for (var d = 0; d < 3; d++)
                    (i = l + (1 / 3) * -(d - 1)) < 0 && i++,
                      i > 1 && i--,
                      (r =
                        6 * i < 1
                          ? t + 6 * (n - t) * i
                          : 2 * i < 1
                          ? n
                          : 3 * i < 2
                          ? t + (n - t) * (2 / 3 - i) * 6
                          : t),
                      (a[d] = 255 * r);
                  return a;
                }),
                (a.hsl.hsv = function (e) {
                  var t = e[0],
                    n = e[1] / 100,
                    i = e[2] / 100,
                    a = n,
                    r = Math.max(i, 0.01);
                  return (
                    (n *= (i *= 2) <= 1 ? i : 2 - i),
                    (a *= r <= 1 ? r : 2 - r),
                    [
                      t,
                      100 * (0 === i ? (2 * a) / (r + a) : (2 * n) / (i + n)),
                      ((i + n) / 2) * 100,
                    ]
                  );
                }),
                (a.hsv.rgb = function (e) {
                  var t = e[0] / 60,
                    n = e[1] / 100,
                    i = e[2] / 100,
                    a = Math.floor(t) % 6,
                    r = t - Math.floor(t),
                    l = 255 * i * (1 - n),
                    o = 255 * i * (1 - n * r),
                    s = 255 * i * (1 - n * (1 - r));
                  switch (((i *= 255), a)) {
                    case 0:
                      return [i, s, l];
                    case 1:
                      return [o, i, l];
                    case 2:
                      return [l, i, s];
                    case 3:
                      return [l, o, i];
                    case 4:
                      return [s, l, i];
                    case 5:
                      return [i, l, o];
                  }
                }),
                (a.hsv.hsl = function (e) {
                  var t,
                    n,
                    i,
                    a = e[0],
                    r = e[1] / 100,
                    l = e[2] / 100,
                    o = Math.max(l, 0.01);
                  return (
                    (i = (2 - r) * l),
                    (n = r * o),
                    [
                      a,
                      100 *
                        (n = (n /= (t = (2 - r) * o) <= 1 ? t : 2 - t) || 0),
                      100 * (i /= 2),
                    ]
                  );
                }),
                (a.hwb.rgb = function (e) {
                  var t,
                    n,
                    i,
                    a,
                    r,
                    l,
                    o,
                    s = e[0] / 360,
                    d = e[1] / 100,
                    u = e[2] / 100,
                    c = d + u;
                  switch (
                    (c > 1 && ((d /= c), (u /= c)),
                    (i = 6 * s - (t = Math.floor(6 * s))),
                    1 & t && (i = 1 - i),
                    (a = d + i * ((n = 1 - u) - d)),
                    t)
                  ) {
                    default:
                    case 6:
                    case 0:
                      (r = n), (l = a), (o = d);
                      break;
                    case 1:
                      (r = a), (l = n), (o = d);
                      break;
                    case 2:
                      (r = d), (l = n), (o = a);
                      break;
                    case 3:
                      (r = d), (l = a), (o = n);
                      break;
                    case 4:
                      (r = a), (l = d), (o = n);
                      break;
                    case 5:
                      (r = n), (l = d), (o = a);
                  }
                  return [255 * r, 255 * l, 255 * o];
                }),
                (a.cmyk.rgb = function (e) {
                  var t = e[0] / 100,
                    n = e[1] / 100,
                    i = e[2] / 100,
                    a = e[3] / 100;
                  return [
                    255 * (1 - Math.min(1, t * (1 - a) + a)),
                    255 * (1 - Math.min(1, n * (1 - a) + a)),
                    255 * (1 - Math.min(1, i * (1 - a) + a)),
                  ];
                }),
                (a.xyz.rgb = function (e) {
                  var t,
                    n,
                    i,
                    a = e[0] / 100,
                    r = e[1] / 100,
                    l = e[2] / 100;
                  return (
                    (n = -0.9689 * a + 1.8758 * r + 0.0415 * l),
                    (i = 0.0557 * a + -0.204 * r + 1.057 * l),
                    (t =
                      (t = 3.2406 * a + -1.5372 * r + -0.4986 * l) > 0.0031308
                        ? 1.055 * Math.pow(t, 1 / 2.4) - 0.055
                        : 12.92 * t),
                    (n =
                      n > 0.0031308
                        ? 1.055 * Math.pow(n, 1 / 2.4) - 0.055
                        : 12.92 * n),
                    (i =
                      i > 0.0031308
                        ? 1.055 * Math.pow(i, 1 / 2.4) - 0.055
                        : 12.92 * i),
                    [
                      255 * (t = Math.min(Math.max(0, t), 1)),
                      255 * (n = Math.min(Math.max(0, n), 1)),
                      255 * (i = Math.min(Math.max(0, i), 1)),
                    ]
                  );
                }),
                (a.xyz.lab = function (e) {
                  var t = e[0],
                    n = e[1],
                    i = e[2];
                  return (
                    (n /= 100),
                    (i /= 108.883),
                    (t =
                      (t /= 95.047) > 0.008856
                        ? Math.pow(t, 1 / 3)
                        : 7.787 * t + 16 / 116),
                    [
                      116 *
                        (n =
                          n > 0.008856
                            ? Math.pow(n, 1 / 3)
                            : 7.787 * n + 16 / 116) -
                        16,
                      500 * (t - n),
                      200 *
                        (n -
                          (i =
                            i > 0.008856
                              ? Math.pow(i, 1 / 3)
                              : 7.787 * i + 16 / 116)),
                    ]
                  );
                }),
                (a.lab.xyz = function (e) {
                  var t,
                    n,
                    i,
                    a = e[0];
                  (t = e[1] / 500 + (n = (a + 16) / 116)), (i = n - e[2] / 200);
                  var r = Math.pow(n, 3),
                    l = Math.pow(t, 3),
                    o = Math.pow(i, 3);
                  return (
                    (n = r > 0.008856 ? r : (n - 16 / 116) / 7.787),
                    (t = l > 0.008856 ? l : (t - 16 / 116) / 7.787),
                    (i = o > 0.008856 ? o : (i - 16 / 116) / 7.787),
                    [(t *= 95.047), (n *= 100), (i *= 108.883)]
                  );
                }),
                (a.lab.lch = function (e) {
                  var t,
                    n = e[0],
                    i = e[1],
                    a = e[2];
                  return (
                    (t = (360 * Math.atan2(a, i)) / 2 / Math.PI) < 0 &&
                      (t += 360),
                    [n, Math.sqrt(i * i + a * a), t]
                  );
                }),
                (a.lch.lab = function (e) {
                  var t,
                    n = e[0],
                    i = e[1];
                  return (
                    (t = (e[2] / 360) * 2 * Math.PI),
                    [n, i * Math.cos(t), i * Math.sin(t)]
                  );
                }),
                (a.rgb.ansi16 = function (e) {
                  var t = e[0],
                    n = e[1],
                    i = e[2],
                    r = 1 in arguments ? arguments[1] : a.rgb.hsv(e)[2];
                  if (0 === (r = Math.round(r / 50))) return 30;
                  var l =
                    30 +
                    ((Math.round(i / 255) << 2) |
                      (Math.round(n / 255) << 1) |
                      Math.round(t / 255));
                  return 2 === r && (l += 60), l;
                }),
                (a.hsv.ansi16 = function (e) {
                  return a.rgb.ansi16(a.hsv.rgb(e), e[2]);
                }),
                (a.rgb.ansi256 = function (e) {
                  var t = e[0],
                    n = e[1],
                    i = e[2];
                  return t === n && n === i
                    ? t < 8
                      ? 16
                      : t > 248
                      ? 231
                      : Math.round(((t - 8) / 247) * 24) + 232
                    : 16 +
                        36 * Math.round((t / 255) * 5) +
                        6 * Math.round((n / 255) * 5) +
                        Math.round((i / 255) * 5);
                }),
                (a.ansi16.rgb = function (e) {
                  var t = e % 10;
                  if (0 === t || 7 === t)
                    return e > 50 && (t += 3.5), [(t = (t / 10.5) * 255), t, t];
                  var n = 0.5 * (1 + ~~(e > 50));
                  return [
                    (1 & t) * n * 255,
                    ((t >> 1) & 1) * n * 255,
                    ((t >> 2) & 1) * n * 255,
                  ];
                }),
                (a.ansi256.rgb = function (e) {
                  if (e >= 232) {
                    var t = 10 * (e - 232) + 8;
                    return [t, t, t];
                  }
                  var n;
                  return (
                    (e -= 16),
                    [
                      (Math.floor(e / 36) / 5) * 255,
                      (Math.floor((n = e % 36) / 6) / 5) * 255,
                      ((n % 6) / 5) * 255,
                    ]
                  );
                }),
                (a.rgb.hex = function (e) {
                  var t = (
                    ((255 & Math.round(e[0])) << 16) +
                    ((255 & Math.round(e[1])) << 8) +
                    (255 & Math.round(e[2]))
                  )
                    .toString(16)
                    .toUpperCase();
                  return "000000".substring(t.length) + t;
                }),
                (a.hex.rgb = function (e) {
                  var t = e.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
                  if (!t) return [0, 0, 0];
                  var n = t[0];
                  3 === t[0].length &&
                    (n = n
                      .split("")
                      .map(function (e) {
                        return e + e;
                      })
                      .join(""));
                  var i = parseInt(n, 16);
                  return [(i >> 16) & 255, (i >> 8) & 255, 255 & i];
                }),
                (a.rgb.hcg = function (e) {
                  var t,
                    n = e[0] / 255,
                    i = e[1] / 255,
                    a = e[2] / 255,
                    r = Math.max(Math.max(n, i), a),
                    l = Math.min(Math.min(n, i), a),
                    o = r - l;
                  return (
                    (t =
                      o <= 0
                        ? 0
                        : r === n
                        ? ((i - a) / o) % 6
                        : r === i
                        ? 2 + (a - n) / o
                        : 4 + (n - i) / o + 4),
                    (t /= 6),
                    [360 * (t %= 1), 100 * o, 100 * (o < 1 ? l / (1 - o) : 0)]
                  );
                }),
                (a.hsl.hcg = function (e) {
                  var t = e[1] / 100,
                    n = e[2] / 100,
                    i = 1,
                    a = 0;
                  return (
                    (i = n < 0.5 ? 2 * t * n : 2 * t * (1 - n)) < 1 &&
                      (a = (n - 0.5 * i) / (1 - i)),
                    [e[0], 100 * i, 100 * a]
                  );
                }),
                (a.hsv.hcg = function (e) {
                  var t = e[1] / 100,
                    n = e[2] / 100,
                    i = t * n,
                    a = 0;
                  return (
                    i < 1 && (a = (n - i) / (1 - i)), [e[0], 100 * i, 100 * a]
                  );
                }),
                (a.hcg.rgb = function (e) {
                  var t = e[0] / 360,
                    n = e[1] / 100,
                    i = e[2] / 100;
                  if (0 === n) return [255 * i, 255 * i, 255 * i];
                  var a = [0, 0, 0],
                    r = (t % 1) * 6,
                    l = r % 1,
                    o = 1 - l,
                    s = 0;
                  switch (Math.floor(r)) {
                    case 0:
                      (a[0] = 1), (a[1] = l), (a[2] = 0);
                      break;
                    case 1:
                      (a[0] = o), (a[1] = 1), (a[2] = 0);
                      break;
                    case 2:
                      (a[0] = 0), (a[1] = 1), (a[2] = l);
                      break;
                    case 3:
                      (a[0] = 0), (a[1] = o), (a[2] = 1);
                      break;
                    case 4:
                      (a[0] = l), (a[1] = 0), (a[2] = 1);
                      break;
                    default:
                      (a[0] = 1), (a[1] = 0), (a[2] = o);
                  }
                  return (
                    (s = (1 - n) * i),
                    [
                      255 * (n * a[0] + s),
                      255 * (n * a[1] + s),
                      255 * (n * a[2] + s),
                    ]
                  );
                }),
                (a.hcg.hsv = function (e) {
                  var t = e[1] / 100,
                    n = t + (e[2] / 100) * (1 - t),
                    i = 0;
                  return n > 0 && (i = t / n), [e[0], 100 * i, 100 * n];
                }),
                (a.hcg.hsl = function (e) {
                  var t = e[1] / 100,
                    n = (e[2] / 100) * (1 - t) + 0.5 * t,
                    i = 0;
                  return (
                    n > 0 && n < 0.5
                      ? (i = t / (2 * n))
                      : n >= 0.5 && n < 1 && (i = t / (2 * (1 - n))),
                    [e[0], 100 * i, 100 * n]
                  );
                }),
                (a.hcg.hwb = function (e) {
                  var t = e[1] / 100,
                    n = t + (e[2] / 100) * (1 - t);
                  return [e[0], 100 * (n - t), 100 * (1 - n)];
                }),
                (a.hwb.hcg = function (e) {
                  var t = e[1] / 100,
                    n = 1 - e[2] / 100,
                    i = n - t,
                    a = 0;
                  return (
                    i < 1 && (a = (n - i) / (1 - i)), [e[0], 100 * i, 100 * a]
                  );
                }),
                (a.apple.rgb = function (e) {
                  return [
                    (e[0] / 65535) * 255,
                    (e[1] / 65535) * 255,
                    (e[2] / 65535) * 255,
                  ];
                }),
                (a.rgb.apple = function (e) {
                  return [
                    (e[0] / 255) * 65535,
                    (e[1] / 255) * 65535,
                    (e[2] / 255) * 65535,
                  ];
                }),
                (a.gray.rgb = function (e) {
                  return [
                    (e[0] / 100) * 255,
                    (e[0] / 100) * 255,
                    (e[0] / 100) * 255,
                  ];
                }),
                (a.gray.hsl = a.gray.hsv =
                  function (e) {
                    return [0, 0, e[0]];
                  }),
                (a.gray.hwb = function (e) {
                  return [0, 100, e[0]];
                }),
                (a.gray.cmyk = function (e) {
                  return [0, 0, 0, e[0]];
                }),
                (a.gray.lab = function (e) {
                  return [e[0], 0, 0];
                }),
                (a.gray.hex = function (e) {
                  var t = 255 & Math.round((e[0] / 100) * 255),
                    n = ((t << 16) + (t << 8) + t).toString(16).toUpperCase();
                  return "000000".substring(n.length) + n;
                }),
                (a.rgb.gray = function (e) {
                  return [((e[0] + e[1] + e[2]) / 3 / 255) * 100];
                });
            });
          function r() {
            for (
              var e = {}, t = Object.keys(a), n = t.length, i = 0;
              i < n;
              i++
            )
              e[t[i]] = { distance: -1, parent: null };
            return e;
          }
          function l(e) {
            var t = r(),
              n = [e];
            for (t[e].distance = 0; n.length; )
              for (
                var i = n.pop(), l = Object.keys(a[i]), o = l.length, s = 0;
                s < o;
                s++
              ) {
                var d = l[s],
                  u = t[d];
                -1 === u.distance &&
                  ((u.distance = t[i].distance + 1),
                  (u.parent = i),
                  n.unshift(d));
              }
            return t;
          }
          function o(e, t) {
            return function (n) {
              return t(e(n));
            };
          }
          function s(e, t) {
            for (
              var n = [t[e].parent, e], i = a[t[e].parent][e], r = t[e].parent;
              t[r].parent;

            )
              n.unshift(t[r].parent),
                (i = o(a[t[r].parent][r], i)),
                (r = t[r].parent);
            return (i.conversion = n), i;
          }
          a.rgb,
            a.hsl,
            a.hsv,
            a.hwb,
            a.cmyk,
            a.xyz,
            a.lab,
            a.lch,
            a.hex,
            a.keyword,
            a.ansi16,
            a.ansi256,
            a.hcg,
            a.apple,
            a.gray;
          var d = function (e) {
              for (
                var t = l(e), n = {}, i = Object.keys(t), a = i.length, r = 0;
                r < a;
                r++
              ) {
                var o = i[r];
                null !== t[o].parent && (n[o] = s(o, t));
              }
              return n;
            },
            u = {};
          function c(e) {
            var t = function (t) {
              return null == t
                ? t
                : (arguments.length > 1 &&
                    (t = Array.prototype.slice.call(arguments)),
                  e(t));
            };
            return "conversion" in e && (t.conversion = e.conversion), t;
          }
          function h(e) {
            var t = function (t) {
              if (null == t) return t;
              arguments.length > 1 &&
                (t = Array.prototype.slice.call(arguments));
              var n = e(t);
              if ("object" == typeof n)
                for (var i = n.length, a = 0; a < i; a++)
                  n[a] = Math.round(n[a]);
              return n;
            };
            return "conversion" in e && (t.conversion = e.conversion), t;
          }
          Object.keys(a).forEach(function (e) {
            (u[e] = {}),
              Object.defineProperty(u[e], "channels", { value: a[e].channels }),
              Object.defineProperty(u[e], "labels", { value: a[e].labels });
            var t = d(e);
            Object.keys(t).forEach(function (n) {
              var i = t[n];
              (u[e][n] = h(i)), (u[e][n].raw = c(i));
            });
          });
          var m = u,
            f = {
              aliceblue: [240, 248, 255],
              antiquewhite: [250, 235, 215],
              aqua: [0, 255, 255],
              aquamarine: [127, 255, 212],
              azure: [240, 255, 255],
              beige: [245, 245, 220],
              bisque: [255, 228, 196],
              black: [0, 0, 0],
              blanchedalmond: [255, 235, 205],
              blue: [0, 0, 255],
              blueviolet: [138, 43, 226],
              brown: [165, 42, 42],
              burlywood: [222, 184, 135],
              cadetblue: [95, 158, 160],
              chartreuse: [127, 255, 0],
              chocolate: [210, 105, 30],
              coral: [255, 127, 80],
              cornflowerblue: [100, 149, 237],
              cornsilk: [255, 248, 220],
              crimson: [220, 20, 60],
              cyan: [0, 255, 255],
              darkblue: [0, 0, 139],
              darkcyan: [0, 139, 139],
              darkgoldenrod: [184, 134, 11],
              darkgray: [169, 169, 169],
              darkgreen: [0, 100, 0],
              darkgrey: [169, 169, 169],
              darkkhaki: [189, 183, 107],
              darkmagenta: [139, 0, 139],
              darkolivegreen: [85, 107, 47],
              darkorange: [255, 140, 0],
              darkorchid: [153, 50, 204],
              darkred: [139, 0, 0],
              darksalmon: [233, 150, 122],
              darkseagreen: [143, 188, 143],
              darkslateblue: [72, 61, 139],
              darkslategray: [47, 79, 79],
              darkslategrey: [47, 79, 79],
              darkturquoise: [0, 206, 209],
              darkviolet: [148, 0, 211],
              deeppink: [255, 20, 147],
              deepskyblue: [0, 191, 255],
              dimgray: [105, 105, 105],
              dimgrey: [105, 105, 105],
              dodgerblue: [30, 144, 255],
              firebrick: [178, 34, 34],
              floralwhite: [255, 250, 240],
              forestgreen: [34, 139, 34],
              fuchsia: [255, 0, 255],
              gainsboro: [220, 220, 220],
              ghostwhite: [248, 248, 255],
              gold: [255, 215, 0],
              goldenrod: [218, 165, 32],
              gray: [128, 128, 128],
              green: [0, 128, 0],
              greenyellow: [173, 255, 47],
              grey: [128, 128, 128],
              honeydew: [240, 255, 240],
              hotpink: [255, 105, 180],
              indianred: [205, 92, 92],
              indigo: [75, 0, 130],
              ivory: [255, 255, 240],
              khaki: [240, 230, 140],
              lavender: [230, 230, 250],
              lavenderblush: [255, 240, 245],
              lawngreen: [124, 252, 0],
              lemonchiffon: [255, 250, 205],
              lightblue: [173, 216, 230],
              lightcoral: [240, 128, 128],
              lightcyan: [224, 255, 255],
              lightgoldenrodyellow: [250, 250, 210],
              lightgray: [211, 211, 211],
              lightgreen: [144, 238, 144],
              lightgrey: [211, 211, 211],
              lightpink: [255, 182, 193],
              lightsalmon: [255, 160, 122],
              lightseagreen: [32, 178, 170],
              lightskyblue: [135, 206, 250],
              lightslategray: [119, 136, 153],
              lightslategrey: [119, 136, 153],
              lightsteelblue: [176, 196, 222],
              lightyellow: [255, 255, 224],
              lime: [0, 255, 0],
              limegreen: [50, 205, 50],
              linen: [250, 240, 230],
              magenta: [255, 0, 255],
              maroon: [128, 0, 0],
              mediumaquamarine: [102, 205, 170],
              mediumblue: [0, 0, 205],
              mediumorchid: [186, 85, 211],
              mediumpurple: [147, 112, 219],
              mediumseagreen: [60, 179, 113],
              mediumslateblue: [123, 104, 238],
              mediumspringgreen: [0, 250, 154],
              mediumturquoise: [72, 209, 204],
              mediumvioletred: [199, 21, 133],
              midnightblue: [25, 25, 112],
              mintcream: [245, 255, 250],
              mistyrose: [255, 228, 225],
              moccasin: [255, 228, 181],
              navajowhite: [255, 222, 173],
              navy: [0, 0, 128],
              oldlace: [253, 245, 230],
              olive: [128, 128, 0],
              olivedrab: [107, 142, 35],
              orange: [255, 165, 0],
              orangered: [255, 69, 0],
              orchid: [218, 112, 214],
              palegoldenrod: [238, 232, 170],
              palegreen: [152, 251, 152],
              paleturquoise: [175, 238, 238],
              palevioletred: [219, 112, 147],
              papayawhip: [255, 239, 213],
              peachpuff: [255, 218, 185],
              peru: [205, 133, 63],
              pink: [255, 192, 203],
              plum: [221, 160, 221],
              powderblue: [176, 224, 230],
              purple: [128, 0, 128],
              rebeccapurple: [102, 51, 153],
              red: [255, 0, 0],
              rosybrown: [188, 143, 143],
              royalblue: [65, 105, 225],
              saddlebrown: [139, 69, 19],
              salmon: [250, 128, 114],
              sandybrown: [244, 164, 96],
              seagreen: [46, 139, 87],
              seashell: [255, 245, 238],
              sienna: [160, 82, 45],
              silver: [192, 192, 192],
              skyblue: [135, 206, 235],
              slateblue: [106, 90, 205],
              slategray: [112, 128, 144],
              slategrey: [112, 128, 144],
              snow: [255, 250, 250],
              springgreen: [0, 255, 127],
              steelblue: [70, 130, 180],
              tan: [210, 180, 140],
              teal: [0, 128, 128],
              thistle: [216, 191, 216],
              tomato: [255, 99, 71],
              turquoise: [64, 224, 208],
              violet: [238, 130, 238],
              wheat: [245, 222, 179],
              white: [255, 255, 255],
              whitesmoke: [245, 245, 245],
              yellow: [255, 255, 0],
              yellowgreen: [154, 205, 50],
            },
            _ = {
              getRgba: p,
              getHsla: g,
              getRgb: v,
              getHsl: M,
              getHwb: y,
              getAlpha: b,
              hexString: x,
              rgbString: L,
              rgbaString: w,
              percentString: k,
              percentaString: Y,
              hslString: D,
              hslaString: T,
              hwbString: S,
              keyword: j,
            };
          function p(e) {
            if (e) {
              var t = /^#([a-fA-F0-9]{3,4})$/i,
                n = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
                i =
                  /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
                a =
                  /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
                r = /(\w+)/,
                l = [0, 0, 0],
                o = 1,
                s = e.match(t),
                d = "";
              if (s) {
                d = (s = s[1])[3];
                for (var u = 0; u < l.length; u++)
                  l[u] = parseInt(s[u] + s[u], 16);
                d && (o = Math.round((parseInt(d + d, 16) / 255) * 100) / 100);
              } else if ((s = e.match(n))) {
                for (d = s[2], s = s[1], u = 0; u < l.length; u++)
                  l[u] = parseInt(s.slice(2 * u, 2 * u + 2), 16);
                d && (o = Math.round((parseInt(d, 16) / 255) * 100) / 100);
              } else if ((s = e.match(i))) {
                for (u = 0; u < l.length; u++) l[u] = parseInt(s[u + 1]);
                o = parseFloat(s[4]);
              } else if ((s = e.match(a))) {
                for (u = 0; u < l.length; u++)
                  l[u] = Math.round(2.55 * parseFloat(s[u + 1]));
                o = parseFloat(s[4]);
              } else if ((s = e.match(r))) {
                if ("transparent" == s[1]) return [0, 0, 0, 0];
                if (!(l = f[s[1]])) return;
              }
              for (u = 0; u < l.length; u++) l[u] = O(l[u], 0, 255);
              return (o = o || 0 == o ? O(o, 0, 1) : 1), (l[3] = o), l;
            }
          }
          function g(e) {
            if (e) {
              var t =
                  /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,
                n = e.match(t);
              if (n) {
                var i = parseFloat(n[4]);
                return [
                  O(parseInt(n[1]), 0, 360),
                  O(parseFloat(n[2]), 0, 100),
                  O(parseFloat(n[3]), 0, 100),
                  O(isNaN(i) ? 1 : i, 0, 1),
                ];
              }
            }
          }
          function y(e) {
            if (e) {
              var t =
                  /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/,
                n = e.match(t);
              if (n) {
                var i = parseFloat(n[4]);
                return [
                  O(parseInt(n[1]), 0, 360),
                  O(parseFloat(n[2]), 0, 100),
                  O(parseFloat(n[3]), 0, 100),
                  O(isNaN(i) ? 1 : i, 0, 1),
                ];
              }
            }
          }
          function v(e) {
            var t = p(e);
            return t && t.slice(0, 3);
          }
          function M(e) {
            var t = g(e);
            return t && t.slice(0, 3);
          }
          function b(e) {
            var t = p(e);
            return t || (t = g(e)) || (t = y(e)) ? t[3] : void 0;
          }
          function x(e, t) {
            return (
              (t = void 0 !== t && 3 === e.length ? t : e[3]),
              "#" +
                A(e[0]) +
                A(e[1]) +
                A(e[2]) +
                (t >= 0 && t < 1 ? A(Math.round(255 * t)) : "")
            );
          }
          function L(e, t) {
            return t < 1 || (e[3] && e[3] < 1)
              ? w(e, t)
              : "rgb(" + e[0] + ", " + e[1] + ", " + e[2] + ")";
          }
          function w(e, t) {
            return (
              void 0 === t && (t = void 0 !== e[3] ? e[3] : 1),
              "rgba(" + e[0] + ", " + e[1] + ", " + e[2] + ", " + t + ")"
            );
          }
          function k(e, t) {
            return t < 1 || (e[3] && e[3] < 1)
              ? Y(e, t)
              : "rgb(" +
                  Math.round((e[0] / 255) * 100) +
                  "%, " +
                  Math.round((e[1] / 255) * 100) +
                  "%, " +
                  Math.round((e[2] / 255) * 100) +
                  "%)";
          }
          function Y(e, t) {
            return (
              "rgba(" +
              Math.round((e[0] / 255) * 100) +
              "%, " +
              Math.round((e[1] / 255) * 100) +
              "%, " +
              Math.round((e[2] / 255) * 100) +
              "%, " +
              (t || e[3] || 1) +
              ")"
            );
          }
          function D(e, t) {
            return t < 1 || (e[3] && e[3] < 1)
              ? T(e, t)
              : "hsl(" + e[0] + ", " + e[1] + "%, " + e[2] + "%)";
          }
          function T(e, t) {
            return (
              void 0 === t && (t = void 0 !== e[3] ? e[3] : 1),
              "hsla(" + e[0] + ", " + e[1] + "%, " + e[2] + "%, " + t + ")"
            );
          }
          function S(e, t) {
            return (
              void 0 === t && (t = void 0 !== e[3] ? e[3] : 1),
              "hwb(" +
                e[0] +
                ", " +
                e[1] +
                "%, " +
                e[2] +
                "%" +
                (void 0 !== t && 1 !== t ? ", " + t : "") +
                ")"
            );
          }
          function j(e) {
            return H[e.slice(0, 3)];
          }
          function O(e, t, n) {
            return Math.min(Math.max(t, e), n);
          }
          function A(e) {
            var t = e.toString(16).toUpperCase();
            return t.length < 2 ? "0" + t : t;
          }
          var H = {};
          for (var E in f) H[f[E]] = E;
          var C = function (e) {
            return e instanceof C
              ? e
              : this instanceof C
              ? ((this.valid = !1),
                (this.values = {
                  rgb: [0, 0, 0],
                  hsl: [0, 0, 0],
                  hsv: [0, 0, 0],
                  hwb: [0, 0, 0],
                  cmyk: [0, 0, 0, 0],
                  alpha: 1,
                }),
                void ("string" == typeof e
                  ? (t = _.getRgba(e))
                    ? this.setValues("rgb", t)
                    : (t = _.getHsla(e))
                    ? this.setValues("hsl", t)
                    : (t = _.getHwb(e)) && this.setValues("hwb", t)
                  : "object" == typeof e &&
                    (void 0 !== (t = e).r || void 0 !== t.red
                      ? this.setValues("rgb", t)
                      : void 0 !== t.l || void 0 !== t.lightness
                      ? this.setValues("hsl", t)
                      : void 0 !== t.v || void 0 !== t.value
                      ? this.setValues("hsv", t)
                      : void 0 !== t.w || void 0 !== t.whiteness
                      ? this.setValues("hwb", t)
                      : (void 0 === t.c && void 0 === t.cyan) ||
                        this.setValues("cmyk", t))))
              : new C(e);
            var t;
          };
          (C.prototype = {
            isValid: function () {
              return this.valid;
            },
            rgb: function () {
              return this.setSpace("rgb", arguments);
            },
            hsl: function () {
              return this.setSpace("hsl", arguments);
            },
            hsv: function () {
              return this.setSpace("hsv", arguments);
            },
            hwb: function () {
              return this.setSpace("hwb", arguments);
            },
            cmyk: function () {
              return this.setSpace("cmyk", arguments);
            },
            rgbArray: function () {
              return this.values.rgb;
            },
            hslArray: function () {
              return this.values.hsl;
            },
            hsvArray: function () {
              return this.values.hsv;
            },
            hwbArray: function () {
              var e = this.values;
              return 1 !== e.alpha ? e.hwb.concat([e.alpha]) : e.hwb;
            },
            cmykArray: function () {
              return this.values.cmyk;
            },
            rgbaArray: function () {
              var e = this.values;
              return e.rgb.concat([e.alpha]);
            },
            hslaArray: function () {
              var e = this.values;
              return e.hsl.concat([e.alpha]);
            },
            alpha: function (e) {
              return void 0 === e
                ? this.values.alpha
                : (this.setValues("alpha", e), this);
            },
            red: function (e) {
              return this.setChannel("rgb", 0, e);
            },
            green: function (e) {
              return this.setChannel("rgb", 1, e);
            },
            blue: function (e) {
              return this.setChannel("rgb", 2, e);
            },
            hue: function (e) {
              return (
                e && (e = (e %= 360) < 0 ? 360 + e : e),
                this.setChannel("hsl", 0, e)
              );
            },
            saturation: function (e) {
              return this.setChannel("hsl", 1, e);
            },
            lightness: function (e) {
              return this.setChannel("hsl", 2, e);
            },
            saturationv: function (e) {
              return this.setChannel("hsv", 1, e);
            },
            whiteness: function (e) {
              return this.setChannel("hwb", 1, e);
            },
            blackness: function (e) {
              return this.setChannel("hwb", 2, e);
            },
            value: function (e) {
              return this.setChannel("hsv", 2, e);
            },
            cyan: function (e) {
              return this.setChannel("cmyk", 0, e);
            },
            magenta: function (e) {
              return this.setChannel("cmyk", 1, e);
            },
            yellow: function (e) {
              return this.setChannel("cmyk", 2, e);
            },
            black: function (e) {
              return this.setChannel("cmyk", 3, e);
            },
            hexString: function () {
              return _.hexString(this.values.rgb);
            },
            rgbString: function () {
              return _.rgbString(this.values.rgb, this.values.alpha);
            },
            rgbaString: function () {
              return _.rgbaString(this.values.rgb, this.values.alpha);
            },
            percentString: function () {
              return _.percentString(this.values.rgb, this.values.alpha);
            },
            hslString: function () {
              return _.hslString(this.values.hsl, this.values.alpha);
            },
            hslaString: function () {
              return _.hslaString(this.values.hsl, this.values.alpha);
            },
            hwbString: function () {
              return _.hwbString(this.values.hwb, this.values.alpha);
            },
            keyword: function () {
              return _.keyword(this.values.rgb, this.values.alpha);
            },
            rgbNumber: function () {
              var e = this.values.rgb;
              return (e[0] << 16) | (e[1] << 8) | e[2];
            },
            luminosity: function () {
              for (var e = this.values.rgb, t = [], n = 0; n < e.length; n++) {
                var i = e[n] / 255;
                t[n] =
                  i <= 0.03928 ? i / 12.92 : Math.pow((i + 0.055) / 1.055, 2.4);
              }
              return 0.2126 * t[0] + 0.7152 * t[1] + 0.0722 * t[2];
            },
            contrast: function (e) {
              var t = this.luminosity(),
                n = e.luminosity();
              return t > n ? (t + 0.05) / (n + 0.05) : (n + 0.05) / (t + 0.05);
            },
            level: function (e) {
              var t = this.contrast(e);
              return t >= 7.1 ? "AAA" : t >= 4.5 ? "AA" : "";
            },
            dark: function () {
              var e = this.values.rgb;
              return (299 * e[0] + 587 * e[1] + 114 * e[2]) / 1e3 < 128;
            },
            light: function () {
              return !this.dark();
            },
            negate: function () {
              for (var e = [], t = 0; t < 3; t++)
                e[t] = 255 - this.values.rgb[t];
              return this.setValues("rgb", e), this;
            },
            lighten: function (e) {
              var t = this.values.hsl;
              return (t[2] += t[2] * e), this.setValues("hsl", t), this;
            },
            darken: function (e) {
              var t = this.values.hsl;
              return (t[2] -= t[2] * e), this.setValues("hsl", t), this;
            },
            saturate: function (e) {
              var t = this.values.hsl;
              return (t[1] += t[1] * e), this.setValues("hsl", t), this;
            },
            desaturate: function (e) {
              var t = this.values.hsl;
              return (t[1] -= t[1] * e), this.setValues("hsl", t), this;
            },
            whiten: function (e) {
              var t = this.values.hwb;
              return (t[1] += t[1] * e), this.setValues("hwb", t), this;
            },
            blacken: function (e) {
              var t = this.values.hwb;
              return (t[2] += t[2] * e), this.setValues("hwb", t), this;
            },
            greyscale: function () {
              var e = this.values.rgb,
                t = 0.3 * e[0] + 0.59 * e[1] + 0.11 * e[2];
              return this.setValues("rgb", [t, t, t]), this;
            },
            clearer: function (e) {
              var t = this.values.alpha;
              return this.setValues("alpha", t - t * e), this;
            },
            opaquer: function (e) {
              var t = this.values.alpha;
              return this.setValues("alpha", t + t * e), this;
            },
            rotate: function (e) {
              var t = this.values.hsl,
                n = (t[0] + e) % 360;
              return (
                (t[0] = n < 0 ? 360 + n : n), this.setValues("hsl", t), this
              );
            },
            mix: function (e, t) {
              var n = this,
                i = e,
                a = void 0 === t ? 0.5 : t,
                r = 2 * a - 1,
                l = n.alpha() - i.alpha(),
                o = ((r * l == -1 ? r : (r + l) / (1 + r * l)) + 1) / 2,
                s = 1 - o;
              return this.rgb(
                o * n.red() + s * i.red(),
                o * n.green() + s * i.green(),
                o * n.blue() + s * i.blue()
              ).alpha(n.alpha() * a + i.alpha() * (1 - a));
            },
            toJSON: function () {
              return this.rgb();
            },
            clone: function () {
              var e,
                t,
                n = new C(),
                i = this.values,
                a = n.values;
              for (var r in i)
                i.hasOwnProperty(r) &&
                  ((e = i[r]),
                  "[object Array]" === (t = {}.toString.call(e))
                    ? (a[r] = e.slice(0))
                    : "[object Number]" === t
                    ? (a[r] = e)
                    : console.error("unexpected color value:", e));
              return n;
            },
          }),
            (C.prototype.spaces = {
              rgb: ["red", "green", "blue"],
              hsl: ["hue", "saturation", "lightness"],
              hsv: ["hue", "saturation", "value"],
              hwb: ["hue", "whiteness", "blackness"],
              cmyk: ["cyan", "magenta", "yellow", "black"],
            }),
            (C.prototype.maxes = {
              rgb: [255, 255, 255],
              hsl: [360, 100, 100],
              hsv: [360, 100, 100],
              hwb: [360, 100, 100],
              cmyk: [100, 100, 100, 100],
            }),
            (C.prototype.getValues = function (e) {
              for (var t = this.values, n = {}, i = 0; i < e.length; i++)
                n[e.charAt(i)] = t[e][i];
              return 1 !== t.alpha && (n.a = t.alpha), n;
            }),
            (C.prototype.setValues = function (e, t) {
              var n,
                i,
                a = this.values,
                r = this.spaces,
                l = this.maxes,
                o = 1;
              if (((this.valid = !0), "alpha" === e)) o = t;
              else if (t.length)
                (a[e] = t.slice(0, e.length)), (o = t[e.length]);
              else if (void 0 !== t[e.charAt(0)]) {
                for (n = 0; n < e.length; n++) a[e][n] = t[e.charAt(n)];
                o = t.a;
              } else if (void 0 !== t[r[e][0]]) {
                var s = r[e];
                for (n = 0; n < e.length; n++) a[e][n] = t[s[n]];
                o = t.alpha;
              }
              if (
                ((a.alpha = Math.max(
                  0,
                  Math.min(1, void 0 === o ? a.alpha : o)
                )),
                "alpha" === e)
              )
                return !1;
              for (n = 0; n < e.length; n++)
                (i = Math.max(0, Math.min(l[e][n], a[e][n]))),
                  (a[e][n] = Math.round(i));
              for (var d in r) d !== e && (a[d] = m[e][d](a[e]));
              return !0;
            }),
            (C.prototype.setSpace = function (e, t) {
              var n = t[0];
              return void 0 === n
                ? this.getValues(e)
                : ("number" == typeof n && (n = Array.prototype.slice.call(t)),
                  this.setValues(e, n),
                  this);
            }),
            (C.prototype.setChannel = function (e, t, n) {
              var i = this.values[e];
              return void 0 === n
                ? i[t]
                : (n === i[t] || ((i[t] = n), this.setValues(e, i)), this);
            }),
            "undefined" != typeof window && (window.Color = C);
          var P = C;
          function F(e) {
            return -1 === ["__proto__", "prototype", "constructor"].indexOf(e);
          }
          var I,
            W = {
              noop: function () {},
              uid:
                ((I = 0),
                function () {
                  return I++;
                }),
              isNullOrUndef: function (e) {
                return null == e;
              },
              isArray: function (e) {
                if (Array.isArray && Array.isArray(e)) return !0;
                var t = Object.prototype.toString.call(e);
                return (
                  "[object" === t.substr(0, 7) && "Array]" === t.substr(-6)
                );
              },
              isObject: function (e) {
                return (
                  null !== e &&
                  "[object Object]" === Object.prototype.toString.call(e)
                );
              },
              isFinite: function (e) {
                return (
                  ("number" == typeof e || e instanceof Number) && isFinite(e)
                );
              },
              valueOrDefault: function (e, t) {
                return void 0 === e ? t : e;
              },
              valueAtIndexOrDefault: function (e, t, n) {
                return W.valueOrDefault(W.isArray(e) ? e[t] : e, n);
              },
              callback: function (e, t, n) {
                if (e && "function" == typeof e.call) return e.apply(n, t);
              },
              each: function (e, t, n, i) {
                var a, r, l;
                if (W.isArray(e))
                  if (((r = e.length), i))
                    for (a = r - 1; a >= 0; a--) t.call(n, e[a], a);
                  else for (a = 0; a < r; a++) t.call(n, e[a], a);
                else if (W.isObject(e))
                  for (r = (l = Object.keys(e)).length, a = 0; a < r; a++)
                    t.call(n, e[l[a]], l[a]);
              },
              arrayEquals: function (e, t) {
                var n, i, a, r;
                if (!e || !t || e.length !== t.length) return !1;
                for (n = 0, i = e.length; n < i; ++n)
                  if (
                    ((a = e[n]),
                    (r = t[n]),
                    a instanceof Array && r instanceof Array)
                  ) {
                    if (!W.arrayEquals(a, r)) return !1;
                  } else if (a !== r) return !1;
                return !0;
              },
              clone: function (e) {
                if (W.isArray(e)) return e.map(W.clone);
                if (W.isObject(e)) {
                  for (
                    var t = Object.create(e),
                      n = Object.keys(e),
                      i = n.length,
                      a = 0;
                    a < i;
                    ++a
                  )
                    t[n[a]] = W.clone(e[n[a]]);
                  return t;
                }
                return e;
              },
              _merger: function (e, t, n, i) {
                if (F(e)) {
                  var a = t[e],
                    r = n[e];
                  W.isObject(a) && W.isObject(r)
                    ? W.merge(a, r, i)
                    : (t[e] = W.clone(r));
                }
              },
              _mergerIf: function (e, t, n) {
                if (F(e)) {
                  var i = t[e],
                    a = n[e];
                  W.isObject(i) && W.isObject(a)
                    ? W.mergeIf(i, a)
                    : t.hasOwnProperty(e) || (t[e] = W.clone(a));
                }
              },
              merge: function (e, t, n) {
                var i,
                  a,
                  r,
                  l,
                  o,
                  s = W.isArray(t) ? t : [t],
                  d = s.length;
                if (!W.isObject(e)) return e;
                for (i = (n = n || {}).merger || W._merger, a = 0; a < d; ++a)
                  if (((t = s[a]), W.isObject(t)))
                    for (o = 0, l = (r = Object.keys(t)).length; o < l; ++o)
                      i(r[o], e, t, n);
                return e;
              },
              mergeIf: function (e, t) {
                return W.merge(e, t, { merger: W._mergerIf });
              },
              extend:
                Object.assign ||
                function (e) {
                  return W.merge(e, [].slice.call(arguments, 1), {
                    merger: function (e, t, n) {
                      t[e] = n[e];
                    },
                  });
                },
              inherits: function (e) {
                var t = this,
                  n =
                    e && e.hasOwnProperty("constructor")
                      ? e.constructor
                      : function () {
                          return t.apply(this, arguments);
                        },
                  i = function () {
                    this.constructor = n;
                  };
                return (
                  (i.prototype = t.prototype),
                  (n.prototype = new i()),
                  (n.extend = W.inherits),
                  e && W.extend(n.prototype, e),
                  (n.__super__ = t.prototype),
                  n
                );
              },
              _deprecated: function (e, t, n, i) {
                void 0 !== t &&
                  console.warn(
                    e +
                      ': "' +
                      n +
                      '" is deprecated. Please use "' +
                      i +
                      '" instead'
                  );
              },
            },
            z = W;
          (W.callCallback = W.callback),
            (W.indexOf = function (e, t, n) {
              return Array.prototype.indexOf.call(e, t, n);
            }),
            (W.getValueOrDefault = W.valueOrDefault),
            (W.getValueAtIndexOrDefault = W.valueAtIndexOrDefault);
          var N = {
              linear: function (e) {
                return e;
              },
              easeInQuad: function (e) {
                return e * e;
              },
              easeOutQuad: function (e) {
                return -e * (e - 2);
              },
              easeInOutQuad: function (e) {
                return (e /= 0.5) < 1
                  ? 0.5 * e * e
                  : -0.5 * (--e * (e - 2) - 1);
              },
              easeInCubic: function (e) {
                return e * e * e;
              },
              easeOutCubic: function (e) {
                return (e -= 1) * e * e + 1;
              },
              easeInOutCubic: function (e) {
                return (e /= 0.5) < 1
                  ? 0.5 * e * e * e
                  : 0.5 * ((e -= 2) * e * e + 2);
              },
              easeInQuart: function (e) {
                return e * e * e * e;
              },
              easeOutQuart: function (e) {
                return -((e -= 1) * e * e * e - 1);
              },
              easeInOutQuart: function (e) {
                return (e /= 0.5) < 1
                  ? 0.5 * e * e * e * e
                  : -0.5 * ((e -= 2) * e * e * e - 2);
              },
              easeInQuint: function (e) {
                return e * e * e * e * e;
              },
              easeOutQuint: function (e) {
                return (e -= 1) * e * e * e * e + 1;
              },
              easeInOutQuint: function (e) {
                return (e /= 0.5) < 1
                  ? 0.5 * e * e * e * e * e
                  : 0.5 * ((e -= 2) * e * e * e * e + 2);
              },
              easeInSine: function (e) {
                return 1 - Math.cos(e * (Math.PI / 2));
              },
              easeOutSine: function (e) {
                return Math.sin(e * (Math.PI / 2));
              },
              easeInOutSine: function (e) {
                return -0.5 * (Math.cos(Math.PI * e) - 1);
              },
              easeInExpo: function (e) {
                return 0 === e ? 0 : Math.pow(2, 10 * (e - 1));
              },
              easeOutExpo: function (e) {
                return 1 === e ? 1 : 1 - Math.pow(2, -10 * e);
              },
              easeInOutExpo: function (e) {
                return 0 === e
                  ? 0
                  : 1 === e
                  ? 1
                  : (e /= 0.5) < 1
                  ? 0.5 * Math.pow(2, 10 * (e - 1))
                  : 0.5 * (2 - Math.pow(2, -10 * --e));
              },
              easeInCirc: function (e) {
                return e >= 1 ? e : -(Math.sqrt(1 - e * e) - 1);
              },
              easeOutCirc: function (e) {
                return Math.sqrt(1 - (e -= 1) * e);
              },
              easeInOutCirc: function (e) {
                return (e /= 0.5) < 1
                  ? -0.5 * (Math.sqrt(1 - e * e) - 1)
                  : 0.5 * (Math.sqrt(1 - (e -= 2) * e) + 1);
              },
              easeInElastic: function (e) {
                var t = 1.70158,
                  n = 0,
                  i = 1;
                return 0 === e
                  ? 0
                  : 1 === e
                  ? 1
                  : (n || (n = 0.3),
                    i < 1
                      ? ((i = 1), (t = n / 4))
                      : (t = (n / (2 * Math.PI)) * Math.asin(1 / i)),
                    -i *
                      Math.pow(2, 10 * (e -= 1)) *
                      Math.sin(((e - t) * (2 * Math.PI)) / n));
              },
              easeOutElastic: function (e) {
                var t = 1.70158,
                  n = 0,
                  i = 1;
                return 0 === e
                  ? 0
                  : 1 === e
                  ? 1
                  : (n || (n = 0.3),
                    i < 1
                      ? ((i = 1), (t = n / 4))
                      : (t = (n / (2 * Math.PI)) * Math.asin(1 / i)),
                    i *
                      Math.pow(2, -10 * e) *
                      Math.sin(((e - t) * (2 * Math.PI)) / n) +
                      1);
              },
              easeInOutElastic: function (e) {
                var t = 1.70158,
                  n = 0,
                  i = 1;
                return 0 === e
                  ? 0
                  : 2 == (e /= 0.5)
                  ? 1
                  : (n || (n = 0.45),
                    i < 1
                      ? ((i = 1), (t = n / 4))
                      : (t = (n / (2 * Math.PI)) * Math.asin(1 / i)),
                    e < 1
                      ? i *
                        Math.pow(2, 10 * (e -= 1)) *
                        Math.sin(((e - t) * (2 * Math.PI)) / n) *
                        -0.5
                      : i *
                          Math.pow(2, -10 * (e -= 1)) *
                          Math.sin(((e - t) * (2 * Math.PI)) / n) *
                          0.5 +
                        1);
              },
              easeInBack: function (e) {
                var t = 1.70158;
                return e * e * ((t + 1) * e - t);
              },
              easeOutBack: function (e) {
                var t = 1.70158;
                return (e -= 1) * e * ((t + 1) * e + t) + 1;
              },
              easeInOutBack: function (e) {
                var t = 1.70158;
                return (e /= 0.5) < 1
                  ? e * e * ((1 + (t *= 1.525)) * e - t) * 0.5
                  : 0.5 * ((e -= 2) * e * ((1 + (t *= 1.525)) * e + t) + 2);
              },
              easeInBounce: function (e) {
                return 1 - N.easeOutBounce(1 - e);
              },
              easeOutBounce: function (e) {
                return e < 1 / 2.75
                  ? 7.5625 * e * e
                  : e < 2 / 2.75
                  ? 7.5625 * (e -= 1.5 / 2.75) * e + 0.75
                  : e < 2.5 / 2.75
                  ? 7.5625 * (e -= 2.25 / 2.75) * e + 0.9375
                  : 7.5625 * (e -= 2.625 / 2.75) * e + 0.984375;
              },
              easeInOutBounce: function (e) {
                return e < 0.5
                  ? 0.5 * N.easeInBounce(2 * e)
                  : 0.5 * N.easeOutBounce(2 * e - 1) + 0.5;
              },
            },
            R = { effects: N };
          z.easingEffects = N;
          var B = Math.PI,
            V = B / 180,
            Z = 2 * B,
            U = B / 2,
            $ = B / 4,
            J = (2 * B) / 3,
            q = {
              clear: function (e) {
                e.ctx.clearRect(0, 0, e.width, e.height);
              },
              roundedRect: function (e, t, n, i, a, r) {
                if (r) {
                  var l = Math.min(r, a / 2, i / 2),
                    o = t + l,
                    s = n + l,
                    d = t + i - l,
                    u = n + a - l;
                  e.moveTo(t, s),
                    o < d && s < u
                      ? (e.arc(o, s, l, -B, -U),
                        e.arc(d, s, l, -U, 0),
                        e.arc(d, u, l, 0, U),
                        e.arc(o, u, l, U, B))
                      : o < d
                      ? (e.moveTo(o, n),
                        e.arc(d, s, l, -U, U),
                        e.arc(o, s, l, U, B + U))
                      : s < u
                      ? (e.arc(o, s, l, -B, 0), e.arc(o, u, l, 0, B))
                      : e.arc(o, s, l, -B, B),
                    e.closePath(),
                    e.moveTo(t, n);
                } else e.rect(t, n, i, a);
              },
              drawPoint: function (e, t, n, i, a, r) {
                var l,
                  o,
                  s,
                  d,
                  u,
                  c = (r || 0) * V;
                if (
                  t &&
                  "object" == typeof t &&
                  ("[object HTMLImageElement]" === (l = t.toString()) ||
                    "[object HTMLCanvasElement]" === l)
                )
                  return (
                    e.save(),
                    e.translate(i, a),
                    e.rotate(c),
                    e.drawImage(
                      t,
                      -t.width / 2,
                      -t.height / 2,
                      t.width,
                      t.height
                    ),
                    void e.restore()
                  );
                if (!(isNaN(n) || n <= 0)) {
                  switch ((e.beginPath(), t)) {
                    default:
                      e.arc(i, a, n, 0, Z), e.closePath();
                      break;
                    case "triangle":
                      e.moveTo(i + Math.sin(c) * n, a - Math.cos(c) * n),
                        (c += J),
                        e.lineTo(i + Math.sin(c) * n, a - Math.cos(c) * n),
                        (c += J),
                        e.lineTo(i + Math.sin(c) * n, a - Math.cos(c) * n),
                        e.closePath();
                      break;
                    case "rectRounded":
                      (d = n - (u = 0.516 * n)),
                        (o = Math.cos(c + $) * d),
                        (s = Math.sin(c + $) * d),
                        e.arc(i - o, a - s, u, c - B, c - U),
                        e.arc(i + s, a - o, u, c - U, c),
                        e.arc(i + o, a + s, u, c, c + U),
                        e.arc(i - s, a + o, u, c + U, c + B),
                        e.closePath();
                      break;
                    case "rect":
                      if (!r) {
                        (d = Math.SQRT1_2 * n),
                          e.rect(i - d, a - d, 2 * d, 2 * d);
                        break;
                      }
                      c += $;
                    case "rectRot":
                      (o = Math.cos(c) * n),
                        (s = Math.sin(c) * n),
                        e.moveTo(i - o, a - s),
                        e.lineTo(i + s, a - o),
                        e.lineTo(i + o, a + s),
                        e.lineTo(i - s, a + o),
                        e.closePath();
                      break;
                    case "crossRot":
                      c += $;
                    case "cross":
                      (o = Math.cos(c) * n),
                        (s = Math.sin(c) * n),
                        e.moveTo(i - o, a - s),
                        e.lineTo(i + o, a + s),
                        e.moveTo(i + s, a - o),
                        e.lineTo(i - s, a + o);
                      break;
                    case "star":
                      (o = Math.cos(c) * n),
                        (s = Math.sin(c) * n),
                        e.moveTo(i - o, a - s),
                        e.lineTo(i + o, a + s),
                        e.moveTo(i + s, a - o),
                        e.lineTo(i - s, a + o),
                        (c += $),
                        (o = Math.cos(c) * n),
                        (s = Math.sin(c) * n),
                        e.moveTo(i - o, a - s),
                        e.lineTo(i + o, a + s),
                        e.moveTo(i + s, a - o),
                        e.lineTo(i - s, a + o);
                      break;
                    case "line":
                      (o = Math.cos(c) * n),
                        (s = Math.sin(c) * n),
                        e.moveTo(i - o, a - s),
                        e.lineTo(i + o, a + s);
                      break;
                    case "dash":
                      e.moveTo(i, a),
                        e.lineTo(i + Math.cos(c) * n, a + Math.sin(c) * n);
                  }
                  e.fill(), e.stroke();
                }
              },
              _isPointInArea: function (e, t) {
                var n = 1e-6;
                return (
                  e.x > t.left - n &&
                  e.x < t.right + n &&
                  e.y > t.top - n &&
                  e.y < t.bottom + n
                );
              },
              clipArea: function (e, t) {
                e.save(),
                  e.beginPath(),
                  e.rect(t.left, t.top, t.right - t.left, t.bottom - t.top),
                  e.clip();
              },
              unclipArea: function (e) {
                e.restore();
              },
              lineTo: function (e, t, n, i) {
                var a = n.steppedLine;
                if (a) {
                  if ("middle" === a) {
                    var r = (t.x + n.x) / 2;
                    e.lineTo(r, i ? n.y : t.y), e.lineTo(r, i ? t.y : n.y);
                  } else
                    ("after" === a && !i) || ("after" !== a && i)
                      ? e.lineTo(t.x, n.y)
                      : e.lineTo(n.x, t.y);
                  e.lineTo(n.x, n.y);
                } else
                  n.tension
                    ? e.bezierCurveTo(
                        i ? t.controlPointPreviousX : t.controlPointNextX,
                        i ? t.controlPointPreviousY : t.controlPointNextY,
                        i ? n.controlPointNextX : n.controlPointPreviousX,
                        i ? n.controlPointNextY : n.controlPointPreviousY,
                        n.x,
                        n.y
                      )
                    : e.lineTo(n.x, n.y);
              },
            },
            G = q;
          (z.clear = q.clear),
            (z.drawRoundedRectangle = function (e) {
              e.beginPath(), q.roundedRect.apply(q, arguments);
            });
          var X = {
            _set: function (e, t) {
              return z.merge(this[e] || (this[e] = {}), t);
            },
          };
          X._set("global", {
            defaultColor: "rgba(0,0,0,0.1)",
            defaultFontColor: "#666",
            defaultFontFamily:
              "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
            defaultFontSize: 12,
            defaultFontStyle: "normal",
            defaultLineHeight: 1.2,
            showLines: !0,
          });
          var K = X,
            Q = z.valueOrDefault;
          function ee(e) {
            return !e || z.isNullOrUndef(e.size) || z.isNullOrUndef(e.family)
              ? null
              : (e.style ? e.style + " " : "") +
                  (e.weight ? e.weight + " " : "") +
                  e.size +
                  "px " +
                  e.family;
          }
          var te = {
              toLineHeight: function (e, t) {
                var n = ("" + e).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
                if (!n || "normal" === n[1]) return 1.2 * t;
                switch (((e = +n[2]), n[3])) {
                  case "px":
                    return e;
                  case "%":
                    e /= 100;
                }
                return t * e;
              },
              toPadding: function (e) {
                var t, n, i, a;
                return (
                  z.isObject(e)
                    ? ((t = +e.top || 0),
                      (n = +e.right || 0),
                      (i = +e.bottom || 0),
                      (a = +e.left || 0))
                    : (t = n = i = a = +e || 0),
                  {
                    top: t,
                    right: n,
                    bottom: i,
                    left: a,
                    height: t + i,
                    width: a + n,
                  }
                );
              },
              _parseFont: function (e) {
                var t = K.global,
                  n = Q(e.fontSize, t.defaultFontSize),
                  i = {
                    family: Q(e.fontFamily, t.defaultFontFamily),
                    lineHeight: z.options.toLineHeight(
                      Q(e.lineHeight, t.defaultLineHeight),
                      n
                    ),
                    size: n,
                    style: Q(e.fontStyle, t.defaultFontStyle),
                    weight: null,
                    string: "",
                  };
                return (i.string = ee(i)), i;
              },
              resolve: function (e, t, n, i) {
                var a,
                  r,
                  l,
                  o = !0;
                for (a = 0, r = e.length; a < r; ++a)
                  if (
                    void 0 !== (l = e[a]) &&
                    (void 0 !== t &&
                      "function" == typeof l &&
                      ((l = l(t)), (o = !1)),
                    void 0 !== n && z.isArray(l) && ((l = l[n]), (o = !1)),
                    void 0 !== l)
                  )
                    return i && !o && (i.cacheable = !1), l;
              },
            },
            ne = {
              _factorize: function (e) {
                var t,
                  n = [],
                  i = Math.sqrt(e);
                for (t = 1; t < i; t++)
                  e % t == 0 && (n.push(t), n.push(e / t));
                return (
                  i === (0 | i) && n.push(i),
                  n
                    .sort(function (e, t) {
                      return e - t;
                    })
                    .pop(),
                  n
                );
              },
              log10:
                Math.log10 ||
                function (e) {
                  var t = Math.log(e) * Math.LOG10E,
                    n = Math.round(t);
                  return e === Math.pow(10, n) ? n : t;
                },
            },
            ie = ne;
          z.log10 = ne.log10;
          var ae = function (e, t) {
              return {
                x: function (n) {
                  return e + e + t - n;
                },
                setWidth: function (e) {
                  t = e;
                },
                textAlign: function (e) {
                  return "center" === e ? e : "right" === e ? "left" : "right";
                },
                xPlus: function (e, t) {
                  return e - t;
                },
                leftForLtr: function (e, t) {
                  return e - t;
                },
              };
            },
            re = function () {
              return {
                x: function (e) {
                  return e;
                },
                setWidth: function (e) {},
                textAlign: function (e) {
                  return e;
                },
                xPlus: function (e, t) {
                  return e + t;
                },
                leftForLtr: function (e, t) {
                  return e;
                },
              };
            },
            le = z,
            oe = R,
            se = G,
            de = te,
            ue = ie,
            ce = {
              getRtlAdapter: function (e, t, n) {
                return e ? ae(t, n) : re();
              },
              overrideTextDirection: function (e, t) {
                var n, i;
                ("ltr" !== t && "rtl" !== t) ||
                  ((i = [
                    (n = e.canvas.style).getPropertyValue("direction"),
                    n.getPropertyPriority("direction"),
                  ]),
                  n.setProperty("direction", t, "important"),
                  (e.prevTextDirection = i));
              },
              restoreTextDirection: function (e) {
                var t = e.prevTextDirection;
                void 0 !== t &&
                  (delete e.prevTextDirection,
                  e.canvas.style.setProperty("direction", t[0], t[1]));
              },
            };
          function he(e, t, n, i) {
            var a,
              r,
              l,
              o,
              s,
              d,
              u,
              c,
              h,
              m = Object.keys(n);
            for (a = 0, r = m.length; a < r; ++a)
              if (
                ((d = n[(l = m[a])]),
                t.hasOwnProperty(l) || (t[l] = d),
                (o = t[l]) !== d && "_" !== l[0])
              ) {
                if (
                  (e.hasOwnProperty(l) || (e[l] = o),
                  (u = typeof d) == typeof (s = e[l]))
                )
                  if ("string" === u) {
                    if ((c = P(s)).valid && (h = P(d)).valid) {
                      t[l] = h.mix(c, i).rgbString();
                      continue;
                    }
                  } else if (le.isFinite(s) && le.isFinite(d)) {
                    t[l] = s + (d - s) * i;
                    continue;
                  }
                t[l] = d;
              }
          }
          (le.easing = oe),
            (le.canvas = se),
            (le.options = de),
            (le.math = ue),
            (le.rtl = ce);
          var me = function (e) {
            le.extend(this, e), this.initialize.apply(this, arguments);
          };
          le.extend(me.prototype, {
            _type: void 0,
            initialize: function () {
              this.hidden = !1;
            },
            pivot: function () {
              var e = this;
              return (
                e._view || (e._view = le.extend({}, e._model)),
                (e._start = {}),
                e
              );
            },
            transition: function (e) {
              var t = this,
                n = t._model,
                i = t._start,
                a = t._view;
              return n && 1 !== e
                ? (a || (a = t._view = {}),
                  i || (i = t._start = {}),
                  he(i, a, n, e),
                  t)
                : ((t._view = le.extend({}, n)), (t._start = null), t);
            },
            tooltipPosition: function () {
              return { x: this._model.x, y: this._model.y };
            },
            hasValue: function () {
              return le.isNumber(this._model.x) && le.isNumber(this._model.y);
            },
          }),
            (me.extend = le.inherits);
          var fe = me,
            _e = fe.extend({
              chart: null,
              currentStep: 0,
              numSteps: 60,
              easing: "",
              render: null,
              onAnimationProgress: null,
              onAnimationComplete: null,
            }),
            pe = _e;
          Object.defineProperty(_e.prototype, "animationObject", {
            get: function () {
              return this;
            },
          }),
            Object.defineProperty(_e.prototype, "chartInstance", {
              get: function () {
                return this.chart;
              },
              set: function (e) {
                this.chart = e;
              },
            }),
            K._set("global", {
              animation: {
                duration: 1e3,
                easing: "easeOutQuart",
                onProgress: le.noop,
                onComplete: le.noop,
              },
            });
          var ge = {
              animations: [],
              request: null,
              addAnimation: function (e, t, n, i) {
                var a,
                  r,
                  l = this.animations;
                for (
                  t.chart = e,
                    t.startTime = Date.now(),
                    t.duration = n,
                    i || (e.animating = !0),
                    a = 0,
                    r = l.length;
                  a < r;
                  ++a
                )
                  if (l[a].chart === e) return void (l[a] = t);
                l.push(t), 1 === l.length && this.requestAnimationFrame();
              },
              cancelAnimation: function (e) {
                var t = le.findIndex(this.animations, function (t) {
                  return t.chart === e;
                });
                -1 !== t && (this.animations.splice(t, 1), (e.animating = !1));
              },
              requestAnimationFrame: function () {
                var e = this;
                null === e.request &&
                  (e.request = le.requestAnimFrame.call(window, function () {
                    (e.request = null), e.startDigest();
                  }));
              },
              startDigest: function () {
                var e = this;
                e.advance(),
                  e.animations.length > 0 && e.requestAnimationFrame();
              },
              advance: function () {
                for (var e, t, n, i, a = this.animations, r = 0; r < a.length; )
                  (t = (e = a[r]).chart),
                    (n = e.numSteps),
                    (i =
                      Math.floor(
                        ((Date.now() - e.startTime) / e.duration) * n
                      ) + 1),
                    (e.currentStep = Math.min(i, n)),
                    le.callback(e.render, [t, e], t),
                    le.callback(e.onAnimationProgress, [e], t),
                    e.currentStep >= n
                      ? (le.callback(e.onAnimationComplete, [e], t),
                        (t.animating = !1),
                        a.splice(r, 1))
                      : ++r;
              },
            },
            ye = le.options.resolve,
            ve = ["push", "pop", "shift", "splice", "unshift"];
          function Me(e, t) {
            e._chartjs
              ? e._chartjs.listeners.push(t)
              : (Object.defineProperty(e, "_chartjs", {
                  configurable: !0,
                  enumerable: !1,
                  value: { listeners: [t] },
                }),
                ve.forEach(function (t) {
                  var n = "onData" + t.charAt(0).toUpperCase() + t.slice(1),
                    i = e[t];
                  Object.defineProperty(e, t, {
                    configurable: !0,
                    enumerable: !1,
                    value: function () {
                      var t = Array.prototype.slice.call(arguments),
                        a = i.apply(this, t);
                      return (
                        le.each(e._chartjs.listeners, function (e) {
                          "function" == typeof e[n] && e[n].apply(e, t);
                        }),
                        a
                      );
                    },
                  });
                }));
          }
          function be(e, t) {
            var n = e._chartjs;
            if (n) {
              var i = n.listeners,
                a = i.indexOf(t);
              -1 !== a && i.splice(a, 1),
                i.length > 0 ||
                  (ve.forEach(function (t) {
                    delete e[t];
                  }),
                  delete e._chartjs);
            }
          }
          var xe = function (e, t) {
            this.initialize(e, t);
          };
          le.extend(xe.prototype, {
            datasetElementType: null,
            dataElementType: null,
            _datasetElementOptions: [
              "backgroundColor",
              "borderCapStyle",
              "borderColor",
              "borderDash",
              "borderDashOffset",
              "borderJoinStyle",
              "borderWidth",
            ],
            _dataElementOptions: [
              "backgroundColor",
              "borderColor",
              "borderWidth",
              "pointStyle",
            ],
            initialize: function (e, t) {
              var n = this;
              (n.chart = e),
                (n.index = t),
                n.linkScales(),
                n.addElements(),
                (n._type = n.getMeta().type);
            },
            updateIndex: function (e) {
              this.index = e;
            },
            linkScales: function () {
              var e = this,
                t = e.getMeta(),
                n = e.chart,
                i = n.scales,
                a = e.getDataset(),
                r = n.options.scales;
              (null !== t.xAxisID && t.xAxisID in i && !a.xAxisID) ||
                (t.xAxisID = a.xAxisID || r.xAxes[0].id),
                (null !== t.yAxisID && t.yAxisID in i && !a.yAxisID) ||
                  (t.yAxisID = a.yAxisID || r.yAxes[0].id);
            },
            getDataset: function () {
              return this.chart.data.datasets[this.index];
            },
            getMeta: function () {
              return this.chart.getDatasetMeta(this.index);
            },
            getScaleForId: function (e) {
              return this.chart.scales[e];
            },
            _getValueScaleId: function () {
              return this.getMeta().yAxisID;
            },
            _getIndexScaleId: function () {
              return this.getMeta().xAxisID;
            },
            _getValueScale: function () {
              return this.getScaleForId(this._getValueScaleId());
            },
            _getIndexScale: function () {
              return this.getScaleForId(this._getIndexScaleId());
            },
            reset: function () {
              this._update(!0);
            },
            destroy: function () {
              this._data && be(this._data, this);
            },
            createMetaDataset: function () {
              var e = this,
                t = e.datasetElementType;
              return t && new t({ _chart: e.chart, _datasetIndex: e.index });
            },
            createMetaData: function (e) {
              var t = this,
                n = t.dataElementType;
              return (
                n &&
                new n({ _chart: t.chart, _datasetIndex: t.index, _index: e })
              );
            },
            addElements: function () {
              var e,
                t,
                n = this,
                i = n.getMeta(),
                a = n.getDataset().data || [],
                r = i.data;
              for (e = 0, t = a.length; e < t; ++e)
                r[e] = r[e] || n.createMetaData(e);
              i.dataset = i.dataset || n.createMetaDataset();
            },
            addElementAndReset: function (e) {
              var t = this.createMetaData(e);
              this.getMeta().data.splice(e, 0, t), this.updateElement(t, e, !0);
            },
            buildOrUpdateElements: function () {
              var e = this,
                t = e.getDataset(),
                n = t.data || (t.data = []);
              e._data !== n &&
                (e._data && be(e._data, e),
                n && Object.isExtensible(n) && Me(n, e),
                (e._data = n)),
                e.resyncElements();
            },
            _configure: function () {
              var e = this;
              e._config = le.merge(
                Object.create(null),
                [e.chart.options.datasets[e._type], e.getDataset()],
                {
                  merger: function (e, t, n) {
                    "_meta" !== e && "data" !== e && le._merger(e, t, n);
                  },
                }
              );
            },
            _update: function (e) {
              var t = this;
              t._configure(), (t._cachedDataOpts = null), t.update(e);
            },
            update: le.noop,
            transition: function (e) {
              for (
                var t = this.getMeta(), n = t.data || [], i = n.length, a = 0;
                a < i;
                ++a
              )
                n[a].transition(e);
              t.dataset && t.dataset.transition(e);
            },
            draw: function () {
              var e = this.getMeta(),
                t = e.data || [],
                n = t.length,
                i = 0;
              for (e.dataset && e.dataset.draw(); i < n; ++i) t[i].draw();
            },
            getStyle: function (e) {
              var t,
                n = this,
                i = n.getMeta(),
                a = i.dataset;
              return (
                n._configure(),
                a && void 0 === e
                  ? (t = n._resolveDatasetElementOptions(a || {}))
                  : ((e = e || 0),
                    (t = n._resolveDataElementOptions(i.data[e] || {}, e))),
                (!1 !== t.fill && null !== t.fill) ||
                  (t.backgroundColor = t.borderColor),
                t
              );
            },
            _resolveDatasetElementOptions: function (e, t) {
              var n,
                i,
                a,
                r,
                l = this,
                o = l.chart,
                s = l._config,
                d = e.custom || {},
                u =
                  o.options.elements[l.datasetElementType.prototype._type] ||
                  {},
                c = l._datasetElementOptions,
                h = {},
                m = {
                  chart: o,
                  dataset: l.getDataset(),
                  datasetIndex: l.index,
                  hover: t,
                };
              for (n = 0, i = c.length; n < i; ++n)
                (a = c[n]),
                  (r = t
                    ? "hover" + a.charAt(0).toUpperCase() + a.slice(1)
                    : a),
                  (h[a] = ye([d[r], s[r], u[r]], m));
              return h;
            },
            _resolveDataElementOptions: function (e, t) {
              var n = this,
                i = e && e.custom,
                a = n._cachedDataOpts;
              if (a && !i) return a;
              var r,
                l,
                o,
                s,
                d = n.chart,
                u = n._config,
                c = d.options.elements[n.dataElementType.prototype._type] || {},
                h = n._dataElementOptions,
                m = {},
                f = {
                  chart: d,
                  dataIndex: t,
                  dataset: n.getDataset(),
                  datasetIndex: n.index,
                },
                _ = { cacheable: !i };
              if (((i = i || {}), le.isArray(h)))
                for (l = 0, o = h.length; l < o; ++l)
                  m[(s = h[l])] = ye([i[s], u[s], c[s]], f, t, _);
              else
                for (l = 0, o = (r = Object.keys(h)).length; l < o; ++l)
                  m[(s = r[l])] = ye([i[s], u[h[s]], u[s], c[s]], f, t, _);
              return _.cacheable && (n._cachedDataOpts = Object.freeze(m)), m;
            },
            removeHoverStyle: function (e) {
              le.merge(e._model, e.$previousStyle || {}),
                delete e.$previousStyle;
            },
            setHoverStyle: function (e) {
              var t = this.chart.data.datasets[e._datasetIndex],
                n = e._index,
                i = e.custom || {},
                a = e._model,
                r = le.getHoverColor;
              (e.$previousStyle = {
                backgroundColor: a.backgroundColor,
                borderColor: a.borderColor,
                borderWidth: a.borderWidth,
              }),
                (a.backgroundColor = ye(
                  [
                    i.hoverBackgroundColor,
                    t.hoverBackgroundColor,
                    r(a.backgroundColor),
                  ],
                  void 0,
                  n
                )),
                (a.borderColor = ye(
                  [i.hoverBorderColor, t.hoverBorderColor, r(a.borderColor)],
                  void 0,
                  n
                )),
                (a.borderWidth = ye(
                  [i.hoverBorderWidth, t.hoverBorderWidth, a.borderWidth],
                  void 0,
                  n
                ));
            },
            _removeDatasetHoverStyle: function () {
              var e = this.getMeta().dataset;
              e && this.removeHoverStyle(e);
            },
            _setDatasetHoverStyle: function () {
              var e,
                t,
                n,
                i,
                a,
                r,
                l = this.getMeta().dataset,
                o = {};
              if (l) {
                for (
                  r = l._model,
                    a = this._resolveDatasetElementOptions(l, !0),
                    e = 0,
                    t = (i = Object.keys(a)).length;
                  e < t;
                  ++e
                )
                  (o[(n = i[e])] = r[n]), (r[n] = a[n]);
                l.$previousStyle = o;
              }
            },
            resyncElements: function () {
              var e = this,
                t = e.getMeta(),
                n = e.getDataset().data,
                i = t.data.length,
                a = n.length;
              a < i
                ? t.data.splice(a, i - a)
                : a > i && e.insertElements(i, a - i);
            },
            insertElements: function (e, t) {
              for (var n = 0; n < t; ++n) this.addElementAndReset(e + n);
            },
            onDataPush: function () {
              var e = arguments.length;
              this.insertElements(this.getDataset().data.length - e, e);
            },
            onDataPop: function () {
              this.getMeta().data.pop();
            },
            onDataShift: function () {
              this.getMeta().data.shift();
            },
            onDataSplice: function (e, t) {
              this.getMeta().data.splice(e, t),
                this.insertElements(e, arguments.length - 2);
            },
            onDataUnshift: function () {
              this.insertElements(0, arguments.length);
            },
          }),
            (xe.extend = le.inherits);
          var Le = xe,
            we = 2 * Math.PI;
          function ke(e, t) {
            var n = t.startAngle,
              i = t.endAngle,
              a = t.pixelMargin,
              r = a / t.outerRadius,
              l = t.x,
              o = t.y;
            e.beginPath(),
              e.arc(l, o, t.outerRadius, n - r, i + r),
              t.innerRadius > a
                ? ((r = a / t.innerRadius),
                  e.arc(l, o, t.innerRadius - a, i + r, n - r, !0))
                : e.arc(l, o, a, i + Math.PI / 2, n - Math.PI / 2),
              e.closePath(),
              e.clip();
          }
          function Ye(e, t, n, i) {
            var a,
              r = n.endAngle;
            for (
              i &&
                ((n.endAngle = n.startAngle + we),
                ke(e, n),
                (n.endAngle = r),
                n.endAngle === n.startAngle &&
                  n.fullCircles &&
                  ((n.endAngle += we), n.fullCircles--)),
                e.beginPath(),
                e.arc(
                  n.x,
                  n.y,
                  n.innerRadius,
                  n.startAngle + we,
                  n.startAngle,
                  !0
                ),
                a = 0;
              a < n.fullCircles;
              ++a
            )
              e.stroke();
            for (
              e.beginPath(),
                e.arc(n.x, n.y, t.outerRadius, n.startAngle, n.startAngle + we),
                a = 0;
              a < n.fullCircles;
              ++a
            )
              e.stroke();
          }
          function De(e, t, n) {
            var i = "inner" === t.borderAlign;
            i
              ? ((e.lineWidth = 2 * t.borderWidth), (e.lineJoin = "round"))
              : ((e.lineWidth = t.borderWidth), (e.lineJoin = "bevel")),
              n.fullCircles && Ye(e, t, n, i),
              i && ke(e, n),
              e.beginPath(),
              e.arc(n.x, n.y, t.outerRadius, n.startAngle, n.endAngle),
              e.arc(n.x, n.y, n.innerRadius, n.endAngle, n.startAngle, !0),
              e.closePath(),
              e.stroke();
          }
          K._set("global", {
            elements: {
              arc: {
                backgroundColor: K.global.defaultColor,
                borderColor: "#fff",
                borderWidth: 2,
                borderAlign: "center",
              },
            },
          });
          var Te = fe.extend({
              _type: "arc",
              inLabelRange: function (e) {
                var t = this._view;
                return (
                  !!t &&
                  Math.pow(e - t.x, 2) < Math.pow(t.radius + t.hoverRadius, 2)
                );
              },
              inRange: function (e, t) {
                var n = this._view;
                if (n) {
                  for (
                    var i = le.getAngleFromPoint(n, { x: e, y: t }),
                      a = i.angle,
                      r = i.distance,
                      l = n.startAngle,
                      o = n.endAngle;
                    o < l;

                  )
                    o += we;
                  for (; a > o; ) a -= we;
                  for (; a < l; ) a += we;
                  var s = a >= l && a <= o,
                    d = r >= n.innerRadius && r <= n.outerRadius;
                  return s && d;
                }
                return !1;
              },
              getCenterPoint: function () {
                var e = this._view,
                  t = (e.startAngle + e.endAngle) / 2,
                  n = (e.innerRadius + e.outerRadius) / 2;
                return { x: e.x + Math.cos(t) * n, y: e.y + Math.sin(t) * n };
              },
              getArea: function () {
                var e = this._view;
                return (
                  Math.PI *
                  ((e.endAngle - e.startAngle) / (2 * Math.PI)) *
                  (Math.pow(e.outerRadius, 2) - Math.pow(e.innerRadius, 2))
                );
              },
              tooltipPosition: function () {
                var e = this._view,
                  t = e.startAngle + (e.endAngle - e.startAngle) / 2,
                  n = (e.outerRadius - e.innerRadius) / 2 + e.innerRadius;
                return { x: e.x + Math.cos(t) * n, y: e.y + Math.sin(t) * n };
              },
              draw: function () {
                var e,
                  t = this._chart.ctx,
                  n = this._view,
                  i = "inner" === n.borderAlign ? 0.33 : 0,
                  a = {
                    x: n.x,
                    y: n.y,
                    innerRadius: n.innerRadius,
                    outerRadius: Math.max(n.outerRadius - i, 0),
                    pixelMargin: i,
                    startAngle: n.startAngle,
                    endAngle: n.endAngle,
                    fullCircles: Math.floor(n.circumference / we),
                  };
                if (
                  (t.save(),
                  (t.fillStyle = n.backgroundColor),
                  (t.strokeStyle = n.borderColor),
                  a.fullCircles)
                ) {
                  for (
                    a.endAngle = a.startAngle + we,
                      t.beginPath(),
                      t.arc(a.x, a.y, a.outerRadius, a.startAngle, a.endAngle),
                      t.arc(
                        a.x,
                        a.y,
                        a.innerRadius,
                        a.endAngle,
                        a.startAngle,
                        !0
                      ),
                      t.closePath(),
                      e = 0;
                    e < a.fullCircles;
                    ++e
                  )
                    t.fill();
                  a.endAngle = a.startAngle + (n.circumference % we);
                }
                t.beginPath(),
                  t.arc(a.x, a.y, a.outerRadius, a.startAngle, a.endAngle),
                  t.arc(a.x, a.y, a.innerRadius, a.endAngle, a.startAngle, !0),
                  t.closePath(),
                  t.fill(),
                  n.borderWidth && De(t, n, a),
                  t.restore();
              },
            }),
            Se = le.valueOrDefault,
            je = K.global.defaultColor;
          K._set("global", {
            elements: {
              line: {
                tension: 0.4,
                backgroundColor: je,
                borderWidth: 3,
                borderColor: je,
                borderCapStyle: "butt",
                borderDash: [],
                borderDashOffset: 0,
                borderJoinStyle: "miter",
                capBezierPoints: !0,
                fill: !0,
              },
            },
          });
          var Oe = fe.extend({
              _type: "line",
              draw: function () {
                var e,
                  t,
                  n,
                  i = this,
                  a = i._view,
                  r = i._chart.ctx,
                  l = a.spanGaps,
                  o = i._children.slice(),
                  s = K.global,
                  d = s.elements.line,
                  u = -1,
                  c = i._loop;
                if (o.length) {
                  if (i._loop) {
                    for (e = 0; e < o.length; ++e)
                      if (
                        ((t = le.previousItem(o, e)),
                        !o[e]._view.skip && t._view.skip)
                      ) {
                        (o = o.slice(e).concat(o.slice(0, e))), (c = l);
                        break;
                      }
                    c && o.push(o[0]);
                  }
                  for (
                    r.save(),
                      r.lineCap = a.borderCapStyle || d.borderCapStyle,
                      r.setLineDash &&
                        r.setLineDash(a.borderDash || d.borderDash),
                      r.lineDashOffset = Se(
                        a.borderDashOffset,
                        d.borderDashOffset
                      ),
                      r.lineJoin = a.borderJoinStyle || d.borderJoinStyle,
                      r.lineWidth = Se(a.borderWidth, d.borderWidth),
                      r.strokeStyle = a.borderColor || s.defaultColor,
                      r.beginPath(),
                      (n = o[0]._view).skip || (r.moveTo(n.x, n.y), (u = 0)),
                      e = 1;
                    e < o.length;
                    ++e
                  )
                    (n = o[e]._view),
                      (t = -1 === u ? le.previousItem(o, e) : o[u]),
                      n.skip ||
                        ((u !== e - 1 && !l) || -1 === u
                          ? r.moveTo(n.x, n.y)
                          : le.canvas.lineTo(r, t._view, n),
                        (u = e));
                  c && r.closePath(), r.stroke(), r.restore();
                }
              },
            }),
            Ae = le.valueOrDefault,
            He = K.global.defaultColor;
          function Ee(e) {
            var t = this._view;
            return !!t && Math.abs(e - t.x) < t.radius + t.hitRadius;
          }
          function Ce(e) {
            var t = this._view;
            return !!t && Math.abs(e - t.y) < t.radius + t.hitRadius;
          }
          K._set("global", {
            elements: {
              point: {
                radius: 3,
                pointStyle: "circle",
                backgroundColor: He,
                borderColor: He,
                borderWidth: 1,
                hitRadius: 1,
                hoverRadius: 4,
                hoverBorderWidth: 1,
              },
            },
          });
          var Pe = fe.extend({
              _type: "point",
              inRange: function (e, t) {
                var n = this._view;
                return (
                  !!n &&
                  Math.pow(e - n.x, 2) + Math.pow(t - n.y, 2) <
                    Math.pow(n.hitRadius + n.radius, 2)
                );
              },
              inLabelRange: Ee,
              inXRange: Ee,
              inYRange: Ce,
              getCenterPoint: function () {
                var e = this._view;
                return { x: e.x, y: e.y };
              },
              getArea: function () {
                return Math.PI * Math.pow(this._view.radius, 2);
              },
              tooltipPosition: function () {
                var e = this._view;
                return { x: e.x, y: e.y, padding: e.radius + e.borderWidth };
              },
              draw: function (e) {
                var t = this._view,
                  n = this._chart.ctx,
                  i = t.pointStyle,
                  a = t.rotation,
                  r = t.radius,
                  l = t.x,
                  o = t.y,
                  s = K.global,
                  d = s.defaultColor;
                t.skip ||
                  ((void 0 === e || le.canvas._isPointInArea(t, e)) &&
                    ((n.strokeStyle = t.borderColor || d),
                    (n.lineWidth = Ae(
                      t.borderWidth,
                      s.elements.point.borderWidth
                    )),
                    (n.fillStyle = t.backgroundColor || d),
                    le.canvas.drawPoint(n, i, r, l, o, a)));
              },
            }),
            Fe = K.global.defaultColor;
          function Ie(e) {
            return e && void 0 !== e.width;
          }
          function We(e) {
            var t, n, i, a, r;
            return (
              Ie(e)
                ? ((r = e.width / 2),
                  (t = e.x - r),
                  (n = e.x + r),
                  (i = Math.min(e.y, e.base)),
                  (a = Math.max(e.y, e.base)))
                : ((r = e.height / 2),
                  (t = Math.min(e.x, e.base)),
                  (n = Math.max(e.x, e.base)),
                  (i = e.y - r),
                  (a = e.y + r)),
              { left: t, top: i, right: n, bottom: a }
            );
          }
          function ze(e, t, n) {
            return e === t ? n : e === n ? t : e;
          }
          function Ne(e) {
            var t = e.borderSkipped,
              n = {};
            return t
              ? (e.horizontal
                  ? e.base > e.x && (t = ze(t, "left", "right"))
                  : e.base < e.y && (t = ze(t, "bottom", "top")),
                (n[t] = !0),
                n)
              : n;
          }
          function Re(e, t, n) {
            var i,
              a,
              r,
              l,
              o = e.borderWidth,
              s = Ne(e);
            return (
              le.isObject(o)
                ? ((i = +o.top || 0),
                  (a = +o.right || 0),
                  (r = +o.bottom || 0),
                  (l = +o.left || 0))
                : (i = a = r = l = +o || 0),
              {
                t: s.top || i < 0 ? 0 : i > n ? n : i,
                r: s.right || a < 0 ? 0 : a > t ? t : a,
                b: s.bottom || r < 0 ? 0 : r > n ? n : r,
                l: s.left || l < 0 ? 0 : l > t ? t : l,
              }
            );
          }
          function Be(e) {
            var t = We(e),
              n = t.right - t.left,
              i = t.bottom - t.top,
              a = Re(e, n / 2, i / 2);
            return {
              outer: { x: t.left, y: t.top, w: n, h: i },
              inner: {
                x: t.left + a.l,
                y: t.top + a.t,
                w: n - a.l - a.r,
                h: i - a.t - a.b,
              },
            };
          }
          function Ve(e, t, n) {
            var i = null === t,
              a = null === n,
              r = !(!e || (i && a)) && We(e);
            return (
              r &&
              (i || (t >= r.left && t <= r.right)) &&
              (a || (n >= r.top && n <= r.bottom))
            );
          }
          K._set("global", {
            elements: {
              rectangle: {
                backgroundColor: Fe,
                borderColor: Fe,
                borderSkipped: "bottom",
                borderWidth: 0,
              },
            },
          });
          var Ze = fe.extend({
              _type: "rectangle",
              draw: function () {
                var e = this._chart.ctx,
                  t = this._view,
                  n = Be(t),
                  i = n.outer,
                  a = n.inner;
                (e.fillStyle = t.backgroundColor),
                  e.fillRect(i.x, i.y, i.w, i.h),
                  (i.w === a.w && i.h === a.h) ||
                    (e.save(),
                    e.beginPath(),
                    e.rect(i.x, i.y, i.w, i.h),
                    e.clip(),
                    (e.fillStyle = t.borderColor),
                    e.rect(a.x, a.y, a.w, a.h),
                    e.fill("evenodd"),
                    e.restore());
              },
              height: function () {
                var e = this._view;
                return e.base - e.y;
              },
              inRange: function (e, t) {
                return Ve(this._view, e, t);
              },
              inLabelRange: function (e, t) {
                var n = this._view;
                return Ie(n) ? Ve(n, e, null) : Ve(n, null, t);
              },
              inXRange: function (e) {
                return Ve(this._view, e, null);
              },
              inYRange: function (e) {
                return Ve(this._view, null, e);
              },
              getCenterPoint: function () {
                var e,
                  t,
                  n = this._view;
                return (
                  Ie(n)
                    ? ((e = n.x), (t = (n.y + n.base) / 2))
                    : ((e = (n.x + n.base) / 2), (t = n.y)),
                  { x: e, y: t }
                );
              },
              getArea: function () {
                var e = this._view;
                return Ie(e)
                  ? e.width * Math.abs(e.y - e.base)
                  : e.height * Math.abs(e.x - e.base);
              },
              tooltipPosition: function () {
                var e = this._view;
                return { x: e.x, y: e.y };
              },
            }),
            Ue = {},
            $e = Te,
            Je = Oe,
            qe = Pe,
            Ge = Ze;
          (Ue.Arc = $e), (Ue.Line = Je), (Ue.Point = qe), (Ue.Rectangle = Ge);
          var Xe = le._deprecated,
            Ke = le.valueOrDefault;
          function Qe(e, t) {
            var n,
              i,
              a,
              r,
              l = e._length;
            for (a = 1, r = t.length; a < r; ++a)
              l = Math.min(l, Math.abs(t[a] - t[a - 1]));
            for (a = 0, r = e.getTicks().length; a < r; ++a)
              (i = e.getPixelForTick(a)),
                (l = a > 0 ? Math.min(l, Math.abs(i - n)) : l),
                (n = i);
            return l;
          }
          function et(e, t, n) {
            var i,
              a,
              r = n.barThickness,
              l = t.stackCount,
              o = t.pixels[e],
              s = le.isNullOrUndef(r) ? Qe(t.scale, t.pixels) : -1;
            return (
              le.isNullOrUndef(r)
                ? ((i = s * n.categoryPercentage), (a = n.barPercentage))
                : ((i = r * l), (a = 1)),
              { chunk: i / l, ratio: a, start: o - i / 2 }
            );
          }
          function tt(e, t, n) {
            var i,
              a = t.pixels,
              r = a[e],
              l = e > 0 ? a[e - 1] : null,
              o = e < a.length - 1 ? a[e + 1] : null,
              s = n.categoryPercentage;
            return (
              null === l && (l = r - (null === o ? t.end - t.start : o - r)),
              null === o && (o = r + r - l),
              (i = r - ((r - Math.min(l, o)) / 2) * s),
              {
                chunk: ((Math.abs(o - l) / 2) * s) / t.stackCount,
                ratio: n.barPercentage,
                start: i,
              }
            );
          }
          K._set("bar", {
            hover: { mode: "label" },
            scales: {
              xAxes: [
                {
                  type: "category",
                  offset: !0,
                  gridLines: { offsetGridLines: !0 },
                },
              ],
              yAxes: [{ type: "linear" }],
            },
          }),
            K._set("global", {
              datasets: {
                bar: { categoryPercentage: 0.8, barPercentage: 0.9 },
              },
            });
          var nt = Le.extend({
              dataElementType: Ue.Rectangle,
              _dataElementOptions: [
                "backgroundColor",
                "borderColor",
                "borderSkipped",
                "borderWidth",
                "barPercentage",
                "barThickness",
                "categoryPercentage",
                "maxBarThickness",
                "minBarLength",
              ],
              initialize: function () {
                var e,
                  t,
                  n = this;
                Le.prototype.initialize.apply(n, arguments),
                  ((e = n.getMeta()).stack = n.getDataset().stack),
                  (e.bar = !0),
                  (t = n._getIndexScale().options),
                  Xe(
                    "bar chart",
                    t.barPercentage,
                    "scales.[x/y]Axes.barPercentage",
                    "dataset.barPercentage"
                  ),
                  Xe(
                    "bar chart",
                    t.barThickness,
                    "scales.[x/y]Axes.barThickness",
                    "dataset.barThickness"
                  ),
                  Xe(
                    "bar chart",
                    t.categoryPercentage,
                    "scales.[x/y]Axes.categoryPercentage",
                    "dataset.categoryPercentage"
                  ),
                  Xe(
                    "bar chart",
                    n._getValueScale().options.minBarLength,
                    "scales.[x/y]Axes.minBarLength",
                    "dataset.minBarLength"
                  ),
                  Xe(
                    "bar chart",
                    t.maxBarThickness,
                    "scales.[x/y]Axes.maxBarThickness",
                    "dataset.maxBarThickness"
                  );
              },
              update: function (e) {
                var t,
                  n,
                  i = this,
                  a = i.getMeta().data;
                for (i._ruler = i.getRuler(), t = 0, n = a.length; t < n; ++t)
                  i.updateElement(a[t], t, e);
              },
              updateElement: function (e, t, n) {
                var i = this,
                  a = i.getMeta(),
                  r = i.getDataset(),
                  l = i._resolveDataElementOptions(e, t);
                (e._xScale = i.getScaleForId(a.xAxisID)),
                  (e._yScale = i.getScaleForId(a.yAxisID)),
                  (e._datasetIndex = i.index),
                  (e._index = t),
                  (e._model = {
                    backgroundColor: l.backgroundColor,
                    borderColor: l.borderColor,
                    borderSkipped: l.borderSkipped,
                    borderWidth: l.borderWidth,
                    datasetLabel: r.label,
                    label: i.chart.data.labels[t],
                  }),
                  le.isArray(r.data[t]) && (e._model.borderSkipped = null),
                  i._updateElementGeometry(e, t, n, l),
                  e.pivot();
              },
              _updateElementGeometry: function (e, t, n, i) {
                var a = this,
                  r = e._model,
                  l = a._getValueScale(),
                  o = l.getBasePixel(),
                  s = l.isHorizontal(),
                  d = a._ruler || a.getRuler(),
                  u = a.calculateBarValuePixels(a.index, t, i),
                  c = a.calculateBarIndexPixels(a.index, t, d, i);
                (r.horizontal = s),
                  (r.base = n ? o : u.base),
                  (r.x = s ? (n ? o : u.head) : c.center),
                  (r.y = s ? c.center : n ? o : u.head),
                  (r.height = s ? c.size : void 0),
                  (r.width = s ? void 0 : c.size);
              },
              _getStacks: function (e) {
                var t,
                  n,
                  i = this,
                  a = i._getIndexScale(),
                  r = a._getMatchingVisibleMetas(i._type),
                  l = a.options.stacked,
                  o = r.length,
                  s = [];
                for (
                  t = 0;
                  t < o &&
                  ((n = r[t]),
                  (!1 === l ||
                    -1 === s.indexOf(n.stack) ||
                    (void 0 === l && void 0 === n.stack)) &&
                    s.push(n.stack),
                  n.index !== e);
                  ++t
                );
                return s;
              },
              getStackCount: function () {
                return this._getStacks().length;
              },
              getStackIndex: function (e, t) {
                var n = this._getStacks(e),
                  i = void 0 !== t ? n.indexOf(t) : -1;
                return -1 === i ? n.length - 1 : i;
              },
              getRuler: function () {
                var e,
                  t,
                  n = this,
                  i = n._getIndexScale(),
                  a = [];
                for (e = 0, t = n.getMeta().data.length; e < t; ++e)
                  a.push(i.getPixelForValue(null, e, n.index));
                return {
                  pixels: a,
                  start: i._startPixel,
                  end: i._endPixel,
                  stackCount: n.getStackCount(),
                  scale: i,
                };
              },
              calculateBarValuePixels: function (e, t, n) {
                var i,
                  a,
                  r,
                  l,
                  o,
                  s,
                  d,
                  u = this,
                  c = u.chart,
                  h = u._getValueScale(),
                  m = h.isHorizontal(),
                  f = c.data.datasets,
                  _ = h._getMatchingVisibleMetas(u._type),
                  p = h._parseValue(f[e].data[t]),
                  g = n.minBarLength,
                  y = h.options.stacked,
                  v = u.getMeta().stack,
                  M =
                    void 0 === p.start
                      ? 0
                      : p.max >= 0 && p.min >= 0
                      ? p.min
                      : p.max,
                  b =
                    void 0 === p.start
                      ? p.end
                      : p.max >= 0 && p.min >= 0
                      ? p.max - p.min
                      : p.min - p.max,
                  x = _.length;
                if (y || (void 0 === y && void 0 !== v))
                  for (i = 0; i < x && (a = _[i]).index !== e; ++i)
                    a.stack === v &&
                      ((r =
                        void 0 === (d = h._parseValue(f[a.index].data[t])).start
                          ? d.end
                          : d.min >= 0 && d.max >= 0
                          ? d.max
                          : d.min),
                      ((p.min < 0 && r < 0) || (p.max >= 0 && r > 0)) &&
                        (M += r));
                return (
                  (l = h.getPixelForValue(M)),
                  (s = (o = h.getPixelForValue(M + b)) - l),
                  void 0 !== g &&
                    Math.abs(s) < g &&
                    ((s = g),
                    (o = (b >= 0 && !m) || (b < 0 && m) ? l - g : l + g)),
                  { size: s, base: l, head: o, center: o + s / 2 }
                );
              },
              calculateBarIndexPixels: function (e, t, n, i) {
                var a = this,
                  r = "flex" === i.barThickness ? tt(t, n, i) : et(t, n, i),
                  l = a.getStackIndex(e, a.getMeta().stack),
                  o = r.start + r.chunk * l + r.chunk / 2,
                  s = Math.min(Ke(i.maxBarThickness, 1 / 0), r.chunk * r.ratio);
                return { base: o - s / 2, head: o + s / 2, center: o, size: s };
              },
              draw: function () {
                var e = this,
                  t = e.chart,
                  n = e._getValueScale(),
                  i = e.getMeta().data,
                  a = e.getDataset(),
                  r = i.length,
                  l = 0;
                for (le.canvas.clipArea(t.ctx, t.chartArea); l < r; ++l) {
                  var o = n._parseValue(a.data[l]);
                  isNaN(o.min) || isNaN(o.max) || i[l].draw();
                }
                le.canvas.unclipArea(t.ctx);
              },
              _resolveDataElementOptions: function () {
                var e = this,
                  t = le.extend(
                    {},
                    Le.prototype._resolveDataElementOptions.apply(e, arguments)
                  ),
                  n = e._getIndexScale().options,
                  i = e._getValueScale().options;
                return (
                  (t.barPercentage = Ke(n.barPercentage, t.barPercentage)),
                  (t.barThickness = Ke(n.barThickness, t.barThickness)),
                  (t.categoryPercentage = Ke(
                    n.categoryPercentage,
                    t.categoryPercentage
                  )),
                  (t.maxBarThickness = Ke(
                    n.maxBarThickness,
                    t.maxBarThickness
                  )),
                  (t.minBarLength = Ke(i.minBarLength, t.minBarLength)),
                  t
                );
              },
            }),
            it = le.valueOrDefault,
            at = le.options.resolve;
          K._set("bubble", {
            hover: { mode: "single" },
            scales: {
              xAxes: [{ type: "linear", position: "bottom", id: "x-axis-0" }],
              yAxes: [{ type: "linear", position: "left", id: "y-axis-0" }],
            },
            tooltips: {
              callbacks: {
                title: function () {
                  return "";
                },
                label: function (e, t) {
                  var n = t.datasets[e.datasetIndex].label || "",
                    i = t.datasets[e.datasetIndex].data[e.index];
                  return (
                    n + ": (" + e.xLabel + ", " + e.yLabel + ", " + i.r + ")"
                  );
                },
              },
            },
          });
          var rt = Le.extend({
              dataElementType: Ue.Point,
              _dataElementOptions: [
                "backgroundColor",
                "borderColor",
                "borderWidth",
                "hoverBackgroundColor",
                "hoverBorderColor",
                "hoverBorderWidth",
                "hoverRadius",
                "hitRadius",
                "pointStyle",
                "rotation",
              ],
              update: function (e) {
                var t = this,
                  n = t.getMeta().data;
                le.each(n, function (n, i) {
                  t.updateElement(n, i, e);
                });
              },
              updateElement: function (e, t, n) {
                var i = this,
                  a = i.getMeta(),
                  r = e.custom || {},
                  l = i.getScaleForId(a.xAxisID),
                  o = i.getScaleForId(a.yAxisID),
                  s = i._resolveDataElementOptions(e, t),
                  d = i.getDataset().data[t],
                  u = i.index,
                  c = n
                    ? l.getPixelForDecimal(0.5)
                    : l.getPixelForValue("object" == typeof d ? d : NaN, t, u),
                  h = n ? o.getBasePixel() : o.getPixelForValue(d, t, u);
                (e._xScale = l),
                  (e._yScale = o),
                  (e._options = s),
                  (e._datasetIndex = u),
                  (e._index = t),
                  (e._model = {
                    backgroundColor: s.backgroundColor,
                    borderColor: s.borderColor,
                    borderWidth: s.borderWidth,
                    hitRadius: s.hitRadius,
                    pointStyle: s.pointStyle,
                    rotation: s.rotation,
                    radius: n ? 0 : s.radius,
                    skip: r.skip || isNaN(c) || isNaN(h),
                    x: c,
                    y: h,
                  }),
                  e.pivot();
              },
              setHoverStyle: function (e) {
                var t = e._model,
                  n = e._options,
                  i = le.getHoverColor;
                (e.$previousStyle = {
                  backgroundColor: t.backgroundColor,
                  borderColor: t.borderColor,
                  borderWidth: t.borderWidth,
                  radius: t.radius,
                }),
                  (t.backgroundColor = it(
                    n.hoverBackgroundColor,
                    i(n.backgroundColor)
                  )),
                  (t.borderColor = it(n.hoverBorderColor, i(n.borderColor))),
                  (t.borderWidth = it(n.hoverBorderWidth, n.borderWidth)),
                  (t.radius = n.radius + n.hoverRadius);
              },
              _resolveDataElementOptions: function (e, t) {
                var n = this,
                  i = n.chart,
                  a = n.getDataset(),
                  r = e.custom || {},
                  l = a.data[t] || {},
                  o = Le.prototype._resolveDataElementOptions.apply(
                    n,
                    arguments
                  ),
                  s = {
                    chart: i,
                    dataIndex: t,
                    dataset: a,
                    datasetIndex: n.index,
                  };
                return (
                  n._cachedDataOpts === o && (o = le.extend({}, o)),
                  (o.radius = at(
                    [
                      r.radius,
                      l.r,
                      n._config.radius,
                      i.options.elements.point.radius,
                    ],
                    s,
                    t
                  )),
                  o
                );
              },
            }),
            lt = le.valueOrDefault,
            ot = Math.PI,
            st = 2 * ot,
            dt = ot / 2;
          K._set("doughnut", {
            animation: { animateRotate: !0, animateScale: !1 },
            hover: { mode: "single" },
            legendCallback: function (e) {
              var t,
                n,
                i,
                a = document.createElement("ul"),
                r = e.data,
                l = r.datasets,
                o = r.labels;
              if ((a.setAttribute("class", e.id + "-legend"), l.length))
                for (t = 0, n = l[0].data.length; t < n; ++t)
                  ((i = a.appendChild(
                    document.createElement("li")
                  )).appendChild(
                    document.createElement("span")
                  ).style.backgroundColor = l[0].backgroundColor[t]),
                    o[t] && i.appendChild(document.createTextNode(o[t]));
              return a.outerHTML;
            },
            legend: {
              labels: {
                generateLabels: function (e) {
                  var t = e.data;
                  return t.labels.length && t.datasets.length
                    ? t.labels.map(function (n, i) {
                        var a = e.getDatasetMeta(0),
                          r = a.controller.getStyle(i);
                        return {
                          text: n,
                          fillStyle: r.backgroundColor,
                          strokeStyle: r.borderColor,
                          lineWidth: r.borderWidth,
                          hidden:
                            isNaN(t.datasets[0].data[i]) || a.data[i].hidden,
                          index: i,
                        };
                      })
                    : [];
                },
              },
              onClick: function (e, t) {
                var n,
                  i,
                  a,
                  r = t.index,
                  l = this.chart;
                for (n = 0, i = (l.data.datasets || []).length; n < i; ++n)
                  (a = l.getDatasetMeta(n)).data[r] &&
                    (a.data[r].hidden = !a.data[r].hidden);
                l.update();
              },
            },
            cutoutPercentage: 50,
            rotation: -dt,
            circumference: st,
            tooltips: {
              callbacks: {
                title: function () {
                  return "";
                },
                label: function (e, t) {
                  var n = t.labels[e.index],
                    i = ": " + t.datasets[e.datasetIndex].data[e.index];
                  return (
                    le.isArray(n) ? ((n = n.slice())[0] += i) : (n += i), n
                  );
                },
              },
            },
          });
          var ut = Le.extend({
            dataElementType: Ue.Arc,
            linkScales: le.noop,
            _dataElementOptions: [
              "backgroundColor",
              "borderColor",
              "borderWidth",
              "borderAlign",
              "hoverBackgroundColor",
              "hoverBorderColor",
              "hoverBorderWidth",
            ],
            getRingIndex: function (e) {
              for (var t = 0, n = 0; n < e; ++n)
                this.chart.isDatasetVisible(n) && ++t;
              return t;
            },
            update: function (e) {
              var t,
                n,
                i,
                a,
                r = this,
                l = r.chart,
                o = l.chartArea,
                s = l.options,
                d = 1,
                u = 1,
                c = 0,
                h = 0,
                m = r.getMeta(),
                f = m.data,
                _ = s.cutoutPercentage / 100 || 0,
                p = s.circumference,
                g = r._getRingWeight(r.index);
              if (p < st) {
                var y = s.rotation % st,
                  v = (y += y >= ot ? -st : y < -ot ? st : 0) + p,
                  M = Math.cos(y),
                  b = Math.sin(y),
                  x = Math.cos(v),
                  L = Math.sin(v),
                  w = (y <= 0 && v >= 0) || v >= st,
                  k = (y <= dt && v >= dt) || v >= st + dt,
                  Y = (y <= -dt && v >= -dt) || v >= ot + dt,
                  D = y === -ot || v >= ot ? -1 : Math.min(M, M * _, x, x * _),
                  T = Y ? -1 : Math.min(b, b * _, L, L * _),
                  S = w ? 1 : Math.max(M, M * _, x, x * _),
                  j = k ? 1 : Math.max(b, b * _, L, L * _);
                (d = (S - D) / 2),
                  (u = (j - T) / 2),
                  (c = -(S + D) / 2),
                  (h = -(j + T) / 2);
              }
              for (i = 0, a = f.length; i < a; ++i)
                f[i]._options = r._resolveDataElementOptions(f[i], i);
              for (
                l.borderWidth = r.getMaxBorderWidth(),
                  t = (o.right - o.left - l.borderWidth) / d,
                  n = (o.bottom - o.top - l.borderWidth) / u,
                  l.outerRadius = Math.max(Math.min(t, n) / 2, 0),
                  l.innerRadius = Math.max(l.outerRadius * _, 0),
                  l.radiusLength =
                    (l.outerRadius - l.innerRadius) /
                    (r._getVisibleDatasetWeightTotal() || 1),
                  l.offsetX = c * l.outerRadius,
                  l.offsetY = h * l.outerRadius,
                  m.total = r.calculateTotal(),
                  r.outerRadius =
                    l.outerRadius -
                    l.radiusLength * r._getRingWeightOffset(r.index),
                  r.innerRadius = Math.max(
                    r.outerRadius - l.radiusLength * g,
                    0
                  ),
                  i = 0,
                  a = f.length;
                i < a;
                ++i
              )
                r.updateElement(f[i], i, e);
            },
            updateElement: function (e, t, n) {
              var i = this,
                a = i.chart,
                r = a.chartArea,
                l = a.options,
                o = l.animation,
                s = (r.left + r.right) / 2,
                d = (r.top + r.bottom) / 2,
                u = l.rotation,
                c = l.rotation,
                h = i.getDataset(),
                m =
                  (n && o.animateRotate) || e.hidden
                    ? 0
                    : i.calculateCircumference(h.data[t]) *
                      (l.circumference / st),
                f = n && o.animateScale ? 0 : i.innerRadius,
                _ = n && o.animateScale ? 0 : i.outerRadius,
                p = e._options || {};
              le.extend(e, {
                _datasetIndex: i.index,
                _index: t,
                _model: {
                  backgroundColor: p.backgroundColor,
                  borderColor: p.borderColor,
                  borderWidth: p.borderWidth,
                  borderAlign: p.borderAlign,
                  x: s + a.offsetX,
                  y: d + a.offsetY,
                  startAngle: u,
                  endAngle: c,
                  circumference: m,
                  outerRadius: _,
                  innerRadius: f,
                  label: le.valueAtIndexOrDefault(h.label, t, a.data.labels[t]),
                },
              });
              var g = e._model;
              (n && o.animateRotate) ||
                ((g.startAngle =
                  0 === t
                    ? l.rotation
                    : i.getMeta().data[t - 1]._model.endAngle),
                (g.endAngle = g.startAngle + g.circumference)),
                e.pivot();
            },
            calculateTotal: function () {
              var e,
                t = this.getDataset(),
                n = this.getMeta(),
                i = 0;
              return (
                le.each(n.data, function (n, a) {
                  (e = t.data[a]), isNaN(e) || n.hidden || (i += Math.abs(e));
                }),
                i
              );
            },
            calculateCircumference: function (e) {
              var t = this.getMeta().total;
              return t > 0 && !isNaN(e) ? st * (Math.abs(e) / t) : 0;
            },
            getMaxBorderWidth: function (e) {
              var t,
                n,
                i,
                a,
                r,
                l,
                o,
                s,
                d = this,
                u = 0,
                c = d.chart;
              if (!e)
                for (t = 0, n = c.data.datasets.length; t < n; ++t)
                  if (c.isDatasetVisible(t)) {
                    (e = (i = c.getDatasetMeta(t)).data),
                      t !== d.index && (r = i.controller);
                    break;
                  }
              if (!e) return 0;
              for (t = 0, n = e.length; t < n; ++t)
                (a = e[t]),
                  r
                    ? (r._configure(), (l = r._resolveDataElementOptions(a, t)))
                    : (l = a._options),
                  "inner" !== l.borderAlign &&
                    ((o = l.borderWidth),
                    (u =
                      (s = l.hoverBorderWidth) > (u = o > u ? o : u) ? s : u));
              return u;
            },
            setHoverStyle: function (e) {
              var t = e._model,
                n = e._options,
                i = le.getHoverColor;
              (e.$previousStyle = {
                backgroundColor: t.backgroundColor,
                borderColor: t.borderColor,
                borderWidth: t.borderWidth,
              }),
                (t.backgroundColor = lt(
                  n.hoverBackgroundColor,
                  i(n.backgroundColor)
                )),
                (t.borderColor = lt(n.hoverBorderColor, i(n.borderColor))),
                (t.borderWidth = lt(n.hoverBorderWidth, n.borderWidth));
            },
            _getRingWeightOffset: function (e) {
              for (var t = 0, n = 0; n < e; ++n)
                this.chart.isDatasetVisible(n) && (t += this._getRingWeight(n));
              return t;
            },
            _getRingWeight: function (e) {
              return Math.max(lt(this.chart.data.datasets[e].weight, 1), 0);
            },
            _getVisibleDatasetWeightTotal: function () {
              return this._getRingWeightOffset(this.chart.data.datasets.length);
            },
          });
          K._set("horizontalBar", {
            hover: { mode: "index", axis: "y" },
            scales: {
              xAxes: [{ type: "linear", position: "bottom" }],
              yAxes: [
                {
                  type: "category",
                  position: "left",
                  offset: !0,
                  gridLines: { offsetGridLines: !0 },
                },
              ],
            },
            elements: { rectangle: { borderSkipped: "left" } },
            tooltips: { mode: "index", axis: "y" },
          }),
            K._set("global", {
              datasets: {
                horizontalBar: { categoryPercentage: 0.8, barPercentage: 0.9 },
              },
            });
          var ct = nt.extend({
              _getValueScaleId: function () {
                return this.getMeta().xAxisID;
              },
              _getIndexScaleId: function () {
                return this.getMeta().yAxisID;
              },
            }),
            ht = le.valueOrDefault,
            mt = le.options.resolve,
            ft = le.canvas._isPointInArea;
          function _t(e, t) {
            var n = (e && e.options.ticks) || {},
              i = n.reverse,
              a = void 0 === n.min ? t : 0,
              r = void 0 === n.max ? t : 0;
            return { start: i ? r : a, end: i ? a : r };
          }
          function pt(e, t, n) {
            var i = n / 2,
              a = _t(e, i),
              r = _t(t, i);
            return { top: r.end, right: a.end, bottom: r.start, left: a.start };
          }
          function gt(e) {
            var t, n, i, a;
            return (
              le.isObject(e)
                ? ((t = e.top), (n = e.right), (i = e.bottom), (a = e.left))
                : (t = n = i = a = e),
              { top: t, right: n, bottom: i, left: a }
            );
          }
          K._set("line", {
            showLines: !0,
            spanGaps: !1,
            hover: { mode: "label" },
            scales: {
              xAxes: [{ type: "category", id: "x-axis-0" }],
              yAxes: [{ type: "linear", id: "y-axis-0" }],
            },
          });
          var yt = Le.extend({
              datasetElementType: Ue.Line,
              dataElementType: Ue.Point,
              _datasetElementOptions: [
                "backgroundColor",
                "borderCapStyle",
                "borderColor",
                "borderDash",
                "borderDashOffset",
                "borderJoinStyle",
                "borderWidth",
                "cubicInterpolationMode",
                "fill",
              ],
              _dataElementOptions: {
                backgroundColor: "pointBackgroundColor",
                borderColor: "pointBorderColor",
                borderWidth: "pointBorderWidth",
                hitRadius: "pointHitRadius",
                hoverBackgroundColor: "pointHoverBackgroundColor",
                hoverBorderColor: "pointHoverBorderColor",
                hoverBorderWidth: "pointHoverBorderWidth",
                hoverRadius: "pointHoverRadius",
                pointStyle: "pointStyle",
                radius: "pointRadius",
                rotation: "pointRotation",
              },
              update: function (e) {
                var t,
                  n,
                  i = this,
                  a = i.getMeta(),
                  r = a.dataset,
                  l = a.data || [],
                  o = i.chart.options,
                  s = i._config,
                  d = (i._showLine = ht(s.showLine, o.showLines));
                for (
                  i._xScale = i.getScaleForId(a.xAxisID),
                    i._yScale = i.getScaleForId(a.yAxisID),
                    d &&
                      (void 0 !== s.tension &&
                        void 0 === s.lineTension &&
                        (s.lineTension = s.tension),
                      (r._scale = i._yScale),
                      (r._datasetIndex = i.index),
                      (r._children = l),
                      (r._model = i._resolveDatasetElementOptions(r)),
                      r.pivot()),
                    t = 0,
                    n = l.length;
                  t < n;
                  ++t
                )
                  i.updateElement(l[t], t, e);
                for (
                  d && 0 !== r._model.tension && i.updateBezierControlPoints(),
                    t = 0,
                    n = l.length;
                  t < n;
                  ++t
                )
                  l[t].pivot();
              },
              updateElement: function (e, t, n) {
                var i,
                  a,
                  r = this,
                  l = r.getMeta(),
                  o = e.custom || {},
                  s = r.getDataset(),
                  d = r.index,
                  u = s.data[t],
                  c = r._xScale,
                  h = r._yScale,
                  m = l.dataset._model,
                  f = r._resolveDataElementOptions(e, t);
                (i = c.getPixelForValue("object" == typeof u ? u : NaN, t, d)),
                  (a = n ? h.getBasePixel() : r.calculatePointY(u, t, d)),
                  (e._xScale = c),
                  (e._yScale = h),
                  (e._options = f),
                  (e._datasetIndex = d),
                  (e._index = t),
                  (e._model = {
                    x: i,
                    y: a,
                    skip: o.skip || isNaN(i) || isNaN(a),
                    radius: f.radius,
                    pointStyle: f.pointStyle,
                    rotation: f.rotation,
                    backgroundColor: f.backgroundColor,
                    borderColor: f.borderColor,
                    borderWidth: f.borderWidth,
                    tension: ht(o.tension, m ? m.tension : 0),
                    steppedLine: !!m && m.steppedLine,
                    hitRadius: f.hitRadius,
                  });
              },
              _resolveDatasetElementOptions: function (e) {
                var t = this,
                  n = t._config,
                  i = e.custom || {},
                  a = t.chart.options,
                  r = a.elements.line,
                  l = Le.prototype._resolveDatasetElementOptions.apply(
                    t,
                    arguments
                  );
                return (
                  (l.spanGaps = ht(n.spanGaps, a.spanGaps)),
                  (l.tension = ht(n.lineTension, r.tension)),
                  (l.steppedLine = mt([
                    i.steppedLine,
                    n.steppedLine,
                    r.stepped,
                  ])),
                  (l.clip = gt(
                    ht(n.clip, pt(t._xScale, t._yScale, l.borderWidth))
                  )),
                  l
                );
              },
              calculatePointY: function (e, t, n) {
                var i,
                  a,
                  r,
                  l,
                  o,
                  s,
                  d,
                  u = this,
                  c = u.chart,
                  h = u._yScale,
                  m = 0,
                  f = 0;
                if (h.options.stacked) {
                  for (
                    o = +h.getRightValue(e),
                      d = (s = c._getSortedVisibleDatasetMetas()).length,
                      i = 0;
                    i < d && (r = s[i]).index !== n;
                    ++i
                  )
                    (a = c.data.datasets[r.index]),
                      "line" === r.type &&
                        r.yAxisID === h.id &&
                        ((l = +h.getRightValue(a.data[t])) < 0
                          ? (f += l || 0)
                          : (m += l || 0));
                  return o < 0
                    ? h.getPixelForValue(f + o)
                    : h.getPixelForValue(m + o);
                }
                return h.getPixelForValue(e);
              },
              updateBezierControlPoints: function () {
                var e,
                  t,
                  n,
                  i,
                  a = this,
                  r = a.chart,
                  l = a.getMeta(),
                  o = l.dataset._model,
                  s = r.chartArea,
                  d = l.data || [];
                function u(e, t, n) {
                  return Math.max(Math.min(e, n), t);
                }
                if (
                  (o.spanGaps &&
                    (d = d.filter(function (e) {
                      return !e._model.skip;
                    })),
                  "monotone" === o.cubicInterpolationMode)
                )
                  le.splineCurveMonotone(d);
                else
                  for (e = 0, t = d.length; e < t; ++e)
                    (n = d[e]._model),
                      (i = le.splineCurve(
                        le.previousItem(d, e)._model,
                        n,
                        le.nextItem(d, e)._model,
                        o.tension
                      )),
                      (n.controlPointPreviousX = i.previous.x),
                      (n.controlPointPreviousY = i.previous.y),
                      (n.controlPointNextX = i.next.x),
                      (n.controlPointNextY = i.next.y);
                if (r.options.elements.line.capBezierPoints)
                  for (e = 0, t = d.length; e < t; ++e)
                    (n = d[e]._model),
                      ft(n, s) &&
                        (e > 0 &&
                          ft(d[e - 1]._model, s) &&
                          ((n.controlPointPreviousX = u(
                            n.controlPointPreviousX,
                            s.left,
                            s.right
                          )),
                          (n.controlPointPreviousY = u(
                            n.controlPointPreviousY,
                            s.top,
                            s.bottom
                          ))),
                        e < d.length - 1 &&
                          ft(d[e + 1]._model, s) &&
                          ((n.controlPointNextX = u(
                            n.controlPointNextX,
                            s.left,
                            s.right
                          )),
                          (n.controlPointNextY = u(
                            n.controlPointNextY,
                            s.top,
                            s.bottom
                          ))));
              },
              draw: function () {
                var e,
                  t = this,
                  n = t.chart,
                  i = t.getMeta(),
                  a = i.data || [],
                  r = n.chartArea,
                  l = n.canvas,
                  o = 0,
                  s = a.length;
                for (
                  t._showLine &&
                  ((e = i.dataset._model.clip),
                  le.canvas.clipArea(n.ctx, {
                    left: !1 === e.left ? 0 : r.left - e.left,
                    right: !1 === e.right ? l.width : r.right + e.right,
                    top: !1 === e.top ? 0 : r.top - e.top,
                    bottom: !1 === e.bottom ? l.height : r.bottom + e.bottom,
                  }),
                  i.dataset.draw(),
                  le.canvas.unclipArea(n.ctx));
                  o < s;
                  ++o
                )
                  a[o].draw(r);
              },
              setHoverStyle: function (e) {
                var t = e._model,
                  n = e._options,
                  i = le.getHoverColor;
                (e.$previousStyle = {
                  backgroundColor: t.backgroundColor,
                  borderColor: t.borderColor,
                  borderWidth: t.borderWidth,
                  radius: t.radius,
                }),
                  (t.backgroundColor = ht(
                    n.hoverBackgroundColor,
                    i(n.backgroundColor)
                  )),
                  (t.borderColor = ht(n.hoverBorderColor, i(n.borderColor))),
                  (t.borderWidth = ht(n.hoverBorderWidth, n.borderWidth)),
                  (t.radius = ht(n.hoverRadius, n.radius));
              },
            }),
            vt = le.options.resolve;
          K._set("polarArea", {
            scale: {
              type: "radialLinear",
              angleLines: { display: !1 },
              gridLines: { circular: !0 },
              pointLabels: { display: !1 },
              ticks: { beginAtZero: !0 },
            },
            animation: { animateRotate: !0, animateScale: !0 },
            startAngle: -0.5 * Math.PI,
            legendCallback: function (e) {
              var t,
                n,
                i,
                a = document.createElement("ul"),
                r = e.data,
                l = r.datasets,
                o = r.labels;
              if ((a.setAttribute("class", e.id + "-legend"), l.length))
                for (t = 0, n = l[0].data.length; t < n; ++t)
                  ((i = a.appendChild(
                    document.createElement("li")
                  )).appendChild(
                    document.createElement("span")
                  ).style.backgroundColor = l[0].backgroundColor[t]),
                    o[t] && i.appendChild(document.createTextNode(o[t]));
              return a.outerHTML;
            },
            legend: {
              labels: {
                generateLabels: function (e) {
                  var t = e.data;
                  return t.labels.length && t.datasets.length
                    ? t.labels.map(function (n, i) {
                        var a = e.getDatasetMeta(0),
                          r = a.controller.getStyle(i);
                        return {
                          text: n,
                          fillStyle: r.backgroundColor,
                          strokeStyle: r.borderColor,
                          lineWidth: r.borderWidth,
                          hidden:
                            isNaN(t.datasets[0].data[i]) || a.data[i].hidden,
                          index: i,
                        };
                      })
                    : [];
                },
              },
              onClick: function (e, t) {
                var n,
                  i,
                  a,
                  r = t.index,
                  l = this.chart;
                for (n = 0, i = (l.data.datasets || []).length; n < i; ++n)
                  (a = l.getDatasetMeta(n)).data[r].hidden = !a.data[r].hidden;
                l.update();
              },
            },
            tooltips: {
              callbacks: {
                title: function () {
                  return "";
                },
                label: function (e, t) {
                  return t.labels[e.index] + ": " + e.yLabel;
                },
              },
            },
          });
          var Mt = Le.extend({
            dataElementType: Ue.Arc,
            linkScales: le.noop,
            _dataElementOptions: [
              "backgroundColor",
              "borderColor",
              "borderWidth",
              "borderAlign",
              "hoverBackgroundColor",
              "hoverBorderColor",
              "hoverBorderWidth",
            ],
            _getIndexScaleId: function () {
              return this.chart.scale.id;
            },
            _getValueScaleId: function () {
              return this.chart.scale.id;
            },
            update: function (e) {
              var t,
                n,
                i,
                a = this,
                r = a.getDataset(),
                l = a.getMeta(),
                o = a.chart.options.startAngle || 0,
                s = (a._starts = []),
                d = (a._angles = []),
                u = l.data;
              for (
                a._updateRadius(),
                  l.count = a.countVisibleElements(),
                  t = 0,
                  n = r.data.length;
                t < n;
                t++
              )
                (s[t] = o), (i = a._computeAngle(t)), (d[t] = i), (o += i);
              for (t = 0, n = u.length; t < n; ++t)
                (u[t]._options = a._resolveDataElementOptions(u[t], t)),
                  a.updateElement(u[t], t, e);
            },
            _updateRadius: function () {
              var e = this,
                t = e.chart,
                n = t.chartArea,
                i = t.options,
                a = Math.min(n.right - n.left, n.bottom - n.top);
              (t.outerRadius = Math.max(a / 2, 0)),
                (t.innerRadius = Math.max(
                  i.cutoutPercentage
                    ? (t.outerRadius / 100) * i.cutoutPercentage
                    : 1,
                  0
                )),
                (t.radiusLength =
                  (t.outerRadius - t.innerRadius) / t.getVisibleDatasetCount()),
                (e.outerRadius = t.outerRadius - t.radiusLength * e.index),
                (e.innerRadius = e.outerRadius - t.radiusLength);
            },
            updateElement: function (e, t, n) {
              var i = this,
                a = i.chart,
                r = i.getDataset(),
                l = a.options,
                o = l.animation,
                s = a.scale,
                d = a.data.labels,
                u = s.xCenter,
                c = s.yCenter,
                h = l.startAngle,
                m = e.hidden ? 0 : s.getDistanceFromCenterForValue(r.data[t]),
                f = i._starts[t],
                _ = f + (e.hidden ? 0 : i._angles[t]),
                p = o.animateScale
                  ? 0
                  : s.getDistanceFromCenterForValue(r.data[t]),
                g = e._options || {};
              le.extend(e, {
                _datasetIndex: i.index,
                _index: t,
                _scale: s,
                _model: {
                  backgroundColor: g.backgroundColor,
                  borderColor: g.borderColor,
                  borderWidth: g.borderWidth,
                  borderAlign: g.borderAlign,
                  x: u,
                  y: c,
                  innerRadius: 0,
                  outerRadius: n ? p : m,
                  startAngle: n && o.animateRotate ? h : f,
                  endAngle: n && o.animateRotate ? h : _,
                  label: le.valueAtIndexOrDefault(d, t, d[t]),
                },
              }),
                e.pivot();
            },
            countVisibleElements: function () {
              var e = this.getDataset(),
                t = this.getMeta(),
                n = 0;
              return (
                le.each(t.data, function (t, i) {
                  isNaN(e.data[i]) || t.hidden || n++;
                }),
                n
              );
            },
            setHoverStyle: function (e) {
              var t = e._model,
                n = e._options,
                i = le.getHoverColor,
                a = le.valueOrDefault;
              (e.$previousStyle = {
                backgroundColor: t.backgroundColor,
                borderColor: t.borderColor,
                borderWidth: t.borderWidth,
              }),
                (t.backgroundColor = a(
                  n.hoverBackgroundColor,
                  i(n.backgroundColor)
                )),
                (t.borderColor = a(n.hoverBorderColor, i(n.borderColor))),
                (t.borderWidth = a(n.hoverBorderWidth, n.borderWidth));
            },
            _computeAngle: function (e) {
              var t = this,
                n = this.getMeta().count,
                i = t.getDataset(),
                a = t.getMeta();
              if (isNaN(i.data[e]) || a.data[e].hidden) return 0;
              var r = {
                chart: t.chart,
                dataIndex: e,
                dataset: i,
                datasetIndex: t.index,
              };
              return vt(
                [t.chart.options.elements.arc.angle, (2 * Math.PI) / n],
                r,
                e
              );
            },
          });
          K._set("pie", le.clone(K.doughnut)),
            K._set("pie", { cutoutPercentage: 0 });
          var bt = ut,
            xt = le.valueOrDefault;
          K._set("radar", {
            spanGaps: !1,
            scale: { type: "radialLinear" },
            elements: { line: { fill: "start", tension: 0 } },
          });
          var Lt = Le.extend({
            datasetElementType: Ue.Line,
            dataElementType: Ue.Point,
            linkScales: le.noop,
            _datasetElementOptions: [
              "backgroundColor",
              "borderWidth",
              "borderColor",
              "borderCapStyle",
              "borderDash",
              "borderDashOffset",
              "borderJoinStyle",
              "fill",
            ],
            _dataElementOptions: {
              backgroundColor: "pointBackgroundColor",
              borderColor: "pointBorderColor",
              borderWidth: "pointBorderWidth",
              hitRadius: "pointHitRadius",
              hoverBackgroundColor: "pointHoverBackgroundColor",
              hoverBorderColor: "pointHoverBorderColor",
              hoverBorderWidth: "pointHoverBorderWidth",
              hoverRadius: "pointHoverRadius",
              pointStyle: "pointStyle",
              radius: "pointRadius",
              rotation: "pointRotation",
            },
            _getIndexScaleId: function () {
              return this.chart.scale.id;
            },
            _getValueScaleId: function () {
              return this.chart.scale.id;
            },
            update: function (e) {
              var t,
                n,
                i = this,
                a = i.getMeta(),
                r = a.dataset,
                l = a.data || [],
                o = i.chart.scale,
                s = i._config;
              for (
                void 0 !== s.tension &&
                  void 0 === s.lineTension &&
                  (s.lineTension = s.tension),
                  r._scale = o,
                  r._datasetIndex = i.index,
                  r._children = l,
                  r._loop = !0,
                  r._model = i._resolveDatasetElementOptions(r),
                  r.pivot(),
                  t = 0,
                  n = l.length;
                t < n;
                ++t
              )
                i.updateElement(l[t], t, e);
              for (
                i.updateBezierControlPoints(), t = 0, n = l.length;
                t < n;
                ++t
              )
                l[t].pivot();
            },
            updateElement: function (e, t, n) {
              var i = this,
                a = e.custom || {},
                r = i.getDataset(),
                l = i.chart.scale,
                o = l.getPointPositionForValue(t, r.data[t]),
                s = i._resolveDataElementOptions(e, t),
                d = i.getMeta().dataset._model,
                u = n ? l.xCenter : o.x,
                c = n ? l.yCenter : o.y;
              (e._scale = l),
                (e._options = s),
                (e._datasetIndex = i.index),
                (e._index = t),
                (e._model = {
                  x: u,
                  y: c,
                  skip: a.skip || isNaN(u) || isNaN(c),
                  radius: s.radius,
                  pointStyle: s.pointStyle,
                  rotation: s.rotation,
                  backgroundColor: s.backgroundColor,
                  borderColor: s.borderColor,
                  borderWidth: s.borderWidth,
                  tension: xt(a.tension, d ? d.tension : 0),
                  hitRadius: s.hitRadius,
                });
            },
            _resolveDatasetElementOptions: function () {
              var e = this,
                t = e._config,
                n = e.chart.options,
                i = Le.prototype._resolveDatasetElementOptions.apply(
                  e,
                  arguments
                );
              return (
                (i.spanGaps = xt(t.spanGaps, n.spanGaps)),
                (i.tension = xt(t.lineTension, n.elements.line.tension)),
                i
              );
            },
            updateBezierControlPoints: function () {
              var e,
                t,
                n,
                i,
                a = this,
                r = a.getMeta(),
                l = a.chart.chartArea,
                o = r.data || [];
              function s(e, t, n) {
                return Math.max(Math.min(e, n), t);
              }
              for (
                r.dataset._model.spanGaps &&
                  (o = o.filter(function (e) {
                    return !e._model.skip;
                  })),
                  e = 0,
                  t = o.length;
                e < t;
                ++e
              )
                (n = o[e]._model),
                  (i = le.splineCurve(
                    le.previousItem(o, e, !0)._model,
                    n,
                    le.nextItem(o, e, !0)._model,
                    n.tension
                  )),
                  (n.controlPointPreviousX = s(i.previous.x, l.left, l.right)),
                  (n.controlPointPreviousY = s(i.previous.y, l.top, l.bottom)),
                  (n.controlPointNextX = s(i.next.x, l.left, l.right)),
                  (n.controlPointNextY = s(i.next.y, l.top, l.bottom));
            },
            setHoverStyle: function (e) {
              var t = e._model,
                n = e._options,
                i = le.getHoverColor;
              (e.$previousStyle = {
                backgroundColor: t.backgroundColor,
                borderColor: t.borderColor,
                borderWidth: t.borderWidth,
                radius: t.radius,
              }),
                (t.backgroundColor = xt(
                  n.hoverBackgroundColor,
                  i(n.backgroundColor)
                )),
                (t.borderColor = xt(n.hoverBorderColor, i(n.borderColor))),
                (t.borderWidth = xt(n.hoverBorderWidth, n.borderWidth)),
                (t.radius = xt(n.hoverRadius, n.radius));
            },
          });
          K._set("scatter", {
            hover: { mode: "single" },
            scales: {
              xAxes: [{ id: "x-axis-1", type: "linear", position: "bottom" }],
              yAxes: [{ id: "y-axis-1", type: "linear", position: "left" }],
            },
            tooltips: {
              callbacks: {
                title: function () {
                  return "";
                },
                label: function (e) {
                  return "(" + e.xLabel + ", " + e.yLabel + ")";
                },
              },
            },
          }),
            K._set("global", { datasets: { scatter: { showLine: !1 } } });
          var wt = {
            bar: nt,
            bubble: rt,
            doughnut: ut,
            horizontalBar: ct,
            line: yt,
            polarArea: Mt,
            pie: bt,
            radar: Lt,
            scatter: yt,
          };
          function kt(e, t) {
            return e.native ? { x: e.x, y: e.y } : le.getRelativePosition(e, t);
          }
          function Yt(e, t) {
            var n,
              i,
              a,
              r,
              l,
              o,
              s = e._getSortedVisibleDatasetMetas();
            for (i = 0, r = s.length; i < r; ++i)
              for (a = 0, l = (n = s[i].data).length; a < l; ++a)
                (o = n[a])._view.skip || t(o);
          }
          function Dt(e, t) {
            var n = [];
            return (
              Yt(e, function (e) {
                e.inRange(t.x, t.y) && n.push(e);
              }),
              n
            );
          }
          function Tt(e, t, n, i) {
            var a = Number.POSITIVE_INFINITY,
              r = [];
            return (
              Yt(e, function (e) {
                if (!n || e.inRange(t.x, t.y)) {
                  var l = e.getCenterPoint(),
                    o = i(t, l);
                  o < a ? ((r = [e]), (a = o)) : o === a && r.push(e);
                }
              }),
              r
            );
          }
          function St(e) {
            var t = -1 !== e.indexOf("x"),
              n = -1 !== e.indexOf("y");
            return function (e, i) {
              var a = t ? Math.abs(e.x - i.x) : 0,
                r = n ? Math.abs(e.y - i.y) : 0;
              return Math.sqrt(Math.pow(a, 2) + Math.pow(r, 2));
            };
          }
          function jt(e, t, n) {
            var i = kt(t, e);
            n.axis = n.axis || "x";
            var a = St(n.axis),
              r = n.intersect ? Dt(e, i) : Tt(e, i, !1, a),
              l = [];
            return r.length
              ? (e._getSortedVisibleDatasetMetas().forEach(function (e) {
                  var t = e.data[r[0]._index];
                  t && !t._view.skip && l.push(t);
                }),
                l)
              : [];
          }
          var Ot = {
              modes: {
                single: function (e, t) {
                  var n = kt(t, e),
                    i = [];
                  return (
                    Yt(e, function (e) {
                      if (e.inRange(n.x, n.y)) return i.push(e), i;
                    }),
                    i.slice(0, 1)
                  );
                },
                label: jt,
                index: jt,
                dataset: function (e, t, n) {
                  var i = kt(t, e);
                  n.axis = n.axis || "xy";
                  var a = St(n.axis),
                    r = n.intersect ? Dt(e, i) : Tt(e, i, !1, a);
                  return (
                    r.length > 0 &&
                      (r = e.getDatasetMeta(r[0]._datasetIndex).data),
                    r
                  );
                },
                "x-axis": function (e, t) {
                  return jt(e, t, { intersect: !1 });
                },
                point: function (e, t) {
                  return Dt(e, kt(t, e));
                },
                nearest: function (e, t, n) {
                  var i = kt(t, e);
                  n.axis = n.axis || "xy";
                  var a = St(n.axis);
                  return Tt(e, i, n.intersect, a);
                },
                x: function (e, t, n) {
                  var i = kt(t, e),
                    a = [],
                    r = !1;
                  return (
                    Yt(e, function (e) {
                      e.inXRange(i.x) && a.push(e),
                        e.inRange(i.x, i.y) && (r = !0);
                    }),
                    n.intersect && !r && (a = []),
                    a
                  );
                },
                y: function (e, t, n) {
                  var i = kt(t, e),
                    a = [],
                    r = !1;
                  return (
                    Yt(e, function (e) {
                      e.inYRange(i.y) && a.push(e),
                        e.inRange(i.x, i.y) && (r = !0);
                    }),
                    n.intersect && !r && (a = []),
                    a
                  );
                },
              },
            },
            At = le.extend;
          function Ht(e, t) {
            return le.where(e, function (e) {
              return e.pos === t;
            });
          }
          function Et(e, t) {
            return e.sort(function (e, n) {
              var i = t ? n : e,
                a = t ? e : n;
              return i.weight === a.weight
                ? i.index - a.index
                : i.weight - a.weight;
            });
          }
          function Ct(e) {
            var t,
              n,
              i,
              a = [];
            for (t = 0, n = (e || []).length; t < n; ++t)
              (i = e[t]),
                a.push({
                  index: t,
                  box: i,
                  pos: i.position,
                  horizontal: i.isHorizontal(),
                  weight: i.weight,
                });
            return a;
          }
          function Pt(e, t) {
            var n, i, a;
            for (n = 0, i = e.length; n < i; ++n)
              ((a = e[n]).width = a.horizontal
                ? a.box.fullWidth && t.availableWidth
                : t.vBoxMaxWidth),
                (a.height = a.horizontal && t.hBoxMaxHeight);
          }
          function Ft(e) {
            var t = Ct(e),
              n = Et(Ht(t, "left"), !0),
              i = Et(Ht(t, "right")),
              a = Et(Ht(t, "top"), !0),
              r = Et(Ht(t, "bottom"));
            return {
              leftAndTop: n.concat(a),
              rightAndBottom: i.concat(r),
              chartArea: Ht(t, "chartArea"),
              vertical: n.concat(i),
              horizontal: a.concat(r),
            };
          }
          function It(e, t, n, i) {
            return Math.max(e[n], t[n]) + Math.max(e[i], t[i]);
          }
          function Wt(e, t, n) {
            var i,
              a,
              r = n.box,
              l = e.maxPadding;
            if (
              (n.size && (e[n.pos] -= n.size),
              (n.size = n.horizontal ? r.height : r.width),
              (e[n.pos] += n.size),
              r.getPadding)
            ) {
              var o = r.getPadding();
              (l.top = Math.max(l.top, o.top)),
                (l.left = Math.max(l.left, o.left)),
                (l.bottom = Math.max(l.bottom, o.bottom)),
                (l.right = Math.max(l.right, o.right));
            }
            if (
              ((i = t.outerWidth - It(l, e, "left", "right")),
              (a = t.outerHeight - It(l, e, "top", "bottom")),
              i !== e.w || a !== e.h)
            ) {
              (e.w = i), (e.h = a);
              var s = n.horizontal ? [i, e.w] : [a, e.h];
              return !(s[0] === s[1] || (isNaN(s[0]) && isNaN(s[1])));
            }
          }
          function zt(e) {
            var t = e.maxPadding;
            function n(n) {
              var i = Math.max(t[n] - e[n], 0);
              return (e[n] += i), i;
            }
            (e.y += n("top")), (e.x += n("left")), n("right"), n("bottom");
          }
          function Nt(e, t) {
            var n = t.maxPadding;
            function i(e) {
              var i = { left: 0, top: 0, right: 0, bottom: 0 };
              return (
                e.forEach(function (e) {
                  i[e] = Math.max(t[e], n[e]);
                }),
                i
              );
            }
            return i(e ? ["left", "right"] : ["top", "bottom"]);
          }
          function Rt(e, t, n) {
            var i,
              a,
              r,
              l,
              o,
              s,
              d = [];
            for (i = 0, a = e.length; i < a; ++i)
              (l = (r = e[i]).box).update(
                r.width || t.w,
                r.height || t.h,
                Nt(r.horizontal, t)
              ),
                Wt(t, n, r) && ((s = !0), d.length && (o = !0)),
                l.fullWidth || d.push(r);
            return (o && Rt(d, t, n)) || s;
          }
          function Bt(e, t, n) {
            var i,
              a,
              r,
              l,
              o = n.padding,
              s = t.x,
              d = t.y;
            for (i = 0, a = e.length; i < a; ++i)
              (l = (r = e[i]).box),
                r.horizontal
                  ? ((l.left = l.fullWidth ? o.left : t.left),
                    (l.right = l.fullWidth
                      ? n.outerWidth - o.right
                      : t.left + t.w),
                    (l.top = d),
                    (l.bottom = d + l.height),
                    (l.width = l.right - l.left),
                    (d = l.bottom))
                  : ((l.left = s),
                    (l.right = s + l.width),
                    (l.top = t.top),
                    (l.bottom = t.top + t.h),
                    (l.height = l.bottom - l.top),
                    (s = l.right));
            (t.x = s), (t.y = d);
          }
          K._set("global", {
            layout: { padding: { top: 0, right: 0, bottom: 0, left: 0 } },
          });
          var Vt = {
              defaults: {},
              addBox: function (e, t) {
                e.boxes || (e.boxes = []),
                  (t.fullWidth = t.fullWidth || !1),
                  (t.position = t.position || "top"),
                  (t.weight = t.weight || 0),
                  (t._layers =
                    t._layers ||
                    function () {
                      return [
                        {
                          z: 0,
                          draw: function () {
                            t.draw.apply(t, arguments);
                          },
                        },
                      ];
                    }),
                  e.boxes.push(t);
              },
              removeBox: function (e, t) {
                var n = e.boxes ? e.boxes.indexOf(t) : -1;
                -1 !== n && e.boxes.splice(n, 1);
              },
              configure: function (e, t, n) {
                for (
                  var i,
                    a = ["fullWidth", "position", "weight"],
                    r = a.length,
                    l = 0;
                  l < r;
                  ++l
                )
                  (i = a[l]), n.hasOwnProperty(i) && (t[i] = n[i]);
              },
              update: function (e, t, n) {
                if (e) {
                  var i = e.options.layout || {},
                    a = le.options.toPadding(i.padding),
                    r = t - a.width,
                    l = n - a.height,
                    o = Ft(e.boxes),
                    s = o.vertical,
                    d = o.horizontal,
                    u = Object.freeze({
                      outerWidth: t,
                      outerHeight: n,
                      padding: a,
                      availableWidth: r,
                      vBoxMaxWidth: r / 2 / s.length,
                      hBoxMaxHeight: l / 2,
                    }),
                    c = At(
                      {
                        maxPadding: At({}, a),
                        w: r,
                        h: l,
                        x: a.left,
                        y: a.top,
                      },
                      a
                    );
                  Pt(s.concat(d), u),
                    Rt(s, c, u),
                    Rt(d, c, u) && Rt(s, c, u),
                    zt(c),
                    Bt(o.leftAndTop, c, u),
                    (c.x += c.w),
                    (c.y += c.h),
                    Bt(o.rightAndBottom, c, u),
                    (e.chartArea = {
                      left: c.left,
                      top: c.top,
                      right: c.left + c.w,
                      bottom: c.top + c.h,
                    }),
                    le.each(o.chartArea, function (t) {
                      var n = t.box;
                      At(n, e.chartArea), n.update(c.w, c.h);
                    });
                }
              },
            },
            Zt = {
              acquireContext: function (e) {
                return (
                  e && e.canvas && (e = e.canvas),
                  (e && e.getContext("2d")) || null
                );
              },
            },
            Ut =
              "/*\r\n * DOM element rendering detection\r\n * https://davidwalsh.name/detect-node-insertion\r\n */\r\n@keyframes chartjs-render-animation {\r\n\tfrom { opacity: 0.99; }\r\n\tto { opacity: 1; }\r\n}\r\n\r\n.chartjs-render-monitor {\r\n\tanimation: chartjs-render-animation 0.001s;\r\n}\r\n\r\n/*\r\n * DOM element resizing detection\r\n * https://github.com/marcj/css-element-queries\r\n */\r\n.chartjs-size-monitor,\r\n.chartjs-size-monitor-expand,\r\n.chartjs-size-monitor-shrink {\r\n\tposition: absolute;\r\n\tdirection: ltr;\r\n\tleft: 0;\r\n\ttop: 0;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\toverflow: hidden;\r\n\tpointer-events: none;\r\n\tvisibility: hidden;\r\n\tz-index: -1;\r\n}\r\n\r\n.chartjs-size-monitor-expand > div {\r\n\tposition: absolute;\r\n\twidth: 1000000px;\r\n\theight: 1000000px;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n\r\n.chartjs-size-monitor-shrink > div {\r\n\tposition: absolute;\r\n\twidth: 200%;\r\n\theight: 200%;\r\n\tleft: 0;\r\n\ttop: 0;\r\n}\r\n",
            $t = n(Object.freeze({ __proto__: null, default: Ut })),
            Jt = "$chartjs",
            qt = "chartjs-",
            Gt = qt + "size-monitor",
            Xt = qt + "render-monitor",
            Kt = qt + "render-animation",
            Qt = ["animationstart", "webkitAnimationStart"],
            en = {
              touchstart: "mousedown",
              touchmove: "mousemove",
              touchend: "mouseup",
              pointerenter: "mouseenter",
              pointerdown: "mousedown",
              pointermove: "mousemove",
              pointerup: "mouseup",
              pointerleave: "mouseout",
              pointerout: "mouseout",
            };
          function tn(e, t) {
            var n = le.getStyle(e, t),
              i = n && n.match(/^(\d+)(\.\d+)?px$/);
            return i ? Number(i[1]) : void 0;
          }
          function nn(e, t) {
            var n = e.style,
              i = e.getAttribute("height"),
              a = e.getAttribute("width");
            if (
              ((e[Jt] = {
                initial: {
                  height: i,
                  width: a,
                  style: {
                    display: n.display,
                    height: n.height,
                    width: n.width,
                  },
                },
              }),
              (n.display = n.display || "block"),
              null === a || "" === a)
            ) {
              var r = tn(e, "width");
              void 0 !== r && (e.width = r);
            }
            if (null === i || "" === i)
              if ("" === e.style.height)
                e.height = e.width / (t.options.aspectRatio || 2);
              else {
                var l = tn(e, "height");
                void 0 !== r && (e.height = l);
              }
            return e;
          }
          var an = !!(function () {
            var e = !1;
            try {
              var t = Object.defineProperty({}, "passive", {
                get: function () {
                  e = !0;
                },
              });
              window.addEventListener("e", null, t);
            } catch (e) {}
            return e;
          })() && { passive: !0 };
          function rn(e, t, n) {
            e.addEventListener(t, n, an);
          }
          function ln(e, t, n) {
            e.removeEventListener(t, n, an);
          }
          function on(e, t, n, i, a) {
            return {
              type: e,
              chart: t,
              native: a || null,
              x: void 0 !== n ? n : null,
              y: void 0 !== i ? i : null,
            };
          }
          function sn(e, t) {
            var n = en[e.type] || e.type,
              i = le.getRelativePosition(e, t);
            return on(n, t, i.x, i.y, e);
          }
          function dn(e, t) {
            var n = !1,
              i = [];
            return function () {
              (i = Array.prototype.slice.call(arguments)),
                (t = t || this),
                n ||
                  ((n = !0),
                  le.requestAnimFrame.call(window, function () {
                    (n = !1), e.apply(t, i);
                  }));
            };
          }
          function un(e) {
            var t = document.createElement("div");
            return (t.className = e || ""), t;
          }
          function cn(e) {
            var t = 1e6,
              n = un(Gt),
              i = un(Gt + "-expand"),
              a = un(Gt + "-shrink");
            i.appendChild(un()),
              a.appendChild(un()),
              n.appendChild(i),
              n.appendChild(a),
              (n._reset = function () {
                (i.scrollLeft = t),
                  (i.scrollTop = t),
                  (a.scrollLeft = t),
                  (a.scrollTop = t);
              });
            var r = function () {
              n._reset(), e();
            };
            return (
              rn(i, "scroll", r.bind(i, "expand")),
              rn(a, "scroll", r.bind(a, "shrink")),
              n
            );
          }
          function hn(e, t) {
            var n = e[Jt] || (e[Jt] = {}),
              i = (n.renderProxy = function (e) {
                e.animationName === Kt && t();
              });
            le.each(Qt, function (t) {
              rn(e, t, i);
            }),
              (n.reflow = !!e.offsetParent),
              e.classList.add(Xt);
          }
          function mn(e) {
            var t = e[Jt] || {},
              n = t.renderProxy;
            n &&
              (le.each(Qt, function (t) {
                ln(e, t, n);
              }),
              delete t.renderProxy),
              e.classList.remove(Xt);
          }
          function fn(e, t, n) {
            var i = e[Jt] || (e[Jt] = {}),
              a = (i.resizer = cn(
                dn(function () {
                  if (i.resizer) {
                    var a = n.options.maintainAspectRatio && e.parentNode,
                      r = a ? a.clientWidth : 0;
                    t(on("resize", n)),
                      a && a.clientWidth < r && n.canvas && t(on("resize", n));
                  }
                })
              ));
            hn(e, function () {
              if (i.resizer) {
                var t = e.parentNode;
                t && t !== a.parentNode && t.insertBefore(a, t.firstChild),
                  a._reset();
              }
            });
          }
          function _n(e) {
            var t = e[Jt] || {},
              n = t.resizer;
            delete t.resizer,
              mn(e),
              n && n.parentNode && n.parentNode.removeChild(n);
          }
          function pn(e, t) {
            var n = e[Jt] || (e[Jt] = {});
            if (!n.containsStyles) {
              (n.containsStyles = !0), (t = "/* Chart.js */\n" + t);
              var i = document.createElement("style");
              i.setAttribute("type", "text/css"),
                i.appendChild(document.createTextNode(t)),
                e.appendChild(i);
            }
          }
          var gn = {
            disableCSSInjection: !1,
            _enabled:
              "undefined" != typeof window && "undefined" != typeof document,
            _ensureLoaded: function (e) {
              if (!this.disableCSSInjection) {
                var t = e.getRootNode ? e.getRootNode() : document;
                pn(t.host ? t : document.head, $t);
              }
            },
            acquireContext: function (e, t) {
              "string" == typeof e
                ? (e = document.getElementById(e))
                : e.length && (e = e[0]),
                e && e.canvas && (e = e.canvas);
              var n = e && e.getContext && e.getContext("2d");
              return n && n.canvas === e
                ? (this._ensureLoaded(e), nn(e, t), n)
                : null;
            },
            releaseContext: function (e) {
              var t = e.canvas;
              if (t[Jt]) {
                var n = t[Jt].initial;
                ["height", "width"].forEach(function (e) {
                  var i = n[e];
                  le.isNullOrUndef(i)
                    ? t.removeAttribute(e)
                    : t.setAttribute(e, i);
                }),
                  le.each(n.style || {}, function (e, n) {
                    t.style[n] = e;
                  }),
                  (t.width = t.width),
                  delete t[Jt];
              }
            },
            addEventListener: function (e, t, n) {
              var i = e.canvas;
              if ("resize" !== t) {
                var a = n[Jt] || (n[Jt] = {});
                rn(
                  i,
                  t,
                  ((a.proxies || (a.proxies = {}))[e.id + "_" + t] = function (
                    t
                  ) {
                    n(sn(t, e));
                  })
                );
              } else fn(i, n, e);
            },
            removeEventListener: function (e, t, n) {
              var i = e.canvas;
              if ("resize" !== t) {
                var a = ((n[Jt] || {}).proxies || {})[e.id + "_" + t];
                a && ln(i, t, a);
              } else _n(i);
            },
          };
          (le.addEvent = rn), (le.removeEvent = ln);
          var yn = gn._enabled ? gn : Zt,
            vn = le.extend(
              {
                initialize: function () {},
                acquireContext: function () {},
                releaseContext: function () {},
                addEventListener: function () {},
                removeEventListener: function () {},
              },
              yn
            );
          K._set("global", { plugins: {} });
          var Mn = {
              _plugins: [],
              _cacheId: 0,
              register: function (e) {
                var t = this._plugins;
                [].concat(e).forEach(function (e) {
                  -1 === t.indexOf(e) && t.push(e);
                }),
                  this._cacheId++;
              },
              unregister: function (e) {
                var t = this._plugins;
                [].concat(e).forEach(function (e) {
                  var n = t.indexOf(e);
                  -1 !== n && t.splice(n, 1);
                }),
                  this._cacheId++;
              },
              clear: function () {
                (this._plugins = []), this._cacheId++;
              },
              count: function () {
                return this._plugins.length;
              },
              getAll: function () {
                return this._plugins;
              },
              notify: function (e, t, n) {
                var i,
                  a,
                  r,
                  l,
                  o,
                  s = this.descriptors(e),
                  d = s.length;
                for (i = 0; i < d; ++i)
                  if (
                    "function" == typeof (o = (r = (a = s[i]).plugin)[t]) &&
                    ((l = [e].concat(n || [])).push(a.options),
                    !1 === o.apply(r, l))
                  )
                    return !1;
                return !0;
              },
              descriptors: function (e) {
                var t = e.$plugins || (e.$plugins = {});
                if (t.id === this._cacheId) return t.descriptors;
                var n = [],
                  i = [],
                  a = (e && e.config) || {},
                  r = (a.options && a.options.plugins) || {};
                return (
                  this._plugins.concat(a.plugins || []).forEach(function (e) {
                    if (-1 === n.indexOf(e)) {
                      var t = e.id,
                        a = r[t];
                      !1 !== a &&
                        (!0 === a && (a = le.clone(K.global.plugins[t])),
                        n.push(e),
                        i.push({ plugin: e, options: a || {} }));
                    }
                  }),
                  (t.descriptors = i),
                  (t.id = this._cacheId),
                  i
                );
              },
              _invalidate: function (e) {
                delete e.$plugins;
              },
            },
            bn = {
              constructors: {},
              defaults: {},
              registerScaleType: function (e, t, n) {
                (this.constructors[e] = t), (this.defaults[e] = le.clone(n));
              },
              getScaleConstructor: function (e) {
                return this.constructors.hasOwnProperty(e)
                  ? this.constructors[e]
                  : void 0;
              },
              getScaleDefaults: function (e) {
                return this.defaults.hasOwnProperty(e)
                  ? le.merge(Object.create(null), [K.scale, this.defaults[e]])
                  : {};
              },
              updateScaleDefaults: function (e, t) {
                var n = this;
                n.defaults.hasOwnProperty(e) &&
                  (n.defaults[e] = le.extend(n.defaults[e], t));
              },
              addScalesToLayout: function (e) {
                le.each(e.scales, function (t) {
                  (t.fullWidth = t.options.fullWidth),
                    (t.position = t.options.position),
                    (t.weight = t.options.weight),
                    Vt.addBox(e, t);
                });
              },
            },
            xn = le.valueOrDefault,
            Ln = le.rtl.getRtlAdapter;
          K._set("global", {
            tooltips: {
              enabled: !0,
              custom: null,
              mode: "nearest",
              position: "average",
              intersect: !0,
              backgroundColor: "rgba(0,0,0,0.8)",
              titleFontStyle: "bold",
              titleSpacing: 2,
              titleMarginBottom: 6,
              titleFontColor: "#fff",
              titleAlign: "left",
              bodySpacing: 2,
              bodyFontColor: "#fff",
              bodyAlign: "left",
              footerFontStyle: "bold",
              footerSpacing: 2,
              footerMarginTop: 6,
              footerFontColor: "#fff",
              footerAlign: "left",
              yPadding: 6,
              xPadding: 6,
              caretPadding: 2,
              caretSize: 5,
              cornerRadius: 6,
              multiKeyBackground: "#fff",
              displayColors: !0,
              borderColor: "rgba(0,0,0,0)",
              borderWidth: 0,
              callbacks: {
                beforeTitle: le.noop,
                title: function (e, t) {
                  var n = "",
                    i = t.labels,
                    a = i ? i.length : 0;
                  if (e.length > 0) {
                    var r = e[0];
                    r.label
                      ? (n = r.label)
                      : r.xLabel
                      ? (n = r.xLabel)
                      : a > 0 && r.index < a && (n = i[r.index]);
                  }
                  return n;
                },
                afterTitle: le.noop,
                beforeBody: le.noop,
                beforeLabel: le.noop,
                label: function (e, t) {
                  var n = t.datasets[e.datasetIndex].label || "";
                  return (
                    n && (n += ": "),
                    le.isNullOrUndef(e.value)
                      ? (n += e.yLabel)
                      : (n += e.value),
                    n
                  );
                },
                labelColor: function (e, t) {
                  var n = t.getDatasetMeta(e.datasetIndex).data[e.index]._view;
                  return {
                    borderColor: n.borderColor,
                    backgroundColor: n.backgroundColor,
                  };
                },
                labelTextColor: function () {
                  return this._options.bodyFontColor;
                },
                afterLabel: le.noop,
                afterBody: le.noop,
                beforeFooter: le.noop,
                footer: le.noop,
                afterFooter: le.noop,
              },
            },
          });
          var wn = {
            average: function (e) {
              if (!e.length) return !1;
              var t,
                n,
                i = 0,
                a = 0,
                r = 0;
              for (t = 0, n = e.length; t < n; ++t) {
                var l = e[t];
                if (l && l.hasValue()) {
                  var o = l.tooltipPosition();
                  (i += o.x), (a += o.y), ++r;
                }
              }
              return { x: i / r, y: a / r };
            },
            nearest: function (e, t) {
              var n,
                i,
                a,
                r = t.x,
                l = t.y,
                o = Number.POSITIVE_INFINITY;
              for (n = 0, i = e.length; n < i; ++n) {
                var s = e[n];
                if (s && s.hasValue()) {
                  var d = s.getCenterPoint(),
                    u = le.distanceBetweenPoints(t, d);
                  u < o && ((o = u), (a = s));
                }
              }
              if (a) {
                var c = a.tooltipPosition();
                (r = c.x), (l = c.y);
              }
              return { x: r, y: l };
            },
          };
          function kn(e, t) {
            return (
              t &&
                (le.isArray(t) ? Array.prototype.push.apply(e, t) : e.push(t)),
              e
            );
          }
          function Yn(e) {
            return ("string" == typeof e || e instanceof String) &&
              e.indexOf("\n") > -1
              ? e.split("\n")
              : e;
          }
          function Dn(e) {
            var t = e._xScale,
              n = e._yScale || e._scale,
              i = e._index,
              a = e._datasetIndex,
              r = e._chart.getDatasetMeta(a).controller,
              l = r._getIndexScale(),
              o = r._getValueScale();
            return {
              xLabel: t ? t.getLabelForIndex(i, a) : "",
              yLabel: n ? n.getLabelForIndex(i, a) : "",
              label: l ? "" + l.getLabelForIndex(i, a) : "",
              value: o ? "" + o.getLabelForIndex(i, a) : "",
              index: i,
              datasetIndex: a,
              x: e._model.x,
              y: e._model.y,
            };
          }
          function Tn(e) {
            var t = K.global;
            return {
              xPadding: e.xPadding,
              yPadding: e.yPadding,
              xAlign: e.xAlign,
              yAlign: e.yAlign,
              rtl: e.rtl,
              textDirection: e.textDirection,
              bodyFontColor: e.bodyFontColor,
              _bodyFontFamily: xn(e.bodyFontFamily, t.defaultFontFamily),
              _bodyFontStyle: xn(e.bodyFontStyle, t.defaultFontStyle),
              _bodyAlign: e.bodyAlign,
              bodyFontSize: xn(e.bodyFontSize, t.defaultFontSize),
              bodySpacing: e.bodySpacing,
              titleFontColor: e.titleFontColor,
              _titleFontFamily: xn(e.titleFontFamily, t.defaultFontFamily),
              _titleFontStyle: xn(e.titleFontStyle, t.defaultFontStyle),
              titleFontSize: xn(e.titleFontSize, t.defaultFontSize),
              _titleAlign: e.titleAlign,
              titleSpacing: e.titleSpacing,
              titleMarginBottom: e.titleMarginBottom,
              footerFontColor: e.footerFontColor,
              _footerFontFamily: xn(e.footerFontFamily, t.defaultFontFamily),
              _footerFontStyle: xn(e.footerFontStyle, t.defaultFontStyle),
              footerFontSize: xn(e.footerFontSize, t.defaultFontSize),
              _footerAlign: e.footerAlign,
              footerSpacing: e.footerSpacing,
              footerMarginTop: e.footerMarginTop,
              caretSize: e.caretSize,
              cornerRadius: e.cornerRadius,
              backgroundColor: e.backgroundColor,
              opacity: 0,
              legendColorBackground: e.multiKeyBackground,
              displayColors: e.displayColors,
              borderColor: e.borderColor,
              borderWidth: e.borderWidth,
            };
          }
          function Sn(e, t) {
            var n = e._chart.ctx,
              i = 2 * t.yPadding,
              a = 0,
              r = t.body,
              l = r.reduce(function (e, t) {
                return e + t.before.length + t.lines.length + t.after.length;
              }, 0);
            l += t.beforeBody.length + t.afterBody.length;
            var o = t.title.length,
              s = t.footer.length,
              d = t.titleFontSize,
              u = t.bodyFontSize,
              c = t.footerFontSize;
            (i += o * d),
              (i += o ? (o - 1) * t.titleSpacing : 0),
              (i += o ? t.titleMarginBottom : 0),
              (i += l * u),
              (i += l ? (l - 1) * t.bodySpacing : 0),
              (i += s ? t.footerMarginTop : 0),
              (i += s * c),
              (i += s ? (s - 1) * t.footerSpacing : 0);
            var h = 0,
              m = function (e) {
                a = Math.max(a, n.measureText(e).width + h);
              };
            return (
              (n.font = le.fontString(
                d,
                t._titleFontStyle,
                t._titleFontFamily
              )),
              le.each(t.title, m),
              (n.font = le.fontString(u, t._bodyFontStyle, t._bodyFontFamily)),
              le.each(t.beforeBody.concat(t.afterBody), m),
              (h = t.displayColors ? u + 2 : 0),
              le.each(r, function (e) {
                le.each(e.before, m), le.each(e.lines, m), le.each(e.after, m);
              }),
              (h = 0),
              (n.font = le.fontString(
                c,
                t._footerFontStyle,
                t._footerFontFamily
              )),
              le.each(t.footer, m),
              { width: (a += 2 * t.xPadding), height: i }
            );
          }
          function jn(e, t) {
            var n,
              i,
              a,
              r,
              l,
              o = e._model,
              s = e._chart,
              d = e._chart.chartArea,
              u = "center",
              c = "center";
            o.y < t.height
              ? (c = "top")
              : o.y > s.height - t.height && (c = "bottom");
            var h = (d.left + d.right) / 2,
              m = (d.top + d.bottom) / 2;
            "center" === c
              ? ((n = function (e) {
                  return e <= h;
                }),
                (i = function (e) {
                  return e > h;
                }))
              : ((n = function (e) {
                  return e <= t.width / 2;
                }),
                (i = function (e) {
                  return e >= s.width - t.width / 2;
                })),
              (a = function (e) {
                return e + t.width + o.caretSize + o.caretPadding > s.width;
              }),
              (r = function (e) {
                return e - t.width - o.caretSize - o.caretPadding < 0;
              }),
              (l = function (e) {
                return e <= m ? "top" : "bottom";
              }),
              n(o.x)
                ? ((u = "left"), a(o.x) && ((u = "center"), (c = l(o.y))))
                : i(o.x) &&
                  ((u = "right"), r(o.x) && ((u = "center"), (c = l(o.y))));
            var f = e._options;
            return {
              xAlign: f.xAlign ? f.xAlign : u,
              yAlign: f.yAlign ? f.yAlign : c,
            };
          }
          function On(e, t, n, i) {
            var a = e.x,
              r = e.y,
              l = e.caretSize,
              o = e.caretPadding,
              s = e.cornerRadius,
              d = n.xAlign,
              u = n.yAlign,
              c = l + o,
              h = s + o;
            return (
              "right" === d
                ? (a -= t.width)
                : "center" === d &&
                  ((a -= t.width / 2) + t.width > i.width &&
                    (a = i.width - t.width),
                  a < 0 && (a = 0)),
              "top" === u
                ? (r += c)
                : (r -= "bottom" === u ? t.height + c : t.height / 2),
              "center" === u
                ? "left" === d
                  ? (a += c)
                  : "right" === d && (a -= c)
                : "left" === d
                ? (a -= h)
                : "right" === d && (a += h),
              { x: a, y: r }
            );
          }
          function An(e, t) {
            return "center" === t
              ? e.x + e.width / 2
              : "right" === t
              ? e.x + e.width - e.xPadding
              : e.x + e.xPadding;
          }
          function Hn(e) {
            return kn([], Yn(e));
          }
          var En = fe.extend({
              initialize: function () {
                (this._model = Tn(this._options)), (this._lastActive = []);
              },
              getTitle: function () {
                var e = this,
                  t = e._options.callbacks,
                  n = t.beforeTitle.apply(e, arguments),
                  i = t.title.apply(e, arguments),
                  a = t.afterTitle.apply(e, arguments),
                  r = [];
                return (
                  (r = kn(r, Yn(n))), (r = kn(r, Yn(i))), (r = kn(r, Yn(a)))
                );
              },
              getBeforeBody: function () {
                return Hn(
                  this._options.callbacks.beforeBody.apply(this, arguments)
                );
              },
              getBody: function (e, t) {
                var n = this,
                  i = n._options.callbacks,
                  a = [];
                return (
                  le.each(e, function (e) {
                    var r = { before: [], lines: [], after: [] };
                    kn(r.before, Yn(i.beforeLabel.call(n, e, t))),
                      kn(r.lines, i.label.call(n, e, t)),
                      kn(r.after, Yn(i.afterLabel.call(n, e, t))),
                      a.push(r);
                  }),
                  a
                );
              },
              getAfterBody: function () {
                return Hn(
                  this._options.callbacks.afterBody.apply(this, arguments)
                );
              },
              getFooter: function () {
                var e = this,
                  t = e._options.callbacks,
                  n = t.beforeFooter.apply(e, arguments),
                  i = t.footer.apply(e, arguments),
                  a = t.afterFooter.apply(e, arguments),
                  r = [];
                return (
                  (r = kn(r, Yn(n))), (r = kn(r, Yn(i))), (r = kn(r, Yn(a)))
                );
              },
              update: function (e) {
                var t,
                  n,
                  i = this,
                  a = i._options,
                  r = i._model,
                  l = (i._model = Tn(a)),
                  o = i._active,
                  s = i._data,
                  d = { xAlign: r.xAlign, yAlign: r.yAlign },
                  u = { x: r.x, y: r.y },
                  c = { width: r.width, height: r.height },
                  h = { x: r.caretX, y: r.caretY };
                if (o.length) {
                  l.opacity = 1;
                  var m = [],
                    f = [];
                  h = wn[a.position].call(i, o, i._eventPosition);
                  var _ = [];
                  for (t = 0, n = o.length; t < n; ++t) _.push(Dn(o[t]));
                  a.filter &&
                    (_ = _.filter(function (e) {
                      return a.filter(e, s);
                    })),
                    a.itemSort &&
                      (_ = _.sort(function (e, t) {
                        return a.itemSort(e, t, s);
                      })),
                    le.each(_, function (e) {
                      m.push(a.callbacks.labelColor.call(i, e, i._chart)),
                        f.push(a.callbacks.labelTextColor.call(i, e, i._chart));
                    }),
                    (l.title = i.getTitle(_, s)),
                    (l.beforeBody = i.getBeforeBody(_, s)),
                    (l.body = i.getBody(_, s)),
                    (l.afterBody = i.getAfterBody(_, s)),
                    (l.footer = i.getFooter(_, s)),
                    (l.x = h.x),
                    (l.y = h.y),
                    (l.caretPadding = a.caretPadding),
                    (l.labelColors = m),
                    (l.labelTextColors = f),
                    (l.dataPoints = _),
                    (u = On(l, (c = Sn(this, l)), (d = jn(this, c)), i._chart));
                } else l.opacity = 0;
                return (
                  (l.xAlign = d.xAlign),
                  (l.yAlign = d.yAlign),
                  (l.x = u.x),
                  (l.y = u.y),
                  (l.width = c.width),
                  (l.height = c.height),
                  (l.caretX = h.x),
                  (l.caretY = h.y),
                  (i._model = l),
                  e && a.custom && a.custom.call(i, l),
                  i
                );
              },
              drawCaret: function (e, t) {
                var n = this._chart.ctx,
                  i = this._view,
                  a = this.getCaretPosition(e, t, i);
                n.lineTo(a.x1, a.y1),
                  n.lineTo(a.x2, a.y2),
                  n.lineTo(a.x3, a.y3);
              },
              getCaretPosition: function (e, t, n) {
                var i,
                  a,
                  r,
                  l,
                  o,
                  s,
                  d = n.caretSize,
                  u = n.cornerRadius,
                  c = n.xAlign,
                  h = n.yAlign,
                  m = e.x,
                  f = e.y,
                  _ = t.width,
                  p = t.height;
                if ("center" === h)
                  (o = f + p / 2),
                    "left" === c
                      ? ((a = (i = m) - d), (r = i), (l = o + d), (s = o - d))
                      : ((a = (i = m + _) + d),
                        (r = i),
                        (l = o - d),
                        (s = o + d));
                else if (
                  ("left" === c
                    ? ((i = (a = m + u + d) - d), (r = a + d))
                    : "right" === c
                    ? ((i = (a = m + _ - u - d) - d), (r = a + d))
                    : ((i = (a = n.caretX) - d), (r = a + d)),
                  "top" === h)
                )
                  (o = (l = f) - d), (s = l);
                else {
                  (o = (l = f + p) + d), (s = l);
                  var g = r;
                  (r = i), (i = g);
                }
                return { x1: i, x2: a, x3: r, y1: l, y2: o, y3: s };
              },
              drawTitle: function (e, t, n) {
                var i,
                  a,
                  r,
                  l = t.title,
                  o = l.length;
                if (o) {
                  var s = Ln(t.rtl, t.x, t.width);
                  for (
                    e.x = An(t, t._titleAlign),
                      n.textAlign = s.textAlign(t._titleAlign),
                      n.textBaseline = "middle",
                      i = t.titleFontSize,
                      a = t.titleSpacing,
                      n.fillStyle = t.titleFontColor,
                      n.font = le.fontString(
                        i,
                        t._titleFontStyle,
                        t._titleFontFamily
                      ),
                      r = 0;
                    r < o;
                    ++r
                  )
                    n.fillText(l[r], s.x(e.x), e.y + i / 2),
                      (e.y += i + a),
                      r + 1 === o && (e.y += t.titleMarginBottom - a);
                }
              },
              drawBody: function (e, t, n) {
                var i,
                  a,
                  r,
                  l,
                  o,
                  s,
                  d,
                  u,
                  c = t.bodyFontSize,
                  h = t.bodySpacing,
                  m = t._bodyAlign,
                  f = t.body,
                  _ = t.displayColors,
                  p = 0,
                  g = _ ? An(t, "left") : 0,
                  y = Ln(t.rtl, t.x, t.width),
                  v = function (t) {
                    n.fillText(t, y.x(e.x + p), e.y + c / 2), (e.y += c + h);
                  },
                  M = y.textAlign(m);
                for (
                  n.textAlign = m,
                    n.textBaseline = "middle",
                    n.font = le.fontString(
                      c,
                      t._bodyFontStyle,
                      t._bodyFontFamily
                    ),
                    e.x = An(t, M),
                    n.fillStyle = t.bodyFontColor,
                    le.each(t.beforeBody, v),
                    p =
                      _ && "right" !== M
                        ? "center" === m
                          ? c / 2 + 1
                          : c + 2
                        : 0,
                    o = 0,
                    d = f.length;
                  o < d;
                  ++o
                ) {
                  for (
                    i = f[o],
                      a = t.labelTextColors[o],
                      r = t.labelColors[o],
                      n.fillStyle = a,
                      le.each(i.before, v),
                      s = 0,
                      u = (l = i.lines).length;
                    s < u;
                    ++s
                  ) {
                    if (_) {
                      var b = y.x(g);
                      (n.fillStyle = t.legendColorBackground),
                        n.fillRect(y.leftForLtr(b, c), e.y, c, c),
                        (n.lineWidth = 1),
                        (n.strokeStyle = r.borderColor),
                        n.strokeRect(y.leftForLtr(b, c), e.y, c, c),
                        (n.fillStyle = r.backgroundColor),
                        n.fillRect(
                          y.leftForLtr(y.xPlus(b, 1), c - 2),
                          e.y + 1,
                          c - 2,
                          c - 2
                        ),
                        (n.fillStyle = a);
                    }
                    v(l[s]);
                  }
                  le.each(i.after, v);
                }
                (p = 0), le.each(t.afterBody, v), (e.y -= h);
              },
              drawFooter: function (e, t, n) {
                var i,
                  a,
                  r = t.footer,
                  l = r.length;
                if (l) {
                  var o = Ln(t.rtl, t.x, t.width);
                  for (
                    e.x = An(t, t._footerAlign),
                      e.y += t.footerMarginTop,
                      n.textAlign = o.textAlign(t._footerAlign),
                      n.textBaseline = "middle",
                      i = t.footerFontSize,
                      n.fillStyle = t.footerFontColor,
                      n.font = le.fontString(
                        i,
                        t._footerFontStyle,
                        t._footerFontFamily
                      ),
                      a = 0;
                    a < l;
                    ++a
                  )
                    n.fillText(r[a], o.x(e.x), e.y + i / 2),
                      (e.y += i + t.footerSpacing);
                }
              },
              drawBackground: function (e, t, n, i) {
                (n.fillStyle = t.backgroundColor),
                  (n.strokeStyle = t.borderColor),
                  (n.lineWidth = t.borderWidth);
                var a = t.xAlign,
                  r = t.yAlign,
                  l = e.x,
                  o = e.y,
                  s = i.width,
                  d = i.height,
                  u = t.cornerRadius;
                n.beginPath(),
                  n.moveTo(l + u, o),
                  "top" === r && this.drawCaret(e, i),
                  n.lineTo(l + s - u, o),
                  n.quadraticCurveTo(l + s, o, l + s, o + u),
                  "center" === r && "right" === a && this.drawCaret(e, i),
                  n.lineTo(l + s, o + d - u),
                  n.quadraticCurveTo(l + s, o + d, l + s - u, o + d),
                  "bottom" === r && this.drawCaret(e, i),
                  n.lineTo(l + u, o + d),
                  n.quadraticCurveTo(l, o + d, l, o + d - u),
                  "center" === r && "left" === a && this.drawCaret(e, i),
                  n.lineTo(l, o + u),
                  n.quadraticCurveTo(l, o, l + u, o),
                  n.closePath(),
                  n.fill(),
                  t.borderWidth > 0 && n.stroke();
              },
              draw: function () {
                var e = this._chart.ctx,
                  t = this._view;
                if (0 !== t.opacity) {
                  var n = { width: t.width, height: t.height },
                    i = { x: t.x, y: t.y },
                    a = Math.abs(t.opacity < 0.001) ? 0 : t.opacity,
                    r =
                      t.title.length ||
                      t.beforeBody.length ||
                      t.body.length ||
                      t.afterBody.length ||
                      t.footer.length;
                  this._options.enabled &&
                    r &&
                    (e.save(),
                    (e.globalAlpha = a),
                    this.drawBackground(i, t, e, n),
                    (i.y += t.yPadding),
                    le.rtl.overrideTextDirection(e, t.textDirection),
                    this.drawTitle(i, t, e),
                    this.drawBody(i, t, e),
                    this.drawFooter(i, t, e),
                    le.rtl.restoreTextDirection(e, t.textDirection),
                    e.restore());
                }
              },
              handleEvent: function (e) {
                var t = this,
                  n = t._options,
                  i = !1;
                return (
                  (t._lastActive = t._lastActive || []),
                  "mouseout" === e.type
                    ? (t._active = [])
                    : ((t._active = t._chart.getElementsAtEventForMode(
                        e,
                        n.mode,
                        n
                      )),
                      n.reverse && t._active.reverse()),
                  (i = !le.arrayEquals(t._active, t._lastActive)) &&
                    ((t._lastActive = t._active),
                    (n.enabled || n.custom) &&
                      ((t._eventPosition = { x: e.x, y: e.y }),
                      t.update(!0),
                      t.pivot())),
                  i
                );
              },
            }),
            Cn = wn,
            Pn = En;
          Pn.positioners = Cn;
          var Fn = le.valueOrDefault;
          function In() {
            return le.merge(Object.create(null), [].slice.call(arguments), {
              merger: function (e, t, n, i) {
                if ("xAxes" === e || "yAxes" === e) {
                  var a,
                    r,
                    l,
                    o = n[e].length;
                  for (t[e] || (t[e] = []), a = 0; a < o; ++a)
                    (l = n[e][a]),
                      (r = Fn(l.type, "xAxes" === e ? "category" : "linear")),
                      a >= t[e].length && t[e].push({}),
                      !t[e][a].type || (l.type && l.type !== t[e][a].type)
                        ? le.merge(t[e][a], [bn.getScaleDefaults(r), l])
                        : le.merge(t[e][a], l);
                } else le._merger(e, t, n, i);
              },
            });
          }
          function Wn() {
            return le.merge(Object.create(null), [].slice.call(arguments), {
              merger: function (e, t, n, i) {
                var a = t[e] || Object.create(null),
                  r = n[e];
                "scales" === e
                  ? (t[e] = In(a, r))
                  : "scale" === e
                  ? (t[e] = le.merge(a, [bn.getScaleDefaults(r.type), r]))
                  : le._merger(e, t, n, i);
              },
            });
          }
          function zn(e) {
            var t = ((e = e || Object.create(null)).data = e.data || {});
            return (
              (t.datasets = t.datasets || []),
              (t.labels = t.labels || []),
              (e.options = Wn(K.global, K[e.type], e.options || {})),
              e
            );
          }
          function Nn(e) {
            var t = e.options;
            le.each(e.scales, function (t) {
              Vt.removeBox(e, t);
            }),
              (t = Wn(K.global, K[e.config.type], t)),
              (e.options = e.config.options = t),
              e.ensureScalesHaveIDs(),
              e.buildOrUpdateScales(),
              (e.tooltip._options = t.tooltips),
              e.tooltip.initialize();
          }
          function Rn(e, t, n) {
            var i,
              a = function (e) {
                return e.id === i;
              };
            do {
              i = t + n++;
            } while (le.findIndex(e, a) >= 0);
            return i;
          }
          function Bn(e) {
            return "top" === e || "bottom" === e;
          }
          function Vn(e, t) {
            return function (n, i) {
              return n[e] === i[e] ? n[t] - i[t] : n[e] - i[e];
            };
          }
          K._set("global", {
            elements: {},
            events: [
              "mousemove",
              "mouseout",
              "click",
              "touchstart",
              "touchmove",
            ],
            hover: {
              onHover: null,
              mode: "nearest",
              intersect: !0,
              animationDuration: 400,
            },
            onClick: null,
            maintainAspectRatio: !0,
            responsive: !0,
            responsiveAnimationDuration: 0,
          });
          var Zn = function (e, t) {
            return this.construct(e, t), this;
          };
          le.extend(Zn.prototype, {
            construct: function (e, t) {
              var n = this;
              t = zn(t);
              var i = vn.acquireContext(e, t),
                a = i && i.canvas,
                r = a && a.height,
                l = a && a.width;
              (n.id = le.uid()),
                (n.ctx = i),
                (n.canvas = a),
                (n.config = t),
                (n.width = l),
                (n.height = r),
                (n.aspectRatio = r ? l / r : null),
                (n.options = t.options),
                (n._bufferedRender = !1),
                (n._layers = []),
                (n.chart = n),
                (n.controller = n),
                (Zn.instances[n.id] = n),
                Object.defineProperty(n, "data", {
                  get: function () {
                    return n.config.data;
                  },
                  set: function (e) {
                    n.config.data = e;
                  },
                }),
                i && a
                  ? (n.initialize(), n.update())
                  : console.error(
                      "Failed to create chart: can't acquire context from the given item"
                    );
            },
            initialize: function () {
              var e = this;
              return (
                Mn.notify(e, "beforeInit"),
                le.retinaScale(e, e.options.devicePixelRatio),
                e.bindEvents(),
                e.options.responsive && e.resize(!0),
                e.initToolTip(),
                Mn.notify(e, "afterInit"),
                e
              );
            },
            clear: function () {
              return le.canvas.clear(this), this;
            },
            stop: function () {
              return ge.cancelAnimation(this), this;
            },
            resize: function (e) {
              var t = this,
                n = t.options,
                i = t.canvas,
                a = (n.maintainAspectRatio && t.aspectRatio) || null,
                r = Math.max(0, Math.floor(le.getMaximumWidth(i))),
                l = Math.max(0, Math.floor(a ? r / a : le.getMaximumHeight(i)));
              if (
                (t.width !== r || t.height !== l) &&
                ((i.width = t.width = r),
                (i.height = t.height = l),
                (i.style.width = r + "px"),
                (i.style.height = l + "px"),
                le.retinaScale(t, n.devicePixelRatio),
                !e)
              ) {
                var o = { width: r, height: l };
                Mn.notify(t, "resize", [o]),
                  n.onResize && n.onResize(t, o),
                  t.stop(),
                  t.update({ duration: n.responsiveAnimationDuration });
              }
            },
            ensureScalesHaveIDs: function () {
              var e = this.options,
                t = e.scales || {},
                n = e.scale;
              le.each(t.xAxes, function (e, n) {
                e.id || (e.id = Rn(t.xAxes, "x-axis-", n));
              }),
                le.each(t.yAxes, function (e, n) {
                  e.id || (e.id = Rn(t.yAxes, "y-axis-", n));
                }),
                n && (n.id = n.id || "scale");
            },
            buildOrUpdateScales: function () {
              var e = this,
                t = e.options,
                n = e.scales || {},
                i = [],
                a = Object.keys(n).reduce(function (e, t) {
                  return (e[t] = !1), e;
                }, {});
              t.scales &&
                (i = i.concat(
                  (t.scales.xAxes || []).map(function (e) {
                    return {
                      options: e,
                      dtype: "category",
                      dposition: "bottom",
                    };
                  }),
                  (t.scales.yAxes || []).map(function (e) {
                    return { options: e, dtype: "linear", dposition: "left" };
                  })
                )),
                t.scale &&
                  i.push({
                    options: t.scale,
                    dtype: "radialLinear",
                    isDefault: !0,
                    dposition: "chartArea",
                  }),
                le.each(i, function (t) {
                  var i = t.options,
                    r = i.id,
                    l = Fn(i.type, t.dtype);
                  Bn(i.position) !== Bn(t.dposition) &&
                    (i.position = t.dposition),
                    (a[r] = !0);
                  var o = null;
                  if (r in n && n[r].type === l)
                    ((o = n[r]).options = i), (o.ctx = e.ctx), (o.chart = e);
                  else {
                    var s = bn.getScaleConstructor(l);
                    if (!s) return;
                    (o = new s({
                      id: r,
                      type: l,
                      options: i,
                      ctx: e.ctx,
                      chart: e,
                    })),
                      (n[o.id] = o);
                  }
                  o.mergeTicksOptions(), t.isDefault && (e.scale = o);
                }),
                le.each(a, function (e, t) {
                  e || delete n[t];
                }),
                (e.scales = n),
                bn.addScalesToLayout(this);
            },
            buildOrUpdateControllers: function () {
              var e,
                t,
                n = this,
                i = [],
                a = n.data.datasets;
              for (e = 0, t = a.length; e < t; e++) {
                var r = a[e],
                  l = n.getDatasetMeta(e),
                  o = r.type || n.config.type;
                if (
                  (l.type &&
                    l.type !== o &&
                    (n.destroyDatasetMeta(e), (l = n.getDatasetMeta(e))),
                  (l.type = o),
                  (l.order = r.order || 0),
                  (l.index = e),
                  l.controller)
                )
                  l.controller.updateIndex(e), l.controller.linkScales();
                else {
                  var s = wt[l.type];
                  if (void 0 === s)
                    throw new Error('"' + l.type + '" is not a chart type.');
                  (l.controller = new s(n, e)), i.push(l.controller);
                }
              }
              return i;
            },
            resetElements: function () {
              var e = this;
              le.each(
                e.data.datasets,
                function (t, n) {
                  e.getDatasetMeta(n).controller.reset();
                },
                e
              );
            },
            reset: function () {
              this.resetElements(), this.tooltip.initialize();
            },
            update: function (e) {
              var t,
                n,
                i = this;
              if (
                ((e && "object" == typeof e) ||
                  (e = { duration: e, lazy: arguments[1] }),
                Nn(i),
                Mn._invalidate(i),
                !1 !== Mn.notify(i, "beforeUpdate"))
              ) {
                i.tooltip._data = i.data;
                var a = i.buildOrUpdateControllers();
                for (t = 0, n = i.data.datasets.length; t < n; t++)
                  i.getDatasetMeta(t).controller.buildOrUpdateElements();
                i.updateLayout(),
                  i.options.animation &&
                    i.options.animation.duration &&
                    le.each(a, function (e) {
                      e.reset();
                    }),
                  i.updateDatasets(),
                  i.tooltip.initialize(),
                  (i.lastActive = []),
                  Mn.notify(i, "afterUpdate"),
                  i._layers.sort(Vn("z", "_idx")),
                  i._bufferedRender
                    ? (i._bufferedRequest = {
                        duration: e.duration,
                        easing: e.easing,
                        lazy: e.lazy,
                      })
                    : i.render(e);
              }
            },
            updateLayout: function () {
              var e = this;
              !1 !== Mn.notify(e, "beforeLayout") &&
                (Vt.update(this, this.width, this.height),
                (e._layers = []),
                le.each(
                  e.boxes,
                  function (t) {
                    t._configure && t._configure(),
                      e._layers.push.apply(e._layers, t._layers());
                  },
                  e
                ),
                e._layers.forEach(function (e, t) {
                  e._idx = t;
                }),
                Mn.notify(e, "afterScaleUpdate"),
                Mn.notify(e, "afterLayout"));
            },
            updateDatasets: function () {
              var e = this;
              if (!1 !== Mn.notify(e, "beforeDatasetsUpdate")) {
                for (var t = 0, n = e.data.datasets.length; t < n; ++t)
                  e.updateDataset(t);
                Mn.notify(e, "afterDatasetsUpdate");
              }
            },
            updateDataset: function (e) {
              var t = this,
                n = t.getDatasetMeta(e),
                i = { meta: n, index: e };
              !1 !== Mn.notify(t, "beforeDatasetUpdate", [i]) &&
                (n.controller._update(),
                Mn.notify(t, "afterDatasetUpdate", [i]));
            },
            render: function (e) {
              var t = this;
              (e && "object" == typeof e) ||
                (e = { duration: e, lazy: arguments[1] });
              var n = t.options.animation,
                i = Fn(e.duration, n && n.duration),
                a = e.lazy;
              if (!1 !== Mn.notify(t, "beforeRender")) {
                var r = function (e) {
                  Mn.notify(t, "afterRender"),
                    le.callback(n && n.onComplete, [e], t);
                };
                if (n && i) {
                  var l = new pe({
                    numSteps: i / 16.66,
                    easing: e.easing || n.easing,
                    render: function (e, t) {
                      var n = le.easing.effects[t.easing],
                        i = t.currentStep,
                        a = i / t.numSteps;
                      e.draw(n(a), a, i);
                    },
                    onAnimationProgress: n.onProgress,
                    onAnimationComplete: r,
                  });
                  ge.addAnimation(t, l, i, a);
                } else t.draw(), r(new pe({ numSteps: 0, chart: t }));
                return t;
              }
            },
            draw: function (e) {
              var t,
                n,
                i = this;
              if (
                (i.clear(),
                le.isNullOrUndef(e) && (e = 1),
                i.transition(e),
                !(i.width <= 0 || i.height <= 0) &&
                  !1 !== Mn.notify(i, "beforeDraw", [e]))
              ) {
                for (n = i._layers, t = 0; t < n.length && n[t].z <= 0; ++t)
                  n[t].draw(i.chartArea);
                for (i.drawDatasets(e); t < n.length; ++t)
                  n[t].draw(i.chartArea);
                i._drawTooltip(e), Mn.notify(i, "afterDraw", [e]);
              }
            },
            transition: function (e) {
              for (
                var t = this, n = 0, i = (t.data.datasets || []).length;
                n < i;
                ++n
              )
                t.isDatasetVisible(n) &&
                  t.getDatasetMeta(n).controller.transition(e);
              t.tooltip.transition(e);
            },
            _getSortedDatasetMetas: function (e) {
              var t,
                n,
                i = this,
                a = [];
              for (t = 0, n = (i.data.datasets || []).length; t < n; ++t)
                (e && !i.isDatasetVisible(t)) || a.push(i.getDatasetMeta(t));
              return a.sort(Vn("order", "index")), a;
            },
            _getSortedVisibleDatasetMetas: function () {
              return this._getSortedDatasetMetas(!0);
            },
            drawDatasets: function (e) {
              var t,
                n,
                i = this;
              if (!1 !== Mn.notify(i, "beforeDatasetsDraw", [e])) {
                for (
                  n = (t = i._getSortedVisibleDatasetMetas()).length - 1;
                  n >= 0;
                  --n
                )
                  i.drawDataset(t[n], e);
                Mn.notify(i, "afterDatasetsDraw", [e]);
              }
            },
            drawDataset: function (e, t) {
              var n = this,
                i = { meta: e, index: e.index, easingValue: t };
              !1 !== Mn.notify(n, "beforeDatasetDraw", [i]) &&
                (e.controller.draw(t), Mn.notify(n, "afterDatasetDraw", [i]));
            },
            _drawTooltip: function (e) {
              var t = this,
                n = t.tooltip,
                i = { tooltip: n, easingValue: e };
              !1 !== Mn.notify(t, "beforeTooltipDraw", [i]) &&
                (n.draw(), Mn.notify(t, "afterTooltipDraw", [i]));
            },
            getElementAtEvent: function (e) {
              return Ot.modes.single(this, e);
            },
            getElementsAtEvent: function (e) {
              return Ot.modes.label(this, e, { intersect: !0 });
            },
            getElementsAtXAxis: function (e) {
              return Ot.modes["x-axis"](this, e, { intersect: !0 });
            },
            getElementsAtEventForMode: function (e, t, n) {
              var i = Ot.modes[t];
              return "function" == typeof i ? i(this, e, n) : [];
            },
            getDatasetAtEvent: function (e) {
              return Ot.modes.dataset(this, e, { intersect: !0 });
            },
            getDatasetMeta: function (e) {
              var t = this,
                n = t.data.datasets[e];
              n._meta || (n._meta = {});
              var i = n._meta[t.id];
              return (
                i ||
                  (i = n._meta[t.id] =
                    {
                      type: null,
                      data: [],
                      dataset: null,
                      controller: null,
                      hidden: null,
                      xAxisID: null,
                      yAxisID: null,
                      order: n.order || 0,
                      index: e,
                    }),
                i
              );
            },
            getVisibleDatasetCount: function () {
              for (var e = 0, t = 0, n = this.data.datasets.length; t < n; ++t)
                this.isDatasetVisible(t) && e++;
              return e;
            },
            isDatasetVisible: function (e) {
              var t = this.getDatasetMeta(e);
              return "boolean" == typeof t.hidden
                ? !t.hidden
                : !this.data.datasets[e].hidden;
            },
            generateLegend: function () {
              return this.options.legendCallback(this);
            },
            destroyDatasetMeta: function (e) {
              var t = this.id,
                n = this.data.datasets[e],
                i = n._meta && n._meta[t];
              i && (i.controller.destroy(), delete n._meta[t]);
            },
            destroy: function () {
              var e,
                t,
                n = this,
                i = n.canvas;
              for (n.stop(), e = 0, t = n.data.datasets.length; e < t; ++e)
                n.destroyDatasetMeta(e);
              i &&
                (n.unbindEvents(),
                le.canvas.clear(n),
                vn.releaseContext(n.ctx),
                (n.canvas = null),
                (n.ctx = null)),
                Mn.notify(n, "destroy"),
                delete Zn.instances[n.id];
            },
            toBase64Image: function () {
              return this.canvas.toDataURL.apply(this.canvas, arguments);
            },
            initToolTip: function () {
              var e = this;
              e.tooltip = new Pn(
                {
                  _chart: e,
                  _chartInstance: e,
                  _data: e.data,
                  _options: e.options.tooltips,
                },
                e
              );
            },
            bindEvents: function () {
              var e = this,
                t = (e._listeners = {}),
                n = function () {
                  e.eventHandler.apply(e, arguments);
                };
              le.each(e.options.events, function (i) {
                vn.addEventListener(e, i, n), (t[i] = n);
              }),
                e.options.responsive &&
                  ((n = function () {
                    e.resize();
                  }),
                  vn.addEventListener(e, "resize", n),
                  (t.resize = n));
            },
            unbindEvents: function () {
              var e = this,
                t = e._listeners;
              t &&
                (delete e._listeners,
                le.each(t, function (t, n) {
                  vn.removeEventListener(e, n, t);
                }));
            },
            updateHoverStyle: function (e, t, n) {
              var i,
                a,
                r,
                l = n ? "set" : "remove";
              for (a = 0, r = e.length; a < r; ++a)
                (i = e[a]) &&
                  this.getDatasetMeta(i._datasetIndex).controller[
                    l + "HoverStyle"
                  ](i);
              "dataset" === t &&
                this.getDatasetMeta(e[0]._datasetIndex).controller[
                  "_" + l + "DatasetHoverStyle"
                ]();
            },
            eventHandler: function (e) {
              var t = this,
                n = t.tooltip;
              if (!1 !== Mn.notify(t, "beforeEvent", [e])) {
                (t._bufferedRender = !0), (t._bufferedRequest = null);
                var i = t.handleEvent(e);
                n && (i = n._start ? n.handleEvent(e) : i | n.handleEvent(e)),
                  Mn.notify(t, "afterEvent", [e]);
                var a = t._bufferedRequest;
                return (
                  a
                    ? t.render(a)
                    : i &&
                      !t.animating &&
                      (t.stop(),
                      t.render({
                        duration: t.options.hover.animationDuration,
                        lazy: !0,
                      })),
                  (t._bufferedRender = !1),
                  (t._bufferedRequest = null),
                  t
                );
              }
            },
            handleEvent: function (e) {
              var t = this,
                n = t.options || {},
                i = n.hover,
                a = !1;
              return (
                (t.lastActive = t.lastActive || []),
                "mouseout" === e.type
                  ? (t.active = [])
                  : (t.active = t.getElementsAtEventForMode(e, i.mode, i)),
                le.callback(
                  n.onHover || n.hover.onHover,
                  [e.native, t.active],
                  t
                ),
                ("mouseup" !== e.type && "click" !== e.type) ||
                  (n.onClick && n.onClick.call(t, e.native, t.active)),
                t.lastActive.length &&
                  t.updateHoverStyle(t.lastActive, i.mode, !1),
                t.active.length &&
                  i.mode &&
                  t.updateHoverStyle(t.active, i.mode, !0),
                (a = !le.arrayEquals(t.active, t.lastActive)),
                (t.lastActive = t.active),
                a
              );
            },
          }),
            (Zn.instances = {});
          var Un = Zn;
          (Zn.Controller = Zn),
            (Zn.types = {}),
            (le.configMerge = Wn),
            (le.scaleMerge = In);
          var $n = function () {
            function e(e, t, n) {
              var i;
              return (
                "string" == typeof e
                  ? ((i = parseInt(e, 10)),
                    -1 !== e.indexOf("%") && (i = (i / 100) * t.parentNode[n]))
                  : (i = e),
                i
              );
            }
            function t(e) {
              return null != e && "none" !== e;
            }
            function n(n, i, a) {
              var r = document.defaultView,
                l = le._getParentNode(n),
                o = r.getComputedStyle(n)[i],
                s = r.getComputedStyle(l)[i],
                d = t(o),
                u = t(s),
                c = Number.POSITIVE_INFINITY;
              return d || u
                ? Math.min(d ? e(o, n, a) : c, u ? e(s, l, a) : c)
                : "none";
            }
            (le.where = function (e, t) {
              if (le.isArray(e) && Array.prototype.filter) return e.filter(t);
              var n = [];
              return (
                le.each(e, function (e) {
                  t(e) && n.push(e);
                }),
                n
              );
            }),
              (le.findIndex = Array.prototype.findIndex
                ? function (e, t, n) {
                    return e.findIndex(t, n);
                  }
                : function (e, t, n) {
                    n = void 0 === n ? e : n;
                    for (var i = 0, a = e.length; i < a; ++i)
                      if (t.call(n, e[i], i, e)) return i;
                    return -1;
                  }),
              (le.findNextWhere = function (e, t, n) {
                le.isNullOrUndef(n) && (n = -1);
                for (var i = n + 1; i < e.length; i++) {
                  var a = e[i];
                  if (t(a)) return a;
                }
              }),
              (le.findPreviousWhere = function (e, t, n) {
                le.isNullOrUndef(n) && (n = e.length);
                for (var i = n - 1; i >= 0; i--) {
                  var a = e[i];
                  if (t(a)) return a;
                }
              }),
              (le.isNumber = function (e) {
                return !isNaN(parseFloat(e)) && isFinite(e);
              }),
              (le.almostEquals = function (e, t, n) {
                return Math.abs(e - t) < n;
              }),
              (le.almostWhole = function (e, t) {
                var n = Math.round(e);
                return n - t <= e && n + t >= e;
              }),
              (le.max = function (e) {
                return e.reduce(function (e, t) {
                  return isNaN(t) ? e : Math.max(e, t);
                }, Number.NEGATIVE_INFINITY);
              }),
              (le.min = function (e) {
                return e.reduce(function (e, t) {
                  return isNaN(t) ? e : Math.min(e, t);
                }, Number.POSITIVE_INFINITY);
              }),
              (le.sign = Math.sign
                ? function (e) {
                    return Math.sign(e);
                  }
                : function (e) {
                    return 0 == (e = +e) || isNaN(e) ? e : e > 0 ? 1 : -1;
                  }),
              (le.toRadians = function (e) {
                return e * (Math.PI / 180);
              }),
              (le.toDegrees = function (e) {
                return e * (180 / Math.PI);
              }),
              (le._decimalPlaces = function (e) {
                if (le.isFinite(e)) {
                  for (var t = 1, n = 0; Math.round(e * t) / t !== e; )
                    (t *= 10), n++;
                  return n;
                }
              }),
              (le.getAngleFromPoint = function (e, t) {
                var n = t.x - e.x,
                  i = t.y - e.y,
                  a = Math.sqrt(n * n + i * i),
                  r = Math.atan2(i, n);
                return (
                  r < -0.5 * Math.PI && (r += 2 * Math.PI),
                  { angle: r, distance: a }
                );
              }),
              (le.distanceBetweenPoints = function (e, t) {
                return Math.sqrt(
                  Math.pow(t.x - e.x, 2) + Math.pow(t.y - e.y, 2)
                );
              }),
              (le.aliasPixel = function (e) {
                return e % 2 == 0 ? 0 : 0.5;
              }),
              (le._alignPixel = function (e, t, n) {
                var i = e.currentDevicePixelRatio,
                  a = n / 2;
                return Math.round((t - a) * i) / i + a;
              }),
              (le.splineCurve = function (e, t, n, i) {
                var a = e.skip ? t : e,
                  r = t,
                  l = n.skip ? t : n,
                  o = Math.sqrt(
                    Math.pow(r.x - a.x, 2) + Math.pow(r.y - a.y, 2)
                  ),
                  s = Math.sqrt(
                    Math.pow(l.x - r.x, 2) + Math.pow(l.y - r.y, 2)
                  ),
                  d = o / (o + s),
                  u = s / (o + s),
                  c = i * (d = isNaN(d) ? 0 : d),
                  h = i * (u = isNaN(u) ? 0 : u);
                return {
                  previous: {
                    x: r.x - c * (l.x - a.x),
                    y: r.y - c * (l.y - a.y),
                  },
                  next: { x: r.x + h * (l.x - a.x), y: r.y + h * (l.y - a.y) },
                };
              }),
              (le.EPSILON = Number.EPSILON || 1e-14),
              (le.splineCurveMonotone = function (e) {
                var t,
                  n,
                  i,
                  a,
                  r,
                  l,
                  o,
                  s,
                  d,
                  u = (e || []).map(function (e) {
                    return { model: e._model, deltaK: 0, mK: 0 };
                  }),
                  c = u.length;
                for (t = 0; t < c; ++t)
                  if (!(i = u[t]).model.skip) {
                    if (
                      ((n = t > 0 ? u[t - 1] : null),
                      (a = t < c - 1 ? u[t + 1] : null) && !a.model.skip)
                    ) {
                      var h = a.model.x - i.model.x;
                      i.deltaK = 0 !== h ? (a.model.y - i.model.y) / h : 0;
                    }
                    !n || n.model.skip
                      ? (i.mK = i.deltaK)
                      : !a || a.model.skip
                      ? (i.mK = n.deltaK)
                      : this.sign(n.deltaK) !== this.sign(i.deltaK)
                      ? (i.mK = 0)
                      : (i.mK = (n.deltaK + i.deltaK) / 2);
                  }
                for (t = 0; t < c - 1; ++t)
                  (i = u[t]),
                    (a = u[t + 1]),
                    i.model.skip ||
                      a.model.skip ||
                      (le.almostEquals(i.deltaK, 0, this.EPSILON)
                        ? (i.mK = a.mK = 0)
                        : ((r = i.mK / i.deltaK),
                          (l = a.mK / i.deltaK),
                          (s = Math.pow(r, 2) + Math.pow(l, 2)) <= 9 ||
                            ((o = 3 / Math.sqrt(s)),
                            (i.mK = r * o * i.deltaK),
                            (a.mK = l * o * i.deltaK))));
                for (t = 0; t < c; ++t)
                  (i = u[t]).model.skip ||
                    ((n = t > 0 ? u[t - 1] : null),
                    (a = t < c - 1 ? u[t + 1] : null),
                    n &&
                      !n.model.skip &&
                      ((d = (i.model.x - n.model.x) / 3),
                      (i.model.controlPointPreviousX = i.model.x - d),
                      (i.model.controlPointPreviousY = i.model.y - d * i.mK)),
                    a &&
                      !a.model.skip &&
                      ((d = (a.model.x - i.model.x) / 3),
                      (i.model.controlPointNextX = i.model.x + d),
                      (i.model.controlPointNextY = i.model.y + d * i.mK)));
              }),
              (le.nextItem = function (e, t, n) {
                return n
                  ? t >= e.length - 1
                    ? e[0]
                    : e[t + 1]
                  : t >= e.length - 1
                  ? e[e.length - 1]
                  : e[t + 1];
              }),
              (le.previousItem = function (e, t, n) {
                return n
                  ? t <= 0
                    ? e[e.length - 1]
                    : e[t - 1]
                  : t <= 0
                  ? e[0]
                  : e[t - 1];
              }),
              (le.niceNum = function (e, t) {
                var n = Math.floor(le.log10(e)),
                  i = e / Math.pow(10, n);
                return (
                  (t
                    ? i < 1.5
                      ? 1
                      : i < 3
                      ? 2
                      : i < 7
                      ? 5
                      : 10
                    : i <= 1
                    ? 1
                    : i <= 2
                    ? 2
                    : i <= 5
                    ? 5
                    : 10) * Math.pow(10, n)
                );
              }),
              (le.requestAnimFrame =
                "undefined" == typeof window
                  ? function (e) {
                      e();
                    }
                  : window.requestAnimationFrame ||
                    window.webkitRequestAnimationFrame ||
                    window.mozRequestAnimationFrame ||
                    window.oRequestAnimationFrame ||
                    window.msRequestAnimationFrame ||
                    function (e) {
                      return window.setTimeout(e, 1e3 / 60);
                    }),
              (le.getRelativePosition = function (e, t) {
                var n,
                  i,
                  a = e.originalEvent || e,
                  r = e.target || e.srcElement,
                  l = r.getBoundingClientRect(),
                  o = a.touches;
                o && o.length > 0
                  ? ((n = o[0].clientX), (i = o[0].clientY))
                  : ((n = a.clientX), (i = a.clientY));
                var s = parseFloat(le.getStyle(r, "padding-left")),
                  d = parseFloat(le.getStyle(r, "padding-top")),
                  u = parseFloat(le.getStyle(r, "padding-right")),
                  c = parseFloat(le.getStyle(r, "padding-bottom")),
                  h = l.right - l.left - s - u,
                  m = l.bottom - l.top - d - c;
                return {
                  x: (n = Math.round(
                    (((n - l.left - s) / h) * r.width) /
                      t.currentDevicePixelRatio
                  )),
                  y: (i = Math.round(
                    (((i - l.top - d) / m) * r.height) /
                      t.currentDevicePixelRatio
                  )),
                };
              }),
              (le.getConstraintWidth = function (e) {
                return n(e, "max-width", "clientWidth");
              }),
              (le.getConstraintHeight = function (e) {
                return n(e, "max-height", "clientHeight");
              }),
              (le._calculatePadding = function (e, t, n) {
                return (t = le.getStyle(e, t)).indexOf("%") > -1
                  ? (n * parseInt(t, 10)) / 100
                  : parseInt(t, 10);
              }),
              (le._getParentNode = function (e) {
                var t = e.parentNode;
                return (
                  t && "[object ShadowRoot]" === t.toString() && (t = t.host), t
                );
              }),
              (le.getMaximumWidth = function (e) {
                var t = le._getParentNode(e);
                if (!t) return e.clientWidth;
                var n = t.clientWidth,
                  i =
                    n -
                    le._calculatePadding(t, "padding-left", n) -
                    le._calculatePadding(t, "padding-right", n),
                  a = le.getConstraintWidth(e);
                return isNaN(a) ? i : Math.min(i, a);
              }),
              (le.getMaximumHeight = function (e) {
                var t = le._getParentNode(e);
                if (!t) return e.clientHeight;
                var n = t.clientHeight,
                  i =
                    n -
                    le._calculatePadding(t, "padding-top", n) -
                    le._calculatePadding(t, "padding-bottom", n),
                  a = le.getConstraintHeight(e);
                return isNaN(a) ? i : Math.min(i, a);
              }),
              (le.getStyle = function (e, t) {
                return e.currentStyle
                  ? e.currentStyle[t]
                  : document.defaultView
                      .getComputedStyle(e, null)
                      .getPropertyValue(t);
              }),
              (le.retinaScale = function (e, t) {
                var n = (e.currentDevicePixelRatio =
                  t ||
                  ("undefined" != typeof window && window.devicePixelRatio) ||
                  1);
                if (1 !== n) {
                  var i = e.canvas,
                    a = e.height,
                    r = e.width;
                  (i.height = a * n),
                    (i.width = r * n),
                    e.ctx.scale(n, n),
                    i.style.height ||
                      i.style.width ||
                      ((i.style.height = a + "px"), (i.style.width = r + "px"));
                }
              }),
              (le.fontString = function (e, t, n) {
                return t + " " + e + "px " + n;
              }),
              (le.longestText = function (e, t, n, i) {
                var a = ((i = i || {}).data = i.data || {}),
                  r = (i.garbageCollect = i.garbageCollect || []);
                i.font !== t &&
                  ((a = i.data = {}),
                  (r = i.garbageCollect = []),
                  (i.font = t)),
                  (e.font = t);
                var l,
                  o,
                  s,
                  d,
                  u,
                  c = 0,
                  h = n.length;
                for (l = 0; l < h; l++)
                  if (null != (d = n[l]) && !0 !== le.isArray(d))
                    c = le.measureText(e, a, r, c, d);
                  else if (le.isArray(d))
                    for (o = 0, s = d.length; o < s; o++)
                      null == (u = d[o]) ||
                        le.isArray(u) ||
                        (c = le.measureText(e, a, r, c, u));
                var m = r.length / 2;
                if (m > n.length) {
                  for (l = 0; l < m; l++) delete a[r[l]];
                  r.splice(0, m);
                }
                return c;
              }),
              (le.measureText = function (e, t, n, i, a) {
                var r = t[a];
                return (
                  r || ((r = t[a] = e.measureText(a).width), n.push(a)),
                  r > i && (i = r),
                  i
                );
              }),
              (le.numberOfLabelLines = function (e) {
                var t = 1;
                return (
                  le.each(e, function (e) {
                    le.isArray(e) && e.length > t && (t = e.length);
                  }),
                  t
                );
              }),
              (le.color = P
                ? function (e) {
                    return (
                      e instanceof CanvasGradient &&
                        (e = K.global.defaultColor),
                      P(e)
                    );
                  }
                : function (e) {
                    return console.error("Color.js not found!"), e;
                  }),
              (le.getHoverColor = function (e) {
                return e instanceof CanvasPattern || e instanceof CanvasGradient
                  ? e
                  : le.color(e).saturate(0.5).darken(0.1).rgbString();
              });
          };
          function Jn() {
            throw new Error(
              "This method is not implemented: either no adapter can be found or an incomplete integration was provided."
            );
          }
          function qn(e) {
            this.options = e || {};
          }
          le.extend(qn.prototype, {
            formats: Jn,
            parse: Jn,
            format: Jn,
            add: Jn,
            diff: Jn,
            startOf: Jn,
            endOf: Jn,
            _create: function (e) {
              return e;
            },
          }),
            (qn.override = function (e) {
              le.extend(qn.prototype, e);
            });
          var Gn = { _date: qn },
            Xn = {
              formatters: {
                values: function (e) {
                  return le.isArray(e) ? e : "" + e;
                },
                linear: function (e, t, n) {
                  var i = n.length > 3 ? n[2] - n[1] : n[1] - n[0];
                  Math.abs(i) > 1 &&
                    e !== Math.floor(e) &&
                    (i = e - Math.floor(e));
                  var a = le.log10(Math.abs(i)),
                    r = "";
                  if (0 !== e)
                    if (
                      Math.max(Math.abs(n[0]), Math.abs(n[n.length - 1])) < 1e-4
                    ) {
                      var l = le.log10(Math.abs(e)),
                        o = Math.floor(l) - Math.floor(a);
                      (o = Math.max(Math.min(o, 20), 0)),
                        (r = e.toExponential(o));
                    } else {
                      var s = -1 * Math.floor(a);
                      (s = Math.max(Math.min(s, 20), 0)), (r = e.toFixed(s));
                    }
                  else r = "0";
                  return r;
                },
                logarithmic: function (e, t, n) {
                  var i = e / Math.pow(10, Math.floor(le.log10(e)));
                  return 0 === e
                    ? "0"
                    : 1 === i ||
                      2 === i ||
                      5 === i ||
                      0 === t ||
                      t === n.length - 1
                    ? e.toExponential()
                    : "";
                },
              },
            },
            Kn = le.isArray,
            Qn = le.isNullOrUndef,
            ei = le.valueOrDefault,
            ti = le.valueAtIndexOrDefault;
          function ni(e, t) {
            for (
              var n = [], i = e.length / t, a = 0, r = e.length;
              a < r;
              a += i
            )
              n.push(e[Math.floor(a)]);
            return n;
          }
          function ii(e, t, n) {
            var i,
              a = e.getTicks().length,
              r = Math.min(t, a - 1),
              l = e.getPixelForTick(r),
              o = e._startPixel,
              s = e._endPixel,
              d = 1e-6;
            if (
              !(
                n &&
                ((i =
                  1 === a
                    ? Math.max(l - o, s - l)
                    : 0 === t
                    ? (e.getPixelForTick(1) - l) / 2
                    : (l - e.getPixelForTick(r - 1)) / 2),
                (l += r < t ? i : -i) < o - d || l > s + d)
              )
            )
              return l;
          }
          function ai(e, t) {
            le.each(e, function (e) {
              var n,
                i = e.gc,
                a = i.length / 2;
              if (a > t) {
                for (n = 0; n < a; ++n) delete e.data[i[n]];
                i.splice(0, a);
              }
            });
          }
          function ri(e, t, n, i) {
            var a,
              r,
              l,
              o,
              s,
              d,
              u,
              c,
              h,
              m,
              f,
              _,
              p,
              g = n.length,
              y = [],
              v = [],
              M = [],
              b = 0,
              x = 0;
            for (a = 0; a < g; ++a) {
              if (
                ((o = n[a].label),
                (s = n[a].major ? t.major : t.minor),
                (e.font = d = s.string),
                (u = i[d] = i[d] || { data: {}, gc: [] }),
                (c = s.lineHeight),
                (h = m = 0),
                Qn(o) || Kn(o))
              ) {
                if (Kn(o))
                  for (r = 0, l = o.length; r < l; ++r)
                    (f = o[r]),
                      Qn(f) ||
                        Kn(f) ||
                        ((h = le.measureText(e, u.data, u.gc, h, f)), (m += c));
              } else (h = le.measureText(e, u.data, u.gc, h, o)), (m = c);
              y.push(h),
                v.push(m),
                M.push(c / 2),
                (b = Math.max(h, b)),
                (x = Math.max(m, x));
            }
            function L(e) {
              return { width: y[e] || 0, height: v[e] || 0, offset: M[e] || 0 };
            }
            return (
              ai(i, g),
              (_ = y.indexOf(b)),
              (p = v.indexOf(x)),
              { first: L(0), last: L(g - 1), widest: L(_), highest: L(p) }
            );
          }
          function li(e) {
            return e.drawTicks ? e.tickMarkLength : 0;
          }
          function oi(e) {
            var t, n;
            return e.display
              ? ((t = le.options._parseFont(e)),
                (n = le.options.toPadding(e.padding)),
                t.lineHeight + n.height)
              : 0;
          }
          function si(e, t) {
            return le.extend(
              le.options._parseFont({
                fontFamily: ei(t.fontFamily, e.fontFamily),
                fontSize: ei(t.fontSize, e.fontSize),
                fontStyle: ei(t.fontStyle, e.fontStyle),
                lineHeight: ei(t.lineHeight, e.lineHeight),
              }),
              {
                color: le.options.resolve([
                  t.fontColor,
                  e.fontColor,
                  K.global.defaultFontColor,
                ]),
              }
            );
          }
          function di(e) {
            var t = si(e, e.minor);
            return { minor: t, major: e.major.enabled ? si(e, e.major) : t };
          }
          function ui(e) {
            var t,
              n,
              i,
              a = [];
            for (n = 0, i = e.length; n < i; ++n)
              void 0 !== (t = e[n])._index && a.push(t);
            return a;
          }
          function ci(e) {
            var t,
              n,
              i = e.length;
            if (i < 2) return !1;
            for (n = e[0], t = 1; t < i; ++t)
              if (e[t] - e[t - 1] !== n) return !1;
            return n;
          }
          function hi(e, t, n, i) {
            var a,
              r,
              l,
              o,
              s = ci(e),
              d = (t.length - 1) / i;
            if (!s) return Math.max(d, 1);
            for (l = 0, o = (a = le.math._factorize(s)).length - 1; l < o; l++)
              if ((r = a[l]) > d) return r;
            return Math.max(d, 1);
          }
          function mi(e) {
            var t,
              n,
              i = [];
            for (t = 0, n = e.length; t < n; t++) e[t].major && i.push(t);
            return i;
          }
          function fi(e, t, n) {
            var i,
              a,
              r = 0,
              l = t[0];
            for (n = Math.ceil(n), i = 0; i < e.length; i++)
              (a = e[i]),
                i === l ? ((a._index = i), (l = t[++r * n])) : delete a.label;
          }
          function _i(e, t, n, i) {
            var a,
              r,
              l,
              o,
              s = ei(n, 0),
              d = Math.min(ei(i, e.length), e.length),
              u = 0;
            for (
              t = Math.ceil(t),
                i && (t = (a = i - n) / Math.floor(a / t)),
                o = s;
              o < 0;

            )
              u++, (o = Math.round(s + u * t));
            for (r = Math.max(s, 0); r < d; r++)
              (l = e[r]),
                r === o
                  ? ((l._index = r), u++, (o = Math.round(s + u * t)))
                  : delete l.label;
          }
          K._set("scale", {
            display: !0,
            position: "left",
            offset: !1,
            gridLines: {
              display: !0,
              color: "rgba(0,0,0,0.1)",
              lineWidth: 1,
              drawBorder: !0,
              drawOnChartArea: !0,
              drawTicks: !0,
              tickMarkLength: 10,
              zeroLineWidth: 1,
              zeroLineColor: "rgba(0,0,0,0.25)",
              zeroLineBorderDash: [],
              zeroLineBorderDashOffset: 0,
              offsetGridLines: !1,
              borderDash: [],
              borderDashOffset: 0,
            },
            scaleLabel: {
              display: !1,
              labelString: "",
              padding: { top: 4, bottom: 4 },
            },
            ticks: {
              beginAtZero: !1,
              minRotation: 0,
              maxRotation: 50,
              mirror: !1,
              padding: 0,
              reverse: !1,
              display: !0,
              autoSkip: !0,
              autoSkipPadding: 0,
              labelOffset: 0,
              callback: Xn.formatters.values,
              minor: {},
              major: {},
            },
          });
          var pi = fe.extend({
            zeroLineIndex: 0,
            getPadding: function () {
              var e = this;
              return {
                left: e.paddingLeft || 0,
                top: e.paddingTop || 0,
                right: e.paddingRight || 0,
                bottom: e.paddingBottom || 0,
              };
            },
            getTicks: function () {
              return this._ticks;
            },
            _getLabels: function () {
              var e = this.chart.data;
              return (
                this.options.labels ||
                (this.isHorizontal() ? e.xLabels : e.yLabels) ||
                e.labels ||
                []
              );
            },
            mergeTicksOptions: function () {},
            beforeUpdate: function () {
              le.callback(this.options.beforeUpdate, [this]);
            },
            update: function (e, t, n) {
              var i,
                a,
                r,
                l,
                o,
                s = this,
                d = s.options.ticks,
                u = d.sampleSize;
              if (
                (s.beforeUpdate(),
                (s.maxWidth = e),
                (s.maxHeight = t),
                (s.margins = le.extend(
                  { left: 0, right: 0, top: 0, bottom: 0 },
                  n
                )),
                (s._ticks = null),
                (s.ticks = null),
                (s._labelSizes = null),
                (s._maxLabelLines = 0),
                (s.longestLabelWidth = 0),
                (s.longestTextCache = s.longestTextCache || {}),
                (s._gridLineItems = null),
                (s._labelItems = null),
                s.beforeSetDimensions(),
                s.setDimensions(),
                s.afterSetDimensions(),
                s.beforeDataLimits(),
                s.determineDataLimits(),
                s.afterDataLimits(),
                s.beforeBuildTicks(),
                (l = s.buildTicks() || []),
                (!(l = s.afterBuildTicks(l) || l) || !l.length) && s.ticks)
              )
                for (l = [], i = 0, a = s.ticks.length; i < a; ++i)
                  l.push({ value: s.ticks[i], major: !1 });
              return (
                (s._ticks = l),
                (o = u < l.length),
                (r = s._convertTicksToLabels(o ? ni(l, u) : l)),
                s._configure(),
                s.beforeCalculateTickRotation(),
                s.calculateTickRotation(),
                s.afterCalculateTickRotation(),
                s.beforeFit(),
                s.fit(),
                s.afterFit(),
                (s._ticksToDraw =
                  d.display && (d.autoSkip || "auto" === d.source)
                    ? s._autoSkip(l)
                    : l),
                o && (r = s._convertTicksToLabels(s._ticksToDraw)),
                (s.ticks = r),
                s.afterUpdate(),
                s.minSize
              );
            },
            _configure: function () {
              var e,
                t,
                n = this,
                i = n.options.ticks.reverse;
              n.isHorizontal()
                ? ((e = n.left), (t = n.right))
                : ((e = n.top), (t = n.bottom), (i = !i)),
                (n._startPixel = e),
                (n._endPixel = t),
                (n._reversePixels = i),
                (n._length = t - e);
            },
            afterUpdate: function () {
              le.callback(this.options.afterUpdate, [this]);
            },
            beforeSetDimensions: function () {
              le.callback(this.options.beforeSetDimensions, [this]);
            },
            setDimensions: function () {
              var e = this;
              e.isHorizontal()
                ? ((e.width = e.maxWidth), (e.left = 0), (e.right = e.width))
                : ((e.height = e.maxHeight),
                  (e.top = 0),
                  (e.bottom = e.height)),
                (e.paddingLeft = 0),
                (e.paddingTop = 0),
                (e.paddingRight = 0),
                (e.paddingBottom = 0);
            },
            afterSetDimensions: function () {
              le.callback(this.options.afterSetDimensions, [this]);
            },
            beforeDataLimits: function () {
              le.callback(this.options.beforeDataLimits, [this]);
            },
            determineDataLimits: le.noop,
            afterDataLimits: function () {
              le.callback(this.options.afterDataLimits, [this]);
            },
            beforeBuildTicks: function () {
              le.callback(this.options.beforeBuildTicks, [this]);
            },
            buildTicks: le.noop,
            afterBuildTicks: function (e) {
              var t = this;
              return Kn(e) && e.length
                ? le.callback(t.options.afterBuildTicks, [t, e])
                : ((t.ticks =
                    le.callback(t.options.afterBuildTicks, [t, t.ticks]) ||
                    t.ticks),
                  e);
            },
            beforeTickToLabelConversion: function () {
              le.callback(this.options.beforeTickToLabelConversion, [this]);
            },
            convertTicksToLabels: function () {
              var e = this,
                t = e.options.ticks;
              e.ticks = e.ticks.map(t.userCallback || t.callback, this);
            },
            afterTickToLabelConversion: function () {
              le.callback(this.options.afterTickToLabelConversion, [this]);
            },
            beforeCalculateTickRotation: function () {
              le.callback(this.options.beforeCalculateTickRotation, [this]);
            },
            calculateTickRotation: function () {
              var e,
                t,
                n,
                i,
                a,
                r,
                l,
                o = this,
                s = o.options,
                d = s.ticks,
                u = o.getTicks().length,
                c = d.minRotation || 0,
                h = d.maxRotation,
                m = c;
              !o._isVisible() ||
              !d.display ||
              c >= h ||
              u <= 1 ||
              !o.isHorizontal()
                ? (o.labelRotation = c)
                : ((t = (e = o._getLabelSizes()).widest.width),
                  (n = e.highest.height - e.highest.offset),
                  (i = Math.min(o.maxWidth, o.chart.width - t)),
                  t + 6 > (a = s.offset ? o.maxWidth / u : i / (u - 1)) &&
                    ((a = i / (u - (s.offset ? 0.5 : 1))),
                    (r =
                      o.maxHeight -
                      li(s.gridLines) -
                      d.padding -
                      oi(s.scaleLabel)),
                    (l = Math.sqrt(t * t + n * n)),
                    (m = le.toDegrees(
                      Math.min(
                        Math.asin(Math.min((e.highest.height + 6) / a, 1)),
                        Math.asin(Math.min(r / l, 1)) - Math.asin(n / l)
                      )
                    )),
                    (m = Math.max(c, Math.min(h, m)))),
                  (o.labelRotation = m));
            },
            afterCalculateTickRotation: function () {
              le.callback(this.options.afterCalculateTickRotation, [this]);
            },
            beforeFit: function () {
              le.callback(this.options.beforeFit, [this]);
            },
            fit: function () {
              var e = this,
                t = (e.minSize = { width: 0, height: 0 }),
                n = e.chart,
                i = e.options,
                a = i.ticks,
                r = i.scaleLabel,
                l = i.gridLines,
                o = e._isVisible(),
                s = "bottom" === i.position,
                d = e.isHorizontal();
              if (
                (d ? (t.width = e.maxWidth) : o && (t.width = li(l) + oi(r)),
                d ? o && (t.height = li(l) + oi(r)) : (t.height = e.maxHeight),
                a.display && o)
              ) {
                var u = di(a),
                  c = e._getLabelSizes(),
                  h = c.first,
                  m = c.last,
                  f = c.widest,
                  _ = c.highest,
                  p = 0.4 * u.minor.lineHeight,
                  g = a.padding;
                if (d) {
                  var y = 0 !== e.labelRotation,
                    v = le.toRadians(e.labelRotation),
                    M = Math.cos(v),
                    b = Math.sin(v),
                    x =
                      b * f.width +
                      M * (_.height - (y ? _.offset : 0)) +
                      (y ? 0 : p);
                  t.height = Math.min(e.maxHeight, t.height + x + g);
                  var L,
                    w,
                    k = e.getPixelForTick(0) - e.left,
                    Y = e.right - e.getPixelForTick(e.getTicks().length - 1);
                  y
                    ? ((L = s
                        ? M * h.width + b * h.offset
                        : b * (h.height - h.offset)),
                      (w = s
                        ? b * (m.height - m.offset)
                        : M * m.width + b * m.offset))
                    : ((L = h.width / 2), (w = m.width / 2)),
                    (e.paddingLeft =
                      Math.max(((L - k) * e.width) / (e.width - k), 0) + 3),
                    (e.paddingRight =
                      Math.max(((w - Y) * e.width) / (e.width - Y), 0) + 3);
                } else {
                  var D = a.mirror ? 0 : f.width + g + p;
                  (t.width = Math.min(e.maxWidth, t.width + D)),
                    (e.paddingTop = h.height / 2),
                    (e.paddingBottom = m.height / 2);
                }
              }
              e.handleMargins(),
                d
                  ? ((e.width = e._length =
                      n.width - e.margins.left - e.margins.right),
                    (e.height = t.height))
                  : ((e.width = t.width),
                    (e.height = e._length =
                      n.height - e.margins.top - e.margins.bottom));
            },
            handleMargins: function () {
              var e = this;
              e.margins &&
                ((e.margins.left = Math.max(e.paddingLeft, e.margins.left)),
                (e.margins.top = Math.max(e.paddingTop, e.margins.top)),
                (e.margins.right = Math.max(e.paddingRight, e.margins.right)),
                (e.margins.bottom = Math.max(
                  e.paddingBottom,
                  e.margins.bottom
                )));
            },
            afterFit: function () {
              le.callback(this.options.afterFit, [this]);
            },
            isHorizontal: function () {
              var e = this.options.position;
              return "top" === e || "bottom" === e;
            },
            isFullWidth: function () {
              return this.options.fullWidth;
            },
            getRightValue: function (e) {
              if (Qn(e)) return NaN;
              if (("number" == typeof e || e instanceof Number) && !isFinite(e))
                return NaN;
              if (e)
                if (this.isHorizontal()) {
                  if (void 0 !== e.x) return this.getRightValue(e.x);
                } else if (void 0 !== e.y) return this.getRightValue(e.y);
              return e;
            },
            _convertTicksToLabels: function (e) {
              var t,
                n,
                i,
                a = this;
              for (
                a.ticks = e.map(function (e) {
                  return e.value;
                }),
                  a.beforeTickToLabelConversion(),
                  t = a.convertTicksToLabels(e) || a.ticks,
                  a.afterTickToLabelConversion(),
                  n = 0,
                  i = e.length;
                n < i;
                ++n
              )
                e[n].label = t[n];
              return t;
            },
            _getLabelSizes: function () {
              var e = this,
                t = e._labelSizes;
              return (
                t ||
                  ((e._labelSizes = t =
                    ri(
                      e.ctx,
                      di(e.options.ticks),
                      e.getTicks(),
                      e.longestTextCache
                    )),
                  (e.longestLabelWidth = t.widest.width)),
                t
              );
            },
            _parseValue: function (e) {
              var t, n, i, a;
              return (
                Kn(e)
                  ? ((t = +this.getRightValue(e[0])),
                    (n = +this.getRightValue(e[1])),
                    (i = Math.min(t, n)),
                    (a = Math.max(t, n)))
                  : ((t = void 0),
                    (n = e = +this.getRightValue(e)),
                    (i = e),
                    (a = e)),
                { min: i, max: a, start: t, end: n }
              );
            },
            _getScaleLabel: function (e) {
              var t = this._parseValue(e);
              return void 0 !== t.start
                ? "[" + t.start + ", " + t.end + "]"
                : +this.getRightValue(e);
            },
            getLabelForIndex: le.noop,
            getPixelForValue: le.noop,
            getValueForPixel: le.noop,
            getPixelForTick: function (e) {
              var t = this,
                n = t.options.offset,
                i = t._ticks.length,
                a = 1 / Math.max(i - (n ? 0 : 1), 1);
              return e < 0 || e > i - 1
                ? null
                : t.getPixelForDecimal(e * a + (n ? a / 2 : 0));
            },
            getPixelForDecimal: function (e) {
              var t = this;
              return (
                t._reversePixels && (e = 1 - e), t._startPixel + e * t._length
              );
            },
            getDecimalForPixel: function (e) {
              var t = (e - this._startPixel) / this._length;
              return this._reversePixels ? 1 - t : t;
            },
            getBasePixel: function () {
              return this.getPixelForValue(this.getBaseValue());
            },
            getBaseValue: function () {
              var e = this,
                t = e.min,
                n = e.max;
              return e.beginAtZero
                ? 0
                : t < 0 && n < 0
                ? n
                : t > 0 && n > 0
                ? t
                : 0;
            },
            _autoSkip: function (e) {
              var t,
                n,
                i,
                a,
                r = this,
                l = r.options.ticks,
                o = r._length,
                s = l.maxTicksLimit || o / r._tickSize() + 1,
                d = l.major.enabled ? mi(e) : [],
                u = d.length,
                c = d[0],
                h = d[u - 1];
              if (u > s) return fi(e, d, u / s), ui(e);
              if (((i = hi(d, e, o, s)), u > 0)) {
                for (t = 0, n = u - 1; t < n; t++) _i(e, i, d[t], d[t + 1]);
                return (
                  (a = u > 1 ? (h - c) / (u - 1) : null),
                  _i(e, i, le.isNullOrUndef(a) ? 0 : c - a, c),
                  _i(e, i, h, le.isNullOrUndef(a) ? e.length : h + a),
                  ui(e)
                );
              }
              return _i(e, i), ui(e);
            },
            _tickSize: function () {
              var e = this,
                t = e.options.ticks,
                n = le.toRadians(e.labelRotation),
                i = Math.abs(Math.cos(n)),
                a = Math.abs(Math.sin(n)),
                r = e._getLabelSizes(),
                l = t.autoSkipPadding || 0,
                o = r ? r.widest.width + l : 0,
                s = r ? r.highest.height + l : 0;
              return e.isHorizontal()
                ? s * i > o * a
                  ? o / i
                  : s / a
                : s * a < o * i
                ? s / i
                : o / a;
            },
            _isVisible: function () {
              var e,
                t,
                n,
                i = this,
                a = i.chart,
                r = i.options.display;
              if ("auto" !== r) return !!r;
              for (e = 0, t = a.data.datasets.length; e < t; ++e)
                if (
                  a.isDatasetVisible(e) &&
                  ((n = a.getDatasetMeta(e)).xAxisID === i.id ||
                    n.yAxisID === i.id)
                )
                  return !0;
              return !1;
            },
            _computeGridLineItems: function (e) {
              var t,
                n,
                i,
                a,
                r,
                l,
                o,
                s,
                d,
                u,
                c,
                h,
                m,
                f,
                _,
                p,
                g,
                y = this,
                v = y.chart,
                M = y.options,
                b = M.gridLines,
                x = M.position,
                L = b.offsetGridLines,
                w = y.isHorizontal(),
                k = y._ticksToDraw,
                Y = k.length + (L ? 1 : 0),
                D = li(b),
                T = [],
                S = b.drawBorder ? ti(b.lineWidth, 0, 0) : 0,
                j = S / 2,
                O = le._alignPixel,
                A = function (e) {
                  return O(v, e, S);
                };
              for (
                "top" === x
                  ? ((t = A(y.bottom)),
                    (o = y.bottom - D),
                    (d = t - j),
                    (c = A(e.top) + j),
                    (m = e.bottom))
                  : "bottom" === x
                  ? ((t = A(y.top)),
                    (c = e.top),
                    (m = A(e.bottom) - j),
                    (o = t + j),
                    (d = y.top + D))
                  : "left" === x
                  ? ((t = A(y.right)),
                    (l = y.right - D),
                    (s = t - j),
                    (u = A(e.left) + j),
                    (h = e.right))
                  : ((t = A(y.left)),
                    (u = e.left),
                    (h = A(e.right) - j),
                    (l = t + j),
                    (s = y.left + D)),
                  n = 0;
                n < Y;
                ++n
              )
                (i = k[n] || {}),
                  (Qn(i.label) && n < k.length) ||
                    (n === y.zeroLineIndex && M.offset === L
                      ? ((f = b.zeroLineWidth),
                        (_ = b.zeroLineColor),
                        (p = b.zeroLineBorderDash || []),
                        (g = b.zeroLineBorderDashOffset || 0))
                      : ((f = ti(b.lineWidth, n, 1)),
                        (_ = ti(b.color, n, "rgba(0,0,0,0.1)")),
                        (p = b.borderDash || []),
                        (g = b.borderDashOffset || 0)),
                    void 0 !== (a = ii(y, i._index || n, L)) &&
                      ((r = O(v, a, f)),
                      w ? (l = s = u = h = r) : (o = d = c = m = r),
                      T.push({
                        tx1: l,
                        ty1: o,
                        tx2: s,
                        ty2: d,
                        x1: u,
                        y1: c,
                        x2: h,
                        y2: m,
                        width: f,
                        color: _,
                        borderDash: p,
                        borderDashOffset: g,
                      })));
              return (T.ticksLength = Y), (T.borderValue = t), T;
            },
            _computeLabelItems: function () {
              var e,
                t,
                n,
                i,
                a,
                r,
                l,
                o,
                s,
                d,
                u,
                c,
                h = this,
                m = h.options,
                f = m.ticks,
                _ = m.position,
                p = f.mirror,
                g = h.isHorizontal(),
                y = h._ticksToDraw,
                v = di(f),
                M = f.padding,
                b = li(m.gridLines),
                x = -le.toRadians(h.labelRotation),
                L = [];
              for (
                "top" === _
                  ? ((r = h.bottom - b - M), (l = x ? "left" : "center"))
                  : "bottom" === _
                  ? ((r = h.top + b + M), (l = x ? "right" : "center"))
                  : "left" === _
                  ? ((a = h.right - (p ? 0 : b) - M),
                    (l = p ? "left" : "right"))
                  : ((a = h.left + (p ? 0 : b) + M),
                    (l = p ? "right" : "left")),
                  e = 0,
                  t = y.length;
                e < t;
                ++e
              )
                (i = (n = y[e]).label),
                  Qn(i) ||
                    ((o = h.getPixelForTick(n._index || e) + f.labelOffset),
                    (d = (s = n.major ? v.major : v.minor).lineHeight),
                    (u = Kn(i) ? i.length : 1),
                    g
                      ? ((a = o),
                        (c =
                          "top" === _
                            ? ((x ? 1 : 0.5) - u) * d
                            : (x ? 0 : 0.5) * d))
                      : ((r = o), (c = ((1 - u) * d) / 2)),
                    L.push({
                      x: a,
                      y: r,
                      rotation: x,
                      label: i,
                      font: s,
                      textOffset: c,
                      textAlign: l,
                    }));
              return L;
            },
            _drawGrid: function (e) {
              var t = this,
                n = t.options.gridLines;
              if (n.display) {
                var i,
                  a,
                  r,
                  l,
                  o,
                  s = t.ctx,
                  d = t.chart,
                  u = le._alignPixel,
                  c = n.drawBorder ? ti(n.lineWidth, 0, 0) : 0,
                  h =
                    t._gridLineItems ||
                    (t._gridLineItems = t._computeGridLineItems(e));
                for (r = 0, l = h.length; r < l; ++r)
                  (i = (o = h[r]).width),
                    (a = o.color),
                    i &&
                      a &&
                      (s.save(),
                      (s.lineWidth = i),
                      (s.strokeStyle = a),
                      s.setLineDash &&
                        (s.setLineDash(o.borderDash),
                        (s.lineDashOffset = o.borderDashOffset)),
                      s.beginPath(),
                      n.drawTicks &&
                        (s.moveTo(o.tx1, o.ty1), s.lineTo(o.tx2, o.ty2)),
                      n.drawOnChartArea &&
                        (s.moveTo(o.x1, o.y1), s.lineTo(o.x2, o.y2)),
                      s.stroke(),
                      s.restore());
                if (c) {
                  var m,
                    f,
                    _,
                    p,
                    g = c,
                    y = ti(n.lineWidth, h.ticksLength - 1, 1),
                    v = h.borderValue;
                  t.isHorizontal()
                    ? ((m = u(d, t.left, g) - g / 2),
                      (f = u(d, t.right, y) + y / 2),
                      (_ = p = v))
                    : ((_ = u(d, t.top, g) - g / 2),
                      (p = u(d, t.bottom, y) + y / 2),
                      (m = f = v)),
                    (s.lineWidth = c),
                    (s.strokeStyle = ti(n.color, 0)),
                    s.beginPath(),
                    s.moveTo(m, _),
                    s.lineTo(f, p),
                    s.stroke();
                }
              }
            },
            _drawLabels: function () {
              var e = this;
              if (e.options.ticks.display) {
                var t,
                  n,
                  i,
                  a,
                  r,
                  l,
                  o,
                  s,
                  d = e.ctx,
                  u = e._labelItems || (e._labelItems = e._computeLabelItems());
                for (t = 0, i = u.length; t < i; ++t) {
                  if (
                    ((l = (r = u[t]).font),
                    d.save(),
                    d.translate(r.x, r.y),
                    d.rotate(r.rotation),
                    (d.font = l.string),
                    (d.fillStyle = l.color),
                    (d.textBaseline = "middle"),
                    (d.textAlign = r.textAlign),
                    (o = r.label),
                    (s = r.textOffset),
                    Kn(o))
                  )
                    for (n = 0, a = o.length; n < a; ++n)
                      d.fillText("" + o[n], 0, s), (s += l.lineHeight);
                  else d.fillText(o, 0, s);
                  d.restore();
                }
              }
            },
            _drawTitle: function () {
              var e = this,
                t = e.ctx,
                n = e.options,
                i = n.scaleLabel;
              if (i.display) {
                var a,
                  r,
                  l = ei(i.fontColor, K.global.defaultFontColor),
                  o = le.options._parseFont(i),
                  s = le.options.toPadding(i.padding),
                  d = o.lineHeight / 2,
                  u = n.position,
                  c = 0;
                if (e.isHorizontal())
                  (a = e.left + e.width / 2),
                    (r =
                      "bottom" === u
                        ? e.bottom - d - s.bottom
                        : e.top + d + s.top);
                else {
                  var h = "left" === u;
                  (a = h ? e.left + d + s.top : e.right - d - s.top),
                    (r = e.top + e.height / 2),
                    (c = h ? -0.5 * Math.PI : 0.5 * Math.PI);
                }
                t.save(),
                  t.translate(a, r),
                  t.rotate(c),
                  (t.textAlign = "center"),
                  (t.textBaseline = "middle"),
                  (t.fillStyle = l),
                  (t.font = o.string),
                  t.fillText(i.labelString, 0, 0),
                  t.restore();
              }
            },
            draw: function (e) {
              var t = this;
              t._isVisible() &&
                (t._drawGrid(e), t._drawTitle(), t._drawLabels());
            },
            _layers: function () {
              var e = this,
                t = e.options,
                n = (t.ticks && t.ticks.z) || 0,
                i = (t.gridLines && t.gridLines.z) || 0;
              return e._isVisible() && n !== i && e.draw === e._draw
                ? [
                    {
                      z: i,
                      draw: function () {
                        e._drawGrid.apply(e, arguments),
                          e._drawTitle.apply(e, arguments);
                      },
                    },
                    {
                      z: n,
                      draw: function () {
                        e._drawLabels.apply(e, arguments);
                      },
                    },
                  ]
                : [
                    {
                      z: n,
                      draw: function () {
                        e.draw.apply(e, arguments);
                      },
                    },
                  ];
            },
            _getMatchingVisibleMetas: function (e) {
              var t = this,
                n = t.isHorizontal();
              return t.chart
                ._getSortedVisibleDatasetMetas()
                .filter(function (i) {
                  return (
                    (!e || i.type === e) &&
                    (n ? i.xAxisID === t.id : i.yAxisID === t.id)
                  );
                });
            },
          });
          pi.prototype._draw = pi.prototype.draw;
          var gi = pi,
            yi = le.isNullOrUndef,
            vi = { position: "bottom" },
            Mi = gi.extend({
              determineDataLimits: function () {
                var e,
                  t = this,
                  n = t._getLabels(),
                  i = t.options.ticks,
                  a = i.min,
                  r = i.max,
                  l = 0,
                  o = n.length - 1;
                void 0 !== a && (e = n.indexOf(a)) >= 0 && (l = e),
                  void 0 !== r && (e = n.indexOf(r)) >= 0 && (o = e),
                  (t.minIndex = l),
                  (t.maxIndex = o),
                  (t.min = n[l]),
                  (t.max = n[o]);
              },
              buildTicks: function () {
                var e = this,
                  t = e._getLabels(),
                  n = e.minIndex,
                  i = e.maxIndex;
                e.ticks = 0 === n && i === t.length - 1 ? t : t.slice(n, i + 1);
              },
              getLabelForIndex: function (e, t) {
                var n = this,
                  i = n.chart;
                return i.getDatasetMeta(t).controller._getValueScaleId() ===
                  n.id
                  ? n.getRightValue(i.data.datasets[t].data[e])
                  : n._getLabels()[e];
              },
              _configure: function () {
                var e = this,
                  t = e.options.offset,
                  n = e.ticks;
                gi.prototype._configure.call(e),
                  e.isHorizontal() || (e._reversePixels = !e._reversePixels),
                  n &&
                    ((e._startValue = e.minIndex - (t ? 0.5 : 0)),
                    (e._valueRange = Math.max(n.length - (t ? 0 : 1), 1)));
              },
              getPixelForValue: function (e, t, n) {
                var i,
                  a,
                  r,
                  l = this;
                return (
                  yi(t) || yi(n) || (e = l.chart.data.datasets[n].data[t]),
                  yi(e) || (i = l.isHorizontal() ? e.x : e.y),
                  (void 0 !== i || (void 0 !== e && isNaN(t))) &&
                    ((a = l._getLabels()),
                    (e = le.valueOrDefault(i, e)),
                    (t = -1 !== (r = a.indexOf(e)) ? r : t),
                    isNaN(t) && (t = e)),
                  l.getPixelForDecimal((t - l._startValue) / l._valueRange)
                );
              },
              getPixelForTick: function (e) {
                var t = this.ticks;
                return e < 0 || e > t.length - 1
                  ? null
                  : this.getPixelForValue(t[e], e + this.minIndex);
              },
              getValueForPixel: function (e) {
                var t = this,
                  n = Math.round(
                    t._startValue + t.getDecimalForPixel(e) * t._valueRange
                  );
                return Math.min(Math.max(n, 0), t.ticks.length - 1);
              },
              getBasePixel: function () {
                return this.bottom;
              },
            }),
            bi = vi;
          Mi._defaults = bi;
          var xi = le.noop,
            Li = le.isNullOrUndef;
          function wi(e, t) {
            var n,
              i,
              a,
              r,
              l = [],
              o = 1e-14,
              s = e.stepSize,
              d = s || 1,
              u = e.maxTicks - 1,
              c = e.min,
              h = e.max,
              m = e.precision,
              f = t.min,
              _ = t.max,
              p = le.niceNum((_ - f) / u / d) * d;
            if (p < o && Li(c) && Li(h)) return [f, _];
            (r = Math.ceil(_ / p) - Math.floor(f / p)) > u &&
              (p = le.niceNum((r * p) / u / d) * d),
              s || Li(m)
                ? (n = Math.pow(10, le._decimalPlaces(p)))
                : ((n = Math.pow(10, m)), (p = Math.ceil(p * n) / n)),
              (i = Math.floor(f / p) * p),
              (a = Math.ceil(_ / p) * p),
              s &&
                (!Li(c) && le.almostWhole(c / p, p / 1e3) && (i = c),
                !Li(h) && le.almostWhole(h / p, p / 1e3) && (a = h)),
              (r = (a - i) / p),
              (r = le.almostEquals(r, Math.round(r), p / 1e3)
                ? Math.round(r)
                : Math.ceil(r)),
              (i = Math.round(i * n) / n),
              (a = Math.round(a * n) / n),
              l.push(Li(c) ? i : c);
            for (var g = 1; g < r; ++g) l.push(Math.round((i + g * p) * n) / n);
            return l.push(Li(h) ? a : h), l;
          }
          var ki = gi.extend({
              getRightValue: function (e) {
                return "string" == typeof e
                  ? +e
                  : gi.prototype.getRightValue.call(this, e);
              },
              handleTickRangeOptions: function () {
                var e = this,
                  t = e.options.ticks;
                if (t.beginAtZero) {
                  var n = le.sign(e.min),
                    i = le.sign(e.max);
                  n < 0 && i < 0 ? (e.max = 0) : n > 0 && i > 0 && (e.min = 0);
                }
                var a = void 0 !== t.min || void 0 !== t.suggestedMin,
                  r = void 0 !== t.max || void 0 !== t.suggestedMax;
                void 0 !== t.min
                  ? (e.min = t.min)
                  : void 0 !== t.suggestedMin &&
                    (null === e.min
                      ? (e.min = t.suggestedMin)
                      : (e.min = Math.min(e.min, t.suggestedMin))),
                  void 0 !== t.max
                    ? (e.max = t.max)
                    : void 0 !== t.suggestedMax &&
                      (null === e.max
                        ? (e.max = t.suggestedMax)
                        : (e.max = Math.max(e.max, t.suggestedMax))),
                  a !== r &&
                    e.min >= e.max &&
                    (a ? (e.max = e.min + 1) : (e.min = e.max - 1)),
                  e.min === e.max && (e.max++, t.beginAtZero || e.min--);
              },
              getTickLimit: function () {
                var e,
                  t = this,
                  n = t.options.ticks,
                  i = n.stepSize,
                  a = n.maxTicksLimit;
                return (
                  i
                    ? (e = Math.ceil(t.max / i) - Math.floor(t.min / i) + 1)
                    : ((e = t._computeTickLimit()), (a = a || 11)),
                  a && (e = Math.min(a, e)),
                  e
                );
              },
              _computeTickLimit: function () {
                return Number.POSITIVE_INFINITY;
              },
              handleDirectionalChanges: xi,
              buildTicks: function () {
                var e = this,
                  t = e.options.ticks,
                  n = e.getTickLimit(),
                  i = {
                    maxTicks: (n = Math.max(2, n)),
                    min: t.min,
                    max: t.max,
                    precision: t.precision,
                    stepSize: le.valueOrDefault(t.fixedStepSize, t.stepSize),
                  },
                  a = (e.ticks = wi(i, e));
                e.handleDirectionalChanges(),
                  (e.max = le.max(a)),
                  (e.min = le.min(a)),
                  t.reverse
                    ? (a.reverse(), (e.start = e.max), (e.end = e.min))
                    : ((e.start = e.min), (e.end = e.max));
              },
              convertTicksToLabels: function () {
                var e = this;
                (e.ticksAsNumbers = e.ticks.slice()),
                  (e.zeroLineIndex = e.ticks.indexOf(0)),
                  gi.prototype.convertTicksToLabels.call(e);
              },
              _configure: function () {
                var e,
                  t = this,
                  n = t.getTicks(),
                  i = t.min,
                  a = t.max;
                gi.prototype._configure.call(t),
                  t.options.offset &&
                    n.length &&
                    ((i -= e = (a - i) / Math.max(n.length - 1, 1) / 2),
                    (a += e)),
                  (t._startValue = i),
                  (t._endValue = a),
                  (t._valueRange = a - i);
              },
            }),
            Yi = {
              position: "left",
              ticks: { callback: Xn.formatters.linear },
            },
            Di = 0,
            Ti = 1;
          function Si(e, t, n) {
            var i = [
              n.type,
              void 0 === t && void 0 === n.stack ? n.index : "",
              n.stack,
            ].join(".");
            return void 0 === e[i] && (e[i] = { pos: [], neg: [] }), e[i];
          }
          function ji(e, t, n, i) {
            var a,
              r,
              l = e.options,
              o = Si(t, l.stacked, n),
              s = o.pos,
              d = o.neg,
              u = i.length;
            for (a = 0; a < u; ++a)
              (r = e._parseValue(i[a])),
                isNaN(r.min) ||
                  isNaN(r.max) ||
                  n.data[a].hidden ||
                  ((s[a] = s[a] || 0),
                  (d[a] = d[a] || 0),
                  l.relativePoints
                    ? (s[a] = 100)
                    : r.min < 0 || r.max < 0
                    ? (d[a] += r.min)
                    : (s[a] += r.max));
          }
          function Oi(e, t, n) {
            var i,
              a,
              r = n.length;
            for (i = 0; i < r; ++i)
              (a = e._parseValue(n[i])),
                isNaN(a.min) ||
                  isNaN(a.max) ||
                  t.data[i].hidden ||
                  ((e.min = Math.min(e.min, a.min)),
                  (e.max = Math.max(e.max, a.max)));
          }
          var Ai = ki.extend({
              determineDataLimits: function () {
                var e,
                  t,
                  n,
                  i,
                  a = this,
                  r = a.options,
                  l = a.chart.data.datasets,
                  o = a._getMatchingVisibleMetas(),
                  s = r.stacked,
                  d = {},
                  u = o.length;
                if (
                  ((a.min = Number.POSITIVE_INFINITY),
                  (a.max = Number.NEGATIVE_INFINITY),
                  void 0 === s)
                )
                  for (e = 0; !s && e < u; ++e) s = void 0 !== (t = o[e]).stack;
                for (e = 0; e < u; ++e)
                  (n = l[(t = o[e]).index].data),
                    s ? ji(a, d, t, n) : Oi(a, t, n);
                le.each(d, function (e) {
                  (i = e.pos.concat(e.neg)),
                    (a.min = Math.min(a.min, le.min(i))),
                    (a.max = Math.max(a.max, le.max(i)));
                }),
                  (a.min = le.isFinite(a.min) && !isNaN(a.min) ? a.min : Di),
                  (a.max = le.isFinite(a.max) && !isNaN(a.max) ? a.max : Ti),
                  a.handleTickRangeOptions();
              },
              _computeTickLimit: function () {
                var e,
                  t = this;
                return t.isHorizontal()
                  ? Math.ceil(t.width / 40)
                  : ((e = le.options._parseFont(t.options.ticks)),
                    Math.ceil(t.height / e.lineHeight));
              },
              handleDirectionalChanges: function () {
                this.isHorizontal() || this.ticks.reverse();
              },
              getLabelForIndex: function (e, t) {
                return this._getScaleLabel(this.chart.data.datasets[t].data[e]);
              },
              getPixelForValue: function (e) {
                var t = this;
                return t.getPixelForDecimal(
                  (+t.getRightValue(e) - t._startValue) / t._valueRange
                );
              },
              getValueForPixel: function (e) {
                return (
                  this._startValue +
                  this.getDecimalForPixel(e) * this._valueRange
                );
              },
              getPixelForTick: function (e) {
                var t = this.ticksAsNumbers;
                return e < 0 || e > t.length - 1
                  ? null
                  : this.getPixelForValue(t[e]);
              },
            }),
            Hi = Yi;
          Ai._defaults = Hi;
          var Ei = le.valueOrDefault,
            Ci = le.math.log10;
          function Pi(e, t) {
            var n,
              i,
              a = [],
              r = Ei(e.min, Math.pow(10, Math.floor(Ci(t.min)))),
              l = Math.floor(Ci(t.max)),
              o = Math.ceil(t.max / Math.pow(10, l));
            0 === r
              ? ((n = Math.floor(Ci(t.minNotZero))),
                (i = Math.floor(t.minNotZero / Math.pow(10, n))),
                a.push(r),
                (r = i * Math.pow(10, n)))
              : ((n = Math.floor(Ci(r))),
                (i = Math.floor(r / Math.pow(10, n))));
            var s = n < 0 ? Math.pow(10, Math.abs(n)) : 1;
            do {
              a.push(r),
                10 == ++i && ((i = 1), (s = ++n >= 0 ? 1 : s)),
                (r = Math.round(i * Math.pow(10, n) * s) / s);
            } while (n < l || (n === l && i < o));
            var d = Ei(e.max, r);
            return a.push(d), a;
          }
          var Fi = {
            position: "left",
            ticks: { callback: Xn.formatters.logarithmic },
          };
          function Ii(e, t) {
            return le.isFinite(e) && e >= 0 ? e : t;
          }
          var Wi = gi.extend({
              determineDataLimits: function () {
                var e,
                  t,
                  n,
                  i,
                  a,
                  r,
                  l = this,
                  o = l.options,
                  s = l.chart,
                  d = s.data.datasets,
                  u = l.isHorizontal();
                function c(e) {
                  return u ? e.xAxisID === l.id : e.yAxisID === l.id;
                }
                (l.min = Number.POSITIVE_INFINITY),
                  (l.max = Number.NEGATIVE_INFINITY),
                  (l.minNotZero = Number.POSITIVE_INFINITY);
                var h = o.stacked;
                if (void 0 === h)
                  for (e = 0; e < d.length; e++)
                    if (
                      ((t = s.getDatasetMeta(e)),
                      s.isDatasetVisible(e) && c(t) && void 0 !== t.stack)
                    ) {
                      h = !0;
                      break;
                    }
                if (o.stacked || h) {
                  var m = {};
                  for (e = 0; e < d.length; e++) {
                    var f = [
                      (t = s.getDatasetMeta(e)).type,
                      void 0 === o.stacked && void 0 === t.stack ? e : "",
                      t.stack,
                    ].join(".");
                    if (s.isDatasetVisible(e) && c(t))
                      for (
                        void 0 === m[f] && (m[f] = []),
                          a = 0,
                          r = (i = d[e].data).length;
                        a < r;
                        a++
                      ) {
                        var _ = m[f];
                        (n = l._parseValue(i[a])),
                          isNaN(n.min) ||
                            isNaN(n.max) ||
                            t.data[a].hidden ||
                            n.min < 0 ||
                            n.max < 0 ||
                            ((_[a] = _[a] || 0), (_[a] += n.max));
                      }
                  }
                  le.each(m, function (e) {
                    if (e.length > 0) {
                      var t = le.min(e),
                        n = le.max(e);
                      (l.min = Math.min(l.min, t)),
                        (l.max = Math.max(l.max, n));
                    }
                  });
                } else
                  for (e = 0; e < d.length; e++)
                    if (
                      ((t = s.getDatasetMeta(e)), s.isDatasetVisible(e) && c(t))
                    )
                      for (a = 0, r = (i = d[e].data).length; a < r; a++)
                        (n = l._parseValue(i[a])),
                          isNaN(n.min) ||
                            isNaN(n.max) ||
                            t.data[a].hidden ||
                            n.min < 0 ||
                            n.max < 0 ||
                            ((l.min = Math.min(n.min, l.min)),
                            (l.max = Math.max(n.max, l.max)),
                            0 !== n.min &&
                              (l.minNotZero = Math.min(n.min, l.minNotZero)));
                (l.min = le.isFinite(l.min) ? l.min : null),
                  (l.max = le.isFinite(l.max) ? l.max : null),
                  (l.minNotZero = le.isFinite(l.minNotZero)
                    ? l.minNotZero
                    : null),
                  this.handleTickRangeOptions();
              },
              handleTickRangeOptions: function () {
                var e = this,
                  t = e.options.ticks,
                  n = 1,
                  i = 10;
                (e.min = Ii(t.min, e.min)),
                  (e.max = Ii(t.max, e.max)),
                  e.min === e.max &&
                    (0 !== e.min && null !== e.min
                      ? ((e.min = Math.pow(10, Math.floor(Ci(e.min)) - 1)),
                        (e.max = Math.pow(10, Math.floor(Ci(e.max)) + 1)))
                      : ((e.min = n), (e.max = i))),
                  null === e.min &&
                    (e.min = Math.pow(10, Math.floor(Ci(e.max)) - 1)),
                  null === e.max &&
                    (e.max =
                      0 !== e.min
                        ? Math.pow(10, Math.floor(Ci(e.min)) + 1)
                        : i),
                  null === e.minNotZero &&
                    (e.min > 0
                      ? (e.minNotZero = e.min)
                      : e.max < 1
                      ? (e.minNotZero = Math.pow(10, Math.floor(Ci(e.max))))
                      : (e.minNotZero = n));
              },
              buildTicks: function () {
                var e = this,
                  t = e.options.ticks,
                  n = !e.isHorizontal(),
                  i = { min: Ii(t.min), max: Ii(t.max) },
                  a = (e.ticks = Pi(i, e));
                (e.max = le.max(a)),
                  (e.min = le.min(a)),
                  t.reverse
                    ? ((n = !n), (e.start = e.max), (e.end = e.min))
                    : ((e.start = e.min), (e.end = e.max)),
                  n && a.reverse();
              },
              convertTicksToLabels: function () {
                (this.tickValues = this.ticks.slice()),
                  gi.prototype.convertTicksToLabels.call(this);
              },
              getLabelForIndex: function (e, t) {
                return this._getScaleLabel(this.chart.data.datasets[t].data[e]);
              },
              getPixelForTick: function (e) {
                var t = this.tickValues;
                return e < 0 || e > t.length - 1
                  ? null
                  : this.getPixelForValue(t[e]);
              },
              _getFirstTickValue: function (e) {
                var t = Math.floor(Ci(e));
                return Math.floor(e / Math.pow(10, t)) * Math.pow(10, t);
              },
              _configure: function () {
                var e = this,
                  t = e.min,
                  n = 0;
                gi.prototype._configure.call(e),
                  0 === t &&
                    ((t = e._getFirstTickValue(e.minNotZero)),
                    (n =
                      Ei(e.options.ticks.fontSize, K.global.defaultFontSize) /
                      e._length)),
                  (e._startValue = Ci(t)),
                  (e._valueOffset = n),
                  (e._valueRange = (Ci(e.max) - Ci(t)) / (1 - n));
              },
              getPixelForValue: function (e) {
                var t = this,
                  n = 0;
                return (
                  (e = +t.getRightValue(e)) > t.min &&
                    e > 0 &&
                    (n =
                      (Ci(e) - t._startValue) / t._valueRange + t._valueOffset),
                  t.getPixelForDecimal(n)
                );
              },
              getValueForPixel: function (e) {
                var t = this,
                  n = t.getDecimalForPixel(e);
                return 0 === n && 0 === t.min
                  ? 0
                  : Math.pow(
                      10,
                      t._startValue + (n - t._valueOffset) * t._valueRange
                    );
              },
            }),
            zi = Fi;
          Wi._defaults = zi;
          var Ni = le.valueOrDefault,
            Ri = le.valueAtIndexOrDefault,
            Bi = le.options.resolve,
            Vi = {
              display: !0,
              animate: !0,
              position: "chartArea",
              angleLines: {
                display: !0,
                color: "rgba(0,0,0,0.1)",
                lineWidth: 1,
                borderDash: [],
                borderDashOffset: 0,
              },
              gridLines: { circular: !1 },
              ticks: {
                showLabelBackdrop: !0,
                backdropColor: "rgba(255,255,255,0.75)",
                backdropPaddingY: 2,
                backdropPaddingX: 2,
                callback: Xn.formatters.linear,
              },
              pointLabels: {
                display: !0,
                fontSize: 10,
                callback: function (e) {
                  return e;
                },
              },
            };
          function Zi(e) {
            var t = e.ticks;
            return t.display && e.display
              ? Ni(t.fontSize, K.global.defaultFontSize) +
                  2 * t.backdropPaddingY
              : 0;
          }
          function Ui(e, t, n) {
            return le.isArray(n)
              ? { w: le.longestText(e, e.font, n), h: n.length * t }
              : { w: e.measureText(n).width, h: t };
          }
          function $i(e, t, n, i, a) {
            return e === i || e === a
              ? { start: t - n / 2, end: t + n / 2 }
              : e < i || e > a
              ? { start: t - n, end: t }
              : { start: t, end: t + n };
          }
          function Ji(e) {
            var t,
              n,
              i,
              a = le.options._parseFont(e.options.pointLabels),
              r = { l: 0, r: e.width, t: 0, b: e.height - e.paddingTop },
              l = {};
            (e.ctx.font = a.string), (e._pointLabelSizes = []);
            var o = e.chart.data.labels.length;
            for (t = 0; t < o; t++) {
              (i = e.getPointPosition(t, e.drawingArea + 5)),
                (n = Ui(e.ctx, a.lineHeight, e.pointLabels[t])),
                (e._pointLabelSizes[t] = n);
              var s = e.getIndexAngle(t),
                d = le.toDegrees(s) % 360,
                u = $i(d, i.x, n.w, 0, 180),
                c = $i(d, i.y, n.h, 90, 270);
              u.start < r.l && ((r.l = u.start), (l.l = s)),
                u.end > r.r && ((r.r = u.end), (l.r = s)),
                c.start < r.t && ((r.t = c.start), (l.t = s)),
                c.end > r.b && ((r.b = c.end), (l.b = s));
            }
            e.setReductions(e.drawingArea, r, l);
          }
          function qi(e) {
            return 0 === e || 180 === e ? "center" : e < 180 ? "left" : "right";
          }
          function Gi(e, t, n, i) {
            var a,
              r,
              l = n.y + i / 2;
            if (le.isArray(t))
              for (a = 0, r = t.length; a < r; ++a)
                e.fillText(t[a], n.x, l), (l += i);
            else e.fillText(t, n.x, l);
          }
          function Xi(e, t, n) {
            90 === e || 270 === e
              ? (n.y -= t.h / 2)
              : (e > 270 || e < 90) && (n.y -= t.h);
          }
          function Ki(e) {
            var t = e.ctx,
              n = e.options,
              i = n.pointLabels,
              a = Zi(n),
              r = e.getDistanceFromCenterForValue(
                n.ticks.reverse ? e.min : e.max
              ),
              l = le.options._parseFont(i);
            t.save(), (t.font = l.string), (t.textBaseline = "middle");
            for (var o = e.chart.data.labels.length - 1; o >= 0; o--) {
              var s = 0 === o ? a / 2 : 0,
                d = e.getPointPosition(o, r + s + 5),
                u = Ri(i.fontColor, o, K.global.defaultFontColor);
              t.fillStyle = u;
              var c = e.getIndexAngle(o),
                h = le.toDegrees(c);
              (t.textAlign = qi(h)),
                Xi(h, e._pointLabelSizes[o], d),
                Gi(t, e.pointLabels[o], d, l.lineHeight);
            }
            t.restore();
          }
          function Qi(e, t, n, i) {
            var a,
              r = e.ctx,
              l = t.circular,
              o = e.chart.data.labels.length,
              s = Ri(t.color, i - 1),
              d = Ri(t.lineWidth, i - 1);
            if ((l || o) && s && d) {
              if (
                (r.save(),
                (r.strokeStyle = s),
                (r.lineWidth = d),
                r.setLineDash &&
                  (r.setLineDash(t.borderDash || []),
                  (r.lineDashOffset = t.borderDashOffset || 0)),
                r.beginPath(),
                l)
              )
                r.arc(e.xCenter, e.yCenter, n, 0, 2 * Math.PI);
              else {
                (a = e.getPointPosition(0, n)), r.moveTo(a.x, a.y);
                for (var u = 1; u < o; u++)
                  (a = e.getPointPosition(u, n)), r.lineTo(a.x, a.y);
              }
              r.closePath(), r.stroke(), r.restore();
            }
          }
          function ea(e) {
            return le.isNumber(e) ? e : 0;
          }
          var ta = ki.extend({
              setDimensions: function () {
                var e = this;
                (e.width = e.maxWidth),
                  (e.height = e.maxHeight),
                  (e.paddingTop = Zi(e.options) / 2),
                  (e.xCenter = Math.floor(e.width / 2)),
                  (e.yCenter = Math.floor((e.height - e.paddingTop) / 2)),
                  (e.drawingArea =
                    Math.min(e.height - e.paddingTop, e.width) / 2);
              },
              determineDataLimits: function () {
                var e = this,
                  t = e.chart,
                  n = Number.POSITIVE_INFINITY,
                  i = Number.NEGATIVE_INFINITY;
                le.each(t.data.datasets, function (a, r) {
                  if (t.isDatasetVisible(r)) {
                    var l = t.getDatasetMeta(r);
                    le.each(a.data, function (t, a) {
                      var r = +e.getRightValue(t);
                      isNaN(r) ||
                        l.data[a].hidden ||
                        ((n = Math.min(r, n)), (i = Math.max(r, i)));
                    });
                  }
                }),
                  (e.min = n === Number.POSITIVE_INFINITY ? 0 : n),
                  (e.max = i === Number.NEGATIVE_INFINITY ? 0 : i),
                  e.handleTickRangeOptions();
              },
              _computeTickLimit: function () {
                return Math.ceil(this.drawingArea / Zi(this.options));
              },
              convertTicksToLabels: function () {
                var e = this;
                ki.prototype.convertTicksToLabels.call(e),
                  (e.pointLabels = e.chart.data.labels.map(function () {
                    var t = le.callback(
                      e.options.pointLabels.callback,
                      arguments,
                      e
                    );
                    return t || 0 === t ? t : "";
                  }));
              },
              getLabelForIndex: function (e, t) {
                return +this.getRightValue(this.chart.data.datasets[t].data[e]);
              },
              fit: function () {
                var e = this,
                  t = e.options;
                t.display && t.pointLabels.display
                  ? Ji(e)
                  : e.setCenterPoint(0, 0, 0, 0);
              },
              setReductions: function (e, t, n) {
                var i = this,
                  a = t.l / Math.sin(n.l),
                  r = Math.max(t.r - i.width, 0) / Math.sin(n.r),
                  l = -t.t / Math.cos(n.t),
                  o =
                    -Math.max(t.b - (i.height - i.paddingTop), 0) /
                    Math.cos(n.b);
                (a = ea(a)),
                  (r = ea(r)),
                  (l = ea(l)),
                  (o = ea(o)),
                  (i.drawingArea = Math.min(
                    Math.floor(e - (a + r) / 2),
                    Math.floor(e - (l + o) / 2)
                  )),
                  i.setCenterPoint(a, r, l, o);
              },
              setCenterPoint: function (e, t, n, i) {
                var a = this,
                  r = a.width - t - a.drawingArea,
                  l = e + a.drawingArea,
                  o = n + a.drawingArea,
                  s = a.height - a.paddingTop - i - a.drawingArea;
                (a.xCenter = Math.floor((l + r) / 2 + a.left)),
                  (a.yCenter = Math.floor((o + s) / 2 + a.top + a.paddingTop));
              },
              getIndexAngle: function (e) {
                var t = this.chart,
                  n =
                    (e * (360 / t.data.labels.length) +
                      ((t.options || {}).startAngle || 0)) %
                    360;
                return ((n < 0 ? n + 360 : n) * Math.PI * 2) / 360;
              },
              getDistanceFromCenterForValue: function (e) {
                var t = this;
                if (le.isNullOrUndef(e)) return NaN;
                var n = t.drawingArea / (t.max - t.min);
                return t.options.ticks.reverse
                  ? (t.max - e) * n
                  : (e - t.min) * n;
              },
              getPointPosition: function (e, t) {
                var n = this,
                  i = n.getIndexAngle(e) - Math.PI / 2;
                return {
                  x: Math.cos(i) * t + n.xCenter,
                  y: Math.sin(i) * t + n.yCenter,
                };
              },
              getPointPositionForValue: function (e, t) {
                return this.getPointPosition(
                  e,
                  this.getDistanceFromCenterForValue(t)
                );
              },
              getBasePosition: function (e) {
                var t = this,
                  n = t.min,
                  i = t.max;
                return t.getPointPositionForValue(
                  e || 0,
                  t.beginAtZero
                    ? 0
                    : n < 0 && i < 0
                    ? i
                    : n > 0 && i > 0
                    ? n
                    : 0
                );
              },
              _drawGrid: function () {
                var e,
                  t,
                  n,
                  i = this,
                  a = i.ctx,
                  r = i.options,
                  l = r.gridLines,
                  o = r.angleLines,
                  s = Ni(o.lineWidth, l.lineWidth),
                  d = Ni(o.color, l.color);
                if (
                  (r.pointLabels.display && Ki(i),
                  l.display &&
                    le.each(i.ticks, function (e, n) {
                      0 !== n &&
                        ((t = i.getDistanceFromCenterForValue(
                          i.ticksAsNumbers[n]
                        )),
                        Qi(i, l, t, n));
                    }),
                  o.display && s && d)
                ) {
                  for (
                    a.save(),
                      a.lineWidth = s,
                      a.strokeStyle = d,
                      a.setLineDash &&
                        (a.setLineDash(Bi([o.borderDash, l.borderDash, []])),
                        (a.lineDashOffset = Bi([
                          o.borderDashOffset,
                          l.borderDashOffset,
                          0,
                        ]))),
                      e = i.chart.data.labels.length - 1;
                    e >= 0;
                    e--
                  )
                    (t = i.getDistanceFromCenterForValue(
                      r.ticks.reverse ? i.min : i.max
                    )),
                      (n = i.getPointPosition(e, t)),
                      a.beginPath(),
                      a.moveTo(i.xCenter, i.yCenter),
                      a.lineTo(n.x, n.y),
                      a.stroke();
                  a.restore();
                }
              },
              _drawLabels: function () {
                var e = this,
                  t = e.ctx,
                  n = e.options.ticks;
                if (n.display) {
                  var i,
                    a,
                    r = e.getIndexAngle(0),
                    l = le.options._parseFont(n),
                    o = Ni(n.fontColor, K.global.defaultFontColor);
                  t.save(),
                    (t.font = l.string),
                    t.translate(e.xCenter, e.yCenter),
                    t.rotate(r),
                    (t.textAlign = "center"),
                    (t.textBaseline = "middle"),
                    le.each(e.ticks, function (r, s) {
                      (0 !== s || n.reverse) &&
                        ((i = e.getDistanceFromCenterForValue(
                          e.ticksAsNumbers[s]
                        )),
                        n.showLabelBackdrop &&
                          ((a = t.measureText(r).width),
                          (t.fillStyle = n.backdropColor),
                          t.fillRect(
                            -a / 2 - n.backdropPaddingX,
                            -i - l.size / 2 - n.backdropPaddingY,
                            a + 2 * n.backdropPaddingX,
                            l.size + 2 * n.backdropPaddingY
                          )),
                        (t.fillStyle = o),
                        t.fillText(r, 0, -i));
                    }),
                    t.restore();
                }
              },
              _drawTitle: le.noop,
            }),
            na = Vi;
          ta._defaults = na;
          var ia = le._deprecated,
            aa = le.options.resolve,
            ra = le.valueOrDefault,
            la = Number.MIN_SAFE_INTEGER || -9007199254740991,
            oa = Number.MAX_SAFE_INTEGER || 9007199254740991,
            sa = {
              millisecond: { common: !0, size: 1, steps: 1e3 },
              second: { common: !0, size: 1e3, steps: 60 },
              minute: { common: !0, size: 6e4, steps: 60 },
              hour: { common: !0, size: 36e5, steps: 24 },
              day: { common: !0, size: 864e5, steps: 30 },
              week: { common: !1, size: 6048e5, steps: 4 },
              month: { common: !0, size: 2628e6, steps: 12 },
              quarter: { common: !1, size: 7884e6, steps: 4 },
              year: { common: !0, size: 3154e7 },
            },
            da = Object.keys(sa);
          function ua(e, t) {
            return e - t;
          }
          function ca(e) {
            var t,
              n,
              i,
              a = {},
              r = [];
            for (t = 0, n = e.length; t < n; ++t)
              a[(i = e[t])] || ((a[i] = !0), r.push(i));
            return r;
          }
          function ha(e) {
            return le.valueOrDefault(e.time.min, e.ticks.min);
          }
          function ma(e) {
            return le.valueOrDefault(e.time.max, e.ticks.max);
          }
          function fa(e, t, n, i) {
            if ("linear" === i || !e.length)
              return [
                { time: t, pos: 0 },
                { time: n, pos: 1 },
              ];
            var a,
              r,
              l,
              o,
              s,
              d = [],
              u = [t];
            for (a = 0, r = e.length; a < r; ++a)
              (o = e[a]) > t && o < n && u.push(o);
            for (u.push(n), a = 0, r = u.length; a < r; ++a)
              (s = u[a + 1]),
                (l = u[a - 1]),
                (o = u[a]),
                (void 0 !== l &&
                  void 0 !== s &&
                  Math.round((s + l) / 2) === o) ||
                  d.push({ time: o, pos: a / (r - 1) });
            return d;
          }
          function _a(e, t, n) {
            for (var i, a, r, l = 0, o = e.length - 1; l >= 0 && l <= o; ) {
              if (((a = e[(i = (l + o) >> 1) - 1] || null), (r = e[i]), !a))
                return { lo: null, hi: r };
              if (r[t] < n) l = i + 1;
              else {
                if (!(a[t] > n)) return { lo: a, hi: r };
                o = i - 1;
              }
            }
            return { lo: r, hi: null };
          }
          function pa(e, t, n, i) {
            var a = _a(e, t, n),
              r = a.lo ? (a.hi ? a.lo : e[e.length - 2]) : e[0],
              l = a.lo ? (a.hi ? a.hi : e[e.length - 1]) : e[1],
              o = l[t] - r[t],
              s = o ? (n - r[t]) / o : 0,
              d = (l[i] - r[i]) * s;
            return r[i] + d;
          }
          function ga(e, t) {
            var n = e._adapter,
              i = e.options.time,
              a = i.parser,
              r = a || i.format,
              l = t;
            return (
              "function" == typeof a && (l = a(l)),
              le.isFinite(l) ||
                (l = "string" == typeof r ? n.parse(l, r) : n.parse(l)),
              null !== l
                ? +l
                : (a ||
                    "function" != typeof r ||
                    ((l = r(t)), le.isFinite(l) || (l = n.parse(l))),
                  l)
            );
          }
          function ya(e, t) {
            if (le.isNullOrUndef(t)) return null;
            var n = e.options.time,
              i = ga(e, e.getRightValue(t));
            return (
              null === i || (n.round && (i = +e._adapter.startOf(i, n.round))),
              i
            );
          }
          function va(e, t, n, i) {
            var a,
              r,
              l,
              o = da.length;
            for (a = da.indexOf(e); a < o - 1; ++a)
              if (
                ((l = (r = sa[da[a]]).steps ? r.steps : oa),
                r.common && Math.ceil((n - t) / (l * r.size)) <= i)
              )
                return da[a];
            return da[o - 1];
          }
          function Ma(e, t, n, i, a) {
            var r, l;
            for (r = da.length - 1; r >= da.indexOf(n); r--)
              if (
                ((l = da[r]), sa[l].common && e._adapter.diff(a, i, l) >= t - 1)
              )
                return l;
            return da[n ? da.indexOf(n) : 0];
          }
          function ba(e) {
            for (var t = da.indexOf(e) + 1, n = da.length; t < n; ++t)
              if (sa[da[t]].common) return da[t];
          }
          function xa(e, t, n, i) {
            var a,
              r = e._adapter,
              l = e.options,
              o = l.time,
              s = o.unit || va(o.minUnit, t, n, i),
              d = aa([o.stepSize, o.unitStepSize, 1]),
              u = "week" === s && o.isoWeekday,
              c = t,
              h = [];
            if (
              (u && (c = +r.startOf(c, "isoWeek", u)),
              (c = +r.startOf(c, u ? "day" : s)),
              r.diff(n, t, s) > 1e5 * d)
            )
              throw (
                t +
                " and " +
                n +
                " are too far apart with stepSize of " +
                d +
                " " +
                s
              );
            for (a = c; a < n; a = +r.add(a, d, s)) h.push(a);
            return (a !== n && "ticks" !== l.bounds) || h.push(a), h;
          }
          function La(e, t, n, i, a) {
            var r,
              l,
              o = 0,
              s = 0;
            return (
              a.offset &&
                t.length &&
                ((r = pa(e, "time", t[0], "pos")),
                (o =
                  1 === t.length
                    ? 1 - r
                    : (pa(e, "time", t[1], "pos") - r) / 2),
                (l = pa(e, "time", t[t.length - 1], "pos")),
                (s =
                  1 === t.length
                    ? l
                    : (l - pa(e, "time", t[t.length - 2], "pos")) / 2)),
              { start: o, end: s, factor: 1 / (o + 1 + s) }
            );
          }
          function wa(e, t, n, i) {
            var a,
              r,
              l = e._adapter,
              o = +l.startOf(t[0].value, i),
              s = t[t.length - 1].value;
            for (a = o; a <= s; a = +l.add(a, 1, i))
              (r = n[a]) >= 0 && (t[r].major = !0);
            return t;
          }
          function ka(e, t, n) {
            var i,
              a,
              r = [],
              l = {},
              o = t.length;
            for (i = 0; i < o; ++i)
              (l[(a = t[i])] = i), r.push({ value: a, major: !1 });
            return 0 !== o && n ? wa(e, r, l, n) : r;
          }
          var Ya = {
              position: "bottom",
              distribution: "linear",
              bounds: "data",
              adapters: {},
              time: {
                parser: !1,
                unit: !1,
                round: !1,
                displayFormat: !1,
                isoWeekday: !1,
                minUnit: "millisecond",
                displayFormats: {},
              },
              ticks: { autoSkip: !1, source: "auto", major: { enabled: !1 } },
            },
            Da = gi.extend({
              initialize: function () {
                this.mergeTicksOptions(), gi.prototype.initialize.call(this);
              },
              update: function () {
                var e = this,
                  t = e.options,
                  n = t.time || (t.time = {}),
                  i = (e._adapter = new Gn._date(t.adapters.date));
                return (
                  ia("time scale", n.format, "time.format", "time.parser"),
                  ia("time scale", n.min, "time.min", "ticks.min"),
                  ia("time scale", n.max, "time.max", "ticks.max"),
                  le.mergeIf(n.displayFormats, i.formats()),
                  gi.prototype.update.apply(e, arguments)
                );
              },
              getRightValue: function (e) {
                return (
                  e && void 0 !== e.t && (e = e.t),
                  gi.prototype.getRightValue.call(this, e)
                );
              },
              determineDataLimits: function () {
                var e,
                  t,
                  n,
                  i,
                  a,
                  r,
                  l,
                  o = this,
                  s = o.chart,
                  d = o._adapter,
                  u = o.options,
                  c = u.time.unit || "day",
                  h = oa,
                  m = la,
                  f = [],
                  _ = [],
                  p = [],
                  g = o._getLabels();
                for (e = 0, n = g.length; e < n; ++e) p.push(ya(o, g[e]));
                for (e = 0, n = (s.data.datasets || []).length; e < n; ++e)
                  if (s.isDatasetVisible(e))
                    if (((a = s.data.datasets[e].data), le.isObject(a[0])))
                      for (_[e] = [], t = 0, i = a.length; t < i; ++t)
                        (r = ya(o, a[t])), f.push(r), (_[e][t] = r);
                    else
                      (_[e] = p.slice(0)), l || ((f = f.concat(p)), (l = !0));
                  else _[e] = [];
                p.length &&
                  ((h = Math.min(h, p[0])), (m = Math.max(m, p[p.length - 1]))),
                  f.length &&
                    ((f = n > 1 ? ca(f).sort(ua) : f.sort(ua)),
                    (h = Math.min(h, f[0])),
                    (m = Math.max(m, f[f.length - 1]))),
                  (h = ya(o, ha(u)) || h),
                  (m = ya(o, ma(u)) || m),
                  (h = h === oa ? +d.startOf(Date.now(), c) : h),
                  (m = m === la ? +d.endOf(Date.now(), c) + 1 : m),
                  (o.min = Math.min(h, m)),
                  (o.max = Math.max(h + 1, m)),
                  (o._table = []),
                  (o._timestamps = { data: f, datasets: _, labels: p });
              },
              buildTicks: function () {
                var e,
                  t,
                  n,
                  i = this,
                  a = i.min,
                  r = i.max,
                  l = i.options,
                  o = l.ticks,
                  s = l.time,
                  d = i._timestamps,
                  u = [],
                  c = i.getLabelCapacity(a),
                  h = o.source,
                  m = l.distribution;
                for (
                  d =
                    "data" === h || ("auto" === h && "series" === m)
                      ? d.data
                      : "labels" === h
                      ? d.labels
                      : xa(i, a, r, c),
                    "ticks" === l.bounds &&
                      d.length &&
                      ((a = d[0]), (r = d[d.length - 1])),
                    a = ya(i, ha(l)) || a,
                    r = ya(i, ma(l)) || r,
                    e = 0,
                    t = d.length;
                  e < t;
                  ++e
                )
                  (n = d[e]) >= a && n <= r && u.push(n);
                return (
                  (i.min = a),
                  (i.max = r),
                  (i._unit =
                    s.unit ||
                    (o.autoSkip
                      ? va(s.minUnit, i.min, i.max, c)
                      : Ma(i, u.length, s.minUnit, i.min, i.max))),
                  (i._majorUnit =
                    o.major.enabled && "year" !== i._unit
                      ? ba(i._unit)
                      : void 0),
                  (i._table = fa(i._timestamps.data, a, r, m)),
                  (i._offsets = La(i._table, u, a, r, l)),
                  o.reverse && u.reverse(),
                  ka(i, u, i._majorUnit)
                );
              },
              getLabelForIndex: function (e, t) {
                var n = this,
                  i = n._adapter,
                  a = n.chart.data,
                  r = n.options.time,
                  l = a.labels && e < a.labels.length ? a.labels[e] : "",
                  o = a.datasets[t].data[e];
                return (
                  le.isObject(o) && (l = n.getRightValue(o)),
                  r.tooltipFormat
                    ? i.format(ga(n, l), r.tooltipFormat)
                    : "string" == typeof l
                    ? l
                    : i.format(ga(n, l), r.displayFormats.datetime)
                );
              },
              tickFormatFunction: function (e, t, n, i) {
                var a = this,
                  r = a._adapter,
                  l = a.options,
                  o = l.time.displayFormats,
                  s = o[a._unit],
                  d = a._majorUnit,
                  u = o[d],
                  c = n[t],
                  h = l.ticks,
                  m = d && u && c && c.major,
                  f = r.format(e, i || (m ? u : s)),
                  _ = m ? h.major : h.minor,
                  p = aa([
                    _.callback,
                    _.userCallback,
                    h.callback,
                    h.userCallback,
                  ]);
                return p ? p(f, t, n) : f;
              },
              convertTicksToLabels: function (e) {
                var t,
                  n,
                  i = [];
                for (t = 0, n = e.length; t < n; ++t)
                  i.push(this.tickFormatFunction(e[t].value, t, e));
                return i;
              },
              getPixelForOffset: function (e) {
                var t = this,
                  n = t._offsets,
                  i = pa(t._table, "time", e, "pos");
                return t.getPixelForDecimal((n.start + i) * n.factor);
              },
              getPixelForValue: function (e, t, n) {
                var i = this,
                  a = null;
                if (
                  (void 0 !== t &&
                    void 0 !== n &&
                    (a = i._timestamps.datasets[n][t]),
                  null === a && (a = ya(i, e)),
                  null !== a)
                )
                  return i.getPixelForOffset(a);
              },
              getPixelForTick: function (e) {
                var t = this.getTicks();
                return e >= 0 && e < t.length
                  ? this.getPixelForOffset(t[e].value)
                  : null;
              },
              getValueForPixel: function (e) {
                var t = this,
                  n = t._offsets,
                  i = t.getDecimalForPixel(e) / n.factor - n.end,
                  a = pa(t._table, "pos", i, "time");
                return t._adapter._create(a);
              },
              _getLabelSize: function (e) {
                var t = this,
                  n = t.options.ticks,
                  i = t.ctx.measureText(e).width,
                  a = le.toRadians(
                    t.isHorizontal() ? n.maxRotation : n.minRotation
                  ),
                  r = Math.cos(a),
                  l = Math.sin(a),
                  o = ra(n.fontSize, K.global.defaultFontSize);
                return { w: i * r + o * l, h: i * l + o * r };
              },
              getLabelWidth: function (e) {
                return this._getLabelSize(e).w;
              },
              getLabelCapacity: function (e) {
                var t = this,
                  n = t.options.time,
                  i = n.displayFormats,
                  a = i[n.unit] || i.millisecond,
                  r = t.tickFormatFunction(e, 0, ka(t, [e], t._majorUnit), a),
                  l = t._getLabelSize(r),
                  o = Math.floor(
                    t.isHorizontal() ? t.width / l.w : t.height / l.h
                  );
                return t.options.offset && o--, o > 0 ? o : 1;
              },
            }),
            Ta = Ya;
          Da._defaults = Ta;
          var Sa = {
              category: Mi,
              linear: Ai,
              logarithmic: Wi,
              radialLinear: ta,
              time: Da,
            },
            ja = {
              datetime: "MMM D, YYYY, h:mm:ss a",
              millisecond: "h:mm:ss.SSS a",
              second: "h:mm:ss a",
              minute: "h:mm a",
              hour: "hA",
              day: "MMM D",
              week: "ll",
              month: "MMM YYYY",
              quarter: "[Q]Q - YYYY",
              year: "YYYY",
            };
          Gn._date.override(
            "function" == typeof e
              ? {
                  _id: "moment",
                  formats: function () {
                    return ja;
                  },
                  parse: function (t, n) {
                    return (
                      "string" == typeof t && "string" == typeof n
                        ? (t = e(t, n))
                        : t instanceof e || (t = e(t)),
                      t.isValid() ? t.valueOf() : null
                    );
                  },
                  format: function (t, n) {
                    return e(t).format(n);
                  },
                  add: function (t, n, i) {
                    return e(t).add(n, i).valueOf();
                  },
                  diff: function (t, n, i) {
                    return e(t).diff(e(n), i);
                  },
                  startOf: function (t, n, i) {
                    return (
                      (t = e(t)),
                      "isoWeek" === n
                        ? t.isoWeekday(i).valueOf()
                        : t.startOf(n).valueOf()
                    );
                  },
                  endOf: function (t, n) {
                    return e(t).endOf(n).valueOf();
                  },
                  _create: function (t) {
                    return e(t);
                  },
                }
              : {}
          ),
            K._set("global", { plugins: { filler: { propagate: !0 } } });
          var Oa = {
            dataset: function (e) {
              var t = e.fill,
                n = e.chart,
                i = n.getDatasetMeta(t),
                a = (i && n.isDatasetVisible(t) && i.dataset._children) || [],
                r = a.length || 0;
              return r
                ? function (e, t) {
                    return (t < r && a[t]._view) || null;
                  }
                : null;
            },
            boundary: function (e) {
              var t = e.boundary,
                n = t ? t.x : null,
                i = t ? t.y : null;
              return le.isArray(t)
                ? function (e, n) {
                    return t[n];
                  }
                : function (e) {
                    return { x: null === n ? e.x : n, y: null === i ? e.y : i };
                  };
            },
          };
          function Aa(e, t, n) {
            var i,
              a = e._model || {},
              r = a.fill;
            if (
              (void 0 === r && (r = !!a.backgroundColor),
              !1 === r || null === r)
            )
              return !1;
            if (!0 === r) return "origin";
            if (((i = parseFloat(r, 10)), isFinite(i) && Math.floor(i) === i))
              return (
                ("-" !== r[0] && "+" !== r[0]) || (i = t + i),
                !(i === t || i < 0 || i >= n) && i
              );
            switch (r) {
              case "bottom":
                return "start";
              case "top":
                return "end";
              case "zero":
                return "origin";
              case "origin":
              case "start":
              case "end":
                return r;
              default:
                return !1;
            }
          }
          function Ha(e) {
            var t,
              n = e.el._model || {},
              i = e.el._scale || {},
              a = e.fill,
              r = null;
            if (isFinite(a)) return null;
            if (
              ("start" === a
                ? (r = void 0 === n.scaleBottom ? i.bottom : n.scaleBottom)
                : "end" === a
                ? (r = void 0 === n.scaleTop ? i.top : n.scaleTop)
                : void 0 !== n.scaleZero
                ? (r = n.scaleZero)
                : i.getBasePixel && (r = i.getBasePixel()),
              null != r)
            ) {
              if (void 0 !== r.x && void 0 !== r.y) return r;
              if (le.isFinite(r))
                return {
                  x: (t = i.isHorizontal()) ? r : null,
                  y: t ? null : r,
                };
            }
            return null;
          }
          function Ea(e) {
            var t,
              n,
              i,
              a,
              r,
              l = e.el._scale,
              o = l.options,
              s = l.chart.data.labels.length,
              d = e.fill,
              u = [];
            if (!s) return null;
            for (
              t = o.ticks.reverse ? l.max : l.min,
                n = o.ticks.reverse ? l.min : l.max,
                i = l.getPointPositionForValue(0, t),
                a = 0;
              a < s;
              ++a
            )
              (r =
                "start" === d || "end" === d
                  ? l.getPointPositionForValue(a, "start" === d ? t : n)
                  : l.getBasePosition(a)),
                o.gridLines.circular &&
                  ((r.cx = i.x),
                  (r.cy = i.y),
                  (r.angle = l.getIndexAngle(a) - Math.PI / 2)),
                u.push(r);
            return u;
          }
          function Ca(e) {
            return (e.el._scale || {}).getPointPositionForValue ? Ea(e) : Ha(e);
          }
          function Pa(e, t, n) {
            var i,
              a = e[t].fill,
              r = [t];
            if (!n) return a;
            for (; !1 !== a && -1 === r.indexOf(a); ) {
              if (!isFinite(a)) return a;
              if (!(i = e[a])) return !1;
              if (i.visible) return a;
              r.push(a), (a = i.fill);
            }
            return !1;
          }
          function Fa(e) {
            var t = e.fill,
              n = "dataset";
            return !1 === t
              ? null
              : (isFinite(t) || (n = "boundary"), Oa[n](e));
          }
          function Ia(e) {
            return e && !e.skip;
          }
          function Wa(e, t, n, i, a) {
            var r, l, o, s;
            if (i && a) {
              for (e.moveTo(t[0].x, t[0].y), r = 1; r < i; ++r)
                le.canvas.lineTo(e, t[r - 1], t[r]);
              if (void 0 === n[0].angle)
                for (e.lineTo(n[a - 1].x, n[a - 1].y), r = a - 1; r > 0; --r)
                  le.canvas.lineTo(e, n[r], n[r - 1], !0);
              else
                for (
                  l = n[0].cx,
                    o = n[0].cy,
                    s = Math.sqrt(
                      Math.pow(n[0].x - l, 2) + Math.pow(n[0].y - o, 2)
                    ),
                    r = a - 1;
                  r > 0;
                  --r
                )
                  e.arc(l, o, s, n[r].angle, n[r - 1].angle, !0);
            }
          }
          function za(e, t, n, i, a, r) {
            var l,
              o,
              s,
              d,
              u,
              c,
              h,
              m,
              f = t.length,
              _ = i.spanGaps,
              p = [],
              g = [],
              y = 0,
              v = 0;
            for (e.beginPath(), l = 0, o = f; l < o; ++l)
              (u = n((d = t[(s = l % f)]._view), s, i)),
                (c = Ia(d)),
                (h = Ia(u)),
                r && void 0 === m && c && (o = f + (m = l + 1)),
                c && h
                  ? ((y = p.push(d)), (v = g.push(u)))
                  : y &&
                    v &&
                    (_
                      ? (c && p.push(d), h && g.push(u))
                      : (Wa(e, p, g, y, v), (y = v = 0), (p = []), (g = [])));
            Wa(e, p, g, y, v), e.closePath(), (e.fillStyle = a), e.fill();
          }
          var Na = {
              id: "filler",
              afterDatasetsUpdate: function (e, t) {
                var n,
                  i,
                  a,
                  r,
                  l = (e.data.datasets || []).length,
                  o = t.propagate,
                  s = [];
                for (i = 0; i < l; ++i)
                  (r = null),
                    (a = (n = e.getDatasetMeta(i)).dataset) &&
                      a._model &&
                      a instanceof Ue.Line &&
                      (r = {
                        visible: e.isDatasetVisible(i),
                        fill: Aa(a, i, l),
                        chart: e,
                        el: a,
                      }),
                    (n.$filler = r),
                    s.push(r);
                for (i = 0; i < l; ++i)
                  (r = s[i]) &&
                    ((r.fill = Pa(s, i, o)),
                    (r.boundary = Ca(r)),
                    (r.mapper = Fa(r)));
              },
              beforeDatasetsDraw: function (e) {
                var t,
                  n,
                  i,
                  a,
                  r,
                  l,
                  o,
                  s = e._getSortedVisibleDatasetMetas(),
                  d = e.ctx;
                for (n = s.length - 1; n >= 0; --n)
                  (t = s[n].$filler) &&
                    t.visible &&
                    ((a = (i = t.el)._view),
                    (r = i._children || []),
                    (l = t.mapper),
                    (o = a.backgroundColor || K.global.defaultColor),
                    l &&
                      o &&
                      r.length &&
                      (le.canvas.clipArea(d, e.chartArea),
                      za(d, r, l, a, o, i._loop),
                      le.canvas.unclipArea(d)));
              },
            },
            Ra = le.rtl.getRtlAdapter,
            Ba = le.noop,
            Va = le.valueOrDefault;
          function Za(e, t) {
            return e.usePointStyle && e.boxWidth > t ? t : e.boxWidth;
          }
          K._set("global", {
            legend: {
              display: !0,
              position: "top",
              align: "center",
              fullWidth: !0,
              reverse: !1,
              weight: 1e3,
              onClick: function (e, t) {
                var n = t.datasetIndex,
                  i = this.chart,
                  a = i.getDatasetMeta(n);
                (a.hidden =
                  null === a.hidden ? !i.data.datasets[n].hidden : null),
                  i.update();
              },
              onHover: null,
              onLeave: null,
              labels: {
                boxWidth: 40,
                padding: 10,
                generateLabels: function (e) {
                  var t = e.data.datasets,
                    n = e.options.legend || {},
                    i = n.labels && n.labels.usePointStyle;
                  return e._getSortedDatasetMetas().map(function (n) {
                    var a = n.controller.getStyle(i ? 0 : void 0);
                    return {
                      text: t[n.index].label,
                      fillStyle: a.backgroundColor,
                      hidden: !e.isDatasetVisible(n.index),
                      lineCap: a.borderCapStyle,
                      lineDash: a.borderDash,
                      lineDashOffset: a.borderDashOffset,
                      lineJoin: a.borderJoinStyle,
                      lineWidth: a.borderWidth,
                      strokeStyle: a.borderColor,
                      pointStyle: a.pointStyle,
                      rotation: a.rotation,
                      datasetIndex: n.index,
                    };
                  }, this);
                },
              },
            },
            legendCallback: function (e) {
              var t,
                n,
                i,
                a = document.createElement("ul"),
                r = e.data.datasets;
              for (
                a.setAttribute("class", e.id + "-legend"), t = 0, n = r.length;
                t < n;
                t++
              )
                ((i = a.appendChild(document.createElement("li"))).appendChild(
                  document.createElement("span")
                ).style.backgroundColor = r[t].backgroundColor),
                  r[t].label &&
                    i.appendChild(document.createTextNode(r[t].label));
              return a.outerHTML;
            },
          });
          var Ua = fe.extend({
            initialize: function (e) {
              var t = this;
              le.extend(t, e),
                (t.legendHitBoxes = []),
                (t._hoveredItem = null),
                (t.doughnutMode = !1);
            },
            beforeUpdate: Ba,
            update: function (e, t, n) {
              var i = this;
              return (
                i.beforeUpdate(),
                (i.maxWidth = e),
                (i.maxHeight = t),
                (i.margins = n),
                i.beforeSetDimensions(),
                i.setDimensions(),
                i.afterSetDimensions(),
                i.beforeBuildLabels(),
                i.buildLabels(),
                i.afterBuildLabels(),
                i.beforeFit(),
                i.fit(),
                i.afterFit(),
                i.afterUpdate(),
                i.minSize
              );
            },
            afterUpdate: Ba,
            beforeSetDimensions: Ba,
            setDimensions: function () {
              var e = this;
              e.isHorizontal()
                ? ((e.width = e.maxWidth), (e.left = 0), (e.right = e.width))
                : ((e.height = e.maxHeight),
                  (e.top = 0),
                  (e.bottom = e.height)),
                (e.paddingLeft = 0),
                (e.paddingTop = 0),
                (e.paddingRight = 0),
                (e.paddingBottom = 0),
                (e.minSize = { width: 0, height: 0 });
            },
            afterSetDimensions: Ba,
            beforeBuildLabels: Ba,
            buildLabels: function () {
              var e = this,
                t = e.options.labels || {},
                n = le.callback(t.generateLabels, [e.chart], e) || [];
              t.filter &&
                (n = n.filter(function (n) {
                  return t.filter(n, e.chart.data);
                })),
                e.options.reverse && n.reverse(),
                (e.legendItems = n);
            },
            afterBuildLabels: Ba,
            beforeFit: Ba,
            fit: function () {
              var e = this,
                t = e.options,
                n = t.labels,
                i = t.display,
                a = e.ctx,
                r = le.options._parseFont(n),
                l = r.size,
                o = (e.legendHitBoxes = []),
                s = e.minSize,
                d = e.isHorizontal();
              if (
                (d
                  ? ((s.width = e.maxWidth), (s.height = i ? 10 : 0))
                  : ((s.width = i ? 10 : 0), (s.height = e.maxHeight)),
                i)
              ) {
                if (((a.font = r.string), d)) {
                  var u = (e.lineWidths = [0]),
                    c = 0;
                  (a.textAlign = "left"),
                    (a.textBaseline = "middle"),
                    le.each(e.legendItems, function (e, t) {
                      var i = Za(n, l) + l / 2 + a.measureText(e.text).width;
                      (0 === t ||
                        u[u.length - 1] + i + 2 * n.padding > s.width) &&
                        ((c += l + n.padding),
                        (u[u.length - (t > 0 ? 0 : 1)] = 0)),
                        (o[t] = { left: 0, top: 0, width: i, height: l }),
                        (u[u.length - 1] += i + n.padding);
                    }),
                    (s.height += c);
                } else {
                  var h = n.padding,
                    m = (e.columnWidths = []),
                    f = (e.columnHeights = []),
                    _ = n.padding,
                    p = 0,
                    g = 0;
                  le.each(e.legendItems, function (e, t) {
                    var i = Za(n, l) + l / 2 + a.measureText(e.text).width;
                    t > 0 &&
                      g + l + 2 * h > s.height &&
                      ((_ += p + n.padding),
                      m.push(p),
                      f.push(g),
                      (p = 0),
                      (g = 0)),
                      (p = Math.max(p, i)),
                      (g += l + h),
                      (o[t] = { left: 0, top: 0, width: i, height: l });
                  }),
                    (_ += p),
                    m.push(p),
                    f.push(g),
                    (s.width += _);
                }
                (e.width = s.width), (e.height = s.height);
              } else e.width = s.width = e.height = s.height = 0;
            },
            afterFit: Ba,
            isHorizontal: function () {
              return (
                "top" === this.options.position ||
                "bottom" === this.options.position
              );
            },
            draw: function () {
              var e = this,
                t = e.options,
                n = t.labels,
                i = K.global,
                a = i.defaultColor,
                r = i.elements.line,
                l = e.height,
                o = e.columnHeights,
                s = e.width,
                d = e.lineWidths;
              if (t.display) {
                var u,
                  c = Ra(t.rtl, e.left, e.minSize.width),
                  h = e.ctx,
                  m = Va(n.fontColor, i.defaultFontColor),
                  f = le.options._parseFont(n),
                  _ = f.size;
                (h.textAlign = c.textAlign("left")),
                  (h.textBaseline = "middle"),
                  (h.lineWidth = 0.5),
                  (h.strokeStyle = m),
                  (h.fillStyle = m),
                  (h.font = f.string);
                var p = Za(n, _),
                  g = e.legendHitBoxes,
                  y = function (e, t, i) {
                    if (!(isNaN(p) || p <= 0)) {
                      h.save();
                      var l = Va(i.lineWidth, r.borderWidth);
                      if (
                        ((h.fillStyle = Va(i.fillStyle, a)),
                        (h.lineCap = Va(i.lineCap, r.borderCapStyle)),
                        (h.lineDashOffset = Va(
                          i.lineDashOffset,
                          r.borderDashOffset
                        )),
                        (h.lineJoin = Va(i.lineJoin, r.borderJoinStyle)),
                        (h.lineWidth = l),
                        (h.strokeStyle = Va(i.strokeStyle, a)),
                        h.setLineDash &&
                          h.setLineDash(Va(i.lineDash, r.borderDash)),
                        n && n.usePointStyle)
                      ) {
                        var o = (p * Math.SQRT2) / 2,
                          s = c.xPlus(e, p / 2),
                          d = t + _ / 2;
                        le.canvas.drawPoint(
                          h,
                          i.pointStyle,
                          o,
                          s,
                          d,
                          i.rotation
                        );
                      } else
                        h.fillRect(c.leftForLtr(e, p), t, p, _),
                          0 !== l && h.strokeRect(c.leftForLtr(e, p), t, p, _);
                      h.restore();
                    }
                  },
                  v = function (e, t, n, i) {
                    var a = _ / 2,
                      r = c.xPlus(e, p + a),
                      l = t + a;
                    h.fillText(n.text, r, l),
                      n.hidden &&
                        (h.beginPath(),
                        (h.lineWidth = 2),
                        h.moveTo(r, l),
                        h.lineTo(c.xPlus(r, i), l),
                        h.stroke());
                  },
                  M = function (e, i) {
                    switch (t.align) {
                      case "start":
                        return n.padding;
                      case "end":
                        return e - i;
                      default:
                        return (e - i + n.padding) / 2;
                    }
                  },
                  b = e.isHorizontal();
                (u = b
                  ? { x: e.left + M(s, d[0]), y: e.top + n.padding, line: 0 }
                  : { x: e.left + n.padding, y: e.top + M(l, o[0]), line: 0 }),
                  le.rtl.overrideTextDirection(e.ctx, t.textDirection);
                var x = _ + n.padding;
                le.each(e.legendItems, function (t, i) {
                  var a = h.measureText(t.text).width,
                    r = p + _ / 2 + a,
                    m = u.x,
                    f = u.y;
                  c.setWidth(e.minSize.width),
                    b
                      ? i > 0 &&
                        m + r + n.padding > e.left + e.minSize.width &&
                        ((f = u.y += x),
                        u.line++,
                        (m = u.x = e.left + M(s, d[u.line])))
                      : i > 0 &&
                        f + x > e.top + e.minSize.height &&
                        ((m = u.x = m + e.columnWidths[u.line] + n.padding),
                        u.line++,
                        (f = u.y = e.top + M(l, o[u.line])));
                  var L = c.x(m);
                  y(L, f, t),
                    (g[i].left = c.leftForLtr(L, g[i].width)),
                    (g[i].top = f),
                    v(L, f, t, a),
                    b ? (u.x += r + n.padding) : (u.y += x);
                }),
                  le.rtl.restoreTextDirection(e.ctx, t.textDirection);
              }
            },
            _getLegendItemAt: function (e, t) {
              var n,
                i,
                a,
                r = this;
              if (e >= r.left && e <= r.right && t >= r.top && t <= r.bottom)
                for (a = r.legendHitBoxes, n = 0; n < a.length; ++n)
                  if (
                    e >= (i = a[n]).left &&
                    e <= i.left + i.width &&
                    t >= i.top &&
                    t <= i.top + i.height
                  )
                    return r.legendItems[n];
              return null;
            },
            handleEvent: function (e) {
              var t,
                n = this,
                i = n.options,
                a = "mouseup" === e.type ? "click" : e.type;
              if ("mousemove" === a) {
                if (!i.onHover && !i.onLeave) return;
              } else {
                if ("click" !== a) return;
                if (!i.onClick) return;
              }
              (t = n._getLegendItemAt(e.x, e.y)),
                "click" === a
                  ? t && i.onClick && i.onClick.call(n, e.native, t)
                  : (i.onLeave &&
                      t !== n._hoveredItem &&
                      (n._hoveredItem &&
                        i.onLeave.call(n, e.native, n._hoveredItem),
                      (n._hoveredItem = t)),
                    i.onHover && t && i.onHover.call(n, e.native, t));
            },
          });
          function $a(e, t) {
            var n = new Ua({ ctx: e.ctx, options: t, chart: e });
            Vt.configure(e, n, t), Vt.addBox(e, n), (e.legend = n);
          }
          var Ja = {
              id: "legend",
              _element: Ua,
              beforeInit: function (e) {
                var t = e.options.legend;
                t && $a(e, t);
              },
              beforeUpdate: function (e) {
                var t = e.options.legend,
                  n = e.legend;
                t
                  ? (le.mergeIf(t, K.global.legend),
                    n ? (Vt.configure(e, n, t), (n.options = t)) : $a(e, t))
                  : n && (Vt.removeBox(e, n), delete e.legend);
              },
              afterEvent: function (e, t) {
                var n = e.legend;
                n && n.handleEvent(t);
              },
            },
            qa = le.noop;
          K._set("global", {
            title: {
              display: !1,
              fontStyle: "bold",
              fullWidth: !0,
              padding: 10,
              position: "top",
              text: "",
              weight: 2e3,
            },
          });
          var Ga = fe.extend({
            initialize: function (e) {
              var t = this;
              le.extend(t, e), (t.legendHitBoxes = []);
            },
            beforeUpdate: qa,
            update: function (e, t, n) {
              var i = this;
              return (
                i.beforeUpdate(),
                (i.maxWidth = e),
                (i.maxHeight = t),
                (i.margins = n),
                i.beforeSetDimensions(),
                i.setDimensions(),
                i.afterSetDimensions(),
                i.beforeBuildLabels(),
                i.buildLabels(),
                i.afterBuildLabels(),
                i.beforeFit(),
                i.fit(),
                i.afterFit(),
                i.afterUpdate(),
                i.minSize
              );
            },
            afterUpdate: qa,
            beforeSetDimensions: qa,
            setDimensions: function () {
              var e = this;
              e.isHorizontal()
                ? ((e.width = e.maxWidth), (e.left = 0), (e.right = e.width))
                : ((e.height = e.maxHeight),
                  (e.top = 0),
                  (e.bottom = e.height)),
                (e.paddingLeft = 0),
                (e.paddingTop = 0),
                (e.paddingRight = 0),
                (e.paddingBottom = 0),
                (e.minSize = { width: 0, height: 0 });
            },
            afterSetDimensions: qa,
            beforeBuildLabels: qa,
            buildLabels: qa,
            afterBuildLabels: qa,
            beforeFit: qa,
            fit: function () {
              var e,
                t = this,
                n = t.options,
                i = (t.minSize = {}),
                a = t.isHorizontal();
              n.display
                ? ((e =
                    (le.isArray(n.text) ? n.text.length : 1) *
                      le.options._parseFont(n).lineHeight +
                    2 * n.padding),
                  (t.width = i.width = a ? t.maxWidth : e),
                  (t.height = i.height = a ? e : t.maxHeight))
                : (t.width = i.width = t.height = i.height = 0);
            },
            afterFit: qa,
            isHorizontal: function () {
              var e = this.options.position;
              return "top" === e || "bottom" === e;
            },
            draw: function () {
              var e = this,
                t = e.ctx,
                n = e.options;
              if (n.display) {
                var i,
                  a,
                  r,
                  l = le.options._parseFont(n),
                  o = l.lineHeight,
                  s = o / 2 + n.padding,
                  d = 0,
                  u = e.top,
                  c = e.left,
                  h = e.bottom,
                  m = e.right;
                (t.fillStyle = le.valueOrDefault(
                  n.fontColor,
                  K.global.defaultFontColor
                )),
                  (t.font = l.string),
                  e.isHorizontal()
                    ? ((a = c + (m - c) / 2), (r = u + s), (i = m - c))
                    : ((a = "left" === n.position ? c + s : m - s),
                      (r = u + (h - u) / 2),
                      (i = h - u),
                      (d = Math.PI * ("left" === n.position ? -0.5 : 0.5))),
                  t.save(),
                  t.translate(a, r),
                  t.rotate(d),
                  (t.textAlign = "center"),
                  (t.textBaseline = "middle");
                var f = n.text;
                if (le.isArray(f))
                  for (var _ = 0, p = 0; p < f.length; ++p)
                    t.fillText(f[p], 0, _, i), (_ += o);
                else t.fillText(f, 0, 0, i);
                t.restore();
              }
            },
          });
          function Xa(e, t) {
            var n = new Ga({ ctx: e.ctx, options: t, chart: e });
            Vt.configure(e, n, t), Vt.addBox(e, n), (e.titleBlock = n);
          }
          var Ka = {},
            Qa = Na,
            er = Ja,
            tr = {
              id: "title",
              _element: Ga,
              beforeInit: function (e) {
                var t = e.options.title;
                t && Xa(e, t);
              },
              beforeUpdate: function (e) {
                var t = e.options.title,
                  n = e.titleBlock;
                t
                  ? (le.mergeIf(t, K.global.title),
                    n ? (Vt.configure(e, n, t), (n.options = t)) : Xa(e, t))
                  : n && (Vt.removeBox(e, n), delete e.titleBlock);
              },
            };
          for (var nr in ((Ka.filler = Qa),
          (Ka.legend = er),
          (Ka.title = tr),
          (Un.helpers = le),
          $n(),
          (Un._adapters = Gn),
          (Un.Animation = pe),
          (Un.animationService = ge),
          (Un.controllers = wt),
          (Un.DatasetController = Le),
          (Un.defaults = K),
          (Un.Element = fe),
          (Un.elements = Ue),
          (Un.Interaction = Ot),
          (Un.layouts = Vt),
          (Un.platform = vn),
          (Un.plugins = Mn),
          (Un.Scale = gi),
          (Un.scaleService = bn),
          (Un.Ticks = Xn),
          (Un.Tooltip = Pn),
          Un.helpers.each(Sa, function (e, t) {
            Un.scaleService.registerScaleType(t, e, e._defaults);
          }),
          Ka))
            Ka.hasOwnProperty(nr) && Un.plugins.register(Ka[nr]);
          Un.platform.initialize();
          var ir = Un;
          return (
            "undefined" != typeof window && (window.Chart = Un),
            (Un.Chart = Un),
            (Un.Legend = Ka.legend._element),
            (Un.Title = Ka.title._element),
            (Un.pluginService = Un.plugins),
            (Un.PluginBase = Un.Element.extend({})),
            (Un.canvasHelpers = Un.helpers.canvas),
            (Un.layoutService = Un.layouts),
            (Un.LinearScaleBase = ki),
            Un.helpers.each(
              [
                "Bar",
                "Bubble",
                "Doughnut",
                "Line",
                "PolarArea",
                "Radar",
                "Scatter",
              ],
              function (e) {
                Un[e] = function (t, n) {
                  return new Un(
                    t,
                    Un.helpers.merge(n || {}, {
                      type: e.charAt(0).toLowerCase() + e.slice(1),
                    })
                  );
                };
              }
            ),
            ir
          );
        })(
          (function () {
            try {
              return n(381);
            } catch (e) {}
          })()
        );
      },
      8508: function (e) {
        var t;
        "undefined" != typeof self && self,
          (t = function () {
            return (function (e) {
              var t = {};
              function n(i) {
                if (t[i]) return t[i].exports;
                var a = (t[i] = { i: i, l: !1, exports: {} });
                return (
                  e[i].call(a.exports, a, a.exports, n), (a.l = !0), a.exports
                );
              }
              return (
                (n.m = e),
                (n.c = t),
                (n.d = function (e, t, i) {
                  n.o(e, t) ||
                    Object.defineProperty(e, t, {
                      configurable: !1,
                      enumerable: !0,
                      get: i,
                    });
                }),
                (n.r = function (e) {
                  Object.defineProperty(e, "__esModule", { value: !0 });
                }),
                (n.n = function (e) {
                  var t =
                    e && e.__esModule
                      ? function () {
                          return e.default;
                        }
                      : function () {
                          return e;
                        };
                  return n.d(t, "a", t), t;
                }),
                (n.o = function (e, t) {
                  return Object.prototype.hasOwnProperty.call(e, t);
                }),
                (n.p = ""),
                n((n.s = 0))
              );
            })({
              "./dist/icons.json": function (e) {
                e.exports = {
                  activity:
                    '<polyline points="22 12 18 12 15 21 9 3 6 12 2 12"></polyline>',
                  airplay:
                    '<path d="M5 17H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2h-1"></path><polygon points="12 15 17 21 7 21 12 15"></polygon>',
                  "alert-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
                  "alert-octagon":
                    '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line>',
                  "alert-triangle":
                    '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path><line x1="12" y1="9" x2="12" y2="13"></line><line x1="12" y1="17" x2="12.01" y2="17"></line>',
                  "align-center":
                    '<line x1="18" y1="10" x2="6" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="18" y1="18" x2="6" y2="18"></line>',
                  "align-justify":
                    '<line x1="21" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="3" y2="18"></line>',
                  "align-left":
                    '<line x1="17" y1="10" x2="3" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="17" y1="18" x2="3" y2="18"></line>',
                  "align-right":
                    '<line x1="21" y1="10" x2="7" y2="10"></line><line x1="21" y1="6" x2="3" y2="6"></line><line x1="21" y1="14" x2="3" y2="14"></line><line x1="21" y1="18" x2="7" y2="18"></line>',
                  anchor:
                    '<circle cx="12" cy="5" r="3"></circle><line x1="12" y1="22" x2="12" y2="8"></line><path d="M5 12H2a10 10 0 0 0 20 0h-3"></path>',
                  aperture:
                    '<circle cx="12" cy="12" r="10"></circle><line x1="14.31" y1="8" x2="20.05" y2="17.94"></line><line x1="9.69" y1="8" x2="21.17" y2="8"></line><line x1="7.38" y1="12" x2="13.12" y2="2.06"></line><line x1="9.69" y1="16" x2="3.95" y2="6.06"></line><line x1="14.31" y1="16" x2="2.83" y2="16"></line><line x1="16.62" y1="12" x2="10.88" y2="21.94"></line>',
                  archive:
                    '<polyline points="21 8 21 21 3 21 3 8"></polyline><rect x="1" y="3" width="22" height="5"></rect><line x1="10" y1="12" x2="14" y2="12"></line>',
                  "arrow-down-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="8 12 12 16 16 12"></polyline><line x1="12" y1="8" x2="12" y2="16"></line>',
                  "arrow-down-left":
                    '<line x1="17" y1="7" x2="7" y2="17"></line><polyline points="17 17 7 17 7 7"></polyline>',
                  "arrow-down-right":
                    '<line x1="7" y1="7" x2="17" y2="17"></line><polyline points="17 7 17 17 7 17"></polyline>',
                  "arrow-down":
                    '<line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline>',
                  "arrow-left-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="12 8 8 12 12 16"></polyline><line x1="16" y1="12" x2="8" y2="12"></line>',
                  "arrow-left":
                    '<line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>',
                  "arrow-right-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="12 16 16 12 12 8"></polyline><line x1="8" y1="12" x2="16" y2="12"></line>',
                  "arrow-right":
                    '<line x1="5" y1="12" x2="19" y2="12"></line><polyline points="12 5 19 12 12 19"></polyline>',
                  "arrow-up-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="16 12 12 8 8 12"></polyline><line x1="12" y1="16" x2="12" y2="8"></line>',
                  "arrow-up-left":
                    '<line x1="17" y1="17" x2="7" y2="7"></line><polyline points="7 17 7 7 17 7"></polyline>',
                  "arrow-up-right":
                    '<line x1="7" y1="17" x2="17" y2="7"></line><polyline points="7 7 17 7 17 17"></polyline>',
                  "arrow-up":
                    '<line x1="12" y1="19" x2="12" y2="5"></line><polyline points="5 12 12 5 19 12"></polyline>',
                  "at-sign":
                    '<circle cx="12" cy="12" r="4"></circle><path d="M16 8v5a3 3 0 0 0 6 0v-1a10 10 0 1 0-3.92 7.94"></path>',
                  award:
                    '<circle cx="12" cy="8" r="7"></circle><polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"></polyline>',
                  "bar-chart-2":
                    '<line x1="18" y1="20" x2="18" y2="10"></line><line x1="12" y1="20" x2="12" y2="4"></line><line x1="6" y1="20" x2="6" y2="14"></line>',
                  "bar-chart":
                    '<line x1="12" y1="20" x2="12" y2="10"></line><line x1="18" y1="20" x2="18" y2="4"></line><line x1="6" y1="20" x2="6" y2="16"></line>',
                  "battery-charging":
                    '<path d="M5 18H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3.19M15 6h2a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-3.19"></path><line x1="23" y1="13" x2="23" y2="11"></line><polyline points="11 6 7 12 13 12 9 18"></polyline>',
                  battery:
                    '<rect x="1" y="6" width="18" height="12" rx="2" ry="2"></rect><line x1="23" y1="13" x2="23" y2="11"></line>',
                  "bell-off":
                    '<path d="M13.73 21a2 2 0 0 1-3.46 0"></path><path d="M18.63 13A17.89 17.89 0 0 1 18 8"></path><path d="M6.26 6.26A5.86 5.86 0 0 0 6 8c0 7-3 9-3 9h14"></path><path d="M18 8a6 6 0 0 0-9.33-5"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  bell: '<path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path>',
                  bluetooth:
                    '<polyline points="6.5 6.5 17.5 17.5 12 23 12 1 17.5 6.5 6.5 17.5"></polyline>',
                  bold: '<path d="M6 4h8a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path><path d="M6 12h9a4 4 0 0 1 4 4 4 4 0 0 1-4 4H6z"></path>',
                  "book-open":
                    '<path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path>',
                  book: '<path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"></path><path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"></path>',
                  bookmark:
                    '<path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>',
                  box: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                  briefcase:
                    '<rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect><path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>',
                  calendar:
                    '<rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect><line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line><line x1="3" y1="10" x2="21" y2="10"></line>',
                  "camera-off":
                    '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M21 21H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h3m3-3h6l2 3h4a2 2 0 0 1 2 2v9.34m-7.72-2.06a4 4 0 1 1-5.56-5.56"></path>',
                  camera:
                    '<path d="M23 19a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h4l2-3h6l2 3h4a2 2 0 0 1 2 2z"></path><circle cx="12" cy="13" r="4"></circle>',
                  cast: '<path d="M2 16.1A5 5 0 0 1 5.9 20M2 12.05A9 9 0 0 1 9.95 20M2 8V6a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2h-6"></path><line x1="2" y1="20" x2="2.01" y2="20"></line>',
                  "check-circle":
                    '<path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline>',
                  "check-square":
                    '<polyline points="9 11 12 14 22 4"></polyline><path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>',
                  check: '<polyline points="20 6 9 17 4 12"></polyline>',
                  "chevron-down":
                    '<polyline points="6 9 12 15 18 9"></polyline>',
                  "chevron-left":
                    '<polyline points="15 18 9 12 15 6"></polyline>',
                  "chevron-right":
                    '<polyline points="9 18 15 12 9 6"></polyline>',
                  "chevron-up":
                    '<polyline points="18 15 12 9 6 15"></polyline>',
                  "chevrons-down":
                    '<polyline points="7 13 12 18 17 13"></polyline><polyline points="7 6 12 11 17 6"></polyline>',
                  "chevrons-left":
                    '<polyline points="11 17 6 12 11 7"></polyline><polyline points="18 17 13 12 18 7"></polyline>',
                  "chevrons-right":
                    '<polyline points="13 17 18 12 13 7"></polyline><polyline points="6 17 11 12 6 7"></polyline>',
                  "chevrons-up":
                    '<polyline points="17 11 12 6 7 11"></polyline><polyline points="17 18 12 13 7 18"></polyline>',
                  chrome:
                    '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="21.17" y1="8" x2="12" y2="8"></line><line x1="3.95" y1="6.06" x2="8.54" y2="14"></line><line x1="10.88" y1="21.94" x2="15.46" y2="14"></line>',
                  circle: '<circle cx="12" cy="12" r="10"></circle>',
                  clipboard:
                    '<path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"></path><rect x="8" y="2" width="8" height="4" rx="1" ry="1"></rect>',
                  clock:
                    '<circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline>',
                  "cloud-drizzle":
                    '<line x1="8" y1="19" x2="8" y2="21"></line><line x1="8" y1="13" x2="8" y2="15"></line><line x1="16" y1="19" x2="16" y2="21"></line><line x1="16" y1="13" x2="16" y2="15"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="12" y1="15" x2="12" y2="17"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
                  "cloud-lightning":
                    '<path d="M19 16.9A5 5 0 0 0 18 7h-1.26a8 8 0 1 0-11.62 9"></path><polyline points="13 11 9 17 15 17 11 23"></polyline>',
                  "cloud-off":
                    '<path d="M22.61 16.95A5 5 0 0 0 18 10h-1.26a8 8 0 0 0-7.05-6M5 5a8 8 0 0 0 4 15h9a5 5 0 0 0 1.7-.3"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  "cloud-rain":
                    '<line x1="16" y1="13" x2="16" y2="21"></line><line x1="8" y1="13" x2="8" y2="21"></line><line x1="12" y1="15" x2="12" y2="23"></line><path d="M20 16.58A5 5 0 0 0 18 7h-1.26A8 8 0 1 0 4 15.25"></path>',
                  "cloud-snow":
                    '<path d="M20 17.58A5 5 0 0 0 18 8h-1.26A8 8 0 1 0 4 16.25"></path><line x1="8" y1="16" x2="8.01" y2="16"></line><line x1="8" y1="20" x2="8.01" y2="20"></line><line x1="12" y1="18" x2="12.01" y2="18"></line><line x1="12" y1="22" x2="12.01" y2="22"></line><line x1="16" y1="16" x2="16.01" y2="16"></line><line x1="16" y1="20" x2="16.01" y2="20"></line>',
                  cloud:
                    '<path d="M18 10h-1.26A8 8 0 1 0 9 20h9a5 5 0 0 0 0-10z"></path>',
                  code: '<polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline>',
                  codepen:
                    '<polygon points="12 2 22 8.5 22 15.5 12 22 2 15.5 2 8.5 12 2"></polygon><line x1="12" y1="22" x2="12" y2="15.5"></line><polyline points="22 8.5 12 15.5 2 8.5"></polyline><polyline points="2 15.5 12 8.5 22 15.5"></polyline><line x1="12" y1="2" x2="12" y2="8.5"></line>',
                  codesandbox:
                    '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="7.5 4.21 12 6.81 16.5 4.21"></polyline><polyline points="7.5 19.79 7.5 14.6 3 12"></polyline><polyline points="21 12 16.5 14.6 16.5 19.79"></polyline><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                  coffee:
                    '<path d="M18 8h1a4 4 0 0 1 0 8h-1"></path><path d="M2 8h16v9a4 4 0 0 1-4 4H6a4 4 0 0 1-4-4V8z"></path><line x1="6" y1="1" x2="6" y2="4"></line><line x1="10" y1="1" x2="10" y2="4"></line><line x1="14" y1="1" x2="14" y2="4"></line>',
                  columns:
                    '<path d="M12 3h7a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-7m0-18H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h7m0-18v18"></path>',
                  command:
                    '<path d="M18 3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3 3 3 0 0 0 3-3 3 3 0 0 0-3-3H6a3 3 0 0 0-3 3 3 3 0 0 0 3 3 3 3 0 0 0 3-3V6a3 3 0 0 0-3-3 3 3 0 0 0-3 3 3 3 0 0 0 3 3h12a3 3 0 0 0 3-3 3 3 0 0 0-3-3z"></path>',
                  compass:
                    '<circle cx="12" cy="12" r="10"></circle><polygon points="16.24 7.76 14.12 14.12 7.76 16.24 9.88 9.88 16.24 7.76"></polygon>',
                  copy: '<rect x="9" y="9" width="13" height="13" rx="2" ry="2"></rect><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"></path>',
                  "corner-down-left":
                    '<polyline points="9 10 4 15 9 20"></polyline><path d="M20 4v7a4 4 0 0 1-4 4H4"></path>',
                  "corner-down-right":
                    '<polyline points="15 10 20 15 15 20"></polyline><path d="M4 4v7a4 4 0 0 0 4 4h12"></path>',
                  "corner-left-down":
                    '<polyline points="14 15 9 20 4 15"></polyline><path d="M20 4h-7a4 4 0 0 0-4 4v12"></path>',
                  "corner-left-up":
                    '<polyline points="14 9 9 4 4 9"></polyline><path d="M20 20h-7a4 4 0 0 1-4-4V4"></path>',
                  "corner-right-down":
                    '<polyline points="10 15 15 20 20 15"></polyline><path d="M4 4h7a4 4 0 0 1 4 4v12"></path>',
                  "corner-right-up":
                    '<polyline points="10 9 15 4 20 9"></polyline><path d="M4 20h7a4 4 0 0 0 4-4V4"></path>',
                  "corner-up-left":
                    '<polyline points="9 14 4 9 9 4"></polyline><path d="M20 20v-7a4 4 0 0 0-4-4H4"></path>',
                  "corner-up-right":
                    '<polyline points="15 14 20 9 15 4"></polyline><path d="M4 20v-7a4 4 0 0 1 4-4h12"></path>',
                  cpu: '<rect x="4" y="4" width="16" height="16" rx="2" ry="2"></rect><rect x="9" y="9" width="6" height="6"></rect><line x1="9" y1="1" x2="9" y2="4"></line><line x1="15" y1="1" x2="15" y2="4"></line><line x1="9" y1="20" x2="9" y2="23"></line><line x1="15" y1="20" x2="15" y2="23"></line><line x1="20" y1="9" x2="23" y2="9"></line><line x1="20" y1="14" x2="23" y2="14"></line><line x1="1" y1="9" x2="4" y2="9"></line><line x1="1" y1="14" x2="4" y2="14"></line>',
                  "credit-card":
                    '<rect x="1" y="4" width="22" height="16" rx="2" ry="2"></rect><line x1="1" y1="10" x2="23" y2="10"></line>',
                  crop: '<path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path><path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>',
                  crosshair:
                    '<circle cx="12" cy="12" r="10"></circle><line x1="22" y1="12" x2="18" y2="12"></line><line x1="6" y1="12" x2="2" y2="12"></line><line x1="12" y1="6" x2="12" y2="2"></line><line x1="12" y1="22" x2="12" y2="18"></line>',
                  database:
                    '<ellipse cx="12" cy="5" rx="9" ry="3"></ellipse><path d="M21 12c0 1.66-4 3-9 3s-9-1.34-9-3"></path><path d="M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5"></path>',
                  delete:
                    '<path d="M21 4H8l-7 8 7 8h13a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2z"></path><line x1="18" y1="9" x2="12" y2="15"></line><line x1="12" y1="9" x2="18" y2="15"></line>',
                  disc: '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="3"></circle>',
                  "divide-circle":
                    '<line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line><circle cx="12" cy="12" r="10"></circle>',
                  "divide-square":
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line><line x1="12" y1="16" x2="12" y2="16"></line><line x1="12" y1="8" x2="12" y2="8"></line>',
                  divide:
                    '<circle cx="12" cy="6" r="2"></circle><line x1="5" y1="12" x2="19" y2="12"></line><circle cx="12" cy="18" r="2"></circle>',
                  "dollar-sign":
                    '<line x1="12" y1="1" x2="12" y2="23"></line><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>',
                  "download-cloud":
                    '<polyline points="8 17 12 21 16 17"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.88 18.09A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.29"></path>',
                  download:
                    '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line>',
                  dribbble:
                    '<circle cx="12" cy="12" r="10"></circle><path d="M8.56 2.75c4.37 6.03 6.02 9.42 8.03 17.72m2.54-15.38c-3.72 4.35-8.94 5.66-16.88 5.85m19.5 1.9c-3.5-.93-6.63-.82-8.94 0-2.58.92-5.01 2.86-7.44 6.32"></path>',
                  droplet:
                    '<path d="M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"></path>',
                  "edit-2":
                    '<path d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"></path>',
                  "edit-3":
                    '<path d="M12 20h9"></path><path d="M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"></path>',
                  edit: '<path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>',
                  "external-link":
                    '<path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"></path><polyline points="15 3 21 3 21 9"></polyline><line x1="10" y1="14" x2="21" y2="3"></line>',
                  "eye-off":
                    '<path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  eye: '<path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path><circle cx="12" cy="12" r="3"></circle>',
                  facebook:
                    '<path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>',
                  "fast-forward":
                    '<polygon points="13 19 22 12 13 5 13 19"></polygon><polygon points="2 19 11 12 2 5 2 19"></polygon>',
                  feather:
                    '<path d="M20.24 12.24a6 6 0 0 0-8.49-8.49L5 10.5V19h8.5z"></path><line x1="16" y1="8" x2="2" y2="22"></line><line x1="17.5" y1="15" x2="9" y2="15"></line>',
                  figma:
                    '<path d="M5 5.5A3.5 3.5 0 0 1 8.5 2H12v7H8.5A3.5 3.5 0 0 1 5 5.5z"></path><path d="M12 2h3.5a3.5 3.5 0 1 1 0 7H12V2z"></path><path d="M12 12.5a3.5 3.5 0 1 1 7 0 3.5 3.5 0 1 1-7 0z"></path><path d="M5 19.5A3.5 3.5 0 0 1 8.5 16H12v3.5a3.5 3.5 0 1 1-7 0z"></path><path d="M5 12.5A3.5 3.5 0 0 1 8.5 9H12v7H8.5A3.5 3.5 0 0 1 5 12.5z"></path>',
                  "file-minus":
                    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="9" y1="15" x2="15" y2="15"></line>',
                  "file-plus":
                    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="12" y1="18" x2="12" y2="12"></line><line x1="9" y1="15" x2="15" y2="15"></line>',
                  "file-text":
                    '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline>',
                  file: '<path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"></path><polyline points="13 2 13 9 20 9"></polyline>',
                  film: '<rect x="2" y="2" width="20" height="20" rx="2.18" ry="2.18"></rect><line x1="7" y1="2" x2="7" y2="22"></line><line x1="17" y1="2" x2="17" y2="22"></line><line x1="2" y1="12" x2="22" y2="12"></line><line x1="2" y1="7" x2="7" y2="7"></line><line x1="2" y1="17" x2="7" y2="17"></line><line x1="17" y1="17" x2="22" y2="17"></line><line x1="17" y1="7" x2="22" y2="7"></line>',
                  filter:
                    '<polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"></polygon>',
                  flag: '<path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z"></path><line x1="4" y1="22" x2="4" y2="15"></line>',
                  "folder-minus":
                    '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="9" y1="14" x2="15" y2="14"></line>',
                  "folder-plus":
                    '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path><line x1="12" y1="11" x2="12" y2="17"></line><line x1="9" y1="14" x2="15" y2="14"></line>',
                  folder:
                    '<path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"></path>',
                  framer:
                    '<path d="M5 16V9h14V2H5l14 14h-7m-7 0l7 7v-7m-7 0h7"></path>',
                  frown:
                    '<circle cx="12" cy="12" r="10"></circle><path d="M16 16s-1.5-2-4-2-4 2-4 2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                  gift: '<polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path>',
                  "git-branch":
                    '<line x1="6" y1="3" x2="6" y2="15"></line><circle cx="18" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><path d="M18 9a9 9 0 0 1-9 9"></path>',
                  "git-commit":
                    '<circle cx="12" cy="12" r="4"></circle><line x1="1.05" y1="12" x2="7" y2="12"></line><line x1="17.01" y1="12" x2="22.96" y2="12"></line>',
                  "git-merge":
                    '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M6 21V9a9 9 0 0 0 9 9"></path>',
                  "git-pull-request":
                    '<circle cx="18" cy="18" r="3"></circle><circle cx="6" cy="6" r="3"></circle><path d="M13 6h3a2 2 0 0 1 2 2v7"></path><line x1="6" y1="9" x2="6" y2="21"></line>',
                  github:
                    '<path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path>',
                  gitlab:
                    '<path d="M22.65 14.39L12 22.13 1.35 14.39a.84.84 0 0 1-.3-.94l1.22-3.78 2.44-7.51A.42.42 0 0 1 4.82 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.49h8.1l2.44-7.51A.42.42 0 0 1 18.6 2a.43.43 0 0 1 .58 0 .42.42 0 0 1 .11.18l2.44 7.51L23 13.45a.84.84 0 0 1-.35.94z"></path>',
                  globe:
                    '<circle cx="12" cy="12" r="10"></circle><line x1="2" y1="12" x2="22" y2="12"></line><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>',
                  grid: '<rect x="3" y="3" width="7" height="7"></rect><rect x="14" y="3" width="7" height="7"></rect><rect x="14" y="14" width="7" height="7"></rect><rect x="3" y="14" width="7" height="7"></rect>',
                  "hard-drive":
                    '<line x1="22" y1="12" x2="2" y2="12"></line><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path><line x1="6" y1="16" x2="6.01" y2="16"></line><line x1="10" y1="16" x2="10.01" y2="16"></line>',
                  hash: '<line x1="4" y1="9" x2="20" y2="9"></line><line x1="4" y1="15" x2="20" y2="15"></line><line x1="10" y1="3" x2="8" y2="21"></line><line x1="16" y1="3" x2="14" y2="21"></line>',
                  headphones:
                    '<path d="M3 18v-6a9 9 0 0 1 18 0v6"></path><path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"></path>',
                  heart:
                    '<path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>',
                  "help-circle":
                    '<circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><line x1="12" y1="17" x2="12.01" y2="17"></line>',
                  hexagon:
                    '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>',
                  home: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline>',
                  image:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><circle cx="8.5" cy="8.5" r="1.5"></circle><polyline points="21 15 16 10 5 21"></polyline>',
                  inbox:
                    '<polyline points="22 12 16 12 14 15 10 15 8 12 2 12"></polyline><path d="M5.45 5.11L2 12v6a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2v-6l-3.45-6.89A2 2 0 0 0 16.76 4H7.24a2 2 0 0 0-1.79 1.11z"></path>',
                  info: '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line>',
                  instagram:
                    '<rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect><path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path><line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>',
                  italic:
                    '<line x1="19" y1="4" x2="10" y2="4"></line><line x1="14" y1="20" x2="5" y2="20"></line><line x1="15" y1="4" x2="9" y2="20"></line>',
                  key: '<path d="M21 2l-2 2m-7.61 7.61a5.5 5.5 0 1 1-7.778 7.778 5.5 5.5 0 0 1 7.777-7.777zm0 0L15.5 7.5m0 0l3 3L22 7l-3-3m-3.5 3.5L19 4"></path>',
                  layers:
                    '<polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline>',
                  layout:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="3" y1="9" x2="21" y2="9"></line><line x1="9" y1="21" x2="9" y2="9"></line>',
                  "life-buoy":
                    '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="4"></circle><line x1="4.93" y1="4.93" x2="9.17" y2="9.17"></line><line x1="14.83" y1="14.83" x2="19.07" y2="19.07"></line><line x1="14.83" y1="9.17" x2="19.07" y2="4.93"></line><line x1="14.83" y1="9.17" x2="18.36" y2="5.64"></line><line x1="4.93" y1="19.07" x2="9.17" y2="14.83"></line>',
                  "link-2":
                    '<path d="M15 7h3a5 5 0 0 1 5 5 5 5 0 0 1-5 5h-3m-6 0H6a5 5 0 0 1-5-5 5 5 0 0 1 5-5h3"></path><line x1="8" y1="12" x2="16" y2="12"></line>',
                  link: '<path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path><path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>',
                  linkedin:
                    '<path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path><rect x="2" y="9" width="4" height="12"></rect><circle cx="4" cy="4" r="2"></circle>',
                  list: '<line x1="8" y1="6" x2="21" y2="6"></line><line x1="8" y1="12" x2="21" y2="12"></line><line x1="8" y1="18" x2="21" y2="18"></line><line x1="3" y1="6" x2="3.01" y2="6"></line><line x1="3" y1="12" x2="3.01" y2="12"></line><line x1="3" y1="18" x2="3.01" y2="18"></line>',
                  loader:
                    '<line x1="12" y1="2" x2="12" y2="6"></line><line x1="12" y1="18" x2="12" y2="22"></line><line x1="4.93" y1="4.93" x2="7.76" y2="7.76"></line><line x1="16.24" y1="16.24" x2="19.07" y2="19.07"></line><line x1="2" y1="12" x2="6" y2="12"></line><line x1="18" y1="12" x2="22" y2="12"></line><line x1="4.93" y1="19.07" x2="7.76" y2="16.24"></line><line x1="16.24" y1="7.76" x2="19.07" y2="4.93"></line>',
                  lock: '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path>',
                  "log-in":
                    '<path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"></path><polyline points="10 17 15 12 10 7"></polyline><line x1="15" y1="12" x2="3" y2="12"></line>',
                  "log-out":
                    '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path><polyline points="16 17 21 12 16 7"></polyline><line x1="21" y1="12" x2="9" y2="12"></line>',
                  mail: '<path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"></path><polyline points="22,6 12,13 2,6"></polyline>',
                  "map-pin":
                    '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"></path><circle cx="12" cy="10" r="3"></circle>',
                  map: '<polygon points="1 6 1 22 8 18 16 22 23 18 23 2 16 6 8 2 1 6"></polygon><line x1="8" y1="2" x2="8" y2="18"></line><line x1="16" y1="6" x2="16" y2="22"></line>',
                  "maximize-2":
                    '<polyline points="15 3 21 3 21 9"></polyline><polyline points="9 21 3 21 3 15"></polyline><line x1="21" y1="3" x2="14" y2="10"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
                  maximize:
                    '<path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"></path>',
                  meh: '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="15" x2="16" y2="15"></line><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                  menu: '<line x1="3" y1="12" x2="21" y2="12"></line><line x1="3" y1="6" x2="21" y2="6"></line><line x1="3" y1="18" x2="21" y2="18"></line>',
                  "message-circle":
                    '<path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z"></path>',
                  "message-square":
                    '<path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>',
                  "mic-off":
                    '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M9 9v3a3 3 0 0 0 5.12 2.12M15 9.34V4a3 3 0 0 0-5.94-.6"></path><path d="M17 16.95A7 7 0 0 1 5 12v-2m14 0v2a7 7 0 0 1-.11 1.23"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
                  mic: '<path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"></path><path d="M19 10v2a7 7 0 0 1-14 0v-2"></path><line x1="12" y1="19" x2="12" y2="23"></line><line x1="8" y1="23" x2="16" y2="23"></line>',
                  "minimize-2":
                    '<polyline points="4 14 10 14 10 20"></polyline><polyline points="20 10 14 10 14 4"></polyline><line x1="14" y1="10" x2="21" y2="3"></line><line x1="3" y1="21" x2="10" y2="14"></line>',
                  minimize:
                    '<path d="M8 3v3a2 2 0 0 1-2 2H3m18 0h-3a2 2 0 0 1-2-2V3m0 18v-3a2 2 0 0 1 2-2h3M3 16h3a2 2 0 0 1 2 2v3"></path>',
                  "minus-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="8" y1="12" x2="16" y2="12"></line>',
                  "minus-square":
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="8" y1="12" x2="16" y2="12"></line>',
                  minus: '<line x1="5" y1="12" x2="19" y2="12"></line>',
                  monitor:
                    '<rect x="2" y="3" width="20" height="14" rx="2" ry="2"></rect><line x1="8" y1="21" x2="16" y2="21"></line><line x1="12" y1="17" x2="12" y2="21"></line>',
                  moon: '<path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"></path>',
                  "more-horizontal":
                    '<circle cx="12" cy="12" r="1"></circle><circle cx="19" cy="12" r="1"></circle><circle cx="5" cy="12" r="1"></circle>',
                  "more-vertical":
                    '<circle cx="12" cy="12" r="1"></circle><circle cx="12" cy="5" r="1"></circle><circle cx="12" cy="19" r="1"></circle>',
                  "mouse-pointer":
                    '<path d="M3 3l7.07 16.97 2.51-7.39 7.39-2.51L3 3z"></path><path d="M13 13l6 6"></path>',
                  move: '<polyline points="5 9 2 12 5 15"></polyline><polyline points="9 5 12 2 15 5"></polyline><polyline points="15 19 12 22 9 19"></polyline><polyline points="19 9 22 12 19 15"></polyline><line x1="2" y1="12" x2="22" y2="12"></line><line x1="12" y1="2" x2="12" y2="22"></line>',
                  music:
                    '<path d="M9 18V5l12-2v13"></path><circle cx="6" cy="18" r="3"></circle><circle cx="18" cy="16" r="3"></circle>',
                  "navigation-2":
                    '<polygon points="12 2 19 21 12 17 5 21 12 2"></polygon>',
                  navigation:
                    '<polygon points="3 11 22 2 13 21 11 13 3 11"></polygon>',
                  octagon:
                    '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon>',
                  package:
                    '<line x1="16.5" y1="9.4" x2="7.5" y2="4.21"></line><path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path><polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline><line x1="12" y1="22.08" x2="12" y2="12"></line>',
                  paperclip:
                    '<path d="M21.44 11.05l-9.19 9.19a6 6 0 0 1-8.49-8.49l9.19-9.19a4 4 0 0 1 5.66 5.66l-9.2 9.19a2 2 0 0 1-2.83-2.83l8.49-8.48"></path>',
                  "pause-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="10" y1="15" x2="10" y2="9"></line><line x1="14" y1="15" x2="14" y2="9"></line>',
                  pause:
                    '<rect x="6" y="4" width="4" height="16"></rect><rect x="14" y="4" width="4" height="16"></rect>',
                  "pen-tool":
                    '<path d="M12 19l7-7 3 3-7 7-3-3z"></path><path d="M18 13l-1.5-7.5L2 2l3.5 14.5L13 18l5-5z"></path><path d="M2 2l7.586 7.586"></path><circle cx="11" cy="11" r="2"></circle>',
                  percent:
                    '<line x1="19" y1="5" x2="5" y2="19"></line><circle cx="6.5" cy="6.5" r="2.5"></circle><circle cx="17.5" cy="17.5" r="2.5"></circle>',
                  "phone-call":
                    '<path d="M15.05 5A5 5 0 0 1 19 8.95M15.05 1A9 9 0 0 1 23 8.94m-1 7.98v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "phone-forwarded":
                    '<polyline points="19 1 23 5 19 9"></polyline><line x1="15" y1="5" x2="23" y2="5"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "phone-incoming":
                    '<polyline points="16 2 16 8 22 8"></polyline><line x1="23" y1="1" x2="16" y2="8"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "phone-missed":
                    '<line x1="23" y1="1" x2="17" y2="7"></line><line x1="17" y1="1" x2="23" y2="7"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "phone-off":
                    '<path d="M10.68 13.31a16 16 0 0 0 3.41 2.6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7 2 2 0 0 1 1.72 2v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.42 19.42 0 0 1-3.33-2.67m-2.67-3.34a19.79 19.79 0 0 1-3.07-8.63A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91"></path><line x1="23" y1="1" x2="1" y2="23"></line>',
                  "phone-outgoing":
                    '<polyline points="23 7 23 1 17 1"></polyline><line x1="16" y1="8" x2="23" y2="1"></line><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  phone:
                    '<path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path>',
                  "pie-chart":
                    '<path d="M21.21 15.89A10 10 0 1 1 8 2.83"></path><path d="M22 12A10 10 0 0 0 12 2v10z"></path>',
                  "play-circle":
                    '<circle cx="12" cy="12" r="10"></circle><polygon points="10 8 16 12 10 16 10 8"></polygon>',
                  play: '<polygon points="5 3 19 12 5 21 5 3"></polygon>',
                  "plus-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
                  "plus-square":
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line>',
                  plus: '<line x1="12" y1="5" x2="12" y2="19"></line><line x1="5" y1="12" x2="19" y2="12"></line>',
                  pocket:
                    '<path d="M4 3h16a2 2 0 0 1 2 2v6a10 10 0 0 1-10 10A10 10 0 0 1 2 11V5a2 2 0 0 1 2-2z"></path><polyline points="8 10 12 14 16 10"></polyline>',
                  power:
                    '<path d="M18.36 6.64a9 9 0 1 1-12.73 0"></path><line x1="12" y1="2" x2="12" y2="12"></line>',
                  printer:
                    '<polyline points="6 9 6 2 18 2 18 9"></polyline><path d="M6 18H4a2 2 0 0 1-2-2v-5a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v5a2 2 0 0 1-2 2h-2"></path><rect x="6" y="14" width="12" height="8"></rect>',
                  radio:
                    '<circle cx="12" cy="12" r="2"></circle><path d="M16.24 7.76a6 6 0 0 1 0 8.49m-8.48-.01a6 6 0 0 1 0-8.49m11.31-2.82a10 10 0 0 1 0 14.14m-14.14 0a10 10 0 0 1 0-14.14"></path>',
                  "refresh-ccw":
                    '<polyline points="1 4 1 10 7 10"></polyline><polyline points="23 20 23 14 17 14"></polyline><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"></path>',
                  "refresh-cw":
                    '<polyline points="23 4 23 10 17 10"></polyline><polyline points="1 20 1 14 7 14"></polyline><path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>',
                  repeat:
                    '<polyline points="17 1 21 5 17 9"></polyline><path d="M3 11V9a4 4 0 0 1 4-4h14"></path><polyline points="7 23 3 19 7 15"></polyline><path d="M21 13v2a4 4 0 0 1-4 4H3"></path>',
                  rewind:
                    '<polygon points="11 19 2 12 11 5 11 19"></polygon><polygon points="22 19 13 12 22 5 22 19"></polygon>',
                  "rotate-ccw":
                    '<polyline points="1 4 1 10 7 10"></polyline><path d="M3.51 15a9 9 0 1 0 2.13-9.36L1 10"></path>',
                  "rotate-cw":
                    '<polyline points="23 4 23 10 17 10"></polyline><path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"></path>',
                  rss: '<path d="M4 11a9 9 0 0 1 9 9"></path><path d="M4 4a16 16 0 0 1 16 16"></path><circle cx="5" cy="19" r="1"></circle>',
                  save: '<path d="M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2z"></path><polyline points="17 21 17 13 7 13 7 21"></polyline><polyline points="7 3 7 8 15 8"></polyline>',
                  scissors:
                    '<circle cx="6" cy="6" r="3"></circle><circle cx="6" cy="18" r="3"></circle><line x1="20" y1="4" x2="8.12" y2="15.88"></line><line x1="14.47" y1="14.48" x2="20" y2="20"></line><line x1="8.12" y1="8.12" x2="12" y2="12"></line>',
                  search:
                    '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line>',
                  send: '<line x1="22" y1="2" x2="11" y2="13"></line><polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>',
                  server:
                    '<rect x="2" y="2" width="20" height="8" rx="2" ry="2"></rect><rect x="2" y="14" width="20" height="8" rx="2" ry="2"></rect><line x1="6" y1="6" x2="6.01" y2="6"></line><line x1="6" y1="18" x2="6.01" y2="18"></line>',
                  settings:
                    '<circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"></path>',
                  "share-2":
                    '<circle cx="18" cy="5" r="3"></circle><circle cx="6" cy="12" r="3"></circle><circle cx="18" cy="19" r="3"></circle><line x1="8.59" y1="13.51" x2="15.42" y2="17.49"></line><line x1="15.41" y1="6.51" x2="8.59" y2="10.49"></line>',
                  share:
                    '<path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"></path><polyline points="16 6 12 2 8 6"></polyline><line x1="12" y1="2" x2="12" y2="15"></line>',
                  "shield-off":
                    '<path d="M19.69 14a6.9 6.9 0 0 0 .31-2V5l-8-3-3.16 1.18"></path><path d="M4.73 4.73L4 5v7c0 6 8 10 8 10a20.29 20.29 0 0 0 5.62-4.38"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  shield:
                    '<path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>',
                  "shopping-bag":
                    '<path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"></path><line x1="3" y1="6" x2="21" y2="6"></line><path d="M16 10a4 4 0 0 1-8 0"></path>',
                  "shopping-cart":
                    '<circle cx="9" cy="21" r="1"></circle><circle cx="20" cy="21" r="1"></circle><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>',
                  shuffle:
                    '<polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line>',
                  sidebar:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="3" x2="9" y2="21"></line>',
                  "skip-back":
                    '<polygon points="19 20 9 12 19 4 19 20"></polygon><line x1="5" y1="19" x2="5" y2="5"></line>',
                  "skip-forward":
                    '<polygon points="5 4 15 12 5 20 5 4"></polygon><line x1="19" y1="5" x2="19" y2="19"></line>',
                  slack:
                    '<path d="M14.5 10c-.83 0-1.5-.67-1.5-1.5v-5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5z"></path><path d="M20.5 10H19V8.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"></path><path d="M9.5 14c.83 0 1.5.67 1.5 1.5v5c0 .83-.67 1.5-1.5 1.5S8 21.33 8 20.5v-5c0-.83.67-1.5 1.5-1.5z"></path><path d="M3.5 14H5v1.5c0 .83-.67 1.5-1.5 1.5S2 16.33 2 15.5 2.67 14 3.5 14z"></path><path d="M14 14.5c0-.83.67-1.5 1.5-1.5h5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-5c-.83 0-1.5-.67-1.5-1.5z"></path><path d="M15.5 19H14v1.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z"></path><path d="M10 9.5C10 8.67 9.33 8 8.5 8h-5C2.67 8 2 8.67 2 9.5S2.67 11 3.5 11h5c.83 0 1.5-.67 1.5-1.5z"></path><path d="M8.5 5H10V3.5C10 2.67 9.33 2 8.5 2S7 2.67 7 3.5 7.67 5 8.5 5z"></path>',
                  slash:
                    '<circle cx="12" cy="12" r="10"></circle><line x1="4.93" y1="4.93" x2="19.07" y2="19.07"></line>',
                  sliders:
                    '<line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line>',
                  smartphone:
                    '<rect x="5" y="2" width="14" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
                  smile:
                    '<circle cx="12" cy="12" r="10"></circle><path d="M8 14s1.5 2 4 2 4-2 4-2"></path><line x1="9" y1="9" x2="9.01" y2="9"></line><line x1="15" y1="9" x2="15.01" y2="9"></line>',
                  speaker:
                    '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><circle cx="12" cy="14" r="4"></circle><line x1="12" y1="6" x2="12.01" y2="6"></line>',
                  square:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>',
                  star: '<polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>',
                  "stop-circle":
                    '<circle cx="12" cy="12" r="10"></circle><rect x="9" y="9" width="6" height="6"></rect>',
                  sun: '<circle cx="12" cy="12" r="5"></circle><line x1="12" y1="1" x2="12" y2="3"></line><line x1="12" y1="21" x2="12" y2="23"></line><line x1="4.22" y1="4.22" x2="5.64" y2="5.64"></line><line x1="18.36" y1="18.36" x2="19.78" y2="19.78"></line><line x1="1" y1="12" x2="3" y2="12"></line><line x1="21" y1="12" x2="23" y2="12"></line><line x1="4.22" y1="19.78" x2="5.64" y2="18.36"></line><line x1="18.36" y1="5.64" x2="19.78" y2="4.22"></line>',
                  sunrise:
                    '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="2" x2="12" y2="9"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="8 6 12 2 16 6"></polyline>',
                  sunset:
                    '<path d="M17 18a5 5 0 0 0-10 0"></path><line x1="12" y1="9" x2="12" y2="2"></line><line x1="4.22" y1="10.22" x2="5.64" y2="11.64"></line><line x1="1" y1="18" x2="3" y2="18"></line><line x1="21" y1="18" x2="23" y2="18"></line><line x1="18.36" y1="11.64" x2="19.78" y2="10.22"></line><line x1="23" y1="22" x2="1" y2="22"></line><polyline points="16 5 12 9 8 5"></polyline>',
                  table:
                    '<path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2V9M9 21H5a2 2 0 0 1-2-2V9m0 0h18"></path>',
                  tablet:
                    '<rect x="4" y="2" width="16" height="20" rx="2" ry="2"></rect><line x1="12" y1="18" x2="12.01" y2="18"></line>',
                  tag: '<path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path><line x1="7" y1="7" x2="7.01" y2="7"></line>',
                  target:
                    '<circle cx="12" cy="12" r="10"></circle><circle cx="12" cy="12" r="6"></circle><circle cx="12" cy="12" r="2"></circle>',
                  terminal:
                    '<polyline points="4 17 10 11 4 5"></polyline><line x1="12" y1="19" x2="20" y2="19"></line>',
                  thermometer:
                    '<path d="M14 14.76V3.5a2.5 2.5 0 0 0-5 0v11.26a4.5 4.5 0 1 0 5 0z"></path>',
                  "thumbs-down":
                    '<path d="M10 15v4a3 3 0 0 0 3 3l4-9V2H5.72a2 2 0 0 0-2 1.7l-1.38 9a2 2 0 0 0 2 2.3zm7-13h2.67A2.31 2.31 0 0 1 22 4v7a2.31 2.31 0 0 1-2.33 2H17"></path>',
                  "thumbs-up":
                    '<path d="M14 9V5a3 3 0 0 0-3-3l-4 9v11h11.28a2 2 0 0 0 2-1.7l1.38-9a2 2 0 0 0-2-2.3zM7 22H4a2 2 0 0 1-2-2v-7a2 2 0 0 1 2-2h3"></path>',
                  "toggle-left":
                    '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="8" cy="12" r="3"></circle>',
                  "toggle-right":
                    '<rect x="1" y="5" width="22" height="14" rx="7" ry="7"></rect><circle cx="16" cy="12" r="3"></circle>',
                  tool: '<path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"></path>',
                  "trash-2":
                    '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path><line x1="10" y1="11" x2="10" y2="17"></line><line x1="14" y1="11" x2="14" y2="17"></line>',
                  trash:
                    '<polyline points="3 6 5 6 21 6"></polyline><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>',
                  trello:
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><rect x="7" y="7" width="3" height="9"></rect><rect x="14" y="7" width="3" height="5"></rect>',
                  "trending-down":
                    '<polyline points="23 18 13.5 8.5 8.5 13.5 1 6"></polyline><polyline points="17 18 23 18 23 12"></polyline>',
                  "trending-up":
                    '<polyline points="23 6 13.5 15.5 8.5 10.5 1 18"></polyline><polyline points="17 6 23 6 23 12"></polyline>',
                  triangle:
                    '<path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>',
                  truck:
                    '<rect x="1" y="3" width="15" height="13"></rect><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon><circle cx="5.5" cy="18.5" r="2.5"></circle><circle cx="18.5" cy="18.5" r="2.5"></circle>',
                  tv: '<rect x="2" y="7" width="20" height="15" rx="2" ry="2"></rect><polyline points="17 2 12 7 7 2"></polyline>',
                  twitch:
                    '<path d="M21 2H3v16h5v4l4-4h5l4-4V2zm-10 9V7m5 4V7"></path>',
                  twitter:
                    '<path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z"></path>',
                  type: '<polyline points="4 7 4 4 20 4 20 7"></polyline><line x1="9" y1="20" x2="15" y2="20"></line><line x1="12" y1="4" x2="12" y2="20"></line>',
                  umbrella:
                    '<path d="M23 12a11.05 11.05 0 0 0-22 0zm-5 7a3 3 0 0 1-6 0v-7"></path>',
                  underline:
                    '<path d="M6 3v7a6 6 0 0 0 6 6 6 6 0 0 0 6-6V3"></path><line x1="4" y1="21" x2="20" y2="21"></line>',
                  unlock:
                    '<rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect><path d="M7 11V7a5 5 0 0 1 9.9-1"></path>',
                  "upload-cloud":
                    '<polyline points="16 16 12 12 8 16"></polyline><line x1="12" y1="12" x2="12" y2="21"></line><path d="M20.39 18.39A5 5 0 0 0 18 9h-1.26A8 8 0 1 0 3 16.3"></path><polyline points="16 16 12 12 8 16"></polyline>',
                  upload:
                    '<path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line>',
                  "user-check":
                    '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><polyline points="17 11 19 13 23 9"></polyline>',
                  "user-minus":
                    '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="23" y1="11" x2="17" y2="11"></line>',
                  "user-plus":
                    '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="20" y1="8" x2="20" y2="14"></line><line x1="23" y1="11" x2="17" y2="11"></line>',
                  "user-x":
                    '<path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="8.5" cy="7" r="4"></circle><line x1="18" y1="8" x2="23" y2="13"></line><line x1="23" y1="8" x2="18" y2="13"></line>',
                  user: '<path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>',
                  users:
                    '<path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path>',
                  "video-off":
                    '<path d="M16 16v1a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h2m5.66 0H14a2 2 0 0 1 2 2v3.34l1 1L23 7v10"></path><line x1="1" y1="1" x2="23" y2="23"></line>',
                  video:
                    '<polygon points="23 7 16 12 23 17 23 7"></polygon><rect x="1" y="5" width="15" height="14" rx="2" ry="2"></rect>',
                  voicemail:
                    '<circle cx="5.5" cy="11.5" r="4.5"></circle><circle cx="18.5" cy="11.5" r="4.5"></circle><line x1="5.5" y1="16" x2="18.5" y2="16"></line>',
                  "volume-1":
                    '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
                  "volume-2":
                    '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path>',
                  "volume-x":
                    '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line>',
                  volume:
                    '<polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon>',
                  watch:
                    '<circle cx="12" cy="12" r="7"></circle><polyline points="12 9 12 12 13.5 13.5"></polyline><path d="M16.51 17.35l-.35 3.83a2 2 0 0 1-2 1.82H9.83a2 2 0 0 1-2-1.82l-.35-3.83m.01-10.7l.35-3.83A2 2 0 0 1 9.83 1h4.35a2 2 0 0 1 2 1.82l.35 3.83"></path>',
                  "wifi-off":
                    '<line x1="1" y1="1" x2="23" y2="23"></line><path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55"></path><path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39"></path><path d="M10.71 5.05A16 16 0 0 1 22.58 9"></path><path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
                  wifi: '<path d="M5 12.55a11 11 0 0 1 14.08 0"></path><path d="M1.42 9a16 16 0 0 1 21.16 0"></path><path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path><line x1="12" y1="20" x2="12.01" y2="20"></line>',
                  wind: '<path d="M9.59 4.59A2 2 0 1 1 11 8H2m10.59 11.41A2 2 0 1 0 14 16H2m15.73-8.27A2.5 2.5 0 1 1 19.5 12H2"></path>',
                  "x-circle":
                    '<circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
                  "x-octagon":
                    '<polygon points="7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"></polygon><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line>',
                  "x-square":
                    '<rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect><line x1="9" y1="9" x2="15" y2="15"></line><line x1="15" y1="9" x2="9" y2="15"></line>',
                  x: '<line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line>',
                  youtube:
                    '<path d="M22.54 6.42a2.78 2.78 0 0 0-1.94-2C18.88 4 12 4 12 4s-6.88 0-8.6.46a2.78 2.78 0 0 0-1.94 2A29 29 0 0 0 1 11.75a29 29 0 0 0 .46 5.33A2.78 2.78 0 0 0 3.4 19c1.72.46 8.6.46 8.6.46s6.88 0 8.6-.46a2.78 2.78 0 0 0 1.94-2 29 29 0 0 0 .46-5.25 29 29 0 0 0-.46-5.33z"></path><polygon points="9.75 15.02 15.5 11.75 9.75 8.48 9.75 15.02"></polygon>',
                  "zap-off":
                    '<polyline points="12.41 6.75 13 2 10.57 4.92"></polyline><polyline points="18.57 12.91 21 10 15.66 10"></polyline><polyline points="8 8 3 14 12 14 11 22 16 16"></polyline><line x1="1" y1="1" x2="23" y2="23"></line>',
                  zap: '<polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"></polygon>',
                  "zoom-in":
                    '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
                  "zoom-out":
                    '<circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="8" y1="11" x2="14" y2="11"></line>',
                };
              },
              "./node_modules/classnames/dedupe.js": function (e, t, n) {
                var i;
                !(function () {
                  var n = (function () {
                    function e() {}
                    function t(e, t) {
                      for (var n = t.length, i = 0; i < n; ++i) a(e, t[i]);
                    }
                    e.prototype = Object.create(null);
                    var n = {}.hasOwnProperty,
                      i = /\s+/;
                    function a(e, a) {
                      if (a) {
                        var r = typeof a;
                        "string" === r
                          ? (function (e, t) {
                              for (
                                var n = t.split(i), a = n.length, r = 0;
                                r < a;
                                ++r
                              )
                                e[n[r]] = !0;
                            })(e, a)
                          : Array.isArray(a)
                          ? t(e, a)
                          : "object" === r
                          ? (function (e, t) {
                              for (var i in t) n.call(t, i) && (e[i] = !!t[i]);
                            })(e, a)
                          : "number" === r &&
                            (function (e, t) {
                              e[t] = !0;
                            })(e, a);
                      }
                    }
                    return function () {
                      for (
                        var n = arguments.length, i = Array(n), a = 0;
                        a < n;
                        a++
                      )
                        i[a] = arguments[a];
                      var r = new e();
                      t(r, i);
                      var l = [];
                      for (var o in r) r[o] && l.push(o);
                      return l.join(" ");
                    };
                  })();
                  void 0 !== e && e.exports
                    ? (e.exports = n)
                    : void 0 ===
                        (i = function () {
                          return n;
                        }.apply(t, [])) || (e.exports = i);
                })();
              },
              "./node_modules/core-js/es/array/from.js": function (e, t, n) {
                n("./node_modules/core-js/modules/es.string.iterator.js"),
                  n("./node_modules/core-js/modules/es.array.from.js");
                var i = n("./node_modules/core-js/internals/path.js");
                e.exports = i.Array.from;
              },
              "./node_modules/core-js/internals/a-function.js": function (
                e,
                t
              ) {
                e.exports = function (e) {
                  if ("function" != typeof e)
                    throw TypeError(String(e) + " is not a function");
                  return e;
                };
              },
              "./node_modules/core-js/internals/an-object.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/is-object.js");
                e.exports = function (e) {
                  if (!i(e)) throw TypeError(String(e) + " is not an object");
                  return e;
                };
              },
              "./node_modules/core-js/internals/array-from.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/bind-context.js"),
                  a = n("./node_modules/core-js/internals/to-object.js"),
                  r = n(
                    "./node_modules/core-js/internals/call-with-safe-iteration-closing.js"
                  ),
                  l = n(
                    "./node_modules/core-js/internals/is-array-iterator-method.js"
                  ),
                  o = n("./node_modules/core-js/internals/to-length.js"),
                  s = n("./node_modules/core-js/internals/create-property.js"),
                  d = n(
                    "./node_modules/core-js/internals/get-iterator-method.js"
                  );
                e.exports = function (e) {
                  var t,
                    n,
                    u,
                    c,
                    h = a(e),
                    m = "function" == typeof this ? this : Array,
                    f = arguments.length,
                    _ = f > 1 ? arguments[1] : void 0,
                    p = void 0 !== _,
                    g = 0,
                    y = d(h);
                  if (
                    (p && (_ = i(_, f > 2 ? arguments[2] : void 0, 2)),
                    null == y || (m == Array && l(y)))
                  )
                    for (n = new m((t = o(h.length))); t > g; g++)
                      s(n, g, p ? _(h[g], g) : h[g]);
                  else
                    for (c = y.call(h), n = new m(); !(u = c.next()).done; g++)
                      s(n, g, p ? r(c, _, [u.value, g], !0) : u.value);
                  return (n.length = g), n;
                };
              },
              "./node_modules/core-js/internals/array-includes.js": function (
                e,
                t,
                n
              ) {
                var i = n(
                    "./node_modules/core-js/internals/to-indexed-object.js"
                  ),
                  a = n("./node_modules/core-js/internals/to-length.js"),
                  r = n(
                    "./node_modules/core-js/internals/to-absolute-index.js"
                  );
                e.exports = function (e) {
                  return function (t, n, l) {
                    var o,
                      s = i(t),
                      d = a(s.length),
                      u = r(l, d);
                    if (e && n != n) {
                      for (; d > u; ) if ((o = s[u++]) != o) return !0;
                    } else
                      for (; d > u; u++)
                        if ((e || u in s) && s[u] === n) return e || u || 0;
                    return !e && -1;
                  };
                };
              },
              "./node_modules/core-js/internals/bind-context.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/a-function.js");
                e.exports = function (e, t, n) {
                  if ((i(e), void 0 === t)) return e;
                  switch (n) {
                    case 0:
                      return function () {
                        return e.call(t);
                      };
                    case 1:
                      return function (n) {
                        return e.call(t, n);
                      };
                    case 2:
                      return function (n, i) {
                        return e.call(t, n, i);
                      };
                    case 3:
                      return function (n, i, a) {
                        return e.call(t, n, i, a);
                      };
                  }
                  return function () {
                    return e.apply(t, arguments);
                  };
                };
              },
              "./node_modules/core-js/internals/call-with-safe-iteration-closing.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/an-object.js");
                  e.exports = function (e, t, n, a) {
                    try {
                      return a ? t(i(n)[0], n[1]) : t(n);
                    } catch (t) {
                      var r = e.return;
                      throw (void 0 !== r && i(r.call(e)), t);
                    }
                  };
                },
              "./node_modules/core-js/internals/check-correctness-of-iteration.js":
                function (e, t, n) {
                  var i = n(
                      "./node_modules/core-js/internals/well-known-symbol.js"
                    )("iterator"),
                    a = !1;
                  try {
                    var r = 0,
                      l = {
                        next: function () {
                          return { done: !!r++ };
                        },
                        return: function () {
                          a = !0;
                        },
                      };
                    (l[i] = function () {
                      return this;
                    }),
                      Array.from(l, function () {
                        throw 2;
                      });
                  } catch (e) {}
                  e.exports = function (e, t) {
                    if (!t && !a) return !1;
                    var n = !1;
                    try {
                      var r = {};
                      (r[i] = function () {
                        return {
                          next: function () {
                            return { done: (n = !0) };
                          },
                        };
                      }),
                        e(r);
                    } catch (e) {}
                    return n;
                  };
                },
              "./node_modules/core-js/internals/classof-raw.js": function (
                e,
                t
              ) {
                var n = {}.toString;
                e.exports = function (e) {
                  return n.call(e).slice(8, -1);
                };
              },
              "./node_modules/core-js/internals/classof.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/classof-raw.js"),
                  a = n(
                    "./node_modules/core-js/internals/well-known-symbol.js"
                  )("toStringTag"),
                  r =
                    "Arguments" ==
                    i(
                      (function () {
                        return arguments;
                      })()
                    );
                e.exports = function (e) {
                  var t, n, l;
                  return void 0 === e
                    ? "Undefined"
                    : null === e
                    ? "Null"
                    : "string" ==
                      typeof (n = (function (e, t) {
                        try {
                          return e[t];
                        } catch (e) {}
                      })((t = Object(e)), a))
                    ? n
                    : r
                    ? i(t)
                    : "Object" == (l = i(t)) && "function" == typeof t.callee
                    ? "Arguments"
                    : l;
                };
              },
              "./node_modules/core-js/internals/copy-constructor-properties.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/has.js"),
                    a = n("./node_modules/core-js/internals/own-keys.js"),
                    r = n(
                      "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
                    ),
                    l = n(
                      "./node_modules/core-js/internals/object-define-property.js"
                    );
                  e.exports = function (e, t) {
                    for (
                      var n = a(t), o = l.f, s = r.f, d = 0;
                      d < n.length;
                      d++
                    ) {
                      var u = n[d];
                      i(e, u) || o(e, u, s(t, u));
                    }
                  };
                },
              "./node_modules/core-js/internals/correct-prototype-getter.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/fails.js");
                  e.exports = !i(function () {
                    function e() {}
                    return (
                      (e.prototype.constructor = null),
                      Object.getPrototypeOf(new e()) !== e.prototype
                    );
                  });
                },
              "./node_modules/core-js/internals/create-iterator-constructor.js":
                function (e, t, n) {
                  var i = n(
                      "./node_modules/core-js/internals/iterators-core.js"
                    ).IteratorPrototype,
                    a = n("./node_modules/core-js/internals/object-create.js"),
                    r = n(
                      "./node_modules/core-js/internals/create-property-descriptor.js"
                    ),
                    l = n(
                      "./node_modules/core-js/internals/set-to-string-tag.js"
                    ),
                    o = n("./node_modules/core-js/internals/iterators.js"),
                    s = function () {
                      return this;
                    };
                  e.exports = function (e, t, n) {
                    var d = t + " Iterator";
                    return (
                      (e.prototype = a(i, { next: r(1, n) })),
                      l(e, d, !1, !0),
                      (o[d] = s),
                      e
                    );
                  };
                },
              "./node_modules/core-js/internals/create-property-descriptor.js":
                function (e, t) {
                  e.exports = function (e, t) {
                    return {
                      enumerable: !(1 & e),
                      configurable: !(2 & e),
                      writable: !(4 & e),
                      value: t,
                    };
                  };
                },
              "./node_modules/core-js/internals/create-property.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/to-primitive.js"),
                  a = n(
                    "./node_modules/core-js/internals/object-define-property.js"
                  ),
                  r = n(
                    "./node_modules/core-js/internals/create-property-descriptor.js"
                  );
                e.exports = function (e, t, n) {
                  var l = i(t);
                  l in e ? a.f(e, l, r(0, n)) : (e[l] = n);
                };
              },
              "./node_modules/core-js/internals/define-iterator.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/export.js"),
                  a = n(
                    "./node_modules/core-js/internals/create-iterator-constructor.js"
                  ),
                  r = n(
                    "./node_modules/core-js/internals/object-get-prototype-of.js"
                  ),
                  l = n(
                    "./node_modules/core-js/internals/object-set-prototype-of.js"
                  ),
                  o = n(
                    "./node_modules/core-js/internals/set-to-string-tag.js"
                  ),
                  s = n("./node_modules/core-js/internals/hide.js"),
                  d = n("./node_modules/core-js/internals/redefine.js"),
                  u = n(
                    "./node_modules/core-js/internals/well-known-symbol.js"
                  ),
                  c = n("./node_modules/core-js/internals/is-pure.js"),
                  h = n("./node_modules/core-js/internals/iterators.js"),
                  m = n("./node_modules/core-js/internals/iterators-core.js"),
                  f = m.IteratorPrototype,
                  _ = m.BUGGY_SAFARI_ITERATORS,
                  p = u("iterator"),
                  g = "keys",
                  y = "values",
                  v = "entries",
                  M = function () {
                    return this;
                  };
                e.exports = function (e, t, n, u, m, b, x) {
                  a(n, t, u);
                  var L,
                    w,
                    k,
                    Y = function (e) {
                      if (e === m && O) return O;
                      if (!_ && e in S) return S[e];
                      switch (e) {
                        case g:
                        case y:
                        case v:
                          return function () {
                            return new n(this, e);
                          };
                      }
                      return function () {
                        return new n(this);
                      };
                    },
                    D = t + " Iterator",
                    T = !1,
                    S = e.prototype,
                    j = S[p] || S["@@iterator"] || (m && S[m]),
                    O = (!_ && j) || Y(m),
                    A = ("Array" == t && S.entries) || j;
                  if (
                    (A &&
                      ((L = r(A.call(new e()))),
                      f !== Object.prototype &&
                        L.next &&
                        (c ||
                          r(L) === f ||
                          (l
                            ? l(L, f)
                            : "function" != typeof L[p] && s(L, p, M)),
                        o(L, D, !0, !0),
                        c && (h[D] = M))),
                    m == y &&
                      j &&
                      j.name !== y &&
                      ((T = !0),
                      (O = function () {
                        return j.call(this);
                      })),
                    (c && !x) || S[p] === O || s(S, p, O),
                    (h[t] = O),
                    m)
                  )
                    if (
                      ((w = {
                        values: Y(y),
                        keys: b ? O : Y(g),
                        entries: Y(v),
                      }),
                      x)
                    )
                      for (k in w) (_ || T || !(k in S)) && d(S, k, w[k]);
                    else i({ target: t, proto: !0, forced: _ || T }, w);
                  return w;
                };
              },
              "./node_modules/core-js/internals/descriptors.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/fails.js");
                e.exports = !i(function () {
                  return (
                    7 !=
                    Object.defineProperty({}, "a", {
                      get: function () {
                        return 7;
                      },
                    }).a
                  );
                });
              },
              "./node_modules/core-js/internals/document-create-element.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/global.js"),
                    a = n("./node_modules/core-js/internals/is-object.js"),
                    r = i.document,
                    l = a(r) && a(r.createElement);
                  e.exports = function (e) {
                    return l ? r.createElement(e) : {};
                  };
                },
              "./node_modules/core-js/internals/enum-bug-keys.js": function (
                e,
                t
              ) {
                e.exports = [
                  "constructor",
                  "hasOwnProperty",
                  "isPrototypeOf",
                  "propertyIsEnumerable",
                  "toLocaleString",
                  "toString",
                  "valueOf",
                ];
              },
              "./node_modules/core-js/internals/export.js": function (e, t, n) {
                var i = n("./node_modules/core-js/internals/global.js"),
                  a = n(
                    "./node_modules/core-js/internals/object-get-own-property-descriptor.js"
                  ).f,
                  r = n("./node_modules/core-js/internals/hide.js"),
                  l = n("./node_modules/core-js/internals/redefine.js"),
                  o = n("./node_modules/core-js/internals/set-global.js"),
                  s = n(
                    "./node_modules/core-js/internals/copy-constructor-properties.js"
                  ),
                  d = n("./node_modules/core-js/internals/is-forced.js");
                e.exports = function (e, t) {
                  var n,
                    u,
                    c,
                    h,
                    m,
                    f = e.target,
                    _ = e.global,
                    p = e.stat;
                  if (
                    (n = _ ? i : p ? i[f] || o(f, {}) : (i[f] || {}).prototype)
                  )
                    for (u in t) {
                      if (
                        ((h = t[u]),
                        (c = e.noTargetGet ? (m = a(n, u)) && m.value : n[u]),
                        !d(_ ? u : f + (p ? "." : "#") + u, e.forced) &&
                          void 0 !== c)
                      ) {
                        if (typeof h == typeof c) continue;
                        s(h, c);
                      }
                      (e.sham || (c && c.sham)) && r(h, "sham", !0),
                        l(n, u, h, e);
                    }
                };
              },
              "./node_modules/core-js/internals/fails.js": function (e, t) {
                e.exports = function (e) {
                  try {
                    return !!e();
                  } catch (e) {
                    return !0;
                  }
                };
              },
              "./node_modules/core-js/internals/function-to-string.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/shared.js");
                  e.exports = i("native-function-to-string", Function.toString);
                },
              "./node_modules/core-js/internals/get-iterator-method.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/classof.js"),
                    a = n("./node_modules/core-js/internals/iterators.js"),
                    r = n(
                      "./node_modules/core-js/internals/well-known-symbol.js"
                    )("iterator");
                  e.exports = function (e) {
                    if (null != e) return e[r] || e["@@iterator"] || a[i(e)];
                  };
                },
              "./node_modules/core-js/internals/global.js": function (e, t, n) {
                (function (t) {
                  var n = "object",
                    i = function (e) {
                      return e && e.Math == Math && e;
                    };
                  e.exports =
                    i(typeof globalThis == n && globalThis) ||
                    i(typeof window == n && window) ||
                    i(typeof self == n && self) ||
                    i(typeof t == n && t) ||
                    Function("return this")();
                }).call(this, n("./node_modules/webpack/buildin/global.js"));
              },
              "./node_modules/core-js/internals/has.js": function (e, t) {
                var n = {}.hasOwnProperty;
                e.exports = function (e, t) {
                  return n.call(e, t);
                };
              },
              "./node_modules/core-js/internals/hidden-keys.js": function (
                e,
                t
              ) {
                e.exports = {};
              },
              "./node_modules/core-js/internals/hide.js": function (e, t, n) {
                var i = n("./node_modules/core-js/internals/descriptors.js"),
                  a = n(
                    "./node_modules/core-js/internals/object-define-property.js"
                  ),
                  r = n(
                    "./node_modules/core-js/internals/create-property-descriptor.js"
                  );
                e.exports = i
                  ? function (e, t, n) {
                      return a.f(e, t, r(1, n));
                    }
                  : function (e, t, n) {
                      return (e[t] = n), e;
                    };
              },
              "./node_modules/core-js/internals/html.js": function (e, t, n) {
                var i = n(
                  "./node_modules/core-js/internals/global.js"
                ).document;
                e.exports = i && i.documentElement;
              },
              "./node_modules/core-js/internals/ie8-dom-define.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/descriptors.js"),
                  a = n("./node_modules/core-js/internals/fails.js"),
                  r = n(
                    "./node_modules/core-js/internals/document-create-element.js"
                  );
                e.exports =
                  !i &&
                  !a(function () {
                    return (
                      7 !=
                      Object.defineProperty(r("div"), "a", {
                        get: function () {
                          return 7;
                        },
                      }).a
                    );
                  });
              },
              "./node_modules/core-js/internals/indexed-object.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/fails.js"),
                  a = n("./node_modules/core-js/internals/classof-raw.js"),
                  r = "".split;
                e.exports = i(function () {
                  return !Object("z").propertyIsEnumerable(0);
                })
                  ? function (e) {
                      return "String" == a(e) ? r.call(e, "") : Object(e);
                    }
                  : Object;
              },
              "./node_modules/core-js/internals/internal-state.js": function (
                e,
                t,
                n
              ) {
                var i,
                  a,
                  r,
                  l = n("./node_modules/core-js/internals/native-weak-map.js"),
                  o = n("./node_modules/core-js/internals/global.js"),
                  s = n("./node_modules/core-js/internals/is-object.js"),
                  d = n("./node_modules/core-js/internals/hide.js"),
                  u = n("./node_modules/core-js/internals/has.js"),
                  c = n("./node_modules/core-js/internals/shared-key.js"),
                  h = n("./node_modules/core-js/internals/hidden-keys.js"),
                  m = o.WeakMap;
                if (l) {
                  var f = new m(),
                    _ = f.get,
                    p = f.has,
                    g = f.set;
                  (i = function (e, t) {
                    return g.call(f, e, t), t;
                  }),
                    (a = function (e) {
                      return _.call(f, e) || {};
                    }),
                    (r = function (e) {
                      return p.call(f, e);
                    });
                } else {
                  var y = c("state");
                  (h[y] = !0),
                    (i = function (e, t) {
                      return d(e, y, t), t;
                    }),
                    (a = function (e) {
                      return u(e, y) ? e[y] : {};
                    }),
                    (r = function (e) {
                      return u(e, y);
                    });
                }
                e.exports = {
                  set: i,
                  get: a,
                  has: r,
                  enforce: function (e) {
                    return r(e) ? a(e) : i(e, {});
                  },
                  getterFor: function (e) {
                    return function (t) {
                      var n;
                      if (!s(t) || (n = a(t)).type !== e)
                        throw TypeError(
                          "Incompatible receiver, " + e + " required"
                        );
                      return n;
                    };
                  },
                };
              },
              "./node_modules/core-js/internals/is-array-iterator-method.js":
                function (e, t, n) {
                  var i = n(
                      "./node_modules/core-js/internals/well-known-symbol.js"
                    ),
                    a = n("./node_modules/core-js/internals/iterators.js"),
                    r = i("iterator"),
                    l = Array.prototype;
                  e.exports = function (e) {
                    return void 0 !== e && (a.Array === e || l[r] === e);
                  };
                },
              "./node_modules/core-js/internals/is-forced.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/fails.js"),
                  a = /#|\.prototype\./,
                  r = function (e, t) {
                    var n = o[l(e)];
                    return (
                      n == d ||
                      (n != s && ("function" == typeof t ? i(t) : !!t))
                    );
                  },
                  l = (r.normalize = function (e) {
                    return String(e).replace(a, ".").toLowerCase();
                  }),
                  o = (r.data = {}),
                  s = (r.NATIVE = "N"),
                  d = (r.POLYFILL = "P");
                e.exports = r;
              },
              "./node_modules/core-js/internals/is-object.js": function (e, t) {
                e.exports = function (e) {
                  return "object" == typeof e
                    ? null !== e
                    : "function" == typeof e;
                };
              },
              "./node_modules/core-js/internals/is-pure.js": function (e, t) {
                e.exports = !1;
              },
              "./node_modules/core-js/internals/iterators-core.js": function (
                e,
                t,
                n
              ) {
                var i,
                  a,
                  r,
                  l = n(
                    "./node_modules/core-js/internals/object-get-prototype-of.js"
                  ),
                  o = n("./node_modules/core-js/internals/hide.js"),
                  s = n("./node_modules/core-js/internals/has.js"),
                  d = n(
                    "./node_modules/core-js/internals/well-known-symbol.js"
                  ),
                  u = n("./node_modules/core-js/internals/is-pure.js"),
                  c = d("iterator"),
                  h = !1;
                [].keys &&
                  ("next" in (r = [].keys())
                    ? (a = l(l(r))) !== Object.prototype && (i = a)
                    : (h = !0)),
                  null == i && (i = {}),
                  u ||
                    s(i, c) ||
                    o(i, c, function () {
                      return this;
                    }),
                  (e.exports = {
                    IteratorPrototype: i,
                    BUGGY_SAFARI_ITERATORS: h,
                  });
              },
              "./node_modules/core-js/internals/iterators.js": function (e, t) {
                e.exports = {};
              },
              "./node_modules/core-js/internals/native-symbol.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/fails.js");
                e.exports =
                  !!Object.getOwnPropertySymbols &&
                  !i(function () {
                    return !String(Symbol());
                  });
              },
              "./node_modules/core-js/internals/native-weak-map.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/global.js"),
                  a = n(
                    "./node_modules/core-js/internals/function-to-string.js"
                  ),
                  r = i.WeakMap;
                e.exports =
                  "function" == typeof r && /native code/.test(a.call(r));
              },
              "./node_modules/core-js/internals/object-create.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/an-object.js"),
                  a = n(
                    "./node_modules/core-js/internals/object-define-properties.js"
                  ),
                  r = n("./node_modules/core-js/internals/enum-bug-keys.js"),
                  l = n("./node_modules/core-js/internals/hidden-keys.js"),
                  o = n("./node_modules/core-js/internals/html.js"),
                  s = n(
                    "./node_modules/core-js/internals/document-create-element.js"
                  ),
                  d = n("./node_modules/core-js/internals/shared-key.js")(
                    "IE_PROTO"
                  ),
                  u = "prototype",
                  c = function () {},
                  h = function () {
                    var e,
                      t = s("iframe"),
                      n = r.length,
                      i = "script",
                      a = "java" + i + ":";
                    for (
                      t.style.display = "none",
                        o.appendChild(t),
                        t.src = String(a),
                        (e = t.contentWindow.document).open(),
                        e.write("<" + i + ">document.F=Object</" + i + ">"),
                        e.close(),
                        h = e.F;
                      n--;

                    )
                      delete h[u][r[n]];
                    return h();
                  };
                (e.exports =
                  Object.create ||
                  function (e, t) {
                    var n;
                    return (
                      null !== e
                        ? ((c[u] = i(e)),
                          (n = new c()),
                          (c[u] = null),
                          (n[d] = e))
                        : (n = h()),
                      void 0 === t ? n : a(n, t)
                    );
                  }),
                  (l[d] = !0);
              },
              "./node_modules/core-js/internals/object-define-properties.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/descriptors.js"),
                    a = n(
                      "./node_modules/core-js/internals/object-define-property.js"
                    ),
                    r = n("./node_modules/core-js/internals/an-object.js"),
                    l = n("./node_modules/core-js/internals/object-keys.js");
                  e.exports = i
                    ? Object.defineProperties
                    : function (e, t) {
                        r(e);
                        for (var n, i = l(t), o = i.length, s = 0; o > s; )
                          a.f(e, (n = i[s++]), t[n]);
                        return e;
                      };
                },
              "./node_modules/core-js/internals/object-define-property.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/descriptors.js"),
                    a = n("./node_modules/core-js/internals/ie8-dom-define.js"),
                    r = n("./node_modules/core-js/internals/an-object.js"),
                    l = n("./node_modules/core-js/internals/to-primitive.js"),
                    o = Object.defineProperty;
                  t.f = i
                    ? o
                    : function (e, t, n) {
                        if ((r(e), (t = l(t, !0)), r(n), a))
                          try {
                            return o(e, t, n);
                          } catch (e) {}
                        if ("get" in n || "set" in n)
                          throw TypeError("Accessors not supported");
                        return "value" in n && (e[t] = n.value), e;
                      };
                },
              "./node_modules/core-js/internals/object-get-own-property-descriptor.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/descriptors.js"),
                    a = n(
                      "./node_modules/core-js/internals/object-property-is-enumerable.js"
                    ),
                    r = n(
                      "./node_modules/core-js/internals/create-property-descriptor.js"
                    ),
                    l = n(
                      "./node_modules/core-js/internals/to-indexed-object.js"
                    ),
                    o = n("./node_modules/core-js/internals/to-primitive.js"),
                    s = n("./node_modules/core-js/internals/has.js"),
                    d = n("./node_modules/core-js/internals/ie8-dom-define.js"),
                    u = Object.getOwnPropertyDescriptor;
                  t.f = i
                    ? u
                    : function (e, t) {
                        if (((e = l(e)), (t = o(t, !0)), d))
                          try {
                            return u(e, t);
                          } catch (e) {}
                        if (s(e, t)) return r(!a.f.call(e, t), e[t]);
                      };
                },
              "./node_modules/core-js/internals/object-get-own-property-names.js":
                function (e, t, n) {
                  var i = n(
                      "./node_modules/core-js/internals/object-keys-internal.js"
                    ),
                    a = n(
                      "./node_modules/core-js/internals/enum-bug-keys.js"
                    ).concat("length", "prototype");
                  t.f =
                    Object.getOwnPropertyNames ||
                    function (e) {
                      return i(e, a);
                    };
                },
              "./node_modules/core-js/internals/object-get-own-property-symbols.js":
                function (e, t) {
                  t.f = Object.getOwnPropertySymbols;
                },
              "./node_modules/core-js/internals/object-get-prototype-of.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/has.js"),
                    a = n("./node_modules/core-js/internals/to-object.js"),
                    r = n("./node_modules/core-js/internals/shared-key.js"),
                    l = n(
                      "./node_modules/core-js/internals/correct-prototype-getter.js"
                    ),
                    o = r("IE_PROTO"),
                    s = Object.prototype;
                  e.exports = l
                    ? Object.getPrototypeOf
                    : function (e) {
                        return (
                          (e = a(e)),
                          i(e, o)
                            ? e[o]
                            : "function" == typeof e.constructor &&
                              e instanceof e.constructor
                            ? e.constructor.prototype
                            : e instanceof Object
                            ? s
                            : null
                        );
                      };
                },
              "./node_modules/core-js/internals/object-keys-internal.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/has.js"),
                    a = n(
                      "./node_modules/core-js/internals/to-indexed-object.js"
                    ),
                    r = n("./node_modules/core-js/internals/array-includes.js"),
                    l = n("./node_modules/core-js/internals/hidden-keys.js"),
                    o = r(!1);
                  e.exports = function (e, t) {
                    var n,
                      r = a(e),
                      s = 0,
                      d = [];
                    for (n in r) !i(l, n) && i(r, n) && d.push(n);
                    for (; t.length > s; )
                      i(r, (n = t[s++])) && (~o(d, n) || d.push(n));
                    return d;
                  };
                },
              "./node_modules/core-js/internals/object-keys.js": function (
                e,
                t,
                n
              ) {
                var i = n(
                    "./node_modules/core-js/internals/object-keys-internal.js"
                  ),
                  a = n("./node_modules/core-js/internals/enum-bug-keys.js");
                e.exports =
                  Object.keys ||
                  function (e) {
                    return i(e, a);
                  };
              },
              "./node_modules/core-js/internals/object-property-is-enumerable.js":
                function (e, t, n) {
                  var i = {}.propertyIsEnumerable,
                    a = Object.getOwnPropertyDescriptor,
                    r = a && !i.call({ 1: 2 }, 1);
                  t.f = r
                    ? function (e) {
                        var t = a(this, e);
                        return !!t && t.enumerable;
                      }
                    : i;
                },
              "./node_modules/core-js/internals/object-set-prototype-of.js":
                function (e, t, n) {
                  var i = n(
                    "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js"
                  );
                  e.exports =
                    Object.setPrototypeOf ||
                    ("__proto__" in {}
                      ? (function () {
                          var e,
                            t = !1,
                            n = {};
                          try {
                            (e = Object.getOwnPropertyDescriptor(
                              Object.prototype,
                              "__proto__"
                            ).set).call(n, []),
                              (t = n instanceof Array);
                          } catch (e) {}
                          return function (n, a) {
                            return (
                              i(n, a), t ? e.call(n, a) : (n.__proto__ = a), n
                            );
                          };
                        })()
                      : void 0);
                },
              "./node_modules/core-js/internals/own-keys.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/global.js"),
                  a = n(
                    "./node_modules/core-js/internals/object-get-own-property-names.js"
                  ),
                  r = n(
                    "./node_modules/core-js/internals/object-get-own-property-symbols.js"
                  ),
                  l = n("./node_modules/core-js/internals/an-object.js"),
                  o = i.Reflect;
                e.exports =
                  (o && o.ownKeys) ||
                  function (e) {
                    var t = a.f(l(e)),
                      n = r.f;
                    return n ? t.concat(n(e)) : t;
                  };
              },
              "./node_modules/core-js/internals/path.js": function (e, t, n) {
                e.exports = n("./node_modules/core-js/internals/global.js");
              },
              "./node_modules/core-js/internals/redefine.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/global.js"),
                  a = n("./node_modules/core-js/internals/shared.js"),
                  r = n("./node_modules/core-js/internals/hide.js"),
                  l = n("./node_modules/core-js/internals/has.js"),
                  o = n("./node_modules/core-js/internals/set-global.js"),
                  s = n(
                    "./node_modules/core-js/internals/function-to-string.js"
                  ),
                  d = n("./node_modules/core-js/internals/internal-state.js"),
                  u = d.get,
                  c = d.enforce,
                  h = String(s).split("toString");
                a("inspectSource", function (e) {
                  return s.call(e);
                }),
                  (e.exports = function (e, t, n, a) {
                    var s = !!a && !!a.unsafe,
                      d = !!a && !!a.enumerable,
                      u = !!a && !!a.noTargetGet;
                    "function" == typeof n &&
                      ("string" != typeof t || l(n, "name") || r(n, "name", t),
                      (c(n).source = h.join("string" == typeof t ? t : ""))),
                      e !== i
                        ? (s ? !u && e[t] && (d = !0) : delete e[t],
                          d ? (e[t] = n) : r(e, t, n))
                        : d
                        ? (e[t] = n)
                        : o(t, n);
                  })(Function.prototype, "toString", function () {
                    return (
                      ("function" == typeof this && u(this).source) ||
                      s.call(this)
                    );
                  });
              },
              "./node_modules/core-js/internals/require-object-coercible.js":
                function (e, t) {
                  e.exports = function (e) {
                    if (null == e) throw TypeError("Can't call method on " + e);
                    return e;
                  };
                },
              "./node_modules/core-js/internals/set-global.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/global.js"),
                  a = n("./node_modules/core-js/internals/hide.js");
                e.exports = function (e, t) {
                  try {
                    a(i, e, t);
                  } catch (n) {
                    i[e] = t;
                  }
                  return t;
                };
              },
              "./node_modules/core-js/internals/set-to-string-tag.js":
                function (e, t, n) {
                  var i = n(
                      "./node_modules/core-js/internals/object-define-property.js"
                    ).f,
                    a = n("./node_modules/core-js/internals/has.js"),
                    r = n(
                      "./node_modules/core-js/internals/well-known-symbol.js"
                    )("toStringTag");
                  e.exports = function (e, t, n) {
                    e &&
                      !a((e = n ? e : e.prototype), r) &&
                      i(e, r, { configurable: !0, value: t });
                  };
                },
              "./node_modules/core-js/internals/shared-key.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/shared.js"),
                  a = n("./node_modules/core-js/internals/uid.js"),
                  r = i("keys");
                e.exports = function (e) {
                  return r[e] || (r[e] = a(e));
                };
              },
              "./node_modules/core-js/internals/shared.js": function (e, t, n) {
                var i = n("./node_modules/core-js/internals/global.js"),
                  a = n("./node_modules/core-js/internals/set-global.js"),
                  r = n("./node_modules/core-js/internals/is-pure.js"),
                  l = "__core-js_shared__",
                  o = i[l] || a(l, {});
                (e.exports = function (e, t) {
                  return o[e] || (o[e] = void 0 !== t ? t : {});
                })("versions", []).push({
                  version: "3.1.3",
                  mode: r ? "pure" : "global",
                  copyright: "© 2019 Denis Pushkarev (zloirock.ru)",
                });
              },
              "./node_modules/core-js/internals/string-at.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/to-integer.js"),
                  a = n(
                    "./node_modules/core-js/internals/require-object-coercible.js"
                  );
                e.exports = function (e, t, n) {
                  var r,
                    l,
                    o = String(a(e)),
                    s = i(t),
                    d = o.length;
                  return s < 0 || s >= d
                    ? n
                      ? ""
                      : void 0
                    : (r = o.charCodeAt(s)) < 55296 ||
                      r > 56319 ||
                      s + 1 === d ||
                      (l = o.charCodeAt(s + 1)) < 56320 ||
                      l > 57343
                    ? n
                      ? o.charAt(s)
                      : r
                    : n
                    ? o.slice(s, s + 2)
                    : l - 56320 + ((r - 55296) << 10) + 65536;
                };
              },
              "./node_modules/core-js/internals/to-absolute-index.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/to-integer.js"),
                    a = Math.max,
                    r = Math.min;
                  e.exports = function (e, t) {
                    var n = i(e);
                    return n < 0 ? a(n + t, 0) : r(n, t);
                  };
                },
              "./node_modules/core-js/internals/to-indexed-object.js":
                function (e, t, n) {
                  var i = n(
                      "./node_modules/core-js/internals/indexed-object.js"
                    ),
                    a = n(
                      "./node_modules/core-js/internals/require-object-coercible.js"
                    );
                  e.exports = function (e) {
                    return i(a(e));
                  };
                },
              "./node_modules/core-js/internals/to-integer.js": function (
                e,
                t
              ) {
                var n = Math.ceil,
                  i = Math.floor;
                e.exports = function (e) {
                  return isNaN((e = +e)) ? 0 : (e > 0 ? i : n)(e);
                };
              },
              "./node_modules/core-js/internals/to-length.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/to-integer.js"),
                  a = Math.min;
                e.exports = function (e) {
                  return e > 0 ? a(i(e), 9007199254740991) : 0;
                };
              },
              "./node_modules/core-js/internals/to-object.js": function (
                e,
                t,
                n
              ) {
                var i = n(
                  "./node_modules/core-js/internals/require-object-coercible.js"
                );
                e.exports = function (e) {
                  return Object(i(e));
                };
              },
              "./node_modules/core-js/internals/to-primitive.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/is-object.js");
                e.exports = function (e, t) {
                  if (!i(e)) return e;
                  var n, a;
                  if (
                    t &&
                    "function" == typeof (n = e.toString) &&
                    !i((a = n.call(e)))
                  )
                    return a;
                  if (
                    "function" == typeof (n = e.valueOf) &&
                    !i((a = n.call(e)))
                  )
                    return a;
                  if (
                    !t &&
                    "function" == typeof (n = e.toString) &&
                    !i((a = n.call(e)))
                  )
                    return a;
                  throw TypeError("Can't convert object to primitive value");
                };
              },
              "./node_modules/core-js/internals/uid.js": function (e, t) {
                var n = 0,
                  i = Math.random();
                e.exports = function (e) {
                  return "Symbol(".concat(
                    void 0 === e ? "" : e,
                    ")_",
                    (++n + i).toString(36)
                  );
                };
              },
              "./node_modules/core-js/internals/validate-set-prototype-of-arguments.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/is-object.js"),
                    a = n("./node_modules/core-js/internals/an-object.js");
                  e.exports = function (e, t) {
                    if ((a(e), !i(t) && null !== t))
                      throw TypeError(
                        "Can't set " + String(t) + " as a prototype"
                      );
                  };
                },
              "./node_modules/core-js/internals/well-known-symbol.js":
                function (e, t, n) {
                  var i = n("./node_modules/core-js/internals/global.js"),
                    a = n("./node_modules/core-js/internals/shared.js"),
                    r = n("./node_modules/core-js/internals/uid.js"),
                    l = n("./node_modules/core-js/internals/native-symbol.js"),
                    o = i.Symbol,
                    s = a("wks");
                  e.exports = function (e) {
                    return (
                      s[e] || (s[e] = (l && o[e]) || (l ? o : r)("Symbol." + e))
                    );
                  };
                },
              "./node_modules/core-js/modules/es.array.from.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/export.js"),
                  a = n("./node_modules/core-js/internals/array-from.js");
                i(
                  {
                    target: "Array",
                    stat: !0,
                    forced: !n(
                      "./node_modules/core-js/internals/check-correctness-of-iteration.js"
                    )(function (e) {
                      Array.from(e);
                    }),
                  },
                  { from: a }
                );
              },
              "./node_modules/core-js/modules/es.string.iterator.js": function (
                e,
                t,
                n
              ) {
                var i = n("./node_modules/core-js/internals/string-at.js"),
                  a = n("./node_modules/core-js/internals/internal-state.js"),
                  r = n("./node_modules/core-js/internals/define-iterator.js"),
                  l = "String Iterator",
                  o = a.set,
                  s = a.getterFor(l);
                r(
                  String,
                  "String",
                  function (e) {
                    o(this, { type: l, string: String(e), index: 0 });
                  },
                  function () {
                    var e,
                      t = s(this),
                      n = t.string,
                      a = t.index;
                    return a >= n.length
                      ? { value: void 0, done: !0 }
                      : ((e = i(n, a, !0)),
                        (t.index += e.length),
                        { value: e, done: !1 });
                  }
                );
              },
              "./node_modules/webpack/buildin/global.js": function (e, t) {
                var n;
                n = (function () {
                  return this;
                })();
                try {
                  n = n || Function("return this")() || (0, eval)("this");
                } catch (e) {
                  "object" == typeof window && (n = window);
                }
                e.exports = n;
              },
              "./src/default-attrs.json": function (e) {
                e.exports = {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: 24,
                  height: 24,
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": 2,
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                };
              },
              "./src/icon.js": function (e, t, n) {
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i =
                    Object.assign ||
                    function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var i in n)
                          Object.prototype.hasOwnProperty.call(n, i) &&
                            (e[i] = n[i]);
                      }
                      return e;
                    },
                  a = (function () {
                    function e(e, t) {
                      for (var n = 0; n < t.length; n++) {
                        var i = t[n];
                        (i.enumerable = i.enumerable || !1),
                          (i.configurable = !0),
                          "value" in i && (i.writable = !0),
                          Object.defineProperty(e, i.key, i);
                      }
                    }
                    return function (t, n, i) {
                      return n && e(t.prototype, n), i && e(t, i), t;
                    };
                  })(),
                  r = o(n("./node_modules/classnames/dedupe.js")),
                  l = o(n("./src/default-attrs.json"));
                function o(e) {
                  return e && e.__esModule ? e : { default: e };
                }
                var s = (function () {
                  function e(t, n) {
                    var a =
                      arguments.length > 2 && void 0 !== arguments[2]
                        ? arguments[2]
                        : [];
                    !(function (e, t) {
                      if (!(e instanceof t))
                        throw new TypeError(
                          "Cannot call a class as a function"
                        );
                    })(this, e),
                      (this.name = t),
                      (this.contents = n),
                      (this.tags = a),
                      (this.attrs = i({}, l.default, {
                        class: "feather feather-" + t,
                      }));
                  }
                  return (
                    a(e, [
                      {
                        key: "toSvg",
                        value: function () {
                          var e =
                            arguments.length > 0 && void 0 !== arguments[0]
                              ? arguments[0]
                              : {};
                          return (
                            "<svg " +
                            (function (e) {
                              return Object.keys(e)
                                .map(function (t) {
                                  return t + '="' + e[t] + '"';
                                })
                                .join(" ");
                            })(
                              i({}, this.attrs, e, {
                                class: (0, r.default)(
                                  this.attrs.class,
                                  e.class
                                ),
                              })
                            ) +
                            ">" +
                            this.contents +
                            "</svg>"
                          );
                        },
                      },
                      {
                        key: "toString",
                        value: function () {
                          return this.contents;
                        },
                      },
                    ]),
                    e
                  );
                })();
                t.default = s;
              },
              "./src/icons.js": function (e, t, n) {
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i = l(n("./src/icon.js")),
                  a = l(n("./dist/icons.json")),
                  r = l(n("./src/tags.json"));
                function l(e) {
                  return e && e.__esModule ? e : { default: e };
                }
                t.default = Object.keys(a.default)
                  .map(function (e) {
                    return new i.default(e, a.default[e], r.default[e]);
                  })
                  .reduce(function (e, t) {
                    return (e[t.name] = t), e;
                  }, {});
              },
              "./src/index.js": function (e, t, n) {
                var i = l(n("./src/icons.js")),
                  a = l(n("./src/to-svg.js")),
                  r = l(n("./src/replace.js"));
                function l(e) {
                  return e && e.__esModule ? e : { default: e };
                }
                e.exports = {
                  icons: i.default,
                  toSvg: a.default,
                  replace: r.default,
                };
              },
              "./src/replace.js": function (e, t, n) {
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i =
                    Object.assign ||
                    function (e) {
                      for (var t = 1; t < arguments.length; t++) {
                        var n = arguments[t];
                        for (var i in n)
                          Object.prototype.hasOwnProperty.call(n, i) &&
                            (e[i] = n[i]);
                      }
                      return e;
                    },
                  a = l(n("./node_modules/classnames/dedupe.js")),
                  r = l(n("./src/icons.js"));
                function l(e) {
                  return e && e.__esModule ? e : { default: e };
                }
                t.default = function () {
                  var e =
                    arguments.length > 0 && void 0 !== arguments[0]
                      ? arguments[0]
                      : {};
                  if ("undefined" == typeof document)
                    throw new Error(
                      "`feather.replace()` only works in a browser environment."
                    );
                  var t = document.querySelectorAll("[data-feather]");
                  Array.from(t).forEach(function (t) {
                    return (function (e) {
                      var t =
                          arguments.length > 1 && void 0 !== arguments[1]
                            ? arguments[1]
                            : {},
                        n = (function (e) {
                          return Array.from(e.attributes).reduce(function (
                            e,
                            t
                          ) {
                            return (e[t.name] = t.value), e;
                          },
                          {});
                        })(e),
                        l = n["data-feather"];
                      delete n["data-feather"];
                      var o = r.default[l].toSvg(
                          i({}, t, n, {
                            class: (0, a.default)(t.class, n.class),
                          })
                        ),
                        s = new DOMParser()
                          .parseFromString(o, "image/svg+xml")
                          .querySelector("svg");
                      e.parentNode.replaceChild(s, e);
                    })(t, e);
                  });
                };
              },
              "./src/tags.json": function (e) {
                e.exports = {
                  activity: ["pulse", "health", "action", "motion"],
                  airplay: ["stream", "cast", "mirroring"],
                  "alert-circle": ["warning", "alert", "danger"],
                  "alert-octagon": ["warning", "alert", "danger"],
                  "alert-triangle": ["warning", "alert", "danger"],
                  "align-center": ["text alignment", "center"],
                  "align-justify": ["text alignment", "justified"],
                  "align-left": ["text alignment", "left"],
                  "align-right": ["text alignment", "right"],
                  anchor: [],
                  archive: ["index", "box"],
                  "at-sign": ["mention", "at", "email", "message"],
                  award: ["achievement", "badge"],
                  aperture: ["camera", "photo"],
                  "bar-chart": ["statistics", "diagram", "graph"],
                  "bar-chart-2": ["statistics", "diagram", "graph"],
                  battery: ["power", "electricity"],
                  "battery-charging": ["power", "electricity"],
                  bell: ["alarm", "notification", "sound"],
                  "bell-off": ["alarm", "notification", "silent"],
                  bluetooth: ["wireless"],
                  "book-open": ["read", "library"],
                  book: [
                    "read",
                    "dictionary",
                    "booklet",
                    "magazine",
                    "library",
                  ],
                  bookmark: ["read", "clip", "marker", "tag"],
                  box: ["cube"],
                  briefcase: ["work", "bag", "baggage", "folder"],
                  calendar: ["date"],
                  camera: ["photo"],
                  cast: ["chromecast", "airplay"],
                  "chevron-down": ["expand"],
                  "chevron-up": ["collapse"],
                  circle: ["off", "zero", "record"],
                  clipboard: ["copy"],
                  clock: ["time", "watch", "alarm"],
                  "cloud-drizzle": ["weather", "shower"],
                  "cloud-lightning": ["weather", "bolt"],
                  "cloud-rain": ["weather"],
                  "cloud-snow": ["weather", "blizzard"],
                  cloud: ["weather"],
                  codepen: ["logo"],
                  codesandbox: ["logo"],
                  code: ["source", "programming"],
                  coffee: [
                    "drink",
                    "cup",
                    "mug",
                    "tea",
                    "cafe",
                    "hot",
                    "beverage",
                  ],
                  columns: ["layout"],
                  command: ["keyboard", "cmd", "terminal", "prompt"],
                  compass: ["navigation", "safari", "travel", "direction"],
                  copy: ["clone", "duplicate"],
                  "corner-down-left": ["arrow", "return"],
                  "corner-down-right": ["arrow"],
                  "corner-left-down": ["arrow"],
                  "corner-left-up": ["arrow"],
                  "corner-right-down": ["arrow"],
                  "corner-right-up": ["arrow"],
                  "corner-up-left": ["arrow"],
                  "corner-up-right": ["arrow"],
                  cpu: ["processor", "technology"],
                  "credit-card": ["purchase", "payment", "cc"],
                  crop: ["photo", "image"],
                  crosshair: ["aim", "target"],
                  database: ["storage", "memory"],
                  delete: ["remove"],
                  disc: ["album", "cd", "dvd", "music"],
                  "dollar-sign": ["currency", "money", "payment"],
                  droplet: ["water"],
                  edit: ["pencil", "change"],
                  "edit-2": ["pencil", "change"],
                  "edit-3": ["pencil", "change"],
                  eye: ["view", "watch"],
                  "eye-off": ["view", "watch", "hide", "hidden"],
                  "external-link": ["outbound"],
                  facebook: ["logo", "social"],
                  "fast-forward": ["music"],
                  figma: ["logo", "design", "tool"],
                  "file-minus": ["delete", "remove", "erase"],
                  "file-plus": ["add", "create", "new"],
                  "file-text": ["data", "txt", "pdf"],
                  film: ["movie", "video"],
                  filter: ["funnel", "hopper"],
                  flag: ["report"],
                  "folder-minus": ["directory"],
                  "folder-plus": ["directory"],
                  folder: ["directory"],
                  framer: ["logo", "design", "tool"],
                  frown: ["emoji", "face", "bad", "sad", "emotion"],
                  gift: ["present", "box", "birthday", "party"],
                  "git-branch": ["code", "version control"],
                  "git-commit": ["code", "version control"],
                  "git-merge": ["code", "version control"],
                  "git-pull-request": ["code", "version control"],
                  github: ["logo", "version control"],
                  gitlab: ["logo", "version control"],
                  globe: ["world", "browser", "language", "translate"],
                  "hard-drive": ["computer", "server", "memory", "data"],
                  hash: ["hashtag", "number", "pound"],
                  headphones: ["music", "audio", "sound"],
                  heart: ["like", "love", "emotion"],
                  "help-circle": ["question mark"],
                  hexagon: ["shape", "node.js", "logo"],
                  home: ["house", "living"],
                  image: ["picture"],
                  inbox: ["email"],
                  instagram: ["logo", "camera"],
                  key: ["password", "login", "authentication", "secure"],
                  layers: ["stack"],
                  layout: ["window", "webpage"],
                  "life-bouy": ["help", "life ring", "support"],
                  link: ["chain", "url"],
                  "link-2": ["chain", "url"],
                  linkedin: ["logo", "social media"],
                  list: ["options"],
                  lock: ["security", "password", "secure"],
                  "log-in": ["sign in", "arrow", "enter"],
                  "log-out": ["sign out", "arrow", "exit"],
                  mail: ["email", "message"],
                  "map-pin": ["location", "navigation", "travel", "marker"],
                  map: ["location", "navigation", "travel"],
                  maximize: ["fullscreen"],
                  "maximize-2": ["fullscreen", "arrows", "expand"],
                  meh: ["emoji", "face", "neutral", "emotion"],
                  menu: ["bars", "navigation", "hamburger"],
                  "message-circle": ["comment", "chat"],
                  "message-square": ["comment", "chat"],
                  "mic-off": ["record", "sound", "mute"],
                  mic: ["record", "sound", "listen"],
                  minimize: ["exit fullscreen", "close"],
                  "minimize-2": ["exit fullscreen", "arrows", "close"],
                  minus: ["subtract"],
                  monitor: ["tv", "screen", "display"],
                  moon: ["dark", "night"],
                  "more-horizontal": ["ellipsis"],
                  "more-vertical": ["ellipsis"],
                  "mouse-pointer": ["arrow", "cursor"],
                  move: ["arrows"],
                  music: ["note"],
                  navigation: ["location", "travel"],
                  "navigation-2": ["location", "travel"],
                  octagon: ["stop"],
                  package: ["box", "container"],
                  paperclip: ["attachment"],
                  pause: ["music", "stop"],
                  "pause-circle": ["music", "audio", "stop"],
                  "pen-tool": ["vector", "drawing"],
                  percent: ["discount"],
                  "phone-call": ["ring"],
                  "phone-forwarded": ["call"],
                  "phone-incoming": ["call"],
                  "phone-missed": ["call"],
                  "phone-off": ["call", "mute"],
                  "phone-outgoing": ["call"],
                  phone: ["call"],
                  play: ["music", "start"],
                  "pie-chart": ["statistics", "diagram"],
                  "play-circle": ["music", "start"],
                  plus: ["add", "new"],
                  "plus-circle": ["add", "new"],
                  "plus-square": ["add", "new"],
                  pocket: ["logo", "save"],
                  power: ["on", "off"],
                  printer: ["fax", "office", "device"],
                  radio: ["signal"],
                  "refresh-cw": ["synchronise", "arrows"],
                  "refresh-ccw": ["arrows"],
                  repeat: ["loop", "arrows"],
                  rewind: ["music"],
                  "rotate-ccw": ["arrow"],
                  "rotate-cw": ["arrow"],
                  rss: ["feed", "subscribe"],
                  save: ["floppy disk"],
                  scissors: ["cut"],
                  search: ["find", "magnifier", "magnifying glass"],
                  send: [
                    "message",
                    "mail",
                    "email",
                    "paper airplane",
                    "paper aeroplane",
                  ],
                  settings: ["cog", "edit", "gear", "preferences"],
                  "share-2": ["network", "connections"],
                  shield: ["security", "secure"],
                  "shield-off": ["security", "insecure"],
                  "shopping-bag": ["ecommerce", "cart", "purchase", "store"],
                  "shopping-cart": ["ecommerce", "cart", "purchase", "store"],
                  shuffle: ["music"],
                  "skip-back": ["music"],
                  "skip-forward": ["music"],
                  slack: ["logo"],
                  slash: ["ban", "no"],
                  sliders: ["settings", "controls"],
                  smartphone: ["cellphone", "device"],
                  smile: ["emoji", "face", "happy", "good", "emotion"],
                  speaker: ["audio", "music"],
                  star: ["bookmark", "favorite", "like"],
                  "stop-circle": ["media", "music"],
                  sun: ["brightness", "weather", "light"],
                  sunrise: ["weather", "time", "morning", "day"],
                  sunset: ["weather", "time", "evening", "night"],
                  tablet: ["device"],
                  tag: ["label"],
                  target: ["logo", "bullseye"],
                  terminal: ["code", "command line", "prompt"],
                  thermometer: [
                    "temperature",
                    "celsius",
                    "fahrenheit",
                    "weather",
                  ],
                  "thumbs-down": ["dislike", "bad", "emotion"],
                  "thumbs-up": ["like", "good", "emotion"],
                  "toggle-left": ["on", "off", "switch"],
                  "toggle-right": ["on", "off", "switch"],
                  tool: ["settings", "spanner"],
                  trash: ["garbage", "delete", "remove", "bin"],
                  "trash-2": ["garbage", "delete", "remove", "bin"],
                  triangle: ["delta"],
                  truck: ["delivery", "van", "shipping", "transport", "lorry"],
                  tv: ["television", "stream"],
                  twitch: ["logo"],
                  twitter: ["logo", "social"],
                  type: ["text"],
                  umbrella: ["rain", "weather"],
                  unlock: ["security"],
                  "user-check": ["followed", "subscribed"],
                  "user-minus": ["delete", "remove", "unfollow", "unsubscribe"],
                  "user-plus": ["new", "add", "create", "follow", "subscribe"],
                  "user-x": [
                    "delete",
                    "remove",
                    "unfollow",
                    "unsubscribe",
                    "unavailable",
                  ],
                  user: ["person", "account"],
                  users: ["group"],
                  "video-off": ["camera", "movie", "film"],
                  video: ["camera", "movie", "film"],
                  voicemail: ["phone"],
                  volume: ["music", "sound", "mute"],
                  "volume-1": ["music", "sound"],
                  "volume-2": ["music", "sound"],
                  "volume-x": ["music", "sound", "mute"],
                  watch: ["clock", "time"],
                  "wifi-off": ["disabled"],
                  wifi: ["connection", "signal", "wireless"],
                  wind: ["weather", "air"],
                  "x-circle": [
                    "cancel",
                    "close",
                    "delete",
                    "remove",
                    "times",
                    "clear",
                  ],
                  "x-octagon": [
                    "delete",
                    "stop",
                    "alert",
                    "warning",
                    "times",
                    "clear",
                  ],
                  "x-square": [
                    "cancel",
                    "close",
                    "delete",
                    "remove",
                    "times",
                    "clear",
                  ],
                  x: ["cancel", "close", "delete", "remove", "times", "clear"],
                  youtube: ["logo", "video", "play"],
                  "zap-off": ["flash", "camera", "lightning"],
                  zap: ["flash", "camera", "lightning"],
                  "zoom-in": ["magnifying glass"],
                  "zoom-out": ["magnifying glass"],
                };
              },
              "./src/to-svg.js": function (e, t, n) {
                Object.defineProperty(t, "__esModule", { value: !0 });
                var i,
                  a = n("./src/icons.js"),
                  r = (i = a) && i.__esModule ? i : { default: i };
                t.default = function (e) {
                  var t =
                    arguments.length > 1 && void 0 !== arguments[1]
                      ? arguments[1]
                      : {};
                  if (
                    (console.warn(
                      "feather.toSvg() is deprecated. Please use feather.icons[name].toSvg() instead."
                    ),
                    !e)
                  )
                    throw new Error(
                      "The required `key` (icon name) parameter is missing."
                    );
                  if (!r.default[e])
                    throw new Error(
                      "No icon matching '" +
                        e +
                        "'. See the complete list of icons at https://feathericons.com"
                    );
                  return r.default[e].toSvg(t);
                };
              },
              0: function (e, t, n) {
                n("./node_modules/core-js/es/array/from.js"),
                  (e.exports = n("./src/index.js"));
              },
            });
          }),
          (e.exports = t());
      },
      1895: function () {
        "function" != typeof Object.assign &&
          (Object.assign = function (e) {
            for (var t = [], n = 1; n < arguments.length; n++)
              t[n - 1] = arguments[n];
            if (!e)
              throw TypeError("Cannot convert undefined or null to object");
            for (
              var i = function (t) {
                  t &&
                    Object.keys(t).forEach(function (n) {
                      return (e[n] = t[n]);
                    });
                },
                a = 0,
                r = t;
              a < r.length;
              a++
            ) {
              i(r[a]);
            }
            return e;
          });
      },
      1163: function (e) {
        e.exports = (function () {
          function e(e, n) {
            (e.prototype = Object.create(n.prototype)),
              (e.prototype.constructor = e),
              t(e, n);
          }
          function t(e, n) {
            return (
              (t = Object.setPrototypeOf
                ? Object.setPrototypeOf.bind()
                : function (e, t) {
                    return (e.__proto__ = t), e;
                  }),
              t(e, n)
            );
          }
          function n(e) {
            if (void 0 === e)
              throw new ReferenceError(
                "this hasn't been initialised - super() hasn't been called"
              );
            return e;
          }
          function i(e) {
            throw new TypeError('"' + e + '" is read-only');
          }
          function a(e, t) {
            (null == t || t > e.length) && (t = e.length);
            for (var n = 0, i = new Array(t); n < t; n++) i[n] = e[n];
            return i;
          }
          function r(e, t) {
            var n =
              ("undefined" != typeof Symbol && e[Symbol.iterator]) ||
              e["@@iterator"];
            if (n) return (n = n.call(e)).next.bind(n);
            if (
              Array.isArray(e) ||
              (n = (function (e, t) {
                if (e) {
                  if ("string" == typeof e) return a(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return (
                    "Object" === n && e.constructor && (n = e.constructor.name),
                    "Map" === n || "Set" === n
                      ? Array.from(e)
                      : "Arguments" === n ||
                        /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)
                      ? a(e, t)
                      : void 0
                  );
                }
              })(e)) ||
              (t && e && "number" == typeof e.length)
            ) {
              n && (e = n);
              var i = 0;
              return function () {
                return i >= e.length
                  ? { done: !0 }
                  : { done: !1, value: e[i++] };
              };
            }
            throw new TypeError(
              "Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."
            );
          }
          Element.prototype.matches ||
            (Element.prototype.matches =
              Element.prototype.matchesSelector ||
              Element.prototype.mozMatchesSelector ||
              Element.prototype.msMatchesSelector ||
              Element.prototype.oMatchesSelector ||
              Element.prototype.webkitMatchesSelector ||
              function (e) {
                for (
                  var t = (
                      this.document || this.ownerDocument
                    ).querySelectorAll(e),
                    n = t.length;
                  i("i") >= 0 && t.item(n) !== this;

                );
                return n > -1;
              }),
            Object.assign ||
              Object.defineProperty(Object, "assign", {
                enumerable: !1,
                configurable: !0,
                writable: !0,
                value: function (e) {
                  if (null == e)
                    throw new TypeError(
                      "Cannot convert first argument to object"
                    );
                  for (var t = Object(e), n = 1; n < arguments.length; n++) {
                    var i = arguments[n];
                    if (null != i) {
                      i = Object(i);
                      for (
                        var a = Object.keys(Object(i)), r = 0, l = a.length;
                        r < l;
                        r++
                      ) {
                        var o = a[r],
                          s = Object.getOwnPropertyDescriptor(i, o);
                        void 0 !== s && s.enumerable && (t[o] = i[o]);
                      }
                    }
                  }
                  return t;
                },
              });
          var l = function (e) {
              return (
                (function (e) {
                  return !!e && "object" == typeof e;
                })(e) &&
                !(function (e) {
                  var t = Object.prototype.toString.call(e);
                  return (
                    "[object RegExp]" === t ||
                    "[object Date]" === t ||
                    (function (e) {
                      return e instanceof Node;
                    })(e) ||
                    (function (e) {
                      return e.$$typeof === o;
                    })(e)
                  );
                })(e)
              );
            },
            o =
              "function" == typeof Symbol && Symbol.for
                ? Symbol.for("react.element")
                : 60103;
          function s(e, t) {
            return !1 !== t.clone && t.isMergeableObject(e)
              ? m(((n = e), Array.isArray(n) ? [] : {}), e, t)
              : e;
            var n;
          }
          function d(e, t, n) {
            return e.concat(t).map(function (e) {
              return s(e, n);
            });
          }
          function u(e) {
            return Object.keys(e).concat(
              (function (e) {
                return Object.getOwnPropertySymbols
                  ? Object.getOwnPropertySymbols(e).filter(function (t) {
                      return e.propertyIsEnumerable(t);
                    })
                  : [];
              })(e)
            );
          }
          function c(e, t) {
            try {
              return t in e;
            } catch (e) {
              return !1;
            }
          }
          function h(e, t, n) {
            var i = {};
            return (
              n.isMergeableObject(e) &&
                u(e).forEach(function (t) {
                  i[t] = s(e[t], n);
                }),
              u(t).forEach(function (a) {
                (function (e, t) {
                  return (
                    c(e, t) &&
                    !(
                      Object.hasOwnProperty.call(e, t) &&
                      Object.propertyIsEnumerable.call(e, t)
                    )
                  );
                })(e, a) ||
                  (c(e, a) && n.isMergeableObject(t[a])
                    ? (i[a] = (function (e, t) {
                        if (!t.customMerge) return m;
                        var n = t.customMerge(e);
                        return "function" == typeof n ? n : m;
                      })(a, n)(e[a], t[a], n))
                    : (i[a] = s(t[a], n)));
              }),
              i
            );
          }
          var m = function (e, t, n) {
              ((n = n || {}).arrayMerge = n.arrayMerge || d),
                (n.isMergeableObject = n.isMergeableObject || l),
                (n.cloneUnlessOtherwiseSpecified = s);
              var i = Array.isArray(t);
              return i === Array.isArray(e)
                ? i
                  ? n.arrayMerge(e, t, n)
                  : h(e, t, n)
                : s(t, n);
            },
            f = function (e) {
              return "object" == typeof e && void 0 !== e.nodeType
                ? e
                : "string" == typeof e
                ? document.querySelector(e)
                : null;
            },
            _ = function (e, t, n, i) {
              void 0 === i && (i = !1);
              var a = document.createElement(e);
              return (
                n && (a[i ? "innerHTML" : "textContent"] = n),
                t && (a.className = t),
                a
              );
            },
            p = function (e) {
              e.parentNode.removeChild(e);
            },
            g = function (e, t, n) {
              return (
                void 0 === n && (n = !1), n ? m(e, t) : Object.assign(e, t)
              );
            },
            y = function (e, t) {
              return e.toLowerCase() + ":to:" + t.toLowerCase();
            },
            v = function (e, t) {
              Object.assign(e.prototype, t);
            },
            M = {},
            b = 1,
            x = {
              on: function (e, t, n, i) {
                void 0 === i && (i = {});
                var a = "jvm:" + t + "::" + b++;
                (M[a] = { selector: e, handler: n }),
                  (n._uid = a),
                  e.addEventListener(t, n, i);
              },
              delegate: function (e, t, n, i) {
                (t = t.split(" ")).forEach(function (t) {
                  x.on(e, t, function (e) {
                    var t = e.target;
                    t.matches(n) && i.call(t, e);
                  });
                });
              },
              off: function (e, t, n) {
                var i = t.split(":")[1];
                e.removeEventListener(i, n), delete M[n._uid];
              },
              flush: function () {
                Object.keys(M).forEach(function (e) {
                  x.off(M[e].selector, e, M[e].handler);
                });
              },
              getEventRegistry: function () {
                return M;
              },
            },
            L = {
              onLoaded: "map:loaded",
              onViewportChange: "viewport:changed",
              onRegionClick: "region:clicked",
              onMarkerClick: "marker:clicked",
              onRegionSelected: "region:selected",
              onMarkerSelected: "marker:selected",
              onRegionTooltipShow: "region.tooltip:show",
              onMarkerTooltipShow: "marker.tooltip:show",
              onDestroyed: "map:destroyed",
            },
            w = function (e, t, n) {
              var i = f(t),
                a =
                  -1 === i.getAttribute("class").indexOf("jvm-region")
                    ? "marker"
                    : "region",
                r = "region" === a,
                l = r
                  ? i.getAttribute("data-code")
                  : i.getAttribute("data-index"),
                o = r ? L.onRegionSelected : L.onMarkerSelected;
              return (
                n && (o = r ? L.onRegionTooltipShow : L.onMarkerTooltipShow),
                {
                  type: a,
                  code: l,
                  event: o,
                  element: r ? e.regions[l].element : e._markers[l].element,
                  tooltipText: r
                    ? e._mapData.paths[l].name || ""
                    : e._markers[l].config.name || "",
                }
              );
            },
            k = (function () {
              function e() {}
              return (
                (e.prototype.dispose = function () {
                  this._tooltip ? p(this._tooltip) : this.shape.remove();
                  for (
                    var e, t = r(Object.getOwnPropertyNames(this));
                    !(e = t()).done;

                  )
                    this[e.value] = null;
                }),
                e
              );
            })(),
            Y = {
              getLabelText: function (e, t) {
                if (t) {
                  if ("function" == typeof t.render) {
                    var n = [];
                    return (
                      this.config &&
                        this.config.marker &&
                        n.push(this.config.marker),
                      n.push(e),
                      t.render.apply(this, n)
                    );
                  }
                  return e;
                }
              },
              getLabelOffsets: function (e, t) {
                return "function" == typeof t.offsets
                  ? t.offsets(e)
                  : Array.isArray(t.offsets)
                  ? t.offsets[e]
                  : [0, 0];
              },
              setStyle: function (e, t) {
                this.shape.setStyle(e, t);
              },
              remove: function () {
                this.shape.remove(), this.label && this.label.remove();
              },
              hover: function (e) {
                this._setStatus("isHovered", e);
              },
              select: function (e) {
                this._setStatus("isSelected", e);
              },
              _setStatus: function (e, t) {
                (this.shape[e] = t),
                  this.shape.updateStyle(),
                  (this[e] = t),
                  this.label && ((this.label[e] = t), this.label.updateStyle());
              },
            },
            D = (function (t) {
              function n(e) {
                var n,
                  i = e.map,
                  a = e.code,
                  r = e.path,
                  l = e.style,
                  o = e.label,
                  s = e.labelStyle,
                  d = e.labelsGroup;
                ((n = t.call(this) || this)._map = i),
                  (n.shape = n._createRegion(r, a, l));
                var u = n.getLabelText(a, o);
                if (o && u) {
                  var c = n.shape.getBBox(),
                    h = n.getLabelOffsets(a, o);
                  (n.labelX = c.x + c.width / 2 + h[0]),
                    (n.labelY = c.y + c.height / 2 + h[1]),
                    (n.label = n._map.canvas.createText(
                      {
                        text: u,
                        textAnchor: "middle",
                        alignmentBaseline: "central",
                        dataCode: a,
                        x: n.labelX,
                        y: n.labelY,
                      },
                      s,
                      d
                    )),
                    n.label.addClass("jvm-region jvm-element");
                }
                return n;
              }
              e(n, t);
              var i = n.prototype;
              return (
                (i._createRegion = function (e, t, n) {
                  return (
                    (e = this._map.canvas.createPath(
                      { d: e, dataCode: t },
                      n
                    )).addClass("jvm-region jvm-element"),
                    e
                  );
                }),
                (i.updateLabelPosition = function () {
                  this.label &&
                    this.label.set({
                      x:
                        this.labelX * this._map.scale +
                        this._map.transX * this._map.scale,
                      y:
                        this.labelY * this._map.scale +
                        this._map.transY * this._map.scale,
                    });
                }),
                n
              );
            })(k);
          v(D, Y);
          var T = (function (t) {
              function n(e) {
                var n,
                  i = e.index,
                  a = e.map,
                  r = e.style,
                  l = e.x1,
                  o = e.y1,
                  s = e.x2,
                  d = e.y2,
                  u = e.group,
                  c = e.config;
                return (
                  ((n = t.call(this) || this).config = c),
                  (n.shape = a.canvas.createLine(
                    { x1: l, y1: o, x2: s, y2: d, dataIndex: i },
                    r,
                    u
                  )),
                  n.shape.addClass("jvm-line"),
                  n
                );
              }
              return (
                e(n, t),
                (n.prototype.setStyle = function (e, t) {
                  this.shape.setStyle(e, t);
                }),
                n
              );
            })(k),
            S = (function (t) {
              function n(e) {
                var n,
                  i = e.index,
                  a = e.style,
                  r = e.label,
                  l = e.cx,
                  o = e.cy,
                  s = e.map,
                  d = e.group;
                return (
                  ((n = t.call(this) || this)._map = s),
                  (n._isImage = !!a.initial.image),
                  (n.config = arguments[0]),
                  (n.shape = s.canvas[
                    n._isImage ? "createImage" : "createCircle"
                  ]({ dataIndex: i, cx: l, cy: o }, a, d)),
                  n.shape.addClass("jvm-marker jvm-element"),
                  n._isImage && n.updateLabelPosition(),
                  r && n._createLabel(n.config),
                  n
                );
              }
              e(n, t);
              var i = n.prototype;
              return (
                (i.updateLabelPosition = function () {
                  this.label &&
                    this.label.set({
                      x:
                        this._labelX * this._map.scale +
                        this._offsets[0] +
                        this._map.transX * this._map.scale +
                        5 +
                        (this._isImage
                          ? (this.shape.width || 0) / 2
                          : this.shape.node.r.baseVal.value),
                      y:
                        this._labelY * this._map.scale +
                        this._map.transY * this._map.scale +
                        this._offsets[1],
                    });
                }),
                (i._createLabel = function (e) {
                  var t = e.index,
                    n = e.map,
                    i = e.label,
                    a = e.labelsGroup,
                    r = e.cx,
                    l = e.cy,
                    o = e.marker,
                    s = e.isRecentlyCreated,
                    d = this.getLabelText(t, i);
                  (this._labelX = r / n.scale - n.transX),
                    (this._labelY = l / n.scale - n.transY),
                    (this._offsets =
                      s && o.offsets ? o.offsets : this.getLabelOffsets(t, i)),
                    (this.label = n.canvas.createText(
                      {
                        text: d,
                        dataIndex: t,
                        x: this._labelX,
                        y: this._labelY,
                        dy: "0.6ex",
                      },
                      n.params.markerLabelStyle,
                      a
                    )),
                    this.label.addClass("jvm-marker jvm-element"),
                    s && this.updateLabelPosition();
                }),
                n
              );
            })(k);
          v(S, Y);
          var j = (function () {
              function e(e) {
                void 0 === e && (e = {}),
                  (this._options = e),
                  (this._map = this._options.map),
                  (this._series = this._options.series),
                  (this._body = _("div", "jvm-legend")),
                  this._options.cssClass &&
                    this._body.setAttribute("class", this._options.cssClass),
                  e.vertical
                    ? this._map.legendVertical.appendChild(this._body)
                    : this._map.legendHorizontal.appendChild(this._body),
                  this.render();
              }
              return (
                (e.prototype.render = function () {
                  var e,
                    t = this._series.scale.getTicks(),
                    n = _("div", "jvm-legend-inner");
                  if (((this._body.innderHTML = ""), this._options.title)) {
                    var i = _("div", "jvm-legend-title", this._options.title);
                    this._body.appendChild(i);
                  }
                  this._body.appendChild(n);
                  for (var a = 0; a < t.length; a++) {
                    var r = _("div", "jvm-legend-tick"),
                      l = _("div", "jvm-legend-tick-sample");
                    switch (this._series.config.attribute) {
                      case "fill":
                        (e = t[a].value),
                          /\.(jpg|gif|png)$/.test(e)
                            ? (l.style.background = "url(" + t[a].value + ")")
                            : (l.style.background = t[a].value);
                        break;
                      case "stroke":
                        l.style.background = t[a].value;
                        break;
                      case "image":
                        (l.style.background =
                          "url(" +
                          ("object" == typeof t[a].value
                            ? t[a].value.url
                            : t[a].value) +
                          ") no-repeat center center"),
                          (l.style.backgroundSize = "cover");
                    }
                    r.appendChild(l);
                    var o = t[a].label;
                    this._options.labelRender &&
                      (o = this._options.labelRender(o));
                    var s = _("div", "jvm-legend-tick-text", o);
                    r.appendChild(s), n.appendChild(r);
                  }
                }),
                e
              );
            })(),
            O = (function () {
              function e(e) {
                this._scale = e;
              }
              var t = e.prototype;
              return (
                (t.getValue = function (e) {
                  return this._scale[e];
                }),
                (t.getTicks = function () {
                  var e = [];
                  for (var t in this._scale)
                    e.push({ label: t, value: this._scale[t] });
                  return e;
                }),
                e
              );
            })(),
            A = (function () {
              function e(e, t, n) {
                void 0 === e && (e = {}),
                  (this._map = n),
                  (this._elements = t),
                  (this._values = e.values || {}),
                  (this.config = e),
                  (this.config.attribute = e.attribute || "fill"),
                  e.attributes && this.setAttributes(e.attributes),
                  "object" == typeof e.scale && (this.scale = new O(e.scale)),
                  this.config.legend &&
                    (this.legend = new j(
                      g({ map: this._map, series: this }, this.config.legend)
                    )),
                  this.setValues(this._values);
              }
              var t = e.prototype;
              return (
                (t.setValues = function (e) {
                  var t = {};
                  for (var n in e) e[n] && (t[n] = this.scale.getValue(e[n]));
                  this.setAttributes(t);
                }),
                (t.setAttributes = function (e) {
                  for (var t in e)
                    this._elements[t] &&
                      this._elements[t].element.setStyle(
                        this.config.attribute,
                        e[t]
                      );
                }),
                (t.clear = function () {
                  var e,
                    t = {};
                  for (e in this._values)
                    this._elements[e] &&
                      (t[e] =
                        this._elements[e].element.shape.style.initial[
                          this.config.attribute
                        ]);
                  this.setAttributes(t), (this._values = {});
                }),
                e
              );
            })(),
            H = {
              mill: function (e, t, n) {
                return {
                  x: this.radius * (t - n) * this.radDeg,
                  y:
                    (-this.radius *
                      Math.log(Math.tan((45 + 0.4 * e) * this.radDeg))) /
                    0.8,
                };
              },
              merc: function (e, t, n) {
                return {
                  x: this.radius * (t - n) * this.radDeg,
                  y:
                    -this.radius *
                    Math.log(Math.tan(Math.PI / 4 + (e * Math.PI) / 360)),
                };
              },
              aea: function (e, t, n) {
                var i = n * this.radDeg,
                  a = 29.5 * this.radDeg,
                  r = 45.5 * this.radDeg,
                  l = e * this.radDeg,
                  o = t * this.radDeg,
                  s = (Math.sin(a) + Math.sin(r)) / 2,
                  d = Math.cos(a) * Math.cos(a) + 2 * s * Math.sin(a),
                  u = s * (o - i),
                  c = Math.sqrt(d - 2 * s * Math.sin(l)) / s,
                  h = Math.sqrt(d - 2 * s * Math.sin(0)) / s;
                return {
                  x: c * Math.sin(u) * this.radius,
                  y: -(h - c * Math.cos(u)) * this.radius,
                };
              },
              lcc: function (e, t, n) {
                var i = n * this.radDeg,
                  a = t * this.radDeg,
                  r = 33 * this.radDeg,
                  l = 45 * this.radDeg,
                  o = e * this.radDeg,
                  s =
                    Math.log(Math.cos(r) * (1 / Math.cos(l))) /
                    Math.log(
                      Math.tan(Math.PI / 4 + l / 2) *
                        (1 / Math.tan(Math.PI / 4 + r / 2))
                    ),
                  d =
                    (Math.cos(r) * Math.pow(Math.tan(Math.PI / 4 + r / 2), s)) /
                    s,
                  u = d * Math.pow(1 / Math.tan(Math.PI / 4 + o / 2), s),
                  c = d * Math.pow(1 / Math.tan(Math.PI / 4 + 0), s);
                return {
                  x: u * Math.sin(s * (a - i)) * this.radius,
                  y: -(c - u * Math.cos(s * (a - i))) * this.radius,
                };
              },
            };
          (H.degRad = 180 / Math.PI),
            (H.radDeg = Math.PI / 180),
            (H.radius = 6381372);
          var E = {
              _setupContainerEvents: function () {
                var e,
                  t,
                  n = this,
                  i = this,
                  a = !1;
                this.params.draggable &&
                  (x.on(this.container, "mousemove", function (n) {
                    if (!a) return !1;
                    (i.transX -= (e - n.pageX) / i.scale),
                      (i.transY -= (t - n.pageY) / i.scale),
                      i._applyTransform(),
                      (e = n.pageX),
                      (t = n.pageY);
                  }),
                  x.on(this.container, "mousedown", function (n) {
                    return (a = !0), (e = n.pageX), (t = n.pageY), !1;
                  }),
                  x.on(document.body, "mouseup", function () {
                    a = !1;
                  })),
                  this.params.zoomOnScroll &&
                    x.on(this.container, "wheel", function (e) {
                      var t =
                          75 *
                          ((e.deltaY || -e.wheelDelta || e.detail) >> 10 || 1),
                        a = n.container.getBoundingClientRect(),
                        r = e.pageX - a.left - window.pageXOffset,
                        l = e.pageY - a.top - window.pageYOffset,
                        o = Math.pow(
                          1 + i.params.zoomOnScrollSpeed / 1e3,
                          -1.5 * t
                        );
                      i.tooltip && i._tooltip.hide(),
                        i._setScale(i.scale * o, r, l),
                        e.preventDefault();
                    });
              },
              _setupElementEvents: function () {
                var e,
                  t,
                  n,
                  i = this,
                  a = this.container;
                x.on(a, "mousemove", function (i) {
                  Math.abs(e - i.pageX) + Math.abs(t - i.pageY) > 2 && (n = !0);
                }),
                  x.delegate(a, "mousedown", ".jvm-element", function (i) {
                    (e = i.pageX), (t = i.pageY), (n = !1);
                  }),
                  x.delegate(
                    a,
                    "mouseover mouseout",
                    ".jvm-element",
                    function (e) {
                      var t = w(i, this, !0),
                        n = i.params.showTooltip;
                      "mouseover" === e.type
                        ? (t.element.hover(!0),
                          n &&
                            (i._tooltip.text(t.tooltipText),
                            i._tooltip.show(),
                            i._emit(t.event, [e, i._tooltip, t.code])))
                        : (t.element.hover(!1), n && i._tooltip.hide());
                    }
                  ),
                  x.delegate(a, "mouseup", ".jvm-element", function (e) {
                    var t = w(i, this);
                    if (
                      !n &&
                      (("region" === t.type && i.params.regionsSelectable) ||
                        ("marker" === t.type && i.params.markersSelectable))
                    ) {
                      var a = t.element;
                      i.params[t.type + "sSelectableOne"] &&
                        i._clearSelected(t.type + "s"),
                        t.element.isSelected ? a.select(!1) : a.select(!0),
                        i._emit(t.event, [
                          t.code,
                          a.isSelected,
                          i._getSelected(t.type + "s"),
                        ]);
                    }
                  }),
                  x.delegate(a, "click", ".jvm-element", function (e) {
                    var t = w(i, this),
                      n = t.type,
                      a = t.code;
                    i._emit(
                      "region" === n ? L.onRegionClick : L.onMarkerClick,
                      [e, a]
                    );
                  });
              },
              _setupZoomButtons: function () {
                var e = this,
                  t = _("div", "jvm-zoom-btn jvm-zoomin", "&#43;", !0),
                  n = _("div", "jvm-zoom-btn jvm-zoomout", "&#x2212", !0);
                this.container.appendChild(t), this.container.appendChild(n);
                var i = function (t) {
                  return (
                    void 0 === t && (t = !0),
                    function () {
                      return e._setScale(
                        t
                          ? e.scale * e.params.zoomStep
                          : e.scale / e.params.zoomStep,
                        e._width / 2,
                        e._height / 2,
                        !1,
                        e.params.zoomAnimate
                      );
                    }
                  );
                };
                x.on(t, "click", i()), x.on(n, "click", i(!1));
              },
              _setupContainerTouchEvents: function () {
                var e,
                  t,
                  n,
                  i,
                  a,
                  r,
                  l,
                  o = this,
                  s = function (s) {
                    var d,
                      u,
                      c,
                      h,
                      m = s.touches;
                    if (("touchstart" == s.type && (l = 0), 1 == m.length))
                      1 == l &&
                        ((c = o.transX),
                        (h = o.transY),
                        (o.transX -= (n - m[0].pageX) / o.scale),
                        (o.transY -= (i - m[0].pageY) / o.scale),
                        o._tooltip.hide(),
                        o._applyTransform(),
                        (c == o.transX && h == o.transY) || s.preventDefault()),
                        (n = m[0].pageX),
                        (i = m[0].pageY);
                    else if (2 == m.length)
                      if (2 == l)
                        (u =
                          Math.sqrt(
                            Math.pow(m[0].pageX - m[1].pageX, 2) +
                              Math.pow(m[0].pageY - m[1].pageY, 2)
                          ) / t),
                          o._setScale(e * u, a, r),
                          o._tooltip.hide(),
                          s.preventDefault();
                      else {
                        var f = o.container.getBoundingClientRect();
                        (d = {
                          top: f.top + window.scrollY,
                          left: f.left + window.scrollX,
                        }),
                          (a =
                            m[0].pageX > m[1].pageX
                              ? m[1].pageX + (m[0].pageX - m[1].pageX) / 2
                              : m[0].pageX + (m[1].pageX - m[0].pageX) / 2),
                          (r =
                            m[0].pageY > m[1].pageY
                              ? m[1].pageY + (m[0].pageY - m[1].pageY) / 2
                              : m[0].pageY + (m[1].pageY - m[0].pageY) / 2),
                          (a -= d.left),
                          (r -= d.top),
                          (e = o.scale),
                          (t = Math.sqrt(
                            Math.pow(m[0].pageX - m[1].pageX, 2) +
                              Math.pow(m[0].pageY - m[1].pageY, 2)
                          ));
                      }
                    l = m.length;
                  };
                x.on(o.container, "touchstart", s),
                  x.on(o.container, "touchmove", s);
              },
              _createRegions: function () {
                for (var e in ((this._regionLabelsGroup =
                  this._regionLabelsGroup ||
                  this.canvas.createGroup("jvm-regions-labels-group")),
                this._mapData.paths)) {
                  var t = new D({
                    map: this,
                    code: e,
                    path: this._mapData.paths[e].path,
                    style: g({}, this.params.regionStyle),
                    labelStyle: this.params.regionLabelStyle,
                    labelsGroup: this._regionLabelsGroup,
                    label: this.params.labels && this.params.labels.regions,
                  });
                  this.regions[e] = {
                    config: this._mapData.paths[e],
                    element: t,
                  };
                }
              },
              _createLines: function (e, t, n) {
                void 0 === n && (n = !1);
                var i = !1,
                  a = !1;
                for (var r in ((this.linesGroup =
                  this.linesGroup ||
                  this.canvas.createGroup("jvm-lines-group")),
                e)) {
                  var l = e[r];
                  for (var o in t) {
                    var s = n ? t[o].config : t[o];
                    s.name === l.from && (i = this.getMarkerPosition(s)),
                      s.name === l.to && (a = this.getMarkerPosition(s));
                  }
                  !1 !== i &&
                    !1 !== a &&
                    (this._lines[y(l.from, l.to)] = new T({
                      index: r,
                      map: this,
                      style: g(
                        { initial: this.params.lineStyle },
                        { initial: l.style || {} },
                        !0
                      ),
                      x1: i.x,
                      y1: i.y,
                      x2: a.x,
                      y2: a.y,
                      group: this.linesGroup,
                      config: l,
                    }));
                }
              },
              _createMarkers: function (e, t) {
                var n = this;
                void 0 === e && (e = {}),
                  void 0 === t && (t = !1),
                  (this._markersGroup =
                    this._markersGroup ||
                    this.canvas.createGroup("jvm-markers-group")),
                  (this._markerLabelsGroup =
                    this._markerLabelsGroup ||
                    this.canvas.createGroup("jvm-markers-labels-group"));
                var i = function () {
                  var i = e[a],
                    r = n.getMarkerPosition(i),
                    l = i.coords.join(":");
                  if (!r) return "continue";
                  if (t) {
                    if (
                      Object.keys(n._markers).filter(function (e) {
                        return n._markers[e]._uid === l;
                      }).length
                    )
                      return "continue";
                    a = Object.keys(n._markers).length;
                  }
                  var o = new S({
                    index: a,
                    map: n,
                    style: g(
                      n.params.markerStyle,
                      { initial: i.style || {} },
                      !0
                    ),
                    label: n.params.labels && n.params.labels.markers,
                    labelsGroup: n._markerLabelsGroup,
                    cx: r.x,
                    cy: r.y,
                    group: n._markersGroup,
                    marker: i,
                    isRecentlyCreated: t,
                  });
                  n._markers[a] && n.removeMarkers([a]),
                    (n._markers[a] = { _uid: l, config: i, element: o });
                };
                for (var a in e) i();
              },
              _createSeries: function () {
                for (var e in ((this.series = { markers: [], regions: [] }),
                this.params.series))
                  for (var t = 0; t < this.params.series[e].length; t++)
                    this.series[e][t] = new A(
                      this.params.series[e][t],
                      "markers" === e ? this._markers : this.regions,
                      this
                    );
              },
              _applyTransform: function () {
                var e, t, n, i;
                this._defaultWidth * this.scale <= this._width
                  ? ((e =
                      (this._width - this._defaultWidth * this.scale) /
                      (2 * this.scale)),
                    (n =
                      (this._width - this._defaultWidth * this.scale) /
                      (2 * this.scale)))
                  : ((e = 0),
                    (n =
                      (this._width - this._defaultWidth * this.scale) /
                      this.scale)),
                  this._defaultHeight * this.scale <= this._height
                    ? ((t =
                        (this._height - this._defaultHeight * this.scale) /
                        (2 * this.scale)),
                      (i =
                        (this._height - this._defaultHeight * this.scale) /
                        (2 * this.scale)))
                    : ((t = 0),
                      (i =
                        (this._height - this._defaultHeight * this.scale) /
                        this.scale)),
                  this.transY > t
                    ? (this.transY = t)
                    : this.transY < i && (this.transY = i),
                  this.transX > e
                    ? (this.transX = e)
                    : this.transX < n && (this.transX = n),
                  this.canvas.applyTransformParams(
                    this.scale,
                    this.transX,
                    this.transY
                  ),
                  this._markers && this._repositionMarkers(),
                  this._lines && this._repositionLines(),
                  this._repositionLabels();
              },
              _resize: function () {
                var e = this._baseScale;
                this._width / this._height >
                this._defaultWidth / this._defaultHeight
                  ? ((this._baseScale = this._height / this._defaultHeight),
                    (this._baseTransX =
                      Math.abs(
                        this._width - this._defaultWidth * this._baseScale
                      ) /
                      (2 * this._baseScale)))
                  : ((this._baseScale = this._width / this._defaultWidth),
                    (this._baseTransY =
                      Math.abs(
                        this._height - this._defaultHeight * this._baseScale
                      ) /
                      (2 * this._baseScale))),
                  (this.scale *= this._baseScale / e),
                  (this.transX *= this._baseScale / e),
                  (this.transY *= this._baseScale / e);
              },
              _setScale: function (e, t, n, i, a) {
                var r,
                  l,
                  o,
                  s,
                  d,
                  u,
                  c,
                  h,
                  m,
                  f,
                  _ = this,
                  p = 0,
                  g = Math.abs(
                    Math.round(
                      (60 * (e - this.scale)) / Math.max(e, this.scale)
                    )
                  );
                e > this.params.zoomMax * this._baseScale
                  ? (e = this.params.zoomMax * this._baseScale)
                  : e < this.params.zoomMin * this._baseScale &&
                    (e = this.params.zoomMin * this._baseScale),
                  void 0 !== t &&
                    void 0 !== n &&
                    ((r = e / this.scale),
                    i
                      ? ((m =
                          t +
                          (this._defaultWidth *
                            (this._width / (this._defaultWidth * e))) /
                            2),
                        (f =
                          n +
                          (this._defaultHeight *
                            (this._height / (this._defaultHeight * e))) /
                            2))
                      : ((m = this.transX - ((r - 1) / e) * t),
                        (f = this.transY - ((r - 1) / e) * n))),
                  a && g > 0
                    ? ((o = this.scale),
                      (s = (e - o) / g),
                      (d = this.transX * this.scale),
                      (c = this.transY * this.scale),
                      (u = (m * e - d) / g),
                      (h = (f * e - c) / g),
                      (l = setInterval(function () {
                        (p += 1),
                          (_.scale = o + s * p),
                          (_.transX = (d + u * p) / _.scale),
                          (_.transY = (c + h * p) / _.scale),
                          _._applyTransform(),
                          p == g &&
                            (clearInterval(l),
                            _._emit(L.onViewportChange, [
                              _.scale,
                              _.transX,
                              _.transY,
                            ]));
                      }, 10)))
                    : ((this.transX = m),
                      (this.transY = f),
                      (this.scale = e),
                      this._applyTransform(),
                      this._emit(L.onViewportChange, [
                        this.scale,
                        this.transX,
                        this.transY,
                      ]));
              },
              setFocus: function (e) {
                var t = this;
                void 0 === e && (e = {});
                var n,
                  i = [];
                if (
                  (e.region ? i.push(e.region) : e.regions && (i = e.regions),
                  i.length)
                )
                  return (
                    i.forEach(function (e) {
                      if (t.regions[e]) {
                        var i = t.regions[e].element.shape.getBBox();
                        i &&
                          (n =
                            void 0 === n
                              ? i
                              : {
                                  x: Math.min(n.x, i.x),
                                  y: Math.min(n.y, i.y),
                                  width:
                                    Math.max(n.x + n.width, i.x + i.width) -
                                    Math.min(n.x, i.x),
                                  height:
                                    Math.max(n.y + n.height, i.y + i.height) -
                                    Math.min(n.y, i.y),
                                });
                      }
                    }),
                    this._setScale(
                      Math.min(this._width / n.width, this._height / n.height),
                      -(n.x + n.width / 2),
                      -(n.y + n.height / 2),
                      !0,
                      e.animate
                    )
                  );
                if (e.coords) {
                  var a = this.coordsToPoint(e.coords[0], e.coords[1]),
                    r = this.transX - a.x / this.scale,
                    l = this.transY - a.y / this.scale;
                  return this._setScale(
                    e.scale * this._baseScale,
                    r,
                    l,
                    !0,
                    e.animate
                  );
                }
              },
              updateSize: function () {
                (this._width = this.container.offsetWidth),
                  (this._height = this.container.offsetHeight),
                  this._resize(),
                  this.canvas.setSize(this._width, this._height),
                  this._applyTransform();
              },
              coordsToPoint: function (e, t) {
                var n = R.maps[this.params.map].projection,
                  i = H[n.type](e, t, n.centralMeridian),
                  a = i.x,
                  r = i.y,
                  l = this.getInsetForPoint(a, r);
                if (!l) return !1;
                var o = l.bbox;
                return (
                  (a =
                    ((a - o[0].x) / (o[1].x - o[0].x)) * l.width * this.scale),
                  (r =
                    ((r - o[0].y) / (o[1].y - o[0].y)) * l.height * this.scale),
                  {
                    x: a + this.transX * this.scale + l.left * this.scale,
                    y: r + this.transY * this.scale + l.top * this.scale,
                  }
                );
              },
              getInsetForPoint: function (e, t) {
                for (
                  var n = R.maps[this.params.map].insets, i = 0;
                  i < n.length;
                  i++
                ) {
                  var a = n[i].bbox,
                    r = a[0],
                    l = a[1];
                  if (e > r.x && e < l.x && t > r.y && t < l.y) return n[i];
                }
              },
              getMarkerPosition: function (e) {
                var t = e.coords;
                return R.maps[this.params.map].projection
                  ? this.coordsToPoint.apply(this, t)
                  : {
                      x: t[0] * this.scale + this.transX * this.scale,
                      y: t[1] * this.scale + this.transY * this.scale,
                    };
              },
              _repositionLines: function () {
                var e = !1,
                  t = !1;
                for (var n in this._lines) {
                  for (var i in this._markers) {
                    var a = this._markers[i];
                    a.config.name === this._lines[n].config.from &&
                      (e = this.getMarkerPosition(a.config)),
                      a.config.name === this._lines[n].config.to &&
                        (t = this.getMarkerPosition(a.config));
                  }
                  !1 !== e &&
                    !1 !== t &&
                    this._lines[n].setStyle({
                      x1: e.x,
                      y1: e.y,
                      x2: t.x,
                      y2: t.y,
                    });
                }
              },
              _repositionMarkers: function () {
                for (var e in this._markers) {
                  var t = this.getMarkerPosition(this._markers[e].config);
                  !1 !== t &&
                    this._markers[e].element.setStyle({ cx: t.x, cy: t.y });
                }
              },
              _repositionLabels: function () {
                var e = this.params.labels;
                if (e) {
                  if (e.regions)
                    for (var t in this.regions)
                      this.regions[t].element.updateLabelPosition();
                  if (e.markers)
                    for (var n in this._markers)
                      this._markers[n].element.updateLabelPosition();
                }
              },
            },
            C = (function () {
              function e(e, t) {
                (this.node = this._createElement(e)), t && this.set(t);
              }
              var t = e.prototype;
              return (
                (t._createElement = function (e) {
                  return document.createElementNS(
                    "http://www.w3.org/2000/svg",
                    e
                  );
                }),
                (t.addClass = function (e) {
                  this.node.setAttribute("class", e);
                }),
                (t.getBBox = function () {
                  return this.node.getBBox();
                }),
                (t.set = function (e, t) {
                  if ("object" == typeof e)
                    for (var n in e) this.applyAttr(n, e[n]);
                  else this.applyAttr(e, t);
                }),
                (t.get = function (e) {
                  return this.style.initial[e];
                }),
                (t.applyAttr = function (e, t) {
                  this.node.setAttribute(
                    e
                      .replace(/[\w]([A-Z])/g, function (e) {
                        return e[0] + "-" + e[1];
                      })
                      .toLowerCase(),
                    t
                  );
                }),
                (t.remove = function () {
                  p(this.node);
                }),
                e
              );
            })(),
            P = (function (t) {
              function n(e, n, i) {
                var a;
                return (
                  void 0 === i && (i = {}),
                  ((a = t.call(this, e, n) || this).isHovered = !1),
                  (a.isSelected = !1),
                  (a.style = i),
                  (a.style.current = {}),
                  a.updateStyle(),
                  a
                );
              }
              e(n, t);
              var i = n.prototype;
              return (
                (i.setStyle = function (e, t) {
                  var n;
                  g(
                    this.style.current,
                    "object" == typeof e ? e : (((n = {})[e] = t), n)
                  ),
                    this.updateStyle();
                }),
                (i.updateStyle = function () {
                  var e = {};
                  g(e, this.style.initial),
                    g(e, this.style.current),
                    this.isHovered && g(e, this.style.hover),
                    this.isSelected &&
                      (g(e, this.style.selected),
                      this.isHovered && g(e, this.style.selectedHover)),
                    this.set(e);
                }),
                n
              );
            })(C),
            F = (function (t) {
              function n(e, n) {
                return t.call(this, "text", e, n) || this;
              }
              return (
                e(n, t),
                (n.prototype.applyAttr = function (e, n) {
                  "text" === e
                    ? (this.node.textContent = n)
                    : t.prototype.applyAttr.call(this, e, n);
                }),
                n
              );
            })(P),
            I = (function (t) {
              function n(e, n) {
                return t.call(this, "image", e, n) || this;
              }
              return (
                e(n, t),
                (n.prototype.applyAttr = function (e, n) {
                  var i;
                  "image" === e
                    ? ("object" == typeof n
                        ? ((i = n.url), (this.offset = n.offset || [0, 0]))
                        : ((i = n), (this.offset = [0, 0])),
                      this.node.setAttributeNS(
                        "http://www.w3.org/1999/xlink",
                        "href",
                        i
                      ),
                      (this.width = 23),
                      (this.height = 23),
                      this.applyAttr("width", this.width),
                      this.applyAttr("height", this.height),
                      this.applyAttr(
                        "x",
                        this.cx - this.width / 2 + this.offset[0]
                      ),
                      this.applyAttr(
                        "y",
                        this.cy - this.height / 2 + this.offset[1]
                      ))
                    : "cx" == e
                    ? ((this.cx = n),
                      this.width &&
                        this.applyAttr(
                          "x",
                          n - this.width / 2 + this.offset[0]
                        ))
                    : "cy" == e
                    ? ((this.cy = n),
                      this.height &&
                        this.applyAttr(
                          "y",
                          n - this.height / 2 + this.offset[1]
                        ))
                    : t.prototype.applyAttr.apply(this, arguments);
                }),
                n
              );
            })(P),
            W = (function (t) {
              function n(e) {
                var n;
                return (
                  ((n = t.call(this, "svg") || this)._container = e),
                  (n._defsElement = new C("defs")),
                  (n._rootElement = new C("g", { id: "jvm-regions-group" })),
                  n.node.appendChild(n._defsElement.node),
                  n.node.appendChild(n._rootElement.node),
                  n._container.appendChild(n.node),
                  n
                );
              }
              e(n, t);
              var i = n.prototype;
              return (
                (i.setSize = function (e, t) {
                  this.node.setAttribute("width", e),
                    this.node.setAttribute("height", t);
                }),
                (i.applyTransformParams = function (e, t, n) {
                  this._rootElement.node.setAttribute(
                    "transform",
                    "scale(" + e + ") translate(" + t + ", " + n + ")"
                  );
                }),
                (i.createPath = function (e, t) {
                  var n = new P("path", e, t);
                  return (
                    n.node.setAttribute("fill-rule", "evenodd"), this._add(n)
                  );
                }),
                (i.createCircle = function (e, t, n) {
                  var i = new P("circle", e, t);
                  return this._add(i, n);
                }),
                (i.createLine = function (e, t, n) {
                  var i = new P("line", e, t);
                  return this._add(i, n);
                }),
                (i.createText = function (e, t, n) {
                  var i = new F(e, t);
                  return this._add(i, n);
                }),
                (i.createImage = function (e, t, n) {
                  var i = new I(e, t);
                  return this._add(i, n);
                }),
                (i.createGroup = function (e) {
                  var t = new C("g");
                  return (
                    this.node.appendChild(t.node),
                    e && (t.node.id = e),
                    (t.canvas = this),
                    t
                  );
                }),
                (i._add = function (e, t) {
                  return (
                    (t = t || this._rootElement).node.appendChild(e.node), e
                  );
                }),
                n
              );
            })(C),
            z = (function (t) {
              function i(e) {
                var i;
                i = t.call(this) || this;
                var a = _("div", "jvm-tooltip");
                return (
                  (i._map = e),
                  (i._tooltip = document.body.appendChild(a)),
                  i._bindEventListeners(),
                  n(i) || n(i)
                );
              }
              e(i, t);
              var a = i.prototype;
              return (
                (a._bindEventListeners = function () {
                  var e = this;
                  x.on(this._map.container, "mousemove", function (t) {
                    if (e._tooltip.classList.contains("active")) {
                      var n,
                        i,
                        a = ((n = e._map.container),
                        (i = "#jvm-regions-group"),
                        Element.prototype.querySelector.call(
                          n,
                          i
                        )).getBoundingClientRect(),
                        r = e._tooltip.getBoundingClientRect(),
                        l = r.height,
                        o = r.width,
                        s = t.clientY <= a.top + l + 5,
                        d = t.pageY - l - 5,
                        u = t.pageX - o - 5;
                      s && ((d += l + 5), (u -= 10)),
                        t.clientX < a.left + o + 5 &&
                          ((u = t.pageX + 5 + 2), s && (u += 10)),
                        e.css({ top: d + "px", left: u + "px" });
                    }
                  });
                }),
                (a.getElement = function () {
                  return this._tooltip;
                }),
                (a.show = function () {
                  this._tooltip.classList.add("active");
                }),
                (a.hide = function () {
                  this._tooltip.classList.remove("active");
                }),
                (a.text = function (e, t) {
                  void 0 === t && (t = !1);
                  var n = t ? "innerHTML" : "textContent";
                  if (!e) return this._tooltip[n];
                  this._tooltip[n] = e;
                }),
                (a.css = function (e) {
                  for (var t in e) this._tooltip.style[t] = e[t];
                  return this;
                }),
                i
              );
            })(k),
            N = (function () {
              function e(e, t) {
                var n = e.scale,
                  i = e.values;
                (this._scale = n),
                  (this._values = i),
                  (this._fromColor = this.hexToRgb(n[0])),
                  (this._toColor = this.hexToRgb(n[1])),
                  (this._map = t),
                  this.setMinMaxValues(i),
                  this.visualize();
              }
              var t = e.prototype;
              return (
                (t.setMinMaxValues = function (e) {
                  for (var t in ((this.min = Number.MAX_VALUE),
                  (this.max = 0),
                  e))
                    (t = parseFloat(e[t])) > this.max && (this.max = t),
                      t < this.min && (this.min = t);
                }),
                (t.visualize = function () {
                  var e,
                    t = {};
                  for (var n in this._values)
                    (e = parseFloat(this._values[n])),
                      isNaN(e) || (t[n] = this.getValue(e));
                  this.setAttributes(t);
                }),
                (t.setAttributes = function (e) {
                  for (var t in e)
                    this._map.regions[t] &&
                      this._map.regions[t].element.setStyle("fill", e[t]);
                }),
                (t.getValue = function (e) {
                  for (var t, n = "#", i = 0; i < 3; i++)
                    n +=
                      (1 ===
                      (t = Math.round(
                        this._fromColor[i] +
                          (this._toColor[i] - this._fromColor[i]) *
                            ((e - this.min) / (this.max - this.min))
                      ).toString(16)).length
                        ? "0"
                        : "") + t;
                  return n;
                }),
                (t.hexToRgb = function (e) {
                  var t = 0,
                    n = 0,
                    i = 0;
                  return (
                    4 == e.length
                      ? ((t = "0x" + e[1] + e[1]),
                        (n = "0x" + e[2] + e[2]),
                        (i = "0x" + e[3] + e[3]))
                      : 7 == e.length &&
                        ((t = "0x" + e[1] + e[2]),
                        (n = "0x" + e[3] + e[4]),
                        (i = "0x" + e[5] + e[6])),
                    [parseInt(t), parseInt(n), parseInt(i)]
                  );
                }),
                e
              );
            })(),
            R = (function () {
              function e(t) {
                var n = this;
                if (
                  (void 0 === t && (t = {}),
                  (this.params = g(e.defaults, t, !0)),
                  !e.maps[this.params.map])
                )
                  throw new Error(
                    "Attempt to use map which was not loaded: " + t.map
                  );
                (this.regions = {}),
                  (this.scale = 1),
                  (this.transX = 0),
                  (this.transY = 0),
                  (this._mapData = e.maps[this.params.map]),
                  (this._markers = {}),
                  (this._lines = {}),
                  (this._defaultWidth = this._mapData.width),
                  (this._defaultHeight = this._mapData.height),
                  (this._height = 0),
                  (this._width = 0),
                  (this._baseScale = 1),
                  (this._baseTransX = 0),
                  (this._baseTransY = 0),
                  "loading" !== document.readyState
                    ? this._init()
                    : window.addEventListener("DOMContentLoaded", function () {
                        return n._init();
                      });
              }
              var t = e.prototype;
              return (
                (t._init = function () {
                  var e = this.params;
                  (this.container = f(e.selector)),
                    this.container.classList.add("jvm-container"),
                    (this.canvas = new W(this.container)),
                    this.setBackgroundColor(e.backgroundColor),
                    this._createRegions(),
                    this.updateSize(),
                    this._createLines(e.lines || {}, e.markers || {}),
                    this._createMarkers(e.markers),
                    this._repositionLabels(),
                    this._setupContainerEvents(),
                    this._setupElementEvents(),
                    e.zoomButtons && this._setupZoomButtons(),
                    e.showTooltip && (this._tooltip = new z(this)),
                    e.selectedRegions &&
                      this._setSelected("regions", e.selectedRegions),
                    e.selectedMarkers &&
                      this._setSelected("_markers", e.selectedMarkers),
                    e.focusOn && this.setFocus(e.focusOn),
                    e.visualizeData &&
                      (this.dataVisualization = new N(e.visualizeData, this)),
                    e.bindTouchEvents &&
                      ("ontouchstart" in window ||
                        (window.DocumentTouch &&
                          document instanceof DocumentTouch)) &&
                      this._setupContainerTouchEvents(),
                    e.series &&
                      (this.container.appendChild(
                        (this.legendHorizontal = _(
                          "div",
                          "jvm-series-container jvm-series-h"
                        ))
                      ),
                      this.container.appendChild(
                        (this.legendVertical = _(
                          "div",
                          "jvm-series-container jvm-series-v"
                        ))
                      ),
                      this._createSeries()),
                    this._emit(L.onLoaded, [this]);
                }),
                (t.setBackgroundColor = function (e) {
                  this.container.style.backgroundColor = e;
                }),
                (t.getSelectedRegions = function () {
                  return this._getSelected("regions");
                }),
                (t.clearSelectedRegions = function () {
                  this._clearSelected("regions");
                }),
                (t.getSelectedMarkers = function () {
                  return this._getSelected("_markers");
                }),
                (t.clearSelectedMarkers = function () {
                  this._clearSelected("_markers");
                }),
                (t.addMarkers = function (e) {
                  if (Array.isArray(e)) return this._createMarkers(e, !0);
                  this._createMarkers([e], !0);
                }),
                (t.removeMarkers = function (e) {
                  var t = this;
                  e || (e = Object.keys(this._markers)),
                    e.forEach(function (e) {
                      t._markers[e].element.remove(), delete t._markers[e];
                    });
                }),
                (t.addLine = function (e, t, n) {
                  void 0 === n && (n = {}),
                    console.warn(
                      "`addLine` method is deprecated, please use `addLines` instead."
                    ),
                    this._createLines(
                      [{ from: e, to: t, style: n }],
                      this._markers,
                      !0
                    );
                }),
                (t.addLines = function (e) {
                  var t = this._getLinesAsUids();
                  Array.isArray(e) || (e = [e]),
                    this._createLines(
                      e.filter(function (e) {
                        return !(t.indexOf(y(e.from, e.to)) > -1);
                      }),
                      this._markers,
                      !0
                    );
                }),
                (t.removeLines = function (e) {
                  var t = this;
                  (e = Array.isArray(e)
                    ? e.map(function (e) {
                        return y(e.from, e.to);
                      })
                    : this._getLinesAsUids()).forEach(function (e) {
                    t._lines[e].dispose(), delete t._lines[e];
                  });
                }),
                (t.removeLine = function (e, t) {
                  console.warn(
                    "`removeLine` method is deprecated, please use `removeLines` instead."
                  );
                  var n = y(e, t);
                  this._lines.hasOwnProperty(n) &&
                    (this._lines[n].element.remove(), delete this._lines[n]);
                }),
                (t.reset = function () {
                  for (var e in this.series)
                    for (var t = 0; t < this.series[e].length; t++)
                      this.series[e][t].clear();
                  this.legendHorizontal &&
                    (p(this.legendHorizontal), (this.legendHorizontal = null)),
                    this.legendVertical &&
                      (p(this.legendVertical), (this.legendVertical = null)),
                    (this.scale = this._baseScale),
                    (this.transX = this._baseTransX),
                    (this.transY = this._baseTransY),
                    this._applyTransform(),
                    this.clearSelectedMarkers(),
                    this.clearSelectedRegions(),
                    this.removeMarkers();
                }),
                (t.destroy = function (e) {
                  var t = this;
                  void 0 === e && (e = !0),
                    x.flush(),
                    this._tooltip.dispose(),
                    this._emit(L.onDestroyed),
                    e &&
                      Object.keys(this).forEach(function (e) {
                        try {
                          delete t[e];
                        } catch (e) {}
                      });
                }),
                (t.extend = function (t, n) {
                  if ("function" == typeof this[t])
                    throw new Error(
                      "The method [" +
                        t +
                        "] does already exist, please use another name."
                    );
                  e.prototype[t] = n;
                }),
                (t._emit = function (e, t) {
                  for (var n in L)
                    L[n] === e &&
                      "function" == typeof this.params[n] &&
                      this.params[n].apply(this, t);
                }),
                (t._getSelected = function (e) {
                  var t = [];
                  for (var n in this[e])
                    this[e][n].element.isSelected && t.push(n);
                  return t;
                }),
                (t._setSelected = function (e, t) {
                  var n = this;
                  t.forEach(function (t) {
                    n[e][t] && n[e][t].element.select(!0);
                  });
                }),
                (t._clearSelected = function (e) {
                  var t = this;
                  this._getSelected(e).forEach(function (n) {
                    t[e][n].element.select(!1);
                  });
                }),
                (t._getLinesAsUids = function () {
                  return Object.keys(this._lines);
                }),
                e
              );
            })();
          (R.maps = {}),
            (R.defaults = {
              map: "world",
              backgroundColor: "transparent",
              draggable: !0,
              zoomButtons: !0,
              zoomOnScroll: !0,
              zoomOnScrollSpeed: 3,
              zoomMax: 12,
              zoomMin: 1,
              zoomAnimate: !0,
              showTooltip: !0,
              zoomStep: 1.5,
              bindTouchEvents: !0,
              lineStyle: {
                stroke: "#808080",
                strokeWidth: 1,
                strokeLinecap: "round",
              },
              markersSelectable: !1,
              markersSelectableOne: !1,
              markerStyle: {
                initial: {
                  r: 7,
                  fill: "#374151",
                  fillOpacity: 1,
                  stroke: "#FFF",
                  strokeWidth: 5,
                  strokeOpacity: 0.5,
                },
                hover: { fill: "#3cc0ff", cursor: "pointer" },
                selected: { fill: "blue" },
                selectedHover: {},
              },
              markerLabelStyle: {
                initial: {
                  fontFamily: "Verdana",
                  fontSize: 12,
                  fontWeight: 500,
                  cursor: "default",
                  fill: "#374151",
                },
                hover: { cursor: "pointer" },
                selected: {},
                selectedHover: {},
              },
              regionsSelectable: !1,
              regionsSelectableOne: !1,
              regionStyle: {
                initial: {
                  fill: "#dee2e8",
                  fillOpacity: 1,
                  stroke: "none",
                  strokeWidth: 0,
                },
                hover: { fillOpacity: 0.7, cursor: "pointer" },
                selected: { fill: "#9ca3af" },
                selectedHover: {},
              },
              regionLabelStyle: {
                initial: {
                  fontFamily: "Verdana",
                  fontSize: "12",
                  fontWeight: "bold",
                  cursor: "default",
                  fill: "#35373e",
                },
                hover: { cursor: "pointer" },
              },
            }),
            Object.assign(R.prototype, E);
          var B = (function () {
            function e(e) {
              if ((void 0 === e && (e = {}), !e.selector))
                throw new Error("Selector is not given.");
              return new R(e);
            }
            return (
              (e.addMap = function (e, t) {
                R.maps[e] = t;
              }),
              e
            );
          })();
          return (window.jsVectorMap = B);
        })();
      },
      1296: function (e, t, n) {
        var i = NaN,
          a = "[object Symbol]",
          r = /^\s+|\s+$/g,
          l = /^[-+]0x[0-9a-f]+$/i,
          o = /^0b[01]+$/i,
          s = /^0o[0-7]+$/i,
          d = parseInt,
          u = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
          c = "object" == typeof self && self && self.Object === Object && self,
          h = u || c || Function("return this")(),
          m = Object.prototype.toString,
          f = Math.max,
          _ = Math.min,
          p = function () {
            return h.Date.now();
          };
        function g(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function y(e) {
          if ("number" == typeof e) return e;
          if (
            (function (e) {
              return (
                "symbol" == typeof e ||
                ((function (e) {
                  return !!e && "object" == typeof e;
                })(e) &&
                  m.call(e) == a)
              );
            })(e)
          )
            return i;
          if (g(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = g(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(r, "");
          var n = o.test(e);
          return n || s.test(e) ? d(e.slice(2), n ? 2 : 8) : l.test(e) ? i : +e;
        }
        e.exports = function (e, t, n) {
          var i,
            a,
            r,
            l,
            o,
            s,
            d = 0,
            u = !1,
            c = !1,
            h = !0;
          if ("function" != typeof e)
            throw new TypeError("Expected a function");
          function m(t) {
            var n = i,
              r = a;
            return (i = a = void 0), (d = t), (l = e.apply(r, n));
          }
          function v(e) {
            var n = e - s;
            return void 0 === s || n >= t || n < 0 || (c && e - d >= r);
          }
          function M() {
            var e = p();
            if (v(e)) return b(e);
            o = setTimeout(
              M,
              (function (e) {
                var n = t - (e - s);
                return c ? _(n, r - (e - d)) : n;
              })(e)
            );
          }
          function b(e) {
            return (o = void 0), h && i ? m(e) : ((i = a = void 0), l);
          }
          function x() {
            var e = p(),
              n = v(e);
            if (((i = arguments), (a = this), (s = e), n)) {
              if (void 0 === o)
                return (function (e) {
                  return (d = e), (o = setTimeout(M, t)), u ? m(e) : l;
                })(s);
              if (c) return (o = setTimeout(M, t)), m(s);
            }
            return void 0 === o && (o = setTimeout(M, t)), l;
          }
          return (
            (t = y(t) || 0),
            g(n) &&
              ((u = !!n.leading),
              (r = (c = "maxWait" in n) ? f(y(n.maxWait) || 0, t) : r),
              (h = "trailing" in n ? !!n.trailing : h)),
            (x.cancel = function () {
              void 0 !== o && clearTimeout(o),
                (d = 0),
                (i = s = a = o = void 0);
            }),
            (x.flush = function () {
              return void 0 === o ? l : b(p());
            }),
            x
          );
        };
      },
      773: function (e, t, n) {
        var i = "__lodash_hash_undefined__",
          a = "[object Function]",
          r = "[object GeneratorFunction]",
          l = /^\[object .+?Constructor\]$/,
          o = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
          s = "object" == typeof self && self && self.Object === Object && self,
          d = o || s || Function("return this")();
        var u,
          c = Array.prototype,
          h = Function.prototype,
          m = Object.prototype,
          f = d["__core-js_shared__"],
          _ = (u = /[^.]+$/.exec((f && f.keys && f.keys.IE_PROTO) || ""))
            ? "Symbol(src)_1." + u
            : "",
          p = h.toString,
          g = m.hasOwnProperty,
          y = m.toString,
          v = RegExp(
            "^" +
              p
                .call(g)
                .replace(/[\\^$.*+?()[\]{}|]/g, "\\$&")
                .replace(
                  /hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,
                  "$1.*?"
                ) +
              "$"
          ),
          M = c.splice,
          b = S(d, "Map"),
          x = S(Object, "create");
        function L(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var i = e[t];
            this.set(i[0], i[1]);
          }
        }
        function w(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var i = e[t];
            this.set(i[0], i[1]);
          }
        }
        function k(e) {
          var t = -1,
            n = e ? e.length : 0;
          for (this.clear(); ++t < n; ) {
            var i = e[t];
            this.set(i[0], i[1]);
          }
        }
        function Y(e, t) {
          for (var n, i, a = e.length; a--; )
            if ((n = e[a][0]) === (i = t) || (n != n && i != i)) return a;
          return -1;
        }
        function D(e) {
          if (!O(e) || ((t = e), _ && _ in t)) return !1;
          var t,
            n =
              (function (e) {
                var t = O(e) ? y.call(e) : "";
                return t == a || t == r;
              })(e) ||
              (function (e) {
                var t = !1;
                if (null != e && "function" != typeof e.toString)
                  try {
                    t = !!(e + "");
                  } catch (e) {}
                return t;
              })(e)
                ? v
                : l;
          return n.test(
            (function (e) {
              if (null != e) {
                try {
                  return p.call(e);
                } catch (e) {}
                try {
                  return e + "";
                } catch (e) {}
              }
              return "";
            })(e)
          );
        }
        function T(e, t) {
          var n,
            i,
            a = e.__data__;
          return (
            "string" == (i = typeof (n = t)) ||
            "number" == i ||
            "symbol" == i ||
            "boolean" == i
              ? "__proto__" !== n
              : null === n
          )
            ? a["string" == typeof t ? "string" : "hash"]
            : a.map;
        }
        function S(e, t) {
          var n = (function (e, t) {
            return null == e ? void 0 : e[t];
          })(e, t);
          return D(n) ? n : void 0;
        }
        function j(e, t) {
          if ("function" != typeof e || (t && "function" != typeof t))
            throw new TypeError("Expected a function");
          var n = function () {
            var i = arguments,
              a = t ? t.apply(this, i) : i[0],
              r = n.cache;
            if (r.has(a)) return r.get(a);
            var l = e.apply(this, i);
            return (n.cache = r.set(a, l)), l;
          };
          return (n.cache = new (j.Cache || k)()), n;
        }
        function O(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        (L.prototype.clear = function () {
          this.__data__ = x ? x(null) : {};
        }),
          (L.prototype.delete = function (e) {
            return this.has(e) && delete this.__data__[e];
          }),
          (L.prototype.get = function (e) {
            var t = this.__data__;
            if (x) {
              var n = t[e];
              return n === i ? void 0 : n;
            }
            return g.call(t, e) ? t[e] : void 0;
          }),
          (L.prototype.has = function (e) {
            var t = this.__data__;
            return x ? void 0 !== t[e] : g.call(t, e);
          }),
          (L.prototype.set = function (e, t) {
            return (this.__data__[e] = x && void 0 === t ? i : t), this;
          }),
          (w.prototype.clear = function () {
            this.__data__ = [];
          }),
          (w.prototype.delete = function (e) {
            var t = this.__data__,
              n = Y(t, e);
            return (
              !(n < 0) && (n == t.length - 1 ? t.pop() : M.call(t, n, 1), !0)
            );
          }),
          (w.prototype.get = function (e) {
            var t = this.__data__,
              n = Y(t, e);
            return n < 0 ? void 0 : t[n][1];
          }),
          (w.prototype.has = function (e) {
            return Y(this.__data__, e) > -1;
          }),
          (w.prototype.set = function (e, t) {
            var n = this.__data__,
              i = Y(n, e);
            return i < 0 ? n.push([e, t]) : (n[i][1] = t), this;
          }),
          (k.prototype.clear = function () {
            this.__data__ = {
              hash: new L(),
              map: new (b || w)(),
              string: new L(),
            };
          }),
          (k.prototype.delete = function (e) {
            return T(this, e).delete(e);
          }),
          (k.prototype.get = function (e) {
            return T(this, e).get(e);
          }),
          (k.prototype.has = function (e) {
            return T(this, e).has(e);
          }),
          (k.prototype.set = function (e, t) {
            return T(this, e).set(e, t), this;
          }),
          (j.Cache = k),
          (e.exports = j);
      },
      3096: function (e, t, n) {
        var i = "Expected a function",
          a = NaN,
          r = "[object Symbol]",
          l = /^\s+|\s+$/g,
          o = /^[-+]0x[0-9a-f]+$/i,
          s = /^0b[01]+$/i,
          d = /^0o[0-7]+$/i,
          u = parseInt,
          c = "object" == typeof n.g && n.g && n.g.Object === Object && n.g,
          h = "object" == typeof self && self && self.Object === Object && self,
          m = c || h || Function("return this")(),
          f = Object.prototype.toString,
          _ = Math.max,
          p = Math.min,
          g = function () {
            return m.Date.now();
          };
        function y(e, t, n) {
          var a,
            r,
            l,
            o,
            s,
            d,
            u = 0,
            c = !1,
            h = !1,
            m = !0;
          if ("function" != typeof e) throw new TypeError(i);
          function f(t) {
            var n = a,
              i = r;
            return (a = r = void 0), (u = t), (o = e.apply(i, n));
          }
          function y(e) {
            var n = e - d;
            return void 0 === d || n >= t || n < 0 || (h && e - u >= l);
          }
          function b() {
            var e = g();
            if (y(e)) return x(e);
            s = setTimeout(
              b,
              (function (e) {
                var n = t - (e - d);
                return h ? p(n, l - (e - u)) : n;
              })(e)
            );
          }
          function x(e) {
            return (s = void 0), m && a ? f(e) : ((a = r = void 0), o);
          }
          function L() {
            var e = g(),
              n = y(e);
            if (((a = arguments), (r = this), (d = e), n)) {
              if (void 0 === s)
                return (function (e) {
                  return (u = e), (s = setTimeout(b, t)), c ? f(e) : o;
                })(d);
              if (h) return (s = setTimeout(b, t)), f(d);
            }
            return void 0 === s && (s = setTimeout(b, t)), o;
          }
          return (
            (t = M(t) || 0),
            v(n) &&
              ((c = !!n.leading),
              (l = (h = "maxWait" in n) ? _(M(n.maxWait) || 0, t) : l),
              (m = "trailing" in n ? !!n.trailing : m)),
            (L.cancel = function () {
              void 0 !== s && clearTimeout(s),
                (u = 0),
                (a = d = r = s = void 0);
            }),
            (L.flush = function () {
              return void 0 === s ? o : x(g());
            }),
            L
          );
        }
        function v(e) {
          var t = typeof e;
          return !!e && ("object" == t || "function" == t);
        }
        function M(e) {
          if ("number" == typeof e) return e;
          if (
            (function (e) {
              return (
                "symbol" == typeof e ||
                ((function (e) {
                  return !!e && "object" == typeof e;
                })(e) &&
                  f.call(e) == r)
              );
            })(e)
          )
            return a;
          if (v(e)) {
            var t = "function" == typeof e.valueOf ? e.valueOf() : e;
            e = v(t) ? t + "" : t;
          }
          if ("string" != typeof e) return 0 === e ? e : +e;
          e = e.replace(l, "");
          var n = s.test(e);
          return n || d.test(e) ? u(e.slice(2), n ? 2 : 8) : o.test(e) ? a : +e;
        }
        e.exports = function (e, t, n) {
          var a = !0,
            r = !0;
          if ("function" != typeof e) throw new TypeError(i);
          return (
            v(n) &&
              ((a = "leading" in n ? !!n.leading : a),
              (r = "trailing" in n ? !!n.trailing : r)),
            y(e, t, { leading: a, maxWait: t, trailing: r })
          );
        };
      },
      2009: function (e, t, n) {
        !(function (e) {
          e.defineLocale("af", {
            months:
              "Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des".split("_"),
            weekdays:
              "Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag".split(
                "_"
              ),
            weekdaysShort: "Son_Maa_Din_Woe_Don_Vry_Sat".split("_"),
            weekdaysMin: "So_Ma_Di_Wo_Do_Vr_Sa".split("_"),
            meridiemParse: /vm|nm/i,
            isPM: function (e) {
              return /^nm$/i.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 12 ? (n ? "vm" : "VM") : n ? "nm" : "NM";
            },
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Vandag om] LT",
              nextDay: "[Môre om] LT",
              nextWeek: "dddd [om] LT",
              lastDay: "[Gister om] LT",
              lastWeek: "[Laas] dddd [om] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "oor %s",
              past: "%s gelede",
              s: "'n paar sekondes",
              ss: "%d sekondes",
              m: "'n minuut",
              mm: "%d minute",
              h: "'n uur",
              hh: "%d ure",
              d: "'n dag",
              dd: "%d dae",
              M: "'n maand",
              MM: "%d maande",
              y: "'n jaar",
              yy: "%d jaar",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function (e) {
              return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      4130: function (e, t, n) {
        !(function (e) {
          var t = function (e) {
              return 0 === e
                ? 0
                : 1 === e
                ? 1
                : 2 === e
                ? 2
                : e % 100 >= 3 && e % 100 <= 10
                ? 3
                : e % 100 >= 11
                ? 4
                : 5;
            },
            n = {
              s: [
                "أقل من ثانية",
                "ثانية واحدة",
                ["ثانيتان", "ثانيتين"],
                "%d ثوان",
                "%d ثانية",
                "%d ثانية",
              ],
              m: [
                "أقل من دقيقة",
                "دقيقة واحدة",
                ["دقيقتان", "دقيقتين"],
                "%d دقائق",
                "%d دقيقة",
                "%d دقيقة",
              ],
              h: [
                "أقل من ساعة",
                "ساعة واحدة",
                ["ساعتان", "ساعتين"],
                "%d ساعات",
                "%d ساعة",
                "%d ساعة",
              ],
              d: [
                "أقل من يوم",
                "يوم واحد",
                ["يومان", "يومين"],
                "%d أيام",
                "%d يومًا",
                "%d يوم",
              ],
              M: [
                "أقل من شهر",
                "شهر واحد",
                ["شهران", "شهرين"],
                "%d أشهر",
                "%d شهرا",
                "%d شهر",
              ],
              y: [
                "أقل من عام",
                "عام واحد",
                ["عامان", "عامين"],
                "%d أعوام",
                "%d عامًا",
                "%d عام",
              ],
            },
            i = function (e) {
              return function (i, a, r, l) {
                var o = t(i),
                  s = n[e][t(i)];
                return 2 === o && (s = s[a ? 0 : 1]), s.replace(/%d/i, i);
              };
            },
            a = [
              "جانفي",
              "فيفري",
              "مارس",
              "أفريل",
              "ماي",
              "جوان",
              "جويلية",
              "أوت",
              "سبتمبر",
              "أكتوبر",
              "نوفمبر",
              "ديسمبر",
            ];
          e.defineLocale("ar-dz", {
            months: a,
            monthsShort: a,
            weekdays:
              "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "D/‏M/‏YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            meridiemParse: /ص|م/,
            isPM: function (e) {
              return "م" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ص" : "م";
            },
            calendar: {
              sameDay: "[اليوم عند الساعة] LT",
              nextDay: "[غدًا عند الساعة] LT",
              nextWeek: "dddd [عند الساعة] LT",
              lastDay: "[أمس عند الساعة] LT",
              lastWeek: "dddd [عند الساعة] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "بعد %s",
              past: "منذ %s",
              s: i("s"),
              ss: i("s"),
              m: i("m"),
              mm: i("m"),
              h: i("h"),
              hh: i("h"),
              d: i("d"),
              dd: i("d"),
              M: i("M"),
              MM: i("M"),
              y: i("y"),
              yy: i("y"),
            },
            postformat: function (e) {
              return e.replace(/,/g, "،");
            },
            week: { dow: 0, doy: 4 },
          });
        })(n(381));
      },
      6135: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ar-kw", {
            months:
              "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split(
                "_"
              ),
            monthsShort:
              "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split(
                "_"
              ),
            weekdays:
              "الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[اليوم على الساعة] LT",
              nextDay: "[غدا على الساعة] LT",
              nextWeek: "dddd [على الساعة] LT",
              lastDay: "[أمس على الساعة] LT",
              lastWeek: "dddd [على الساعة] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "في %s",
              past: "منذ %s",
              s: "ثوان",
              ss: "%d ثانية",
              m: "دقيقة",
              mm: "%d دقائق",
              h: "ساعة",
              hh: "%d ساعات",
              d: "يوم",
              dd: "%d أيام",
              M: "شهر",
              MM: "%d أشهر",
              y: "سنة",
              yy: "%d سنوات",
            },
            week: { dow: 0, doy: 12 },
          });
        })(n(381));
      },
      6440: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "1",
              2: "2",
              3: "3",
              4: "4",
              5: "5",
              6: "6",
              7: "7",
              8: "8",
              9: "9",
              0: "0",
            },
            n = function (e) {
              return 0 === e
                ? 0
                : 1 === e
                ? 1
                : 2 === e
                ? 2
                : e % 100 >= 3 && e % 100 <= 10
                ? 3
                : e % 100 >= 11
                ? 4
                : 5;
            },
            i = {
              s: [
                "أقل من ثانية",
                "ثانية واحدة",
                ["ثانيتان", "ثانيتين"],
                "%d ثوان",
                "%d ثانية",
                "%d ثانية",
              ],
              m: [
                "أقل من دقيقة",
                "دقيقة واحدة",
                ["دقيقتان", "دقيقتين"],
                "%d دقائق",
                "%d دقيقة",
                "%d دقيقة",
              ],
              h: [
                "أقل من ساعة",
                "ساعة واحدة",
                ["ساعتان", "ساعتين"],
                "%d ساعات",
                "%d ساعة",
                "%d ساعة",
              ],
              d: [
                "أقل من يوم",
                "يوم واحد",
                ["يومان", "يومين"],
                "%d أيام",
                "%d يومًا",
                "%d يوم",
              ],
              M: [
                "أقل من شهر",
                "شهر واحد",
                ["شهران", "شهرين"],
                "%d أشهر",
                "%d شهرا",
                "%d شهر",
              ],
              y: [
                "أقل من عام",
                "عام واحد",
                ["عامان", "عامين"],
                "%d أعوام",
                "%d عامًا",
                "%d عام",
              ],
            },
            a = function (e) {
              return function (t, a, r, l) {
                var o = n(t),
                  s = i[e][n(t)];
                return 2 === o && (s = s[a ? 0 : 1]), s.replace(/%d/i, t);
              };
            },
            r = [
              "يناير",
              "فبراير",
              "مارس",
              "أبريل",
              "مايو",
              "يونيو",
              "يوليو",
              "أغسطس",
              "سبتمبر",
              "أكتوبر",
              "نوفمبر",
              "ديسمبر",
            ];
          e.defineLocale("ar-ly", {
            months: r,
            monthsShort: r,
            weekdays:
              "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "D/‏M/‏YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            meridiemParse: /ص|م/,
            isPM: function (e) {
              return "م" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ص" : "م";
            },
            calendar: {
              sameDay: "[اليوم عند الساعة] LT",
              nextDay: "[غدًا عند الساعة] LT",
              nextWeek: "dddd [عند الساعة] LT",
              lastDay: "[أمس عند الساعة] LT",
              lastWeek: "dddd [عند الساعة] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "بعد %s",
              past: "منذ %s",
              s: a("s"),
              ss: a("s"),
              m: a("m"),
              mm: a("m"),
              h: a("h"),
              hh: a("h"),
              d: a("d"),
              dd: a("d"),
              M: a("M"),
              MM: a("M"),
              y: a("y"),
              yy: a("y"),
            },
            preparse: function (e) {
              return e.replace(/،/g, ",");
            },
            postformat: function (e) {
              return e
                .replace(/\d/g, function (e) {
                  return t[e];
                })
                .replace(/,/g, "،");
            },
            week: { dow: 6, doy: 12 },
          });
        })(n(381));
      },
      7702: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ar-ma", {
            months:
              "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split(
                "_"
              ),
            monthsShort:
              "يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر".split(
                "_"
              ),
            weekdays:
              "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[اليوم على الساعة] LT",
              nextDay: "[غدا على الساعة] LT",
              nextWeek: "dddd [على الساعة] LT",
              lastDay: "[أمس على الساعة] LT",
              lastWeek: "dddd [على الساعة] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "في %s",
              past: "منذ %s",
              s: "ثوان",
              ss: "%d ثانية",
              m: "دقيقة",
              mm: "%d دقائق",
              h: "ساعة",
              hh: "%d ساعات",
              d: "يوم",
              dd: "%d أيام",
              M: "شهر",
              MM: "%d أشهر",
              y: "سنة",
              yy: "%d سنوات",
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      315: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "١",
              2: "٢",
              3: "٣",
              4: "٤",
              5: "٥",
              6: "٦",
              7: "٧",
              8: "٨",
              9: "٩",
              0: "٠",
            },
            n = {
              "١": "1",
              "٢": "2",
              "٣": "3",
              "٤": "4",
              "٥": "5",
              "٦": "6",
              "٧": "7",
              "٨": "8",
              "٩": "9",
              "٠": "0",
            };
          e.defineLocale("ar-ps", {
            months:
              "كانون الثاني_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_تشري الأوّل_تشرين الثاني_كانون الأوّل".split(
                "_"
              ),
            monthsShort:
              "ك٢_شباط_آذار_نيسان_أيّار_حزيران_تمّوز_آب_أيلول_ت١_ت٢_ك١".split(
                "_"
              ),
            weekdays:
              "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            meridiemParse: /ص|م/,
            isPM: function (e) {
              return "م" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ص" : "م";
            },
            calendar: {
              sameDay: "[اليوم على الساعة] LT",
              nextDay: "[غدا على الساعة] LT",
              nextWeek: "dddd [على الساعة] LT",
              lastDay: "[أمس على الساعة] LT",
              lastWeek: "dddd [على الساعة] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "في %s",
              past: "منذ %s",
              s: "ثوان",
              ss: "%d ثانية",
              m: "دقيقة",
              mm: "%d دقائق",
              h: "ساعة",
              hh: "%d ساعات",
              d: "يوم",
              dd: "%d أيام",
              M: "شهر",
              MM: "%d أشهر",
              y: "سنة",
              yy: "%d سنوات",
            },
            preparse: function (e) {
              return e
                .replace(/[٣٤٥٦٧٨٩٠]/g, function (e) {
                  return n[e];
                })
                .split("")
                .reverse()
                .join("")
                .replace(/[١٢](?![\u062a\u0643])/g, function (e) {
                  return n[e];
                })
                .split("")
                .reverse()
                .join("")
                .replace(/،/g, ",");
            },
            postformat: function (e) {
              return e
                .replace(/\d/g, function (e) {
                  return t[e];
                })
                .replace(/,/g, "،");
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      6040: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "١",
              2: "٢",
              3: "٣",
              4: "٤",
              5: "٥",
              6: "٦",
              7: "٧",
              8: "٨",
              9: "٩",
              0: "٠",
            },
            n = {
              "١": "1",
              "٢": "2",
              "٣": "3",
              "٤": "4",
              "٥": "5",
              "٦": "6",
              "٧": "7",
              "٨": "8",
              "٩": "9",
              "٠": "0",
            };
          e.defineLocale("ar-sa", {
            months:
              "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split(
                "_"
              ),
            monthsShort:
              "يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split(
                "_"
              ),
            weekdays:
              "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            meridiemParse: /ص|م/,
            isPM: function (e) {
              return "م" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ص" : "م";
            },
            calendar: {
              sameDay: "[اليوم على الساعة] LT",
              nextDay: "[غدا على الساعة] LT",
              nextWeek: "dddd [على الساعة] LT",
              lastDay: "[أمس على الساعة] LT",
              lastWeek: "dddd [على الساعة] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "في %s",
              past: "منذ %s",
              s: "ثوان",
              ss: "%d ثانية",
              m: "دقيقة",
              mm: "%d دقائق",
              h: "ساعة",
              hh: "%d ساعات",
              d: "يوم",
              dd: "%d أيام",
              M: "شهر",
              MM: "%d أشهر",
              y: "سنة",
              yy: "%d سنوات",
            },
            preparse: function (e) {
              return e
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                  return n[e];
                })
                .replace(/،/g, ",");
            },
            postformat: function (e) {
              return e
                .replace(/\d/g, function (e) {
                  return t[e];
                })
                .replace(/,/g, "،");
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      7100: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ar-tn", {
            months:
              "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split(
                "_"
              ),
            monthsShort:
              "جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر".split(
                "_"
              ),
            weekdays:
              "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[اليوم على الساعة] LT",
              nextDay: "[غدا على الساعة] LT",
              nextWeek: "dddd [على الساعة] LT",
              lastDay: "[أمس على الساعة] LT",
              lastWeek: "dddd [على الساعة] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "في %s",
              past: "منذ %s",
              s: "ثوان",
              ss: "%d ثانية",
              m: "دقيقة",
              mm: "%d دقائق",
              h: "ساعة",
              hh: "%d ساعات",
              d: "يوم",
              dd: "%d أيام",
              M: "شهر",
              MM: "%d أشهر",
              y: "سنة",
              yy: "%d سنوات",
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      867: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "١",
              2: "٢",
              3: "٣",
              4: "٤",
              5: "٥",
              6: "٦",
              7: "٧",
              8: "٨",
              9: "٩",
              0: "٠",
            },
            n = {
              "١": "1",
              "٢": "2",
              "٣": "3",
              "٤": "4",
              "٥": "5",
              "٦": "6",
              "٧": "7",
              "٨": "8",
              "٩": "9",
              "٠": "0",
            },
            i = function (e) {
              return 0 === e
                ? 0
                : 1 === e
                ? 1
                : 2 === e
                ? 2
                : e % 100 >= 3 && e % 100 <= 10
                ? 3
                : e % 100 >= 11
                ? 4
                : 5;
            },
            a = {
              s: [
                "أقل من ثانية",
                "ثانية واحدة",
                ["ثانيتان", "ثانيتين"],
                "%d ثوان",
                "%d ثانية",
                "%d ثانية",
              ],
              m: [
                "أقل من دقيقة",
                "دقيقة واحدة",
                ["دقيقتان", "دقيقتين"],
                "%d دقائق",
                "%d دقيقة",
                "%d دقيقة",
              ],
              h: [
                "أقل من ساعة",
                "ساعة واحدة",
                ["ساعتان", "ساعتين"],
                "%d ساعات",
                "%d ساعة",
                "%d ساعة",
              ],
              d: [
                "أقل من يوم",
                "يوم واحد",
                ["يومان", "يومين"],
                "%d أيام",
                "%d يومًا",
                "%d يوم",
              ],
              M: [
                "أقل من شهر",
                "شهر واحد",
                ["شهران", "شهرين"],
                "%d أشهر",
                "%d شهرا",
                "%d شهر",
              ],
              y: [
                "أقل من عام",
                "عام واحد",
                ["عامان", "عامين"],
                "%d أعوام",
                "%d عامًا",
                "%d عام",
              ],
            },
            r = function (e) {
              return function (t, n, r, l) {
                var o = i(t),
                  s = a[e][i(t)];
                return 2 === o && (s = s[n ? 0 : 1]), s.replace(/%d/i, t);
              };
            },
            l = [
              "يناير",
              "فبراير",
              "مارس",
              "أبريل",
              "مايو",
              "يونيو",
              "يوليو",
              "أغسطس",
              "سبتمبر",
              "أكتوبر",
              "نوفمبر",
              "ديسمبر",
            ];
          e.defineLocale("ar", {
            months: l,
            monthsShort: l,
            weekdays:
              "الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت".split("_"),
            weekdaysShort: "أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت".split("_"),
            weekdaysMin: "ح_ن_ث_ر_خ_ج_س".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "D/‏M/‏YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            meridiemParse: /ص|م/,
            isPM: function (e) {
              return "م" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ص" : "م";
            },
            calendar: {
              sameDay: "[اليوم عند الساعة] LT",
              nextDay: "[غدًا عند الساعة] LT",
              nextWeek: "dddd [عند الساعة] LT",
              lastDay: "[أمس عند الساعة] LT",
              lastWeek: "dddd [عند الساعة] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "بعد %s",
              past: "منذ %s",
              s: r("s"),
              ss: r("s"),
              m: r("m"),
              mm: r("m"),
              h: r("h"),
              hh: r("h"),
              d: r("d"),
              dd: r("d"),
              M: r("M"),
              MM: r("M"),
              y: r("y"),
              yy: r("y"),
            },
            preparse: function (e) {
              return e
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                  return n[e];
                })
                .replace(/،/g, ",");
            },
            postformat: function (e) {
              return e
                .replace(/\d/g, function (e) {
                  return t[e];
                })
                .replace(/,/g, "،");
            },
            week: { dow: 6, doy: 12 },
          });
        })(n(381));
      },
      1083: function (e, t, n) {
        !(function (e) {
          var t = {
            1: "-inci",
            5: "-inci",
            8: "-inci",
            70: "-inci",
            80: "-inci",
            2: "-nci",
            7: "-nci",
            20: "-nci",
            50: "-nci",
            3: "-üncü",
            4: "-üncü",
            100: "-üncü",
            6: "-ncı",
            9: "-uncu",
            10: "-uncu",
            30: "-uncu",
            60: "-ıncı",
            90: "-ıncı",
          };
          e.defineLocale("az", {
            months:
              "yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr".split(
                "_"
              ),
            monthsShort:
              "yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek".split("_"),
            weekdays:
              "Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə".split(
                "_"
              ),
            weekdaysShort: "Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən".split("_"),
            weekdaysMin: "Bz_BE_ÇA_Çə_CA_Cü_Şə".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[bugün saat] LT",
              nextDay: "[sabah saat] LT",
              nextWeek: "[gələn həftə] dddd [saat] LT",
              lastDay: "[dünən] LT",
              lastWeek: "[keçən həftə] dddd [saat] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s sonra",
              past: "%s əvvəl",
              s: "bir neçə saniyə",
              ss: "%d saniyə",
              m: "bir dəqiqə",
              mm: "%d dəqiqə",
              h: "bir saat",
              hh: "%d saat",
              d: "bir gün",
              dd: "%d gün",
              M: "bir ay",
              MM: "%d ay",
              y: "bir il",
              yy: "%d il",
            },
            meridiemParse: /gecə|səhər|gündüz|axşam/,
            isPM: function (e) {
              return /^(gündüz|axşam)$/.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "gecə"
                : e < 12
                ? "səhər"
                : e < 17
                ? "gündüz"
                : "axşam";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
            ordinal: function (e) {
              if (0 === e) return e + "-ıncı";
              var n = e % 10,
                i = (e % 100) - n,
                a = e >= 100 ? 100 : null;
              return e + (t[n] || t[i] || t[a]);
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      9808: function (e, t, n) {
        !(function (e) {
          function t(e, t) {
            var n = e.split("_");
            return t % 10 == 1 && t % 100 != 11
              ? n[0]
              : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20)
              ? n[1]
              : n[2];
          }
          function n(e, n, i) {
            return "m" === i
              ? n
                ? "хвіліна"
                : "хвіліну"
              : "h" === i
              ? n
                ? "гадзіна"
                : "гадзіну"
              : e +
                " " +
                t(
                  {
                    ss: n ? "секунда_секунды_секунд" : "секунду_секунды_секунд",
                    mm: n ? "хвіліна_хвіліны_хвілін" : "хвіліну_хвіліны_хвілін",
                    hh: n ? "гадзіна_гадзіны_гадзін" : "гадзіну_гадзіны_гадзін",
                    dd: "дзень_дні_дзён",
                    MM: "месяц_месяцы_месяцаў",
                    yy: "год_гады_гадоў",
                  }[i],
                  +e
                );
          }
          e.defineLocale("be", {
            months: {
              format:
                "студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня".split(
                  "_"
                ),
              standalone:
                "студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань".split(
                  "_"
                ),
            },
            monthsShort:
              "студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж".split(
                "_"
              ),
            weekdays: {
              format:
                "нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу".split(
                  "_"
                ),
              standalone:
                "нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота".split(
                  "_"
                ),
              isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
            },
            weekdaysShort: "нд_пн_ат_ср_чц_пт_сб".split("_"),
            weekdaysMin: "нд_пн_ат_ср_чц_пт_сб".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY г.",
              LLL: "D MMMM YYYY г., HH:mm",
              LLLL: "dddd, D MMMM YYYY г., HH:mm",
            },
            calendar: {
              sameDay: "[Сёння ў] LT",
              nextDay: "[Заўтра ў] LT",
              lastDay: "[Учора ў] LT",
              nextWeek: function () {
                return "[У] dddd [ў] LT";
              },
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                  case 3:
                  case 5:
                  case 6:
                    return "[У мінулую] dddd [ў] LT";
                  case 1:
                  case 2:
                  case 4:
                    return "[У мінулы] dddd [ў] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "праз %s",
              past: "%s таму",
              s: "некалькі секунд",
              m: n,
              mm: n,
              h: n,
              hh: n,
              d: "дзень",
              dd: n,
              M: "месяц",
              MM: n,
              y: "год",
              yy: n,
            },
            meridiemParse: /ночы|раніцы|дня|вечара/,
            isPM: function (e) {
              return /^(дня|вечара)$/.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "ночы"
                : e < 12
                ? "раніцы"
                : e < 17
                ? "дня"
                : "вечара";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
            ordinal: function (e, t) {
              switch (t) {
                case "M":
                case "d":
                case "DDD":
                case "w":
                case "W":
                  return (e % 10 != 2 && e % 10 != 3) ||
                    e % 100 == 12 ||
                    e % 100 == 13
                    ? e + "-ы"
                    : e + "-і";
                case "D":
                  return e + "-га";
                default:
                  return e;
              }
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      8338: function (e, t, n) {
        !(function (e) {
          e.defineLocale("bg", {
            months:
              "януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември".split(
                "_"
              ),
            monthsShort:
              "яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек".split("_"),
            weekdays:
              "неделя_понеделник_вторник_сряда_четвъртък_петък_събота".split(
                "_"
              ),
            weekdaysShort: "нед_пон_вто_сря_чет_пет_съб".split("_"),
            weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "D.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY H:mm",
              LLLL: "dddd, D MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[Днес в] LT",
              nextDay: "[Утре в] LT",
              nextWeek: "dddd [в] LT",
              lastDay: "[Вчера в] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                  case 3:
                  case 6:
                    return "[Миналата] dddd [в] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[Миналия] dddd [в] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "след %s",
              past: "преди %s",
              s: "няколко секунди",
              ss: "%d секунди",
              m: "минута",
              mm: "%d минути",
              h: "час",
              hh: "%d часа",
              d: "ден",
              dd: "%d дена",
              w: "седмица",
              ww: "%d седмици",
              M: "месец",
              MM: "%d месеца",
              y: "година",
              yy: "%d години",
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
            ordinal: function (e) {
              var t = e % 10,
                n = e % 100;
              return 0 === e
                ? e + "-ев"
                : 0 === n
                ? e + "-ен"
                : n > 10 && n < 20
                ? e + "-ти"
                : 1 === t
                ? e + "-ви"
                : 2 === t
                ? e + "-ри"
                : 7 === t || 8 === t
                ? e + "-ми"
                : e + "-ти";
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      7438: function (e, t, n) {
        !(function (e) {
          e.defineLocale("bm", {
            months:
              "Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo".split(
                "_"
              ),
            monthsShort: "Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des".split(
              "_"
            ),
            weekdays: "Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri".split("_"),
            weekdaysShort: "Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib".split("_"),
            weekdaysMin: "Ka_Nt_Ta_Ar_Al_Ju_Si".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "MMMM [tile] D [san] YYYY",
              LLL: "MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm",
              LLLL: "dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm",
            },
            calendar: {
              sameDay: "[Bi lɛrɛ] LT",
              nextDay: "[Sini lɛrɛ] LT",
              nextWeek: "dddd [don lɛrɛ] LT",
              lastDay: "[Kunu lɛrɛ] LT",
              lastWeek: "dddd [tɛmɛnen lɛrɛ] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s kɔnɔ",
              past: "a bɛ %s bɔ",
              s: "sanga dama dama",
              ss: "sekondi %d",
              m: "miniti kelen",
              mm: "miniti %d",
              h: "lɛrɛ kelen",
              hh: "lɛrɛ %d",
              d: "tile kelen",
              dd: "tile %d",
              M: "kalo kelen",
              MM: "kalo %d",
              y: "san kelen",
              yy: "san %d",
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      6225: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "১",
              2: "২",
              3: "৩",
              4: "৪",
              5: "৫",
              6: "৬",
              7: "৭",
              8: "৮",
              9: "৯",
              0: "০",
            },
            n = {
              "১": "1",
              "২": "2",
              "৩": "3",
              "৪": "4",
              "৫": "5",
              "৬": "6",
              "৭": "7",
              "৮": "8",
              "৯": "9",
              "০": "0",
            };
          e.defineLocale("bn-bd", {
            months:
              "জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split(
                "_"
              ),
            monthsShort:
              "জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split(
                "_"
              ),
            weekdays:
              "রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split(
                "_"
              ),
            weekdaysShort: "রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),
            weekdaysMin: "রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),
            longDateFormat: {
              LT: "A h:mm সময়",
              LTS: "A h:mm:ss সময়",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm সময়",
              LLLL: "dddd, D MMMM YYYY, A h:mm সময়",
            },
            calendar: {
              sameDay: "[আজ] LT",
              nextDay: "[আগামীকাল] LT",
              nextWeek: "dddd, LT",
              lastDay: "[গতকাল] LT",
              lastWeek: "[গত] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s পরে",
              past: "%s আগে",
              s: "কয়েক সেকেন্ড",
              ss: "%d সেকেন্ড",
              m: "এক মিনিট",
              mm: "%d মিনিট",
              h: "এক ঘন্টা",
              hh: "%d ঘন্টা",
              d: "এক দিন",
              dd: "%d দিন",
              M: "এক মাস",
              MM: "%d মাস",
              y: "এক বছর",
              yy: "%d বছর",
            },
            preparse: function (e) {
              return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "রাত" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "ভোর" === t || "সকাল" === t
                  ? e
                  : "দুপুর" === t
                  ? e >= 3
                    ? e
                    : e + 12
                  : "বিকাল" === t || "সন্ধ্যা" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "রাত"
                : e < 6
                ? "ভোর"
                : e < 12
                ? "সকাল"
                : e < 15
                ? "দুপুর"
                : e < 18
                ? "বিকাল"
                : e < 20
                ? "সন্ধ্যা"
                : "রাত";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      8905: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "১",
              2: "২",
              3: "৩",
              4: "৪",
              5: "৫",
              6: "৬",
              7: "৭",
              8: "৮",
              9: "৯",
              0: "০",
            },
            n = {
              "১": "1",
              "২": "2",
              "৩": "3",
              "৪": "4",
              "৫": "5",
              "৬": "6",
              "৭": "7",
              "৮": "8",
              "৯": "9",
              "০": "0",
            };
          e.defineLocale("bn", {
            months:
              "জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর".split(
                "_"
              ),
            monthsShort:
              "জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে".split(
                "_"
              ),
            weekdays:
              "রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার".split(
                "_"
              ),
            weekdaysShort: "রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি".split("_"),
            weekdaysMin: "রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি".split("_"),
            longDateFormat: {
              LT: "A h:mm সময়",
              LTS: "A h:mm:ss সময়",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm সময়",
              LLLL: "dddd, D MMMM YYYY, A h:mm সময়",
            },
            calendar: {
              sameDay: "[আজ] LT",
              nextDay: "[আগামীকাল] LT",
              nextWeek: "dddd, LT",
              lastDay: "[গতকাল] LT",
              lastWeek: "[গত] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s পরে",
              past: "%s আগে",
              s: "কয়েক সেকেন্ড",
              ss: "%d সেকেন্ড",
              m: "এক মিনিট",
              mm: "%d মিনিট",
              h: "এক ঘন্টা",
              hh: "%d ঘন্টা",
              d: "এক দিন",
              dd: "%d দিন",
              M: "এক মাস",
              MM: "%d মাস",
              y: "এক বছর",
              yy: "%d বছর",
            },
            preparse: function (e) {
              return e.replace(/[১২৩৪৫৬৭৮৯০]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                ("রাত" === t && e >= 4) ||
                ("দুপুর" === t && e < 5) ||
                "বিকাল" === t
                  ? e + 12
                  : e
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "রাত"
                : e < 10
                ? "সকাল"
                : e < 17
                ? "দুপুর"
                : e < 20
                ? "বিকাল"
                : "রাত";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      1560: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "༡",
              2: "༢",
              3: "༣",
              4: "༤",
              5: "༥",
              6: "༦",
              7: "༧",
              8: "༨",
              9: "༩",
              0: "༠",
            },
            n = {
              "༡": "1",
              "༢": "2",
              "༣": "3",
              "༤": "4",
              "༥": "5",
              "༦": "6",
              "༧": "7",
              "༨": "8",
              "༩": "9",
              "༠": "0",
            };
          e.defineLocale("bo", {
            months:
              "ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ".split(
                "_"
              ),
            monthsShort:
              "ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12".split(
                "_"
              ),
            monthsShortRegex: /^(ཟླ་\d{1,2})/,
            monthsParseExact: !0,
            weekdays:
              "གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་".split(
                "_"
              ),
            weekdaysShort:
              "ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་".split("_"),
            weekdaysMin: "ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན".split("_"),
            longDateFormat: {
              LT: "A h:mm",
              LTS: "A h:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm",
              LLLL: "dddd, D MMMM YYYY, A h:mm",
            },
            calendar: {
              sameDay: "[དི་རིང] LT",
              nextDay: "[སང་ཉིན] LT",
              nextWeek: "[བདུན་ཕྲག་རྗེས་མ], LT",
              lastDay: "[ཁ་སང] LT",
              lastWeek: "[བདུན་ཕྲག་མཐའ་མ] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s ལ་",
              past: "%s སྔན་ལ",
              s: "ལམ་སང",
              ss: "%d སྐར་ཆ།",
              m: "སྐར་མ་གཅིག",
              mm: "%d སྐར་མ",
              h: "ཆུ་ཚོད་གཅིག",
              hh: "%d ཆུ་ཚོད",
              d: "ཉིན་གཅིག",
              dd: "%d ཉིན་",
              M: "ཟླ་བ་གཅིག",
              MM: "%d ཟླ་བ",
              y: "ལོ་གཅིག",
              yy: "%d ལོ",
            },
            preparse: function (e) {
              return e.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                ("མཚན་མོ" === t && e >= 4) ||
                ("ཉིན་གུང" === t && e < 5) ||
                "དགོང་དག" === t
                  ? e + 12
                  : e
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "མཚན་མོ"
                : e < 10
                ? "ཞོགས་ཀས"
                : e < 17
                ? "ཉིན་གུང"
                : e < 20
                ? "དགོང་དག"
                : "མཚན་མོ";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      1278: function (e, t, n) {
        !(function (e) {
          function t(e, t, n) {
            return (
              e + " " + a({ mm: "munutenn", MM: "miz", dd: "devezh" }[n], e)
            );
          }
          function n(e) {
            switch (i(e)) {
              case 1:
              case 3:
              case 4:
              case 5:
              case 9:
                return e + " bloaz";
              default:
                return e + " vloaz";
            }
          }
          function i(e) {
            return e > 9 ? i(e % 10) : e;
          }
          function a(e, t) {
            return 2 === t ? r(e) : e;
          }
          function r(e) {
            var t = { m: "v", b: "v", d: "z" };
            return void 0 === t[e.charAt(0)]
              ? e
              : t[e.charAt(0)] + e.substring(1);
          }
          var l = [
              /^gen/i,
              /^c[ʼ\']hwe/i,
              /^meu/i,
              /^ebr/i,
              /^mae/i,
              /^(mez|eve)/i,
              /^gou/i,
              /^eos/i,
              /^gwe/i,
              /^her/i,
              /^du/i,
              /^ker/i,
            ],
            o =
              /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
            s =
              /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
            d = /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
            u = [
              /^sul/i,
              /^lun/i,
              /^meurzh/i,
              /^merc[ʼ\']her/i,
              /^yaou/i,
              /^gwener/i,
              /^sadorn/i,
            ],
            c = [/^Sul/i, /^Lun/i, /^Meu/i, /^Mer/i, /^Yao/i, /^Gwe/i, /^Sad/i],
            h = [
              /^Su/i,
              /^Lu/i,
              /^Me([^r]|$)/i,
              /^Mer/i,
              /^Ya/i,
              /^Gw/i,
              /^Sa/i,
            ];
          e.defineLocale("br", {
            months:
              "Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu".split(
                "_"
              ),
            monthsShort:
              "Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker".split("_"),
            weekdays: "Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn".split("_"),
            weekdaysShort: "Sul_Lun_Meu_Mer_Yao_Gwe_Sad".split("_"),
            weekdaysMin: "Su_Lu_Me_Mer_Ya_Gw_Sa".split("_"),
            weekdaysParse: h,
            fullWeekdaysParse: u,
            shortWeekdaysParse: c,
            minWeekdaysParse: h,
            monthsRegex: o,
            monthsShortRegex: o,
            monthsStrictRegex: s,
            monthsShortStrictRegex: d,
            monthsParse: l,
            longMonthsParse: l,
            shortMonthsParse: l,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D [a viz] MMMM YYYY",
              LLL: "D [a viz] MMMM YYYY HH:mm",
              LLLL: "dddd, D [a viz] MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Hiziv da] LT",
              nextDay: "[Warcʼhoazh da] LT",
              nextWeek: "dddd [da] LT",
              lastDay: "[Decʼh da] LT",
              lastWeek: "dddd [paset da] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "a-benn %s",
              past: "%s ʼzo",
              s: "un nebeud segondennoù",
              ss: "%d eilenn",
              m: "ur vunutenn",
              mm: t,
              h: "un eur",
              hh: "%d eur",
              d: "un devezh",
              dd: t,
              M: "ur miz",
              MM: t,
              y: "ur bloaz",
              yy: n,
            },
            dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
            ordinal: function (e) {
              return e + (1 === e ? "añ" : "vet");
            },
            week: { dow: 1, doy: 4 },
            meridiemParse: /a.m.|g.m./,
            isPM: function (e) {
              return "g.m." === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "a.m." : "g.m.";
            },
          });
        })(n(381));
      },
      622: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            if ("m" === n)
              return t ? "jedna minuta" : i ? "jednu minutu" : "jedne minute";
          }
          function n(e, t, n) {
            var i = e + " ";
            switch (n) {
              case "ss":
                return (i +=
                  1 === e
                    ? "sekunda"
                    : 2 === e || 3 === e || 4 === e
                    ? "sekunde"
                    : "sekundi");
              case "mm":
                return (i +=
                  1 === e
                    ? "minuta"
                    : 2 === e || 3 === e || 4 === e
                    ? "minute"
                    : "minuta");
              case "h":
                return "jedan sat";
              case "hh":
                return (i +=
                  1 === e
                    ? "sat"
                    : 2 === e || 3 === e || 4 === e
                    ? "sata"
                    : "sati");
              case "dd":
                return (i += 1 === e ? "dan" : "dana");
              case "MM":
                return (i +=
                  1 === e
                    ? "mjesec"
                    : 2 === e || 3 === e || 4 === e
                    ? "mjeseca"
                    : "mjeseci");
              case "yy":
                return (i +=
                  1 === e
                    ? "godina"
                    : 2 === e || 3 === e || 4 === e
                    ? "godine"
                    : "godina");
            }
          }
          e.defineLocale("bs", {
            months:
              "januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar".split(
                "_"
              ),
            monthsShort:
              "jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split(
                "_"
              ),
            weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY H:mm",
              LLLL: "dddd, D. MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[danas u] LT",
              nextDay: "[sutra u] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[u] [nedjelju] [u] LT";
                  case 3:
                    return "[u] [srijedu] [u] LT";
                  case 6:
                    return "[u] [subotu] [u] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[u] dddd [u] LT";
                }
              },
              lastDay: "[jučer u] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                  case 3:
                    return "[prošlu] dddd [u] LT";
                  case 6:
                    return "[prošle] [subote] [u] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[prošli] dddd [u] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "za %s",
              past: "prije %s",
              s: "par sekundi",
              ss: n,
              m: t,
              mm: n,
              h: n,
              hh: n,
              d: "dan",
              dd: n,
              M: "mjesec",
              MM: n,
              y: "godinu",
              yy: n,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      2468: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ca", {
            months: {
              standalone:
                "gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre".split(
                  "_"
                ),
              format:
                "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                  "_"
                ),
              isFormat: /D[oD]?(\s)+MMMM/,
            },
            monthsShort:
              "gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte".split(
                "_"
              ),
            weekdaysShort: "dg._dl._dt._dc._dj._dv._ds.".split("_"),
            weekdaysMin: "dg_dl_dt_dc_dj_dv_ds".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM [de] YYYY",
              ll: "D MMM YYYY",
              LLL: "D MMMM [de] YYYY [a les] H:mm",
              lll: "D MMM YYYY, H:mm",
              LLLL: "dddd D MMMM [de] YYYY [a les] H:mm",
              llll: "ddd D MMM YYYY, H:mm",
            },
            calendar: {
              sameDay: function () {
                return (
                  "[avui a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                );
              },
              nextDay: function () {
                return (
                  "[demà a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                );
              },
              nextWeek: function () {
                return (
                  "dddd [a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                );
              },
              lastDay: function () {
                return (
                  "[ahir a " + (1 !== this.hours() ? "les" : "la") + "] LT"
                );
              },
              lastWeek: function () {
                return (
                  "[el] dddd [passat a " +
                  (1 !== this.hours() ? "les" : "la") +
                  "] LT"
                );
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "d'aquí %s",
              past: "fa %s",
              s: "uns segons",
              ss: "%d segons",
              m: "un minut",
              mm: "%d minuts",
              h: "una hora",
              hh: "%d hores",
              d: "un dia",
              dd: "%d dies",
              M: "un mes",
              MM: "%d mesos",
              y: "un any",
              yy: "%d anys",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
            ordinal: function (e, t) {
              var n =
                1 === e
                  ? "r"
                  : 2 === e
                  ? "n"
                  : 3 === e
                  ? "r"
                  : 4 === e
                  ? "t"
                  : "è";
              return ("w" !== t && "W" !== t) || (n = "a"), e + n;
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      5822: function (e, t, n) {
        !(function (e) {
          var t = {
              standalone:
                "leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec".split(
                  "_"
                ),
              format:
                "ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince".split(
                  "_"
                ),
              isFormat: /DD?[o.]?(\[[^\[\]]*\]|\s)+MMMM/,
            },
            n = "led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro".split("_"),
            i = [
              /^led/i,
              /^úno/i,
              /^bře/i,
              /^dub/i,
              /^kvě/i,
              /^(čvn|červen$|června)/i,
              /^(čvc|červenec|července)/i,
              /^srp/i,
              /^zář/i,
              /^říj/i,
              /^lis/i,
              /^pro/i,
            ],
            a =
              /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;
          function r(e) {
            return e > 1 && e < 5 && 1 != ~~(e / 10);
          }
          function l(e, t, n, i) {
            var a = e + " ";
            switch (n) {
              case "s":
                return t || i ? "pár sekund" : "pár sekundami";
              case "ss":
                return t || i
                  ? a + (r(e) ? "sekundy" : "sekund")
                  : a + "sekundami";
              case "m":
                return t ? "minuta" : i ? "minutu" : "minutou";
              case "mm":
                return t || i
                  ? a + (r(e) ? "minuty" : "minut")
                  : a + "minutami";
              case "h":
                return t ? "hodina" : i ? "hodinu" : "hodinou";
              case "hh":
                return t || i
                  ? a + (r(e) ? "hodiny" : "hodin")
                  : a + "hodinami";
              case "d":
                return t || i ? "den" : "dnem";
              case "dd":
                return t || i ? a + (r(e) ? "dny" : "dní") : a + "dny";
              case "M":
                return t || i ? "měsíc" : "měsícem";
              case "MM":
                return t || i ? a + (r(e) ? "měsíce" : "měsíců") : a + "měsíci";
              case "y":
                return t || i ? "rok" : "rokem";
              case "yy":
                return t || i ? a + (r(e) ? "roky" : "let") : a + "lety";
            }
          }
          e.defineLocale("cs", {
            months: t,
            monthsShort: n,
            monthsRegex: a,
            monthsShortRegex: a,
            monthsStrictRegex:
              /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
            monthsShortStrictRegex:
              /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays: "neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota".split(
              "_"
            ),
            weekdaysShort: "ne_po_út_st_čt_pá_so".split("_"),
            weekdaysMin: "ne_po_út_st_čt_pá_so".split("_"),
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY H:mm",
              LLLL: "dddd D. MMMM YYYY H:mm",
              l: "D. M. YYYY",
            },
            calendar: {
              sameDay: "[dnes v] LT",
              nextDay: "[zítra v] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[v neděli v] LT";
                  case 1:
                  case 2:
                    return "[v] dddd [v] LT";
                  case 3:
                    return "[ve středu v] LT";
                  case 4:
                    return "[ve čtvrtek v] LT";
                  case 5:
                    return "[v pátek v] LT";
                  case 6:
                    return "[v sobotu v] LT";
                }
              },
              lastDay: "[včera v] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[minulou neděli v] LT";
                  case 1:
                  case 2:
                    return "[minulé] dddd [v] LT";
                  case 3:
                    return "[minulou středu v] LT";
                  case 4:
                  case 5:
                    return "[minulý] dddd [v] LT";
                  case 6:
                    return "[minulou sobotu v] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "za %s",
              past: "před %s",
              s: l,
              ss: l,
              m: l,
              mm: l,
              h: l,
              hh: l,
              d: l,
              dd: l,
              M: l,
              MM: l,
              y: l,
              yy: l,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      877: function (e, t, n) {
        !(function (e) {
          e.defineLocale("cv", {
            months:
              "кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав".split(
                "_"
              ),
            monthsShort:
              "кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш".split("_"),
            weekdays:
              "вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун".split(
                "_"
              ),
            weekdaysShort: "выр_тун_ытл_юн_кӗҫ_эрн_шӑм".split("_"),
            weekdaysMin: "вр_тн_ыт_юн_кҫ_эр_шм".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD-MM-YYYY",
              LL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]",
              LLL: "YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",
              LLLL: "dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm",
            },
            calendar: {
              sameDay: "[Паян] LT [сехетре]",
              nextDay: "[Ыран] LT [сехетре]",
              lastDay: "[Ӗнер] LT [сехетре]",
              nextWeek: "[Ҫитес] dddd LT [сехетре]",
              lastWeek: "[Иртнӗ] dddd LT [сехетре]",
              sameElse: "L",
            },
            relativeTime: {
              future: function (e) {
                return (
                  e +
                  (/сехет$/i.exec(e) ? "рен" : /ҫул$/i.exec(e) ? "тан" : "ран")
                );
              },
              past: "%s каялла",
              s: "пӗр-ик ҫеккунт",
              ss: "%d ҫеккунт",
              m: "пӗр минут",
              mm: "%d минут",
              h: "пӗр сехет",
              hh: "%d сехет",
              d: "пӗр кун",
              dd: "%d кун",
              M: "пӗр уйӑх",
              MM: "%d уйӑх",
              y: "пӗр ҫул",
              yy: "%d ҫул",
            },
            dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
            ordinal: "%d-мӗш",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      7373: function (e, t, n) {
        !(function (e) {
          e.defineLocale("cy", {
            months:
              "Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr".split(
                "_"
              ),
            monthsShort:
              "Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag".split("_"),
            weekdays:
              "Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn".split(
                "_"
              ),
            weekdaysShort: "Sul_Llun_Maw_Mer_Iau_Gwe_Sad".split("_"),
            weekdaysMin: "Su_Ll_Ma_Me_Ia_Gw_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Heddiw am] LT",
              nextDay: "[Yfory am] LT",
              nextWeek: "dddd [am] LT",
              lastDay: "[Ddoe am] LT",
              lastWeek: "dddd [diwethaf am] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "mewn %s",
              past: "%s yn ôl",
              s: "ychydig eiliadau",
              ss: "%d eiliad",
              m: "munud",
              mm: "%d munud",
              h: "awr",
              hh: "%d awr",
              d: "diwrnod",
              dd: "%d diwrnod",
              M: "mis",
              MM: "%d mis",
              y: "blwyddyn",
              yy: "%d flynedd",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
            ordinal: function (e) {
              var t = "";
              return (
                e > 20
                  ? (t =
                      40 === e || 50 === e || 60 === e || 80 === e || 100 === e
                        ? "fed"
                        : "ain")
                  : e > 0 &&
                    (t = [
                      "",
                      "af",
                      "il",
                      "ydd",
                      "ydd",
                      "ed",
                      "ed",
                      "ed",
                      "fed",
                      "fed",
                      "fed",
                      "eg",
                      "fed",
                      "eg",
                      "eg",
                      "fed",
                      "eg",
                      "eg",
                      "fed",
                      "eg",
                      "fed",
                    ][e]),
                e + t
              );
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      4780: function (e, t, n) {
        !(function (e) {
          e.defineLocale("da", {
            months:
              "januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december".split(
                "_"
              ),
            monthsShort:
              "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
            weekdays:
              "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
            weekdaysShort: "søn_man_tir_ons_tor_fre_lør".split("_"),
            weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY HH:mm",
              LLLL: "dddd [d.] D. MMMM YYYY [kl.] HH:mm",
            },
            calendar: {
              sameDay: "[i dag kl.] LT",
              nextDay: "[i morgen kl.] LT",
              nextWeek: "på dddd [kl.] LT",
              lastDay: "[i går kl.] LT",
              lastWeek: "[i] dddd[s kl.] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "om %s",
              past: "%s siden",
              s: "få sekunder",
              ss: "%d sekunder",
              m: "et minut",
              mm: "%d minutter",
              h: "en time",
              hh: "%d timer",
              d: "en dag",
              dd: "%d dage",
              M: "en måned",
              MM: "%d måneder",
              y: "et år",
              yy: "%d år",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      217: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              m: ["eine Minute", "einer Minute"],
              h: ["eine Stunde", "einer Stunde"],
              d: ["ein Tag", "einem Tag"],
              dd: [e + " Tage", e + " Tagen"],
              w: ["eine Woche", "einer Woche"],
              M: ["ein Monat", "einem Monat"],
              MM: [e + " Monate", e + " Monaten"],
              y: ["ein Jahr", "einem Jahr"],
              yy: [e + " Jahre", e + " Jahren"],
            };
            return t ? a[n][0] : a[n][1];
          }
          e.defineLocale("de-at", {
            months:
              "Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
                "_"
              ),
            monthsShort:
              "Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
                "_"
              ),
            weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY HH:mm",
              LLLL: "dddd, D. MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[heute um] LT [Uhr]",
              sameElse: "L",
              nextDay: "[morgen um] LT [Uhr]",
              nextWeek: "dddd [um] LT [Uhr]",
              lastDay: "[gestern um] LT [Uhr]",
              lastWeek: "[letzten] dddd [um] LT [Uhr]",
            },
            relativeTime: {
              future: "in %s",
              past: "vor %s",
              s: "ein paar Sekunden",
              ss: "%d Sekunden",
              m: t,
              mm: "%d Minuten",
              h: t,
              hh: "%d Stunden",
              d: t,
              dd: t,
              w: t,
              ww: "%d Wochen",
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      894: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              m: ["eine Minute", "einer Minute"],
              h: ["eine Stunde", "einer Stunde"],
              d: ["ein Tag", "einem Tag"],
              dd: [e + " Tage", e + " Tagen"],
              w: ["eine Woche", "einer Woche"],
              M: ["ein Monat", "einem Monat"],
              MM: [e + " Monate", e + " Monaten"],
              y: ["ein Jahr", "einem Jahr"],
              yy: [e + " Jahre", e + " Jahren"],
            };
            return t ? a[n][0] : a[n][1];
          }
          e.defineLocale("de-ch", {
            months:
              "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
                "_"
              ),
            monthsShort:
              "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
                "_"
              ),
            weekdaysShort: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY HH:mm",
              LLLL: "dddd, D. MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[heute um] LT [Uhr]",
              sameElse: "L",
              nextDay: "[morgen um] LT [Uhr]",
              nextWeek: "dddd [um] LT [Uhr]",
              lastDay: "[gestern um] LT [Uhr]",
              lastWeek: "[letzten] dddd [um] LT [Uhr]",
            },
            relativeTime: {
              future: "in %s",
              past: "vor %s",
              s: "ein paar Sekunden",
              ss: "%d Sekunden",
              m: t,
              mm: "%d Minuten",
              h: t,
              hh: "%d Stunden",
              d: t,
              dd: t,
              w: t,
              ww: "%d Wochen",
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      9740: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              m: ["eine Minute", "einer Minute"],
              h: ["eine Stunde", "einer Stunde"],
              d: ["ein Tag", "einem Tag"],
              dd: [e + " Tage", e + " Tagen"],
              w: ["eine Woche", "einer Woche"],
              M: ["ein Monat", "einem Monat"],
              MM: [e + " Monate", e + " Monaten"],
              y: ["ein Jahr", "einem Jahr"],
              yy: [e + " Jahre", e + " Jahren"],
            };
            return t ? a[n][0] : a[n][1];
          }
          e.defineLocale("de", {
            months:
              "Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember".split(
                "_"
              ),
            monthsShort:
              "Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag".split(
                "_"
              ),
            weekdaysShort: "So._Mo._Di._Mi._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mo_Di_Mi_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY HH:mm",
              LLLL: "dddd, D. MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[heute um] LT [Uhr]",
              sameElse: "L",
              nextDay: "[morgen um] LT [Uhr]",
              nextWeek: "dddd [um] LT [Uhr]",
              lastDay: "[gestern um] LT [Uhr]",
              lastWeek: "[letzten] dddd [um] LT [Uhr]",
            },
            relativeTime: {
              future: "in %s",
              past: "vor %s",
              s: "ein paar Sekunden",
              ss: "%d Sekunden",
              m: t,
              mm: "%d Minuten",
              h: t,
              hh: "%d Stunden",
              d: t,
              dd: t,
              w: t,
              ww: "%d Wochen",
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      5300: function (e, t, n) {
        !(function (e) {
          var t = [
              "ޖެނުއަރީ",
              "ފެބްރުއަރީ",
              "މާރިޗު",
              "އޭޕްރީލު",
              "މޭ",
              "ޖޫން",
              "ޖުލައި",
              "އޯގަސްޓު",
              "ސެޕްޓެމްބަރު",
              "އޮކްޓޯބަރު",
              "ނޮވެމްބަރު",
              "ޑިސެމްބަރު",
            ],
            n = [
              "އާދިއްތަ",
              "ހޯމަ",
              "އަންގާރަ",
              "ބުދަ",
              "ބުރާސްފަތި",
              "ހުކުރު",
              "ހޮނިހިރު",
            ];
          e.defineLocale("dv", {
            months: t,
            monthsShort: t,
            weekdays: n,
            weekdaysShort: n,
            weekdaysMin: "އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "D/M/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            meridiemParse: /މކ|މފ/,
            isPM: function (e) {
              return "މފ" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "މކ" : "މފ";
            },
            calendar: {
              sameDay: "[މިއަދު] LT",
              nextDay: "[މާދަމާ] LT",
              nextWeek: "dddd LT",
              lastDay: "[އިއްޔެ] LT",
              lastWeek: "[ފާއިތުވި] dddd LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "ތެރޭގައި %s",
              past: "ކުރިން %s",
              s: "ސިކުންތުކޮޅެއް",
              ss: "d% ސިކުންތު",
              m: "މިނިޓެއް",
              mm: "މިނިޓު %d",
              h: "ގަޑިއިރެއް",
              hh: "ގަޑިއިރު %d",
              d: "ދުވަހެއް",
              dd: "ދުވަސް %d",
              M: "މަހެއް",
              MM: "މަސް %d",
              y: "އަހަރެއް",
              yy: "އަހަރު %d",
            },
            preparse: function (e) {
              return e.replace(/،/g, ",");
            },
            postformat: function (e) {
              return e.replace(/,/g, "،");
            },
            week: { dow: 7, doy: 12 },
          });
        })(n(381));
      },
      837: function (e, t, n) {
        !(function (e) {
          function t(e) {
            return (
              ("undefined" != typeof Function && e instanceof Function) ||
              "[object Function]" === Object.prototype.toString.call(e)
            );
          }
          e.defineLocale("el", {
            monthsNominativeEl:
              "Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος".split(
                "_"
              ),
            monthsGenitiveEl:
              "Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου".split(
                "_"
              ),
            months: function (e, t) {
              return e
                ? "string" == typeof t &&
                  /D/.test(t.substring(0, t.indexOf("MMMM")))
                  ? this._monthsGenitiveEl[e.month()]
                  : this._monthsNominativeEl[e.month()]
                : this._monthsNominativeEl;
            },
            monthsShort:
              "Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ".split("_"),
            weekdays:
              "Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο".split(
                "_"
              ),
            weekdaysShort: "Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ".split("_"),
            weekdaysMin: "Κυ_Δε_Τρ_Τε_Πε_Πα_Σα".split("_"),
            meridiem: function (e, t, n) {
              return e > 11 ? (n ? "μμ" : "ΜΜ") : n ? "πμ" : "ΠΜ";
            },
            isPM: function (e) {
              return "μ" === (e + "").toLowerCase()[0];
            },
            meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY h:mm A",
              LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendarEl: {
              sameDay: "[Σήμερα {}] LT",
              nextDay: "[Αύριο {}] LT",
              nextWeek: "dddd [{}] LT",
              lastDay: "[Χθες {}] LT",
              lastWeek: function () {
                return 6 === this.day()
                  ? "[το προηγούμενο] dddd [{}] LT"
                  : "[την προηγούμενη] dddd [{}] LT";
              },
              sameElse: "L",
            },
            calendar: function (e, n) {
              var i = this._calendarEl[e],
                a = n && n.hours();
              return (
                t(i) && (i = i.apply(n)),
                i.replace("{}", a % 12 == 1 ? "στη" : "στις")
              );
            },
            relativeTime: {
              future: "σε %s",
              past: "%s πριν",
              s: "λίγα δευτερόλεπτα",
              ss: "%d δευτερόλεπτα",
              m: "ένα λεπτό",
              mm: "%d λεπτά",
              h: "μία ώρα",
              hh: "%d ώρες",
              d: "μία μέρα",
              dd: "%d μέρες",
              M: "ένας μήνας",
              MM: "%d μήνες",
              y: "ένας χρόνος",
              yy: "%d χρόνια",
            },
            dayOfMonthOrdinalParse: /\d{1,2}η/,
            ordinal: "%dη",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      8348: function (e, t, n) {
        !(function (e) {
          e.defineLocale("en-au", {
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY h:mm A",
              LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
            week: { dow: 0, doy: 4 },
          });
        })(n(381));
      },
      7925: function (e, t, n) {
        !(function (e) {
          e.defineLocale("en-ca", {
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "YYYY-MM-DD",
              LL: "MMMM D, YYYY",
              LLL: "MMMM D, YYYY h:mm A",
              LLLL: "dddd, MMMM D, YYYY h:mm A",
            },
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
          });
        })(n(381));
      },
      2243: function (e, t, n) {
        !(function (e) {
          e.defineLocale("en-gb", {
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      6436: function (e, t, n) {
        !(function (e) {
          e.defineLocale("en-ie", {
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      7207: function (e, t, n) {
        !(function (e) {
          e.defineLocale("en-il", {
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
          });
        })(n(381));
      },
      4175: function (e, t, n) {
        !(function (e) {
          e.defineLocale("en-in", {
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY h:mm A",
              LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      6319: function (e, t, n) {
        !(function (e) {
          e.defineLocale("en-nz", {
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY h:mm A",
              LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      1662: function (e, t, n) {
        !(function (e) {
          e.defineLocale("en-sg", {
            months:
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            weekdays:
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            weekdaysShort: "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            weekdaysMin: "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Today at] LT",
              nextDay: "[Tomorrow at] LT",
              nextWeek: "dddd [at] LT",
              lastDay: "[Yesterday at] LT",
              lastWeek: "[Last] dddd [at] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "in %s",
              past: "%s ago",
              s: "a few seconds",
              ss: "%d seconds",
              m: "a minute",
              mm: "%d minutes",
              h: "an hour",
              hh: "%d hours",
              d: "a day",
              dd: "%d days",
              M: "a month",
              MM: "%d months",
              y: "a year",
              yy: "%d years",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      2915: function (e, t, n) {
        !(function (e) {
          e.defineLocale("eo", {
            months:
              "januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro".split(
                "_"
              ),
            monthsShort:
              "jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec".split("_"),
            weekdays:
              "dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato".split("_"),
            weekdaysShort: "dim_lun_mard_merk_ĵaŭ_ven_sab".split("_"),
            weekdaysMin: "di_lu_ma_me_ĵa_ve_sa".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY-MM-DD",
              LL: "[la] D[-an de] MMMM, YYYY",
              LLL: "[la] D[-an de] MMMM, YYYY HH:mm",
              LLLL: "dddd[n], [la] D[-an de] MMMM, YYYY HH:mm",
              llll: "ddd, [la] D[-an de] MMM, YYYY HH:mm",
            },
            meridiemParse: /[ap]\.t\.m/i,
            isPM: function (e) {
              return "p" === e.charAt(0).toLowerCase();
            },
            meridiem: function (e, t, n) {
              return e > 11
                ? n
                  ? "p.t.m."
                  : "P.T.M."
                : n
                ? "a.t.m."
                : "A.T.M.";
            },
            calendar: {
              sameDay: "[Hodiaŭ je] LT",
              nextDay: "[Morgaŭ je] LT",
              nextWeek: "dddd[n je] LT",
              lastDay: "[Hieraŭ je] LT",
              lastWeek: "[pasintan] dddd[n je] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "post %s",
              past: "antaŭ %s",
              s: "kelkaj sekundoj",
              ss: "%d sekundoj",
              m: "unu minuto",
              mm: "%d minutoj",
              h: "unu horo",
              hh: "%d horoj",
              d: "unu tago",
              dd: "%d tagoj",
              M: "unu monato",
              MM: "%d monatoj",
              y: "unu jaro",
              yy: "%d jaroj",
            },
            dayOfMonthOrdinalParse: /\d{1,2}a/,
            ordinal: "%da",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      5251: function (e, t, n) {
        !(function (e) {
          var t =
              "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
                "_"
              ),
            n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
            i = [
              /^ene/i,
              /^feb/i,
              /^mar/i,
              /^abr/i,
              /^may/i,
              /^jun/i,
              /^jul/i,
              /^ago/i,
              /^sep/i,
              /^oct/i,
              /^nov/i,
              /^dic/i,
            ],
            a =
              /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
          e.defineLocale("es-do", {
            months:
              "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
                "_"
              ),
            monthsShort: function (e, i) {
              return e ? (/-MMM-/.test(i) ? n[e.month()] : t[e.month()]) : t;
            },
            monthsRegex: a,
            monthsShortRegex: a,
            monthsStrictRegex:
              /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex:
              /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays:
              "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "DD/MM/YYYY",
              LL: "D [de] MMMM [de] YYYY",
              LLL: "D [de] MMMM [de] YYYY h:mm A",
              LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A",
            },
            calendar: {
              sameDay: function () {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              nextDay: function () {
                return (
                  "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                );
              },
              nextWeek: function () {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              lastDay: function () {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              lastWeek: function () {
                return (
                  "[el] dddd [pasado a la" +
                  (1 !== this.hours() ? "s" : "") +
                  "] LT"
                );
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "en %s",
              past: "hace %s",
              s: "unos segundos",
              ss: "%d segundos",
              m: "un minuto",
              mm: "%d minutos",
              h: "una hora",
              hh: "%d horas",
              d: "un día",
              dd: "%d días",
              w: "una semana",
              ww: "%d semanas",
              M: "un mes",
              MM: "%d meses",
              y: "un año",
              yy: "%d años",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      6112: function (e, t, n) {
        !(function (e) {
          var t =
              "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
                "_"
              ),
            n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
            i = [
              /^ene/i,
              /^feb/i,
              /^mar/i,
              /^abr/i,
              /^may/i,
              /^jun/i,
              /^jul/i,
              /^ago/i,
              /^sep/i,
              /^oct/i,
              /^nov/i,
              /^dic/i,
            ],
            a =
              /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
          e.defineLocale("es-mx", {
            months:
              "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
                "_"
              ),
            monthsShort: function (e, i) {
              return e ? (/-MMM-/.test(i) ? n[e.month()] : t[e.month()]) : t;
            },
            monthsRegex: a,
            monthsShortRegex: a,
            monthsStrictRegex:
              /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex:
              /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays:
              "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D [de] MMMM [de] YYYY",
              LLL: "D [de] MMMM [de] YYYY H:mm",
              LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
            },
            calendar: {
              sameDay: function () {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              nextDay: function () {
                return (
                  "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                );
              },
              nextWeek: function () {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              lastDay: function () {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              lastWeek: function () {
                return (
                  "[el] dddd [pasado a la" +
                  (1 !== this.hours() ? "s" : "") +
                  "] LT"
                );
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "en %s",
              past: "hace %s",
              s: "unos segundos",
              ss: "%d segundos",
              m: "un minuto",
              mm: "%d minutos",
              h: "una hora",
              hh: "%d horas",
              d: "un día",
              dd: "%d días",
              w: "una semana",
              ww: "%d semanas",
              M: "un mes",
              MM: "%d meses",
              y: "un año",
              yy: "%d años",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 0, doy: 4 },
            invalidDate: "Fecha inválida",
          });
        })(n(381));
      },
      1146: function (e, t, n) {
        !(function (e) {
          var t =
              "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
                "_"
              ),
            n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
            i = [
              /^ene/i,
              /^feb/i,
              /^mar/i,
              /^abr/i,
              /^may/i,
              /^jun/i,
              /^jul/i,
              /^ago/i,
              /^sep/i,
              /^oct/i,
              /^nov/i,
              /^dic/i,
            ],
            a =
              /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
          e.defineLocale("es-us", {
            months:
              "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
                "_"
              ),
            monthsShort: function (e, i) {
              return e ? (/-MMM-/.test(i) ? n[e.month()] : t[e.month()]) : t;
            },
            monthsRegex: a,
            monthsShortRegex: a,
            monthsStrictRegex:
              /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex:
              /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays:
              "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "MM/DD/YYYY",
              LL: "D [de] MMMM [de] YYYY",
              LLL: "D [de] MMMM [de] YYYY h:mm A",
              LLLL: "dddd, D [de] MMMM [de] YYYY h:mm A",
            },
            calendar: {
              sameDay: function () {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              nextDay: function () {
                return (
                  "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                );
              },
              nextWeek: function () {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              lastDay: function () {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              lastWeek: function () {
                return (
                  "[el] dddd [pasado a la" +
                  (1 !== this.hours() ? "s" : "") +
                  "] LT"
                );
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "en %s",
              past: "hace %s",
              s: "unos segundos",
              ss: "%d segundos",
              m: "un minuto",
              mm: "%d minutos",
              h: "una hora",
              hh: "%d horas",
              d: "un día",
              dd: "%d días",
              w: "una semana",
              ww: "%d semanas",
              M: "un mes",
              MM: "%d meses",
              y: "un año",
              yy: "%d años",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      5655: function (e, t, n) {
        !(function (e) {
          var t =
              "ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.".split(
                "_"
              ),
            n = "ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic".split("_"),
            i = [
              /^ene/i,
              /^feb/i,
              /^mar/i,
              /^abr/i,
              /^may/i,
              /^jun/i,
              /^jul/i,
              /^ago/i,
              /^sep/i,
              /^oct/i,
              /^nov/i,
              /^dic/i,
            ],
            a =
              /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;
          e.defineLocale("es", {
            months:
              "enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre".split(
                "_"
              ),
            monthsShort: function (e, i) {
              return e ? (/-MMM-/.test(i) ? n[e.month()] : t[e.month()]) : t;
            },
            monthsRegex: a,
            monthsShortRegex: a,
            monthsStrictRegex:
              /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
            monthsShortStrictRegex:
              /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays:
              "domingo_lunes_martes_miércoles_jueves_viernes_sábado".split("_"),
            weekdaysShort: "dom._lun._mar._mié._jue._vie._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mi_ju_vi_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D [de] MMMM [de] YYYY",
              LLL: "D [de] MMMM [de] YYYY H:mm",
              LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
            },
            calendar: {
              sameDay: function () {
                return "[hoy a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              nextDay: function () {
                return (
                  "[mañana a la" + (1 !== this.hours() ? "s" : "") + "] LT"
                );
              },
              nextWeek: function () {
                return "dddd [a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              lastDay: function () {
                return "[ayer a la" + (1 !== this.hours() ? "s" : "") + "] LT";
              },
              lastWeek: function () {
                return (
                  "[el] dddd [pasado a la" +
                  (1 !== this.hours() ? "s" : "") +
                  "] LT"
                );
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "en %s",
              past: "hace %s",
              s: "unos segundos",
              ss: "%d segundos",
              m: "un minuto",
              mm: "%d minutos",
              h: "una hora",
              hh: "%d horas",
              d: "un día",
              dd: "%d días",
              w: "una semana",
              ww: "%d semanas",
              M: "un mes",
              MM: "%d meses",
              y: "un año",
              yy: "%d años",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 1, doy: 4 },
            invalidDate: "Fecha inválida",
          });
        })(n(381));
      },
      5603: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              s: ["mõne sekundi", "mõni sekund", "paar sekundit"],
              ss: [e + "sekundi", e + "sekundit"],
              m: ["ühe minuti", "üks minut"],
              mm: [e + " minuti", e + " minutit"],
              h: ["ühe tunni", "tund aega", "üks tund"],
              hh: [e + " tunni", e + " tundi"],
              d: ["ühe päeva", "üks päev"],
              M: ["kuu aja", "kuu aega", "üks kuu"],
              MM: [e + " kuu", e + " kuud"],
              y: ["ühe aasta", "aasta", "üks aasta"],
              yy: [e + " aasta", e + " aastat"],
            };
            return t ? (a[n][2] ? a[n][2] : a[n][1]) : i ? a[n][0] : a[n][1];
          }
          e.defineLocale("et", {
            months:
              "jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember".split(
                "_"
              ),
            monthsShort:
              "jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets".split(
                "_"
              ),
            weekdays:
              "pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev".split(
                "_"
              ),
            weekdaysShort: "P_E_T_K_N_R_L".split("_"),
            weekdaysMin: "P_E_T_K_N_R_L".split("_"),
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY H:mm",
              LLLL: "dddd, D. MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[Täna,] LT",
              nextDay: "[Homme,] LT",
              nextWeek: "[Järgmine] dddd LT",
              lastDay: "[Eile,] LT",
              lastWeek: "[Eelmine] dddd LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s pärast",
              past: "%s tagasi",
              s: t,
              ss: t,
              m: t,
              mm: t,
              h: t,
              hh: t,
              d: t,
              dd: "%d päeva",
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      7763: function (e, t, n) {
        !(function (e) {
          e.defineLocale("eu", {
            months:
              "urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua".split(
                "_"
              ),
            monthsShort:
              "urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata".split(
                "_"
              ),
            weekdaysShort: "ig._al._ar._az._og._ol._lr.".split("_"),
            weekdaysMin: "ig_al_ar_az_og_ol_lr".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY-MM-DD",
              LL: "YYYY[ko] MMMM[ren] D[a]",
              LLL: "YYYY[ko] MMMM[ren] D[a] HH:mm",
              LLLL: "dddd, YYYY[ko] MMMM[ren] D[a] HH:mm",
              l: "YYYY-M-D",
              ll: "YYYY[ko] MMM D[a]",
              lll: "YYYY[ko] MMM D[a] HH:mm",
              llll: "ddd, YYYY[ko] MMM D[a] HH:mm",
            },
            calendar: {
              sameDay: "[gaur] LT[etan]",
              nextDay: "[bihar] LT[etan]",
              nextWeek: "dddd LT[etan]",
              lastDay: "[atzo] LT[etan]",
              lastWeek: "[aurreko] dddd LT[etan]",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s barru",
              past: "duela %s",
              s: "segundo batzuk",
              ss: "%d segundo",
              m: "minutu bat",
              mm: "%d minutu",
              h: "ordu bat",
              hh: "%d ordu",
              d: "egun bat",
              dd: "%d egun",
              M: "hilabete bat",
              MM: "%d hilabete",
              y: "urte bat",
              yy: "%d urte",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      6959: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "۱",
              2: "۲",
              3: "۳",
              4: "۴",
              5: "۵",
              6: "۶",
              7: "۷",
              8: "۸",
              9: "۹",
              0: "۰",
            },
            n = {
              "۱": "1",
              "۲": "2",
              "۳": "3",
              "۴": "4",
              "۵": "5",
              "۶": "6",
              "۷": "7",
              "۸": "8",
              "۹": "9",
              "۰": "0",
            };
          e.defineLocale("fa", {
            months:
              "ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split(
                "_"
              ),
            monthsShort:
              "ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر".split(
                "_"
              ),
            weekdays:
              "یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),
            weekdaysShort:
              "یک‌شنبه_دوشنبه_سه‌شنبه_چهارشنبه_پنج‌شنبه_جمعه_شنبه".split("_"),
            weekdaysMin: "ی_د_س_چ_پ_ج_ش".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            meridiemParse: /قبل از ظهر|بعد از ظهر/,
            isPM: function (e) {
              return /بعد از ظهر/.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "قبل از ظهر" : "بعد از ظهر";
            },
            calendar: {
              sameDay: "[امروز ساعت] LT",
              nextDay: "[فردا ساعت] LT",
              nextWeek: "dddd [ساعت] LT",
              lastDay: "[دیروز ساعت] LT",
              lastWeek: "dddd [پیش] [ساعت] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "در %s",
              past: "%s پیش",
              s: "چند ثانیه",
              ss: "%d ثانیه",
              m: "یک دقیقه",
              mm: "%d دقیقه",
              h: "یک ساعت",
              hh: "%d ساعت",
              d: "یک روز",
              dd: "%d روز",
              M: "یک ماه",
              MM: "%d ماه",
              y: "یک سال",
              yy: "%d سال",
            },
            preparse: function (e) {
              return e
                .replace(/[۰-۹]/g, function (e) {
                  return n[e];
                })
                .replace(/،/g, ",");
            },
            postformat: function (e) {
              return e
                .replace(/\d/g, function (e) {
                  return t[e];
                })
                .replace(/,/g, "،");
            },
            dayOfMonthOrdinalParse: /\d{1,2}م/,
            ordinal: "%dم",
            week: { dow: 6, doy: 12 },
          });
        })(n(381));
      },
      1897: function (e, t, n) {
        !(function (e) {
          var t =
              "nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän".split(
                " "
              ),
            n = [
              "nolla",
              "yhden",
              "kahden",
              "kolmen",
              "neljän",
              "viiden",
              "kuuden",
              t[7],
              t[8],
              t[9],
            ];
          function i(e, t, n, i) {
            var r = "";
            switch (n) {
              case "s":
                return i ? "muutaman sekunnin" : "muutama sekunti";
              case "ss":
                r = i ? "sekunnin" : "sekuntia";
                break;
              case "m":
                return i ? "minuutin" : "minuutti";
              case "mm":
                r = i ? "minuutin" : "minuuttia";
                break;
              case "h":
                return i ? "tunnin" : "tunti";
              case "hh":
                r = i ? "tunnin" : "tuntia";
                break;
              case "d":
                return i ? "päivän" : "päivä";
              case "dd":
                r = i ? "päivän" : "päivää";
                break;
              case "M":
                return i ? "kuukauden" : "kuukausi";
              case "MM":
                r = i ? "kuukauden" : "kuukautta";
                break;
              case "y":
                return i ? "vuoden" : "vuosi";
              case "yy":
                r = i ? "vuoden" : "vuotta";
            }
            return (r = a(e, i) + " " + r);
          }
          function a(e, i) {
            return e < 10 ? (i ? n[e] : t[e]) : e;
          }
          e.defineLocale("fi", {
            months:
              "tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu".split(
                "_"
              ),
            monthsShort:
              "tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu".split(
                "_"
              ),
            weekdays:
              "sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai".split(
                "_"
              ),
            weekdaysShort: "su_ma_ti_ke_to_pe_la".split("_"),
            weekdaysMin: "su_ma_ti_ke_to_pe_la".split("_"),
            longDateFormat: {
              LT: "HH.mm",
              LTS: "HH.mm.ss",
              L: "DD.MM.YYYY",
              LL: "Do MMMM[ta] YYYY",
              LLL: "Do MMMM[ta] YYYY, [klo] HH.mm",
              LLLL: "dddd, Do MMMM[ta] YYYY, [klo] HH.mm",
              l: "D.M.YYYY",
              ll: "Do MMM YYYY",
              lll: "Do MMM YYYY, [klo] HH.mm",
              llll: "ddd, Do MMM YYYY, [klo] HH.mm",
            },
            calendar: {
              sameDay: "[tänään] [klo] LT",
              nextDay: "[huomenna] [klo] LT",
              nextWeek: "dddd [klo] LT",
              lastDay: "[eilen] [klo] LT",
              lastWeek: "[viime] dddd[na] [klo] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s päästä",
              past: "%s sitten",
              s: i,
              ss: i,
              m: i,
              mm: i,
              h: i,
              hh: i,
              d: i,
              dd: i,
              M: i,
              MM: i,
              y: i,
              yy: i,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      2549: function (e, t, n) {
        !(function (e) {
          e.defineLocale("fil", {
            months:
              "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split(
                "_"
              ),
            monthsShort:
              "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
            weekdays:
              "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split(
                "_"
              ),
            weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
            weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "MM/D/YYYY",
              LL: "MMMM D, YYYY",
              LLL: "MMMM D, YYYY HH:mm",
              LLLL: "dddd, MMMM DD, YYYY HH:mm",
            },
            calendar: {
              sameDay: "LT [ngayong araw]",
              nextDay: "[Bukas ng] LT",
              nextWeek: "LT [sa susunod na] dddd",
              lastDay: "LT [kahapon]",
              lastWeek: "LT [noong nakaraang] dddd",
              sameElse: "L",
            },
            relativeTime: {
              future: "sa loob ng %s",
              past: "%s ang nakalipas",
              s: "ilang segundo",
              ss: "%d segundo",
              m: "isang minuto",
              mm: "%d minuto",
              h: "isang oras",
              hh: "%d oras",
              d: "isang araw",
              dd: "%d araw",
              M: "isang buwan",
              MM: "%d buwan",
              y: "isang taon",
              yy: "%d taon",
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: function (e) {
              return e;
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      4694: function (e, t, n) {
        !(function (e) {
          e.defineLocale("fo", {
            months:
              "januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember".split(
                "_"
              ),
            monthsShort:
              "jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_"),
            weekdays:
              "sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur".split(
                "_"
              ),
            weekdaysShort: "sun_mán_týs_mik_hós_frí_ley".split("_"),
            weekdaysMin: "su_má_tý_mi_hó_fr_le".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D. MMMM, YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Í dag kl.] LT",
              nextDay: "[Í morgin kl.] LT",
              nextWeek: "dddd [kl.] LT",
              lastDay: "[Í gjár kl.] LT",
              lastWeek: "[síðstu] dddd [kl] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "um %s",
              past: "%s síðani",
              s: "fá sekund",
              ss: "%d sekundir",
              m: "ein minuttur",
              mm: "%d minuttir",
              h: "ein tími",
              hh: "%d tímar",
              d: "ein dagur",
              dd: "%d dagar",
              M: "ein mánaður",
              MM: "%d mánaðir",
              y: "eitt ár",
              yy: "%d ár",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      3049: function (e, t, n) {
        !(function (e) {
          e.defineLocale("fr-ca", {
            months:
              "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
                "_"
              ),
            monthsShort:
              "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY-MM-DD",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Aujourd’hui à] LT",
              nextDay: "[Demain à] LT",
              nextWeek: "dddd [à] LT",
              lastDay: "[Hier à] LT",
              lastWeek: "dddd [dernier à] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "dans %s",
              past: "il y a %s",
              s: "quelques secondes",
              ss: "%d secondes",
              m: "une minute",
              mm: "%d minutes",
              h: "une heure",
              hh: "%d heures",
              d: "un jour",
              dd: "%d jours",
              M: "un mois",
              MM: "%d mois",
              y: "un an",
              yy: "%d ans",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
            ordinal: function (e, t) {
              switch (t) {
                default:
                case "M":
                case "Q":
                case "D":
                case "DDD":
                case "d":
                  return e + (1 === e ? "er" : "e");
                case "w":
                case "W":
                  return e + (1 === e ? "re" : "e");
              }
            },
          });
        })(n(381));
      },
      2330: function (e, t, n) {
        !(function (e) {
          e.defineLocale("fr-ch", {
            months:
              "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
                "_"
              ),
            monthsShort:
              "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Aujourd’hui à] LT",
              nextDay: "[Demain à] LT",
              nextWeek: "dddd [à] LT",
              lastDay: "[Hier à] LT",
              lastWeek: "dddd [dernier à] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "dans %s",
              past: "il y a %s",
              s: "quelques secondes",
              ss: "%d secondes",
              m: "une minute",
              mm: "%d minutes",
              h: "une heure",
              hh: "%d heures",
              d: "un jour",
              dd: "%d jours",
              M: "un mois",
              MM: "%d mois",
              y: "un an",
              yy: "%d ans",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
            ordinal: function (e, t) {
              switch (t) {
                default:
                case "M":
                case "Q":
                case "D":
                case "DDD":
                case "d":
                  return e + (1 === e ? "er" : "e");
                case "w":
                case "W":
                  return e + (1 === e ? "re" : "e");
              }
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      4470: function (e, t, n) {
        !(function (e) {
          var t =
              /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
            n =
              /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
            i =
              /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
            a = [
              /^janv/i,
              /^févr/i,
              /^mars/i,
              /^avr/i,
              /^mai/i,
              /^juin/i,
              /^juil/i,
              /^août/i,
              /^sept/i,
              /^oct/i,
              /^nov/i,
              /^déc/i,
            ];
          e.defineLocale("fr", {
            months:
              "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
                "_"
              ),
            monthsShort:
              "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split(
                "_"
              ),
            monthsRegex: i,
            monthsShortRegex: i,
            monthsStrictRegex: t,
            monthsShortStrictRegex: n,
            monthsParse: a,
            longMonthsParse: a,
            shortMonthsParse: a,
            weekdays:
              "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
            weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
            weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Aujourd’hui à] LT",
              nextDay: "[Demain à] LT",
              nextWeek: "dddd [à] LT",
              lastDay: "[Hier à] LT",
              lastWeek: "dddd [dernier à] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "dans %s",
              past: "il y a %s",
              s: "quelques secondes",
              ss: "%d secondes",
              m: "une minute",
              mm: "%d minutes",
              h: "une heure",
              hh: "%d heures",
              d: "un jour",
              dd: "%d jours",
              w: "une semaine",
              ww: "%d semaines",
              M: "un mois",
              MM: "%d mois",
              y: "un an",
              yy: "%d ans",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
            ordinal: function (e, t) {
              switch (t) {
                case "D":
                  return e + (1 === e ? "er" : "");
                default:
                case "M":
                case "Q":
                case "DDD":
                case "d":
                  return e + (1 === e ? "er" : "e");
                case "w":
                case "W":
                  return e + (1 === e ? "re" : "e");
              }
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      5044: function (e, t, n) {
        !(function (e) {
          var t =
              "jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.".split(
                "_"
              ),
            n = "jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des".split("_");
          e.defineLocale("fy", {
            months:
              "jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber".split(
                "_"
              ),
            monthsShort: function (e, i) {
              return e ? (/-MMM-/.test(i) ? n[e.month()] : t[e.month()]) : t;
            },
            monthsParseExact: !0,
            weekdays:
              "snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon".split(
                "_"
              ),
            weekdaysShort: "si._mo._ti._wo._to._fr._so.".split("_"),
            weekdaysMin: "Si_Mo_Ti_Wo_To_Fr_So".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD-MM-YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[hjoed om] LT",
              nextDay: "[moarn om] LT",
              nextWeek: "dddd [om] LT",
              lastDay: "[juster om] LT",
              lastWeek: "[ôfrûne] dddd [om] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "oer %s",
              past: "%s lyn",
              s: "in pear sekonden",
              ss: "%d sekonden",
              m: "ien minút",
              mm: "%d minuten",
              h: "ien oere",
              hh: "%d oeren",
              d: "ien dei",
              dd: "%d dagen",
              M: "ien moanne",
              MM: "%d moannen",
              y: "ien jier",
              yy: "%d jierren",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function (e) {
              return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      9295: function (e, t, n) {
        !(function (e) {
          var t = [
              "Eanáir",
              "Feabhra",
              "Márta",
              "Aibreán",
              "Bealtaine",
              "Meitheamh",
              "Iúil",
              "Lúnasa",
              "Meán Fómhair",
              "Deireadh Fómhair",
              "Samhain",
              "Nollaig",
            ],
            n = [
              "Ean",
              "Feabh",
              "Márt",
              "Aib",
              "Beal",
              "Meith",
              "Iúil",
              "Lún",
              "M.F.",
              "D.F.",
              "Samh",
              "Noll",
            ],
            i = [
              "Dé Domhnaigh",
              "Dé Luain",
              "Dé Máirt",
              "Dé Céadaoin",
              "Déardaoin",
              "Dé hAoine",
              "Dé Sathairn",
            ],
            a = ["Domh", "Luan", "Máirt", "Céad", "Déar", "Aoine", "Sath"],
            r = ["Do", "Lu", "Má", "Cé", "Dé", "A", "Sa"];
          e.defineLocale("ga", {
            months: t,
            monthsShort: n,
            monthsParseExact: !0,
            weekdays: i,
            weekdaysShort: a,
            weekdaysMin: r,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Inniu ag] LT",
              nextDay: "[Amárach ag] LT",
              nextWeek: "dddd [ag] LT",
              lastDay: "[Inné ag] LT",
              lastWeek: "dddd [seo caite] [ag] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "i %s",
              past: "%s ó shin",
              s: "cúpla soicind",
              ss: "%d soicind",
              m: "nóiméad",
              mm: "%d nóiméad",
              h: "uair an chloig",
              hh: "%d uair an chloig",
              d: "lá",
              dd: "%d lá",
              M: "mí",
              MM: "%d míonna",
              y: "bliain",
              yy: "%d bliain",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
            ordinal: function (e) {
              return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      2101: function (e, t, n) {
        !(function (e) {
          var t = [
              "Am Faoilleach",
              "An Gearran",
              "Am Màrt",
              "An Giblean",
              "An Cèitean",
              "An t-Ògmhios",
              "An t-Iuchar",
              "An Lùnastal",
              "An t-Sultain",
              "An Dàmhair",
              "An t-Samhain",
              "An Dùbhlachd",
            ],
            n = [
              "Faoi",
              "Gear",
              "Màrt",
              "Gibl",
              "Cèit",
              "Ògmh",
              "Iuch",
              "Lùn",
              "Sult",
              "Dàmh",
              "Samh",
              "Dùbh",
            ],
            i = [
              "Didòmhnaich",
              "Diluain",
              "Dimàirt",
              "Diciadain",
              "Diardaoin",
              "Dihaoine",
              "Disathairne",
            ],
            a = ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
            r = ["Dò", "Lu", "Mà", "Ci", "Ar", "Ha", "Sa"];
          e.defineLocale("gd", {
            months: t,
            monthsShort: n,
            monthsParseExact: !0,
            weekdays: i,
            weekdaysShort: a,
            weekdaysMin: r,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[An-diugh aig] LT",
              nextDay: "[A-màireach aig] LT",
              nextWeek: "dddd [aig] LT",
              lastDay: "[An-dè aig] LT",
              lastWeek: "dddd [seo chaidh] [aig] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "ann an %s",
              past: "bho chionn %s",
              s: "beagan diogan",
              ss: "%d diogan",
              m: "mionaid",
              mm: "%d mionaidean",
              h: "uair",
              hh: "%d uairean",
              d: "latha",
              dd: "%d latha",
              M: "mìos",
              MM: "%d mìosan",
              y: "bliadhna",
              yy: "%d bliadhna",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
            ordinal: function (e) {
              return e + (1 === e ? "d" : e % 10 == 2 ? "na" : "mh");
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      8794: function (e, t, n) {
        !(function (e) {
          e.defineLocale("gl", {
            months:
              "xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro".split(
                "_"
              ),
            monthsShort:
              "xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays: "domingo_luns_martes_mércores_xoves_venres_sábado".split(
              "_"
            ),
            weekdaysShort: "dom._lun._mar._mér._xov._ven._sáb.".split("_"),
            weekdaysMin: "do_lu_ma_mé_xo_ve_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D [de] MMMM [de] YYYY",
              LLL: "D [de] MMMM [de] YYYY H:mm",
              LLLL: "dddd, D [de] MMMM [de] YYYY H:mm",
            },
            calendar: {
              sameDay: function () {
                return "[hoxe " + (1 !== this.hours() ? "ás" : "á") + "] LT";
              },
              nextDay: function () {
                return "[mañá " + (1 !== this.hours() ? "ás" : "á") + "] LT";
              },
              nextWeek: function () {
                return "dddd [" + (1 !== this.hours() ? "ás" : "a") + "] LT";
              },
              lastDay: function () {
                return "[onte " + (1 !== this.hours() ? "á" : "a") + "] LT";
              },
              lastWeek: function () {
                return (
                  "[o] dddd [pasado " +
                  (1 !== this.hours() ? "ás" : "a") +
                  "] LT"
                );
              },
              sameElse: "L",
            },
            relativeTime: {
              future: function (e) {
                return 0 === e.indexOf("un") ? "n" + e : "en " + e;
              },
              past: "hai %s",
              s: "uns segundos",
              ss: "%d segundos",
              m: "un minuto",
              mm: "%d minutos",
              h: "unha hora",
              hh: "%d horas",
              d: "un día",
              dd: "%d días",
              M: "un mes",
              MM: "%d meses",
              y: "un ano",
              yy: "%d anos",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      7884: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              s: ["थोडया सॅकंडांनी", "थोडे सॅकंड"],
              ss: [e + " सॅकंडांनी", e + " सॅकंड"],
              m: ["एका मिणटान", "एक मिनूट"],
              mm: [e + " मिणटांनी", e + " मिणटां"],
              h: ["एका वरान", "एक वर"],
              hh: [e + " वरांनी", e + " वरां"],
              d: ["एका दिसान", "एक दीस"],
              dd: [e + " दिसांनी", e + " दीस"],
              M: ["एका म्हयन्यान", "एक म्हयनो"],
              MM: [e + " म्हयन्यानी", e + " म्हयने"],
              y: ["एका वर्सान", "एक वर्स"],
              yy: [e + " वर्सांनी", e + " वर्सां"],
            };
            return i ? a[n][0] : a[n][1];
          }
          e.defineLocale("gom-deva", {
            months: {
              standalone:
                "जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split(
                  "_"
                ),
              format:
                "जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या".split(
                  "_"
                ),
              isFormat: /MMMM(\s)+D[oD]?/,
            },
            monthsShort:
              "जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार".split("_"),
            weekdaysShort: "आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.".split(
              "_"
            ),
            weekdaysMin: "आ_सो_मं_बु_ब्रे_सु_शे".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "A h:mm [वाजतां]",
              LTS: "A h:mm:ss [वाजतां]",
              L: "DD-MM-YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY A h:mm [वाजतां]",
              LLLL: "dddd, MMMM Do, YYYY, A h:mm [वाजतां]",
              llll: "ddd, D MMM YYYY, A h:mm [वाजतां]",
            },
            calendar: {
              sameDay: "[आयज] LT",
              nextDay: "[फाल्यां] LT",
              nextWeek: "[फुडलो] dddd[,] LT",
              lastDay: "[काल] LT",
              lastWeek: "[फाटलो] dddd[,] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s",
              past: "%s आदीं",
              s: t,
              ss: t,
              m: t,
              mm: t,
              h: t,
              hh: t,
              d: t,
              dd: t,
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
            ordinal: function (e, t) {
              return "D" === t ? e + "वेर" : e;
            },
            week: { dow: 0, doy: 3 },
            meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "राती" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "सकाळीं" === t
                  ? e
                  : "दनपारां" === t
                  ? e > 12
                    ? e
                    : e + 12
                  : "सांजे" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "राती"
                : e < 12
                ? "सकाळीं"
                : e < 16
                ? "दनपारां"
                : e < 20
                ? "सांजे"
                : "राती";
            },
          });
        })(n(381));
      },
      3168: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              s: ["thoddea sekondamni", "thodde sekond"],
              ss: [e + " sekondamni", e + " sekond"],
              m: ["eka mintan", "ek minut"],
              mm: [e + " mintamni", e + " mintam"],
              h: ["eka voran", "ek vor"],
              hh: [e + " voramni", e + " voram"],
              d: ["eka disan", "ek dis"],
              dd: [e + " disamni", e + " dis"],
              M: ["eka mhoinean", "ek mhoino"],
              MM: [e + " mhoineamni", e + " mhoine"],
              y: ["eka vorsan", "ek voros"],
              yy: [e + " vorsamni", e + " vorsam"],
            };
            return i ? a[n][0] : a[n][1];
          }
          e.defineLocale("gom-latn", {
            months: {
              standalone:
                "Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr".split(
                  "_"
                ),
              format:
                "Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea".split(
                  "_"
                ),
              isFormat: /MMMM(\s)+D[oD]?/,
            },
            monthsShort:
              "Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split("_"),
            weekdaysShort: "Ait._Som._Mon._Bud._Bre._Suk._Son.".split("_"),
            weekdaysMin: "Ai_Sm_Mo_Bu_Br_Su_Sn".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "A h:mm [vazta]",
              LTS: "A h:mm:ss [vazta]",
              L: "DD-MM-YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY A h:mm [vazta]",
              LLLL: "dddd, MMMM Do, YYYY, A h:mm [vazta]",
              llll: "ddd, D MMM YYYY, A h:mm [vazta]",
            },
            calendar: {
              sameDay: "[Aiz] LT",
              nextDay: "[Faleam] LT",
              nextWeek: "[Fuddlo] dddd[,] LT",
              lastDay: "[Kal] LT",
              lastWeek: "[Fattlo] dddd[,] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s",
              past: "%s adim",
              s: t,
              ss: t,
              m: t,
              mm: t,
              h: t,
              hh: t,
              d: t,
              dd: t,
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}(er)/,
            ordinal: function (e, t) {
              return "D" === t ? e + "er" : e;
            },
            week: { dow: 0, doy: 3 },
            meridiemParse: /rati|sokallim|donparam|sanje/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "rati" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "sokallim" === t
                  ? e
                  : "donparam" === t
                  ? e > 12
                    ? e
                    : e + 12
                  : "sanje" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "rati"
                : e < 12
                ? "sokallim"
                : e < 16
                ? "donparam"
                : e < 20
                ? "sanje"
                : "rati";
            },
          });
        })(n(381));
      },
      5349: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "૧",
              2: "૨",
              3: "૩",
              4: "૪",
              5: "૫",
              6: "૬",
              7: "૭",
              8: "૮",
              9: "૯",
              0: "૦",
            },
            n = {
              "૧": "1",
              "૨": "2",
              "૩": "3",
              "૪": "4",
              "૫": "5",
              "૬": "6",
              "૭": "7",
              "૮": "8",
              "૯": "9",
              "૦": "0",
            };
          e.defineLocale("gu", {
            months:
              "જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર".split(
                "_"
              ),
            monthsShort:
              "જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર".split(
                "_"
              ),
            weekdaysShort: "રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ".split("_"),
            weekdaysMin: "ર_સો_મં_બુ_ગુ_શુ_શ".split("_"),
            longDateFormat: {
              LT: "A h:mm વાગ્યે",
              LTS: "A h:mm:ss વાગ્યે",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm વાગ્યે",
              LLLL: "dddd, D MMMM YYYY, A h:mm વાગ્યે",
            },
            calendar: {
              sameDay: "[આજ] LT",
              nextDay: "[કાલે] LT",
              nextWeek: "dddd, LT",
              lastDay: "[ગઇકાલે] LT",
              lastWeek: "[પાછલા] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s મા",
              past: "%s પહેલા",
              s: "અમુક પળો",
              ss: "%d સેકંડ",
              m: "એક મિનિટ",
              mm: "%d મિનિટ",
              h: "એક કલાક",
              hh: "%d કલાક",
              d: "એક દિવસ",
              dd: "%d દિવસ",
              M: "એક મહિનો",
              MM: "%d મહિનો",
              y: "એક વર્ષ",
              yy: "%d વર્ષ",
            },
            preparse: function (e) {
              return e.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "રાત" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "સવાર" === t
                  ? e
                  : "બપોર" === t
                  ? e >= 10
                    ? e
                    : e + 12
                  : "સાંજ" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "રાત"
                : e < 10
                ? "સવાર"
                : e < 17
                ? "બપોર"
                : e < 20
                ? "સાંજ"
                : "રાત";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      4206: function (e, t, n) {
        !(function (e) {
          e.defineLocale("he", {
            months:
              "ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר".split(
                "_"
              ),
            monthsShort:
              "ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳".split(
                "_"
              ),
            weekdays: "ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת".split("_"),
            weekdaysShort: "א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳".split("_"),
            weekdaysMin: "א_ב_ג_ד_ה_ו_ש".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D [ב]MMMM YYYY",
              LLL: "D [ב]MMMM YYYY HH:mm",
              LLLL: "dddd, D [ב]MMMM YYYY HH:mm",
              l: "D/M/YYYY",
              ll: "D MMM YYYY",
              lll: "D MMM YYYY HH:mm",
              llll: "ddd, D MMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[היום ב־]LT",
              nextDay: "[מחר ב־]LT",
              nextWeek: "dddd [בשעה] LT",
              lastDay: "[אתמול ב־]LT",
              lastWeek: "[ביום] dddd [האחרון בשעה] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "בעוד %s",
              past: "לפני %s",
              s: "מספר שניות",
              ss: "%d שניות",
              m: "דקה",
              mm: "%d דקות",
              h: "שעה",
              hh: function (e) {
                return 2 === e ? "שעתיים" : e + " שעות";
              },
              d: "יום",
              dd: function (e) {
                return 2 === e ? "יומיים" : e + " ימים";
              },
              M: "חודש",
              MM: function (e) {
                return 2 === e ? "חודשיים" : e + " חודשים";
              },
              y: "שנה",
              yy: function (e) {
                return 2 === e
                  ? "שנתיים"
                  : e % 10 == 0 && 10 !== e
                  ? e + " שנה"
                  : e + " שנים";
              },
            },
            meridiemParse:
              /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
            isPM: function (e) {
              return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 5
                ? "לפנות בוקר"
                : e < 10
                ? "בבוקר"
                : e < 12
                ? n
                  ? 'לפנה"צ'
                  : "לפני הצהריים"
                : e < 18
                ? n
                  ? 'אחה"צ'
                  : "אחרי הצהריים"
                : "בערב";
            },
          });
        })(n(381));
      },
      94: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "१",
              2: "२",
              3: "३",
              4: "४",
              5: "५",
              6: "६",
              7: "७",
              8: "८",
              9: "९",
              0: "०",
            },
            n = {
              "१": "1",
              "२": "2",
              "३": "3",
              "४": "4",
              "५": "5",
              "६": "6",
              "७": "7",
              "८": "8",
              "९": "9",
              "०": "0",
            },
            i = [
              /^जन/i,
              /^फ़र|फर/i,
              /^मार्च/i,
              /^अप्रै/i,
              /^मई/i,
              /^जून/i,
              /^जुल/i,
              /^अग/i,
              /^सितं|सित/i,
              /^अक्टू/i,
              /^नव|नवं/i,
              /^दिसं|दिस/i,
            ],
            a = [
              /^जन/i,
              /^फ़र/i,
              /^मार्च/i,
              /^अप्रै/i,
              /^मई/i,
              /^जून/i,
              /^जुल/i,
              /^अग/i,
              /^सित/i,
              /^अक्टू/i,
              /^नव/i,
              /^दिस/i,
            ];
          e.defineLocale("hi", {
            months: {
              format:
                "जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर".split(
                  "_"
                ),
              standalone:
                "जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर".split(
                  "_"
                ),
            },
            monthsShort:
              "जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.".split(
                "_"
              ),
            weekdays:
              "रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),
            weekdaysShort: "रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि".split("_"),
            weekdaysMin: "र_सो_मं_बु_गु_शु_श".split("_"),
            longDateFormat: {
              LT: "A h:mm बजे",
              LTS: "A h:mm:ss बजे",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm बजे",
              LLLL: "dddd, D MMMM YYYY, A h:mm बजे",
            },
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: a,
            monthsRegex:
              /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
            monthsShortRegex:
              /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,
            monthsStrictRegex:
              /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,
            monthsShortStrictRegex:
              /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,
            calendar: {
              sameDay: "[आज] LT",
              nextDay: "[कल] LT",
              nextWeek: "dddd, LT",
              lastDay: "[कल] LT",
              lastWeek: "[पिछले] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s में",
              past: "%s पहले",
              s: "कुछ ही क्षण",
              ss: "%d सेकंड",
              m: "एक मिनट",
              mm: "%d मिनट",
              h: "एक घंटा",
              hh: "%d घंटे",
              d: "एक दिन",
              dd: "%d दिन",
              M: "एक महीने",
              MM: "%d महीने",
              y: "एक वर्ष",
              yy: "%d वर्ष",
            },
            preparse: function (e) {
              return e.replace(/[१२३४५६७८९०]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /रात|सुबह|दोपहर|शाम/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "रात" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "सुबह" === t
                  ? e
                  : "दोपहर" === t
                  ? e >= 10
                    ? e
                    : e + 12
                  : "शाम" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "रात"
                : e < 10
                ? "सुबह"
                : e < 17
                ? "दोपहर"
                : e < 20
                ? "शाम"
                : "रात";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      316: function (e, t, n) {
        !(function (e) {
          function t(e, t, n) {
            var i = e + " ";
            switch (n) {
              case "ss":
                return (i +=
                  1 === e
                    ? "sekunda"
                    : 2 === e || 3 === e || 4 === e
                    ? "sekunde"
                    : "sekundi");
              case "m":
                return t ? "jedna minuta" : "jedne minute";
              case "mm":
                return (i +=
                  1 === e
                    ? "minuta"
                    : 2 === e || 3 === e || 4 === e
                    ? "minute"
                    : "minuta");
              case "h":
                return t ? "jedan sat" : "jednog sata";
              case "hh":
                return (i +=
                  1 === e
                    ? "sat"
                    : 2 === e || 3 === e || 4 === e
                    ? "sata"
                    : "sati");
              case "dd":
                return (i += 1 === e ? "dan" : "dana");
              case "MM":
                return (i +=
                  1 === e
                    ? "mjesec"
                    : 2 === e || 3 === e || 4 === e
                    ? "mjeseca"
                    : "mjeseci");
              case "yy":
                return (i +=
                  1 === e
                    ? "godina"
                    : 2 === e || 3 === e || 4 === e
                    ? "godine"
                    : "godina");
            }
          }
          e.defineLocale("hr", {
            months: {
              format:
                "siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca".split(
                  "_"
                ),
              standalone:
                "siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac".split(
                  "_"
                ),
            },
            monthsShort:
              "sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split(
                "_"
              ),
            weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "Do MMMM YYYY",
              LLL: "Do MMMM YYYY H:mm",
              LLLL: "dddd, Do MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[danas u] LT",
              nextDay: "[sutra u] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[u] [nedjelju] [u] LT";
                  case 3:
                    return "[u] [srijedu] [u] LT";
                  case 6:
                    return "[u] [subotu] [u] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[u] dddd [u] LT";
                }
              },
              lastDay: "[jučer u] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[prošlu] [nedjelju] [u] LT";
                  case 3:
                    return "[prošlu] [srijedu] [u] LT";
                  case 6:
                    return "[prošle] [subote] [u] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[prošli] dddd [u] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "za %s",
              past: "prije %s",
              s: "par sekundi",
              ss: t,
              m: t,
              mm: t,
              h: t,
              hh: t,
              d: "dan",
              dd: t,
              M: "mjesec",
              MM: t,
              y: "godinu",
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      2138: function (e, t, n) {
        !(function (e) {
          var t =
            "vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton".split(
              " "
            );
          function n(e, t, n, i) {
            var a = e;
            switch (n) {
              case "s":
                return i || t ? "néhány másodperc" : "néhány másodperce";
              case "ss":
                return a + (i || t) ? " másodperc" : " másodperce";
              case "m":
                return "egy" + (i || t ? " perc" : " perce");
              case "mm":
                return a + (i || t ? " perc" : " perce");
              case "h":
                return "egy" + (i || t ? " óra" : " órája");
              case "hh":
                return a + (i || t ? " óra" : " órája");
              case "d":
                return "egy" + (i || t ? " nap" : " napja");
              case "dd":
                return a + (i || t ? " nap" : " napja");
              case "M":
                return "egy" + (i || t ? " hónap" : " hónapja");
              case "MM":
                return a + (i || t ? " hónap" : " hónapja");
              case "y":
                return "egy" + (i || t ? " év" : " éve");
              case "yy":
                return a + (i || t ? " év" : " éve");
            }
            return "";
          }
          function i(e) {
            return (e ? "" : "[múlt] ") + "[" + t[this.day()] + "] LT[-kor]";
          }
          e.defineLocale("hu", {
            months:
              "január_február_március_április_május_június_július_augusztus_szeptember_október_november_december".split(
                "_"
              ),
            monthsShort:
              "jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat".split("_"),
            weekdaysShort: "vas_hét_kedd_sze_csüt_pén_szo".split("_"),
            weekdaysMin: "v_h_k_sze_cs_p_szo".split("_"),
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "YYYY.MM.DD.",
              LL: "YYYY. MMMM D.",
              LLL: "YYYY. MMMM D. H:mm",
              LLLL: "YYYY. MMMM D., dddd H:mm",
            },
            meridiemParse: /de|du/i,
            isPM: function (e) {
              return "u" === e.charAt(1).toLowerCase();
            },
            meridiem: function (e, t, n) {
              return e < 12 ? (!0 === n ? "de" : "DE") : !0 === n ? "du" : "DU";
            },
            calendar: {
              sameDay: "[ma] LT[-kor]",
              nextDay: "[holnap] LT[-kor]",
              nextWeek: function () {
                return i.call(this, !0);
              },
              lastDay: "[tegnap] LT[-kor]",
              lastWeek: function () {
                return i.call(this, !1);
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "%s múlva",
              past: "%s",
              s: n,
              ss: n,
              m: n,
              mm: n,
              h: n,
              hh: n,
              d: n,
              dd: n,
              M: n,
              MM: n,
              y: n,
              yy: n,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      1423: function (e, t, n) {
        !(function (e) {
          e.defineLocale("hy-am", {
            months: {
              format:
                "հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի".split(
                  "_"
                ),
              standalone:
                "հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր".split(
                  "_"
                ),
            },
            monthsShort:
              "հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ".split("_"),
            weekdays:
              "կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ".split(
                "_"
              ),
            weekdaysShort: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
            weekdaysMin: "կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY թ.",
              LLL: "D MMMM YYYY թ., HH:mm",
              LLLL: "dddd, D MMMM YYYY թ., HH:mm",
            },
            calendar: {
              sameDay: "[այսօր] LT",
              nextDay: "[վաղը] LT",
              lastDay: "[երեկ] LT",
              nextWeek: function () {
                return "dddd [օրը ժամը] LT";
              },
              lastWeek: function () {
                return "[անցած] dddd [օրը ժամը] LT";
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "%s հետո",
              past: "%s առաջ",
              s: "մի քանի վայրկյան",
              ss: "%d վայրկյան",
              m: "րոպե",
              mm: "%d րոպե",
              h: "ժամ",
              hh: "%d ժամ",
              d: "օր",
              dd: "%d օր",
              M: "ամիս",
              MM: "%d ամիս",
              y: "տարի",
              yy: "%d տարի",
            },
            meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
            isPM: function (e) {
              return /^(ցերեկվա|երեկոյան)$/.test(e);
            },
            meridiem: function (e) {
              return e < 4
                ? "գիշերվա"
                : e < 12
                ? "առավոտվա"
                : e < 17
                ? "ցերեկվա"
                : "երեկոյան";
            },
            dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
            ordinal: function (e, t) {
              switch (t) {
                case "DDD":
                case "w":
                case "W":
                case "DDDo":
                  return 1 === e ? e + "-ին" : e + "-րդ";
                default:
                  return e;
              }
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      9218: function (e, t, n) {
        !(function (e) {
          e.defineLocale("id", {
            months:
              "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des".split("_"),
            weekdays: "Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu".split("_"),
            weekdaysShort: "Min_Sen_Sel_Rab_Kam_Jum_Sab".split("_"),
            weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
              LT: "HH.mm",
              LTS: "HH.mm.ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY [pukul] HH.mm",
              LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
            },
            meridiemParse: /pagi|siang|sore|malam/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "pagi" === t
                  ? e
                  : "siang" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "sore" === t || "malam" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 11
                ? "pagi"
                : e < 15
                ? "siang"
                : e < 19
                ? "sore"
                : "malam";
            },
            calendar: {
              sameDay: "[Hari ini pukul] LT",
              nextDay: "[Besok pukul] LT",
              nextWeek: "dddd [pukul] LT",
              lastDay: "[Kemarin pukul] LT",
              lastWeek: "dddd [lalu pukul] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "dalam %s",
              past: "%s yang lalu",
              s: "beberapa detik",
              ss: "%d detik",
              m: "semenit",
              mm: "%d menit",
              h: "sejam",
              hh: "%d jam",
              d: "sehari",
              dd: "%d hari",
              M: "sebulan",
              MM: "%d bulan",
              y: "setahun",
              yy: "%d tahun",
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      135: function (e, t, n) {
        !(function (e) {
          function t(e) {
            return e % 100 == 11 || e % 10 != 1;
          }
          function n(e, n, i, a) {
            var r = e + " ";
            switch (i) {
              case "s":
                return n || a ? "nokkrar sekúndur" : "nokkrum sekúndum";
              case "ss":
                return t(e)
                  ? r + (n || a ? "sekúndur" : "sekúndum")
                  : r + "sekúnda";
              case "m":
                return n ? "mínúta" : "mínútu";
              case "mm":
                return t(e)
                  ? r + (n || a ? "mínútur" : "mínútum")
                  : n
                  ? r + "mínúta"
                  : r + "mínútu";
              case "hh":
                return t(e)
                  ? r + (n || a ? "klukkustundir" : "klukkustundum")
                  : r + "klukkustund";
              case "d":
                return n ? "dagur" : a ? "dag" : "degi";
              case "dd":
                return t(e)
                  ? n
                    ? r + "dagar"
                    : r + (a ? "daga" : "dögum")
                  : n
                  ? r + "dagur"
                  : r + (a ? "dag" : "degi");
              case "M":
                return n ? "mánuður" : a ? "mánuð" : "mánuði";
              case "MM":
                return t(e)
                  ? n
                    ? r + "mánuðir"
                    : r + (a ? "mánuði" : "mánuðum")
                  : n
                  ? r + "mánuður"
                  : r + (a ? "mánuð" : "mánuði");
              case "y":
                return n || a ? "ár" : "ári";
              case "yy":
                return t(e)
                  ? r + (n || a ? "ár" : "árum")
                  : r + (n || a ? "ár" : "ári");
            }
          }
          e.defineLocale("is", {
            months:
              "janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember".split(
                "_"
              ),
            monthsShort:
              "jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des".split("_"),
            weekdays:
              "sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur".split(
                "_"
              ),
            weekdaysShort: "sun_mán_þri_mið_fim_fös_lau".split("_"),
            weekdaysMin: "Su_Má_Þr_Mi_Fi_Fö_La".split("_"),
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY [kl.] H:mm",
              LLLL: "dddd, D. MMMM YYYY [kl.] H:mm",
            },
            calendar: {
              sameDay: "[í dag kl.] LT",
              nextDay: "[á morgun kl.] LT",
              nextWeek: "dddd [kl.] LT",
              lastDay: "[í gær kl.] LT",
              lastWeek: "[síðasta] dddd [kl.] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "eftir %s",
              past: "fyrir %s síðan",
              s: n,
              ss: n,
              m: n,
              mm: n,
              h: "klukkustund",
              hh: n,
              d: n,
              dd: n,
              M: n,
              MM: n,
              y: n,
              yy: n,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      150: function (e, t, n) {
        !(function (e) {
          e.defineLocale("it-ch", {
            months:
              "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split(
                "_"
              ),
            monthsShort:
              "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
            weekdays:
              "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split(
                "_"
              ),
            weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
            weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Oggi alle] LT",
              nextDay: "[Domani alle] LT",
              nextWeek: "dddd [alle] LT",
              lastDay: "[Ieri alle] LT",
              lastWeek: function () {
                return 0 === this.day()
                  ? "[la scorsa] dddd [alle] LT"
                  : "[lo scorso] dddd [alle] LT";
              },
              sameElse: "L",
            },
            relativeTime: {
              future: function (e) {
                return (/^[0-9].+$/.test(e) ? "tra" : "in") + " " + e;
              },
              past: "%s fa",
              s: "alcuni secondi",
              ss: "%d secondi",
              m: "un minuto",
              mm: "%d minuti",
              h: "un'ora",
              hh: "%d ore",
              d: "un giorno",
              dd: "%d giorni",
              M: "un mese",
              MM: "%d mesi",
              y: "un anno",
              yy: "%d anni",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      626: function (e, t, n) {
        !(function (e) {
          e.defineLocale("it", {
            months:
              "gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre".split(
                "_"
              ),
            monthsShort:
              "gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic".split("_"),
            weekdays:
              "domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato".split(
                "_"
              ),
            weekdaysShort: "dom_lun_mar_mer_gio_ven_sab".split("_"),
            weekdaysMin: "do_lu_ma_me_gi_ve_sa".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: function () {
                return (
                  "[Oggi a" +
                  (this.hours() > 1
                    ? "lle "
                    : 0 === this.hours()
                    ? " "
                    : "ll'") +
                  "]LT"
                );
              },
              nextDay: function () {
                return (
                  "[Domani a" +
                  (this.hours() > 1
                    ? "lle "
                    : 0 === this.hours()
                    ? " "
                    : "ll'") +
                  "]LT"
                );
              },
              nextWeek: function () {
                return (
                  "dddd [a" +
                  (this.hours() > 1
                    ? "lle "
                    : 0 === this.hours()
                    ? " "
                    : "ll'") +
                  "]LT"
                );
              },
              lastDay: function () {
                return (
                  "[Ieri a" +
                  (this.hours() > 1
                    ? "lle "
                    : 0 === this.hours()
                    ? " "
                    : "ll'") +
                  "]LT"
                );
              },
              lastWeek: function () {
                return 0 === this.day()
                  ? "[La scorsa] dddd [a" +
                      (this.hours() > 1
                        ? "lle "
                        : 0 === this.hours()
                        ? " "
                        : "ll'") +
                      "]LT"
                  : "[Lo scorso] dddd [a" +
                      (this.hours() > 1
                        ? "lle "
                        : 0 === this.hours()
                        ? " "
                        : "ll'") +
                      "]LT";
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "tra %s",
              past: "%s fa",
              s: "alcuni secondi",
              ss: "%d secondi",
              m: "un minuto",
              mm: "%d minuti",
              h: "un'ora",
              hh: "%d ore",
              d: "un giorno",
              dd: "%d giorni",
              w: "una settimana",
              ww: "%d settimane",
              M: "un mese",
              MM: "%d mesi",
              y: "un anno",
              yy: "%d anni",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      9183: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ja", {
            eras: [
              {
                since: "2019-05-01",
                offset: 1,
                name: "令和",
                narrow: "㋿",
                abbr: "R",
              },
              {
                since: "1989-01-08",
                until: "2019-04-30",
                offset: 1,
                name: "平成",
                narrow: "㍻",
                abbr: "H",
              },
              {
                since: "1926-12-25",
                until: "1989-01-07",
                offset: 1,
                name: "昭和",
                narrow: "㍼",
                abbr: "S",
              },
              {
                since: "1912-07-30",
                until: "1926-12-24",
                offset: 1,
                name: "大正",
                narrow: "㍽",
                abbr: "T",
              },
              {
                since: "1873-01-01",
                until: "1912-07-29",
                offset: 6,
                name: "明治",
                narrow: "㍾",
                abbr: "M",
              },
              {
                since: "0001-01-01",
                until: "1873-12-31",
                offset: 1,
                name: "西暦",
                narrow: "AD",
                abbr: "AD",
              },
              {
                since: "0000-12-31",
                until: -1 / 0,
                offset: 1,
                name: "紀元前",
                narrow: "BC",
                abbr: "BC",
              },
            ],
            eraYearOrdinalRegex: /(元|\d+)年/,
            eraYearOrdinalParse: function (e, t) {
              return "元" === t[1] ? 1 : parseInt(t[1] || e, 10);
            },
            months: "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split(
              "_"
            ),
            monthsShort:
              "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日".split(
              "_"
            ),
            weekdaysShort: "日_月_火_水_木_金_土".split("_"),
            weekdaysMin: "日_月_火_水_木_金_土".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY/MM/DD",
              LL: "YYYY年M月D日",
              LLL: "YYYY年M月D日 HH:mm",
              LLLL: "YYYY年M月D日 dddd HH:mm",
              l: "YYYY/MM/DD",
              ll: "YYYY年M月D日",
              lll: "YYYY年M月D日 HH:mm",
              llll: "YYYY年M月D日(ddd) HH:mm",
            },
            meridiemParse: /午前|午後/i,
            isPM: function (e) {
              return "午後" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "午前" : "午後";
            },
            calendar: {
              sameDay: "[今日] LT",
              nextDay: "[明日] LT",
              nextWeek: function (e) {
                return e.week() !== this.week() ? "[来週]dddd LT" : "dddd LT";
              },
              lastDay: "[昨日] LT",
              lastWeek: function (e) {
                return this.week() !== e.week() ? "[先週]dddd LT" : "dddd LT";
              },
              sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}日/,
            ordinal: function (e, t) {
              switch (t) {
                case "y":
                  return 1 === e ? "元年" : e + "年";
                case "d":
                case "D":
                case "DDD":
                  return e + "日";
                default:
                  return e;
              }
            },
            relativeTime: {
              future: "%s後",
              past: "%s前",
              s: "数秒",
              ss: "%d秒",
              m: "1分",
              mm: "%d分",
              h: "1時間",
              hh: "%d時間",
              d: "1日",
              dd: "%d日",
              M: "1ヶ月",
              MM: "%dヶ月",
              y: "1年",
              yy: "%d年",
            },
          });
        })(n(381));
      },
      4286: function (e, t, n) {
        !(function (e) {
          e.defineLocale("jv", {
            months:
              "Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des".split("_"),
            weekdays: "Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu".split("_"),
            weekdaysShort: "Min_Sen_Sel_Reb_Kem_Jem_Sep".split("_"),
            weekdaysMin: "Mg_Sn_Sl_Rb_Km_Jm_Sp".split("_"),
            longDateFormat: {
              LT: "HH.mm",
              LTS: "HH.mm.ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY [pukul] HH.mm",
              LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
            },
            meridiemParse: /enjing|siyang|sonten|ndalu/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "enjing" === t
                  ? e
                  : "siyang" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "sonten" === t || "ndalu" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 11
                ? "enjing"
                : e < 15
                ? "siyang"
                : e < 19
                ? "sonten"
                : "ndalu";
            },
            calendar: {
              sameDay: "[Dinten puniko pukul] LT",
              nextDay: "[Mbenjang pukul] LT",
              nextWeek: "dddd [pukul] LT",
              lastDay: "[Kala wingi pukul] LT",
              lastWeek: "dddd [kepengker pukul] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "wonten ing %s",
              past: "%s ingkang kepengker",
              s: "sawetawis detik",
              ss: "%d detik",
              m: "setunggal menit",
              mm: "%d menit",
              h: "setunggal jam",
              hh: "%d jam",
              d: "sedinten",
              dd: "%d dinten",
              M: "sewulan",
              MM: "%d wulan",
              y: "setaun",
              yy: "%d taun",
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      2105: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ka", {
            months:
              "იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი".split(
                "_"
              ),
            monthsShort:
              "იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ".split("_"),
            weekdays: {
              standalone:
                "კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი".split(
                  "_"
                ),
              format:
                "კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს".split(
                  "_"
                ),
              isFormat: /(წინა|შემდეგ)/,
            },
            weekdaysShort: "კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ".split("_"),
            weekdaysMin: "კვ_ორ_სა_ოთ_ხუ_პა_შა".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[დღეს] LT[-ზე]",
              nextDay: "[ხვალ] LT[-ზე]",
              lastDay: "[გუშინ] LT[-ზე]",
              nextWeek: "[შემდეგ] dddd LT[-ზე]",
              lastWeek: "[წინა] dddd LT-ზე",
              sameElse: "L",
            },
            relativeTime: {
              future: function (e) {
                return e.replace(
                  /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                  function (e, t, n) {
                    return "ი" === n ? t + "ში" : t + n + "ში";
                  }
                );
              },
              past: function (e) {
                return /(წამი|წუთი|საათი|დღე|თვე)/.test(e)
                  ? e.replace(/(ი|ე)$/, "ის წინ")
                  : /წელი/.test(e)
                  ? e.replace(/წელი$/, "წლის წინ")
                  : e;
              },
              s: "რამდენიმე წამი",
              ss: "%d წამი",
              m: "წუთი",
              mm: "%d წუთი",
              h: "საათი",
              hh: "%d საათი",
              d: "დღე",
              dd: "%d დღე",
              M: "თვე",
              MM: "%d თვე",
              y: "წელი",
              yy: "%d წელი",
            },
            dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
            ordinal: function (e) {
              return 0 === e
                ? e
                : 1 === e
                ? e + "-ლი"
                : e < 20 || (e <= 100 && e % 20 == 0) || e % 100 == 0
                ? "მე-" + e
                : e + "-ე";
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      7772: function (e, t, n) {
        !(function (e) {
          var t = {
            0: "-ші",
            1: "-ші",
            2: "-ші",
            3: "-ші",
            4: "-ші",
            5: "-ші",
            6: "-шы",
            7: "-ші",
            8: "-ші",
            9: "-шы",
            10: "-шы",
            20: "-шы",
            30: "-шы",
            40: "-шы",
            50: "-ші",
            60: "-шы",
            70: "-ші",
            80: "-ші",
            90: "-шы",
            100: "-ші",
          };
          e.defineLocale("kk", {
            months:
              "қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан".split(
                "_"
              ),
            monthsShort:
              "қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел".split("_"),
            weekdays:
              "жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі".split(
                "_"
              ),
            weekdaysShort: "жек_дүй_сей_сәр_бей_жұм_сен".split("_"),
            weekdaysMin: "жк_дй_сй_ср_бй_жм_сн".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Бүгін сағат] LT",
              nextDay: "[Ертең сағат] LT",
              nextWeek: "dddd [сағат] LT",
              lastDay: "[Кеше сағат] LT",
              lastWeek: "[Өткен аптаның] dddd [сағат] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s ішінде",
              past: "%s бұрын",
              s: "бірнеше секунд",
              ss: "%d секунд",
              m: "бір минут",
              mm: "%d минут",
              h: "бір сағат",
              hh: "%d сағат",
              d: "бір күн",
              dd: "%d күн",
              M: "бір ай",
              MM: "%d ай",
              y: "бір жыл",
              yy: "%d жыл",
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
            ordinal: function (e) {
              var n = e % 10,
                i = e >= 100 ? 100 : null;
              return e + (t[e] || t[n] || t[i]);
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      8758: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "១",
              2: "២",
              3: "៣",
              4: "៤",
              5: "៥",
              6: "៦",
              7: "៧",
              8: "៨",
              9: "៩",
              0: "០",
            },
            n = {
              "១": "1",
              "២": "2",
              "៣": "3",
              "៤": "4",
              "៥": "5",
              "៦": "6",
              "៧": "7",
              "៨": "8",
              "៩": "9",
              "០": "0",
            };
          e.defineLocale("km", {
            months:
              "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split(
                "_"
              ),
            monthsShort:
              "មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ".split(
                "_"
              ),
            weekdays: "អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍".split(
              "_"
            ),
            weekdaysShort: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
            weekdaysMin: "អា_ច_អ_ព_ព្រ_សុ_ស".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            meridiemParse: /ព្រឹក|ល្ងាច/,
            isPM: function (e) {
              return "ល្ងាច" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ព្រឹក" : "ល្ងាច";
            },
            calendar: {
              sameDay: "[ថ្ងៃនេះ ម៉ោង] LT",
              nextDay: "[ស្អែក ម៉ោង] LT",
              nextWeek: "dddd [ម៉ោង] LT",
              lastDay: "[ម្សិលមិញ ម៉ោង] LT",
              lastWeek: "dddd [សប្តាហ៍មុន] [ម៉ោង] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%sទៀត",
              past: "%sមុន",
              s: "ប៉ុន្មានវិនាទី",
              ss: "%d វិនាទី",
              m: "មួយនាទី",
              mm: "%d នាទី",
              h: "មួយម៉ោង",
              hh: "%d ម៉ោង",
              d: "មួយថ្ងៃ",
              dd: "%d ថ្ងៃ",
              M: "មួយខែ",
              MM: "%d ខែ",
              y: "មួយឆ្នាំ",
              yy: "%d ឆ្នាំ",
            },
            dayOfMonthOrdinalParse: /ទី\d{1,2}/,
            ordinal: "ទី%d",
            preparse: function (e) {
              return e.replace(/[១២៣៤៥៦៧៨៩០]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      9282: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "೧",
              2: "೨",
              3: "೩",
              4: "೪",
              5: "೫",
              6: "೬",
              7: "೭",
              8: "೮",
              9: "೯",
              0: "೦",
            },
            n = {
              "೧": "1",
              "೨": "2",
              "೩": "3",
              "೪": "4",
              "೫": "5",
              "೬": "6",
              "೭": "7",
              "೮": "8",
              "೯": "9",
              "೦": "0",
            };
          e.defineLocale("kn", {
            months:
              "ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್".split(
                "_"
              ),
            monthsShort:
              "ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ".split(
                "_"
              ),
            weekdaysShort: "ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ".split("_"),
            weekdaysMin: "ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ".split("_"),
            longDateFormat: {
              LT: "A h:mm",
              LTS: "A h:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm",
              LLLL: "dddd, D MMMM YYYY, A h:mm",
            },
            calendar: {
              sameDay: "[ಇಂದು] LT",
              nextDay: "[ನಾಳೆ] LT",
              nextWeek: "dddd, LT",
              lastDay: "[ನಿನ್ನೆ] LT",
              lastWeek: "[ಕೊನೆಯ] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s ನಂತರ",
              past: "%s ಹಿಂದೆ",
              s: "ಕೆಲವು ಕ್ಷಣಗಳು",
              ss: "%d ಸೆಕೆಂಡುಗಳು",
              m: "ಒಂದು ನಿಮಿಷ",
              mm: "%d ನಿಮಿಷ",
              h: "ಒಂದು ಗಂಟೆ",
              hh: "%d ಗಂಟೆ",
              d: "ಒಂದು ದಿನ",
              dd: "%d ದಿನ",
              M: "ಒಂದು ತಿಂಗಳು",
              MM: "%d ತಿಂಗಳು",
              y: "ಒಂದು ವರ್ಷ",
              yy: "%d ವರ್ಷ",
            },
            preparse: function (e) {
              return e.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "ರಾತ್ರಿ" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "ಬೆಳಿಗ್ಗೆ" === t
                  ? e
                  : "ಮಧ್ಯಾಹ್ನ" === t
                  ? e >= 10
                    ? e
                    : e + 12
                  : "ಸಂಜೆ" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "ರಾತ್ರಿ"
                : e < 10
                ? "ಬೆಳಿಗ್ಗೆ"
                : e < 17
                ? "ಮಧ್ಯಾಹ್ನ"
                : e < 20
                ? "ಸಂಜೆ"
                : "ರಾತ್ರಿ";
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
            ordinal: function (e) {
              return e + "ನೇ";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      3730: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ko", {
            months: "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split(
              "_"
            ),
            monthsShort:
              "1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월".split("_"),
            weekdays: "일요일_월요일_화요일_수요일_목요일_금요일_토요일".split(
              "_"
            ),
            weekdaysShort: "일_월_화_수_목_금_토".split("_"),
            weekdaysMin: "일_월_화_수_목_금_토".split("_"),
            longDateFormat: {
              LT: "A h:mm",
              LTS: "A h:mm:ss",
              L: "YYYY.MM.DD.",
              LL: "YYYY년 MMMM D일",
              LLL: "YYYY년 MMMM D일 A h:mm",
              LLLL: "YYYY년 MMMM D일 dddd A h:mm",
              l: "YYYY.MM.DD.",
              ll: "YYYY년 MMMM D일",
              lll: "YYYY년 MMMM D일 A h:mm",
              llll: "YYYY년 MMMM D일 dddd A h:mm",
            },
            calendar: {
              sameDay: "오늘 LT",
              nextDay: "내일 LT",
              nextWeek: "dddd LT",
              lastDay: "어제 LT",
              lastWeek: "지난주 dddd LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s 후",
              past: "%s 전",
              s: "몇 초",
              ss: "%d초",
              m: "1분",
              mm: "%d분",
              h: "한 시간",
              hh: "%d시간",
              d: "하루",
              dd: "%d일",
              M: "한 달",
              MM: "%d달",
              y: "일 년",
              yy: "%d년",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
            ordinal: function (e, t) {
              switch (t) {
                case "d":
                case "D":
                case "DDD":
                  return e + "일";
                case "M":
                  return e + "월";
                case "w":
                case "W":
                  return e + "주";
                default:
                  return e;
              }
            },
            meridiemParse: /오전|오후/,
            isPM: function (e) {
              return "오후" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "오전" : "오후";
            },
          });
        })(n(381));
      },
      563: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              s: ["çend sanîye", "çend sanîyeyan"],
              ss: [e + " sanîye", e + " sanîyeyan"],
              m: ["deqîqeyek", "deqîqeyekê"],
              mm: [e + " deqîqe", e + " deqîqeyan"],
              h: ["saetek", "saetekê"],
              hh: [e + " saet", e + " saetan"],
              d: ["rojek", "rojekê"],
              dd: [e + " roj", e + " rojan"],
              w: ["hefteyek", "hefteyekê"],
              ww: [e + " hefte", e + " hefteyan"],
              M: ["mehek", "mehekê"],
              MM: [e + " meh", e + " mehan"],
              y: ["salek", "salekê"],
              yy: [e + " sal", e + " salan"],
            };
            return t ? a[n][0] : a[n][1];
          }
          function n(e) {
            var t = (e = "" + e).substring(e.length - 1),
              n = e.length > 1 ? e.substring(e.length - 2) : "";
            return 12 == n ||
              13 == n ||
              ("2" != t && "3" != t && "50" != n && "70" != t && "80" != t)
              ? "ê"
              : "yê";
          }
          e.defineLocale("ku-kmr", {
            months:
              "Rêbendan_Sibat_Adar_Nîsan_Gulan_Hezîran_Tîrmeh_Tebax_Îlon_Cotmeh_Mijdar_Berfanbar".split(
                "_"
              ),
            monthsShort:
              "Rêb_Sib_Ada_Nîs_Gul_Hez_Tîr_Teb_Îlo_Cot_Mij_Ber".split("_"),
            monthsParseExact: !0,
            weekdays: "Yekşem_Duşem_Sêşem_Çarşem_Pêncşem_În_Şemî".split("_"),
            weekdaysShort: "Yek_Du_Sê_Çar_Pên_În_Şem".split("_"),
            weekdaysMin: "Ye_Du_Sê_Ça_Pê_În_Şe".split("_"),
            meridiem: function (e, t, n) {
              return e < 12 ? (n ? "bn" : "BN") : n ? "pn" : "PN";
            },
            meridiemParse: /bn|BN|pn|PN/,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "Do MMMM[a] YYYY[an]",
              LLL: "Do MMMM[a] YYYY[an] HH:mm",
              LLLL: "dddd, Do MMMM[a] YYYY[an] HH:mm",
              ll: "Do MMM[.] YYYY[an]",
              lll: "Do MMM[.] YYYY[an] HH:mm",
              llll: "ddd[.], Do MMM[.] YYYY[an] HH:mm",
            },
            calendar: {
              sameDay: "[Îro di saet] LT [de]",
              nextDay: "[Sibê di saet] LT [de]",
              nextWeek: "dddd [di saet] LT [de]",
              lastDay: "[Duh di saet] LT [de]",
              lastWeek: "dddd[a borî di saet] LT [de]",
              sameElse: "L",
            },
            relativeTime: {
              future: "di %s de",
              past: "berî %s",
              s: t,
              ss: t,
              m: t,
              mm: t,
              h: t,
              hh: t,
              d: t,
              dd: t,
              w: t,
              ww: t,
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}(?:yê|ê|\.)/,
            ordinal: function (e, t) {
              var i = t.toLowerCase();
              return i.includes("w") || i.includes("m") ? e + "." : e + n(e);
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      1408: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "١",
              2: "٢",
              3: "٣",
              4: "٤",
              5: "٥",
              6: "٦",
              7: "٧",
              8: "٨",
              9: "٩",
              0: "٠",
            },
            n = {
              "١": "1",
              "٢": "2",
              "٣": "3",
              "٤": "4",
              "٥": "5",
              "٦": "6",
              "٧": "7",
              "٨": "8",
              "٩": "9",
              "٠": "0",
            },
            i = [
              "کانونی دووەم",
              "شوبات",
              "ئازار",
              "نیسان",
              "ئایار",
              "حوزەیران",
              "تەمموز",
              "ئاب",
              "ئەیلوول",
              "تشرینی یەكەم",
              "تشرینی دووەم",
              "كانونی یەکەم",
            ];
          e.defineLocale("ku", {
            months: i,
            monthsShort: i,
            weekdays:
              "یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌".split(
                "_"
              ),
            weekdaysShort:
              "یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌".split(
                "_"
              ),
            weekdaysMin: "ی_د_س_چ_پ_ه_ش".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            meridiemParse: /ئێواره‌|به‌یانی/,
            isPM: function (e) {
              return /ئێواره‌/.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "به‌یانی" : "ئێواره‌";
            },
            calendar: {
              sameDay: "[ئه‌مرۆ كاتژمێر] LT",
              nextDay: "[به‌یانی كاتژمێر] LT",
              nextWeek: "dddd [كاتژمێر] LT",
              lastDay: "[دوێنێ كاتژمێر] LT",
              lastWeek: "dddd [كاتژمێر] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "له‌ %s",
              past: "%s",
              s: "چه‌ند چركه‌یه‌ك",
              ss: "چركه‌ %d",
              m: "یه‌ك خوله‌ك",
              mm: "%d خوله‌ك",
              h: "یه‌ك كاتژمێر",
              hh: "%d كاتژمێر",
              d: "یه‌ك ڕۆژ",
              dd: "%d ڕۆژ",
              M: "یه‌ك مانگ",
              MM: "%d مانگ",
              y: "یه‌ك ساڵ",
              yy: "%d ساڵ",
            },
            preparse: function (e) {
              return e
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (e) {
                  return n[e];
                })
                .replace(/،/g, ",");
            },
            postformat: function (e) {
              return e
                .replace(/\d/g, function (e) {
                  return t[e];
                })
                .replace(/,/g, "،");
            },
            week: { dow: 6, doy: 12 },
          });
        })(n(381));
      },
      3291: function (e, t, n) {
        !(function (e) {
          var t = {
            0: "-чү",
            1: "-чи",
            2: "-чи",
            3: "-чү",
            4: "-чү",
            5: "-чи",
            6: "-чы",
            7: "-чи",
            8: "-чи",
            9: "-чу",
            10: "-чу",
            20: "-чы",
            30: "-чу",
            40: "-чы",
            50: "-чү",
            60: "-чы",
            70: "-чи",
            80: "-чи",
            90: "-чу",
            100: "-чү",
          };
          e.defineLocale("ky", {
            months:
              "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split(
                "_"
              ),
            monthsShort:
              "янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек".split("_"),
            weekdays:
              "Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби".split(
                "_"
              ),
            weekdaysShort: "Жек_Дүй_Шей_Шар_Бей_Жум_Ише".split("_"),
            weekdaysMin: "Жк_Дй_Шй_Шр_Бй_Жм_Иш".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Бүгүн саат] LT",
              nextDay: "[Эртең саат] LT",
              nextWeek: "dddd [саат] LT",
              lastDay: "[Кечээ саат] LT",
              lastWeek: "[Өткөн аптанын] dddd [күнү] [саат] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s ичинде",
              past: "%s мурун",
              s: "бирнече секунд",
              ss: "%d секунд",
              m: "бир мүнөт",
              mm: "%d мүнөт",
              h: "бир саат",
              hh: "%d саат",
              d: "бир күн",
              dd: "%d күн",
              M: "бир ай",
              MM: "%d ай",
              y: "бир жыл",
              yy: "%d жыл",
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
            ordinal: function (e) {
              var n = e % 10,
                i = e >= 100 ? 100 : null;
              return e + (t[e] || t[n] || t[i]);
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      6841: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              m: ["eng Minutt", "enger Minutt"],
              h: ["eng Stonn", "enger Stonn"],
              d: ["een Dag", "engem Dag"],
              M: ["ee Mount", "engem Mount"],
              y: ["ee Joer", "engem Joer"],
            };
            return t ? a[n][0] : a[n][1];
          }
          function n(e) {
            return a(e.substr(0, e.indexOf(" "))) ? "a " + e : "an " + e;
          }
          function i(e) {
            return a(e.substr(0, e.indexOf(" "))) ? "viru " + e : "virun " + e;
          }
          function a(e) {
            if (((e = parseInt(e, 10)), isNaN(e))) return !1;
            if (e < 0) return !0;
            if (e < 10) return 4 <= e && e <= 7;
            if (e < 100) {
              var t = e % 10;
              return a(0 === t ? e / 10 : t);
            }
            if (e < 1e4) {
              for (; e >= 10; ) e /= 10;
              return a(e);
            }
            return a((e /= 1e3));
          }
          e.defineLocale("lb", {
            months:
              "Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember".split(
                "_"
              ),
            monthsShort:
              "Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg".split(
                "_"
              ),
            weekdaysShort: "So._Mé._Dë._Më._Do._Fr._Sa.".split("_"),
            weekdaysMin: "So_Mé_Dë_Më_Do_Fr_Sa".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm [Auer]",
              LTS: "H:mm:ss [Auer]",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY H:mm [Auer]",
              LLLL: "dddd, D. MMMM YYYY H:mm [Auer]",
            },
            calendar: {
              sameDay: "[Haut um] LT",
              sameElse: "L",
              nextDay: "[Muer um] LT",
              nextWeek: "dddd [um] LT",
              lastDay: "[Gëschter um] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 2:
                  case 4:
                    return "[Leschten] dddd [um] LT";
                  default:
                    return "[Leschte] dddd [um] LT";
                }
              },
            },
            relativeTime: {
              future: n,
              past: i,
              s: "e puer Sekonnen",
              ss: "%d Sekonnen",
              m: t,
              mm: "%d Minutten",
              h: t,
              hh: "%d Stonnen",
              d: t,
              dd: "%d Deeg",
              M: t,
              MM: "%d Méint",
              y: t,
              yy: "%d Joer",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      5466: function (e, t, n) {
        !(function (e) {
          e.defineLocale("lo", {
            months:
              "ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split(
                "_"
              ),
            monthsShort:
              "ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ".split(
                "_"
              ),
            weekdays: "ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),
            weekdaysShort: "ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ".split("_"),
            weekdaysMin: "ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "ວັນdddd D MMMM YYYY HH:mm",
            },
            meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
            isPM: function (e) {
              return "ຕອນແລງ" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ຕອນເຊົ້າ" : "ຕອນແລງ";
            },
            calendar: {
              sameDay: "[ມື້ນີ້ເວລາ] LT",
              nextDay: "[ມື້ອື່ນເວລາ] LT",
              nextWeek: "[ວັນ]dddd[ໜ້າເວລາ] LT",
              lastDay: "[ມື້ວານນີ້ເວລາ] LT",
              lastWeek: "[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "ອີກ %s",
              past: "%sຜ່ານມາ",
              s: "ບໍ່ເທົ່າໃດວິນາທີ",
              ss: "%d ວິນາທີ",
              m: "1 ນາທີ",
              mm: "%d ນາທີ",
              h: "1 ຊົ່ວໂມງ",
              hh: "%d ຊົ່ວໂມງ",
              d: "1 ມື້",
              dd: "%d ມື້",
              M: "1 ເດືອນ",
              MM: "%d ເດືອນ",
              y: "1 ປີ",
              yy: "%d ປີ",
            },
            dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
            ordinal: function (e) {
              return "ທີ່" + e;
            },
          });
        })(n(381));
      },
      7010: function (e, t, n) {
        !(function (e) {
          var t = {
            ss: "sekundė_sekundžių_sekundes",
            m: "minutė_minutės_minutę",
            mm: "minutės_minučių_minutes",
            h: "valanda_valandos_valandą",
            hh: "valandos_valandų_valandas",
            d: "diena_dienos_dieną",
            dd: "dienos_dienų_dienas",
            M: "mėnuo_mėnesio_mėnesį",
            MM: "mėnesiai_mėnesių_mėnesius",
            y: "metai_metų_metus",
            yy: "metai_metų_metus",
          };
          function n(e, t, n, i) {
            return t
              ? "kelios sekundės"
              : i
              ? "kelių sekundžių"
              : "kelias sekundes";
          }
          function i(e, t, n, i) {
            return t ? r(n)[0] : i ? r(n)[1] : r(n)[2];
          }
          function a(e) {
            return e % 10 == 0 || (e > 10 && e < 20);
          }
          function r(e) {
            return t[e].split("_");
          }
          function l(e, t, n, l) {
            var o = e + " ";
            return 1 === e
              ? o + i(e, t, n[0], l)
              : t
              ? o + (a(e) ? r(n)[1] : r(n)[0])
              : l
              ? o + r(n)[1]
              : o + (a(e) ? r(n)[1] : r(n)[2]);
          }
          e.defineLocale("lt", {
            months: {
              format:
                "sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio".split(
                  "_"
                ),
              standalone:
                "sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis".split(
                  "_"
                ),
              isFormat:
                /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
            },
            monthsShort:
              "sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd".split("_"),
            weekdays: {
              format:
                "sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį".split(
                  "_"
                ),
              standalone:
                "sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis".split(
                  "_"
                ),
              isFormat: /dddd HH:mm/,
            },
            weekdaysShort: "Sek_Pir_Ant_Tre_Ket_Pen_Šeš".split("_"),
            weekdaysMin: "S_P_A_T_K_Pn_Š".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY-MM-DD",
              LL: "YYYY [m.] MMMM D [d.]",
              LLL: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
              LLLL: "YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]",
              l: "YYYY-MM-DD",
              ll: "YYYY [m.] MMMM D [d.]",
              lll: "YYYY [m.] MMMM D [d.], HH:mm [val.]",
              llll: "YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]",
            },
            calendar: {
              sameDay: "[Šiandien] LT",
              nextDay: "[Rytoj] LT",
              nextWeek: "dddd LT",
              lastDay: "[Vakar] LT",
              lastWeek: "[Praėjusį] dddd LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "po %s",
              past: "prieš %s",
              s: n,
              ss: l,
              m: i,
              mm: l,
              h: i,
              hh: l,
              d: i,
              dd: l,
              M: i,
              MM: l,
              y: i,
              yy: l,
            },
            dayOfMonthOrdinalParse: /\d{1,2}-oji/,
            ordinal: function (e) {
              return e + "-oji";
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      7595: function (e, t, n) {
        !(function (e) {
          var t = {
            ss: "sekundes_sekundēm_sekunde_sekundes".split("_"),
            m: "minūtes_minūtēm_minūte_minūtes".split("_"),
            mm: "minūtes_minūtēm_minūte_minūtes".split("_"),
            h: "stundas_stundām_stunda_stundas".split("_"),
            hh: "stundas_stundām_stunda_stundas".split("_"),
            d: "dienas_dienām_diena_dienas".split("_"),
            dd: "dienas_dienām_diena_dienas".split("_"),
            M: "mēneša_mēnešiem_mēnesis_mēneši".split("_"),
            MM: "mēneša_mēnešiem_mēnesis_mēneši".split("_"),
            y: "gada_gadiem_gads_gadi".split("_"),
            yy: "gada_gadiem_gads_gadi".split("_"),
          };
          function n(e, t, n) {
            return n
              ? t % 10 == 1 && t % 100 != 11
                ? e[2]
                : e[3]
              : t % 10 == 1 && t % 100 != 11
              ? e[0]
              : e[1];
          }
          function i(e, i, a) {
            return e + " " + n(t[a], e, i);
          }
          function a(e, i, a) {
            return n(t[a], e, i);
          }
          function r(e, t) {
            return t ? "dažas sekundes" : "dažām sekundēm";
          }
          e.defineLocale("lv", {
            months:
              "janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris".split(
                "_"
              ),
            monthsShort:
              "jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec".split("_"),
            weekdays:
              "svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena".split(
                "_"
              ),
            weekdaysShort: "Sv_P_O_T_C_Pk_S".split("_"),
            weekdaysMin: "Sv_P_O_T_C_Pk_S".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY.",
              LL: "YYYY. [gada] D. MMMM",
              LLL: "YYYY. [gada] D. MMMM, HH:mm",
              LLLL: "YYYY. [gada] D. MMMM, dddd, HH:mm",
            },
            calendar: {
              sameDay: "[Šodien pulksten] LT",
              nextDay: "[Rīt pulksten] LT",
              nextWeek: "dddd [pulksten] LT",
              lastDay: "[Vakar pulksten] LT",
              lastWeek: "[Pagājušā] dddd [pulksten] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "pēc %s",
              past: "pirms %s",
              s: r,
              ss: i,
              m: a,
              mm: i,
              h: a,
              hh: i,
              d: a,
              dd: i,
              M: a,
              MM: i,
              y: a,
              yy: i,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      9861: function (e, t, n) {
        !(function (e) {
          var t = {
            words: {
              ss: ["sekund", "sekunda", "sekundi"],
              m: ["jedan minut", "jednog minuta"],
              mm: ["minut", "minuta", "minuta"],
              h: ["jedan sat", "jednog sata"],
              hh: ["sat", "sata", "sati"],
              dd: ["dan", "dana", "dana"],
              MM: ["mjesec", "mjeseca", "mjeseci"],
              yy: ["godina", "godine", "godina"],
            },
            correctGrammaticalCase: function (e, t) {
              return 1 === e ? t[0] : e >= 2 && e <= 4 ? t[1] : t[2];
            },
            translate: function (e, n, i) {
              var a = t.words[i];
              return 1 === i.length
                ? n
                  ? a[0]
                  : a[1]
                : e + " " + t.correctGrammaticalCase(e, a);
            },
          };
          e.defineLocale("me", {
            months:
              "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split(
                "_"
              ),
            monthsShort:
              "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota".split(
                "_"
              ),
            weekdaysShort: "ned._pon._uto._sri._čet._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY H:mm",
              LLLL: "dddd, D. MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[danas u] LT",
              nextDay: "[sjutra u] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[u] [nedjelju] [u] LT";
                  case 3:
                    return "[u] [srijedu] [u] LT";
                  case 6:
                    return "[u] [subotu] [u] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[u] dddd [u] LT";
                }
              },
              lastDay: "[juče u] LT",
              lastWeek: function () {
                return [
                  "[prošle] [nedjelje] [u] LT",
                  "[prošlog] [ponedjeljka] [u] LT",
                  "[prošlog] [utorka] [u] LT",
                  "[prošle] [srijede] [u] LT",
                  "[prošlog] [četvrtka] [u] LT",
                  "[prošlog] [petka] [u] LT",
                  "[prošle] [subote] [u] LT",
                ][this.day()];
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "za %s",
              past: "prije %s",
              s: "nekoliko sekundi",
              ss: t.translate,
              m: t.translate,
              mm: t.translate,
              h: t.translate,
              hh: t.translate,
              d: "dan",
              dd: t.translate,
              M: "mjesec",
              MM: t.translate,
              y: "godinu",
              yy: t.translate,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      5493: function (e, t, n) {
        !(function (e) {
          e.defineLocale("mi", {
            months:
              "Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea".split(
                "_"
              ),
            monthsShort:
              "Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki".split(
                "_"
              ),
            monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
            monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
            weekdays: "Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei".split(
              "_"
            ),
            weekdaysShort: "Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),
            weekdaysMin: "Ta_Ma_Tū_We_Tāi_Pa_Hā".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY [i] HH:mm",
              LLLL: "dddd, D MMMM YYYY [i] HH:mm",
            },
            calendar: {
              sameDay: "[i teie mahana, i] LT",
              nextDay: "[apopo i] LT",
              nextWeek: "dddd [i] LT",
              lastDay: "[inanahi i] LT",
              lastWeek: "dddd [whakamutunga i] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "i roto i %s",
              past: "%s i mua",
              s: "te hēkona ruarua",
              ss: "%d hēkona",
              m: "he meneti",
              mm: "%d meneti",
              h: "te haora",
              hh: "%d haora",
              d: "he ra",
              dd: "%d ra",
              M: "he marama",
              MM: "%d marama",
              y: "he tau",
              yy: "%d tau",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      5966: function (e, t, n) {
        !(function (e) {
          e.defineLocale("mk", {
            months:
              "јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември".split(
                "_"
              ),
            monthsShort:
              "јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек".split("_"),
            weekdays:
              "недела_понеделник_вторник_среда_четврток_петок_сабота".split(
                "_"
              ),
            weekdaysShort: "нед_пон_вто_сре_чет_пет_саб".split("_"),
            weekdaysMin: "нe_пo_вт_ср_че_пе_сa".split("_"),
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "D.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY H:mm",
              LLLL: "dddd, D MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[Денес во] LT",
              nextDay: "[Утре во] LT",
              nextWeek: "[Во] dddd [во] LT",
              lastDay: "[Вчера во] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                  case 3:
                  case 6:
                    return "[Изминатата] dddd [во] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[Изминатиот] dddd [во] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "за %s",
              past: "пред %s",
              s: "неколку секунди",
              ss: "%d секунди",
              m: "една минута",
              mm: "%d минути",
              h: "еден час",
              hh: "%d часа",
              d: "еден ден",
              dd: "%d дена",
              M: "еден месец",
              MM: "%d месеци",
              y: "една година",
              yy: "%d години",
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
            ordinal: function (e) {
              var t = e % 10,
                n = e % 100;
              return 0 === e
                ? e + "-ев"
                : 0 === n
                ? e + "-ен"
                : n > 10 && n < 20
                ? e + "-ти"
                : 1 === t
                ? e + "-ви"
                : 2 === t
                ? e + "-ри"
                : 7 === t || 8 === t
                ? e + "-ми"
                : e + "-ти";
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      7341: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ml", {
            months:
              "ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ".split(
                "_"
              ),
            monthsShort:
              "ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച".split(
                "_"
              ),
            weekdaysShort: "ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി".split(
              "_"
            ),
            weekdaysMin: "ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ".split("_"),
            longDateFormat: {
              LT: "A h:mm -നു",
              LTS: "A h:mm:ss -നു",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm -നു",
              LLLL: "dddd, D MMMM YYYY, A h:mm -നു",
            },
            calendar: {
              sameDay: "[ഇന്ന്] LT",
              nextDay: "[നാളെ] LT",
              nextWeek: "dddd, LT",
              lastDay: "[ഇന്നലെ] LT",
              lastWeek: "[കഴിഞ്ഞ] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s കഴിഞ്ഞ്",
              past: "%s മുൻപ്",
              s: "അൽപ നിമിഷങ്ങൾ",
              ss: "%d സെക്കൻഡ്",
              m: "ഒരു മിനിറ്റ്",
              mm: "%d മിനിറ്റ്",
              h: "ഒരു മണിക്കൂർ",
              hh: "%d മണിക്കൂർ",
              d: "ഒരു ദിവസം",
              dd: "%d ദിവസം",
              M: "ഒരു മാസം",
              MM: "%d മാസം",
              y: "ഒരു വർഷം",
              yy: "%d വർഷം",
            },
            meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                ("രാത്രി" === t && e >= 4) ||
                "ഉച്ച കഴിഞ്ഞ്" === t ||
                "വൈകുന്നേരം" === t
                  ? e + 12
                  : e
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "രാത്രി"
                : e < 12
                ? "രാവിലെ"
                : e < 17
                ? "ഉച്ച കഴിഞ്ഞ്"
                : e < 20
                ? "വൈകുന്നേരം"
                : "രാത്രി";
            },
          });
        })(n(381));
      },
      5115: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            switch (n) {
              case "s":
                return t ? "хэдхэн секунд" : "хэдхэн секундын";
              case "ss":
                return e + (t ? " секунд" : " секундын");
              case "m":
              case "mm":
                return e + (t ? " минут" : " минутын");
              case "h":
              case "hh":
                return e + (t ? " цаг" : " цагийн");
              case "d":
              case "dd":
                return e + (t ? " өдөр" : " өдрийн");
              case "M":
              case "MM":
                return e + (t ? " сар" : " сарын");
              case "y":
              case "yy":
                return e + (t ? " жил" : " жилийн");
              default:
                return e;
            }
          }
          e.defineLocale("mn", {
            months:
              "Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар".split(
                "_"
              ),
            monthsShort:
              "1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays: "Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба".split("_"),
            weekdaysShort: "Ням_Дав_Мяг_Лха_Пүр_Баа_Бям".split("_"),
            weekdaysMin: "Ня_Да_Мя_Лх_Пү_Ба_Бя".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY-MM-DD",
              LL: "YYYY оны MMMMын D",
              LLL: "YYYY оны MMMMын D HH:mm",
              LLLL: "dddd, YYYY оны MMMMын D HH:mm",
            },
            meridiemParse: /ҮӨ|ҮХ/i,
            isPM: function (e) {
              return "ҮХ" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ҮӨ" : "ҮХ";
            },
            calendar: {
              sameDay: "[Өнөөдөр] LT",
              nextDay: "[Маргааш] LT",
              nextWeek: "[Ирэх] dddd LT",
              lastDay: "[Өчигдөр] LT",
              lastWeek: "[Өнгөрсөн] dddd LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s дараа",
              past: "%s өмнө",
              s: t,
              ss: t,
              m: t,
              mm: t,
              h: t,
              hh: t,
              d: t,
              dd: t,
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
            ordinal: function (e, t) {
              switch (t) {
                case "d":
                case "D":
                case "DDD":
                  return e + " өдөр";
                default:
                  return e;
              }
            },
          });
        })(n(381));
      },
      370: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "१",
              2: "२",
              3: "३",
              4: "४",
              5: "५",
              6: "६",
              7: "७",
              8: "८",
              9: "९",
              0: "०",
            },
            n = {
              "१": "1",
              "२": "2",
              "३": "3",
              "४": "4",
              "५": "5",
              "६": "6",
              "७": "7",
              "८": "8",
              "९": "9",
              "०": "0",
            };
          function i(e, t, n, i) {
            var a = "";
            if (t)
              switch (n) {
                case "s":
                  a = "काही सेकंद";
                  break;
                case "ss":
                  a = "%d सेकंद";
                  break;
                case "m":
                  a = "एक मिनिट";
                  break;
                case "mm":
                  a = "%d मिनिटे";
                  break;
                case "h":
                  a = "एक तास";
                  break;
                case "hh":
                  a = "%d तास";
                  break;
                case "d":
                  a = "एक दिवस";
                  break;
                case "dd":
                  a = "%d दिवस";
                  break;
                case "M":
                  a = "एक महिना";
                  break;
                case "MM":
                  a = "%d महिने";
                  break;
                case "y":
                  a = "एक वर्ष";
                  break;
                case "yy":
                  a = "%d वर्षे";
              }
            else
              switch (n) {
                case "s":
                  a = "काही सेकंदां";
                  break;
                case "ss":
                  a = "%d सेकंदां";
                  break;
                case "m":
                  a = "एका मिनिटा";
                  break;
                case "mm":
                  a = "%d मिनिटां";
                  break;
                case "h":
                  a = "एका तासा";
                  break;
                case "hh":
                  a = "%d तासां";
                  break;
                case "d":
                  a = "एका दिवसा";
                  break;
                case "dd":
                  a = "%d दिवसां";
                  break;
                case "M":
                  a = "एका महिन्या";
                  break;
                case "MM":
                  a = "%d महिन्यां";
                  break;
                case "y":
                  a = "एका वर्षा";
                  break;
                case "yy":
                  a = "%d वर्षां";
              }
            return a.replace(/%d/i, e);
          }
          e.defineLocale("mr", {
            months:
              "जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर".split(
                "_"
              ),
            monthsShort:
              "जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार".split("_"),
            weekdaysShort: "रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि".split("_"),
            weekdaysMin: "र_सो_मं_बु_गु_शु_श".split("_"),
            longDateFormat: {
              LT: "A h:mm वाजता",
              LTS: "A h:mm:ss वाजता",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm वाजता",
              LLLL: "dddd, D MMMM YYYY, A h:mm वाजता",
            },
            calendar: {
              sameDay: "[आज] LT",
              nextDay: "[उद्या] LT",
              nextWeek: "dddd, LT",
              lastDay: "[काल] LT",
              lastWeek: "[मागील] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%sमध्ये",
              past: "%sपूर्वी",
              s: i,
              ss: i,
              m: i,
              mm: i,
              h: i,
              hh: i,
              d: i,
              dd: i,
              M: i,
              MM: i,
              y: i,
              yy: i,
            },
            preparse: function (e) {
              return e.replace(/[१२३४५६७८९०]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "पहाटे" === t || "सकाळी" === t
                  ? e
                  : "दुपारी" === t || "सायंकाळी" === t || "रात्री" === t
                  ? e >= 12
                    ? e
                    : e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e >= 0 && e < 6
                ? "पहाटे"
                : e < 12
                ? "सकाळी"
                : e < 17
                ? "दुपारी"
                : e < 20
                ? "सायंकाळी"
                : "रात्री";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      1237: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ms-my", {
            months:
              "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
            weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
            weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
            weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
              LT: "HH.mm",
              LTS: "HH.mm.ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY [pukul] HH.mm",
              LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
            },
            meridiemParse: /pagi|tengahari|petang|malam/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "pagi" === t
                  ? e
                  : "tengahari" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "petang" === t || "malam" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 11
                ? "pagi"
                : e < 15
                ? "tengahari"
                : e < 19
                ? "petang"
                : "malam";
            },
            calendar: {
              sameDay: "[Hari ini pukul] LT",
              nextDay: "[Esok pukul] LT",
              nextWeek: "dddd [pukul] LT",
              lastDay: "[Kelmarin pukul] LT",
              lastWeek: "dddd [lepas pukul] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "dalam %s",
              past: "%s yang lepas",
              s: "beberapa saat",
              ss: "%d saat",
              m: "seminit",
              mm: "%d minit",
              h: "sejam",
              hh: "%d jam",
              d: "sehari",
              dd: "%d hari",
              M: "sebulan",
              MM: "%d bulan",
              y: "setahun",
              yy: "%d tahun",
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      9847: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ms", {
            months:
              "Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis".split("_"),
            weekdays: "Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu".split("_"),
            weekdaysShort: "Ahd_Isn_Sel_Rab_Kha_Jum_Sab".split("_"),
            weekdaysMin: "Ah_Is_Sl_Rb_Km_Jm_Sb".split("_"),
            longDateFormat: {
              LT: "HH.mm",
              LTS: "HH.mm.ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY [pukul] HH.mm",
              LLLL: "dddd, D MMMM YYYY [pukul] HH.mm",
            },
            meridiemParse: /pagi|tengahari|petang|malam/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "pagi" === t
                  ? e
                  : "tengahari" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "petang" === t || "malam" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 11
                ? "pagi"
                : e < 15
                ? "tengahari"
                : e < 19
                ? "petang"
                : "malam";
            },
            calendar: {
              sameDay: "[Hari ini pukul] LT",
              nextDay: "[Esok pukul] LT",
              nextWeek: "dddd [pukul] LT",
              lastDay: "[Kelmarin pukul] LT",
              lastWeek: "dddd [lepas pukul] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "dalam %s",
              past: "%s yang lepas",
              s: "beberapa saat",
              ss: "%d saat",
              m: "seminit",
              mm: "%d minit",
              h: "sejam",
              hh: "%d jam",
              d: "sehari",
              dd: "%d hari",
              M: "sebulan",
              MM: "%d bulan",
              y: "setahun",
              yy: "%d tahun",
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      2126: function (e, t, n) {
        !(function (e) {
          e.defineLocale("mt", {
            months:
              "Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru".split(
                "_"
              ),
            monthsShort:
              "Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ".split("_"),
            weekdays:
              "Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt".split(
                "_"
              ),
            weekdaysShort: "Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib".split("_"),
            weekdaysMin: "Ħa_Tn_Tl_Er_Ħa_Ġi_Si".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Illum fil-]LT",
              nextDay: "[Għada fil-]LT",
              nextWeek: "dddd [fil-]LT",
              lastDay: "[Il-bieraħ fil-]LT",
              lastWeek: "dddd [li għadda] [fil-]LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "f’ %s",
              past: "%s ilu",
              s: "ftit sekondi",
              ss: "%d sekondi",
              m: "minuta",
              mm: "%d minuti",
              h: "siegħa",
              hh: "%d siegħat",
              d: "ġurnata",
              dd: "%d ġranet",
              M: "xahar",
              MM: "%d xhur",
              y: "sena",
              yy: "%d sni",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      6165: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "၁",
              2: "၂",
              3: "၃",
              4: "၄",
              5: "၅",
              6: "၆",
              7: "၇",
              8: "၈",
              9: "၉",
              0: "၀",
            },
            n = {
              "၁": "1",
              "၂": "2",
              "၃": "3",
              "၄": "4",
              "၅": "5",
              "၆": "6",
              "၇": "7",
              "၈": "8",
              "၉": "9",
              "၀": "0",
            };
          e.defineLocale("my", {
            months:
              "ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ".split(
                "_"
              ),
            monthsShort:
              "ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ".split("_"),
            weekdays:
              "တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ".split(
                "_"
              ),
            weekdaysShort: "နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),
            weekdaysMin: "နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[ယနေ.] LT [မှာ]",
              nextDay: "[မနက်ဖြန်] LT [မှာ]",
              nextWeek: "dddd LT [မှာ]",
              lastDay: "[မနေ.က] LT [မှာ]",
              lastWeek: "[ပြီးခဲ့သော] dddd LT [မှာ]",
              sameElse: "L",
            },
            relativeTime: {
              future: "လာမည့် %s မှာ",
              past: "လွန်ခဲ့သော %s က",
              s: "စက္ကန်.အနည်းငယ်",
              ss: "%d စက္ကန့်",
              m: "တစ်မိနစ်",
              mm: "%d မိနစ်",
              h: "တစ်နာရီ",
              hh: "%d နာရီ",
              d: "တစ်ရက်",
              dd: "%d ရက်",
              M: "တစ်လ",
              MM: "%d လ",
              y: "တစ်နှစ်",
              yy: "%d နှစ်",
            },
            preparse: function (e) {
              return e.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      4924: function (e, t, n) {
        !(function (e) {
          e.defineLocale("nb", {
            months:
              "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split(
                "_"
              ),
            monthsShort:
              "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag".split("_"),
            weekdaysShort: "sø._ma._ti._on._to._fr._lø.".split("_"),
            weekdaysMin: "sø_ma_ti_on_to_fr_lø".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY [kl.] HH:mm",
              LLLL: "dddd D. MMMM YYYY [kl.] HH:mm",
            },
            calendar: {
              sameDay: "[i dag kl.] LT",
              nextDay: "[i morgen kl.] LT",
              nextWeek: "dddd [kl.] LT",
              lastDay: "[i går kl.] LT",
              lastWeek: "[forrige] dddd [kl.] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "om %s",
              past: "%s siden",
              s: "noen sekunder",
              ss: "%d sekunder",
              m: "ett minutt",
              mm: "%d minutter",
              h: "én time",
              hh: "%d timer",
              d: "én dag",
              dd: "%d dager",
              w: "én uke",
              ww: "%d uker",
              M: "én måned",
              MM: "%d måneder",
              y: "ett år",
              yy: "%d år",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      6744: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "१",
              2: "२",
              3: "३",
              4: "४",
              5: "५",
              6: "६",
              7: "७",
              8: "८",
              9: "९",
              0: "०",
            },
            n = {
              "१": "1",
              "२": "2",
              "३": "3",
              "४": "4",
              "५": "5",
              "६": "6",
              "७": "7",
              "८": "8",
              "९": "9",
              "०": "0",
            };
          e.defineLocale("ne", {
            months:
              "जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर".split(
                "_"
              ),
            monthsShort:
              "जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार".split(
                "_"
              ),
            weekdaysShort: "आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.".split("_"),
            weekdaysMin: "आ._सो._मं._बु._बि._शु._श.".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "Aको h:mm बजे",
              LTS: "Aको h:mm:ss बजे",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, Aको h:mm बजे",
              LLLL: "dddd, D MMMM YYYY, Aको h:mm बजे",
            },
            preparse: function (e) {
              return e.replace(/[१२३४५६७८९०]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "राति" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "बिहान" === t
                  ? e
                  : "दिउँसो" === t
                  ? e >= 10
                    ? e
                    : e + 12
                  : "साँझ" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 3
                ? "राति"
                : e < 12
                ? "बिहान"
                : e < 16
                ? "दिउँसो"
                : e < 20
                ? "साँझ"
                : "राति";
            },
            calendar: {
              sameDay: "[आज] LT",
              nextDay: "[भोलि] LT",
              nextWeek: "[आउँदो] dddd[,] LT",
              lastDay: "[हिजो] LT",
              lastWeek: "[गएको] dddd[,] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%sमा",
              past: "%s अगाडि",
              s: "केही क्षण",
              ss: "%d सेकेण्ड",
              m: "एक मिनेट",
              mm: "%d मिनेट",
              h: "एक घण्टा",
              hh: "%d घण्टा",
              d: "एक दिन",
              dd: "%d दिन",
              M: "एक महिना",
              MM: "%d महिना",
              y: "एक बर्ष",
              yy: "%d बर्ष",
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      9814: function (e, t, n) {
        !(function (e) {
          var t =
              "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split(
                "_"
              ),
            n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
            i = [
              /^jan/i,
              /^feb/i,
              /^(maart|mrt\.?)$/i,
              /^apr/i,
              /^mei$/i,
              /^jun[i.]?$/i,
              /^jul[i.]?$/i,
              /^aug/i,
              /^sep/i,
              /^okt/i,
              /^nov/i,
              /^dec/i,
            ],
            a =
              /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
          e.defineLocale("nl-be", {
            months:
              "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split(
                "_"
              ),
            monthsShort: function (e, i) {
              return e ? (/-MMM-/.test(i) ? n[e.month()] : t[e.month()]) : t;
            },
            monthsRegex: a,
            monthsShortRegex: a,
            monthsStrictRegex:
              /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
            monthsShortStrictRegex:
              /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays:
              "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split(
                "_"
              ),
            weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
            weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[vandaag om] LT",
              nextDay: "[morgen om] LT",
              nextWeek: "dddd [om] LT",
              lastDay: "[gisteren om] LT",
              lastWeek: "[afgelopen] dddd [om] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "over %s",
              past: "%s geleden",
              s: "een paar seconden",
              ss: "%d seconden",
              m: "één minuut",
              mm: "%d minuten",
              h: "één uur",
              hh: "%d uur",
              d: "één dag",
              dd: "%d dagen",
              M: "één maand",
              MM: "%d maanden",
              y: "één jaar",
              yy: "%d jaar",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function (e) {
              return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      3901: function (e, t, n) {
        !(function (e) {
          var t =
              "jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.".split(
                "_"
              ),
            n = "jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec".split("_"),
            i = [
              /^jan/i,
              /^feb/i,
              /^(maart|mrt\.?)$/i,
              /^apr/i,
              /^mei$/i,
              /^jun[i.]?$/i,
              /^jul[i.]?$/i,
              /^aug/i,
              /^sep/i,
              /^okt/i,
              /^nov/i,
              /^dec/i,
            ],
            a =
              /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;
          e.defineLocale("nl", {
            months:
              "januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december".split(
                "_"
              ),
            monthsShort: function (e, i) {
              return e ? (/-MMM-/.test(i) ? n[e.month()] : t[e.month()]) : t;
            },
            monthsRegex: a,
            monthsShortRegex: a,
            monthsStrictRegex:
              /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
            monthsShortStrictRegex:
              /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays:
              "zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag".split(
                "_"
              ),
            weekdaysShort: "zo._ma._di._wo._do._vr._za.".split("_"),
            weekdaysMin: "zo_ma_di_wo_do_vr_za".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD-MM-YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[vandaag om] LT",
              nextDay: "[morgen om] LT",
              nextWeek: "dddd [om] LT",
              lastDay: "[gisteren om] LT",
              lastWeek: "[afgelopen] dddd [om] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "over %s",
              past: "%s geleden",
              s: "een paar seconden",
              ss: "%d seconden",
              m: "één minuut",
              mm: "%d minuten",
              h: "één uur",
              hh: "%d uur",
              d: "één dag",
              dd: "%d dagen",
              w: "één week",
              ww: "%d weken",
              M: "één maand",
              MM: "%d maanden",
              y: "één jaar",
              yy: "%d jaar",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
            ordinal: function (e) {
              return e + (1 === e || 8 === e || e >= 20 ? "ste" : "de");
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      3877: function (e, t, n) {
        !(function (e) {
          e.defineLocale("nn", {
            months:
              "januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember".split(
                "_"
              ),
            monthsShort:
              "jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag".split("_"),
            weekdaysShort: "su._må._ty._on._to._fr._lau.".split("_"),
            weekdaysMin: "su_må_ty_on_to_fr_la".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY [kl.] H:mm",
              LLLL: "dddd D. MMMM YYYY [kl.] HH:mm",
            },
            calendar: {
              sameDay: "[I dag klokka] LT",
              nextDay: "[I morgon klokka] LT",
              nextWeek: "dddd [klokka] LT",
              lastDay: "[I går klokka] LT",
              lastWeek: "[Føregåande] dddd [klokka] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "om %s",
              past: "%s sidan",
              s: "nokre sekund",
              ss: "%d sekund",
              m: "eit minutt",
              mm: "%d minutt",
              h: "ein time",
              hh: "%d timar",
              d: "ein dag",
              dd: "%d dagar",
              w: "ei veke",
              ww: "%d veker",
              M: "ein månad",
              MM: "%d månader",
              y: "eit år",
              yy: "%d år",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      2135: function (e, t, n) {
        !(function (e) {
          e.defineLocale("oc-lnc", {
            months: {
              standalone:
                "genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre".split(
                  "_"
                ),
              format:
                "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                  "_"
                ),
              isFormat: /D[oD]?(\s)+MMMM/,
            },
            monthsShort:
              "gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte".split(
                "_"
              ),
            weekdaysShort: "dg._dl._dm._dc._dj._dv._ds.".split("_"),
            weekdaysMin: "dg_dl_dm_dc_dj_dv_ds".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM [de] YYYY",
              ll: "D MMM YYYY",
              LLL: "D MMMM [de] YYYY [a] H:mm",
              lll: "D MMM YYYY, H:mm",
              LLLL: "dddd D MMMM [de] YYYY [a] H:mm",
              llll: "ddd D MMM YYYY, H:mm",
            },
            calendar: {
              sameDay: "[uèi a] LT",
              nextDay: "[deman a] LT",
              nextWeek: "dddd [a] LT",
              lastDay: "[ièr a] LT",
              lastWeek: "dddd [passat a] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "d'aquí %s",
              past: "fa %s",
              s: "unas segondas",
              ss: "%d segondas",
              m: "una minuta",
              mm: "%d minutas",
              h: "una ora",
              hh: "%d oras",
              d: "un jorn",
              dd: "%d jorns",
              M: "un mes",
              MM: "%d meses",
              y: "un an",
              yy: "%d ans",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
            ordinal: function (e, t) {
              var n =
                1 === e
                  ? "r"
                  : 2 === e
                  ? "n"
                  : 3 === e
                  ? "r"
                  : 4 === e
                  ? "t"
                  : "è";
              return ("w" !== t && "W" !== t) || (n = "a"), e + n;
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      5858: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "੧",
              2: "੨",
              3: "੩",
              4: "੪",
              5: "੫",
              6: "੬",
              7: "੭",
              8: "੮",
              9: "੯",
              0: "੦",
            },
            n = {
              "੧": "1",
              "੨": "2",
              "੩": "3",
              "੪": "4",
              "੫": "5",
              "੬": "6",
              "੭": "7",
              "੮": "8",
              "੯": "9",
              "੦": "0",
            };
          e.defineLocale("pa-in", {
            months:
              "ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split(
                "_"
              ),
            monthsShort:
              "ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ".split(
                "_"
              ),
            weekdays:
              "ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ".split(
                "_"
              ),
            weekdaysShort: "ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),
            weekdaysMin: "ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ".split("_"),
            longDateFormat: {
              LT: "A h:mm ਵਜੇ",
              LTS: "A h:mm:ss ਵਜੇ",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm ਵਜੇ",
              LLLL: "dddd, D MMMM YYYY, A h:mm ਵਜੇ",
            },
            calendar: {
              sameDay: "[ਅਜ] LT",
              nextDay: "[ਕਲ] LT",
              nextWeek: "[ਅਗਲਾ] dddd, LT",
              lastDay: "[ਕਲ] LT",
              lastWeek: "[ਪਿਛਲੇ] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s ਵਿੱਚ",
              past: "%s ਪਿਛਲੇ",
              s: "ਕੁਝ ਸਕਿੰਟ",
              ss: "%d ਸਕਿੰਟ",
              m: "ਇਕ ਮਿੰਟ",
              mm: "%d ਮਿੰਟ",
              h: "ਇੱਕ ਘੰਟਾ",
              hh: "%d ਘੰਟੇ",
              d: "ਇੱਕ ਦਿਨ",
              dd: "%d ਦਿਨ",
              M: "ਇੱਕ ਮਹੀਨਾ",
              MM: "%d ਮਹੀਨੇ",
              y: "ਇੱਕ ਸਾਲ",
              yy: "%d ਸਾਲ",
            },
            preparse: function (e) {
              return e.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "ਰਾਤ" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "ਸਵੇਰ" === t
                  ? e
                  : "ਦੁਪਹਿਰ" === t
                  ? e >= 10
                    ? e
                    : e + 12
                  : "ਸ਼ਾਮ" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "ਰਾਤ"
                : e < 10
                ? "ਸਵੇਰ"
                : e < 17
                ? "ਦੁਪਹਿਰ"
                : e < 20
                ? "ਸ਼ਾਮ"
                : "ਰਾਤ";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      4495: function (e, t, n) {
        !(function (e) {
          var t =
              "styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień".split(
                "_"
              ),
            n =
              "stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia".split(
                "_"
              ),
            i = [
              /^sty/i,
              /^lut/i,
              /^mar/i,
              /^kwi/i,
              /^maj/i,
              /^cze/i,
              /^lip/i,
              /^sie/i,
              /^wrz/i,
              /^paź/i,
              /^lis/i,
              /^gru/i,
            ];
          function a(e) {
            return e % 10 < 5 && e % 10 > 1 && ~~(e / 10) % 10 != 1;
          }
          function r(e, t, n) {
            var i = e + " ";
            switch (n) {
              case "ss":
                return i + (a(e) ? "sekundy" : "sekund");
              case "m":
                return t ? "minuta" : "minutę";
              case "mm":
                return i + (a(e) ? "minuty" : "minut");
              case "h":
                return t ? "godzina" : "godzinę";
              case "hh":
                return i + (a(e) ? "godziny" : "godzin");
              case "ww":
                return i + (a(e) ? "tygodnie" : "tygodni");
              case "MM":
                return i + (a(e) ? "miesiące" : "miesięcy");
              case "yy":
                return i + (a(e) ? "lata" : "lat");
            }
          }
          e.defineLocale("pl", {
            months: function (e, i) {
              return e ? (/D MMMM/.test(i) ? n[e.month()] : t[e.month()]) : t;
            },
            monthsShort:
              "sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru".split("_"),
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            weekdays:
              "niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota".split(
                "_"
              ),
            weekdaysShort: "ndz_pon_wt_śr_czw_pt_sob".split("_"),
            weekdaysMin: "Nd_Pn_Wt_Śr_Cz_Pt_So".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Dziś o] LT",
              nextDay: "[Jutro o] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[W niedzielę o] LT";
                  case 2:
                    return "[We wtorek o] LT";
                  case 3:
                    return "[W środę o] LT";
                  case 6:
                    return "[W sobotę o] LT";
                  default:
                    return "[W] dddd [o] LT";
                }
              },
              lastDay: "[Wczoraj o] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[W zeszłą niedzielę o] LT";
                  case 3:
                    return "[W zeszłą środę o] LT";
                  case 6:
                    return "[W zeszłą sobotę o] LT";
                  default:
                    return "[W zeszły] dddd [o] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "za %s",
              past: "%s temu",
              s: "kilka sekund",
              ss: r,
              m: r,
              mm: r,
              h: r,
              hh: r,
              d: "1 dzień",
              dd: "%d dni",
              w: "tydzień",
              ww: r,
              M: "miesiąc",
              MM: r,
              y: "rok",
              yy: r,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      7971: function (e, t, n) {
        !(function (e) {
          e.defineLocale("pt-br", {
            months:
              "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
                "_"
              ),
            monthsShort:
              "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
            weekdays:
              "domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado".split(
                "_"
              ),
            weekdaysShort: "dom_seg_ter_qua_qui_sex_sáb".split("_"),
            weekdaysMin: "do_2ª_3ª_4ª_5ª_6ª_sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D [de] MMMM [de] YYYY",
              LLL: "D [de] MMMM [de] YYYY [às] HH:mm",
              LLLL: "dddd, D [de] MMMM [de] YYYY [às] HH:mm",
            },
            calendar: {
              sameDay: "[Hoje às] LT",
              nextDay: "[Amanhã às] LT",
              nextWeek: "dddd [às] LT",
              lastDay: "[Ontem às] LT",
              lastWeek: function () {
                return 0 === this.day() || 6 === this.day()
                  ? "[Último] dddd [às] LT"
                  : "[Última] dddd [às] LT";
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "em %s",
              past: "há %s",
              s: "poucos segundos",
              ss: "%d segundos",
              m: "um minuto",
              mm: "%d minutos",
              h: "uma hora",
              hh: "%d horas",
              d: "um dia",
              dd: "%d dias",
              M: "um mês",
              MM: "%d meses",
              y: "um ano",
              yy: "%d anos",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            invalidDate: "Data inválida",
          });
        })(n(381));
      },
      9520: function (e, t, n) {
        !(function (e) {
          e.defineLocale("pt", {
            months:
              "janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro".split(
                "_"
              ),
            monthsShort:
              "jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez".split("_"),
            weekdays:
              "Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado".split(
                "_"
              ),
            weekdaysShort: "Dom_Seg_Ter_Qua_Qui_Sex_Sáb".split("_"),
            weekdaysMin: "Do_2ª_3ª_4ª_5ª_6ª_Sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D [de] MMMM [de] YYYY",
              LLL: "D [de] MMMM [de] YYYY HH:mm",
              LLLL: "dddd, D [de] MMMM [de] YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Hoje às] LT",
              nextDay: "[Amanhã às] LT",
              nextWeek: "dddd [às] LT",
              lastDay: "[Ontem às] LT",
              lastWeek: function () {
                return 0 === this.day() || 6 === this.day()
                  ? "[Último] dddd [às] LT"
                  : "[Última] dddd [às] LT";
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "em %s",
              past: "há %s",
              s: "segundos",
              ss: "%d segundos",
              m: "um minuto",
              mm: "%d minutos",
              h: "uma hora",
              hh: "%d horas",
              d: "um dia",
              dd: "%d dias",
              w: "uma semana",
              ww: "%d semanas",
              M: "um mês",
              MM: "%d meses",
              y: "um ano",
              yy: "%d anos",
            },
            dayOfMonthOrdinalParse: /\d{1,2}º/,
            ordinal: "%dº",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      6459: function (e, t, n) {
        !(function (e) {
          function t(e, t, n) {
            var i = " ";
            return (
              (e % 100 >= 20 || (e >= 100 && e % 100 == 0)) && (i = " de "),
              e +
                i +
                {
                  ss: "secunde",
                  mm: "minute",
                  hh: "ore",
                  dd: "zile",
                  ww: "săptămâni",
                  MM: "luni",
                  yy: "ani",
                }[n]
            );
          }
          e.defineLocale("ro", {
            months:
              "ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie".split(
                "_"
              ),
            monthsShort:
              "ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays: "duminică_luni_marți_miercuri_joi_vineri_sâmbătă".split(
              "_"
            ),
            weekdaysShort: "Dum_Lun_Mar_Mie_Joi_Vin_Sâm".split("_"),
            weekdaysMin: "Du_Lu_Ma_Mi_Jo_Vi_Sâ".split("_"),
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY H:mm",
              LLLL: "dddd, D MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[azi la] LT",
              nextDay: "[mâine la] LT",
              nextWeek: "dddd [la] LT",
              lastDay: "[ieri la] LT",
              lastWeek: "[fosta] dddd [la] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "peste %s",
              past: "%s în urmă",
              s: "câteva secunde",
              ss: t,
              m: "un minut",
              mm: t,
              h: "o oră",
              hh: t,
              d: "o zi",
              dd: t,
              w: "o săptămână",
              ww: t,
              M: "o lună",
              MM: t,
              y: "un an",
              yy: t,
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      1793: function (e, t, n) {
        !(function (e) {
          function t(e, t) {
            var n = e.split("_");
            return t % 10 == 1 && t % 100 != 11
              ? n[0]
              : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20)
              ? n[1]
              : n[2];
          }
          function n(e, n, i) {
            return "m" === i
              ? n
                ? "минута"
                : "минуту"
              : e +
                  " " +
                  t(
                    {
                      ss: n
                        ? "секунда_секунды_секунд"
                        : "секунду_секунды_секунд",
                      mm: n ? "минута_минуты_минут" : "минуту_минуты_минут",
                      hh: "час_часа_часов",
                      dd: "день_дня_дней",
                      ww: "неделя_недели_недель",
                      MM: "месяц_месяца_месяцев",
                      yy: "год_года_лет",
                    }[i],
                    +e
                  );
          }
          var i = [
            /^янв/i,
            /^фев/i,
            /^мар/i,
            /^апр/i,
            /^ма[йя]/i,
            /^июн/i,
            /^июл/i,
            /^авг/i,
            /^сен/i,
            /^окт/i,
            /^ноя/i,
            /^дек/i,
          ];
          e.defineLocale("ru", {
            months: {
              format:
                "января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря".split(
                  "_"
                ),
              standalone:
                "январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь".split(
                  "_"
                ),
            },
            monthsShort: {
              format:
                "янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.".split(
                  "_"
                ),
              standalone:
                "янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.".split(
                  "_"
                ),
            },
            weekdays: {
              standalone:
                "воскресенье_понедельник_вторник_среда_четверг_пятница_суббота".split(
                  "_"
                ),
              format:
                "воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу".split(
                  "_"
                ),
              isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
            },
            weekdaysShort: "вс_пн_вт_ср_чт_пт_сб".split("_"),
            weekdaysMin: "вс_пн_вт_ср_чт_пт_сб".split("_"),
            monthsParse: i,
            longMonthsParse: i,
            shortMonthsParse: i,
            monthsRegex:
              /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
            monthsShortRegex:
              /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,
            monthsStrictRegex:
              /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,
            monthsShortStrictRegex:
              /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY г.",
              LLL: "D MMMM YYYY г., H:mm",
              LLLL: "dddd, D MMMM YYYY г., H:mm",
            },
            calendar: {
              sameDay: "[Сегодня, в] LT",
              nextDay: "[Завтра, в] LT",
              lastDay: "[Вчера, в] LT",
              nextWeek: function (e) {
                if (e.week() === this.week())
                  return 2 === this.day()
                    ? "[Во] dddd, [в] LT"
                    : "[В] dddd, [в] LT";
                switch (this.day()) {
                  case 0:
                    return "[В следующее] dddd, [в] LT";
                  case 1:
                  case 2:
                  case 4:
                    return "[В следующий] dddd, [в] LT";
                  case 3:
                  case 5:
                  case 6:
                    return "[В следующую] dddd, [в] LT";
                }
              },
              lastWeek: function (e) {
                if (e.week() === this.week())
                  return 2 === this.day()
                    ? "[Во] dddd, [в] LT"
                    : "[В] dddd, [в] LT";
                switch (this.day()) {
                  case 0:
                    return "[В прошлое] dddd, [в] LT";
                  case 1:
                  case 2:
                  case 4:
                    return "[В прошлый] dddd, [в] LT";
                  case 3:
                  case 5:
                  case 6:
                    return "[В прошлую] dddd, [в] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "через %s",
              past: "%s назад",
              s: "несколько секунд",
              ss: n,
              m: n,
              mm: n,
              h: "час",
              hh: n,
              d: "день",
              dd: n,
              w: "неделя",
              ww: n,
              M: "месяц",
              MM: n,
              y: "год",
              yy: n,
            },
            meridiemParse: /ночи|утра|дня|вечера/i,
            isPM: function (e) {
              return /^(дня|вечера)$/.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "ночи"
                : e < 12
                ? "утра"
                : e < 17
                ? "дня"
                : "вечера";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
            ordinal: function (e, t) {
              switch (t) {
                case "M":
                case "d":
                case "DDD":
                  return e + "-й";
                case "D":
                  return e + "-го";
                case "w":
                case "W":
                  return e + "-я";
                default:
                  return e;
              }
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      950: function (e, t, n) {
        !(function (e) {
          var t = [
              "جنوري",
              "فيبروري",
              "مارچ",
              "اپريل",
              "مئي",
              "جون",
              "جولاءِ",
              "آگسٽ",
              "سيپٽمبر",
              "آڪٽوبر",
              "نومبر",
              "ڊسمبر",
            ],
            n = ["آچر", "سومر", "اڱارو", "اربع", "خميس", "جمع", "ڇنڇر"];
          e.defineLocale("sd", {
            months: t,
            monthsShort: t,
            weekdays: n,
            weekdaysShort: n,
            weekdaysMin: n,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd، D MMMM YYYY HH:mm",
            },
            meridiemParse: /صبح|شام/,
            isPM: function (e) {
              return "شام" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "صبح" : "شام";
            },
            calendar: {
              sameDay: "[اڄ] LT",
              nextDay: "[سڀاڻي] LT",
              nextWeek: "dddd [اڳين هفتي تي] LT",
              lastDay: "[ڪالهه] LT",
              lastWeek: "[گزريل هفتي] dddd [تي] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s پوء",
              past: "%s اڳ",
              s: "چند سيڪنڊ",
              ss: "%d سيڪنڊ",
              m: "هڪ منٽ",
              mm: "%d منٽ",
              h: "هڪ ڪلاڪ",
              hh: "%d ڪلاڪ",
              d: "هڪ ڏينهن",
              dd: "%d ڏينهن",
              M: "هڪ مهينو",
              MM: "%d مهينا",
              y: "هڪ سال",
              yy: "%d سال",
            },
            preparse: function (e) {
              return e.replace(/،/g, ",");
            },
            postformat: function (e) {
              return e.replace(/,/g, "،");
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      490: function (e, t, n) {
        !(function (e) {
          e.defineLocale("se", {
            months:
              "ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu".split(
                "_"
              ),
            monthsShort:
              "ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov".split(
                "_"
              ),
            weekdays:
              "sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat".split(
                "_"
              ),
            weekdaysShort: "sotn_vuos_maŋ_gask_duor_bear_láv".split("_"),
            weekdaysMin: "s_v_m_g_d_b_L".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "MMMM D. [b.] YYYY",
              LLL: "MMMM D. [b.] YYYY [ti.] HH:mm",
              LLLL: "dddd, MMMM D. [b.] YYYY [ti.] HH:mm",
            },
            calendar: {
              sameDay: "[otne ti] LT",
              nextDay: "[ihttin ti] LT",
              nextWeek: "dddd [ti] LT",
              lastDay: "[ikte ti] LT",
              lastWeek: "[ovddit] dddd [ti] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s geažes",
              past: "maŋit %s",
              s: "moadde sekunddat",
              ss: "%d sekunddat",
              m: "okta minuhta",
              mm: "%d minuhtat",
              h: "okta diimmu",
              hh: "%d diimmut",
              d: "okta beaivi",
              dd: "%d beaivvit",
              M: "okta mánnu",
              MM: "%d mánut",
              y: "okta jahki",
              yy: "%d jagit",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      124: function (e, t, n) {
        !(function (e) {
          e.defineLocale("si", {
            months:
              "ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්".split(
                "_"
              ),
            monthsShort:
              "ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ".split(
                "_"
              ),
            weekdays:
              "ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා".split(
                "_"
              ),
            weekdaysShort: "ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන".split("_"),
            weekdaysMin: "ඉ_ස_අ_බ_බ්‍ර_සි_සෙ".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "a h:mm",
              LTS: "a h:mm:ss",
              L: "YYYY/MM/DD",
              LL: "YYYY MMMM D",
              LLL: "YYYY MMMM D, a h:mm",
              LLLL: "YYYY MMMM D [වැනි] dddd, a h:mm:ss",
            },
            calendar: {
              sameDay: "[අද] LT[ට]",
              nextDay: "[හෙට] LT[ට]",
              nextWeek: "dddd LT[ට]",
              lastDay: "[ඊයේ] LT[ට]",
              lastWeek: "[පසුගිය] dddd LT[ට]",
              sameElse: "L",
            },
            relativeTime: {
              future: "%sකින්",
              past: "%sකට පෙර",
              s: "තත්පර කිහිපය",
              ss: "තත්පර %d",
              m: "මිනිත්තුව",
              mm: "මිනිත්තු %d",
              h: "පැය",
              hh: "පැය %d",
              d: "දිනය",
              dd: "දින %d",
              M: "මාසය",
              MM: "මාස %d",
              y: "වසර",
              yy: "වසර %d",
            },
            dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
            ordinal: function (e) {
              return e + " වැනි";
            },
            meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
            isPM: function (e) {
              return "ප.ව." === e || "පස් වරු" === e;
            },
            meridiem: function (e, t, n) {
              return e > 11
                ? n
                  ? "ප.ව."
                  : "පස් වරු"
                : n
                ? "පෙ.ව."
                : "පෙර වරු";
            },
          });
        })(n(381));
      },
      4249: function (e, t, n) {
        !(function (e) {
          var t =
              "január_február_marec_apríl_máj_jún_júl_august_september_október_november_december".split(
                "_"
              ),
            n = "jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec".split("_");
          function i(e) {
            return e > 1 && e < 5;
          }
          function a(e, t, n, a) {
            var r = e + " ";
            switch (n) {
              case "s":
                return t || a ? "pár sekúnd" : "pár sekundami";
              case "ss":
                return t || a
                  ? r + (i(e) ? "sekundy" : "sekúnd")
                  : r + "sekundami";
              case "m":
                return t ? "minúta" : a ? "minútu" : "minútou";
              case "mm":
                return t || a
                  ? r + (i(e) ? "minúty" : "minút")
                  : r + "minútami";
              case "h":
                return t ? "hodina" : a ? "hodinu" : "hodinou";
              case "hh":
                return t || a
                  ? r + (i(e) ? "hodiny" : "hodín")
                  : r + "hodinami";
              case "d":
                return t || a ? "deň" : "dňom";
              case "dd":
                return t || a ? r + (i(e) ? "dni" : "dní") : r + "dňami";
              case "M":
                return t || a ? "mesiac" : "mesiacom";
              case "MM":
                return t || a
                  ? r + (i(e) ? "mesiace" : "mesiacov")
                  : r + "mesiacmi";
              case "y":
                return t || a ? "rok" : "rokom";
              case "yy":
                return t || a ? r + (i(e) ? "roky" : "rokov") : r + "rokmi";
            }
          }
          e.defineLocale("sk", {
            months: t,
            monthsShort: n,
            weekdays:
              "nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota".split("_"),
            weekdaysShort: "ne_po_ut_st_št_pi_so".split("_"),
            weekdaysMin: "ne_po_ut_st_št_pi_so".split("_"),
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY H:mm",
              LLLL: "dddd D. MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[dnes o] LT",
              nextDay: "[zajtra o] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[v nedeľu o] LT";
                  case 1:
                  case 2:
                    return "[v] dddd [o] LT";
                  case 3:
                    return "[v stredu o] LT";
                  case 4:
                    return "[vo štvrtok o] LT";
                  case 5:
                    return "[v piatok o] LT";
                  case 6:
                    return "[v sobotu o] LT";
                }
              },
              lastDay: "[včera o] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[minulú nedeľu o] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[minulý] dddd [o] LT";
                  case 3:
                    return "[minulú stredu o] LT";
                  case 6:
                    return "[minulú sobotu o] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "za %s",
              past: "pred %s",
              s: a,
              ss: a,
              m: a,
              mm: a,
              h: a,
              hh: a,
              d: a,
              dd: a,
              M: a,
              MM: a,
              y: a,
              yy: a,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      4985: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = e + " ";
            switch (n) {
              case "s":
                return t || i ? "nekaj sekund" : "nekaj sekundami";
              case "ss":
                return (a +=
                  1 === e
                    ? t
                      ? "sekundo"
                      : "sekundi"
                    : 2 === e
                    ? t || i
                      ? "sekundi"
                      : "sekundah"
                    : e < 5
                    ? t || i
                      ? "sekunde"
                      : "sekundah"
                    : "sekund");
              case "m":
                return t ? "ena minuta" : "eno minuto";
              case "mm":
                return (a +=
                  1 === e
                    ? t
                      ? "minuta"
                      : "minuto"
                    : 2 === e
                    ? t || i
                      ? "minuti"
                      : "minutama"
                    : e < 5
                    ? t || i
                      ? "minute"
                      : "minutami"
                    : t || i
                    ? "minut"
                    : "minutami");
              case "h":
                return t ? "ena ura" : "eno uro";
              case "hh":
                return (a +=
                  1 === e
                    ? t
                      ? "ura"
                      : "uro"
                    : 2 === e
                    ? t || i
                      ? "uri"
                      : "urama"
                    : e < 5
                    ? t || i
                      ? "ure"
                      : "urami"
                    : t || i
                    ? "ur"
                    : "urami");
              case "d":
                return t || i ? "en dan" : "enim dnem";
              case "dd":
                return (a +=
                  1 === e
                    ? t || i
                      ? "dan"
                      : "dnem"
                    : 2 === e
                    ? t || i
                      ? "dni"
                      : "dnevoma"
                    : t || i
                    ? "dni"
                    : "dnevi");
              case "M":
                return t || i ? "en mesec" : "enim mesecem";
              case "MM":
                return (a +=
                  1 === e
                    ? t || i
                      ? "mesec"
                      : "mesecem"
                    : 2 === e
                    ? t || i
                      ? "meseca"
                      : "mesecema"
                    : e < 5
                    ? t || i
                      ? "mesece"
                      : "meseci"
                    : t || i
                    ? "mesecev"
                    : "meseci");
              case "y":
                return t || i ? "eno leto" : "enim letom";
              case "yy":
                return (a +=
                  1 === e
                    ? t || i
                      ? "leto"
                      : "letom"
                    : 2 === e
                    ? t || i
                      ? "leti"
                      : "letoma"
                    : e < 5
                    ? t || i
                      ? "leta"
                      : "leti"
                    : t || i
                    ? "let"
                    : "leti");
            }
          }
          e.defineLocale("sl", {
            months:
              "januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december".split(
                "_"
              ),
            monthsShort:
              "jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota".split("_"),
            weekdaysShort: "ned._pon._tor._sre._čet._pet._sob.".split("_"),
            weekdaysMin: "ne_po_to_sr_če_pe_so".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD. MM. YYYY",
              LL: "D. MMMM YYYY",
              LLL: "D. MMMM YYYY H:mm",
              LLLL: "dddd, D. MMMM YYYY H:mm",
            },
            calendar: {
              sameDay: "[danes ob] LT",
              nextDay: "[jutri ob] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[v] [nedeljo] [ob] LT";
                  case 3:
                    return "[v] [sredo] [ob] LT";
                  case 6:
                    return "[v] [soboto] [ob] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[v] dddd [ob] LT";
                }
              },
              lastDay: "[včeraj ob] LT",
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[prejšnjo] [nedeljo] [ob] LT";
                  case 3:
                    return "[prejšnjo] [sredo] [ob] LT";
                  case 6:
                    return "[prejšnjo] [soboto] [ob] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[prejšnji] dddd [ob] LT";
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "čez %s",
              past: "pred %s",
              s: t,
              ss: t,
              m: t,
              mm: t,
              h: t,
              hh: t,
              d: t,
              dd: t,
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      1104: function (e, t, n) {
        !(function (e) {
          e.defineLocale("sq", {
            months:
              "Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor".split(
                "_"
              ),
            monthsShort:
              "Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj".split("_"),
            weekdays:
              "E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë".split(
                "_"
              ),
            weekdaysShort: "Die_Hën_Mar_Mër_Enj_Pre_Sht".split("_"),
            weekdaysMin: "D_H_Ma_Më_E_P_Sh".split("_"),
            weekdaysParseExact: !0,
            meridiemParse: /PD|MD/,
            isPM: function (e) {
              return "M" === e.charAt(0);
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "PD" : "MD";
            },
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Sot në] LT",
              nextDay: "[Nesër në] LT",
              nextWeek: "dddd [në] LT",
              lastDay: "[Dje në] LT",
              lastWeek: "dddd [e kaluar në] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "në %s",
              past: "%s më parë",
              s: "disa sekonda",
              ss: "%d sekonda",
              m: "një minutë",
              mm: "%d minuta",
              h: "një orë",
              hh: "%d orë",
              d: "një ditë",
              dd: "%d ditë",
              M: "një muaj",
              MM: "%d muaj",
              y: "një vit",
              yy: "%d vite",
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      9915: function (e, t, n) {
        !(function (e) {
          var t = {
            words: {
              ss: ["секунда", "секунде", "секунди"],
              m: ["један минут", "једног минута"],
              mm: ["минут", "минута", "минута"],
              h: ["један сат", "једног сата"],
              hh: ["сат", "сата", "сати"],
              d: ["један дан", "једног дана"],
              dd: ["дан", "дана", "дана"],
              M: ["један месец", "једног месеца"],
              MM: ["месец", "месеца", "месеци"],
              y: ["једну годину", "једне године"],
              yy: ["годину", "године", "година"],
            },
            correctGrammaticalCase: function (e, t) {
              return e % 10 >= 1 &&
                e % 10 <= 4 &&
                (e % 100 < 10 || e % 100 >= 20)
                ? e % 10 == 1
                  ? t[0]
                  : t[1]
                : t[2];
            },
            translate: function (e, n, i, a) {
              var r,
                l = t.words[i];
              return 1 === i.length
                ? "y" === i && n
                  ? "једна година"
                  : a || n
                  ? l[0]
                  : l[1]
                : ((r = t.correctGrammaticalCase(e, l)),
                  "yy" === i && n && "годину" === r
                    ? e + " година"
                    : e + " " + r);
            },
          };
          e.defineLocale("sr-cyrl", {
            months:
              "јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар".split(
                "_"
              ),
            monthsShort:
              "јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "недеља_понедељак_уторак_среда_четвртак_петак_субота".split("_"),
            weekdaysShort: "нед._пон._уто._сре._чет._пет._суб.".split("_"),
            weekdaysMin: "не_по_ут_ср_че_пе_су".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "D. M. YYYY.",
              LL: "D. MMMM YYYY.",
              LLL: "D. MMMM YYYY. H:mm",
              LLLL: "dddd, D. MMMM YYYY. H:mm",
            },
            calendar: {
              sameDay: "[данас у] LT",
              nextDay: "[сутра у] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[у] [недељу] [у] LT";
                  case 3:
                    return "[у] [среду] [у] LT";
                  case 6:
                    return "[у] [суботу] [у] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[у] dddd [у] LT";
                }
              },
              lastDay: "[јуче у] LT",
              lastWeek: function () {
                return [
                  "[прошле] [недеље] [у] LT",
                  "[прошлог] [понедељка] [у] LT",
                  "[прошлог] [уторка] [у] LT",
                  "[прошле] [среде] [у] LT",
                  "[прошлог] [четвртка] [у] LT",
                  "[прошлог] [петка] [у] LT",
                  "[прошле] [суботе] [у] LT",
                ][this.day()];
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "за %s",
              past: "пре %s",
              s: "неколико секунди",
              ss: t.translate,
              m: t.translate,
              mm: t.translate,
              h: t.translate,
              hh: t.translate,
              d: t.translate,
              dd: t.translate,
              M: t.translate,
              MM: t.translate,
              y: t.translate,
              yy: t.translate,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      9131: function (e, t, n) {
        !(function (e) {
          var t = {
            words: {
              ss: ["sekunda", "sekunde", "sekundi"],
              m: ["jedan minut", "jednog minuta"],
              mm: ["minut", "minuta", "minuta"],
              h: ["jedan sat", "jednog sata"],
              hh: ["sat", "sata", "sati"],
              d: ["jedan dan", "jednog dana"],
              dd: ["dan", "dana", "dana"],
              M: ["jedan mesec", "jednog meseca"],
              MM: ["mesec", "meseca", "meseci"],
              y: ["jednu godinu", "jedne godine"],
              yy: ["godinu", "godine", "godina"],
            },
            correctGrammaticalCase: function (e, t) {
              return e % 10 >= 1 &&
                e % 10 <= 4 &&
                (e % 100 < 10 || e % 100 >= 20)
                ? e % 10 == 1
                  ? t[0]
                  : t[1]
                : t[2];
            },
            translate: function (e, n, i, a) {
              var r,
                l = t.words[i];
              return 1 === i.length
                ? "y" === i && n
                  ? "jedna godina"
                  : a || n
                  ? l[0]
                  : l[1]
                : ((r = t.correctGrammaticalCase(e, l)),
                  "yy" === i && n && "godinu" === r
                    ? e + " godina"
                    : e + " " + r);
            },
          };
          e.defineLocale("sr", {
            months:
              "januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar".split(
                "_"
              ),
            monthsShort:
              "jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota".split(
                "_"
              ),
            weekdaysShort: "ned._pon._uto._sre._čet._pet._sub.".split("_"),
            weekdaysMin: "ne_po_ut_sr_če_pe_su".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "D. M. YYYY.",
              LL: "D. MMMM YYYY.",
              LLL: "D. MMMM YYYY. H:mm",
              LLLL: "dddd, D. MMMM YYYY. H:mm",
            },
            calendar: {
              sameDay: "[danas u] LT",
              nextDay: "[sutra u] LT",
              nextWeek: function () {
                switch (this.day()) {
                  case 0:
                    return "[u] [nedelju] [u] LT";
                  case 3:
                    return "[u] [sredu] [u] LT";
                  case 6:
                    return "[u] [subotu] [u] LT";
                  case 1:
                  case 2:
                  case 4:
                  case 5:
                    return "[u] dddd [u] LT";
                }
              },
              lastDay: "[juče u] LT",
              lastWeek: function () {
                return [
                  "[prošle] [nedelje] [u] LT",
                  "[prošlog] [ponedeljka] [u] LT",
                  "[prošlog] [utorka] [u] LT",
                  "[prošle] [srede] [u] LT",
                  "[prošlog] [četvrtka] [u] LT",
                  "[prošlog] [petka] [u] LT",
                  "[prošle] [subote] [u] LT",
                ][this.day()];
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "za %s",
              past: "pre %s",
              s: "nekoliko sekundi",
              ss: t.translate,
              m: t.translate,
              mm: t.translate,
              h: t.translate,
              hh: t.translate,
              d: t.translate,
              dd: t.translate,
              M: t.translate,
              MM: t.translate,
              y: t.translate,
              yy: t.translate,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      5606: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ss", {
            months:
              "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
                "_"
              ),
            monthsShort:
              "Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo".split("_"),
            weekdays:
              "Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo".split(
                "_"
              ),
            weekdaysShort: "Lis_Umb_Lsb_Les_Lsi_Lsh_Umg".split("_"),
            weekdaysMin: "Li_Us_Lb_Lt_Ls_Lh_Ug".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY h:mm A",
              LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
              sameDay: "[Namuhla nga] LT",
              nextDay: "[Kusasa nga] LT",
              nextWeek: "dddd [nga] LT",
              lastDay: "[Itolo nga] LT",
              lastWeek: "dddd [leliphelile] [nga] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "nga %s",
              past: "wenteka nga %s",
              s: "emizuzwana lomcane",
              ss: "%d mzuzwana",
              m: "umzuzu",
              mm: "%d emizuzu",
              h: "lihora",
              hh: "%d emahora",
              d: "lilanga",
              dd: "%d emalanga",
              M: "inyanga",
              MM: "%d tinyanga",
              y: "umnyaka",
              yy: "%d iminyaka",
            },
            meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
            meridiem: function (e, t, n) {
              return e < 11
                ? "ekuseni"
                : e < 15
                ? "emini"
                : e < 19
                ? "entsambama"
                : "ebusuku";
            },
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "ekuseni" === t
                  ? e
                  : "emini" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "entsambama" === t || "ebusuku" === t
                  ? 0 === e
                    ? 0
                    : e + 12
                  : void 0
              );
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: "%d",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      8760: function (e, t, n) {
        !(function (e) {
          e.defineLocale("sv", {
            months:
              "januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december".split(
                "_"
              ),
            monthsShort:
              "jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec".split("_"),
            weekdays: "söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag".split(
              "_"
            ),
            weekdaysShort: "sön_mån_tis_ons_tor_fre_lör".split("_"),
            weekdaysMin: "sö_må_ti_on_to_fr_lö".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY-MM-DD",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY [kl.] HH:mm",
              LLLL: "dddd D MMMM YYYY [kl.] HH:mm",
              lll: "D MMM YYYY HH:mm",
              llll: "ddd D MMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Idag] LT",
              nextDay: "[Imorgon] LT",
              lastDay: "[Igår] LT",
              nextWeek: "[På] dddd LT",
              lastWeek: "[I] dddd[s] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "om %s",
              past: "för %s sedan",
              s: "några sekunder",
              ss: "%d sekunder",
              m: "en minut",
              mm: "%d minuter",
              h: "en timme",
              hh: "%d timmar",
              d: "en dag",
              dd: "%d dagar",
              M: "en månad",
              MM: "%d månader",
              y: "ett år",
              yy: "%d år",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? ":e"
                  : 1 === t || 2 === t
                  ? ":a"
                  : ":e")
              );
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      1172: function (e, t, n) {
        !(function (e) {
          e.defineLocale("sw", {
            months:
              "Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba".split(
                "_"
              ),
            monthsShort:
              "Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des".split("_"),
            weekdays:
              "Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi".split(
                "_"
              ),
            weekdaysShort: "Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos".split("_"),
            weekdaysMin: "J2_J3_J4_J5_Al_Ij_J1".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "hh:mm A",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[leo saa] LT",
              nextDay: "[kesho saa] LT",
              nextWeek: "[wiki ijayo] dddd [saat] LT",
              lastDay: "[jana] LT",
              lastWeek: "[wiki iliyopita] dddd [saat] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s baadaye",
              past: "tokea %s",
              s: "hivi punde",
              ss: "sekunde %d",
              m: "dakika moja",
              mm: "dakika %d",
              h: "saa limoja",
              hh: "masaa %d",
              d: "siku moja",
              dd: "siku %d",
              M: "mwezi mmoja",
              MM: "miezi %d",
              y: "mwaka mmoja",
              yy: "miaka %d",
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      7333: function (e, t, n) {
        !(function (e) {
          var t = {
              1: "௧",
              2: "௨",
              3: "௩",
              4: "௪",
              5: "௫",
              6: "௬",
              7: "௭",
              8: "௮",
              9: "௯",
              0: "௦",
            },
            n = {
              "௧": "1",
              "௨": "2",
              "௩": "3",
              "௪": "4",
              "௫": "5",
              "௬": "6",
              "௭": "7",
              "௮": "8",
              "௯": "9",
              "௦": "0",
            };
          e.defineLocale("ta", {
            months:
              "ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split(
                "_"
              ),
            monthsShort:
              "ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்".split(
                "_"
              ),
            weekdays:
              "ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை".split(
                "_"
              ),
            weekdaysShort:
              "ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி".split("_"),
            weekdaysMin: "ஞா_தி_செ_பு_வி_வெ_ச".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, HH:mm",
              LLLL: "dddd, D MMMM YYYY, HH:mm",
            },
            calendar: {
              sameDay: "[இன்று] LT",
              nextDay: "[நாளை] LT",
              nextWeek: "dddd, LT",
              lastDay: "[நேற்று] LT",
              lastWeek: "[கடந்த வாரம்] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s இல்",
              past: "%s முன்",
              s: "ஒரு சில விநாடிகள்",
              ss: "%d விநாடிகள்",
              m: "ஒரு நிமிடம்",
              mm: "%d நிமிடங்கள்",
              h: "ஒரு மணி நேரம்",
              hh: "%d மணி நேரம்",
              d: "ஒரு நாள்",
              dd: "%d நாட்கள்",
              M: "ஒரு மாதம்",
              MM: "%d மாதங்கள்",
              y: "ஒரு வருடம்",
              yy: "%d ஆண்டுகள்",
            },
            dayOfMonthOrdinalParse: /\d{1,2}வது/,
            ordinal: function (e) {
              return e + "வது";
            },
            preparse: function (e) {
              return e.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (e) {
                return n[e];
              });
            },
            postformat: function (e) {
              return e.replace(/\d/g, function (e) {
                return t[e];
              });
            },
            meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
            meridiem: function (e, t, n) {
              return e < 2
                ? " யாமம்"
                : e < 6
                ? " வைகறை"
                : e < 10
                ? " காலை"
                : e < 14
                ? " நண்பகல்"
                : e < 18
                ? " எற்பாடு"
                : e < 22
                ? " மாலை"
                : " யாமம்";
            },
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "யாமம்" === t
                  ? e < 2
                    ? e
                    : e + 12
                  : "வைகறை" === t ||
                    "காலை" === t ||
                    ("நண்பகல்" === t && e >= 10)
                  ? e
                  : e + 12
              );
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      3110: function (e, t, n) {
        !(function (e) {
          e.defineLocale("te", {
            months:
              "జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్".split(
                "_"
              ),
            monthsShort:
              "జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం".split(
                "_"
              ),
            weekdaysShort: "ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని".split("_"),
            weekdaysMin: "ఆ_సో_మం_బు_గు_శు_శ".split("_"),
            longDateFormat: {
              LT: "A h:mm",
              LTS: "A h:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY, A h:mm",
              LLLL: "dddd, D MMMM YYYY, A h:mm",
            },
            calendar: {
              sameDay: "[నేడు] LT",
              nextDay: "[రేపు] LT",
              nextWeek: "dddd, LT",
              lastDay: "[నిన్న] LT",
              lastWeek: "[గత] dddd, LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s లో",
              past: "%s క్రితం",
              s: "కొన్ని క్షణాలు",
              ss: "%d సెకన్లు",
              m: "ఒక నిమిషం",
              mm: "%d నిమిషాలు",
              h: "ఒక గంట",
              hh: "%d గంటలు",
              d: "ఒక రోజు",
              dd: "%d రోజులు",
              M: "ఒక నెల",
              MM: "%d నెలలు",
              y: "ఒక సంవత్సరం",
              yy: "%d సంవత్సరాలు",
            },
            dayOfMonthOrdinalParse: /\d{1,2}వ/,
            ordinal: "%dవ",
            meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "రాత్రి" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "ఉదయం" === t
                  ? e
                  : "మధ్యాహ్నం" === t
                  ? e >= 10
                    ? e
                    : e + 12
                  : "సాయంత్రం" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "రాత్రి"
                : e < 10
                ? "ఉదయం"
                : e < 17
                ? "మధ్యాహ్నం"
                : e < 20
                ? "సాయంత్రం"
                : "రాత్రి";
            },
            week: { dow: 0, doy: 6 },
          });
        })(n(381));
      },
      2095: function (e, t, n) {
        !(function (e) {
          e.defineLocale("tet", {
            months:
              "Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru".split(
                "_"
              ),
            monthsShort:
              "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
            weekdays: "Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu".split(
              "_"
            ),
            weekdaysShort: "Dom_Seg_Ters_Kua_Kint_Sest_Sab".split("_"),
            weekdaysMin: "Do_Seg_Te_Ku_Ki_Ses_Sa".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Ohin iha] LT",
              nextDay: "[Aban iha] LT",
              nextWeek: "dddd [iha] LT",
              lastDay: "[Horiseik iha] LT",
              lastWeek: "dddd [semana kotuk] [iha] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "iha %s",
              past: "%s liuba",
              s: "segundu balun",
              ss: "segundu %d",
              m: "minutu ida",
              mm: "minutu %d",
              h: "oras ida",
              hh: "oras %d",
              d: "loron ida",
              dd: "loron %d",
              M: "fulan ida",
              MM: "fulan %d",
              y: "tinan ida",
              yy: "tinan %d",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      7321: function (e, t, n) {
        !(function (e) {
          var t = {
            0: "-ум",
            1: "-ум",
            2: "-юм",
            3: "-юм",
            4: "-ум",
            5: "-ум",
            6: "-ум",
            7: "-ум",
            8: "-ум",
            9: "-ум",
            10: "-ум",
            12: "-ум",
            13: "-ум",
            20: "-ум",
            30: "-юм",
            40: "-ум",
            50: "-ум",
            60: "-ум",
            70: "-ум",
            80: "-ум",
            90: "-ум",
            100: "-ум",
          };
          e.defineLocale("tg", {
            months: {
              format:
                "январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри".split(
                  "_"
                ),
              standalone:
                "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split(
                  "_"
                ),
            },
            monthsShort:
              "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
            weekdays:
              "якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе".split(
                "_"
              ),
            weekdaysShort: "яшб_дшб_сшб_чшб_пшб_ҷум_шнб".split("_"),
            weekdaysMin: "яш_дш_сш_чш_пш_ҷм_шб".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Имрӯз соати] LT",
              nextDay: "[Фардо соати] LT",
              lastDay: "[Дирӯз соати] LT",
              nextWeek: "dddd[и] [ҳафтаи оянда соати] LT",
              lastWeek: "dddd[и] [ҳафтаи гузашта соати] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "баъди %s",
              past: "%s пеш",
              s: "якчанд сония",
              m: "як дақиқа",
              mm: "%d дақиқа",
              h: "як соат",
              hh: "%d соат",
              d: "як рӯз",
              dd: "%d рӯз",
              M: "як моҳ",
              MM: "%d моҳ",
              y: "як сол",
              yy: "%d сол",
            },
            meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "шаб" === t
                  ? e < 4
                    ? e
                    : e + 12
                  : "субҳ" === t
                  ? e
                  : "рӯз" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "бегоҳ" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "шаб"
                : e < 11
                ? "субҳ"
                : e < 16
                ? "рӯз"
                : e < 19
                ? "бегоҳ"
                : "шаб";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
            ordinal: function (e) {
              var n = e % 10,
                i = e >= 100 ? 100 : null;
              return e + (t[e] || t[n] || t[i]);
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      9041: function (e, t, n) {
        !(function (e) {
          e.defineLocale("th", {
            months:
              "มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม".split(
                "_"
              ),
            monthsShort:
              "ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์".split(
              "_"
            ),
            weekdaysShort: "อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์".split(
              "_"
            ),
            weekdaysMin: "อา._จ._อ._พ._พฤ._ศ._ส.".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "H:mm",
              LTS: "H:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY เวลา H:mm",
              LLLL: "วันddddที่ D MMMM YYYY เวลา H:mm",
            },
            meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
            isPM: function (e) {
              return "หลังเที่ยง" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "ก่อนเที่ยง" : "หลังเที่ยง";
            },
            calendar: {
              sameDay: "[วันนี้ เวลา] LT",
              nextDay: "[พรุ่งนี้ เวลา] LT",
              nextWeek: "dddd[หน้า เวลา] LT",
              lastDay: "[เมื่อวานนี้ เวลา] LT",
              lastWeek: "[วัน]dddd[ที่แล้ว เวลา] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "อีก %s",
              past: "%sที่แล้ว",
              s: "ไม่กี่วินาที",
              ss: "%d วินาที",
              m: "1 นาที",
              mm: "%d นาที",
              h: "1 ชั่วโมง",
              hh: "%d ชั่วโมง",
              d: "1 วัน",
              dd: "%d วัน",
              w: "1 สัปดาห์",
              ww: "%d สัปดาห์",
              M: "1 เดือน",
              MM: "%d เดือน",
              y: "1 ปี",
              yy: "%d ปี",
            },
          });
        })(n(381));
      },
      9005: function (e, t, n) {
        !(function (e) {
          var t = {
            1: "'inji",
            5: "'inji",
            8: "'inji",
            70: "'inji",
            80: "'inji",
            2: "'nji",
            7: "'nji",
            20: "'nji",
            50: "'nji",
            3: "'ünji",
            4: "'ünji",
            100: "'ünji",
            6: "'njy",
            9: "'unjy",
            10: "'unjy",
            30: "'unjy",
            60: "'ynjy",
            90: "'ynjy",
          };
          e.defineLocale("tk", {
            months:
              "Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr".split(
                "_"
              ),
            monthsShort:
              "Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek".split("_"),
            weekdays:
              "Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe".split(
                "_"
              ),
            weekdaysShort: "Ýek_Duş_Siş_Çar_Pen_Ann_Şen".split("_"),
            weekdaysMin: "Ýk_Dş_Sş_Çr_Pn_An_Şn".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[bugün sagat] LT",
              nextDay: "[ertir sagat] LT",
              nextWeek: "[indiki] dddd [sagat] LT",
              lastDay: "[düýn] LT",
              lastWeek: "[geçen] dddd [sagat] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s soň",
              past: "%s öň",
              s: "birnäçe sekunt",
              m: "bir minut",
              mm: "%d minut",
              h: "bir sagat",
              hh: "%d sagat",
              d: "bir gün",
              dd: "%d gün",
              M: "bir aý",
              MM: "%d aý",
              y: "bir ýyl",
              yy: "%d ýyl",
            },
            ordinal: function (e, n) {
              switch (n) {
                case "d":
                case "D":
                case "Do":
                case "DD":
                  return e;
                default:
                  if (0 === e) return e + "'unjy";
                  var i = e % 10,
                    a = (e % 100) - i,
                    r = e >= 100 ? 100 : null;
                  return e + (t[i] || t[a] || t[r]);
              }
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      5768: function (e, t, n) {
        !(function (e) {
          e.defineLocale("tl-ph", {
            months:
              "Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre".split(
                "_"
              ),
            monthsShort:
              "Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis".split("_"),
            weekdays:
              "Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado".split(
                "_"
              ),
            weekdaysShort: "Lin_Lun_Mar_Miy_Huw_Biy_Sab".split("_"),
            weekdaysMin: "Li_Lu_Ma_Mi_Hu_Bi_Sab".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "MM/D/YYYY",
              LL: "MMMM D, YYYY",
              LLL: "MMMM D, YYYY HH:mm",
              LLLL: "dddd, MMMM DD, YYYY HH:mm",
            },
            calendar: {
              sameDay: "LT [ngayong araw]",
              nextDay: "[Bukas ng] LT",
              nextWeek: "LT [sa susunod na] dddd",
              lastDay: "LT [kahapon]",
              lastWeek: "LT [noong nakaraang] dddd",
              sameElse: "L",
            },
            relativeTime: {
              future: "sa loob ng %s",
              past: "%s ang nakalipas",
              s: "ilang segundo",
              ss: "%d segundo",
              m: "isang minuto",
              mm: "%d minuto",
              h: "isang oras",
              hh: "%d oras",
              d: "isang araw",
              dd: "%d araw",
              M: "isang buwan",
              MM: "%d buwan",
              y: "isang taon",
              yy: "%d taon",
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: function (e) {
              return e;
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      9444: function (e, t, n) {
        !(function (e) {
          var t = "pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut".split("_");
          function n(e) {
            var t = e;
            return (t =
              -1 !== e.indexOf("jaj")
                ? t.slice(0, -3) + "leS"
                : -1 !== e.indexOf("jar")
                ? t.slice(0, -3) + "waQ"
                : -1 !== e.indexOf("DIS")
                ? t.slice(0, -3) + "nem"
                : t + " pIq");
          }
          function i(e) {
            var t = e;
            return (t =
              -1 !== e.indexOf("jaj")
                ? t.slice(0, -3) + "Hu’"
                : -1 !== e.indexOf("jar")
                ? t.slice(0, -3) + "wen"
                : -1 !== e.indexOf("DIS")
                ? t.slice(0, -3) + "ben"
                : t + " ret");
          }
          function a(e, t, n, i) {
            var a = r(e);
            switch (n) {
              case "ss":
                return a + " lup";
              case "mm":
                return a + " tup";
              case "hh":
                return a + " rep";
              case "dd":
                return a + " jaj";
              case "MM":
                return a + " jar";
              case "yy":
                return a + " DIS";
            }
          }
          function r(e) {
            var n = Math.floor((e % 1e3) / 100),
              i = Math.floor((e % 100) / 10),
              a = e % 10,
              r = "";
            return (
              n > 0 && (r += t[n] + "vatlh"),
              i > 0 && (r += ("" !== r ? " " : "") + t[i] + "maH"),
              a > 0 && (r += ("" !== r ? " " : "") + t[a]),
              "" === r ? "pagh" : r
            );
          }
          e.defineLocale("tlh", {
            months:
              "tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’".split(
                "_"
              ),
            monthsShort:
              "jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split(
                "_"
              ),
            weekdaysShort:
              "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split(
                "_"
              ),
            weekdaysMin:
              "lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj".split(
                "_"
              ),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[DaHjaj] LT",
              nextDay: "[wa’leS] LT",
              nextWeek: "LLL",
              lastDay: "[wa’Hu’] LT",
              lastWeek: "LLL",
              sameElse: "L",
            },
            relativeTime: {
              future: n,
              past: i,
              s: "puS lup",
              ss: a,
              m: "wa’ tup",
              mm: a,
              h: "wa’ rep",
              hh: a,
              d: "wa’ jaj",
              dd: a,
              M: "wa’ jar",
              MM: a,
              y: "wa’ DIS",
              yy: a,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      2397: function (e, t, n) {
        !(function (e) {
          var t = {
            1: "'inci",
            5: "'inci",
            8: "'inci",
            70: "'inci",
            80: "'inci",
            2: "'nci",
            7: "'nci",
            20: "'nci",
            50: "'nci",
            3: "'üncü",
            4: "'üncü",
            100: "'üncü",
            6: "'ncı",
            9: "'uncu",
            10: "'uncu",
            30: "'uncu",
            60: "'ıncı",
            90: "'ıncı",
          };
          e.defineLocale("tr", {
            months:
              "Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık".split(
                "_"
              ),
            monthsShort:
              "Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara".split("_"),
            weekdays:
              "Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi".split(
                "_"
              ),
            weekdaysShort: "Paz_Pzt_Sal_Çar_Per_Cum_Cmt".split("_"),
            weekdaysMin: "Pz_Pt_Sa_Ça_Pe_Cu_Ct".split("_"),
            meridiem: function (e, t, n) {
              return e < 12 ? (n ? "öö" : "ÖÖ") : n ? "ös" : "ÖS";
            },
            meridiemParse: /öö|ÖÖ|ös|ÖS/,
            isPM: function (e) {
              return "ös" === e || "ÖS" === e;
            },
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[bugün saat] LT",
              nextDay: "[yarın saat] LT",
              nextWeek: "[gelecek] dddd [saat] LT",
              lastDay: "[dün] LT",
              lastWeek: "[geçen] dddd [saat] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s sonra",
              past: "%s önce",
              s: "birkaç saniye",
              ss: "%d saniye",
              m: "bir dakika",
              mm: "%d dakika",
              h: "bir saat",
              hh: "%d saat",
              d: "bir gün",
              dd: "%d gün",
              w: "bir hafta",
              ww: "%d hafta",
              M: "bir ay",
              MM: "%d ay",
              y: "bir yıl",
              yy: "%d yıl",
            },
            ordinal: function (e, n) {
              switch (n) {
                case "d":
                case "D":
                case "Do":
                case "DD":
                  return e;
                default:
                  if (0 === e) return e + "'ıncı";
                  var i = e % 10,
                    a = (e % 100) - i,
                    r = e >= 100 ? 100 : null;
                  return e + (t[i] || t[a] || t[r]);
              }
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      8254: function (e, t, n) {
        !(function (e) {
          function t(e, t, n, i) {
            var a = {
              s: ["viensas secunds", "'iensas secunds"],
              ss: [e + " secunds", e + " secunds"],
              m: ["'n míut", "'iens míut"],
              mm: [e + " míuts", e + " míuts"],
              h: ["'n þora", "'iensa þora"],
              hh: [e + " þoras", e + " þoras"],
              d: ["'n ziua", "'iensa ziua"],
              dd: [e + " ziuas", e + " ziuas"],
              M: ["'n mes", "'iens mes"],
              MM: [e + " mesen", e + " mesen"],
              y: ["'n ar", "'iens ar"],
              yy: [e + " ars", e + " ars"],
            };
            return i || t ? a[n][0] : a[n][1];
          }
          e.defineLocale("tzl", {
            months:
              "Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar".split(
                "_"
              ),
            monthsShort:
              "Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec".split("_"),
            weekdays:
              "Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi".split("_"),
            weekdaysShort: "Súl_Lún_Mai_Már_Xhú_Vié_Sát".split("_"),
            weekdaysMin: "Sú_Lú_Ma_Má_Xh_Vi_Sá".split("_"),
            longDateFormat: {
              LT: "HH.mm",
              LTS: "HH.mm.ss",
              L: "DD.MM.YYYY",
              LL: "D. MMMM [dallas] YYYY",
              LLL: "D. MMMM [dallas] YYYY HH.mm",
              LLLL: "dddd, [li] D. MMMM [dallas] YYYY HH.mm",
            },
            meridiemParse: /d\'o|d\'a/i,
            isPM: function (e) {
              return "d'o" === e.toLowerCase();
            },
            meridiem: function (e, t, n) {
              return e > 11 ? (n ? "d'o" : "D'O") : n ? "d'a" : "D'A";
            },
            calendar: {
              sameDay: "[oxhi à] LT",
              nextDay: "[demà à] LT",
              nextWeek: "dddd [à] LT",
              lastDay: "[ieiri à] LT",
              lastWeek: "[sür el] dddd [lasteu à] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "osprei %s",
              past: "ja%s",
              s: t,
              ss: t,
              m: t,
              mm: t,
              h: t,
              hh: t,
              d: t,
              dd: t,
              M: t,
              MM: t,
              y: t,
              yy: t,
            },
            dayOfMonthOrdinalParse: /\d{1,2}\./,
            ordinal: "%d.",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      699: function (e, t, n) {
        !(function (e) {
          e.defineLocale("tzm-latn", {
            months:
              "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split(
                "_"
              ),
            monthsShort:
              "innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir".split(
                "_"
              ),
            weekdays: "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split(
              "_"
            ),
            weekdaysShort:
              "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
            weekdaysMin:
              "asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[asdkh g] LT",
              nextDay: "[aska g] LT",
              nextWeek: "dddd [g] LT",
              lastDay: "[assant g] LT",
              lastWeek: "dddd [g] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "dadkh s yan %s",
              past: "yan %s",
              s: "imik",
              ss: "%d imik",
              m: "minuḍ",
              mm: "%d minuḍ",
              h: "saɛa",
              hh: "%d tassaɛin",
              d: "ass",
              dd: "%d ossan",
              M: "ayowr",
              MM: "%d iyyirn",
              y: "asgas",
              yy: "%d isgasn",
            },
            week: { dow: 6, doy: 12 },
          });
        })(n(381));
      },
      1106: function (e, t, n) {
        !(function (e) {
          e.defineLocale("tzm", {
            months:
              "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split(
                "_"
              ),
            monthsShort:
              "ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ".split(
                "_"
              ),
            weekdays: "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split(
              "_"
            ),
            weekdaysShort:
              "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
            weekdaysMin:
              "ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[ⴰⵙⴷⵅ ⴴ] LT",
              nextDay: "[ⴰⵙⴽⴰ ⴴ] LT",
              nextWeek: "dddd [ⴴ] LT",
              lastDay: "[ⴰⵚⴰⵏⵜ ⴴ] LT",
              lastWeek: "dddd [ⴴ] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s",
              past: "ⵢⴰⵏ %s",
              s: "ⵉⵎⵉⴽ",
              ss: "%d ⵉⵎⵉⴽ",
              m: "ⵎⵉⵏⵓⴺ",
              mm: "%d ⵎⵉⵏⵓⴺ",
              h: "ⵙⴰⵄⴰ",
              hh: "%d ⵜⴰⵙⵙⴰⵄⵉⵏ",
              d: "ⴰⵙⵙ",
              dd: "%d oⵙⵙⴰⵏ",
              M: "ⴰⵢoⵓⵔ",
              MM: "%d ⵉⵢⵢⵉⵔⵏ",
              y: "ⴰⵙⴳⴰⵙ",
              yy: "%d ⵉⵙⴳⴰⵙⵏ",
            },
            week: { dow: 6, doy: 12 },
          });
        })(n(381));
      },
      9288: function (e, t, n) {
        !(function (e) {
          e.defineLocale("ug-cn", {
            months:
              "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split(
                "_"
              ),
            monthsShort:
              "يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر".split(
                "_"
              ),
            weekdays:
              "يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە".split(
                "_"
              ),
            weekdaysShort: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
            weekdaysMin: "يە_دۈ_سە_چا_پە_جۈ_شە".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY-MM-DD",
              LL: "YYYY-يىلىM-ئاينىڭD-كۈنى",
              LLL: "YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm",
              LLLL: "dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm",
            },
            meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "يېرىم كېچە" === t || "سەھەر" === t || "چۈشتىن بۇرۇن" === t
                  ? e
                  : "چۈشتىن كېيىن" === t || "كەچ" === t
                  ? e + 12
                  : e >= 11
                  ? e
                  : e + 12
              );
            },
            meridiem: function (e, t, n) {
              var i = 100 * e + t;
              return i < 600
                ? "يېرىم كېچە"
                : i < 900
                ? "سەھەر"
                : i < 1130
                ? "چۈشتىن بۇرۇن"
                : i < 1230
                ? "چۈش"
                : i < 1800
                ? "چۈشتىن كېيىن"
                : "كەچ";
            },
            calendar: {
              sameDay: "[بۈگۈن سائەت] LT",
              nextDay: "[ئەتە سائەت] LT",
              nextWeek: "[كېلەركى] dddd [سائەت] LT",
              lastDay: "[تۆنۈگۈن] LT",
              lastWeek: "[ئالدىنقى] dddd [سائەت] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s كېيىن",
              past: "%s بۇرۇن",
              s: "نەچچە سېكونت",
              ss: "%d سېكونت",
              m: "بىر مىنۇت",
              mm: "%d مىنۇت",
              h: "بىر سائەت",
              hh: "%d سائەت",
              d: "بىر كۈن",
              dd: "%d كۈن",
              M: "بىر ئاي",
              MM: "%d ئاي",
              y: "بىر يىل",
              yy: "%d يىل",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
            ordinal: function (e, t) {
              switch (t) {
                case "d":
                case "D":
                case "DDD":
                  return e + "-كۈنى";
                case "w":
                case "W":
                  return e + "-ھەپتە";
                default:
                  return e;
              }
            },
            preparse: function (e) {
              return e.replace(/،/g, ",");
            },
            postformat: function (e) {
              return e.replace(/,/g, "،");
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      7691: function (e, t, n) {
        !(function (e) {
          function t(e, t) {
            var n = e.split("_");
            return t % 10 == 1 && t % 100 != 11
              ? n[0]
              : t % 10 >= 2 && t % 10 <= 4 && (t % 100 < 10 || t % 100 >= 20)
              ? n[1]
              : n[2];
          }
          function n(e, n, i) {
            return "m" === i
              ? n
                ? "хвилина"
                : "хвилину"
              : "h" === i
              ? n
                ? "година"
                : "годину"
              : e +
                " " +
                t(
                  {
                    ss: n ? "секунда_секунди_секунд" : "секунду_секунди_секунд",
                    mm: n ? "хвилина_хвилини_хвилин" : "хвилину_хвилини_хвилин",
                    hh: n ? "година_години_годин" : "годину_години_годин",
                    dd: "день_дні_днів",
                    MM: "місяць_місяці_місяців",
                    yy: "рік_роки_років",
                  }[i],
                  +e
                );
          }
          function i(e, t) {
            var n = {
              nominative:
                "неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота".split(
                  "_"
                ),
              accusative:
                "неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу".split(
                  "_"
                ),
              genitive:
                "неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи".split(
                  "_"
                ),
            };
            return !0 === e
              ? n.nominative.slice(1, 7).concat(n.nominative.slice(0, 1))
              : e
              ? n[
                  /(\[[ВвУу]\]) ?dddd/.test(t)
                    ? "accusative"
                    : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(t)
                    ? "genitive"
                    : "nominative"
                ][e.day()]
              : n.nominative;
          }
          function a(e) {
            return function () {
              return e + "о" + (11 === this.hours() ? "б" : "") + "] LT";
            };
          }
          e.defineLocale("uk", {
            months: {
              format:
                "січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня".split(
                  "_"
                ),
              standalone:
                "січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень".split(
                  "_"
                ),
            },
            monthsShort:
              "січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд".split(
                "_"
              ),
            weekdays: i,
            weekdaysShort: "нд_пн_вт_ср_чт_пт_сб".split("_"),
            weekdaysMin: "нд_пн_вт_ср_чт_пт_сб".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD.MM.YYYY",
              LL: "D MMMM YYYY р.",
              LLL: "D MMMM YYYY р., HH:mm",
              LLLL: "dddd, D MMMM YYYY р., HH:mm",
            },
            calendar: {
              sameDay: a("[Сьогодні "),
              nextDay: a("[Завтра "),
              lastDay: a("[Вчора "),
              nextWeek: a("[У] dddd ["),
              lastWeek: function () {
                switch (this.day()) {
                  case 0:
                  case 3:
                  case 5:
                  case 6:
                    return a("[Минулої] dddd [").call(this);
                  case 1:
                  case 2:
                  case 4:
                    return a("[Минулого] dddd [").call(this);
                }
              },
              sameElse: "L",
            },
            relativeTime: {
              future: "за %s",
              past: "%s тому",
              s: "декілька секунд",
              ss: n,
              m: n,
              mm: n,
              h: "годину",
              hh: n,
              d: "день",
              dd: n,
              M: "місяць",
              MM: n,
              y: "рік",
              yy: n,
            },
            meridiemParse: /ночі|ранку|дня|вечора/,
            isPM: function (e) {
              return /^(дня|вечора)$/.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 4
                ? "ночі"
                : e < 12
                ? "ранку"
                : e < 17
                ? "дня"
                : "вечора";
            },
            dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
            ordinal: function (e, t) {
              switch (t) {
                case "M":
                case "d":
                case "DDD":
                case "w":
                case "W":
                  return e + "-й";
                case "D":
                  return e + "-го";
                default:
                  return e;
              }
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      3795: function (e, t, n) {
        !(function (e) {
          var t = [
              "جنوری",
              "فروری",
              "مارچ",
              "اپریل",
              "مئی",
              "جون",
              "جولائی",
              "اگست",
              "ستمبر",
              "اکتوبر",
              "نومبر",
              "دسمبر",
            ],
            n = ["اتوار", "پیر", "منگل", "بدھ", "جمعرات", "جمعہ", "ہفتہ"];
          e.defineLocale("ur", {
            months: t,
            monthsShort: t,
            weekdays: n,
            weekdaysShort: n,
            weekdaysMin: n,
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd، D MMMM YYYY HH:mm",
            },
            meridiemParse: /صبح|شام/,
            isPM: function (e) {
              return "شام" === e;
            },
            meridiem: function (e, t, n) {
              return e < 12 ? "صبح" : "شام";
            },
            calendar: {
              sameDay: "[آج بوقت] LT",
              nextDay: "[کل بوقت] LT",
              nextWeek: "dddd [بوقت] LT",
              lastDay: "[گذشتہ روز بوقت] LT",
              lastWeek: "[گذشتہ] dddd [بوقت] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s بعد",
              past: "%s قبل",
              s: "چند سیکنڈ",
              ss: "%d سیکنڈ",
              m: "ایک منٹ",
              mm: "%d منٹ",
              h: "ایک گھنٹہ",
              hh: "%d گھنٹے",
              d: "ایک دن",
              dd: "%d دن",
              M: "ایک ماہ",
              MM: "%d ماہ",
              y: "ایک سال",
              yy: "%d سال",
            },
            preparse: function (e) {
              return e.replace(/،/g, ",");
            },
            postformat: function (e) {
              return e.replace(/,/g, "،");
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      588: function (e, t, n) {
        !(function (e) {
          e.defineLocale("uz-latn", {
            months:
              "Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr".split(
                "_"
              ),
            monthsShort:
              "Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek".split("_"),
            weekdays:
              "Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba".split(
                "_"
              ),
            weekdaysShort: "Yak_Dush_Sesh_Chor_Pay_Jum_Shan".split("_"),
            weekdaysMin: "Ya_Du_Se_Cho_Pa_Ju_Sha".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "D MMMM YYYY, dddd HH:mm",
            },
            calendar: {
              sameDay: "[Bugun soat] LT [da]",
              nextDay: "[Ertaga] LT [da]",
              nextWeek: "dddd [kuni soat] LT [da]",
              lastDay: "[Kecha soat] LT [da]",
              lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
              sameElse: "L",
            },
            relativeTime: {
              future: "Yaqin %s ichida",
              past: "Bir necha %s oldin",
              s: "soniya",
              ss: "%d soniya",
              m: "bir daqiqa",
              mm: "%d daqiqa",
              h: "bir soat",
              hh: "%d soat",
              d: "bir kun",
              dd: "%d kun",
              M: "bir oy",
              MM: "%d oy",
              y: "bir yil",
              yy: "%d yil",
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      6791: function (e, t, n) {
        !(function (e) {
          e.defineLocale("uz", {
            months:
              "январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр".split(
                "_"
              ),
            monthsShort:
              "янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек".split("_"),
            weekdays:
              "Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба".split("_"),
            weekdaysShort: "Якш_Душ_Сеш_Чор_Пай_Жум_Шан".split("_"),
            weekdaysMin: "Як_Ду_Се_Чо_Па_Жу_Ша".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "D MMMM YYYY, dddd HH:mm",
            },
            calendar: {
              sameDay: "[Бугун соат] LT [да]",
              nextDay: "[Эртага] LT [да]",
              nextWeek: "dddd [куни соат] LT [да]",
              lastDay: "[Кеча соат] LT [да]",
              lastWeek: "[Утган] dddd [куни соат] LT [да]",
              sameElse: "L",
            },
            relativeTime: {
              future: "Якин %s ичида",
              past: "Бир неча %s олдин",
              s: "фурсат",
              ss: "%d фурсат",
              m: "бир дакика",
              mm: "%d дакика",
              h: "бир соат",
              hh: "%d соат",
              d: "бир кун",
              dd: "%d кун",
              M: "бир ой",
              MM: "%d ой",
              y: "бир йил",
              yy: "%d йил",
            },
            week: { dow: 1, doy: 7 },
          });
        })(n(381));
      },
      5666: function (e, t, n) {
        !(function (e) {
          e.defineLocale("vi", {
            months:
              "tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12".split(
                "_"
              ),
            monthsShort:
              "Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy".split(
                "_"
              ),
            weekdaysShort: "CN_T2_T3_T4_T5_T6_T7".split("_"),
            weekdaysMin: "CN_T2_T3_T4_T5_T6_T7".split("_"),
            weekdaysParseExact: !0,
            meridiemParse: /sa|ch/i,
            isPM: function (e) {
              return /^ch$/i.test(e);
            },
            meridiem: function (e, t, n) {
              return e < 12 ? (n ? "sa" : "SA") : n ? "ch" : "CH";
            },
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "D MMMM [năm] YYYY",
              LLL: "D MMMM [năm] YYYY HH:mm",
              LLLL: "dddd, D MMMM [năm] YYYY HH:mm",
              l: "DD/M/YYYY",
              ll: "D MMM YYYY",
              lll: "D MMM YYYY HH:mm",
              llll: "ddd, D MMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[Hôm nay lúc] LT",
              nextDay: "[Ngày mai lúc] LT",
              nextWeek: "dddd [tuần tới lúc] LT",
              lastDay: "[Hôm qua lúc] LT",
              lastWeek: "dddd [tuần trước lúc] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "%s tới",
              past: "%s trước",
              s: "vài giây",
              ss: "%d giây",
              m: "một phút",
              mm: "%d phút",
              h: "một giờ",
              hh: "%d giờ",
              d: "một ngày",
              dd: "%d ngày",
              w: "một tuần",
              ww: "%d tuần",
              M: "một tháng",
              MM: "%d tháng",
              y: "một năm",
              yy: "%d năm",
            },
            dayOfMonthOrdinalParse: /\d{1,2}/,
            ordinal: function (e) {
              return e;
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      4378: function (e, t, n) {
        !(function (e) {
          e.defineLocale("x-pseudo", {
            months:
              "J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér".split(
                "_"
              ),
            monthsShort:
              "J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc".split(
                "_"
              ),
            monthsParseExact: !0,
            weekdays:
              "S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý".split(
                "_"
              ),
            weekdaysShort: "S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát".split("_"),
            weekdaysMin: "S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá".split("_"),
            weekdaysParseExact: !0,
            longDateFormat: {
              LT: "HH:mm",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY HH:mm",
              LLLL: "dddd, D MMMM YYYY HH:mm",
            },
            calendar: {
              sameDay: "[T~ódá~ý át] LT",
              nextDay: "[T~ómó~rró~w át] LT",
              nextWeek: "dddd [át] LT",
              lastDay: "[Ý~ést~érdá~ý át] LT",
              lastWeek: "[L~ást] dddd [át] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "í~ñ %s",
              past: "%s á~gó",
              s: "á ~féw ~sécó~ñds",
              ss: "%d s~écóñ~ds",
              m: "á ~míñ~úté",
              mm: "%d m~íñú~tés",
              h: "á~ñ hó~úr",
              hh: "%d h~óúrs",
              d: "á ~dáý",
              dd: "%d d~áýs",
              M: "á ~móñ~th",
              MM: "%d m~óñt~hs",
              y: "á ~ýéár",
              yy: "%d ý~éárs",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function (e) {
              var t = e % 10;
              return (
                e +
                (1 == ~~((e % 100) / 10)
                  ? "th"
                  : 1 === t
                  ? "st"
                  : 2 === t
                  ? "nd"
                  : 3 === t
                  ? "rd"
                  : "th")
              );
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      5805: function (e, t, n) {
        !(function (e) {
          e.defineLocale("yo", {
            months:
              "Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀".split(
                "_"
              ),
            monthsShort:
              "Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀".split("_"),
            weekdays: "Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta".split("_"),
            weekdaysShort: "Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá".split("_"),
            weekdaysMin: "Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb".split("_"),
            longDateFormat: {
              LT: "h:mm A",
              LTS: "h:mm:ss A",
              L: "DD/MM/YYYY",
              LL: "D MMMM YYYY",
              LLL: "D MMMM YYYY h:mm A",
              LLLL: "dddd, D MMMM YYYY h:mm A",
            },
            calendar: {
              sameDay: "[Ònì ni] LT",
              nextDay: "[Ọ̀la ni] LT",
              nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
              lastDay: "[Àna ni] LT",
              lastWeek: "dddd [Ọsẹ̀ tólọ́] [ni] LT",
              sameElse: "L",
            },
            relativeTime: {
              future: "ní %s",
              past: "%s kọjá",
              s: "ìsẹjú aayá die",
              ss: "aayá %d",
              m: "ìsẹjú kan",
              mm: "ìsẹjú %d",
              h: "wákati kan",
              hh: "wákati %d",
              d: "ọjọ́ kan",
              dd: "ọjọ́ %d",
              M: "osù kan",
              MM: "osù %d",
              y: "ọdún kan",
              yy: "ọdún %d",
            },
            dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
            ordinal: "ọjọ́ %d",
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      3839: function (e, t, n) {
        !(function (e) {
          e.defineLocale("zh-cn", {
            months:
              "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
                "_"
              ),
            monthsShort:
              "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split(
              "_"
            ),
            weekdaysShort: "周日_周一_周二_周三_周四_周五_周六".split("_"),
            weekdaysMin: "日_一_二_三_四_五_六".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY/MM/DD",
              LL: "YYYY年M月D日",
              LLL: "YYYY年M月D日Ah点mm分",
              LLLL: "YYYY年M月D日ddddAh点mm分",
              l: "YYYY/M/D",
              ll: "YYYY年M月D日",
              lll: "YYYY年M月D日 HH:mm",
              llll: "YYYY年M月D日dddd HH:mm",
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "凌晨" === t || "早上" === t || "上午" === t
                  ? e
                  : "下午" === t || "晚上" === t
                  ? e + 12
                  : e >= 11
                  ? e
                  : e + 12
              );
            },
            meridiem: function (e, t, n) {
              var i = 100 * e + t;
              return i < 600
                ? "凌晨"
                : i < 900
                ? "早上"
                : i < 1130
                ? "上午"
                : i < 1230
                ? "中午"
                : i < 1800
                ? "下午"
                : "晚上";
            },
            calendar: {
              sameDay: "[今天]LT",
              nextDay: "[明天]LT",
              nextWeek: function (e) {
                return e.week() !== this.week() ? "[下]dddLT" : "[本]dddLT";
              },
              lastDay: "[昨天]LT",
              lastWeek: function (e) {
                return this.week() !== e.week() ? "[上]dddLT" : "[本]dddLT";
              },
              sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
            ordinal: function (e, t) {
              switch (t) {
                case "d":
                case "D":
                case "DDD":
                  return e + "日";
                case "M":
                  return e + "月";
                case "w":
                case "W":
                  return e + "周";
                default:
                  return e;
              }
            },
            relativeTime: {
              future: "%s后",
              past: "%s前",
              s: "几秒",
              ss: "%d 秒",
              m: "1 分钟",
              mm: "%d 分钟",
              h: "1 小时",
              hh: "%d 小时",
              d: "1 天",
              dd: "%d 天",
              w: "1 周",
              ww: "%d 周",
              M: "1 个月",
              MM: "%d 个月",
              y: "1 年",
              yy: "%d 年",
            },
            week: { dow: 1, doy: 4 },
          });
        })(n(381));
      },
      5726: function (e, t, n) {
        !(function (e) {
          e.defineLocale("zh-hk", {
            months:
              "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
                "_"
              ),
            monthsShort:
              "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split(
              "_"
            ),
            weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
            weekdaysMin: "日_一_二_三_四_五_六".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY/MM/DD",
              LL: "YYYY年M月D日",
              LLL: "YYYY年M月D日 HH:mm",
              LLLL: "YYYY年M月D日dddd HH:mm",
              l: "YYYY/M/D",
              ll: "YYYY年M月D日",
              lll: "YYYY年M月D日 HH:mm",
              llll: "YYYY年M月D日dddd HH:mm",
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "凌晨" === t || "早上" === t || "上午" === t
                  ? e
                  : "中午" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "下午" === t || "晚上" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              var i = 100 * e + t;
              return i < 600
                ? "凌晨"
                : i < 900
                ? "早上"
                : i < 1200
                ? "上午"
                : 1200 === i
                ? "中午"
                : i < 1800
                ? "下午"
                : "晚上";
            },
            calendar: {
              sameDay: "[今天]LT",
              nextDay: "[明天]LT",
              nextWeek: "[下]ddddLT",
              lastDay: "[昨天]LT",
              lastWeek: "[上]ddddLT",
              sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
            ordinal: function (e, t) {
              switch (t) {
                case "d":
                case "D":
                case "DDD":
                  return e + "日";
                case "M":
                  return e + "月";
                case "w":
                case "W":
                  return e + "週";
                default:
                  return e;
              }
            },
            relativeTime: {
              future: "%s後",
              past: "%s前",
              s: "幾秒",
              ss: "%d 秒",
              m: "1 分鐘",
              mm: "%d 分鐘",
              h: "1 小時",
              hh: "%d 小時",
              d: "1 天",
              dd: "%d 天",
              M: "1 個月",
              MM: "%d 個月",
              y: "1 年",
              yy: "%d 年",
            },
          });
        })(n(381));
      },
      9807: function (e, t, n) {
        !(function (e) {
          e.defineLocale("zh-mo", {
            months:
              "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
                "_"
              ),
            monthsShort:
              "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split(
              "_"
            ),
            weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
            weekdaysMin: "日_一_二_三_四_五_六".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "DD/MM/YYYY",
              LL: "YYYY年M月D日",
              LLL: "YYYY年M月D日 HH:mm",
              LLLL: "YYYY年M月D日dddd HH:mm",
              l: "D/M/YYYY",
              ll: "YYYY年M月D日",
              lll: "YYYY年M月D日 HH:mm",
              llll: "YYYY年M月D日dddd HH:mm",
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "凌晨" === t || "早上" === t || "上午" === t
                  ? e
                  : "中午" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "下午" === t || "晚上" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              var i = 100 * e + t;
              return i < 600
                ? "凌晨"
                : i < 900
                ? "早上"
                : i < 1130
                ? "上午"
                : i < 1230
                ? "中午"
                : i < 1800
                ? "下午"
                : "晚上";
            },
            calendar: {
              sameDay: "[今天] LT",
              nextDay: "[明天] LT",
              nextWeek: "[下]dddd LT",
              lastDay: "[昨天] LT",
              lastWeek: "[上]dddd LT",
              sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
            ordinal: function (e, t) {
              switch (t) {
                case "d":
                case "D":
                case "DDD":
                  return e + "日";
                case "M":
                  return e + "月";
                case "w":
                case "W":
                  return e + "週";
                default:
                  return e;
              }
            },
            relativeTime: {
              future: "%s內",
              past: "%s前",
              s: "幾秒",
              ss: "%d 秒",
              m: "1 分鐘",
              mm: "%d 分鐘",
              h: "1 小時",
              hh: "%d 小時",
              d: "1 天",
              dd: "%d 天",
              M: "1 個月",
              MM: "%d 個月",
              y: "1 年",
              yy: "%d 年",
            },
          });
        })(n(381));
      },
      4152: function (e, t, n) {
        !(function (e) {
          e.defineLocale("zh-tw", {
            months:
              "一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月".split(
                "_"
              ),
            monthsShort:
              "1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月".split("_"),
            weekdays: "星期日_星期一_星期二_星期三_星期四_星期五_星期六".split(
              "_"
            ),
            weekdaysShort: "週日_週一_週二_週三_週四_週五_週六".split("_"),
            weekdaysMin: "日_一_二_三_四_五_六".split("_"),
            longDateFormat: {
              LT: "HH:mm",
              LTS: "HH:mm:ss",
              L: "YYYY/MM/DD",
              LL: "YYYY年M月D日",
              LLL: "YYYY年M月D日 HH:mm",
              LLLL: "YYYY年M月D日dddd HH:mm",
              l: "YYYY/M/D",
              ll: "YYYY年M月D日",
              lll: "YYYY年M月D日 HH:mm",
              llll: "YYYY年M月D日dddd HH:mm",
            },
            meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
            meridiemHour: function (e, t) {
              return (
                12 === e && (e = 0),
                "凌晨" === t || "早上" === t || "上午" === t
                  ? e
                  : "中午" === t
                  ? e >= 11
                    ? e
                    : e + 12
                  : "下午" === t || "晚上" === t
                  ? e + 12
                  : void 0
              );
            },
            meridiem: function (e, t, n) {
              var i = 100 * e + t;
              return i < 600
                ? "凌晨"
                : i < 900
                ? "早上"
                : i < 1130
                ? "上午"
                : i < 1230
                ? "中午"
                : i < 1800
                ? "下午"
                : "晚上";
            },
            calendar: {
              sameDay: "[今天] LT",
              nextDay: "[明天] LT",
              nextWeek: "[下]dddd LT",
              lastDay: "[昨天] LT",
              lastWeek: "[上]dddd LT",
              sameElse: "L",
            },
            dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
            ordinal: function (e, t) {
              switch (t) {
                case "d":
                case "D":
                case "DDD":
                  return e + "日";
                case "M":
                  return e + "月";
                case "w":
                case "W":
                  return e + "週";
                default:
                  return e;
              }
            },
            relativeTime: {
              future: "%s後",
              past: "%s前",
              s: "幾秒",
              ss: "%d 秒",
              m: "1 分鐘",
              mm: "%d 分鐘",
              h: "1 小時",
              hh: "%d 小時",
              d: "1 天",
              dd: "%d 天",
              M: "1 個月",
              MM: "%d 個月",
              y: "1 年",
              yy: "%d 年",
            },
          });
        })(n(381));
      },
      5532: function (e, t, n) {
        var i = {
          "./af": 2009,
          "./af.js": 2009,
          "./ar": 867,
          "./ar-dz": 4130,
          "./ar-dz.js": 4130,
          "./ar-kw": 6135,
          "./ar-kw.js": 6135,
          "./ar-ly": 6440,
          "./ar-ly.js": 6440,
          "./ar-ma": 7702,
          "./ar-ma.js": 7702,
          "./ar-ps": 315,
          "./ar-ps.js": 315,
          "./ar-sa": 6040,
          "./ar-sa.js": 6040,
          "./ar-tn": 7100,
          "./ar-tn.js": 7100,
          "./ar.js": 867,
          "./az": 1083,
          "./az.js": 1083,
          "./be": 9808,
          "./be.js": 9808,
          "./bg": 8338,
          "./bg.js": 8338,
          "./bm": 7438,
          "./bm.js": 7438,
          "./bn": 8905,
          "./bn-bd": 6225,
          "./bn-bd.js": 6225,
          "./bn.js": 8905,
          "./bo": 1560,
          "./bo.js": 1560,
          "./br": 1278,
          "./br.js": 1278,
          "./bs": 622,
          "./bs.js": 622,
          "./ca": 2468,
          "./ca.js": 2468,
          "./cs": 5822,
          "./cs.js": 5822,
          "./cv": 877,
          "./cv.js": 877,
          "./cy": 7373,
          "./cy.js": 7373,
          "./da": 4780,
          "./da.js": 4780,
          "./de": 9740,
          "./de-at": 217,
          "./de-at.js": 217,
          "./de-ch": 894,
          "./de-ch.js": 894,
          "./de.js": 9740,
          "./dv": 5300,
          "./dv.js": 5300,
          "./el": 837,
          "./el.js": 837,
          "./en-au": 8348,
          "./en-au.js": 8348,
          "./en-ca": 7925,
          "./en-ca.js": 7925,
          "./en-gb": 2243,
          "./en-gb.js": 2243,
          "./en-ie": 6436,
          "./en-ie.js": 6436,
          "./en-il": 7207,
          "./en-il.js": 7207,
          "./en-in": 4175,
          "./en-in.js": 4175,
          "./en-nz": 6319,
          "./en-nz.js": 6319,
          "./en-sg": 1662,
          "./en-sg.js": 1662,
          "./eo": 2915,
          "./eo.js": 2915,
          "./es": 5655,
          "./es-do": 5251,
          "./es-do.js": 5251,
          "./es-mx": 6112,
          "./es-mx.js": 6112,
          "./es-us": 1146,
          "./es-us.js": 1146,
          "./es.js": 5655,
          "./et": 5603,
          "./et.js": 5603,
          "./eu": 7763,
          "./eu.js": 7763,
          "./fa": 6959,
          "./fa.js": 6959,
          "./fi": 1897,
          "./fi.js": 1897,
          "./fil": 2549,
          "./fil.js": 2549,
          "./fo": 4694,
          "./fo.js": 4694,
          "./fr": 4470,
          "./fr-ca": 3049,
          "./fr-ca.js": 3049,
          "./fr-ch": 2330,
          "./fr-ch.js": 2330,
          "./fr.js": 4470,
          "./fy": 5044,
          "./fy.js": 5044,
          "./ga": 9295,
          "./ga.js": 9295,
          "./gd": 2101,
          "./gd.js": 2101,
          "./gl": 8794,
          "./gl.js": 8794,
          "./gom-deva": 7884,
          "./gom-deva.js": 7884,
          "./gom-latn": 3168,
          "./gom-latn.js": 3168,
          "./gu": 5349,
          "./gu.js": 5349,
          "./he": 4206,
          "./he.js": 4206,
          "./hi": 94,
          "./hi.js": 94,
          "./hr": 316,
          "./hr.js": 316,
          "./hu": 2138,
          "./hu.js": 2138,
          "./hy-am": 1423,
          "./hy-am.js": 1423,
          "./id": 9218,
          "./id.js": 9218,
          "./is": 135,
          "./is.js": 135,
          "./it": 626,
          "./it-ch": 150,
          "./it-ch.js": 150,
          "./it.js": 626,
          "./ja": 9183,
          "./ja.js": 9183,
          "./jv": 4286,
          "./jv.js": 4286,
          "./ka": 2105,
          "./ka.js": 2105,
          "./kk": 7772,
          "./kk.js": 7772,
          "./km": 8758,
          "./km.js": 8758,
          "./kn": 9282,
          "./kn.js": 9282,
          "./ko": 3730,
          "./ko.js": 3730,
          "./ku": 1408,
          "./ku-kmr": 563,
          "./ku-kmr.js": 563,
          "./ku.js": 1408,
          "./ky": 3291,
          "./ky.js": 3291,
          "./lb": 6841,
          "./lb.js": 6841,
          "./lo": 5466,
          "./lo.js": 5466,
          "./lt": 7010,
          "./lt.js": 7010,
          "./lv": 7595,
          "./lv.js": 7595,
          "./me": 9861,
          "./me.js": 9861,
          "./mi": 5493,
          "./mi.js": 5493,
          "./mk": 5966,
          "./mk.js": 5966,
          "./ml": 7341,
          "./ml.js": 7341,
          "./mn": 5115,
          "./mn.js": 5115,
          "./mr": 370,
          "./mr.js": 370,
          "./ms": 9847,
          "./ms-my": 1237,
          "./ms-my.js": 1237,
          "./ms.js": 9847,
          "./mt": 2126,
          "./mt.js": 2126,
          "./my": 6165,
          "./my.js": 6165,
          "./nb": 4924,
          "./nb.js": 4924,
          "./ne": 6744,
          "./ne.js": 6744,
          "./nl": 3901,
          "./nl-be": 9814,
          "./nl-be.js": 9814,
          "./nl.js": 3901,
          "./nn": 3877,
          "./nn.js": 3877,
          "./oc-lnc": 2135,
          "./oc-lnc.js": 2135,
          "./pa-in": 5858,
          "./pa-in.js": 5858,
          "./pl": 4495,
          "./pl.js": 4495,
          "./pt": 9520,
          "./pt-br": 7971,
          "./pt-br.js": 7971,
          "./pt.js": 9520,
          "./ro": 6459,
          "./ro.js": 6459,
          "./ru": 1793,
          "./ru.js": 1793,
          "./sd": 950,
          "./sd.js": 950,
          "./se": 490,
          "./se.js": 490,
          "./si": 124,
          "./si.js": 124,
          "./sk": 4249,
          "./sk.js": 4249,
          "./sl": 4985,
          "./sl.js": 4985,
          "./sq": 1104,
          "./sq.js": 1104,
          "./sr": 9131,
          "./sr-cyrl": 9915,
          "./sr-cyrl.js": 9915,
          "./sr.js": 9131,
          "./ss": 5606,
          "./ss.js": 5606,
          "./sv": 8760,
          "./sv.js": 8760,
          "./sw": 1172,
          "./sw.js": 1172,
          "./ta": 7333,
          "./ta.js": 7333,
          "./te": 3110,
          "./te.js": 3110,
          "./tet": 2095,
          "./tet.js": 2095,
          "./tg": 7321,
          "./tg.js": 7321,
          "./th": 9041,
          "./th.js": 9041,
          "./tk": 9005,
          "./tk.js": 9005,
          "./tl-ph": 5768,
          "./tl-ph.js": 5768,
          "./tlh": 9444,
          "./tlh.js": 9444,
          "./tr": 2397,
          "./tr.js": 2397,
          "./tzl": 8254,
          "./tzl.js": 8254,
          "./tzm": 1106,
          "./tzm-latn": 699,
          "./tzm-latn.js": 699,
          "./tzm.js": 1106,
          "./ug-cn": 9288,
          "./ug-cn.js": 9288,
          "./uk": 7691,
          "./uk.js": 7691,
          "./ur": 3795,
          "./ur.js": 3795,
          "./uz": 6791,
          "./uz-latn": 588,
          "./uz-latn.js": 588,
          "./uz.js": 6791,
          "./vi": 5666,
          "./vi.js": 5666,
          "./x-pseudo": 4378,
          "./x-pseudo.js": 4378,
          "./yo": 5805,
          "./yo.js": 5805,
          "./zh-cn": 3839,
          "./zh-cn.js": 3839,
          "./zh-hk": 5726,
          "./zh-hk.js": 5726,
          "./zh-mo": 9807,
          "./zh-mo.js": 9807,
          "./zh-tw": 4152,
          "./zh-tw.js": 4152,
        };
        function a(e) {
          var t = r(e);
          return n(t);
        }
        function r(e) {
          if (!n.o(i, e)) {
            var t = new Error("Cannot find module '" + e + "'");
            throw ((t.code = "MODULE_NOT_FOUND"), t);
          }
          return i[e];
        }
        (a.keys = function () {
          return Object.keys(i);
        }),
          (a.resolve = r),
          (e.exports = a),
          (a.id = 5532);
      },
      381: function (e, t, n) {
        (e = n.nmd(e)).exports = (function () {
          var t, i;
          function a() {
            return t.apply(null, arguments);
          }
          function r(e) {
            t = e;
          }
          function l(e) {
            return (
              e instanceof Array ||
              "[object Array]" === Object.prototype.toString.call(e)
            );
          }
          function o(e) {
            return (
              null != e &&
              "[object Object]" === Object.prototype.toString.call(e)
            );
          }
          function s(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
          }
          function d(e) {
            if (Object.getOwnPropertyNames)
              return 0 === Object.getOwnPropertyNames(e).length;
            var t;
            for (t in e) if (s(e, t)) return !1;
            return !0;
          }
          function u(e) {
            return void 0 === e;
          }
          function c(e) {
            return (
              "number" == typeof e ||
              "[object Number]" === Object.prototype.toString.call(e)
            );
          }
          function h(e) {
            return (
              e instanceof Date ||
              "[object Date]" === Object.prototype.toString.call(e)
            );
          }
          function m(e, t) {
            var n,
              i = [],
              a = e.length;
            for (n = 0; n < a; ++n) i.push(t(e[n], n));
            return i;
          }
          function f(e, t) {
            for (var n in t) s(t, n) && (e[n] = t[n]);
            return (
              s(t, "toString") && (e.toString = t.toString),
              s(t, "valueOf") && (e.valueOf = t.valueOf),
              e
            );
          }
          function _(e, t, n, i) {
            return qn(e, t, n, i, !0).utc();
          }
          function p() {
            return {
              empty: !1,
              unusedTokens: [],
              unusedInput: [],
              overflow: -2,
              charsLeftOver: 0,
              nullInput: !1,
              invalidEra: null,
              invalidMonth: null,
              invalidFormat: !1,
              userInvalidated: !1,
              iso: !1,
              parsedDateParts: [],
              era: null,
              meridiem: null,
              rfc2822: !1,
              weekdayMismatch: !1,
            };
          }
          function g(e) {
            return null == e._pf && (e._pf = p()), e._pf;
          }
          function y(e) {
            var t = null,
              n = !1,
              a = e._d && !isNaN(e._d.getTime());
            return (
              a &&
                ((t = g(e)),
                (n = i.call(t.parsedDateParts, function (e) {
                  return null != e;
                })),
                (a =
                  t.overflow < 0 &&
                  !t.empty &&
                  !t.invalidEra &&
                  !t.invalidMonth &&
                  !t.invalidWeekday &&
                  !t.weekdayMismatch &&
                  !t.nullInput &&
                  !t.invalidFormat &&
                  !t.userInvalidated &&
                  (!t.meridiem || (t.meridiem && n))),
                e._strict &&
                  (a =
                    a &&
                    0 === t.charsLeftOver &&
                    0 === t.unusedTokens.length &&
                    void 0 === t.bigHour)),
              null != Object.isFrozen && Object.isFrozen(e)
                ? a
                : ((e._isValid = a), e._isValid)
            );
          }
          function v(e) {
            var t = _(NaN);
            return null != e ? f(g(t), e) : (g(t).userInvalidated = !0), t;
          }
          i = Array.prototype.some
            ? Array.prototype.some
            : function (e) {
                var t,
                  n = Object(this),
                  i = n.length >>> 0;
                for (t = 0; t < i; t++)
                  if (t in n && e.call(this, n[t], t, n)) return !0;
                return !1;
              };
          var M = (a.momentProperties = []),
            b = !1;
          function x(e, t) {
            var n,
              i,
              a,
              r = M.length;
            if (
              (u(t._isAMomentObject) ||
                (e._isAMomentObject = t._isAMomentObject),
              u(t._i) || (e._i = t._i),
              u(t._f) || (e._f = t._f),
              u(t._l) || (e._l = t._l),
              u(t._strict) || (e._strict = t._strict),
              u(t._tzm) || (e._tzm = t._tzm),
              u(t._isUTC) || (e._isUTC = t._isUTC),
              u(t._offset) || (e._offset = t._offset),
              u(t._pf) || (e._pf = g(t)),
              u(t._locale) || (e._locale = t._locale),
              r > 0)
            )
              for (n = 0; n < r; n++) u((a = t[(i = M[n])])) || (e[i] = a);
            return e;
          }
          function L(e) {
            x(this, e),
              (this._d = new Date(null != e._d ? e._d.getTime() : NaN)),
              this.isValid() || (this._d = new Date(NaN)),
              !1 === b && ((b = !0), a.updateOffset(this), (b = !1));
          }
          function w(e) {
            return e instanceof L || (null != e && null != e._isAMomentObject);
          }
          function k(e) {
            !1 === a.suppressDeprecationWarnings &&
              "undefined" != typeof console &&
              console.warn &&
              console.warn("Deprecation warning: " + e);
          }
          function Y(e, t) {
            var n = !0;
            return f(function () {
              if (
                (null != a.deprecationHandler && a.deprecationHandler(null, e),
                n)
              ) {
                var i,
                  r,
                  l,
                  o = [],
                  d = arguments.length;
                for (r = 0; r < d; r++) {
                  if (((i = ""), "object" == typeof arguments[r])) {
                    for (l in ((i += "\n[" + r + "] "), arguments[0]))
                      s(arguments[0], l) &&
                        (i += l + ": " + arguments[0][l] + ", ");
                    i = i.slice(0, -2);
                  } else i = arguments[r];
                  o.push(i);
                }
                k(
                  e +
                    "\nArguments: " +
                    Array.prototype.slice.call(o).join("") +
                    "\n" +
                    new Error().stack
                ),
                  (n = !1);
              }
              return t.apply(this, arguments);
            }, t);
          }
          var D,
            T = {};
          function S(e, t) {
            null != a.deprecationHandler && a.deprecationHandler(e, t),
              T[e] || (k(t), (T[e] = !0));
          }
          function j(e) {
            return (
              ("undefined" != typeof Function && e instanceof Function) ||
              "[object Function]" === Object.prototype.toString.call(e)
            );
          }
          function O(e) {
            var t, n;
            for (n in e)
              s(e, n) && (j((t = e[n])) ? (this[n] = t) : (this["_" + n] = t));
            (this._config = e),
              (this._dayOfMonthOrdinalParseLenient = new RegExp(
                (this._dayOfMonthOrdinalParse.source ||
                  this._ordinalParse.source) +
                  "|" +
                  /\d{1,2}/.source
              ));
          }
          function A(e, t) {
            var n,
              i = f({}, e);
            for (n in t)
              s(t, n) &&
                (o(e[n]) && o(t[n])
                  ? ((i[n] = {}), f(i[n], e[n]), f(i[n], t[n]))
                  : null != t[n]
                  ? (i[n] = t[n])
                  : delete i[n]);
            for (n in e) s(e, n) && !s(t, n) && o(e[n]) && (i[n] = f({}, i[n]));
            return i;
          }
          function H(e) {
            null != e && this.set(e);
          }
          (a.suppressDeprecationWarnings = !1),
            (a.deprecationHandler = null),
            (D = Object.keys
              ? Object.keys
              : function (e) {
                  var t,
                    n = [];
                  for (t in e) s(e, t) && n.push(t);
                  return n;
                });
          var E = {
            sameDay: "[Today at] LT",
            nextDay: "[Tomorrow at] LT",
            nextWeek: "dddd [at] LT",
            lastDay: "[Yesterday at] LT",
            lastWeek: "[Last] dddd [at] LT",
            sameElse: "L",
          };
          function C(e, t, n) {
            var i = this._calendar[e] || this._calendar.sameElse;
            return j(i) ? i.call(t, n) : i;
          }
          function P(e, t, n) {
            var i = "" + Math.abs(e),
              a = t - i.length;
            return (
              (e >= 0 ? (n ? "+" : "") : "-") +
              Math.pow(10, Math.max(0, a)).toString().substr(1) +
              i
            );
          }
          var F =
              /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
            I = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
            W = {},
            z = {};
          function N(e, t, n, i) {
            var a = i;
            "string" == typeof i &&
              (a = function () {
                return this[i]();
              }),
              e && (z[e] = a),
              t &&
                (z[t[0]] = function () {
                  return P(a.apply(this, arguments), t[1], t[2]);
                }),
              n &&
                (z[n] = function () {
                  return this.localeData().ordinal(a.apply(this, arguments), e);
                });
          }
          function R(e) {
            return e.match(/\[[\s\S]/)
              ? e.replace(/^\[|\]$/g, "")
              : e.replace(/\\/g, "");
          }
          function B(e) {
            var t,
              n,
              i = e.match(F);
            for (t = 0, n = i.length; t < n; t++)
              z[i[t]] ? (i[t] = z[i[t]]) : (i[t] = R(i[t]));
            return function (t) {
              var a,
                r = "";
              for (a = 0; a < n; a++) r += j(i[a]) ? i[a].call(t, e) : i[a];
              return r;
            };
          }
          function V(e, t) {
            return e.isValid()
              ? ((t = Z(t, e.localeData())), (W[t] = W[t] || B(t)), W[t](e))
              : e.localeData().invalidDate();
          }
          function Z(e, t) {
            var n = 5;
            function i(e) {
              return t.longDateFormat(e) || e;
            }
            for (I.lastIndex = 0; n >= 0 && I.test(e); )
              (e = e.replace(I, i)), (I.lastIndex = 0), (n -= 1);
            return e;
          }
          var U = {
            LTS: "h:mm:ss A",
            LT: "h:mm A",
            L: "MM/DD/YYYY",
            LL: "MMMM D, YYYY",
            LLL: "MMMM D, YYYY h:mm A",
            LLLL: "dddd, MMMM D, YYYY h:mm A",
          };
          function $(e) {
            var t = this._longDateFormat[e],
              n = this._longDateFormat[e.toUpperCase()];
            return t || !n
              ? t
              : ((this._longDateFormat[e] = n
                  .match(F)
                  .map(function (e) {
                    return "MMMM" === e ||
                      "MM" === e ||
                      "DD" === e ||
                      "dddd" === e
                      ? e.slice(1)
                      : e;
                  })
                  .join("")),
                this._longDateFormat[e]);
          }
          var J = "Invalid date";
          function q() {
            return this._invalidDate;
          }
          var G = "%d",
            X = /\d{1,2}/;
          function K(e) {
            return this._ordinal.replace("%d", e);
          }
          var Q = {
            future: "in %s",
            past: "%s ago",
            s: "a few seconds",
            ss: "%d seconds",
            m: "a minute",
            mm: "%d minutes",
            h: "an hour",
            hh: "%d hours",
            d: "a day",
            dd: "%d days",
            w: "a week",
            ww: "%d weeks",
            M: "a month",
            MM: "%d months",
            y: "a year",
            yy: "%d years",
          };
          function ee(e, t, n, i) {
            var a = this._relativeTime[n];
            return j(a) ? a(e, t, n, i) : a.replace(/%d/i, e);
          }
          function te(e, t) {
            var n = this._relativeTime[e > 0 ? "future" : "past"];
            return j(n) ? n(t) : n.replace(/%s/i, t);
          }
          var ne = {
            D: "date",
            dates: "date",
            date: "date",
            d: "day",
            days: "day",
            day: "day",
            e: "weekday",
            weekdays: "weekday",
            weekday: "weekday",
            E: "isoWeekday",
            isoweekdays: "isoWeekday",
            isoweekday: "isoWeekday",
            DDD: "dayOfYear",
            dayofyears: "dayOfYear",
            dayofyear: "dayOfYear",
            h: "hour",
            hours: "hour",
            hour: "hour",
            ms: "millisecond",
            milliseconds: "millisecond",
            millisecond: "millisecond",
            m: "minute",
            minutes: "minute",
            minute: "minute",
            M: "month",
            months: "month",
            month: "month",
            Q: "quarter",
            quarters: "quarter",
            quarter: "quarter",
            s: "second",
            seconds: "second",
            second: "second",
            gg: "weekYear",
            weekyears: "weekYear",
            weekyear: "weekYear",
            GG: "isoWeekYear",
            isoweekyears: "isoWeekYear",
            isoweekyear: "isoWeekYear",
            w: "week",
            weeks: "week",
            week: "week",
            W: "isoWeek",
            isoweeks: "isoWeek",
            isoweek: "isoWeek",
            y: "year",
            years: "year",
            year: "year",
          };
          function ie(e) {
            return "string" == typeof e ? ne[e] || ne[e.toLowerCase()] : void 0;
          }
          function ae(e) {
            var t,
              n,
              i = {};
            for (n in e) s(e, n) && (t = ie(n)) && (i[t] = e[n]);
            return i;
          }
          var re = {
            date: 9,
            day: 11,
            weekday: 11,
            isoWeekday: 11,
            dayOfYear: 4,
            hour: 13,
            millisecond: 16,
            minute: 14,
            month: 8,
            quarter: 7,
            second: 15,
            weekYear: 1,
            isoWeekYear: 1,
            week: 5,
            isoWeek: 5,
            year: 1,
          };
          function le(e) {
            var t,
              n = [];
            for (t in e) s(e, t) && n.push({ unit: t, priority: re[t] });
            return (
              n.sort(function (e, t) {
                return e.priority - t.priority;
              }),
              n
            );
          }
          var oe,
            se = /\d/,
            de = /\d\d/,
            ue = /\d{3}/,
            ce = /\d{4}/,
            he = /[+-]?\d{6}/,
            me = /\d\d?/,
            fe = /\d\d\d\d?/,
            _e = /\d\d\d\d\d\d?/,
            pe = /\d{1,3}/,
            ge = /\d{1,4}/,
            ye = /[+-]?\d{1,6}/,
            ve = /\d+/,
            Me = /[+-]?\d+/,
            be = /Z|[+-]\d\d:?\d\d/gi,
            xe = /Z|[+-]\d\d(?::?\d\d)?/gi,
            Le = /[+-]?\d+(\.\d{1,3})?/,
            we =
              /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
            ke = /^[1-9]\d?/,
            Ye = /^([1-9]\d|\d)/;
          function De(e, t, n) {
            oe[e] = j(t)
              ? t
              : function (e, i) {
                  return e && n ? n : t;
                };
          }
          function Te(e, t) {
            return s(oe, e) ? oe[e](t._strict, t._locale) : new RegExp(Se(e));
          }
          function Se(e) {
            return je(
              e
                .replace("\\", "")
                .replace(
                  /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                  function (e, t, n, i, a) {
                    return t || n || i || a;
                  }
                )
            );
          }
          function je(e) {
            return e.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
          }
          function Oe(e) {
            return e < 0 ? Math.ceil(e) || 0 : Math.floor(e);
          }
          function Ae(e) {
            var t = +e,
              n = 0;
            return 0 !== t && isFinite(t) && (n = Oe(t)), n;
          }
          oe = {};
          var He = {};
          function Ee(e, t) {
            var n,
              i,
              a = t;
            for (
              "string" == typeof e && (e = [e]),
                c(t) &&
                  (a = function (e, n) {
                    n[t] = Ae(e);
                  }),
                i = e.length,
                n = 0;
              n < i;
              n++
            )
              He[e[n]] = a;
          }
          function Ce(e, t) {
            Ee(e, function (e, n, i, a) {
              (i._w = i._w || {}), t(e, i._w, i, a);
            });
          }
          function Pe(e, t, n) {
            null != t && s(He, e) && He[e](t, n._a, n, e);
          }
          function Fe(e) {
            return (e % 4 == 0 && e % 100 != 0) || e % 400 == 0;
          }
          var Ie = 0,
            We = 1,
            ze = 2,
            Ne = 3,
            Re = 4,
            Be = 5,
            Ve = 6,
            Ze = 7,
            Ue = 8;
          function $e(e) {
            return Fe(e) ? 366 : 365;
          }
          N("Y", 0, 0, function () {
            var e = this.year();
            return e <= 9999 ? P(e, 4) : "+" + e;
          }),
            N(0, ["YY", 2], 0, function () {
              return this.year() % 100;
            }),
            N(0, ["YYYY", 4], 0, "year"),
            N(0, ["YYYYY", 5], 0, "year"),
            N(0, ["YYYYYY", 6, !0], 0, "year"),
            De("Y", Me),
            De("YY", me, de),
            De("YYYY", ge, ce),
            De("YYYYY", ye, he),
            De("YYYYYY", ye, he),
            Ee(["YYYYY", "YYYYYY"], Ie),
            Ee("YYYY", function (e, t) {
              t[Ie] = 2 === e.length ? a.parseTwoDigitYear(e) : Ae(e);
            }),
            Ee("YY", function (e, t) {
              t[Ie] = a.parseTwoDigitYear(e);
            }),
            Ee("Y", function (e, t) {
              t[Ie] = parseInt(e, 10);
            }),
            (a.parseTwoDigitYear = function (e) {
              return Ae(e) + (Ae(e) > 68 ? 1900 : 2e3);
            });
          var Je,
            qe = Xe("FullYear", !0);
          function Ge() {
            return Fe(this.year());
          }
          function Xe(e, t) {
            return function (n) {
              return null != n
                ? (Qe(this, e, n), a.updateOffset(this, t), this)
                : Ke(this, e);
            };
          }
          function Ke(e, t) {
            if (!e.isValid()) return NaN;
            var n = e._d,
              i = e._isUTC;
            switch (t) {
              case "Milliseconds":
                return i ? n.getUTCMilliseconds() : n.getMilliseconds();
              case "Seconds":
                return i ? n.getUTCSeconds() : n.getSeconds();
              case "Minutes":
                return i ? n.getUTCMinutes() : n.getMinutes();
              case "Hours":
                return i ? n.getUTCHours() : n.getHours();
              case "Date":
                return i ? n.getUTCDate() : n.getDate();
              case "Day":
                return i ? n.getUTCDay() : n.getDay();
              case "Month":
                return i ? n.getUTCMonth() : n.getMonth();
              case "FullYear":
                return i ? n.getUTCFullYear() : n.getFullYear();
              default:
                return NaN;
            }
          }
          function Qe(e, t, n) {
            var i, a, r, l, o;
            if (e.isValid() && !isNaN(n)) {
              switch (((i = e._d), (a = e._isUTC), t)) {
                case "Milliseconds":
                  return void (a
                    ? i.setUTCMilliseconds(n)
                    : i.setMilliseconds(n));
                case "Seconds":
                  return void (a ? i.setUTCSeconds(n) : i.setSeconds(n));
                case "Minutes":
                  return void (a ? i.setUTCMinutes(n) : i.setMinutes(n));
                case "Hours":
                  return void (a ? i.setUTCHours(n) : i.setHours(n));
                case "Date":
                  return void (a ? i.setUTCDate(n) : i.setDate(n));
                case "FullYear":
                  break;
                default:
                  return;
              }
              (r = n),
                (l = e.month()),
                (o = 29 !== (o = e.date()) || 1 !== l || Fe(r) ? o : 28),
                a ? i.setUTCFullYear(r, l, o) : i.setFullYear(r, l, o);
            }
          }
          function et(e) {
            return j(this[(e = ie(e))]) ? this[e]() : this;
          }
          function tt(e, t) {
            if ("object" == typeof e) {
              var n,
                i = le((e = ae(e))),
                a = i.length;
              for (n = 0; n < a; n++) this[i[n].unit](e[i[n].unit]);
            } else if (j(this[(e = ie(e))])) return this[e](t);
            return this;
          }
          function nt(e, t) {
            return ((e % t) + t) % t;
          }
          function it(e, t) {
            if (isNaN(e) || isNaN(t)) return NaN;
            var n = nt(t, 12);
            return (
              (e += (t - n) / 12),
              1 === n ? (Fe(e) ? 29 : 28) : 31 - ((n % 7) % 2)
            );
          }
          (Je = Array.prototype.indexOf
            ? Array.prototype.indexOf
            : function (e) {
                var t;
                for (t = 0; t < this.length; ++t) if (this[t] === e) return t;
                return -1;
              }),
            N("M", ["MM", 2], "Mo", function () {
              return this.month() + 1;
            }),
            N("MMM", 0, 0, function (e) {
              return this.localeData().monthsShort(this, e);
            }),
            N("MMMM", 0, 0, function (e) {
              return this.localeData().months(this, e);
            }),
            De("M", me, ke),
            De("MM", me, de),
            De("MMM", function (e, t) {
              return t.monthsShortRegex(e);
            }),
            De("MMMM", function (e, t) {
              return t.monthsRegex(e);
            }),
            Ee(["M", "MM"], function (e, t) {
              t[We] = Ae(e) - 1;
            }),
            Ee(["MMM", "MMMM"], function (e, t, n, i) {
              var a = n._locale.monthsParse(e, i, n._strict);
              null != a ? (t[We] = a) : (g(n).invalidMonth = e);
            });
          var at =
              "January_February_March_April_May_June_July_August_September_October_November_December".split(
                "_"
              ),
            rt = "Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec".split("_"),
            lt = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
            ot = we,
            st = we;
          function dt(e, t) {
            return e
              ? l(this._months)
                ? this._months[e.month()]
                : this._months[
                    (this._months.isFormat || lt).test(t)
                      ? "format"
                      : "standalone"
                  ][e.month()]
              : l(this._months)
              ? this._months
              : this._months.standalone;
          }
          function ut(e, t) {
            return e
              ? l(this._monthsShort)
                ? this._monthsShort[e.month()]
                : this._monthsShort[lt.test(t) ? "format" : "standalone"][
                    e.month()
                  ]
              : l(this._monthsShort)
              ? this._monthsShort
              : this._monthsShort.standalone;
          }
          function ct(e, t, n) {
            var i,
              a,
              r,
              l = e.toLocaleLowerCase();
            if (!this._monthsParse)
              for (
                this._monthsParse = [],
                  this._longMonthsParse = [],
                  this._shortMonthsParse = [],
                  i = 0;
                i < 12;
                ++i
              )
                (r = _([2e3, i])),
                  (this._shortMonthsParse[i] = this.monthsShort(
                    r,
                    ""
                  ).toLocaleLowerCase()),
                  (this._longMonthsParse[i] = this.months(
                    r,
                    ""
                  ).toLocaleLowerCase());
            return n
              ? "MMM" === t
                ? -1 !== (a = Je.call(this._shortMonthsParse, l))
                  ? a
                  : null
                : -1 !== (a = Je.call(this._longMonthsParse, l))
                ? a
                : null
              : "MMM" === t
              ? -1 !== (a = Je.call(this._shortMonthsParse, l)) ||
                -1 !== (a = Je.call(this._longMonthsParse, l))
                ? a
                : null
              : -1 !== (a = Je.call(this._longMonthsParse, l)) ||
                -1 !== (a = Je.call(this._shortMonthsParse, l))
              ? a
              : null;
          }
          function ht(e, t, n) {
            var i, a, r;
            if (this._monthsParseExact) return ct.call(this, e, t, n);
            for (
              this._monthsParse ||
                ((this._monthsParse = []),
                (this._longMonthsParse = []),
                (this._shortMonthsParse = [])),
                i = 0;
              i < 12;
              i++
            ) {
              if (
                ((a = _([2e3, i])),
                n &&
                  !this._longMonthsParse[i] &&
                  ((this._longMonthsParse[i] = new RegExp(
                    "^" + this.months(a, "").replace(".", "") + "$",
                    "i"
                  )),
                  (this._shortMonthsParse[i] = new RegExp(
                    "^" + this.monthsShort(a, "").replace(".", "") + "$",
                    "i"
                  ))),
                n ||
                  this._monthsParse[i] ||
                  ((r =
                    "^" + this.months(a, "") + "|^" + this.monthsShort(a, "")),
                  (this._monthsParse[i] = new RegExp(r.replace(".", ""), "i"))),
                n && "MMMM" === t && this._longMonthsParse[i].test(e))
              )
                return i;
              if (n && "MMM" === t && this._shortMonthsParse[i].test(e))
                return i;
              if (!n && this._monthsParse[i].test(e)) return i;
            }
          }
          function mt(e, t) {
            if (!e.isValid()) return e;
            if ("string" == typeof t)
              if (/^\d+$/.test(t)) t = Ae(t);
              else if (!c((t = e.localeData().monthsParse(t)))) return e;
            var n = t,
              i = e.date();
            return (
              (i = i < 29 ? i : Math.min(i, it(e.year(), n))),
              e._isUTC ? e._d.setUTCMonth(n, i) : e._d.setMonth(n, i),
              e
            );
          }
          function ft(e) {
            return null != e
              ? (mt(this, e), a.updateOffset(this, !0), this)
              : Ke(this, "Month");
          }
          function _t() {
            return it(this.year(), this.month());
          }
          function pt(e) {
            return this._monthsParseExact
              ? (s(this, "_monthsRegex") || yt.call(this),
                e ? this._monthsShortStrictRegex : this._monthsShortRegex)
              : (s(this, "_monthsShortRegex") || (this._monthsShortRegex = ot),
                this._monthsShortStrictRegex && e
                  ? this._monthsShortStrictRegex
                  : this._monthsShortRegex);
          }
          function gt(e) {
            return this._monthsParseExact
              ? (s(this, "_monthsRegex") || yt.call(this),
                e ? this._monthsStrictRegex : this._monthsRegex)
              : (s(this, "_monthsRegex") || (this._monthsRegex = st),
                this._monthsStrictRegex && e
                  ? this._monthsStrictRegex
                  : this._monthsRegex);
          }
          function yt() {
            function e(e, t) {
              return t.length - e.length;
            }
            var t,
              n,
              i,
              a,
              r = [],
              l = [],
              o = [];
            for (t = 0; t < 12; t++)
              (n = _([2e3, t])),
                (i = je(this.monthsShort(n, ""))),
                (a = je(this.months(n, ""))),
                r.push(i),
                l.push(a),
                o.push(a),
                o.push(i);
            r.sort(e),
              l.sort(e),
              o.sort(e),
              (this._monthsRegex = new RegExp("^(" + o.join("|") + ")", "i")),
              (this._monthsShortRegex = this._monthsRegex),
              (this._monthsStrictRegex = new RegExp(
                "^(" + l.join("|") + ")",
                "i"
              )),
              (this._monthsShortStrictRegex = new RegExp(
                "^(" + r.join("|") + ")",
                "i"
              ));
          }
          function vt(e, t, n, i, a, r, l) {
            var o;
            return (
              e < 100 && e >= 0
                ? ((o = new Date(e + 400, t, n, i, a, r, l)),
                  isFinite(o.getFullYear()) && o.setFullYear(e))
                : (o = new Date(e, t, n, i, a, r, l)),
              o
            );
          }
          function Mt(e) {
            var t, n;
            return (
              e < 100 && e >= 0
                ? (((n = Array.prototype.slice.call(arguments))[0] = e + 400),
                  (t = new Date(Date.UTC.apply(null, n))),
                  isFinite(t.getUTCFullYear()) && t.setUTCFullYear(e))
                : (t = new Date(Date.UTC.apply(null, arguments))),
              t
            );
          }
          function bt(e, t, n) {
            var i = 7 + t - n;
            return (-(7 + Mt(e, 0, i).getUTCDay() - t) % 7) + i - 1;
          }
          function xt(e, t, n, i, a) {
            var r,
              l,
              o = 1 + 7 * (t - 1) + ((7 + n - i) % 7) + bt(e, i, a);
            return (
              o <= 0
                ? (l = $e((r = e - 1)) + o)
                : o > $e(e)
                ? ((r = e + 1), (l = o - $e(e)))
                : ((r = e), (l = o)),
              { year: r, dayOfYear: l }
            );
          }
          function Lt(e, t, n) {
            var i,
              a,
              r = bt(e.year(), t, n),
              l = Math.floor((e.dayOfYear() - r - 1) / 7) + 1;
            return (
              l < 1
                ? (i = l + wt((a = e.year() - 1), t, n))
                : l > wt(e.year(), t, n)
                ? ((i = l - wt(e.year(), t, n)), (a = e.year() + 1))
                : ((a = e.year()), (i = l)),
              { week: i, year: a }
            );
          }
          function wt(e, t, n) {
            var i = bt(e, t, n),
              a = bt(e + 1, t, n);
            return ($e(e) - i + a) / 7;
          }
          function kt(e) {
            return Lt(e, this._week.dow, this._week.doy).week;
          }
          N("w", ["ww", 2], "wo", "week"),
            N("W", ["WW", 2], "Wo", "isoWeek"),
            De("w", me, ke),
            De("ww", me, de),
            De("W", me, ke),
            De("WW", me, de),
            Ce(["w", "ww", "W", "WW"], function (e, t, n, i) {
              t[i.substr(0, 1)] = Ae(e);
            });
          var Yt = { dow: 0, doy: 6 };
          function Dt() {
            return this._week.dow;
          }
          function Tt() {
            return this._week.doy;
          }
          function St(e) {
            var t = this.localeData().week(this);
            return null == e ? t : this.add(7 * (e - t), "d");
          }
          function jt(e) {
            var t = Lt(this, 1, 4).week;
            return null == e ? t : this.add(7 * (e - t), "d");
          }
          function Ot(e, t) {
            return "string" != typeof e
              ? e
              : isNaN(e)
              ? "number" == typeof (e = t.weekdaysParse(e))
                ? e
                : null
              : parseInt(e, 10);
          }
          function At(e, t) {
            return "string" == typeof e
              ? t.weekdaysParse(e) % 7 || 7
              : isNaN(e)
              ? null
              : e;
          }
          function Ht(e, t) {
            return e.slice(t, 7).concat(e.slice(0, t));
          }
          N("d", 0, "do", "day"),
            N("dd", 0, 0, function (e) {
              return this.localeData().weekdaysMin(this, e);
            }),
            N("ddd", 0, 0, function (e) {
              return this.localeData().weekdaysShort(this, e);
            }),
            N("dddd", 0, 0, function (e) {
              return this.localeData().weekdays(this, e);
            }),
            N("e", 0, 0, "weekday"),
            N("E", 0, 0, "isoWeekday"),
            De("d", me),
            De("e", me),
            De("E", me),
            De("dd", function (e, t) {
              return t.weekdaysMinRegex(e);
            }),
            De("ddd", function (e, t) {
              return t.weekdaysShortRegex(e);
            }),
            De("dddd", function (e, t) {
              return t.weekdaysRegex(e);
            }),
            Ce(["dd", "ddd", "dddd"], function (e, t, n, i) {
              var a = n._locale.weekdaysParse(e, i, n._strict);
              null != a ? (t.d = a) : (g(n).invalidWeekday = e);
            }),
            Ce(["d", "e", "E"], function (e, t, n, i) {
              t[i] = Ae(e);
            });
          var Et =
              "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split(
                "_"
              ),
            Ct = "Sun_Mon_Tue_Wed_Thu_Fri_Sat".split("_"),
            Pt = "Su_Mo_Tu_We_Th_Fr_Sa".split("_"),
            Ft = we,
            It = we,
            Wt = we;
          function zt(e, t) {
            var n = l(this._weekdays)
              ? this._weekdays
              : this._weekdays[
                  e && !0 !== e && this._weekdays.isFormat.test(t)
                    ? "format"
                    : "standalone"
                ];
            return !0 === e ? Ht(n, this._week.dow) : e ? n[e.day()] : n;
          }
          function Nt(e) {
            return !0 === e
              ? Ht(this._weekdaysShort, this._week.dow)
              : e
              ? this._weekdaysShort[e.day()]
              : this._weekdaysShort;
          }
          function Rt(e) {
            return !0 === e
              ? Ht(this._weekdaysMin, this._week.dow)
              : e
              ? this._weekdaysMin[e.day()]
              : this._weekdaysMin;
          }
          function Bt(e, t, n) {
            var i,
              a,
              r,
              l = e.toLocaleLowerCase();
            if (!this._weekdaysParse)
              for (
                this._weekdaysParse = [],
                  this._shortWeekdaysParse = [],
                  this._minWeekdaysParse = [],
                  i = 0;
                i < 7;
                ++i
              )
                (r = _([2e3, 1]).day(i)),
                  (this._minWeekdaysParse[i] = this.weekdaysMin(
                    r,
                    ""
                  ).toLocaleLowerCase()),
                  (this._shortWeekdaysParse[i] = this.weekdaysShort(
                    r,
                    ""
                  ).toLocaleLowerCase()),
                  (this._weekdaysParse[i] = this.weekdays(
                    r,
                    ""
                  ).toLocaleLowerCase());
            return n
              ? "dddd" === t
                ? -1 !== (a = Je.call(this._weekdaysParse, l))
                  ? a
                  : null
                : "ddd" === t
                ? -1 !== (a = Je.call(this._shortWeekdaysParse, l))
                  ? a
                  : null
                : -1 !== (a = Je.call(this._minWeekdaysParse, l))
                ? a
                : null
              : "dddd" === t
              ? -1 !== (a = Je.call(this._weekdaysParse, l)) ||
                -1 !== (a = Je.call(this._shortWeekdaysParse, l)) ||
                -1 !== (a = Je.call(this._minWeekdaysParse, l))
                ? a
                : null
              : "ddd" === t
              ? -1 !== (a = Je.call(this._shortWeekdaysParse, l)) ||
                -1 !== (a = Je.call(this._weekdaysParse, l)) ||
                -1 !== (a = Je.call(this._minWeekdaysParse, l))
                ? a
                : null
              : -1 !== (a = Je.call(this._minWeekdaysParse, l)) ||
                -1 !== (a = Je.call(this._weekdaysParse, l)) ||
                -1 !== (a = Je.call(this._shortWeekdaysParse, l))
              ? a
              : null;
          }
          function Vt(e, t, n) {
            var i, a, r;
            if (this._weekdaysParseExact) return Bt.call(this, e, t, n);
            for (
              this._weekdaysParse ||
                ((this._weekdaysParse = []),
                (this._minWeekdaysParse = []),
                (this._shortWeekdaysParse = []),
                (this._fullWeekdaysParse = [])),
                i = 0;
              i < 7;
              i++
            ) {
              if (
                ((a = _([2e3, 1]).day(i)),
                n &&
                  !this._fullWeekdaysParse[i] &&
                  ((this._fullWeekdaysParse[i] = new RegExp(
                    "^" + this.weekdays(a, "").replace(".", "\\.?") + "$",
                    "i"
                  )),
                  (this._shortWeekdaysParse[i] = new RegExp(
                    "^" + this.weekdaysShort(a, "").replace(".", "\\.?") + "$",
                    "i"
                  )),
                  (this._minWeekdaysParse[i] = new RegExp(
                    "^" + this.weekdaysMin(a, "").replace(".", "\\.?") + "$",
                    "i"
                  ))),
                this._weekdaysParse[i] ||
                  ((r =
                    "^" +
                    this.weekdays(a, "") +
                    "|^" +
                    this.weekdaysShort(a, "") +
                    "|^" +
                    this.weekdaysMin(a, "")),
                  (this._weekdaysParse[i] = new RegExp(
                    r.replace(".", ""),
                    "i"
                  ))),
                n && "dddd" === t && this._fullWeekdaysParse[i].test(e))
              )
                return i;
              if (n && "ddd" === t && this._shortWeekdaysParse[i].test(e))
                return i;
              if (n && "dd" === t && this._minWeekdaysParse[i].test(e))
                return i;
              if (!n && this._weekdaysParse[i].test(e)) return i;
            }
          }
          function Zt(e) {
            if (!this.isValid()) return null != e ? this : NaN;
            var t = Ke(this, "Day");
            return null != e
              ? ((e = Ot(e, this.localeData())), this.add(e - t, "d"))
              : t;
          }
          function Ut(e) {
            if (!this.isValid()) return null != e ? this : NaN;
            var t = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return null == e ? t : this.add(e - t, "d");
          }
          function $t(e) {
            if (!this.isValid()) return null != e ? this : NaN;
            if (null != e) {
              var t = At(e, this.localeData());
              return this.day(this.day() % 7 ? t : t - 7);
            }
            return this.day() || 7;
          }
          function Jt(e) {
            return this._weekdaysParseExact
              ? (s(this, "_weekdaysRegex") || Xt.call(this),
                e ? this._weekdaysStrictRegex : this._weekdaysRegex)
              : (s(this, "_weekdaysRegex") || (this._weekdaysRegex = Ft),
                this._weekdaysStrictRegex && e
                  ? this._weekdaysStrictRegex
                  : this._weekdaysRegex);
          }
          function qt(e) {
            return this._weekdaysParseExact
              ? (s(this, "_weekdaysRegex") || Xt.call(this),
                e ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex)
              : (s(this, "_weekdaysShortRegex") ||
                  (this._weekdaysShortRegex = It),
                this._weekdaysShortStrictRegex && e
                  ? this._weekdaysShortStrictRegex
                  : this._weekdaysShortRegex);
          }
          function Gt(e) {
            return this._weekdaysParseExact
              ? (s(this, "_weekdaysRegex") || Xt.call(this),
                e ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex)
              : (s(this, "_weekdaysMinRegex") || (this._weekdaysMinRegex = Wt),
                this._weekdaysMinStrictRegex && e
                  ? this._weekdaysMinStrictRegex
                  : this._weekdaysMinRegex);
          }
          function Xt() {
            function e(e, t) {
              return t.length - e.length;
            }
            var t,
              n,
              i,
              a,
              r,
              l = [],
              o = [],
              s = [],
              d = [];
            for (t = 0; t < 7; t++)
              (n = _([2e3, 1]).day(t)),
                (i = je(this.weekdaysMin(n, ""))),
                (a = je(this.weekdaysShort(n, ""))),
                (r = je(this.weekdays(n, ""))),
                l.push(i),
                o.push(a),
                s.push(r),
                d.push(i),
                d.push(a),
                d.push(r);
            l.sort(e),
              o.sort(e),
              s.sort(e),
              d.sort(e),
              (this._weekdaysRegex = new RegExp("^(" + d.join("|") + ")", "i")),
              (this._weekdaysShortRegex = this._weekdaysRegex),
              (this._weekdaysMinRegex = this._weekdaysRegex),
              (this._weekdaysStrictRegex = new RegExp(
                "^(" + s.join("|") + ")",
                "i"
              )),
              (this._weekdaysShortStrictRegex = new RegExp(
                "^(" + o.join("|") + ")",
                "i"
              )),
              (this._weekdaysMinStrictRegex = new RegExp(
                "^(" + l.join("|") + ")",
                "i"
              ));
          }
          function Kt() {
            return this.hours() % 12 || 12;
          }
          function Qt() {
            return this.hours() || 24;
          }
          function en(e, t) {
            N(e, 0, 0, function () {
              return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                t
              );
            });
          }
          function tn(e, t) {
            return t._meridiemParse;
          }
          function nn(e) {
            return "p" === (e + "").toLowerCase().charAt(0);
          }
          N("H", ["HH", 2], 0, "hour"),
            N("h", ["hh", 2], 0, Kt),
            N("k", ["kk", 2], 0, Qt),
            N("hmm", 0, 0, function () {
              return "" + Kt.apply(this) + P(this.minutes(), 2);
            }),
            N("hmmss", 0, 0, function () {
              return (
                "" +
                Kt.apply(this) +
                P(this.minutes(), 2) +
                P(this.seconds(), 2)
              );
            }),
            N("Hmm", 0, 0, function () {
              return "" + this.hours() + P(this.minutes(), 2);
            }),
            N("Hmmss", 0, 0, function () {
              return (
                "" + this.hours() + P(this.minutes(), 2) + P(this.seconds(), 2)
              );
            }),
            en("a", !0),
            en("A", !1),
            De("a", tn),
            De("A", tn),
            De("H", me, Ye),
            De("h", me, ke),
            De("k", me, ke),
            De("HH", me, de),
            De("hh", me, de),
            De("kk", me, de),
            De("hmm", fe),
            De("hmmss", _e),
            De("Hmm", fe),
            De("Hmmss", _e),
            Ee(["H", "HH"], Ne),
            Ee(["k", "kk"], function (e, t, n) {
              var i = Ae(e);
              t[Ne] = 24 === i ? 0 : i;
            }),
            Ee(["a", "A"], function (e, t, n) {
              (n._isPm = n._locale.isPM(e)), (n._meridiem = e);
            }),
            Ee(["h", "hh"], function (e, t, n) {
              (t[Ne] = Ae(e)), (g(n).bigHour = !0);
            }),
            Ee("hmm", function (e, t, n) {
              var i = e.length - 2;
              (t[Ne] = Ae(e.substr(0, i))),
                (t[Re] = Ae(e.substr(i))),
                (g(n).bigHour = !0);
            }),
            Ee("hmmss", function (e, t, n) {
              var i = e.length - 4,
                a = e.length - 2;
              (t[Ne] = Ae(e.substr(0, i))),
                (t[Re] = Ae(e.substr(i, 2))),
                (t[Be] = Ae(e.substr(a))),
                (g(n).bigHour = !0);
            }),
            Ee("Hmm", function (e, t, n) {
              var i = e.length - 2;
              (t[Ne] = Ae(e.substr(0, i))), (t[Re] = Ae(e.substr(i)));
            }),
            Ee("Hmmss", function (e, t, n) {
              var i = e.length - 4,
                a = e.length - 2;
              (t[Ne] = Ae(e.substr(0, i))),
                (t[Re] = Ae(e.substr(i, 2))),
                (t[Be] = Ae(e.substr(a)));
            });
          var an = /[ap]\.?m?\.?/i,
            rn = Xe("Hours", !0);
          function ln(e, t, n) {
            return e > 11 ? (n ? "pm" : "PM") : n ? "am" : "AM";
          }
          var on,
            sn = {
              calendar: E,
              longDateFormat: U,
              invalidDate: J,
              ordinal: G,
              dayOfMonthOrdinalParse: X,
              relativeTime: Q,
              months: at,
              monthsShort: rt,
              week: Yt,
              weekdays: Et,
              weekdaysMin: Pt,
              weekdaysShort: Ct,
              meridiemParse: an,
            },
            dn = {},
            un = {};
          function cn(e, t) {
            var n,
              i = Math.min(e.length, t.length);
            for (n = 0; n < i; n += 1) if (e[n] !== t[n]) return n;
            return i;
          }
          function hn(e) {
            return e ? e.toLowerCase().replace("_", "-") : e;
          }
          function mn(e) {
            for (var t, n, i, a, r = 0; r < e.length; ) {
              for (
                t = (a = hn(e[r]).split("-")).length,
                  n = (n = hn(e[r + 1])) ? n.split("-") : null;
                t > 0;

              ) {
                if ((i = _n(a.slice(0, t).join("-")))) return i;
                if (n && n.length >= t && cn(a, n) >= t - 1) break;
                t--;
              }
              r++;
            }
            return on;
          }
          function fn(e) {
            return !(!e || !e.match("^[^/\\\\]*$"));
          }
          function _n(t) {
            var i = null;
            if (void 0 === dn[t] && e && e.exports && fn(t))
              try {
                (i = on._abbr), n(5532)("./" + t), pn(i);
              } catch (e) {
                dn[t] = null;
              }
            return dn[t];
          }
          function pn(e, t) {
            var n;
            return (
              e &&
                ((n = u(t) ? vn(e) : gn(e, t))
                  ? (on = n)
                  : "undefined" != typeof console &&
                    console.warn &&
                    console.warn(
                      "Locale " + e + " not found. Did you forget to load it?"
                    )),
              on._abbr
            );
          }
          function gn(e, t) {
            if (null !== t) {
              var n,
                i = sn;
              if (((t.abbr = e), null != dn[e]))
                S(
                  "defineLocaleOverride",
                  "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info."
                ),
                  (i = dn[e]._config);
              else if (null != t.parentLocale)
                if (null != dn[t.parentLocale]) i = dn[t.parentLocale]._config;
                else {
                  if (null == (n = _n(t.parentLocale)))
                    return (
                      un[t.parentLocale] || (un[t.parentLocale] = []),
                      un[t.parentLocale].push({ name: e, config: t }),
                      null
                    );
                  i = n._config;
                }
              return (
                (dn[e] = new H(A(i, t))),
                un[e] &&
                  un[e].forEach(function (e) {
                    gn(e.name, e.config);
                  }),
                pn(e),
                dn[e]
              );
            }
            return delete dn[e], null;
          }
          function yn(e, t) {
            if (null != t) {
              var n,
                i,
                a = sn;
              null != dn[e] && null != dn[e].parentLocale
                ? dn[e].set(A(dn[e]._config, t))
                : (null != (i = _n(e)) && (a = i._config),
                  (t = A(a, t)),
                  null == i && (t.abbr = e),
                  ((n = new H(t)).parentLocale = dn[e]),
                  (dn[e] = n)),
                pn(e);
            } else
              null != dn[e] &&
                (null != dn[e].parentLocale
                  ? ((dn[e] = dn[e].parentLocale), e === pn() && pn(e))
                  : null != dn[e] && delete dn[e]);
            return dn[e];
          }
          function vn(e) {
            var t;
            if (
              (e && e._locale && e._locale._abbr && (e = e._locale._abbr), !e)
            )
              return on;
            if (!l(e)) {
              if ((t = _n(e))) return t;
              e = [e];
            }
            return mn(e);
          }
          function Mn() {
            return D(dn);
          }
          function bn(e) {
            var t,
              n = e._a;
            return (
              n &&
                -2 === g(e).overflow &&
                ((t =
                  n[We] < 0 || n[We] > 11
                    ? We
                    : n[ze] < 1 || n[ze] > it(n[Ie], n[We])
                    ? ze
                    : n[Ne] < 0 ||
                      n[Ne] > 24 ||
                      (24 === n[Ne] &&
                        (0 !== n[Re] || 0 !== n[Be] || 0 !== n[Ve]))
                    ? Ne
                    : n[Re] < 0 || n[Re] > 59
                    ? Re
                    : n[Be] < 0 || n[Be] > 59
                    ? Be
                    : n[Ve] < 0 || n[Ve] > 999
                    ? Ve
                    : -1),
                g(e)._overflowDayOfYear && (t < Ie || t > ze) && (t = ze),
                g(e)._overflowWeeks && -1 === t && (t = Ze),
                g(e)._overflowWeekday && -1 === t && (t = Ue),
                (g(e).overflow = t)),
              e
            );
          }
          var xn =
              /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            Ln =
              /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
            wn = /Z|[+-]\d\d(?::?\d\d)?/,
            kn = [
              ["YYYYYY-MM-DD", /[+-]\d{6}-\d\d-\d\d/],
              ["YYYY-MM-DD", /\d{4}-\d\d-\d\d/],
              ["GGGG-[W]WW-E", /\d{4}-W\d\d-\d/],
              ["GGGG-[W]WW", /\d{4}-W\d\d/, !1],
              ["YYYY-DDD", /\d{4}-\d{3}/],
              ["YYYY-MM", /\d{4}-\d\d/, !1],
              ["YYYYYYMMDD", /[+-]\d{10}/],
              ["YYYYMMDD", /\d{8}/],
              ["GGGG[W]WWE", /\d{4}W\d{3}/],
              ["GGGG[W]WW", /\d{4}W\d{2}/, !1],
              ["YYYYDDD", /\d{7}/],
              ["YYYYMM", /\d{6}/, !1],
              ["YYYY", /\d{4}/, !1],
            ],
            Yn = [
              ["HH:mm:ss.SSSS", /\d\d:\d\d:\d\d\.\d+/],
              ["HH:mm:ss,SSSS", /\d\d:\d\d:\d\d,\d+/],
              ["HH:mm:ss", /\d\d:\d\d:\d\d/],
              ["HH:mm", /\d\d:\d\d/],
              ["HHmmss.SSSS", /\d\d\d\d\d\d\.\d+/],
              ["HHmmss,SSSS", /\d\d\d\d\d\d,\d+/],
              ["HHmmss", /\d\d\d\d\d\d/],
              ["HHmm", /\d\d\d\d/],
              ["HH", /\d\d/],
            ],
            Dn = /^\/?Date\((-?\d+)/i,
            Tn =
              /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
            Sn = {
              UT: 0,
              GMT: 0,
              EDT: -240,
              EST: -300,
              CDT: -300,
              CST: -360,
              MDT: -360,
              MST: -420,
              PDT: -420,
              PST: -480,
            };
          function jn(e) {
            var t,
              n,
              i,
              a,
              r,
              l,
              o = e._i,
              s = xn.exec(o) || Ln.exec(o),
              d = kn.length,
              u = Yn.length;
            if (s) {
              for (g(e).iso = !0, t = 0, n = d; t < n; t++)
                if (kn[t][1].exec(s[1])) {
                  (a = kn[t][0]), (i = !1 !== kn[t][2]);
                  break;
                }
              if (null == a) return void (e._isValid = !1);
              if (s[3]) {
                for (t = 0, n = u; t < n; t++)
                  if (Yn[t][1].exec(s[3])) {
                    r = (s[2] || " ") + Yn[t][0];
                    break;
                  }
                if (null == r) return void (e._isValid = !1);
              }
              if (!i && null != r) return void (e._isValid = !1);
              if (s[4]) {
                if (!wn.exec(s[4])) return void (e._isValid = !1);
                l = "Z";
              }
              (e._f = a + (r || "") + (l || "")), Rn(e);
            } else e._isValid = !1;
          }
          function On(e, t, n, i, a, r) {
            var l = [
              An(e),
              rt.indexOf(t),
              parseInt(n, 10),
              parseInt(i, 10),
              parseInt(a, 10),
            ];
            return r && l.push(parseInt(r, 10)), l;
          }
          function An(e) {
            var t = parseInt(e, 10);
            return t <= 49 ? 2e3 + t : t <= 999 ? 1900 + t : t;
          }
          function Hn(e) {
            return e
              .replace(/\([^()]*\)|[\n\t]/g, " ")
              .replace(/(\s\s+)/g, " ")
              .replace(/^\s\s*/, "")
              .replace(/\s\s*$/, "");
          }
          function En(e, t, n) {
            return (
              !e ||
              Ct.indexOf(e) === new Date(t[0], t[1], t[2]).getDay() ||
              ((g(n).weekdayMismatch = !0), (n._isValid = !1), !1)
            );
          }
          function Cn(e, t, n) {
            if (e) return Sn[e];
            if (t) return 0;
            var i = parseInt(n, 10),
              a = i % 100;
            return ((i - a) / 100) * 60 + a;
          }
          function Pn(e) {
            var t,
              n = Tn.exec(Hn(e._i));
            if (n) {
              if (
                ((t = On(n[4], n[3], n[2], n[5], n[6], n[7])), !En(n[1], t, e))
              )
                return;
              (e._a = t),
                (e._tzm = Cn(n[8], n[9], n[10])),
                (e._d = Mt.apply(null, e._a)),
                e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
                (g(e).rfc2822 = !0);
            } else e._isValid = !1;
          }
          function Fn(e) {
            var t = Dn.exec(e._i);
            null === t
              ? (jn(e),
                !1 === e._isValid &&
                  (delete e._isValid,
                  Pn(e),
                  !1 === e._isValid &&
                    (delete e._isValid,
                    e._strict
                      ? (e._isValid = !1)
                      : a.createFromInputFallback(e))))
              : (e._d = new Date(+t[1]));
          }
          function In(e, t, n) {
            return null != e ? e : null != t ? t : n;
          }
          function Wn(e) {
            var t = new Date(a.now());
            return e._useUTC
              ? [t.getUTCFullYear(), t.getUTCMonth(), t.getUTCDate()]
              : [t.getFullYear(), t.getMonth(), t.getDate()];
          }
          function zn(e) {
            var t,
              n,
              i,
              a,
              r,
              l = [];
            if (!e._d) {
              for (
                i = Wn(e),
                  e._w && null == e._a[ze] && null == e._a[We] && Nn(e),
                  null != e._dayOfYear &&
                    ((r = In(e._a[Ie], i[Ie])),
                    (e._dayOfYear > $e(r) || 0 === e._dayOfYear) &&
                      (g(e)._overflowDayOfYear = !0),
                    (n = Mt(r, 0, e._dayOfYear)),
                    (e._a[We] = n.getUTCMonth()),
                    (e._a[ze] = n.getUTCDate())),
                  t = 0;
                t < 3 && null == e._a[t];
                ++t
              )
                e._a[t] = l[t] = i[t];
              for (; t < 7; t++)
                e._a[t] = l[t] = null == e._a[t] ? (2 === t ? 1 : 0) : e._a[t];
              24 === e._a[Ne] &&
                0 === e._a[Re] &&
                0 === e._a[Be] &&
                0 === e._a[Ve] &&
                ((e._nextDay = !0), (e._a[Ne] = 0)),
                (e._d = (e._useUTC ? Mt : vt).apply(null, l)),
                (a = e._useUTC ? e._d.getUTCDay() : e._d.getDay()),
                null != e._tzm &&
                  e._d.setUTCMinutes(e._d.getUTCMinutes() - e._tzm),
                e._nextDay && (e._a[Ne] = 24),
                e._w &&
                  void 0 !== e._w.d &&
                  e._w.d !== a &&
                  (g(e).weekdayMismatch = !0);
            }
          }
          function Nn(e) {
            var t, n, i, a, r, l, o, s, d;
            null != (t = e._w).GG || null != t.W || null != t.E
              ? ((r = 1),
                (l = 4),
                (n = In(t.GG, e._a[Ie], Lt(Gn(), 1, 4).year)),
                (i = In(t.W, 1)),
                ((a = In(t.E, 1)) < 1 || a > 7) && (s = !0))
              : ((r = e._locale._week.dow),
                (l = e._locale._week.doy),
                (d = Lt(Gn(), r, l)),
                (n = In(t.gg, e._a[Ie], d.year)),
                (i = In(t.w, d.week)),
                null != t.d
                  ? ((a = t.d) < 0 || a > 6) && (s = !0)
                  : null != t.e
                  ? ((a = t.e + r), (t.e < 0 || t.e > 6) && (s = !0))
                  : (a = r)),
              i < 1 || i > wt(n, r, l)
                ? (g(e)._overflowWeeks = !0)
                : null != s
                ? (g(e)._overflowWeekday = !0)
                : ((o = xt(n, i, a, r, l)),
                  (e._a[Ie] = o.year),
                  (e._dayOfYear = o.dayOfYear));
          }
          function Rn(e) {
            if (e._f !== a.ISO_8601)
              if (e._f !== a.RFC_2822) {
                (e._a = []), (g(e).empty = !0);
                var t,
                  n,
                  i,
                  r,
                  l,
                  o,
                  s,
                  d = "" + e._i,
                  u = d.length,
                  c = 0;
                for (
                  s = (i = Z(e._f, e._locale).match(F) || []).length, t = 0;
                  t < s;
                  t++
                )
                  (r = i[t]),
                    (n = (d.match(Te(r, e)) || [])[0]) &&
                      ((l = d.substr(0, d.indexOf(n))).length > 0 &&
                        g(e).unusedInput.push(l),
                      (d = d.slice(d.indexOf(n) + n.length)),
                      (c += n.length)),
                    z[r]
                      ? (n ? (g(e).empty = !1) : g(e).unusedTokens.push(r),
                        Pe(r, n, e))
                      : e._strict && !n && g(e).unusedTokens.push(r);
                (g(e).charsLeftOver = u - c),
                  d.length > 0 && g(e).unusedInput.push(d),
                  e._a[Ne] <= 12 &&
                    !0 === g(e).bigHour &&
                    e._a[Ne] > 0 &&
                    (g(e).bigHour = void 0),
                  (g(e).parsedDateParts = e._a.slice(0)),
                  (g(e).meridiem = e._meridiem),
                  (e._a[Ne] = Bn(e._locale, e._a[Ne], e._meridiem)),
                  null !== (o = g(e).era) &&
                    (e._a[Ie] = e._locale.erasConvertYear(o, e._a[Ie])),
                  zn(e),
                  bn(e);
              } else Pn(e);
            else jn(e);
          }
          function Bn(e, t, n) {
            var i;
            return null == n
              ? t
              : null != e.meridiemHour
              ? e.meridiemHour(t, n)
              : null != e.isPM
              ? ((i = e.isPM(n)) && t < 12 && (t += 12),
                i || 12 !== t || (t = 0),
                t)
              : t;
          }
          function Vn(e) {
            var t,
              n,
              i,
              a,
              r,
              l,
              o = !1,
              s = e._f.length;
            if (0 === s)
              return (g(e).invalidFormat = !0), void (e._d = new Date(NaN));
            for (a = 0; a < s; a++)
              (r = 0),
                (l = !1),
                (t = x({}, e)),
                null != e._useUTC && (t._useUTC = e._useUTC),
                (t._f = e._f[a]),
                Rn(t),
                y(t) && (l = !0),
                (r += g(t).charsLeftOver),
                (r += 10 * g(t).unusedTokens.length),
                (g(t).score = r),
                o
                  ? r < i && ((i = r), (n = t))
                  : (null == i || r < i || l) &&
                    ((i = r), (n = t), l && (o = !0));
            f(e, n || t);
          }
          function Zn(e) {
            if (!e._d) {
              var t = ae(e._i),
                n = void 0 === t.day ? t.date : t.day;
              (e._a = m(
                [t.year, t.month, n, t.hour, t.minute, t.second, t.millisecond],
                function (e) {
                  return e && parseInt(e, 10);
                }
              )),
                zn(e);
            }
          }
          function Un(e) {
            var t = new L(bn($n(e)));
            return t._nextDay && (t.add(1, "d"), (t._nextDay = void 0)), t;
          }
          function $n(e) {
            var t = e._i,
              n = e._f;
            return (
              (e._locale = e._locale || vn(e._l)),
              null === t || (void 0 === n && "" === t)
                ? v({ nullInput: !0 })
                : ("string" == typeof t && (e._i = t = e._locale.preparse(t)),
                  w(t)
                    ? new L(bn(t))
                    : (h(t) ? (e._d = t) : l(n) ? Vn(e) : n ? Rn(e) : Jn(e),
                      y(e) || (e._d = null),
                      e))
            );
          }
          function Jn(e) {
            var t = e._i;
            u(t)
              ? (e._d = new Date(a.now()))
              : h(t)
              ? (e._d = new Date(t.valueOf()))
              : "string" == typeof t
              ? Fn(e)
              : l(t)
              ? ((e._a = m(t.slice(0), function (e) {
                  return parseInt(e, 10);
                })),
                zn(e))
              : o(t)
              ? Zn(e)
              : c(t)
              ? (e._d = new Date(t))
              : a.createFromInputFallback(e);
          }
          function qn(e, t, n, i, a) {
            var r = {};
            return (
              (!0 !== t && !1 !== t) || ((i = t), (t = void 0)),
              (!0 !== n && !1 !== n) || ((i = n), (n = void 0)),
              ((o(e) && d(e)) || (l(e) && 0 === e.length)) && (e = void 0),
              (r._isAMomentObject = !0),
              (r._useUTC = r._isUTC = a),
              (r._l = n),
              (r._i = e),
              (r._f = t),
              (r._strict = i),
              Un(r)
            );
          }
          function Gn(e, t, n, i) {
            return qn(e, t, n, i, !1);
          }
          (a.createFromInputFallback = Y(
            "value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.",
            function (e) {
              e._d = new Date(e._i + (e._useUTC ? " UTC" : ""));
            }
          )),
            (a.ISO_8601 = function () {}),
            (a.RFC_2822 = function () {});
          var Xn = Y(
              "moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/",
              function () {
                var e = Gn.apply(null, arguments);
                return this.isValid() && e.isValid()
                  ? e < this
                    ? this
                    : e
                  : v();
              }
            ),
            Kn = Y(
              "moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/",
              function () {
                var e = Gn.apply(null, arguments);
                return this.isValid() && e.isValid()
                  ? e > this
                    ? this
                    : e
                  : v();
              }
            );
          function Qn(e, t) {
            var n, i;
            if ((1 === t.length && l(t[0]) && (t = t[0]), !t.length))
              return Gn();
            for (n = t[0], i = 1; i < t.length; ++i)
              (t[i].isValid() && !t[i][e](n)) || (n = t[i]);
            return n;
          }
          function ei() {
            return Qn("isBefore", [].slice.call(arguments, 0));
          }
          function ti() {
            return Qn("isAfter", [].slice.call(arguments, 0));
          }
          var ni = function () {
              return Date.now ? Date.now() : +new Date();
            },
            ii = [
              "year",
              "quarter",
              "month",
              "week",
              "day",
              "hour",
              "minute",
              "second",
              "millisecond",
            ];
          function ai(e) {
            var t,
              n,
              i = !1,
              a = ii.length;
            for (t in e)
              if (
                s(e, t) &&
                (-1 === Je.call(ii, t) || (null != e[t] && isNaN(e[t])))
              )
                return !1;
            for (n = 0; n < a; ++n)
              if (e[ii[n]]) {
                if (i) return !1;
                parseFloat(e[ii[n]]) !== Ae(e[ii[n]]) && (i = !0);
              }
            return !0;
          }
          function ri() {
            return this._isValid;
          }
          function li() {
            return Si(NaN);
          }
          function oi(e) {
            var t = ae(e),
              n = t.year || 0,
              i = t.quarter || 0,
              a = t.month || 0,
              r = t.week || t.isoWeek || 0,
              l = t.day || 0,
              o = t.hour || 0,
              s = t.minute || 0,
              d = t.second || 0,
              u = t.millisecond || 0;
            (this._isValid = ai(t)),
              (this._milliseconds = +u + 1e3 * d + 6e4 * s + 1e3 * o * 60 * 60),
              (this._days = +l + 7 * r),
              (this._months = +a + 3 * i + 12 * n),
              (this._data = {}),
              (this._locale = vn()),
              this._bubble();
          }
          function si(e) {
            return e instanceof oi;
          }
          function di(e) {
            return e < 0 ? -1 * Math.round(-1 * e) : Math.round(e);
          }
          function ui(e, t, n) {
            var i,
              a = Math.min(e.length, t.length),
              r = Math.abs(e.length - t.length),
              l = 0;
            for (i = 0; i < a; i++)
              ((n && e[i] !== t[i]) || (!n && Ae(e[i]) !== Ae(t[i]))) && l++;
            return l + r;
          }
          function ci(e, t) {
            N(e, 0, 0, function () {
              var e = this.utcOffset(),
                n = "+";
              return (
                e < 0 && ((e = -e), (n = "-")),
                n + P(~~(e / 60), 2) + t + P(~~e % 60, 2)
              );
            });
          }
          ci("Z", ":"),
            ci("ZZ", ""),
            De("Z", xe),
            De("ZZ", xe),
            Ee(["Z", "ZZ"], function (e, t, n) {
              (n._useUTC = !0), (n._tzm = mi(xe, e));
            });
          var hi = /([\+\-]|\d\d)/gi;
          function mi(e, t) {
            var n,
              i,
              a = (t || "").match(e);
            return null === a
              ? null
              : 0 ===
                (i =
                  60 *
                    (n = ((a[a.length - 1] || []) + "").match(hi) || [
                      "-",
                      0,
                      0,
                    ])[1] +
                  Ae(n[2]))
              ? 0
              : "+" === n[0]
              ? i
              : -i;
          }
          function fi(e, t) {
            var n, i;
            return t._isUTC
              ? ((n = t.clone()),
                (i =
                  (w(e) || h(e) ? e.valueOf() : Gn(e).valueOf()) - n.valueOf()),
                n._d.setTime(n._d.valueOf() + i),
                a.updateOffset(n, !1),
                n)
              : Gn(e).local();
          }
          function _i(e) {
            return -Math.round(e._d.getTimezoneOffset());
          }
          function pi(e, t, n) {
            var i,
              r = this._offset || 0;
            if (!this.isValid()) return null != e ? this : NaN;
            if (null != e) {
              if ("string" == typeof e) {
                if (null === (e = mi(xe, e))) return this;
              } else Math.abs(e) < 16 && !n && (e *= 60);
              return (
                !this._isUTC && t && (i = _i(this)),
                (this._offset = e),
                (this._isUTC = !0),
                null != i && this.add(i, "m"),
                r !== e &&
                  (!t || this._changeInProgress
                    ? Ei(this, Si(e - r, "m"), 1, !1)
                    : this._changeInProgress ||
                      ((this._changeInProgress = !0),
                      a.updateOffset(this, !0),
                      (this._changeInProgress = null))),
                this
              );
            }
            return this._isUTC ? r : _i(this);
          }
          function gi(e, t) {
            return null != e
              ? ("string" != typeof e && (e = -e), this.utcOffset(e, t), this)
              : -this.utcOffset();
          }
          function yi(e) {
            return this.utcOffset(0, e);
          }
          function vi(e) {
            return (
              this._isUTC &&
                (this.utcOffset(0, e),
                (this._isUTC = !1),
                e && this.subtract(_i(this), "m")),
              this
            );
          }
          function Mi() {
            if (null != this._tzm) this.utcOffset(this._tzm, !1, !0);
            else if ("string" == typeof this._i) {
              var e = mi(be, this._i);
              null != e ? this.utcOffset(e) : this.utcOffset(0, !0);
            }
            return this;
          }
          function bi(e) {
            return (
              !!this.isValid() &&
              ((e = e ? Gn(e).utcOffset() : 0),
              (this.utcOffset() - e) % 60 == 0)
            );
          }
          function xi() {
            return (
              this.utcOffset() > this.clone().month(0).utcOffset() ||
              this.utcOffset() > this.clone().month(5).utcOffset()
            );
          }
          function Li() {
            if (!u(this._isDSTShifted)) return this._isDSTShifted;
            var e,
              t = {};
            return (
              x(t, this),
              (t = $n(t))._a
                ? ((e = t._isUTC ? _(t._a) : Gn(t._a)),
                  (this._isDSTShifted =
                    this.isValid() && ui(t._a, e.toArray()) > 0))
                : (this._isDSTShifted = !1),
              this._isDSTShifted
            );
          }
          function wi() {
            return !!this.isValid() && !this._isUTC;
          }
          function ki() {
            return !!this.isValid() && this._isUTC;
          }
          function Yi() {
            return !!this.isValid() && this._isUTC && 0 === this._offset;
          }
          a.updateOffset = function () {};
          var Di = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
            Ti =
              /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
          function Si(e, t) {
            var n,
              i,
              a,
              r = e,
              l = null;
            return (
              si(e)
                ? (r = { ms: e._milliseconds, d: e._days, M: e._months })
                : c(e) || !isNaN(+e)
                ? ((r = {}), t ? (r[t] = +e) : (r.milliseconds = +e))
                : (l = Di.exec(e))
                ? ((n = "-" === l[1] ? -1 : 1),
                  (r = {
                    y: 0,
                    d: Ae(l[ze]) * n,
                    h: Ae(l[Ne]) * n,
                    m: Ae(l[Re]) * n,
                    s: Ae(l[Be]) * n,
                    ms: Ae(di(1e3 * l[Ve])) * n,
                  }))
                : (l = Ti.exec(e))
                ? ((n = "-" === l[1] ? -1 : 1),
                  (r = {
                    y: ji(l[2], n),
                    M: ji(l[3], n),
                    w: ji(l[4], n),
                    d: ji(l[5], n),
                    h: ji(l[6], n),
                    m: ji(l[7], n),
                    s: ji(l[8], n),
                  }))
                : null == r
                ? (r = {})
                : "object" == typeof r &&
                  ("from" in r || "to" in r) &&
                  ((a = Ai(Gn(r.from), Gn(r.to))),
                  ((r = {}).ms = a.milliseconds),
                  (r.M = a.months)),
              (i = new oi(r)),
              si(e) && s(e, "_locale") && (i._locale = e._locale),
              si(e) && s(e, "_isValid") && (i._isValid = e._isValid),
              i
            );
          }
          function ji(e, t) {
            var n = e && parseFloat(e.replace(",", "."));
            return (isNaN(n) ? 0 : n) * t;
          }
          function Oi(e, t) {
            var n = {};
            return (
              (n.months = t.month() - e.month() + 12 * (t.year() - e.year())),
              e.clone().add(n.months, "M").isAfter(t) && --n.months,
              (n.milliseconds = +t - +e.clone().add(n.months, "M")),
              n
            );
          }
          function Ai(e, t) {
            var n;
            return e.isValid() && t.isValid()
              ? ((t = fi(t, e)),
                e.isBefore(t)
                  ? (n = Oi(e, t))
                  : (((n = Oi(t, e)).milliseconds = -n.milliseconds),
                    (n.months = -n.months)),
                n)
              : { milliseconds: 0, months: 0 };
          }
          function Hi(e, t) {
            return function (n, i) {
              var a;
              return (
                null === i ||
                  isNaN(+i) ||
                  (S(
                    t,
                    "moment()." +
                      t +
                      "(period, number) is deprecated. Please use moment()." +
                      t +
                      "(number, period). See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info."
                  ),
                  (a = n),
                  (n = i),
                  (i = a)),
                Ei(this, Si(n, i), e),
                this
              );
            };
          }
          function Ei(e, t, n, i) {
            var r = t._milliseconds,
              l = di(t._days),
              o = di(t._months);
            e.isValid() &&
              ((i = null == i || i),
              o && mt(e, Ke(e, "Month") + o * n),
              l && Qe(e, "Date", Ke(e, "Date") + l * n),
              r && e._d.setTime(e._d.valueOf() + r * n),
              i && a.updateOffset(e, l || o));
          }
          (Si.fn = oi.prototype), (Si.invalid = li);
          var Ci = Hi(1, "add"),
            Pi = Hi(-1, "subtract");
          function Fi(e) {
            return "string" == typeof e || e instanceof String;
          }
          function Ii(e) {
            return w(e) || h(e) || Fi(e) || c(e) || zi(e) || Wi(e) || null == e;
          }
          function Wi(e) {
            var t,
              n,
              i = o(e) && !d(e),
              a = !1,
              r = [
                "years",
                "year",
                "y",
                "months",
                "month",
                "M",
                "days",
                "day",
                "d",
                "dates",
                "date",
                "D",
                "hours",
                "hour",
                "h",
                "minutes",
                "minute",
                "m",
                "seconds",
                "second",
                "s",
                "milliseconds",
                "millisecond",
                "ms",
              ],
              l = r.length;
            for (t = 0; t < l; t += 1) (n = r[t]), (a = a || s(e, n));
            return i && a;
          }
          function zi(e) {
            var t = l(e),
              n = !1;
            return (
              t &&
                (n =
                  0 ===
                  e.filter(function (t) {
                    return !c(t) && Fi(e);
                  }).length),
              t && n
            );
          }
          function Ni(e) {
            var t,
              n,
              i = o(e) && !d(e),
              a = !1,
              r = [
                "sameDay",
                "nextDay",
                "lastDay",
                "nextWeek",
                "lastWeek",
                "sameElse",
              ];
            for (t = 0; t < r.length; t += 1) (n = r[t]), (a = a || s(e, n));
            return i && a;
          }
          function Ri(e, t) {
            var n = e.diff(t, "days", !0);
            return n < -6
              ? "sameElse"
              : n < -1
              ? "lastWeek"
              : n < 0
              ? "lastDay"
              : n < 1
              ? "sameDay"
              : n < 2
              ? "nextDay"
              : n < 7
              ? "nextWeek"
              : "sameElse";
          }
          function Bi(e, t) {
            1 === arguments.length &&
              (arguments[0]
                ? Ii(arguments[0])
                  ? ((e = arguments[0]), (t = void 0))
                  : Ni(arguments[0]) && ((t = arguments[0]), (e = void 0))
                : ((e = void 0), (t = void 0)));
            var n = e || Gn(),
              i = fi(n, this).startOf("day"),
              r = a.calendarFormat(this, i) || "sameElse",
              l = t && (j(t[r]) ? t[r].call(this, n) : t[r]);
            return this.format(l || this.localeData().calendar(r, this, Gn(n)));
          }
          function Vi() {
            return new L(this);
          }
          function Zi(e, t) {
            var n = w(e) ? e : Gn(e);
            return (
              !(!this.isValid() || !n.isValid()) &&
              ("millisecond" === (t = ie(t) || "millisecond")
                ? this.valueOf() > n.valueOf()
                : n.valueOf() < this.clone().startOf(t).valueOf())
            );
          }
          function Ui(e, t) {
            var n = w(e) ? e : Gn(e);
            return (
              !(!this.isValid() || !n.isValid()) &&
              ("millisecond" === (t = ie(t) || "millisecond")
                ? this.valueOf() < n.valueOf()
                : this.clone().endOf(t).valueOf() < n.valueOf())
            );
          }
          function $i(e, t, n, i) {
            var a = w(e) ? e : Gn(e),
              r = w(t) ? t : Gn(t);
            return (
              !!(this.isValid() && a.isValid() && r.isValid()) &&
              ("(" === (i = i || "()")[0]
                ? this.isAfter(a, n)
                : !this.isBefore(a, n)) &&
              (")" === i[1] ? this.isBefore(r, n) : !this.isAfter(r, n))
            );
          }
          function Ji(e, t) {
            var n,
              i = w(e) ? e : Gn(e);
            return (
              !(!this.isValid() || !i.isValid()) &&
              ("millisecond" === (t = ie(t) || "millisecond")
                ? this.valueOf() === i.valueOf()
                : ((n = i.valueOf()),
                  this.clone().startOf(t).valueOf() <= n &&
                    n <= this.clone().endOf(t).valueOf()))
            );
          }
          function qi(e, t) {
            return this.isSame(e, t) || this.isAfter(e, t);
          }
          function Gi(e, t) {
            return this.isSame(e, t) || this.isBefore(e, t);
          }
          function Xi(e, t, n) {
            var i, a, r;
            if (!this.isValid()) return NaN;
            if (!(i = fi(e, this)).isValid()) return NaN;
            switch (
              ((a = 6e4 * (i.utcOffset() - this.utcOffset())), (t = ie(t)))
            ) {
              case "year":
                r = Ki(this, i) / 12;
                break;
              case "month":
                r = Ki(this, i);
                break;
              case "quarter":
                r = Ki(this, i) / 3;
                break;
              case "second":
                r = (this - i) / 1e3;
                break;
              case "minute":
                r = (this - i) / 6e4;
                break;
              case "hour":
                r = (this - i) / 36e5;
                break;
              case "day":
                r = (this - i - a) / 864e5;
                break;
              case "week":
                r = (this - i - a) / 6048e5;
                break;
              default:
                r = this - i;
            }
            return n ? r : Oe(r);
          }
          function Ki(e, t) {
            if (e.date() < t.date()) return -Ki(t, e);
            var n = 12 * (t.year() - e.year()) + (t.month() - e.month()),
              i = e.clone().add(n, "months");
            return (
              -(
                n +
                (t - i < 0
                  ? (t - i) / (i - e.clone().add(n - 1, "months"))
                  : (t - i) / (e.clone().add(n + 1, "months") - i))
              ) || 0
            );
          }
          function Qi() {
            return this.clone()
              .locale("en")
              .format("ddd MMM DD YYYY HH:mm:ss [GMT]ZZ");
          }
          function ea(e) {
            if (!this.isValid()) return null;
            var t = !0 !== e,
              n = t ? this.clone().utc() : this;
            return n.year() < 0 || n.year() > 9999
              ? V(
                  n,
                  t
                    ? "YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                    : "YYYYYY-MM-DD[T]HH:mm:ss.SSSZ"
                )
              : j(Date.prototype.toISOString)
              ? t
                ? this.toDate().toISOString()
                : new Date(this.valueOf() + 60 * this.utcOffset() * 1e3)
                    .toISOString()
                    .replace("Z", V(n, "Z"))
              : V(
                  n,
                  t
                    ? "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"
                    : "YYYY-MM-DD[T]HH:mm:ss.SSSZ"
                );
          }
          function ta() {
            if (!this.isValid()) return "moment.invalid(/* " + this._i + " */)";
            var e,
              t,
              n,
              i,
              a = "moment",
              r = "";
            return (
              this.isLocal() ||
                ((a =
                  0 === this.utcOffset() ? "moment.utc" : "moment.parseZone"),
                (r = "Z")),
              (e = "[" + a + '("]'),
              (t = 0 <= this.year() && this.year() <= 9999 ? "YYYY" : "YYYYYY"),
              (n = "-MM-DD[T]HH:mm:ss.SSS"),
              (i = r + '[")]'),
              this.format(e + t + n + i)
            );
          }
          function na(e) {
            e || (e = this.isUtc() ? a.defaultFormatUtc : a.defaultFormat);
            var t = V(this, e);
            return this.localeData().postformat(t);
          }
          function ia(e, t) {
            return this.isValid() && ((w(e) && e.isValid()) || Gn(e).isValid())
              ? Si({ to: this, from: e }).locale(this.locale()).humanize(!t)
              : this.localeData().invalidDate();
          }
          function aa(e) {
            return this.from(Gn(), e);
          }
          function ra(e, t) {
            return this.isValid() && ((w(e) && e.isValid()) || Gn(e).isValid())
              ? Si({ from: this, to: e }).locale(this.locale()).humanize(!t)
              : this.localeData().invalidDate();
          }
          function la(e) {
            return this.to(Gn(), e);
          }
          function oa(e) {
            var t;
            return void 0 === e
              ? this._locale._abbr
              : (null != (t = vn(e)) && (this._locale = t), this);
          }
          (a.defaultFormat = "YYYY-MM-DDTHH:mm:ssZ"),
            (a.defaultFormatUtc = "YYYY-MM-DDTHH:mm:ss[Z]");
          var sa = Y(
            "moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.",
            function (e) {
              return void 0 === e ? this.localeData() : this.locale(e);
            }
          );
          function da() {
            return this._locale;
          }
          var ua = 1e3,
            ca = 60 * ua,
            ha = 60 * ca,
            ma = 3506328 * ha;
          function fa(e, t) {
            return ((e % t) + t) % t;
          }
          function _a(e, t, n) {
            return e < 100 && e >= 0
              ? new Date(e + 400, t, n) - ma
              : new Date(e, t, n).valueOf();
          }
          function pa(e, t, n) {
            return e < 100 && e >= 0
              ? Date.UTC(e + 400, t, n) - ma
              : Date.UTC(e, t, n);
          }
          function ga(e) {
            var t, n;
            if (
              void 0 === (e = ie(e)) ||
              "millisecond" === e ||
              !this.isValid()
            )
              return this;
            switch (((n = this._isUTC ? pa : _a), e)) {
              case "year":
                t = n(this.year(), 0, 1);
                break;
              case "quarter":
                t = n(this.year(), this.month() - (this.month() % 3), 1);
                break;
              case "month":
                t = n(this.year(), this.month(), 1);
                break;
              case "week":
                t = n(this.year(), this.month(), this.date() - this.weekday());
                break;
              case "isoWeek":
                t = n(
                  this.year(),
                  this.month(),
                  this.date() - (this.isoWeekday() - 1)
                );
                break;
              case "day":
              case "date":
                t = n(this.year(), this.month(), this.date());
                break;
              case "hour":
                (t = this._d.valueOf()),
                  (t -= fa(t + (this._isUTC ? 0 : this.utcOffset() * ca), ha));
                break;
              case "minute":
                (t = this._d.valueOf()), (t -= fa(t, ca));
                break;
              case "second":
                (t = this._d.valueOf()), (t -= fa(t, ua));
            }
            return this._d.setTime(t), a.updateOffset(this, !0), this;
          }
          function ya(e) {
            var t, n;
            if (
              void 0 === (e = ie(e)) ||
              "millisecond" === e ||
              !this.isValid()
            )
              return this;
            switch (((n = this._isUTC ? pa : _a), e)) {
              case "year":
                t = n(this.year() + 1, 0, 1) - 1;
                break;
              case "quarter":
                t =
                  n(this.year(), this.month() - (this.month() % 3) + 3, 1) - 1;
                break;
              case "month":
                t = n(this.year(), this.month() + 1, 1) - 1;
                break;
              case "week":
                t =
                  n(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday() + 7
                  ) - 1;
                break;
              case "isoWeek":
                t =
                  n(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1) + 7
                  ) - 1;
                break;
              case "day":
              case "date":
                t = n(this.year(), this.month(), this.date() + 1) - 1;
                break;
              case "hour":
                (t = this._d.valueOf()),
                  (t +=
                    ha -
                    fa(t + (this._isUTC ? 0 : this.utcOffset() * ca), ha) -
                    1);
                break;
              case "minute":
                (t = this._d.valueOf()), (t += ca - fa(t, ca) - 1);
                break;
              case "second":
                (t = this._d.valueOf()), (t += ua - fa(t, ua) - 1);
            }
            return this._d.setTime(t), a.updateOffset(this, !0), this;
          }
          function va() {
            return this._d.valueOf() - 6e4 * (this._offset || 0);
          }
          function Ma() {
            return Math.floor(this.valueOf() / 1e3);
          }
          function ba() {
            return new Date(this.valueOf());
          }
          function xa() {
            var e = this;
            return [
              e.year(),
              e.month(),
              e.date(),
              e.hour(),
              e.minute(),
              e.second(),
              e.millisecond(),
            ];
          }
          function La() {
            var e = this;
            return {
              years: e.year(),
              months: e.month(),
              date: e.date(),
              hours: e.hours(),
              minutes: e.minutes(),
              seconds: e.seconds(),
              milliseconds: e.milliseconds(),
            };
          }
          function wa() {
            return this.isValid() ? this.toISOString() : null;
          }
          function ka() {
            return y(this);
          }
          function Ya() {
            return f({}, g(this));
          }
          function Da() {
            return g(this).overflow;
          }
          function Ta() {
            return {
              input: this._i,
              format: this._f,
              locale: this._locale,
              isUTC: this._isUTC,
              strict: this._strict,
            };
          }
          function Sa(e, t) {
            var n,
              i,
              r,
              l = this._eras || vn("en")._eras;
            for (n = 0, i = l.length; n < i; ++n)
              switch (
                ("string" == typeof l[n].since &&
                  ((r = a(l[n].since).startOf("day")),
                  (l[n].since = r.valueOf())),
                typeof l[n].until)
              ) {
                case "undefined":
                  l[n].until = 1 / 0;
                  break;
                case "string":
                  (r = a(l[n].until).startOf("day").valueOf()),
                    (l[n].until = r.valueOf());
              }
            return l;
          }
          function ja(e, t, n) {
            var i,
              a,
              r,
              l,
              o,
              s = this.eras();
            for (e = e.toUpperCase(), i = 0, a = s.length; i < a; ++i)
              if (
                ((r = s[i].name.toUpperCase()),
                (l = s[i].abbr.toUpperCase()),
                (o = s[i].narrow.toUpperCase()),
                n)
              )
                switch (t) {
                  case "N":
                  case "NN":
                  case "NNN":
                    if (l === e) return s[i];
                    break;
                  case "NNNN":
                    if (r === e) return s[i];
                    break;
                  case "NNNNN":
                    if (o === e) return s[i];
                }
              else if ([r, l, o].indexOf(e) >= 0) return s[i];
          }
          function Oa(e, t) {
            var n = e.since <= e.until ? 1 : -1;
            return void 0 === t
              ? a(e.since).year()
              : a(e.since).year() + (t - e.offset) * n;
          }
          function Aa() {
            var e,
              t,
              n,
              i = this.localeData().eras();
            for (e = 0, t = i.length; e < t; ++e) {
              if (
                ((n = this.clone().startOf("day").valueOf()),
                i[e].since <= n && n <= i[e].until)
              )
                return i[e].name;
              if (i[e].until <= n && n <= i[e].since) return i[e].name;
            }
            return "";
          }
          function Ha() {
            var e,
              t,
              n,
              i = this.localeData().eras();
            for (e = 0, t = i.length; e < t; ++e) {
              if (
                ((n = this.clone().startOf("day").valueOf()),
                i[e].since <= n && n <= i[e].until)
              )
                return i[e].narrow;
              if (i[e].until <= n && n <= i[e].since) return i[e].narrow;
            }
            return "";
          }
          function Ea() {
            var e,
              t,
              n,
              i = this.localeData().eras();
            for (e = 0, t = i.length; e < t; ++e) {
              if (
                ((n = this.clone().startOf("day").valueOf()),
                i[e].since <= n && n <= i[e].until)
              )
                return i[e].abbr;
              if (i[e].until <= n && n <= i[e].since) return i[e].abbr;
            }
            return "";
          }
          function Ca() {
            var e,
              t,
              n,
              i,
              r = this.localeData().eras();
            for (e = 0, t = r.length; e < t; ++e)
              if (
                ((n = r[e].since <= r[e].until ? 1 : -1),
                (i = this.clone().startOf("day").valueOf()),
                (r[e].since <= i && i <= r[e].until) ||
                  (r[e].until <= i && i <= r[e].since))
              )
                return (this.year() - a(r[e].since).year()) * n + r[e].offset;
            return this.year();
          }
          function Pa(e) {
            return (
              s(this, "_erasNameRegex") || Ba.call(this),
              e ? this._erasNameRegex : this._erasRegex
            );
          }
          function Fa(e) {
            return (
              s(this, "_erasAbbrRegex") || Ba.call(this),
              e ? this._erasAbbrRegex : this._erasRegex
            );
          }
          function Ia(e) {
            return (
              s(this, "_erasNarrowRegex") || Ba.call(this),
              e ? this._erasNarrowRegex : this._erasRegex
            );
          }
          function Wa(e, t) {
            return t.erasAbbrRegex(e);
          }
          function za(e, t) {
            return t.erasNameRegex(e);
          }
          function Na(e, t) {
            return t.erasNarrowRegex(e);
          }
          function Ra(e, t) {
            return t._eraYearOrdinalRegex || ve;
          }
          function Ba() {
            var e,
              t,
              n,
              i,
              a,
              r = [],
              l = [],
              o = [],
              s = [],
              d = this.eras();
            for (e = 0, t = d.length; e < t; ++e)
              (n = je(d[e].name)),
                (i = je(d[e].abbr)),
                (a = je(d[e].narrow)),
                l.push(n),
                r.push(i),
                o.push(a),
                s.push(n),
                s.push(i),
                s.push(a);
            (this._erasRegex = new RegExp("^(" + s.join("|") + ")", "i")),
              (this._erasNameRegex = new RegExp("^(" + l.join("|") + ")", "i")),
              (this._erasAbbrRegex = new RegExp("^(" + r.join("|") + ")", "i")),
              (this._erasNarrowRegex = new RegExp(
                "^(" + o.join("|") + ")",
                "i"
              ));
          }
          function Va(e, t) {
            N(0, [e, e.length], 0, t);
          }
          function Za(e) {
            return Xa.call(
              this,
              e,
              this.week(),
              this.weekday() + this.localeData()._week.dow,
              this.localeData()._week.dow,
              this.localeData()._week.doy
            );
          }
          function Ua(e) {
            return Xa.call(this, e, this.isoWeek(), this.isoWeekday(), 1, 4);
          }
          function $a() {
            return wt(this.year(), 1, 4);
          }
          function Ja() {
            return wt(this.isoWeekYear(), 1, 4);
          }
          function qa() {
            var e = this.localeData()._week;
            return wt(this.year(), e.dow, e.doy);
          }
          function Ga() {
            var e = this.localeData()._week;
            return wt(this.weekYear(), e.dow, e.doy);
          }
          function Xa(e, t, n, i, a) {
            var r;
            return null == e
              ? Lt(this, i, a).year
              : (t > (r = wt(e, i, a)) && (t = r),
                Ka.call(this, e, t, n, i, a));
          }
          function Ka(e, t, n, i, a) {
            var r = xt(e, t, n, i, a),
              l = Mt(r.year, 0, r.dayOfYear);
            return (
              this.year(l.getUTCFullYear()),
              this.month(l.getUTCMonth()),
              this.date(l.getUTCDate()),
              this
            );
          }
          function Qa(e) {
            return null == e
              ? Math.ceil((this.month() + 1) / 3)
              : this.month(3 * (e - 1) + (this.month() % 3));
          }
          N("N", 0, 0, "eraAbbr"),
            N("NN", 0, 0, "eraAbbr"),
            N("NNN", 0, 0, "eraAbbr"),
            N("NNNN", 0, 0, "eraName"),
            N("NNNNN", 0, 0, "eraNarrow"),
            N("y", ["y", 1], "yo", "eraYear"),
            N("y", ["yy", 2], 0, "eraYear"),
            N("y", ["yyy", 3], 0, "eraYear"),
            N("y", ["yyyy", 4], 0, "eraYear"),
            De("N", Wa),
            De("NN", Wa),
            De("NNN", Wa),
            De("NNNN", za),
            De("NNNNN", Na),
            Ee(["N", "NN", "NNN", "NNNN", "NNNNN"], function (e, t, n, i) {
              var a = n._locale.erasParse(e, i, n._strict);
              a ? (g(n).era = a) : (g(n).invalidEra = e);
            }),
            De("y", ve),
            De("yy", ve),
            De("yyy", ve),
            De("yyyy", ve),
            De("yo", Ra),
            Ee(["y", "yy", "yyy", "yyyy"], Ie),
            Ee(["yo"], function (e, t, n, i) {
              var a;
              n._locale._eraYearOrdinalRegex &&
                (a = e.match(n._locale._eraYearOrdinalRegex)),
                n._locale.eraYearOrdinalParse
                  ? (t[Ie] = n._locale.eraYearOrdinalParse(e, a))
                  : (t[Ie] = parseInt(e, 10));
            }),
            N(0, ["gg", 2], 0, function () {
              return this.weekYear() % 100;
            }),
            N(0, ["GG", 2], 0, function () {
              return this.isoWeekYear() % 100;
            }),
            Va("gggg", "weekYear"),
            Va("ggggg", "weekYear"),
            Va("GGGG", "isoWeekYear"),
            Va("GGGGG", "isoWeekYear"),
            De("G", Me),
            De("g", Me),
            De("GG", me, de),
            De("gg", me, de),
            De("GGGG", ge, ce),
            De("gggg", ge, ce),
            De("GGGGG", ye, he),
            De("ggggg", ye, he),
            Ce(["gggg", "ggggg", "GGGG", "GGGGG"], function (e, t, n, i) {
              t[i.substr(0, 2)] = Ae(e);
            }),
            Ce(["gg", "GG"], function (e, t, n, i) {
              t[i] = a.parseTwoDigitYear(e);
            }),
            N("Q", 0, "Qo", "quarter"),
            De("Q", se),
            Ee("Q", function (e, t) {
              t[We] = 3 * (Ae(e) - 1);
            }),
            N("D", ["DD", 2], "Do", "date"),
            De("D", me, ke),
            De("DD", me, de),
            De("Do", function (e, t) {
              return e
                ? t._dayOfMonthOrdinalParse || t._ordinalParse
                : t._dayOfMonthOrdinalParseLenient;
            }),
            Ee(["D", "DD"], ze),
            Ee("Do", function (e, t) {
              t[ze] = Ae(e.match(me)[0]);
            });
          var er = Xe("Date", !0);
          function tr(e) {
            var t =
              Math.round(
                (this.clone().startOf("day") - this.clone().startOf("year")) /
                  864e5
              ) + 1;
            return null == e ? t : this.add(e - t, "d");
          }
          N("DDD", ["DDDD", 3], "DDDo", "dayOfYear"),
            De("DDD", pe),
            De("DDDD", ue),
            Ee(["DDD", "DDDD"], function (e, t, n) {
              n._dayOfYear = Ae(e);
            }),
            N("m", ["mm", 2], 0, "minute"),
            De("m", me, Ye),
            De("mm", me, de),
            Ee(["m", "mm"], Re);
          var nr = Xe("Minutes", !1);
          N("s", ["ss", 2], 0, "second"),
            De("s", me, Ye),
            De("ss", me, de),
            Ee(["s", "ss"], Be);
          var ir,
            ar,
            rr = Xe("Seconds", !1);
          for (
            N("S", 0, 0, function () {
              return ~~(this.millisecond() / 100);
            }),
              N(0, ["SS", 2], 0, function () {
                return ~~(this.millisecond() / 10);
              }),
              N(0, ["SSS", 3], 0, "millisecond"),
              N(0, ["SSSS", 4], 0, function () {
                return 10 * this.millisecond();
              }),
              N(0, ["SSSSS", 5], 0, function () {
                return 100 * this.millisecond();
              }),
              N(0, ["SSSSSS", 6], 0, function () {
                return 1e3 * this.millisecond();
              }),
              N(0, ["SSSSSSS", 7], 0, function () {
                return 1e4 * this.millisecond();
              }),
              N(0, ["SSSSSSSS", 8], 0, function () {
                return 1e5 * this.millisecond();
              }),
              N(0, ["SSSSSSSSS", 9], 0, function () {
                return 1e6 * this.millisecond();
              }),
              De("S", pe, se),
              De("SS", pe, de),
              De("SSS", pe, ue),
              ir = "SSSS";
            ir.length <= 9;
            ir += "S"
          )
            De(ir, ve);
          function lr(e, t) {
            t[Ve] = Ae(1e3 * ("0." + e));
          }
          for (ir = "S"; ir.length <= 9; ir += "S") Ee(ir, lr);
          function or() {
            return this._isUTC ? "UTC" : "";
          }
          function sr() {
            return this._isUTC ? "Coordinated Universal Time" : "";
          }
          (ar = Xe("Milliseconds", !1)),
            N("z", 0, 0, "zoneAbbr"),
            N("zz", 0, 0, "zoneName");
          var dr = L.prototype;
          function ur(e) {
            return Gn(1e3 * e);
          }
          function cr() {
            return Gn.apply(null, arguments).parseZone();
          }
          function hr(e) {
            return e;
          }
          (dr.add = Ci),
            (dr.calendar = Bi),
            (dr.clone = Vi),
            (dr.diff = Xi),
            (dr.endOf = ya),
            (dr.format = na),
            (dr.from = ia),
            (dr.fromNow = aa),
            (dr.to = ra),
            (dr.toNow = la),
            (dr.get = et),
            (dr.invalidAt = Da),
            (dr.isAfter = Zi),
            (dr.isBefore = Ui),
            (dr.isBetween = $i),
            (dr.isSame = Ji),
            (dr.isSameOrAfter = qi),
            (dr.isSameOrBefore = Gi),
            (dr.isValid = ka),
            (dr.lang = sa),
            (dr.locale = oa),
            (dr.localeData = da),
            (dr.max = Kn),
            (dr.min = Xn),
            (dr.parsingFlags = Ya),
            (dr.set = tt),
            (dr.startOf = ga),
            (dr.subtract = Pi),
            (dr.toArray = xa),
            (dr.toObject = La),
            (dr.toDate = ba),
            (dr.toISOString = ea),
            (dr.inspect = ta),
            "undefined" != typeof Symbol &&
              null != Symbol.for &&
              (dr[Symbol.for("nodejs.util.inspect.custom")] = function () {
                return "Moment<" + this.format() + ">";
              }),
            (dr.toJSON = wa),
            (dr.toString = Qi),
            (dr.unix = Ma),
            (dr.valueOf = va),
            (dr.creationData = Ta),
            (dr.eraName = Aa),
            (dr.eraNarrow = Ha),
            (dr.eraAbbr = Ea),
            (dr.eraYear = Ca),
            (dr.year = qe),
            (dr.isLeapYear = Ge),
            (dr.weekYear = Za),
            (dr.isoWeekYear = Ua),
            (dr.quarter = dr.quarters = Qa),
            (dr.month = ft),
            (dr.daysInMonth = _t),
            (dr.week = dr.weeks = St),
            (dr.isoWeek = dr.isoWeeks = jt),
            (dr.weeksInYear = qa),
            (dr.weeksInWeekYear = Ga),
            (dr.isoWeeksInYear = $a),
            (dr.isoWeeksInISOWeekYear = Ja),
            (dr.date = er),
            (dr.day = dr.days = Zt),
            (dr.weekday = Ut),
            (dr.isoWeekday = $t),
            (dr.dayOfYear = tr),
            (dr.hour = dr.hours = rn),
            (dr.minute = dr.minutes = nr),
            (dr.second = dr.seconds = rr),
            (dr.millisecond = dr.milliseconds = ar),
            (dr.utcOffset = pi),
            (dr.utc = yi),
            (dr.local = vi),
            (dr.parseZone = Mi),
            (dr.hasAlignedHourOffset = bi),
            (dr.isDST = xi),
            (dr.isLocal = wi),
            (dr.isUtcOffset = ki),
            (dr.isUtc = Yi),
            (dr.isUTC = Yi),
            (dr.zoneAbbr = or),
            (dr.zoneName = sr),
            (dr.dates = Y(
              "dates accessor is deprecated. Use date instead.",
              er
            )),
            (dr.months = Y(
              "months accessor is deprecated. Use month instead",
              ft
            )),
            (dr.years = Y(
              "years accessor is deprecated. Use year instead",
              qe
            )),
            (dr.zone = Y(
              "moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/",
              gi
            )),
            (dr.isDSTShifted = Y(
              "isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information",
              Li
            ));
          var mr = H.prototype;
          function fr(e, t, n, i) {
            var a = vn(),
              r = _().set(i, t);
            return a[n](r, e);
          }
          function _r(e, t, n) {
            if ((c(e) && ((t = e), (e = void 0)), (e = e || ""), null != t))
              return fr(e, t, n, "month");
            var i,
              a = [];
            for (i = 0; i < 12; i++) a[i] = fr(e, i, n, "month");
            return a;
          }
          function pr(e, t, n, i) {
            "boolean" == typeof e
              ? (c(t) && ((n = t), (t = void 0)), (t = t || ""))
              : ((n = t = e),
                (e = !1),
                c(t) && ((n = t), (t = void 0)),
                (t = t || ""));
            var a,
              r = vn(),
              l = e ? r._week.dow : 0,
              o = [];
            if (null != n) return fr(t, (n + l) % 7, i, "day");
            for (a = 0; a < 7; a++) o[a] = fr(t, (a + l) % 7, i, "day");
            return o;
          }
          function gr(e, t) {
            return _r(e, t, "months");
          }
          function yr(e, t) {
            return _r(e, t, "monthsShort");
          }
          function vr(e, t, n) {
            return pr(e, t, n, "weekdays");
          }
          function Mr(e, t, n) {
            return pr(e, t, n, "weekdaysShort");
          }
          function br(e, t, n) {
            return pr(e, t, n, "weekdaysMin");
          }
          (mr.calendar = C),
            (mr.longDateFormat = $),
            (mr.invalidDate = q),
            (mr.ordinal = K),
            (mr.preparse = hr),
            (mr.postformat = hr),
            (mr.relativeTime = ee),
            (mr.pastFuture = te),
            (mr.set = O),
            (mr.eras = Sa),
            (mr.erasParse = ja),
            (mr.erasConvertYear = Oa),
            (mr.erasAbbrRegex = Fa),
            (mr.erasNameRegex = Pa),
            (mr.erasNarrowRegex = Ia),
            (mr.months = dt),
            (mr.monthsShort = ut),
            (mr.monthsParse = ht),
            (mr.monthsRegex = gt),
            (mr.monthsShortRegex = pt),
            (mr.week = kt),
            (mr.firstDayOfYear = Tt),
            (mr.firstDayOfWeek = Dt),
            (mr.weekdays = zt),
            (mr.weekdaysMin = Rt),
            (mr.weekdaysShort = Nt),
            (mr.weekdaysParse = Vt),
            (mr.weekdaysRegex = Jt),
            (mr.weekdaysShortRegex = qt),
            (mr.weekdaysMinRegex = Gt),
            (mr.isPM = nn),
            (mr.meridiem = ln),
            pn("en", {
              eras: [
                {
                  since: "0001-01-01",
                  until: 1 / 0,
                  offset: 1,
                  name: "Anno Domini",
                  narrow: "AD",
                  abbr: "AD",
                },
                {
                  since: "0000-12-31",
                  until: -1 / 0,
                  offset: 1,
                  name: "Before Christ",
                  narrow: "BC",
                  abbr: "BC",
                },
              ],
              dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
              ordinal: function (e) {
                var t = e % 10;
                return (
                  e +
                  (1 === Ae((e % 100) / 10)
                    ? "th"
                    : 1 === t
                    ? "st"
                    : 2 === t
                    ? "nd"
                    : 3 === t
                    ? "rd"
                    : "th")
                );
              },
            }),
            (a.lang = Y(
              "moment.lang is deprecated. Use moment.locale instead.",
              pn
            )),
            (a.langData = Y(
              "moment.langData is deprecated. Use moment.localeData instead.",
              vn
            ));
          var xr = Math.abs;
          function Lr() {
            var e = this._data;
            return (
              (this._milliseconds = xr(this._milliseconds)),
              (this._days = xr(this._days)),
              (this._months = xr(this._months)),
              (e.milliseconds = xr(e.milliseconds)),
              (e.seconds = xr(e.seconds)),
              (e.minutes = xr(e.minutes)),
              (e.hours = xr(e.hours)),
              (e.months = xr(e.months)),
              (e.years = xr(e.years)),
              this
            );
          }
          function wr(e, t, n, i) {
            var a = Si(t, n);
            return (
              (e._milliseconds += i * a._milliseconds),
              (e._days += i * a._days),
              (e._months += i * a._months),
              e._bubble()
            );
          }
          function kr(e, t) {
            return wr(this, e, t, 1);
          }
          function Yr(e, t) {
            return wr(this, e, t, -1);
          }
          function Dr(e) {
            return e < 0 ? Math.floor(e) : Math.ceil(e);
          }
          function Tr() {
            var e,
              t,
              n,
              i,
              a,
              r = this._milliseconds,
              l = this._days,
              o = this._months,
              s = this._data;
            return (
              (r >= 0 && l >= 0 && o >= 0) ||
                (r <= 0 && l <= 0 && o <= 0) ||
                ((r += 864e5 * Dr(jr(o) + l)), (l = 0), (o = 0)),
              (s.milliseconds = r % 1e3),
              (e = Oe(r / 1e3)),
              (s.seconds = e % 60),
              (t = Oe(e / 60)),
              (s.minutes = t % 60),
              (n = Oe(t / 60)),
              (s.hours = n % 24),
              (l += Oe(n / 24)),
              (o += a = Oe(Sr(l))),
              (l -= Dr(jr(a))),
              (i = Oe(o / 12)),
              (o %= 12),
              (s.days = l),
              (s.months = o),
              (s.years = i),
              this
            );
          }
          function Sr(e) {
            return (4800 * e) / 146097;
          }
          function jr(e) {
            return (146097 * e) / 4800;
          }
          function Or(e) {
            if (!this.isValid()) return NaN;
            var t,
              n,
              i = this._milliseconds;
            if ("month" === (e = ie(e)) || "quarter" === e || "year" === e)
              switch (
                ((t = this._days + i / 864e5), (n = this._months + Sr(t)), e)
              ) {
                case "month":
                  return n;
                case "quarter":
                  return n / 3;
                case "year":
                  return n / 12;
              }
            else
              switch (((t = this._days + Math.round(jr(this._months))), e)) {
                case "week":
                  return t / 7 + i / 6048e5;
                case "day":
                  return t + i / 864e5;
                case "hour":
                  return 24 * t + i / 36e5;
                case "minute":
                  return 1440 * t + i / 6e4;
                case "second":
                  return 86400 * t + i / 1e3;
                case "millisecond":
                  return Math.floor(864e5 * t) + i;
                default:
                  throw new Error("Unknown unit " + e);
              }
          }
          function Ar(e) {
            return function () {
              return this.as(e);
            };
          }
          var Hr = Ar("ms"),
            Er = Ar("s"),
            Cr = Ar("m"),
            Pr = Ar("h"),
            Fr = Ar("d"),
            Ir = Ar("w"),
            Wr = Ar("M"),
            zr = Ar("Q"),
            Nr = Ar("y"),
            Rr = Hr;
          function Br() {
            return Si(this);
          }
          function Vr(e) {
            return (e = ie(e)), this.isValid() ? this[e + "s"]() : NaN;
          }
          function Zr(e) {
            return function () {
              return this.isValid() ? this._data[e] : NaN;
            };
          }
          var Ur = Zr("milliseconds"),
            $r = Zr("seconds"),
            Jr = Zr("minutes"),
            qr = Zr("hours"),
            Gr = Zr("days"),
            Xr = Zr("months"),
            Kr = Zr("years");
          function Qr() {
            return Oe(this.days() / 7);
          }
          var el = Math.round,
            tl = { ss: 44, s: 45, m: 45, h: 22, d: 26, w: null, M: 11 };
          function nl(e, t, n, i, a) {
            return a.relativeTime(t || 1, !!n, e, i);
          }
          function il(e, t, n, i) {
            var a = Si(e).abs(),
              r = el(a.as("s")),
              l = el(a.as("m")),
              o = el(a.as("h")),
              s = el(a.as("d")),
              d = el(a.as("M")),
              u = el(a.as("w")),
              c = el(a.as("y")),
              h =
                (r <= n.ss && ["s", r]) ||
                (r < n.s && ["ss", r]) ||
                (l <= 1 && ["m"]) ||
                (l < n.m && ["mm", l]) ||
                (o <= 1 && ["h"]) ||
                (o < n.h && ["hh", o]) ||
                (s <= 1 && ["d"]) ||
                (s < n.d && ["dd", s]);
            return (
              null != n.w &&
                (h = h || (u <= 1 && ["w"]) || (u < n.w && ["ww", u])),
              ((h = h ||
                (d <= 1 && ["M"]) ||
                (d < n.M && ["MM", d]) ||
                (c <= 1 && ["y"]) || ["yy", c])[2] = t),
              (h[3] = +e > 0),
              (h[4] = i),
              nl.apply(null, h)
            );
          }
          function al(e) {
            return void 0 === e ? el : "function" == typeof e && ((el = e), !0);
          }
          function rl(e, t) {
            return (
              void 0 !== tl[e] &&
              (void 0 === t
                ? tl[e]
                : ((tl[e] = t), "s" === e && (tl.ss = t - 1), !0))
            );
          }
          function ll(e, t) {
            if (!this.isValid()) return this.localeData().invalidDate();
            var n,
              i,
              a = !1,
              r = tl;
            return (
              "object" == typeof e && ((t = e), (e = !1)),
              "boolean" == typeof e && (a = e),
              "object" == typeof t &&
                ((r = Object.assign({}, tl, t)),
                null != t.s && null == t.ss && (r.ss = t.s - 1)),
              (i = il(this, !a, r, (n = this.localeData()))),
              a && (i = n.pastFuture(+this, i)),
              n.postformat(i)
            );
          }
          var ol = Math.abs;
          function sl(e) {
            return (e > 0) - (e < 0) || +e;
          }
          function dl() {
            if (!this.isValid()) return this.localeData().invalidDate();
            var e,
              t,
              n,
              i,
              a,
              r,
              l,
              o,
              s = ol(this._milliseconds) / 1e3,
              d = ol(this._days),
              u = ol(this._months),
              c = this.asSeconds();
            return c
              ? ((e = Oe(s / 60)),
                (t = Oe(e / 60)),
                (s %= 60),
                (e %= 60),
                (n = Oe(u / 12)),
                (u %= 12),
                (i = s ? s.toFixed(3).replace(/\.?0+$/, "") : ""),
                (a = c < 0 ? "-" : ""),
                (r = sl(this._months) !== sl(c) ? "-" : ""),
                (l = sl(this._days) !== sl(c) ? "-" : ""),
                (o = sl(this._milliseconds) !== sl(c) ? "-" : ""),
                a +
                  "P" +
                  (n ? r + n + "Y" : "") +
                  (u ? r + u + "M" : "") +
                  (d ? l + d + "D" : "") +
                  (t || e || s ? "T" : "") +
                  (t ? o + t + "H" : "") +
                  (e ? o + e + "M" : "") +
                  (s ? o + i + "S" : ""))
              : "P0D";
          }
          var ul = oi.prototype;
          return (
            (ul.isValid = ri),
            (ul.abs = Lr),
            (ul.add = kr),
            (ul.subtract = Yr),
            (ul.as = Or),
            (ul.asMilliseconds = Hr),
            (ul.asSeconds = Er),
            (ul.asMinutes = Cr),
            (ul.asHours = Pr),
            (ul.asDays = Fr),
            (ul.asWeeks = Ir),
            (ul.asMonths = Wr),
            (ul.asQuarters = zr),
            (ul.asYears = Nr),
            (ul.valueOf = Rr),
            (ul._bubble = Tr),
            (ul.clone = Br),
            (ul.get = Vr),
            (ul.milliseconds = Ur),
            (ul.seconds = $r),
            (ul.minutes = Jr),
            (ul.hours = qr),
            (ul.days = Gr),
            (ul.weeks = Qr),
            (ul.months = Xr),
            (ul.years = Kr),
            (ul.humanize = ll),
            (ul.toISOString = dl),
            (ul.toString = dl),
            (ul.toJSON = dl),
            (ul.locale = oa),
            (ul.localeData = da),
            (ul.toIsoString = Y(
              "toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)",
              dl
            )),
            (ul.lang = sa),
            N("X", 0, 0, "unix"),
            N("x", 0, 0, "valueOf"),
            De("x", Me),
            De("X", Le),
            Ee("X", function (e, t, n) {
              n._d = new Date(1e3 * parseFloat(e));
            }),
            Ee("x", function (e, t, n) {
              n._d = new Date(Ae(e));
            }),
            (a.version = "2.30.1"),
            r(Gn),
            (a.fn = dr),
            (a.min = ei),
            (a.max = ti),
            (a.now = ni),
            (a.utc = _),
            (a.unix = ur),
            (a.months = gr),
            (a.isDate = h),
            (a.locale = pn),
            (a.invalid = v),
            (a.duration = Si),
            (a.isMoment = w),
            (a.weekdays = vr),
            (a.parseZone = cr),
            (a.localeData = vn),
            (a.isDuration = si),
            (a.monthsShort = yr),
            (a.weekdaysMin = br),
            (a.defineLocale = gn),
            (a.updateLocale = yn),
            (a.locales = Mn),
            (a.weekdaysShort = Mr),
            (a.normalizeUnits = ie),
            (a.relativeTimeRounding = al),
            (a.relativeTimeThreshold = rl),
            (a.calendarFormat = Ri),
            (a.prototype = dr),
            (a.HTML5_FMT = {
              DATETIME_LOCAL: "YYYY-MM-DDTHH:mm",
              DATETIME_LOCAL_SECONDS: "YYYY-MM-DDTHH:mm:ss",
              DATETIME_LOCAL_MS: "YYYY-MM-DDTHH:mm:ss.SSS",
              DATE: "YYYY-MM-DD",
              TIME: "HH:mm",
              TIME_SECONDS: "HH:mm:ss",
              TIME_MS: "HH:mm:ss.SSS",
              WEEK: "GGGG-[W]WW",
              MONTH: "YYYY-MM",
            }),
            a
          );
        })();
      },
      5084: function (e, t, n) {
        var i = n(5709),
          a = n(1812),
          r = TypeError;
        e.exports = function (e) {
          if (i(e)) return e;
          throw new r(a(e) + " is not a function");
        };
      },
      7230: function (e, t, n) {
        var i = n(990),
          a = String,
          r = TypeError;
        e.exports = function (e) {
          if (i(e)) return e;
          throw new r("Can't set " + a(e) + " as a prototype");
        };
      },
      7342: function (e, t, n) {
        var i = n(140),
          a = n(6716),
          r = n(5489).f,
          l = i("unscopables"),
          o = Array.prototype;
        void 0 === o[l] && r(o, l, { configurable: !0, value: a(null) }),
          (e.exports = function (e) {
            o[l][e] = !0;
          });
      },
      5876: function (e, t, n) {
        var i = n(8630).charAt;
        e.exports = function (e, t, n) {
          return t + (n ? i(e, t).length : 1);
        };
      },
      2267: function (e, t, n) {
        var i = n(9554),
          a = TypeError;
        e.exports = function (e, t) {
          if (i(t, e)) return e;
          throw new a("Incorrect invocation");
        };
      },
      421: function (e, t, n) {
        var i = n(4728),
          a = String,
          r = TypeError;
        e.exports = function (e) {
          if (i(e)) return e;
          throw new r(a(e) + " is not an object");
        };
      },
      2591: function (e, t, n) {
        var i = n(5659);
        e.exports = i(function () {
          if ("function" == typeof ArrayBuffer) {
            var e = new ArrayBuffer(8);
            Object.isExtensible(e) &&
              Object.defineProperty(e, "a", { value: 8 });
          }
        });
      },
      9704: function (e, t, n) {
        var i = n(2246).forEach,
          a = n(2388)("forEach");
        e.exports = a
          ? [].forEach
          : function (e) {
              return i(this, e, arguments.length > 1 ? arguments[1] : void 0);
            };
      },
      6464: function (e, t, n) {
        var i = n(93),
          a = n(8575),
          r = n(2402),
          l = function (e) {
            return function (t, n, l) {
              var o = i(t),
                s = r(o);
              if (0 === s) return !e && -1;
              var d,
                u = a(l, s);
              if (e && n != n) {
                for (; s > u; ) if ((d = o[u++]) != d) return !0;
              } else
                for (; s > u; u++)
                  if ((e || u in o) && o[u] === n) return e || u || 0;
              return !e && -1;
            };
          };
        e.exports = { includes: l(!0), indexOf: l(!1) };
      },
      2246: function (e, t, n) {
        var i = n(9970),
          a = n(2786),
          r = n(9546),
          l = n(3517),
          o = n(2402),
          s = n(2873),
          d = a([].push),
          u = function (e) {
            var t = 1 === e,
              n = 2 === e,
              a = 3 === e,
              u = 4 === e,
              c = 6 === e,
              h = 7 === e,
              m = 5 === e || c;
            return function (f, _, p, g) {
              for (
                var y,
                  v,
                  M = l(f),
                  b = r(M),
                  x = o(b),
                  L = i(_, p),
                  w = 0,
                  k = g || s,
                  Y = t ? k(f, x) : n || h ? k(f, 0) : void 0;
                x > w;
                w++
              )
                if ((m || w in b) && ((v = L((y = b[w]), w, M)), e))
                  if (t) Y[w] = v;
                  else if (v)
                    switch (e) {
                      case 3:
                        return !0;
                      case 5:
                        return y;
                      case 6:
                        return w;
                      case 2:
                        d(Y, y);
                    }
                  else
                    switch (e) {
                      case 4:
                        return !1;
                      case 7:
                        d(Y, y);
                    }
              return c ? -1 : a || u ? u : Y;
            };
          };
        e.exports = {
          forEach: u(0),
          map: u(1),
          filter: u(2),
          some: u(3),
          every: u(4),
          find: u(5),
          findIndex: u(6),
          filterReject: u(7),
        };
      },
      4950: function (e, t, n) {
        var i = n(5659),
          a = n(140),
          r = n(2935),
          l = a("species");
        e.exports = function (e) {
          return (
            r >= 51 ||
            !i(function () {
              var t = [];
              return (
                ((t.constructor = {})[l] = function () {
                  return { foo: 1 };
                }),
                1 !== t[e](Boolean).foo
              );
            })
          );
        };
      },
      2388: function (e, t, n) {
        var i = n(5659);
        e.exports = function (e, t) {
          var n = [][e];
          return (
            !!n &&
            i(function () {
              n.call(
                null,
                t ||
                  function () {
                    return 1;
                  },
                1
              );
            })
          );
        };
      },
      5930: function (e, t, n) {
        var i = n(5084),
          a = n(3517),
          r = n(9546),
          l = n(2402),
          o = TypeError,
          s = "Reduce of empty array with no initial value",
          d = function (e) {
            return function (t, n, d, u) {
              var c = a(t),
                h = r(c),
                m = l(c);
              if ((i(n), 0 === m && d < 2)) throw new o(s);
              var f = e ? m - 1 : 0,
                _ = e ? -1 : 1;
              if (d < 2)
                for (;;) {
                  if (f in h) {
                    (u = h[f]), (f += _);
                    break;
                  }
                  if (((f += _), e ? f < 0 : m <= f)) throw new o(s);
                }
              for (; e ? f >= 0 : m > f; f += _)
                f in h && (u = n(u, h[f], f, c));
              return u;
            };
          };
        e.exports = { left: d(!1), right: d(!0) };
      },
      9838: function (e, t, n) {
        var i = n(2786);
        e.exports = i([].slice);
      },
      2854: function (e, t, n) {
        var i = n(4015),
          a = n(9634),
          r = n(4728),
          l = n(140)("species"),
          o = Array;
        e.exports = function (e) {
          var t;
          return (
            i(e) &&
              ((t = e.constructor),
              ((a(t) && (t === o || i(t.prototype))) ||
                (r(t) && null === (t = t[l]))) &&
                (t = void 0)),
            void 0 === t ? o : t
          );
        };
      },
      2873: function (e, t, n) {
        var i = n(2854);
        e.exports = function (e, t) {
          return new (i(e))(0 === t ? 0 : t);
        };
      },
      6669: function (e, t, n) {
        var i = n(140)("iterator"),
          a = !1;
        try {
          var r = 0,
            l = {
              next: function () {
                return { done: !!r++ };
              },
              return: function () {
                a = !0;
              },
            };
          (l[i] = function () {
            return this;
          }),
            Array.from(l, function () {
              throw 2;
            });
        } catch (e) {}
        e.exports = function (e, t) {
          try {
            if (!t && !a) return !1;
          } catch (e) {
            return !1;
          }
          var n = !1;
          try {
            var r = {};
            (r[i] = function () {
              return {
                next: function () {
                  return { done: (n = !0) };
                },
              };
            }),
              e(r);
          } catch (e) {}
          return n;
        };
      },
      8486: function (e, t, n) {
        var i = n(2786),
          a = i({}.toString),
          r = i("".slice);
        e.exports = function (e) {
          return r(a(e), 8, -1);
        };
      },
      3298: function (e, t, n) {
        var i = n(9030),
          a = n(5709),
          r = n(8486),
          l = n(140)("toStringTag"),
          o = Object,
          s =
            "Arguments" ===
            r(
              (function () {
                return arguments;
              })()
            );
        e.exports = i
          ? r
          : function (e) {
              var t, n, i;
              return void 0 === e
                ? "Undefined"
                : null === e
                ? "Null"
                : "string" ==
                  typeof (n = (function (e, t) {
                    try {
                      return e[t];
                    } catch (e) {}
                  })((t = o(e)), l))
                ? n
                : s
                ? r(t)
                : "Object" === (i = r(t)) && a(t.callee)
                ? "Arguments"
                : i;
            };
      },
      717: function (e, t, n) {
        var i = n(2786),
          a = n(8367),
          r = n(9841).getWeakData,
          l = n(2267),
          o = n(421),
          s = n(5341),
          d = n(4728),
          u = n(1594),
          c = n(2246),
          h = n(2002),
          m = n(4626),
          f = m.set,
          _ = m.getterFor,
          p = c.find,
          g = c.findIndex,
          y = i([].splice),
          v = 0,
          M = function (e) {
            return e.frozen || (e.frozen = new b());
          },
          b = function () {
            this.entries = [];
          },
          x = function (e, t) {
            return p(e.entries, function (e) {
              return e[0] === t;
            });
          };
        (b.prototype = {
          get: function (e) {
            var t = x(this, e);
            if (t) return t[1];
          },
          has: function (e) {
            return !!x(this, e);
          },
          set: function (e, t) {
            var n = x(this, e);
            n ? (n[1] = t) : this.entries.push([e, t]);
          },
          delete: function (e) {
            var t = g(this.entries, function (t) {
              return t[0] === e;
            });
            return ~t && y(this.entries, t, 1), !!~t;
          },
        }),
          (e.exports = {
            getConstructor: function (e, t, n, i) {
              var c = e(function (e, a) {
                  l(e, m),
                    f(e, { type: t, id: v++, frozen: void 0 }),
                    s(a) || u(a, e[i], { that: e, AS_ENTRIES: n });
                }),
                m = c.prototype,
                p = _(t),
                g = function (e, t, n) {
                  var i = p(e),
                    a = r(o(t), !0);
                  return !0 === a ? M(i).set(t, n) : (a[i.id] = n), e;
                };
              return (
                a(m, {
                  delete: function (e) {
                    var t = p(this);
                    if (!d(e)) return !1;
                    var n = r(e);
                    return !0 === n
                      ? M(t).delete(e)
                      : n && h(n, t.id) && delete n[t.id];
                  },
                  has: function (e) {
                    var t = p(this);
                    if (!d(e)) return !1;
                    var n = r(e);
                    return !0 === n ? M(t).has(e) : n && h(n, t.id);
                  },
                }),
                a(
                  m,
                  n
                    ? {
                        get: function (e) {
                          var t = p(this);
                          if (d(e)) {
                            var n = r(e);
                            return !0 === n
                              ? M(t).get(e)
                              : n
                              ? n[t.id]
                              : void 0;
                          }
                        },
                        set: function (e, t) {
                          return g(this, e, t);
                        },
                      }
                    : {
                        add: function (e) {
                          return g(this, e, !0);
                        },
                      }
                ),
                c
              );
            },
          });
      },
      9123: function (e, t, n) {
        var i = n(2654),
          a = n(3507),
          r = n(2786),
          l = n(4975),
          o = n(2667),
          s = n(9841),
          d = n(1594),
          u = n(2267),
          c = n(5709),
          h = n(5341),
          m = n(4728),
          f = n(5659),
          _ = n(6669),
          p = n(5453),
          g = n(5893);
        e.exports = function (e, t, n) {
          var y = -1 !== e.indexOf("Map"),
            v = -1 !== e.indexOf("Weak"),
            M = y ? "set" : "add",
            b = a[e],
            x = b && b.prototype,
            L = b,
            w = {},
            k = function (e) {
              var t = r(x[e]);
              o(
                x,
                e,
                "add" === e
                  ? function (e) {
                      return t(this, 0 === e ? 0 : e), this;
                    }
                  : "delete" === e
                  ? function (e) {
                      return !(v && !m(e)) && t(this, 0 === e ? 0 : e);
                    }
                  : "get" === e
                  ? function (e) {
                      return v && !m(e) ? void 0 : t(this, 0 === e ? 0 : e);
                    }
                  : "has" === e
                  ? function (e) {
                      return !(v && !m(e)) && t(this, 0 === e ? 0 : e);
                    }
                  : function (e, n) {
                      return t(this, 0 === e ? 0 : e, n), this;
                    }
              );
            };
          if (
            l(
              e,
              !c(b) ||
                !(
                  v ||
                  (x.forEach &&
                    !f(function () {
                      new b().entries().next();
                    }))
                )
            )
          )
            (L = n.getConstructor(t, e, y, M)), s.enable();
          else if (l(e, !0)) {
            var Y = new L(),
              D = Y[M](v ? {} : -0, 1) !== Y,
              T = f(function () {
                Y.has(1);
              }),
              S = _(function (e) {
                new b(e);
              }),
              j =
                !v &&
                f(function () {
                  for (var e = new b(), t = 5; t--; ) e[M](t, t);
                  return !e.has(-0);
                });
            S ||
              (((L = t(function (e, t) {
                u(e, x);
                var n = g(new b(), e, L);
                return h(t) || d(t, n[M], { that: n, AS_ENTRIES: y }), n;
              })).prototype = x),
              (x.constructor = L)),
              (T || j) && (k("delete"), k("has"), y && k("get")),
              (j || D) && k(M),
              v && x.clear && delete x.clear;
          }
          return (
            (w[e] = L),
            i({ global: !0, constructor: !0, forced: L !== b }, w),
            p(L, e),
            v || n.setStrong(L, e, y),
            L
          );
        };
      },
      43: function (e, t, n) {
        var i = n(2002),
          a = n(6387),
          r = n(7507),
          l = n(5489);
        e.exports = function (e, t, n) {
          for (var o = a(t), s = l.f, d = r.f, u = 0; u < o.length; u++) {
            var c = o[u];
            i(e, c) || (n && i(n, c)) || s(e, c, d(t, c));
          }
        };
      },
      46: function (e, t, n) {
        var i = n(5659);
        e.exports = !i(function () {
          function e() {}
          return (
            (e.prototype.constructor = null),
            Object.getPrototypeOf(new e()) !== e.prototype
          );
        });
      },
      254: function (e) {
        e.exports = function (e, t) {
          return { value: e, done: t };
        };
      },
      2658: function (e, t, n) {
        var i = n(5459),
          a = n(5489),
          r = n(9954);
        e.exports = i
          ? function (e, t, n) {
              return a.f(e, t, r(1, n));
            }
          : function (e, t, n) {
              return (e[t] = n), e;
            };
      },
      9954: function (e) {
        e.exports = function (e, t) {
          return {
            enumerable: !(1 & e),
            configurable: !(2 & e),
            writable: !(4 & e),
            value: t,
          };
        };
      },
      6127: function (e, t, n) {
        var i = n(3645),
          a = n(5489);
        e.exports = function (e, t, n) {
          return (
            n.get && i(n.get, t, { getter: !0 }),
            n.set && i(n.set, t, { setter: !0 }),
            a.f(e, t, n)
          );
        };
      },
      2667: function (e, t, n) {
        var i = n(5709),
          a = n(5489),
          r = n(3645),
          l = n(6275);
        e.exports = function (e, t, n, o) {
          o || (o = {});
          var s = o.enumerable,
            d = void 0 !== o.name ? o.name : t;
          if ((i(n) && r(n, d, o), o.global)) s ? (e[t] = n) : l(t, n);
          else {
            try {
              o.unsafe ? e[t] && (s = !0) : delete e[t];
            } catch (e) {}
            s
              ? (e[t] = n)
              : a.f(e, t, {
                  value: n,
                  enumerable: !1,
                  configurable: !o.nonConfigurable,
                  writable: !o.nonWritable,
                });
          }
          return e;
        };
      },
      8367: function (e, t, n) {
        var i = n(2667);
        e.exports = function (e, t, n) {
          for (var a in t) i(e, a, t[a], n);
          return e;
        };
      },
      6275: function (e, t, n) {
        var i = n(3507),
          a = Object.defineProperty;
        e.exports = function (e, t) {
          try {
            a(i, e, { value: t, configurable: !0, writable: !0 });
          } catch (n) {
            i[e] = t;
          }
          return t;
        };
      },
      5459: function (e, t, n) {
        var i = n(5659);
        e.exports = !i(function () {
          return (
            7 !==
            Object.defineProperty({}, 1, {
              get: function () {
                return 7;
              },
            })[1]
          );
        });
      },
      8069: function (e, t, n) {
        var i = n(3507),
          a = n(4728),
          r = i.document,
          l = a(r) && a(r.createElement);
        e.exports = function (e) {
          return l ? r.createElement(e) : {};
        };
      },
      8373: function (e) {
        e.exports = {
          CSSRuleList: 0,
          CSSStyleDeclaration: 0,
          CSSValueList: 0,
          ClientRectList: 0,
          DOMRectList: 0,
          DOMStringList: 0,
          DOMTokenList: 1,
          DataTransferItemList: 0,
          FileList: 0,
          HTMLAllCollection: 0,
          HTMLCollection: 0,
          HTMLFormElement: 0,
          HTMLSelectElement: 0,
          MediaList: 0,
          MimeTypeArray: 0,
          NamedNodeMap: 0,
          NodeList: 1,
          PaintRequestList: 0,
          Plugin: 0,
          PluginArray: 0,
          SVGLengthList: 0,
          SVGNumberList: 0,
          SVGPathSegList: 0,
          SVGPointList: 0,
          SVGStringList: 0,
          SVGTransformList: 0,
          SourceBufferList: 0,
          StyleSheetList: 0,
          TextTrackCueList: 0,
          TextTrackList: 0,
          TouchList: 0,
        };
      },
      3486: function (e, t, n) {
        var i = n(8069)("span").classList,
          a = i && i.constructor && i.constructor.prototype;
        e.exports = a === Object.prototype ? void 0 : a;
      },
      9905: function (e, t, n) {
        var i = n(3507),
          a = n(8486);
        e.exports = "process" === a(i.process);
      },
      7760: function (e) {
        e.exports =
          ("undefined" != typeof navigator && String(navigator.userAgent)) ||
          "";
      },
      2935: function (e, t, n) {
        var i,
          a,
          r = n(3507),
          l = n(7760),
          o = r.process,
          s = r.Deno,
          d = (o && o.versions) || (s && s.version),
          u = d && d.v8;
        u && (a = (i = u.split("."))[0] > 0 && i[0] < 4 ? 1 : +(i[0] + i[1])),
          !a &&
            l &&
            (!(i = l.match(/Edge\/(\d+)/)) || i[1] >= 74) &&
            (i = l.match(/Chrome\/(\d+)/)) &&
            (a = +i[1]),
          (e.exports = a);
      },
      8308: function (e) {
        e.exports = [
          "constructor",
          "hasOwnProperty",
          "isPrototypeOf",
          "propertyIsEnumerable",
          "toLocaleString",
          "toString",
          "valueOf",
        ];
      },
      2654: function (e, t, n) {
        var i = n(3507),
          a = n(7507).f,
          r = n(2658),
          l = n(2667),
          o = n(6275),
          s = n(43),
          d = n(4975);
        e.exports = function (e, t) {
          var n,
            u,
            c,
            h,
            m,
            f = e.target,
            _ = e.global,
            p = e.stat;
          if ((n = _ ? i : p ? i[f] || o(f, {}) : i[f] && i[f].prototype))
            for (u in t) {
              if (
                ((h = t[u]),
                (c = e.dontCallGetSet ? (m = a(n, u)) && m.value : n[u]),
                !d(_ ? u : f + (p ? "." : "#") + u, e.forced) && void 0 !== c)
              ) {
                if (typeof h == typeof c) continue;
                s(h, c);
              }
              (e.sham || (c && c.sham)) && r(h, "sham", !0), l(n, u, h, e);
            }
        };
      },
      5659: function (e) {
        e.exports = function (e) {
          try {
            return !!e();
          } catch (e) {
            return !0;
          }
        };
      },
      7988: function (e, t, n) {
        n(8044);
        var i = n(5750),
          a = n(2667),
          r = n(7191),
          l = n(5659),
          o = n(140),
          s = n(2658),
          d = o("species"),
          u = RegExp.prototype;
        e.exports = function (e, t, n, c) {
          var h = o(e),
            m = !l(function () {
              var t = {};
              return (
                (t[h] = function () {
                  return 7;
                }),
                7 !== ""[e](t)
              );
            }),
            f =
              m &&
              !l(function () {
                var t = !1,
                  n = /a/;
                return (
                  "split" === e &&
                    (((n = {}).constructor = {}),
                    (n.constructor[d] = function () {
                      return n;
                    }),
                    (n.flags = ""),
                    (n[h] = /./[h])),
                  (n.exec = function () {
                    return (t = !0), null;
                  }),
                  n[h](""),
                  !t
                );
              });
          if (!m || !f || n) {
            var _ = /./[h],
              p = t(h, ""[e], function (e, t, n, a, l) {
                var o = t.exec;
                return o === r || o === u.exec
                  ? m && !l
                    ? { done: !0, value: i(_, t, n, a) }
                    : { done: !0, value: i(e, n, t, a) }
                  : { done: !1 };
              });
            a(String.prototype, e, p[0]), a(u, h, p[1]);
          }
          c && s(u[h], "sham", !0);
        };
      },
      3681: function (e, t, n) {
        var i = n(5659);
        e.exports = !i(function () {
          return Object.isExtensible(Object.preventExtensions({}));
        });
      },
      368: function (e, t, n) {
        var i = n(2286),
          a = Function.prototype,
          r = a.apply,
          l = a.call;
        e.exports =
          ("object" == typeof Reflect && Reflect.apply) ||
          (i
            ? l.bind(r)
            : function () {
                return l.apply(r, arguments);
              });
      },
      9970: function (e, t, n) {
        var i = n(2501),
          a = n(5084),
          r = n(2286),
          l = i(i.bind);
        e.exports = function (e, t) {
          return (
            a(e),
            void 0 === t
              ? e
              : r
              ? l(e, t)
              : function () {
                  return e.apply(t, arguments);
                }
          );
        };
      },
      2286: function (e, t, n) {
        var i = n(5659);
        e.exports = !i(function () {
          var e = function () {}.bind();
          return "function" != typeof e || e.hasOwnProperty("prototype");
        });
      },
      5750: function (e, t, n) {
        var i = n(2286),
          a = Function.prototype.call;
        e.exports = i
          ? a.bind(a)
          : function () {
              return a.apply(a, arguments);
            };
      },
      1082: function (e, t, n) {
        var i = n(5459),
          a = n(2002),
          r = Function.prototype,
          l = i && Object.getOwnPropertyDescriptor,
          o = a(r, "name"),
          s = o && "something" === function () {}.name,
          d = o && (!i || (i && l(r, "name").configurable));
        e.exports = { EXISTS: o, PROPER: s, CONFIGURABLE: d };
      },
      8663: function (e, t, n) {
        var i = n(2786),
          a = n(5084);
        e.exports = function (e, t, n) {
          try {
            return i(a(Object.getOwnPropertyDescriptor(e, t)[n]));
          } catch (e) {}
        };
      },
      2501: function (e, t, n) {
        var i = n(8486),
          a = n(2786);
        e.exports = function (e) {
          if ("Function" === i(e)) return a(e);
        };
      },
      2786: function (e, t, n) {
        var i = n(2286),
          a = Function.prototype,
          r = a.call,
          l = i && a.bind.bind(r, r);
        e.exports = i
          ? l
          : function (e) {
              return function () {
                return r.apply(e, arguments);
              };
            };
      },
      955: function (e, t, n) {
        var i = n(3507),
          a = n(5709);
        e.exports = function (e, t) {
          return arguments.length < 2
            ? ((n = i[e]), a(n) ? n : void 0)
            : i[e] && i[e][t];
          var n;
        };
      },
      2321: function (e, t, n) {
        var i = n(3298),
          a = n(9290),
          r = n(5341),
          l = n(2528),
          o = n(140)("iterator");
        e.exports = function (e) {
          if (!r(e)) return a(e, o) || a(e, "@@iterator") || l[i(e)];
        };
      },
      9652: function (e, t, n) {
        var i = n(5750),
          a = n(5084),
          r = n(421),
          l = n(1812),
          o = n(2321),
          s = TypeError;
        e.exports = function (e, t) {
          var n = arguments.length < 2 ? o(e) : t;
          if (a(n)) return r(i(n, e));
          throw new s(l(e) + " is not iterable");
        };
      },
      9290: function (e, t, n) {
        var i = n(5084),
          a = n(5341);
        e.exports = function (e, t) {
          var n = e[t];
          return a(n) ? void 0 : i(n);
        };
      },
      4217: function (e, t, n) {
        var i = n(2786),
          a = n(3517),
          r = Math.floor,
          l = i("".charAt),
          o = i("".replace),
          s = i("".slice),
          d = /\$([$&'`]|\d{1,2}|<[^>]*>)/g,
          u = /\$([$&'`]|\d{1,2})/g;
        e.exports = function (e, t, n, i, c, h) {
          var m = n + e.length,
            f = i.length,
            _ = u;
          return (
            void 0 !== c && ((c = a(c)), (_ = d)),
            o(h, _, function (a, o) {
              var d;
              switch (l(o, 0)) {
                case "$":
                  return "$";
                case "&":
                  return e;
                case "`":
                  return s(t, 0, n);
                case "'":
                  return s(t, m);
                case "<":
                  d = c[s(o, 1, -1)];
                  break;
                default:
                  var u = +o;
                  if (0 === u) return a;
                  if (u > f) {
                    var h = r(u / 10);
                    return 0 === h
                      ? a
                      : h <= f
                      ? void 0 === i[h - 1]
                        ? l(o, 1)
                        : i[h - 1] + l(o, 1)
                      : a;
                  }
                  d = i[u - 1];
              }
              return void 0 === d ? "" : d;
            })
          );
        };
      },
      3507: function (e, t, n) {
        var i = function (e) {
          return e && e.Math === Math && e;
        };
        e.exports =
          i("object" == typeof globalThis && globalThis) ||
          i("object" == typeof window && window) ||
          i("object" == typeof self && self) ||
          i("object" == typeof n.g && n.g) ||
          i("object" == typeof this && this) ||
          (function () {
            return this;
          })() ||
          Function("return this")();
      },
      2002: function (e, t, n) {
        var i = n(2786),
          a = n(3517),
          r = i({}.hasOwnProperty);
        e.exports =
          Object.hasOwn ||
          function (e, t) {
            return r(a(e), t);
          };
      },
      3911: function (e) {
        e.exports = {};
      },
      278: function (e, t, n) {
        var i = n(955);
        e.exports = i("document", "documentElement");
      },
      6364: function (e, t, n) {
        var i = n(5459),
          a = n(5659),
          r = n(8069);
        e.exports =
          !i &&
          !a(function () {
            return (
              7 !==
              Object.defineProperty(r("div"), "a", {
                get: function () {
                  return 7;
                },
              }).a
            );
          });
      },
      9546: function (e, t, n) {
        var i = n(2786),
          a = n(5659),
          r = n(8486),
          l = Object,
          o = i("".split);
        e.exports = a(function () {
          return !l("z").propertyIsEnumerable(0);
        })
          ? function (e) {
              return "String" === r(e) ? o(e, "") : l(e);
            }
          : l;
      },
      5893: function (e, t, n) {
        var i = n(5709),
          a = n(4728),
          r = n(8900);
        e.exports = function (e, t, n) {
          var l, o;
          return (
            r &&
              i((l = t.constructor)) &&
              l !== n &&
              a((o = l.prototype)) &&
              o !== n.prototype &&
              r(e, o),
            e
          );
        };
      },
      8079: function (e, t, n) {
        var i = n(2786),
          a = n(5709),
          r = n(6035),
          l = i(Function.toString);
        a(r.inspectSource) ||
          (r.inspectSource = function (e) {
            return l(e);
          }),
          (e.exports = r.inspectSource);
      },
      9841: function (e, t, n) {
        var i = n(2654),
          a = n(2786),
          r = n(3911),
          l = n(4728),
          o = n(2002),
          s = n(5489).f,
          d = n(9769),
          u = n(851),
          c = n(5339),
          h = n(4903),
          m = n(3681),
          f = !1,
          _ = h("meta"),
          p = 0,
          g = function (e) {
            s(e, _, { value: { objectID: "O" + p++, weakData: {} } });
          },
          y = (e.exports = {
            enable: function () {
              (y.enable = function () {}), (f = !0);
              var e = d.f,
                t = a([].splice),
                n = {};
              (n[_] = 1),
                e(n).length &&
                  ((d.f = function (n) {
                    for (var i = e(n), a = 0, r = i.length; a < r; a++)
                      if (i[a] === _) {
                        t(i, a, 1);
                        break;
                      }
                    return i;
                  }),
                  i(
                    { target: "Object", stat: !0, forced: !0 },
                    { getOwnPropertyNames: u.f }
                  ));
            },
            fastKey: function (e, t) {
              if (!l(e))
                return "symbol" == typeof e
                  ? e
                  : ("string" == typeof e ? "S" : "P") + e;
              if (!o(e, _)) {
                if (!c(e)) return "F";
                if (!t) return "E";
                g(e);
              }
              return e[_].objectID;
            },
            getWeakData: function (e, t) {
              if (!o(e, _)) {
                if (!c(e)) return !0;
                if (!t) return !1;
                g(e);
              }
              return e[_].weakData;
            },
            onFreeze: function (e) {
              return m && f && c(e) && !o(e, _) && g(e), e;
            },
          });
        r[_] = !0;
      },
      4626: function (e, t, n) {
        var i,
          a,
          r,
          l = n(4806),
          o = n(3507),
          s = n(4728),
          d = n(2658),
          u = n(2002),
          c = n(6035),
          h = n(8355),
          m = n(3911),
          f = "Object already initialized",
          _ = o.TypeError,
          p = o.WeakMap;
        if (l || c.state) {
          var g = c.state || (c.state = new p());
          (g.get = g.get),
            (g.has = g.has),
            (g.set = g.set),
            (i = function (e, t) {
              if (g.has(e)) throw new _(f);
              return (t.facade = e), g.set(e, t), t;
            }),
            (a = function (e) {
              return g.get(e) || {};
            }),
            (r = function (e) {
              return g.has(e);
            });
        } else {
          var y = h("state");
          (m[y] = !0),
            (i = function (e, t) {
              if (u(e, y)) throw new _(f);
              return (t.facade = e), d(e, y, t), t;
            }),
            (a = function (e) {
              return u(e, y) ? e[y] : {};
            }),
            (r = function (e) {
              return u(e, y);
            });
        }
        e.exports = {
          set: i,
          get: a,
          has: r,
          enforce: function (e) {
            return r(e) ? a(e) : i(e, {});
          },
          getterFor: function (e) {
            return function (t) {
              var n;
              if (!s(t) || (n = a(t)).type !== e)
                throw new _("Incompatible receiver, " + e + " required");
              return n;
            };
          },
        };
      },
      8073: function (e, t, n) {
        var i = n(140),
          a = n(2528),
          r = i("iterator"),
          l = Array.prototype;
        e.exports = function (e) {
          return void 0 !== e && (a.Array === e || l[r] === e);
        };
      },
      4015: function (e, t, n) {
        var i = n(8486);
        e.exports =
          Array.isArray ||
          function (e) {
            return "Array" === i(e);
          };
      },
      5709: function (e) {
        var t = "object" == typeof document && document.all;
        e.exports =
          void 0 === t && void 0 !== t
            ? function (e) {
                return "function" == typeof e || e === t;
              }
            : function (e) {
                return "function" == typeof e;
              };
      },
      9634: function (e, t, n) {
        var i = n(2786),
          a = n(5659),
          r = n(5709),
          l = n(3298),
          o = n(955),
          s = n(8079),
          d = function () {},
          u = o("Reflect", "construct"),
          c = /^\s*(?:class|function)\b/,
          h = i(c.exec),
          m = !c.test(d),
          f = function (e) {
            if (!r(e)) return !1;
            try {
              return u(d, [], e), !0;
            } catch (e) {
              return !1;
            }
          },
          _ = function (e) {
            if (!r(e)) return !1;
            switch (l(e)) {
              case "AsyncFunction":
              case "GeneratorFunction":
              case "AsyncGeneratorFunction":
                return !1;
            }
            try {
              return m || !!h(c, s(e));
            } catch (e) {
              return !0;
            }
          };
        (_.sham = !0),
          (e.exports =
            !u ||
            a(function () {
              var e;
              return (
                f(f.call) ||
                !f(Object) ||
                !f(function () {
                  e = !0;
                }) ||
                e
              );
            })
              ? _
              : f);
      },
      4975: function (e, t, n) {
        var i = n(5659),
          a = n(5709),
          r = /#|\.prototype\./,
          l = function (e, t) {
            var n = s[o(e)];
            return n === u || (n !== d && (a(t) ? i(t) : !!t));
          },
          o = (l.normalize = function (e) {
            return String(e).replace(r, ".").toLowerCase();
          }),
          s = (l.data = {}),
          d = (l.NATIVE = "N"),
          u = (l.POLYFILL = "P");
        e.exports = l;
      },
      5341: function (e) {
        e.exports = function (e) {
          return null == e;
        };
      },
      4728: function (e, t, n) {
        var i = n(5709);
        e.exports = function (e) {
          return "object" == typeof e ? null !== e : i(e);
        };
      },
      990: function (e, t, n) {
        var i = n(4728);
        e.exports = function (e) {
          return i(e) || null === e;
        };
      },
      6940: function (e) {
        e.exports = !1;
      },
      7788: function (e, t, n) {
        var i = n(955),
          a = n(5709),
          r = n(9554),
          l = n(7692),
          o = Object;
        e.exports = l
          ? function (e) {
              return "symbol" == typeof e;
            }
          : function (e) {
              var t = i("Symbol");
              return a(t) && r(t.prototype, o(e));
            };
      },
      1594: function (e, t, n) {
        var i = n(9970),
          a = n(5750),
          r = n(421),
          l = n(1812),
          o = n(8073),
          s = n(2402),
          d = n(9554),
          u = n(9652),
          c = n(2321),
          h = n(8514),
          m = TypeError,
          f = function (e, t) {
            (this.stopped = e), (this.result = t);
          },
          _ = f.prototype;
        e.exports = function (e, t, n) {
          var p,
            g,
            y,
            v,
            M,
            b,
            x,
            L = n && n.that,
            w = !(!n || !n.AS_ENTRIES),
            k = !(!n || !n.IS_RECORD),
            Y = !(!n || !n.IS_ITERATOR),
            D = !(!n || !n.INTERRUPTED),
            T = i(t, L),
            S = function (e) {
              return p && h(p, "normal", e), new f(!0, e);
            },
            j = function (e) {
              return w
                ? (r(e), D ? T(e[0], e[1], S) : T(e[0], e[1]))
                : D
                ? T(e, S)
                : T(e);
            };
          if (k) p = e.iterator;
          else if (Y) p = e;
          else {
            if (!(g = c(e))) throw new m(l(e) + " is not iterable");
            if (o(g)) {
              for (y = 0, v = s(e); v > y; y++)
                if ((M = j(e[y])) && d(_, M)) return M;
              return new f(!1);
            }
            p = u(e, g);
          }
          for (b = k ? e.next : p.next; !(x = a(b, p)).done; ) {
            try {
              M = j(x.value);
            } catch (e) {
              h(p, "throw", e);
            }
            if ("object" == typeof M && M && d(_, M)) return M;
          }
          return new f(!1);
        };
      },
      8514: function (e, t, n) {
        var i = n(5750),
          a = n(421),
          r = n(9290);
        e.exports = function (e, t, n) {
          var l, o;
          a(e);
          try {
            if (!(l = r(e, "return"))) {
              if ("throw" === t) throw n;
              return n;
            }
            l = i(l, e);
          } catch (e) {
            (o = !0), (l = e);
          }
          if ("throw" === t) throw n;
          if (o) throw l;
          return a(l), n;
        };
      },
      4351: function (e, t, n) {
        var i = n(4530).IteratorPrototype,
          a = n(6716),
          r = n(9954),
          l = n(5453),
          o = n(2528),
          s = function () {
            return this;
          };
        e.exports = function (e, t, n, d) {
          var u = t + " Iterator";
          return (
            (e.prototype = a(i, { next: r(+!d, n) })),
            l(e, u, !1, !0),
            (o[u] = s),
            e
          );
        };
      },
      7094: function (e, t, n) {
        var i = n(2654),
          a = n(5750),
          r = n(6940),
          l = n(1082),
          o = n(5709),
          s = n(4351),
          d = n(6426),
          u = n(8900),
          c = n(5453),
          h = n(2658),
          m = n(2667),
          f = n(140),
          _ = n(2528),
          p = n(4530),
          g = l.PROPER,
          y = l.CONFIGURABLE,
          v = p.IteratorPrototype,
          M = p.BUGGY_SAFARI_ITERATORS,
          b = f("iterator"),
          x = "keys",
          L = "values",
          w = "entries",
          k = function () {
            return this;
          };
        e.exports = function (e, t, n, l, f, p, Y) {
          s(n, t, l);
          var D,
            T,
            S,
            j = function (e) {
              if (e === f && C) return C;
              if (!M && e && e in H) return H[e];
              switch (e) {
                case x:
                case L:
                case w:
                  return function () {
                    return new n(this, e);
                  };
              }
              return function () {
                return new n(this);
              };
            },
            O = t + " Iterator",
            A = !1,
            H = e.prototype,
            E = H[b] || H["@@iterator"] || (f && H[f]),
            C = (!M && E) || j(f),
            P = ("Array" === t && H.entries) || E;
          if (
            (P &&
              (D = d(P.call(new e()))) !== Object.prototype &&
              D.next &&
              (r || d(D) === v || (u ? u(D, v) : o(D[b]) || m(D, b, k)),
              c(D, O, !0, !0),
              r && (_[O] = k)),
            g &&
              f === L &&
              E &&
              E.name !== L &&
              (!r && y
                ? h(H, "name", L)
                : ((A = !0),
                  (C = function () {
                    return a(E, this);
                  }))),
            f)
          )
            if (((T = { values: j(L), keys: p ? C : j(x), entries: j(w) }), Y))
              for (S in T) (M || A || !(S in H)) && m(H, S, T[S]);
            else i({ target: t, proto: !0, forced: M || A }, T);
          return (
            (r && !Y) || H[b] === C || m(H, b, C, { name: f }), (_[t] = C), T
          );
        };
      },
      4530: function (e, t, n) {
        var i,
          a,
          r,
          l = n(5659),
          o = n(5709),
          s = n(4728),
          d = n(6716),
          u = n(6426),
          c = n(2667),
          h = n(140),
          m = n(6940),
          f = h("iterator"),
          _ = !1;
        [].keys &&
          ("next" in (r = [].keys())
            ? (a = u(u(r))) !== Object.prototype && (i = a)
            : (_ = !0)),
          !s(i) ||
          l(function () {
            var e = {};
            return i[f].call(e) !== e;
          })
            ? (i = {})
            : m && (i = d(i)),
          o(i[f]) ||
            c(i, f, function () {
              return this;
            }),
          (e.exports = { IteratorPrototype: i, BUGGY_SAFARI_ITERATORS: _ });
      },
      2528: function (e) {
        e.exports = {};
      },
      2402: function (e, t, n) {
        var i = n(682);
        e.exports = function (e) {
          return i(e.length);
        };
      },
      3645: function (e, t, n) {
        var i = n(2786),
          a = n(5659),
          r = n(5709),
          l = n(2002),
          o = n(5459),
          s = n(1082).CONFIGURABLE,
          d = n(8079),
          u = n(4626),
          c = u.enforce,
          h = u.get,
          m = String,
          f = Object.defineProperty,
          _ = i("".slice),
          p = i("".replace),
          g = i([].join),
          y =
            o &&
            !a(function () {
              return 8 !== f(function () {}, "length", { value: 8 }).length;
            }),
          v = String(String).split("String"),
          M = (e.exports = function (e, t, n) {
            "Symbol(" === _(m(t), 0, 7) &&
              (t = "[" + p(m(t), /^Symbol\(([^)]*)\).*$/, "$1") + "]"),
              n && n.getter && (t = "get " + t),
              n && n.setter && (t = "set " + t),
              (!l(e, "name") || (s && e.name !== t)) &&
                (o
                  ? f(e, "name", { value: t, configurable: !0 })
                  : (e.name = t)),
              y &&
                n &&
                l(n, "arity") &&
                e.length !== n.arity &&
                f(e, "length", { value: n.arity });
            try {
              n && l(n, "constructor") && n.constructor
                ? o && f(e, "prototype", { writable: !1 })
                : e.prototype && (e.prototype = void 0);
            } catch (e) {}
            var i = c(e);
            return (
              l(i, "source") ||
                (i.source = g(v, "string" == typeof t ? t : "")),
              e
            );
          });
        Function.prototype.toString = M(function () {
          return (r(this) && h(this).source) || d(this);
        }, "toString");
      },
      3639: function (e) {
        var t = Math.ceil,
          n = Math.floor;
        e.exports =
          Math.trunc ||
          function (e) {
            var i = +e;
            return (i > 0 ? n : t)(i);
          };
      },
      5811: function (e, t, n) {
        var i = n(3507),
          a = n(5659),
          r = n(2786),
          l = n(3634),
          o = n(645).trim,
          s = n(2032),
          d = i.parseInt,
          u = i.Symbol,
          c = u && u.iterator,
          h = /^[+-]?0x/i,
          m = r(h.exec),
          f =
            8 !== d(s + "08") ||
            22 !== d(s + "0x16") ||
            (c &&
              !a(function () {
                d(Object(c));
              }));
        e.exports = f
          ? function (e, t) {
              var n = o(l(e));
              return d(n, t >>> 0 || (m(h, n) ? 16 : 10));
            }
          : d;
      },
      5355: function (e, t, n) {
        var i = n(5459),
          a = n(2786),
          r = n(5750),
          l = n(5659),
          o = n(4332),
          s = n(725),
          d = n(1505),
          u = n(3517),
          c = n(9546),
          h = Object.assign,
          m = Object.defineProperty,
          f = a([].concat);
        e.exports =
          !h ||
          l(function () {
            if (
              i &&
              1 !==
                h(
                  { b: 1 },
                  h(
                    m({}, "a", {
                      enumerable: !0,
                      get: function () {
                        m(this, "b", { value: 3, enumerable: !1 });
                      },
                    }),
                    { b: 2 }
                  )
                ).b
            )
              return !0;
            var e = {},
              t = {},
              n = Symbol("assign detection"),
              a = "abcdefghijklmnopqrst";
            return (
              (e[n] = 7),
              a.split("").forEach(function (e) {
                t[e] = e;
              }),
              7 !== h({}, e)[n] || o(h({}, t)).join("") !== a
            );
          })
            ? function (e, t) {
                for (
                  var n = u(e), a = arguments.length, l = 1, h = s.f, m = d.f;
                  a > l;

                )
                  for (
                    var _,
                      p = c(arguments[l++]),
                      g = h ? f(o(p), h(p)) : o(p),
                      y = g.length,
                      v = 0;
                    y > v;

                  )
                    (_ = g[v++]), (i && !r(m, p, _)) || (n[_] = p[_]);
                return n;
              }
            : h;
      },
      6716: function (e, t, n) {
        var i,
          a = n(421),
          r = n(9221),
          l = n(8308),
          o = n(3911),
          s = n(278),
          d = n(8069),
          u = n(8355),
          c = "prototype",
          h = "script",
          m = u("IE_PROTO"),
          f = function () {},
          _ = function (e) {
            return "<" + h + ">" + e + "</" + h + ">";
          },
          p = function (e) {
            e.write(_("")), e.close();
            var t = e.parentWindow.Object;
            return (e = null), t;
          },
          g = function () {
            try {
              i = new ActiveXObject("htmlfile");
            } catch (e) {}
            var e, t, n;
            g =
              "undefined" != typeof document
                ? document.domain && i
                  ? p(i)
                  : ((t = d("iframe")),
                    (n = "java" + h + ":"),
                    (t.style.display = "none"),
                    s.appendChild(t),
                    (t.src = String(n)),
                    (e = t.contentWindow.document).open(),
                    e.write(_("document.F=Object")),
                    e.close(),
                    e.F)
                : p(i);
            for (var a = l.length; a--; ) delete g[c][l[a]];
            return g();
          };
        (o[m] = !0),
          (e.exports =
            Object.create ||
            function (e, t) {
              var n;
              return (
                null !== e
                  ? ((f[c] = a(e)), (n = new f()), (f[c] = null), (n[m] = e))
                  : (n = g()),
                void 0 === t ? n : r.f(n, t)
              );
            });
      },
      9221: function (e, t, n) {
        var i = n(5459),
          a = n(3169),
          r = n(5489),
          l = n(421),
          o = n(93),
          s = n(4332);
        t.f =
          i && !a
            ? Object.defineProperties
            : function (e, t) {
                l(e);
                for (var n, i = o(t), a = s(t), d = a.length, u = 0; d > u; )
                  r.f(e, (n = a[u++]), i[n]);
                return e;
              };
      },
      5489: function (e, t, n) {
        var i = n(5459),
          a = n(6364),
          r = n(3169),
          l = n(421),
          o = n(9457),
          s = TypeError,
          d = Object.defineProperty,
          u = Object.getOwnPropertyDescriptor,
          c = "enumerable",
          h = "configurable",
          m = "writable";
        t.f = i
          ? r
            ? function (e, t, n) {
                if (
                  (l(e),
                  (t = o(t)),
                  l(n),
                  "function" == typeof e &&
                    "prototype" === t &&
                    "value" in n &&
                    m in n &&
                    !n[m])
                ) {
                  var i = u(e, t);
                  i &&
                    i[m] &&
                    ((e[t] = n.value),
                    (n = {
                      configurable: h in n ? n[h] : i[h],
                      enumerable: c in n ? n[c] : i[c],
                      writable: !1,
                    }));
                }
                return d(e, t, n);
              }
            : d
          : function (e, t, n) {
              if ((l(e), (t = o(t)), l(n), a))
                try {
                  return d(e, t, n);
                } catch (e) {}
              if ("get" in n || "set" in n)
                throw new s("Accessors not supported");
              return "value" in n && (e[t] = n.value), e;
            };
      },
      7507: function (e, t, n) {
        var i = n(5459),
          a = n(5750),
          r = n(1505),
          l = n(9954),
          o = n(93),
          s = n(9457),
          d = n(2002),
          u = n(6364),
          c = Object.getOwnPropertyDescriptor;
        t.f = i
          ? c
          : function (e, t) {
              if (((e = o(e)), (t = s(t)), u))
                try {
                  return c(e, t);
                } catch (e) {}
              if (d(e, t)) return l(!a(r.f, e, t), e[t]);
            };
      },
      851: function (e, t, n) {
        var i = n(8486),
          a = n(93),
          r = n(9769).f,
          l = n(9838),
          o =
            "object" == typeof window && window && Object.getOwnPropertyNames
              ? Object.getOwnPropertyNames(window)
              : [];
        e.exports.f = function (e) {
          return o && "Window" === i(e)
            ? (function (e) {
                try {
                  return r(e);
                } catch (e) {
                  return l(o);
                }
              })(e)
            : r(a(e));
        };
      },
      9769: function (e, t, n) {
        var i = n(8946),
          a = n(8308).concat("length", "prototype");
        t.f =
          Object.getOwnPropertyNames ||
          function (e) {
            return i(e, a);
          };
      },
      725: function (e, t) {
        t.f = Object.getOwnPropertySymbols;
      },
      6426: function (e, t, n) {
        var i = n(2002),
          a = n(5709),
          r = n(3517),
          l = n(8355),
          o = n(46),
          s = l("IE_PROTO"),
          d = Object,
          u = d.prototype;
        e.exports = o
          ? d.getPrototypeOf
          : function (e) {
              var t = r(e);
              if (i(t, s)) return t[s];
              var n = t.constructor;
              return a(n) && t instanceof n
                ? n.prototype
                : t instanceof d
                ? u
                : null;
            };
      },
      5339: function (e, t, n) {
        var i = n(5659),
          a = n(4728),
          r = n(8486),
          l = n(2591),
          o = Object.isExtensible,
          s = i(function () {
            o(1);
          });
        e.exports =
          s || l
            ? function (e) {
                return !!a(e) && (!l || "ArrayBuffer" !== r(e)) && (!o || o(e));
              }
            : o;
      },
      9554: function (e, t, n) {
        var i = n(2786);
        e.exports = i({}.isPrototypeOf);
      },
      8946: function (e, t, n) {
        var i = n(2786),
          a = n(2002),
          r = n(93),
          l = n(6464).indexOf,
          o = n(3911),
          s = i([].push);
        e.exports = function (e, t) {
          var n,
            i = r(e),
            d = 0,
            u = [];
          for (n in i) !a(o, n) && a(i, n) && s(u, n);
          for (; t.length > d; ) a(i, (n = t[d++])) && (~l(u, n) || s(u, n));
          return u;
        };
      },
      4332: function (e, t, n) {
        var i = n(8946),
          a = n(8308);
        e.exports =
          Object.keys ||
          function (e) {
            return i(e, a);
          };
      },
      1505: function (e, t) {
        var n = {}.propertyIsEnumerable,
          i = Object.getOwnPropertyDescriptor,
          a = i && !n.call({ 1: 2 }, 1);
        t.f = a
          ? function (e) {
              var t = i(this, e);
              return !!t && t.enumerable;
            }
          : n;
      },
      8900: function (e, t, n) {
        var i = n(8663),
          a = n(4728),
          r = n(8349),
          l = n(7230);
        e.exports =
          Object.setPrototypeOf ||
          ("__proto__" in {}
            ? (function () {
                var e,
                  t = !1,
                  n = {};
                try {
                  (e = i(Object.prototype, "__proto__", "set"))(n, []),
                    (t = n instanceof Array);
                } catch (e) {}
                return function (n, i) {
                  return (
                    r(n), l(i), a(n) ? (t ? e(n, i) : (n.__proto__ = i), n) : n
                  );
                };
              })()
            : void 0);
      },
      2844: function (e, t, n) {
        var i = n(9030),
          a = n(3298);
        e.exports = i
          ? {}.toString
          : function () {
              return "[object " + a(this) + "]";
            };
      },
      9212: function (e, t, n) {
        var i = n(5750),
          a = n(5709),
          r = n(4728),
          l = TypeError;
        e.exports = function (e, t) {
          var n, o;
          if ("string" === t && a((n = e.toString)) && !r((o = i(n, e))))
            return o;
          if (a((n = e.valueOf)) && !r((o = i(n, e)))) return o;
          if ("string" !== t && a((n = e.toString)) && !r((o = i(n, e))))
            return o;
          throw new l("Can't convert object to primitive value");
        };
      },
      6387: function (e, t, n) {
        var i = n(955),
          a = n(2786),
          r = n(9769),
          l = n(725),
          o = n(421),
          s = a([].concat);
        e.exports =
          i("Reflect", "ownKeys") ||
          function (e) {
            var t = r.f(o(e)),
              n = l.f;
            return n ? s(t, n(e)) : t;
          };
      },
      3910: function (e, t, n) {
        var i = n(5750),
          a = n(421),
          r = n(5709),
          l = n(8486),
          o = n(7191),
          s = TypeError;
        e.exports = function (e, t) {
          var n = e.exec;
          if (r(n)) {
            var d = i(n, e, t);
            return null !== d && a(d), d;
          }
          if ("RegExp" === l(e)) return i(o, e, t);
          throw new s("RegExp#exec called on incompatible receiver");
        };
      },
      7191: function (e, t, n) {
        var i,
          a,
          r = n(5750),
          l = n(2786),
          o = n(3634),
          s = n(3164),
          d = n(3857),
          u = n(3),
          c = n(6716),
          h = n(4626).get,
          m = n(8322),
          f = n(6620),
          _ = u("native-string-replace", String.prototype.replace),
          p = RegExp.prototype.exec,
          g = p,
          y = l("".charAt),
          v = l("".indexOf),
          M = l("".replace),
          b = l("".slice),
          x =
            ((a = /b*/g),
            r(p, (i = /a/), "a"),
            r(p, a, "a"),
            0 !== i.lastIndex || 0 !== a.lastIndex),
          L = d.BROKEN_CARET,
          w = void 0 !== /()??/.exec("")[1];
        (x || w || L || m || f) &&
          (g = function (e) {
            var t,
              n,
              i,
              a,
              l,
              d,
              u,
              m = this,
              f = h(m),
              k = o(e),
              Y = f.raw;
            if (Y)
              return (
                (Y.lastIndex = m.lastIndex),
                (t = r(g, Y, k)),
                (m.lastIndex = Y.lastIndex),
                t
              );
            var D = f.groups,
              T = L && m.sticky,
              S = r(s, m),
              j = m.source,
              O = 0,
              A = k;
            if (
              (T &&
                ((S = M(S, "y", "")),
                -1 === v(S, "g") && (S += "g"),
                (A = b(k, m.lastIndex)),
                m.lastIndex > 0 &&
                  (!m.multiline ||
                    (m.multiline && "\n" !== y(k, m.lastIndex - 1))) &&
                  ((j = "(?: " + j + ")"), (A = " " + A), O++),
                (n = new RegExp("^(?:" + j + ")", S))),
              w && (n = new RegExp("^" + j + "$(?!\\s)", S)),
              x && (i = m.lastIndex),
              (a = r(p, T ? n : m, A)),
              T
                ? a
                  ? ((a.input = b(a.input, O)),
                    (a[0] = b(a[0], O)),
                    (a.index = m.lastIndex),
                    (m.lastIndex += a[0].length))
                  : (m.lastIndex = 0)
                : x &&
                  a &&
                  (m.lastIndex = m.global ? a.index + a[0].length : i),
              w &&
                a &&
                a.length > 1 &&
                r(_, a[0], n, function () {
                  for (l = 1; l < arguments.length - 2; l++)
                    void 0 === arguments[l] && (a[l] = void 0);
                }),
              a && D)
            )
              for (a.groups = d = c(null), l = 0; l < D.length; l++)
                d[(u = D[l])[0]] = a[u[1]];
            return a;
          }),
          (e.exports = g);
      },
      3164: function (e, t, n) {
        var i = n(421);
        e.exports = function () {
          var e = i(this),
            t = "";
          return (
            e.hasIndices && (t += "d"),
            e.global && (t += "g"),
            e.ignoreCase && (t += "i"),
            e.multiline && (t += "m"),
            e.dotAll && (t += "s"),
            e.unicode && (t += "u"),
            e.unicodeSets && (t += "v"),
            e.sticky && (t += "y"),
            t
          );
        };
      },
      3857: function (e, t, n) {
        var i = n(5659),
          a = n(3507).RegExp,
          r = i(function () {
            var e = a("a", "y");
            return (e.lastIndex = 2), null !== e.exec("abcd");
          }),
          l =
            r ||
            i(function () {
              return !a("a", "y").sticky;
            }),
          o =
            r ||
            i(function () {
              var e = a("^r", "gy");
              return (e.lastIndex = 2), null !== e.exec("str");
            });
        e.exports = { BROKEN_CARET: o, MISSED_STICKY: l, UNSUPPORTED_Y: r };
      },
      8322: function (e, t, n) {
        var i = n(5659),
          a = n(3507).RegExp;
        e.exports = i(function () {
          var e = a(".", "s");
          return !(e.dotAll && e.test("\n") && "s" === e.flags);
        });
      },
      6620: function (e, t, n) {
        var i = n(5659),
          a = n(3507).RegExp;
        e.exports = i(function () {
          var e = a("(?<a>b)", "g");
          return (
            "b" !== e.exec("b").groups.a || "bc" !== "b".replace(e, "$<a>c")
          );
        });
      },
      8349: function (e, t, n) {
        var i = n(5341),
          a = TypeError;
        e.exports = function (e) {
          if (i(e)) throw new a("Can't call method on " + e);
          return e;
        };
      },
      5453: function (e, t, n) {
        var i = n(5489).f,
          a = n(2002),
          r = n(140)("toStringTag");
        e.exports = function (e, t, n) {
          e && !n && (e = e.prototype),
            e && !a(e, r) && i(e, r, { configurable: !0, value: t });
        };
      },
      8355: function (e, t, n) {
        var i = n(3),
          a = n(4903),
          r = i("keys");
        e.exports = function (e) {
          return r[e] || (r[e] = a(e));
        };
      },
      6035: function (e, t, n) {
        var i = n(6940),
          a = n(3507),
          r = n(6275),
          l = "__core-js_shared__",
          o = (e.exports = a[l] || r(l, {}));
        (o.versions || (o.versions = [])).push({
          version: "3.36.1",
          mode: i ? "pure" : "global",
          copyright: "© 2014-2024 Denis Pushkarev (zloirock.ru)",
          license: "https://github.com/zloirock/core-js/blob/v3.36.1/LICENSE",
          source: "https://github.com/zloirock/core-js",
        });
      },
      3: function (e, t, n) {
        var i = n(6035);
        e.exports = function (e, t) {
          return i[e] || (i[e] = t || {});
        };
      },
      8630: function (e, t, n) {
        var i = n(2786),
          a = n(1506),
          r = n(3634),
          l = n(8349),
          o = i("".charAt),
          s = i("".charCodeAt),
          d = i("".slice),
          u = function (e) {
            return function (t, n) {
              var i,
                u,
                c = r(l(t)),
                h = a(n),
                m = c.length;
              return h < 0 || h >= m
                ? e
                  ? ""
                  : void 0
                : (i = s(c, h)) < 55296 ||
                  i > 56319 ||
                  h + 1 === m ||
                  (u = s(c, h + 1)) < 56320 ||
                  u > 57343
                ? e
                  ? o(c, h)
                  : i
                : e
                ? d(c, h, h + 2)
                : u - 56320 + ((i - 55296) << 10) + 65536;
            };
          };
        e.exports = { codeAt: u(!1), charAt: u(!0) };
      },
      645: function (e, t, n) {
        var i = n(2786),
          a = n(8349),
          r = n(3634),
          l = n(2032),
          o = i("".replace),
          s = RegExp("^[" + l + "]+"),
          d = RegExp("(^|[^" + l + "])[" + l + "]+$"),
          u = function (e) {
            return function (t) {
              var n = r(a(t));
              return (
                1 & e && (n = o(n, s, "")), 2 & e && (n = o(n, d, "$1")), n
              );
            };
          };
        e.exports = { start: u(1), end: u(2), trim: u(3) };
      },
      9800: function (e, t, n) {
        var i = n(2935),
          a = n(5659),
          r = n(3507).String;
        e.exports =
          !!Object.getOwnPropertySymbols &&
          !a(function () {
            var e = Symbol("symbol detection");
            return (
              !r(e) ||
              !(Object(e) instanceof Symbol) ||
              (!Symbol.sham && i && i < 41)
            );
          });
      },
      8575: function (e, t, n) {
        var i = n(1506),
          a = Math.max,
          r = Math.min;
        e.exports = function (e, t) {
          var n = i(e);
          return n < 0 ? a(n + t, 0) : r(n, t);
        };
      },
      93: function (e, t, n) {
        var i = n(9546),
          a = n(8349);
        e.exports = function (e) {
          return i(a(e));
        };
      },
      1506: function (e, t, n) {
        var i = n(3639);
        e.exports = function (e) {
          var t = +e;
          return t != t || 0 === t ? 0 : i(t);
        };
      },
      682: function (e, t, n) {
        var i = n(1506),
          a = Math.min;
        e.exports = function (e) {
          var t = i(e);
          return t > 0 ? a(t, 9007199254740991) : 0;
        };
      },
      3517: function (e, t, n) {
        var i = n(8349),
          a = Object;
        e.exports = function (e) {
          return a(i(e));
        };
      },
      7352: function (e, t, n) {
        var i = n(5750),
          a = n(4728),
          r = n(7788),
          l = n(9290),
          o = n(9212),
          s = n(140),
          d = TypeError,
          u = s("toPrimitive");
        e.exports = function (e, t) {
          if (!a(e) || r(e)) return e;
          var n,
            s = l(e, u);
          if (s) {
            if (
              (void 0 === t && (t = "default"), (n = i(s, e, t)), !a(n) || r(n))
            )
              return n;
            throw new d("Can't convert object to primitive value");
          }
          return void 0 === t && (t = "number"), o(e, t);
        };
      },
      9457: function (e, t, n) {
        var i = n(7352),
          a = n(7788);
        e.exports = function (e) {
          var t = i(e, "string");
          return a(t) ? t : t + "";
        };
      },
      9030: function (e, t, n) {
        var i = {};
        (i[n(140)("toStringTag")] = "z"),
          (e.exports = "[object z]" === String(i));
      },
      3634: function (e, t, n) {
        var i = n(3298),
          a = String;
        e.exports = function (e) {
          if ("Symbol" === i(e))
            throw new TypeError("Cannot convert a Symbol value to a string");
          return a(e);
        };
      },
      1812: function (e) {
        var t = String;
        e.exports = function (e) {
          try {
            return t(e);
          } catch (e) {
            return "Object";
          }
        };
      },
      4903: function (e, t, n) {
        var i = n(2786),
          a = 0,
          r = Math.random(),
          l = i((1).toString);
        e.exports = function (e) {
          return "Symbol(" + (void 0 === e ? "" : e) + ")_" + l(++a + r, 36);
        };
      },
      7692: function (e, t, n) {
        var i = n(9800);
        e.exports = i && !Symbol.sham && "symbol" == typeof Symbol.iterator;
      },
      3169: function (e, t, n) {
        var i = n(5459),
          a = n(5659);
        e.exports =
          i &&
          a(function () {
            return (
              42 !==
              Object.defineProperty(function () {}, "prototype", {
                value: 42,
                writable: !1,
              }).prototype
            );
          });
      },
      4806: function (e, t, n) {
        var i = n(3507),
          a = n(5709),
          r = i.WeakMap;
        e.exports = a(r) && /native code/.test(String(r));
      },
      140: function (e, t, n) {
        var i = n(3507),
          a = n(3),
          r = n(2002),
          l = n(4903),
          o = n(9800),
          s = n(7692),
          d = i.Symbol,
          u = a("wks"),
          c = s ? d.for || d : (d && d.withoutSetter) || l;
        e.exports = function (e) {
          return (
            r(u, e) || (u[e] = o && r(d, e) ? d[e] : c("Symbol." + e)), u[e]
          );
        };
      },
      2032: function (e) {
        e.exports = "\t\n\v\f\r                　\u2028\u2029\ufeff";
      },
      1888: function (e, t, n) {
        var i = n(2654),
          a = n(2246).filter;
        i(
          { target: "Array", proto: !0, forced: !n(4950)("filter") },
          {
            filter: function (e) {
              return a(this, e, arguments.length > 1 ? arguments[1] : void 0);
            },
          }
        );
      },
      9461: function (e, t, n) {
        var i = n(93),
          a = n(7342),
          r = n(2528),
          l = n(4626),
          o = n(5489).f,
          s = n(7094),
          d = n(254),
          u = n(6940),
          c = n(5459),
          h = "Array Iterator",
          m = l.set,
          f = l.getterFor(h);
        e.exports = s(
          Array,
          "Array",
          function (e, t) {
            m(this, { type: h, target: i(e), index: 0, kind: t });
          },
          function () {
            var e = f(this),
              t = e.target,
              n = e.index++;
            if (!t || n >= t.length) return (e.target = void 0), d(void 0, !0);
            switch (e.kind) {
              case "keys":
                return d(n, !1);
              case "values":
                return d(t[n], !1);
            }
            return d([n, t[n]], !1);
          },
          "values"
        );
        var _ = (r.Arguments = r.Array);
        if (
          (a("keys"), a("values"), a("entries"), !u && c && "values" !== _.name)
        )
          try {
            o(_, "name", { value: "values" });
          } catch (e) {}
      },
      6648: function (e, t, n) {
        var i = n(2654),
          a = n(5930).left,
          r = n(2388),
          l = n(2935);
        i(
          {
            target: "Array",
            proto: !0,
            forced: (!n(9905) && l > 79 && l < 83) || !r("reduce"),
          },
          {
            reduce: function (e) {
              var t = arguments.length;
              return a(this, e, t, t > 1 ? arguments[1] : void 0);
            },
          }
        );
      },
      3030: function (e, t, n) {
        var i = n(5459),
          a = n(1082).EXISTS,
          r = n(2786),
          l = n(6127),
          o = Function.prototype,
          s = r(o.toString),
          d =
            /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/,
          u = r(d.exec);
        i &&
          !a &&
          l(o, "name", {
            configurable: !0,
            get: function () {
              try {
                return u(d, s(this))[1];
              } catch (e) {
                return "";
              }
            },
          });
      },
      6700: function (e, t, n) {
        var i = n(2654),
          a = n(5355);
        i(
          { target: "Object", stat: !0, arity: 2, forced: Object.assign !== a },
          { assign: a }
        );
      },
      8945: function (e, t, n) {
        var i = n(9030),
          a = n(2667),
          r = n(2844);
        i || a(Object.prototype, "toString", r, { unsafe: !0 });
      },
      6369: function (e, t, n) {
        var i = n(2654),
          a = n(5811);
        i({ global: !0, forced: parseInt !== a }, { parseInt: a });
      },
      8044: function (e, t, n) {
        var i = n(2654),
          a = n(7191);
        i({ target: "RegExp", proto: !0, forced: /./.exec !== a }, { exec: a });
      },
      2930: function (e, t, n) {
        var i = n(8630).charAt,
          a = n(3634),
          r = n(4626),
          l = n(7094),
          o = n(254),
          s = "String Iterator",
          d = r.set,
          u = r.getterFor(s);
        l(
          String,
          "String",
          function (e) {
            d(this, { type: s, string: a(e), index: 0 });
          },
          function () {
            var e,
              t = u(this),
              n = t.string,
              a = t.index;
            return a >= n.length
              ? o(void 0, !0)
              : ((e = i(n, a)), (t.index += e.length), o(e, !1));
          }
        );
      },
      7570: function (e, t, n) {
        var i = n(5750),
          a = n(7988),
          r = n(421),
          l = n(5341),
          o = n(682),
          s = n(3634),
          d = n(8349),
          u = n(9290),
          c = n(5876),
          h = n(3910);
        a("match", function (e, t, n) {
          return [
            function (t) {
              var n = d(this),
                a = l(t) ? void 0 : u(t, e);
              return a ? i(a, t, n) : new RegExp(t)[e](s(n));
            },
            function (e) {
              var i = r(this),
                a = s(e),
                l = n(t, i, a);
              if (l.done) return l.value;
              if (!i.global) return h(i, a);
              var d = i.unicode;
              i.lastIndex = 0;
              for (var u, m = [], f = 0; null !== (u = h(i, a)); ) {
                var _ = s(u[0]);
                (m[f] = _),
                  "" === _ && (i.lastIndex = c(a, o(i.lastIndex), d)),
                  f++;
              }
              return 0 === f ? null : m;
            },
          ];
        });
      },
      1845: function (e, t, n) {
        var i = n(368),
          a = n(5750),
          r = n(2786),
          l = n(7988),
          o = n(5659),
          s = n(421),
          d = n(5709),
          u = n(5341),
          c = n(1506),
          h = n(682),
          m = n(3634),
          f = n(8349),
          _ = n(5876),
          p = n(9290),
          g = n(4217),
          y = n(3910),
          v = n(140)("replace"),
          M = Math.max,
          b = Math.min,
          x = r([].concat),
          L = r([].push),
          w = r("".indexOf),
          k = r("".slice),
          Y = "$0" === "a".replace(/./, "$0"),
          D = !!/./[v] && "" === /./[v]("a", "$0");
        l(
          "replace",
          function (e, t, n) {
            var r = D ? "$" : "$0";
            return [
              function (e, n) {
                var i = f(this),
                  r = u(e) ? void 0 : p(e, v);
                return r ? a(r, e, i, n) : a(t, m(i), e, n);
              },
              function (e, a) {
                var l = s(this),
                  o = m(e);
                if (
                  "string" == typeof a &&
                  -1 === w(a, r) &&
                  -1 === w(a, "$<")
                ) {
                  var u = n(t, l, o, a);
                  if (u.done) return u.value;
                }
                var f = d(a);
                f || (a = m(a));
                var p,
                  v = l.global;
                v && ((p = l.unicode), (l.lastIndex = 0));
                for (var Y, D = []; null !== (Y = y(l, o)) && (L(D, Y), v); ) {
                  "" === m(Y[0]) && (l.lastIndex = _(o, h(l.lastIndex), p));
                }
                for (var T, S = "", j = 0, O = 0; O < D.length; O++) {
                  for (
                    var A,
                      H = m((Y = D[O])[0]),
                      E = M(b(c(Y.index), o.length), 0),
                      C = [],
                      P = 1;
                    P < Y.length;
                    P++
                  )
                    L(C, void 0 === (T = Y[P]) ? T : String(T));
                  var F = Y.groups;
                  if (f) {
                    var I = x([H], C, E, o);
                    void 0 !== F && L(I, F), (A = m(i(a, void 0, I)));
                  } else A = g(H, o, E, C, F, a);
                  E >= j && ((S += k(o, j, E) + A), (j = E + H.length));
                }
                return S + k(o, j);
              },
            ];
          },
          !!o(function () {
            var e = /./;
            return (
              (e.exec = function () {
                var e = [];
                return (e.groups = { a: "7" }), e;
              }),
              "7" !== "".replace(e, "$<a>")
            );
          }) ||
            !Y ||
            D
        );
      },
      4114: function (e, t, n) {
        var i,
          a = n(3681),
          r = n(3507),
          l = n(2786),
          o = n(8367),
          s = n(9841),
          d = n(9123),
          u = n(717),
          c = n(4728),
          h = n(4626).enforce,
          m = n(5659),
          f = n(4806),
          _ = Object,
          p = Array.isArray,
          g = _.isExtensible,
          y = _.isFrozen,
          v = _.isSealed,
          M = _.freeze,
          b = _.seal,
          x = !r.ActiveXObject && "ActiveXObject" in r,
          L = function (e) {
            return function () {
              return e(this, arguments.length ? arguments[0] : void 0);
            };
          },
          w = d("WeakMap", L, u),
          k = w.prototype,
          Y = l(k.set);
        if (f)
          if (x) {
            (i = u.getConstructor(L, "WeakMap", !0)), s.enable();
            var D = l(k.delete),
              T = l(k.has),
              S = l(k.get);
            o(k, {
              delete: function (e) {
                if (c(e) && !g(e)) {
                  var t = h(this);
                  return (
                    t.frozen || (t.frozen = new i()),
                    D(this, e) || t.frozen.delete(e)
                  );
                }
                return D(this, e);
              },
              has: function (e) {
                if (c(e) && !g(e)) {
                  var t = h(this);
                  return (
                    t.frozen || (t.frozen = new i()),
                    T(this, e) || t.frozen.has(e)
                  );
                }
                return T(this, e);
              },
              get: function (e) {
                if (c(e) && !g(e)) {
                  var t = h(this);
                  return (
                    t.frozen || (t.frozen = new i()),
                    T(this, e) ? S(this, e) : t.frozen.get(e)
                  );
                }
                return S(this, e);
              },
              set: function (e, t) {
                if (c(e) && !g(e)) {
                  var n = h(this);
                  n.frozen || (n.frozen = new i()),
                    T(this, e) ? Y(this, e, t) : n.frozen.set(e, t);
                } else Y(this, e, t);
                return this;
              },
            });
          } else
            a &&
              m(function () {
                var e = M([]);
                return Y(new w(), e, 1), !y(e);
              }) &&
              o(k, {
                set: function (e, t) {
                  var n;
                  return (
                    p(e) && (y(e) ? (n = M) : v(e) && (n = b)),
                    Y(this, e, t),
                    n && n(e),
                    this
                  );
                },
              });
      },
      7416: function (e, t, n) {
        n(4114);
      },
      8353: function (e, t, n) {
        var i = n(3507),
          a = n(8373),
          r = n(3486),
          l = n(9704),
          o = n(2658),
          s = function (e) {
            if (e && e.forEach !== l)
              try {
                o(e, "forEach", l);
              } catch (t) {
                e.forEach = l;
              }
          };
        for (var d in a) a[d] && s(i[d] && i[d].prototype);
        s(r);
      },
      6235: function (e, t, n) {
        var i = n(3507),
          a = n(8373),
          r = n(3486),
          l = n(9461),
          o = n(2658),
          s = n(5453),
          d = n(140)("iterator"),
          u = l.values,
          c = function (e, t) {
            if (e) {
              if (e[d] !== u)
                try {
                  o(e, d, u);
                } catch (t) {
                  e[d] = u;
                }
              if ((s(e, t, !0), a[t]))
                for (var n in l)
                  if (e[n] !== l[n])
                    try {
                      o(e, n, l[n]);
                    } catch (t) {
                      e[n] = l[n];
                    }
            }
          };
        for (var h in a) c(i[h] && i[h].prototype, h);
        c(r, "DOMTokenList");
      },
    },
    t = {};
  function n(i) {
    var a = t[i];
    if (void 0 !== a) return a.exports;
    var r = (t[i] = { id: i, loaded: !1, exports: {} });
    return e[i].call(r.exports, r, r.exports, n), (r.loaded = !0), r.exports;
  }
  (n.n = function (e) {
    var t =
      e && e.__esModule
        ? function () {
            return e.default;
          }
        : function () {
            return e;
          };
    return n.d(t, { a: t }), t;
  }),
    (n.d = function (e, t) {
      for (var i in t)
        n.o(t, i) &&
          !n.o(e, i) &&
          Object.defineProperty(e, i, { enumerable: !0, get: t[i] });
    }),
    (n.g = (function () {
      if ("object" == typeof globalThis) return globalThis;
      try {
        return this || new Function("return this")();
      } catch (e) {
        if ("object" == typeof window) return window;
      }
    })()),
    (n.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }),
    (n.r = function (e) {
      "undefined" != typeof Symbol &&
        Symbol.toStringTag &&
        Object.defineProperty(e, Symbol.toStringTag, { value: "Module" }),
        Object.defineProperty(e, "__esModule", { value: !0 });
    }),
    (n.nmd = function (e) {
      return (e.paths = []), e.children || (e.children = []), e;
    }),
    (function () {
      var e = {};
      n.r(e),
        n.d(e, {
          afterMain: function () {
            return x;
          },
          afterRead: function () {
            return v;
          },
          afterWrite: function () {
            return k;
          },
          applyStyles: function () {
            return A;
          },
          arrow: function () {
            return K;
          },
          auto: function () {
            return o;
          },
          basePlacements: function () {
            return s;
          },
          beforeMain: function () {
            return M;
          },
          beforeRead: function () {
            return g;
          },
          beforeWrite: function () {
            return L;
          },
          bottom: function () {
            return a;
          },
          clippingParents: function () {
            return c;
          },
          computeStyles: function () {
            return ne;
          },
          createPopper: function () {
            return Ae;
          },
          createPopperBase: function () {
            return Oe;
          },
          createPopperLite: function () {
            return He;
          },
          detectOverflow: function () {
            return ye;
          },
          end: function () {
            return u;
          },
          eventListeners: function () {
            return ae;
          },
          flip: function () {
            return ve;
          },
          hide: function () {
            return xe;
          },
          left: function () {
            return l;
          },
          main: function () {
            return b;
          },
          modifierPhases: function () {
            return Y;
          },
          offset: function () {
            return Le;
          },
          placements: function () {
            return p;
          },
          popper: function () {
            return m;
          },
          popperGenerator: function () {
            return je;
          },
          popperOffsets: function () {
            return we;
          },
          preventOverflow: function () {
            return ke;
          },
          read: function () {
            return y;
          },
          reference: function () {
            return f;
          },
          right: function () {
            return r;
          },
          start: function () {
            return d;
          },
          top: function () {
            return i;
          },
          variationPlacements: function () {
            return _;
          },
          viewport: function () {
            return h;
          },
          write: function () {
            return w;
          },
        });
      var t = {};
      n.r(t),
        n.d(t, {
          Alert: function () {
            return Dt;
          },
          Button: function () {
            return St;
          },
          Carousel: function () {
            return un;
          },
          Collapse: function () {
            return wn;
          },
          Dropdown: function () {
            return qn;
          },
          Modal: function () {
            return ji;
          },
          Offcanvas: function () {
            return Ji;
          },
          Popover: function () {
            return va;
          },
          ScrollSpy: function () {
            return ja;
          },
          Tab: function () {
            return Ga;
          },
          Toast: function () {
            return cr;
          },
          Tooltip: function () {
            return fa;
          },
        });
      var i = "top",
        a = "bottom",
        r = "right",
        l = "left",
        o = "auto",
        s = [i, a, r, l],
        d = "start",
        u = "end",
        c = "clippingParents",
        h = "viewport",
        m = "popper",
        f = "reference",
        _ = s.reduce(function (e, t) {
          return e.concat([t + "-" + d, t + "-" + u]);
        }, []),
        p = [].concat(s, [o]).reduce(function (e, t) {
          return e.concat([t, t + "-" + d, t + "-" + u]);
        }, []),
        g = "beforeRead",
        y = "read",
        v = "afterRead",
        M = "beforeMain",
        b = "main",
        x = "afterMain",
        L = "beforeWrite",
        w = "write",
        k = "afterWrite",
        Y = [g, y, v, M, b, x, L, w, k];
      function D(e) {
        return e ? (e.nodeName || "").toLowerCase() : null;
      }
      function T(e) {
        if (null == e) return window;
        if ("[object Window]" !== e.toString()) {
          var t = e.ownerDocument;
          return (t && t.defaultView) || window;
        }
        return e;
      }
      function S(e) {
        return e instanceof T(e).Element || e instanceof Element;
      }
      function j(e) {
        return e instanceof T(e).HTMLElement || e instanceof HTMLElement;
      }
      function O(e) {
        return (
          "undefined" != typeof ShadowRoot &&
          (e instanceof T(e).ShadowRoot || e instanceof ShadowRoot)
        );
      }
      var A = {
        name: "applyStyles",
        enabled: !0,
        phase: "write",
        fn: function (e) {
          var t = e.state;
          Object.keys(t.elements).forEach(function (e) {
            var n = t.styles[e] || {},
              i = t.attributes[e] || {},
              a = t.elements[e];
            j(a) &&
              D(a) &&
              (Object.assign(a.style, n),
              Object.keys(i).forEach(function (e) {
                var t = i[e];
                !1 === t
                  ? a.removeAttribute(e)
                  : a.setAttribute(e, !0 === t ? "" : t);
              }));
          });
        },
        effect: function (e) {
          var t = e.state,
            n = {
              popper: {
                position: t.options.strategy,
                left: "0",
                top: "0",
                margin: "0",
              },
              arrow: { position: "absolute" },
              reference: {},
            };
          return (
            Object.assign(t.elements.popper.style, n.popper),
            (t.styles = n),
            t.elements.arrow && Object.assign(t.elements.arrow.style, n.arrow),
            function () {
              Object.keys(t.elements).forEach(function (e) {
                var i = t.elements[e],
                  a = t.attributes[e] || {},
                  r = Object.keys(
                    t.styles.hasOwnProperty(e) ? t.styles[e] : n[e]
                  ).reduce(function (e, t) {
                    return (e[t] = ""), e;
                  }, {});
                j(i) &&
                  D(i) &&
                  (Object.assign(i.style, r),
                  Object.keys(a).forEach(function (e) {
                    i.removeAttribute(e);
                  }));
              });
            }
          );
        },
        requires: ["computeStyles"],
      };
      function H(e) {
        return e.split("-")[0];
      }
      var E = Math.max,
        C = Math.min,
        P = Math.round;
      function F() {
        var e = navigator.userAgentData;
        return null != e && e.brands && Array.isArray(e.brands)
          ? e.brands
              .map(function (e) {
                return e.brand + "/" + e.version;
              })
              .join(" ")
          : navigator.userAgent;
      }
      function I() {
        return !/^((?!chrome|android).)*safari/i.test(F());
      }
      function W(e, t, n) {
        void 0 === t && (t = !1), void 0 === n && (n = !1);
        var i = e.getBoundingClientRect(),
          a = 1,
          r = 1;
        t &&
          j(e) &&
          ((a = (e.offsetWidth > 0 && P(i.width) / e.offsetWidth) || 1),
          (r = (e.offsetHeight > 0 && P(i.height) / e.offsetHeight) || 1));
        var l = (S(e) ? T(e) : window).visualViewport,
          o = !I() && n,
          s = (i.left + (o && l ? l.offsetLeft : 0)) / a,
          d = (i.top + (o && l ? l.offsetTop : 0)) / r,
          u = i.width / a,
          c = i.height / r;
        return {
          width: u,
          height: c,
          top: d,
          right: s + u,
          bottom: d + c,
          left: s,
          x: s,
          y: d,
        };
      }
      function z(e) {
        var t = W(e),
          n = e.offsetWidth,
          i = e.offsetHeight;
        return (
          Math.abs(t.width - n) <= 1 && (n = t.width),
          Math.abs(t.height - i) <= 1 && (i = t.height),
          { x: e.offsetLeft, y: e.offsetTop, width: n, height: i }
        );
      }
      function N(e, t) {
        var n = t.getRootNode && t.getRootNode();
        if (e.contains(t)) return !0;
        if (n && O(n)) {
          var i = t;
          do {
            if (i && e.isSameNode(i)) return !0;
            i = i.parentNode || i.host;
          } while (i);
        }
        return !1;
      }
      function R(e) {
        return T(e).getComputedStyle(e);
      }
      function B(e) {
        return ["table", "td", "th"].indexOf(D(e)) >= 0;
      }
      function V(e) {
        return ((S(e) ? e.ownerDocument : e.document) || window.document)
          .documentElement;
      }
      function Z(e) {
        return "html" === D(e)
          ? e
          : e.assignedSlot || e.parentNode || (O(e) ? e.host : null) || V(e);
      }
      function U(e) {
        return j(e) && "fixed" !== R(e).position ? e.offsetParent : null;
      }
      function $(e) {
        for (var t = T(e), n = U(e); n && B(n) && "static" === R(n).position; )
          n = U(n);
        return n &&
          ("html" === D(n) || ("body" === D(n) && "static" === R(n).position))
          ? t
          : n ||
              (function (e) {
                var t = /firefox/i.test(F());
                if (/Trident/i.test(F()) && j(e) && "fixed" === R(e).position)
                  return null;
                var n = Z(e);
                for (
                  O(n) && (n = n.host);
                  j(n) && ["html", "body"].indexOf(D(n)) < 0;

                ) {
                  var i = R(n);
                  if (
                    "none" !== i.transform ||
                    "none" !== i.perspective ||
                    "paint" === i.contain ||
                    -1 !== ["transform", "perspective"].indexOf(i.willChange) ||
                    (t && "filter" === i.willChange) ||
                    (t && i.filter && "none" !== i.filter)
                  )
                    return n;
                  n = n.parentNode;
                }
                return null;
              })(e) ||
              t;
      }
      function J(e) {
        return ["top", "bottom"].indexOf(e) >= 0 ? "x" : "y";
      }
      function q(e, t, n) {
        return E(e, C(t, n));
      }
      function G(e) {
        return Object.assign({}, { top: 0, right: 0, bottom: 0, left: 0 }, e);
      }
      function X(e, t) {
        return t.reduce(function (t, n) {
          return (t[n] = e), t;
        }, {});
      }
      var K = {
        name: "arrow",
        enabled: !0,
        phase: "main",
        fn: function (e) {
          var t,
            n = e.state,
            o = e.name,
            d = e.options,
            u = n.elements.arrow,
            c = n.modifiersData.popperOffsets,
            h = H(n.placement),
            m = J(h),
            f = [l, r].indexOf(h) >= 0 ? "height" : "width";
          if (u && c) {
            var _ = (function (e, t) {
                return G(
                  "number" !=
                    typeof (e =
                      "function" == typeof e
                        ? e(
                            Object.assign({}, t.rects, {
                              placement: t.placement,
                            })
                          )
                        : e)
                    ? e
                    : X(e, s)
                );
              })(d.padding, n),
              p = z(u),
              g = "y" === m ? i : l,
              y = "y" === m ? a : r,
              v =
                n.rects.reference[f] +
                n.rects.reference[m] -
                c[m] -
                n.rects.popper[f],
              M = c[m] - n.rects.reference[m],
              b = $(u),
              x = b
                ? "y" === m
                  ? b.clientHeight || 0
                  : b.clientWidth || 0
                : 0,
              L = v / 2 - M / 2,
              w = _[g],
              k = x - p[f] - _[y],
              Y = x / 2 - p[f] / 2 + L,
              D = q(w, Y, k),
              T = m;
            n.modifiersData[o] =
              (((t = {})[T] = D), (t.centerOffset = D - Y), t);
          }
        },
        effect: function (e) {
          var t = e.state,
            n = e.options.element,
            i = void 0 === n ? "[data-popper-arrow]" : n;
          null != i &&
            ("string" != typeof i ||
              (i = t.elements.popper.querySelector(i))) &&
            N(t.elements.popper, i) &&
            (t.elements.arrow = i);
        },
        requires: ["popperOffsets"],
        requiresIfExists: ["preventOverflow"],
      };
      function Q(e) {
        return e.split("-")[1];
      }
      var ee = { top: "auto", right: "auto", bottom: "auto", left: "auto" };
      function te(e) {
        var t,
          n = e.popper,
          o = e.popperRect,
          s = e.placement,
          d = e.variation,
          c = e.offsets,
          h = e.position,
          m = e.gpuAcceleration,
          f = e.adaptive,
          _ = e.roundOffsets,
          p = e.isFixed,
          g = c.x,
          y = void 0 === g ? 0 : g,
          v = c.y,
          M = void 0 === v ? 0 : v,
          b = "function" == typeof _ ? _({ x: y, y: M }) : { x: y, y: M };
        (y = b.x), (M = b.y);
        var x = c.hasOwnProperty("x"),
          L = c.hasOwnProperty("y"),
          w = l,
          k = i,
          Y = window;
        if (f) {
          var D = $(n),
            S = "clientHeight",
            j = "clientWidth";
          if (
            (D === T(n) &&
              "static" !== R((D = V(n))).position &&
              "absolute" === h &&
              ((S = "scrollHeight"), (j = "scrollWidth")),
            s === i || ((s === l || s === r) && d === u))
          )
            (k = a),
              (M -=
                (p && D === Y && Y.visualViewport
                  ? Y.visualViewport.height
                  : D[S]) - o.height),
              (M *= m ? 1 : -1);
          if (s === l || ((s === i || s === a) && d === u))
            (w = r),
              (y -=
                (p && D === Y && Y.visualViewport
                  ? Y.visualViewport.width
                  : D[j]) - o.width),
              (y *= m ? 1 : -1);
        }
        var O,
          A = Object.assign({ position: h }, f && ee),
          H =
            !0 === _
              ? (function (e, t) {
                  var n = e.x,
                    i = e.y,
                    a = t.devicePixelRatio || 1;
                  return { x: P(n * a) / a || 0, y: P(i * a) / a || 0 };
                })({ x: y, y: M }, T(n))
              : { x: y, y: M };
        return (
          (y = H.x),
          (M = H.y),
          m
            ? Object.assign(
                {},
                A,
                (((O = {})[k] = L ? "0" : ""),
                (O[w] = x ? "0" : ""),
                (O.transform =
                  (Y.devicePixelRatio || 1) <= 1
                    ? "translate(" + y + "px, " + M + "px)"
                    : "translate3d(" + y + "px, " + M + "px, 0)"),
                O)
              )
            : Object.assign(
                {},
                A,
                (((t = {})[k] = L ? M + "px" : ""),
                (t[w] = x ? y + "px" : ""),
                (t.transform = ""),
                t)
              )
        );
      }
      var ne = {
          name: "computeStyles",
          enabled: !0,
          phase: "beforeWrite",
          fn: function (e) {
            var t = e.state,
              n = e.options,
              i = n.gpuAcceleration,
              a = void 0 === i || i,
              r = n.adaptive,
              l = void 0 === r || r,
              o = n.roundOffsets,
              s = void 0 === o || o,
              d = {
                placement: H(t.placement),
                variation: Q(t.placement),
                popper: t.elements.popper,
                popperRect: t.rects.popper,
                gpuAcceleration: a,
                isFixed: "fixed" === t.options.strategy,
              };
            null != t.modifiersData.popperOffsets &&
              (t.styles.popper = Object.assign(
                {},
                t.styles.popper,
                te(
                  Object.assign({}, d, {
                    offsets: t.modifiersData.popperOffsets,
                    position: t.options.strategy,
                    adaptive: l,
                    roundOffsets: s,
                  })
                )
              )),
              null != t.modifiersData.arrow &&
                (t.styles.arrow = Object.assign(
                  {},
                  t.styles.arrow,
                  te(
                    Object.assign({}, d, {
                      offsets: t.modifiersData.arrow,
                      position: "absolute",
                      adaptive: !1,
                      roundOffsets: s,
                    })
                  )
                )),
              (t.attributes.popper = Object.assign({}, t.attributes.popper, {
                "data-popper-placement": t.placement,
              }));
          },
          data: {},
        },
        ie = { passive: !0 };
      var ae = {
          name: "eventListeners",
          enabled: !0,
          phase: "write",
          fn: function () {},
          effect: function (e) {
            var t = e.state,
              n = e.instance,
              i = e.options,
              a = i.scroll,
              r = void 0 === a || a,
              l = i.resize,
              o = void 0 === l || l,
              s = T(t.elements.popper),
              d = [].concat(t.scrollParents.reference, t.scrollParents.popper);
            return (
              r &&
                d.forEach(function (e) {
                  e.addEventListener("scroll", n.update, ie);
                }),
              o && s.addEventListener("resize", n.update, ie),
              function () {
                r &&
                  d.forEach(function (e) {
                    e.removeEventListener("scroll", n.update, ie);
                  }),
                  o && s.removeEventListener("resize", n.update, ie);
              }
            );
          },
          data: {},
        },
        re = { left: "right", right: "left", bottom: "top", top: "bottom" };
      function le(e) {
        return e.replace(/left|right|bottom|top/g, function (e) {
          return re[e];
        });
      }
      var oe = { start: "end", end: "start" };
      function se(e) {
        return e.replace(/start|end/g, function (e) {
          return oe[e];
        });
      }
      function de(e) {
        var t = T(e);
        return { scrollLeft: t.pageXOffset, scrollTop: t.pageYOffset };
      }
      function ue(e) {
        return W(V(e)).left + de(e).scrollLeft;
      }
      function ce(e) {
        var t = R(e),
          n = t.overflow,
          i = t.overflowX,
          a = t.overflowY;
        return /auto|scroll|overlay|hidden/.test(n + a + i);
      }
      function he(e) {
        return ["html", "body", "#document"].indexOf(D(e)) >= 0
          ? e.ownerDocument.body
          : j(e) && ce(e)
          ? e
          : he(Z(e));
      }
      function me(e, t) {
        var n;
        void 0 === t && (t = []);
        var i = he(e),
          a = i === (null == (n = e.ownerDocument) ? void 0 : n.body),
          r = T(i),
          l = a ? [r].concat(r.visualViewport || [], ce(i) ? i : []) : i,
          o = t.concat(l);
        return a ? o : o.concat(me(Z(l)));
      }
      function fe(e) {
        return Object.assign({}, e, {
          left: e.x,
          top: e.y,
          right: e.x + e.width,
          bottom: e.y + e.height,
        });
      }
      function _e(e, t, n) {
        return t === h
          ? fe(
              (function (e, t) {
                var n = T(e),
                  i = V(e),
                  a = n.visualViewport,
                  r = i.clientWidth,
                  l = i.clientHeight,
                  o = 0,
                  s = 0;
                if (a) {
                  (r = a.width), (l = a.height);
                  var d = I();
                  (d || (!d && "fixed" === t)) &&
                    ((o = a.offsetLeft), (s = a.offsetTop));
                }
                return { width: r, height: l, x: o + ue(e), y: s };
              })(e, n)
            )
          : S(t)
          ? (function (e, t) {
              var n = W(e, !1, "fixed" === t);
              return (
                (n.top = n.top + e.clientTop),
                (n.left = n.left + e.clientLeft),
                (n.bottom = n.top + e.clientHeight),
                (n.right = n.left + e.clientWidth),
                (n.width = e.clientWidth),
                (n.height = e.clientHeight),
                (n.x = n.left),
                (n.y = n.top),
                n
              );
            })(t, n)
          : fe(
              (function (e) {
                var t,
                  n = V(e),
                  i = de(e),
                  a = null == (t = e.ownerDocument) ? void 0 : t.body,
                  r = E(
                    n.scrollWidth,
                    n.clientWidth,
                    a ? a.scrollWidth : 0,
                    a ? a.clientWidth : 0
                  ),
                  l = E(
                    n.scrollHeight,
                    n.clientHeight,
                    a ? a.scrollHeight : 0,
                    a ? a.clientHeight : 0
                  ),
                  o = -i.scrollLeft + ue(e),
                  s = -i.scrollTop;
                return (
                  "rtl" === R(a || n).direction &&
                    (o += E(n.clientWidth, a ? a.clientWidth : 0) - r),
                  { width: r, height: l, x: o, y: s }
                );
              })(V(e))
            );
      }
      function pe(e, t, n, i) {
        var a =
            "clippingParents" === t
              ? (function (e) {
                  var t = me(Z(e)),
                    n =
                      ["absolute", "fixed"].indexOf(R(e).position) >= 0 && j(e)
                        ? $(e)
                        : e;
                  return S(n)
                    ? t.filter(function (e) {
                        return S(e) && N(e, n) && "body" !== D(e);
                      })
                    : [];
                })(e)
              : [].concat(t),
          r = [].concat(a, [n]),
          l = r[0],
          o = r.reduce(function (t, n) {
            var a = _e(e, n, i);
            return (
              (t.top = E(a.top, t.top)),
              (t.right = C(a.right, t.right)),
              (t.bottom = C(a.bottom, t.bottom)),
              (t.left = E(a.left, t.left)),
              t
            );
          }, _e(e, l, i));
        return (
          (o.width = o.right - o.left),
          (o.height = o.bottom - o.top),
          (o.x = o.left),
          (o.y = o.top),
          o
        );
      }
      function ge(e) {
        var t,
          n = e.reference,
          o = e.element,
          s = e.placement,
          c = s ? H(s) : null,
          h = s ? Q(s) : null,
          m = n.x + n.width / 2 - o.width / 2,
          f = n.y + n.height / 2 - o.height / 2;
        switch (c) {
          case i:
            t = { x: m, y: n.y - o.height };
            break;
          case a:
            t = { x: m, y: n.y + n.height };
            break;
          case r:
            t = { x: n.x + n.width, y: f };
            break;
          case l:
            t = { x: n.x - o.width, y: f };
            break;
          default:
            t = { x: n.x, y: n.y };
        }
        var _ = c ? J(c) : null;
        if (null != _) {
          var p = "y" === _ ? "height" : "width";
          switch (h) {
            case d:
              t[_] = t[_] - (n[p] / 2 - o[p] / 2);
              break;
            case u:
              t[_] = t[_] + (n[p] / 2 - o[p] / 2);
          }
        }
        return t;
      }
      function ye(e, t) {
        void 0 === t && (t = {});
        var n = t,
          l = n.placement,
          o = void 0 === l ? e.placement : l,
          d = n.strategy,
          u = void 0 === d ? e.strategy : d,
          _ = n.boundary,
          p = void 0 === _ ? c : _,
          g = n.rootBoundary,
          y = void 0 === g ? h : g,
          v = n.elementContext,
          M = void 0 === v ? m : v,
          b = n.altBoundary,
          x = void 0 !== b && b,
          L = n.padding,
          w = void 0 === L ? 0 : L,
          k = G("number" != typeof w ? w : X(w, s)),
          Y = M === m ? f : m,
          D = e.rects.popper,
          T = e.elements[x ? Y : M],
          j = pe(S(T) ? T : T.contextElement || V(e.elements.popper), p, y, u),
          O = W(e.elements.reference),
          A = ge({
            reference: O,
            element: D,
            strategy: "absolute",
            placement: o,
          }),
          H = fe(Object.assign({}, D, A)),
          E = M === m ? H : O,
          C = {
            top: j.top - E.top + k.top,
            bottom: E.bottom - j.bottom + k.bottom,
            left: j.left - E.left + k.left,
            right: E.right - j.right + k.right,
          },
          P = e.modifiersData.offset;
        if (M === m && P) {
          var F = P[o];
          Object.keys(C).forEach(function (e) {
            var t = [r, a].indexOf(e) >= 0 ? 1 : -1,
              n = [i, a].indexOf(e) >= 0 ? "y" : "x";
            C[e] += F[n] * t;
          });
        }
        return C;
      }
      var ve = {
        name: "flip",
        enabled: !0,
        phase: "main",
        fn: function (e) {
          var t = e.state,
            n = e.options,
            u = e.name;
          if (!t.modifiersData[u]._skip) {
            for (
              var c = n.mainAxis,
                h = void 0 === c || c,
                m = n.altAxis,
                f = void 0 === m || m,
                g = n.fallbackPlacements,
                y = n.padding,
                v = n.boundary,
                M = n.rootBoundary,
                b = n.altBoundary,
                x = n.flipVariations,
                L = void 0 === x || x,
                w = n.allowedAutoPlacements,
                k = t.options.placement,
                Y = H(k),
                D =
                  g ||
                  (Y === k || !L
                    ? [le(k)]
                    : (function (e) {
                        if (H(e) === o) return [];
                        var t = le(e);
                        return [se(e), t, se(t)];
                      })(k)),
                T = [k].concat(D).reduce(function (e, n) {
                  return e.concat(
                    H(n) === o
                      ? (function (e, t) {
                          void 0 === t && (t = {});
                          var n = t,
                            i = n.placement,
                            a = n.boundary,
                            r = n.rootBoundary,
                            l = n.padding,
                            o = n.flipVariations,
                            d = n.allowedAutoPlacements,
                            u = void 0 === d ? p : d,
                            c = Q(i),
                            h = c
                              ? o
                                ? _
                                : _.filter(function (e) {
                                    return Q(e) === c;
                                  })
                              : s,
                            m = h.filter(function (e) {
                              return u.indexOf(e) >= 0;
                            });
                          0 === m.length && (m = h);
                          var f = m.reduce(function (t, n) {
                            return (
                              (t[n] = ye(e, {
                                placement: n,
                                boundary: a,
                                rootBoundary: r,
                                padding: l,
                              })[H(n)]),
                              t
                            );
                          }, {});
                          return Object.keys(f).sort(function (e, t) {
                            return f[e] - f[t];
                          });
                        })(t, {
                          placement: n,
                          boundary: v,
                          rootBoundary: M,
                          padding: y,
                          flipVariations: L,
                          allowedAutoPlacements: w,
                        })
                      : n
                  );
                }, []),
                S = t.rects.reference,
                j = t.rects.popper,
                O = new Map(),
                A = !0,
                E = T[0],
                C = 0;
              C < T.length;
              C++
            ) {
              var P = T[C],
                F = H(P),
                I = Q(P) === d,
                W = [i, a].indexOf(F) >= 0,
                z = W ? "width" : "height",
                N = ye(t, {
                  placement: P,
                  boundary: v,
                  rootBoundary: M,
                  altBoundary: b,
                  padding: y,
                }),
                R = W ? (I ? r : l) : I ? a : i;
              S[z] > j[z] && (R = le(R));
              var B = le(R),
                V = [];
              if (
                (h && V.push(N[F] <= 0),
                f && V.push(N[R] <= 0, N[B] <= 0),
                V.every(function (e) {
                  return e;
                }))
              ) {
                (E = P), (A = !1);
                break;
              }
              O.set(P, V);
            }
            if (A)
              for (
                var Z = function (e) {
                    var t = T.find(function (t) {
                      var n = O.get(t);
                      if (n)
                        return n.slice(0, e).every(function (e) {
                          return e;
                        });
                    });
                    if (t) return (E = t), "break";
                  },
                  U = L ? 3 : 1;
                U > 0;
                U--
              ) {
                if ("break" === Z(U)) break;
              }
            t.placement !== E &&
              ((t.modifiersData[u]._skip = !0),
              (t.placement = E),
              (t.reset = !0));
          }
        },
        requiresIfExists: ["offset"],
        data: { _skip: !1 },
      };
      function Me(e, t, n) {
        return (
          void 0 === n && (n = { x: 0, y: 0 }),
          {
            top: e.top - t.height - n.y,
            right: e.right - t.width + n.x,
            bottom: e.bottom - t.height + n.y,
            left: e.left - t.width - n.x,
          }
        );
      }
      function be(e) {
        return [i, r, a, l].some(function (t) {
          return e[t] >= 0;
        });
      }
      var xe = {
        name: "hide",
        enabled: !0,
        phase: "main",
        requiresIfExists: ["preventOverflow"],
        fn: function (e) {
          var t = e.state,
            n = e.name,
            i = t.rects.reference,
            a = t.rects.popper,
            r = t.modifiersData.preventOverflow,
            l = ye(t, { elementContext: "reference" }),
            o = ye(t, { altBoundary: !0 }),
            s = Me(l, i),
            d = Me(o, a, r),
            u = be(s),
            c = be(d);
          (t.modifiersData[n] = {
            referenceClippingOffsets: s,
            popperEscapeOffsets: d,
            isReferenceHidden: u,
            hasPopperEscaped: c,
          }),
            (t.attributes.popper = Object.assign({}, t.attributes.popper, {
              "data-popper-reference-hidden": u,
              "data-popper-escaped": c,
            }));
        },
      };
      var Le = {
        name: "offset",
        enabled: !0,
        phase: "main",
        requires: ["popperOffsets"],
        fn: function (e) {
          var t = e.state,
            n = e.options,
            a = e.name,
            o = n.offset,
            s = void 0 === o ? [0, 0] : o,
            d = p.reduce(function (e, n) {
              return (
                (e[n] = (function (e, t, n) {
                  var a = H(e),
                    o = [l, i].indexOf(a) >= 0 ? -1 : 1,
                    s =
                      "function" == typeof n
                        ? n(Object.assign({}, t, { placement: e }))
                        : n,
                    d = s[0],
                    u = s[1];
                  return (
                    (d = d || 0),
                    (u = (u || 0) * o),
                    [l, r].indexOf(a) >= 0 ? { x: u, y: d } : { x: d, y: u }
                  );
                })(n, t.rects, s)),
                e
              );
            }, {}),
            u = d[t.placement],
            c = u.x,
            h = u.y;
          null != t.modifiersData.popperOffsets &&
            ((t.modifiersData.popperOffsets.x += c),
            (t.modifiersData.popperOffsets.y += h)),
            (t.modifiersData[a] = d);
        },
      };
      var we = {
        name: "popperOffsets",
        enabled: !0,
        phase: "read",
        fn: function (e) {
          var t = e.state,
            n = e.name;
          t.modifiersData[n] = ge({
            reference: t.rects.reference,
            element: t.rects.popper,
            strategy: "absolute",
            placement: t.placement,
          });
        },
        data: {},
      };
      var ke = {
        name: "preventOverflow",
        enabled: !0,
        phase: "main",
        fn: function (e) {
          var t = e.state,
            n = e.options,
            o = e.name,
            s = n.mainAxis,
            u = void 0 === s || s,
            c = n.altAxis,
            h = void 0 !== c && c,
            m = n.boundary,
            f = n.rootBoundary,
            _ = n.altBoundary,
            p = n.padding,
            g = n.tether,
            y = void 0 === g || g,
            v = n.tetherOffset,
            M = void 0 === v ? 0 : v,
            b = ye(t, {
              boundary: m,
              rootBoundary: f,
              padding: p,
              altBoundary: _,
            }),
            x = H(t.placement),
            L = Q(t.placement),
            w = !L,
            k = J(x),
            Y = "x" === k ? "y" : "x",
            D = t.modifiersData.popperOffsets,
            T = t.rects.reference,
            S = t.rects.popper,
            j =
              "function" == typeof M
                ? M(Object.assign({}, t.rects, { placement: t.placement }))
                : M,
            O =
              "number" == typeof j
                ? { mainAxis: j, altAxis: j }
                : Object.assign({ mainAxis: 0, altAxis: 0 }, j),
            A = t.modifiersData.offset
              ? t.modifiersData.offset[t.placement]
              : null,
            P = { x: 0, y: 0 };
          if (D) {
            if (u) {
              var F,
                I = "y" === k ? i : l,
                W = "y" === k ? a : r,
                N = "y" === k ? "height" : "width",
                R = D[k],
                B = R + b[I],
                V = R - b[W],
                Z = y ? -S[N] / 2 : 0,
                U = L === d ? T[N] : S[N],
                G = L === d ? -S[N] : -T[N],
                X = t.elements.arrow,
                K = y && X ? z(X) : { width: 0, height: 0 },
                ee = t.modifiersData["arrow#persistent"]
                  ? t.modifiersData["arrow#persistent"].padding
                  : { top: 0, right: 0, bottom: 0, left: 0 },
                te = ee[I],
                ne = ee[W],
                ie = q(0, T[N], K[N]),
                ae = w
                  ? T[N] / 2 - Z - ie - te - O.mainAxis
                  : U - ie - te - O.mainAxis,
                re = w
                  ? -T[N] / 2 + Z + ie + ne + O.mainAxis
                  : G + ie + ne + O.mainAxis,
                le = t.elements.arrow && $(t.elements.arrow),
                oe = le
                  ? "y" === k
                    ? le.clientTop || 0
                    : le.clientLeft || 0
                  : 0,
                se = null != (F = null == A ? void 0 : A[k]) ? F : 0,
                de = R + re - se,
                ue = q(y ? C(B, R + ae - se - oe) : B, R, y ? E(V, de) : V);
              (D[k] = ue), (P[k] = ue - R);
            }
            if (h) {
              var ce,
                he = "x" === k ? i : l,
                me = "x" === k ? a : r,
                fe = D[Y],
                _e = "y" === Y ? "height" : "width",
                pe = fe + b[he],
                ge = fe - b[me],
                ve = -1 !== [i, l].indexOf(x),
                Me = null != (ce = null == A ? void 0 : A[Y]) ? ce : 0,
                be = ve ? pe : fe - T[_e] - S[_e] - Me + O.altAxis,
                xe = ve ? fe + T[_e] + S[_e] - Me - O.altAxis : ge,
                Le =
                  y && ve
                    ? (function (e, t, n) {
                        var i = q(e, t, n);
                        return i > n ? n : i;
                      })(be, fe, xe)
                    : q(y ? be : pe, fe, y ? xe : ge);
              (D[Y] = Le), (P[Y] = Le - fe);
            }
            t.modifiersData[o] = P;
          }
        },
        requiresIfExists: ["offset"],
      };
      function Ye(e, t, n) {
        void 0 === n && (n = !1);
        var i,
          a,
          r = j(t),
          l =
            j(t) &&
            (function (e) {
              var t = e.getBoundingClientRect(),
                n = P(t.width) / e.offsetWidth || 1,
                i = P(t.height) / e.offsetHeight || 1;
              return 1 !== n || 1 !== i;
            })(t),
          o = V(t),
          s = W(e, l, n),
          d = { scrollLeft: 0, scrollTop: 0 },
          u = { x: 0, y: 0 };
        return (
          (r || (!r && !n)) &&
            (("body" !== D(t) || ce(o)) &&
              (d =
                (i = t) !== T(i) && j(i)
                  ? { scrollLeft: (a = i).scrollLeft, scrollTop: a.scrollTop }
                  : de(i)),
            j(t)
              ? (((u = W(t, !0)).x += t.clientLeft), (u.y += t.clientTop))
              : o && (u.x = ue(o))),
          {
            x: s.left + d.scrollLeft - u.x,
            y: s.top + d.scrollTop - u.y,
            width: s.width,
            height: s.height,
          }
        );
      }
      function De(e) {
        var t = new Map(),
          n = new Set(),
          i = [];
        function a(e) {
          n.add(e.name),
            []
              .concat(e.requires || [], e.requiresIfExists || [])
              .forEach(function (e) {
                if (!n.has(e)) {
                  var i = t.get(e);
                  i && a(i);
                }
              }),
            i.push(e);
        }
        return (
          e.forEach(function (e) {
            t.set(e.name, e);
          }),
          e.forEach(function (e) {
            n.has(e.name) || a(e);
          }),
          i
        );
      }
      var Te = { placement: "bottom", modifiers: [], strategy: "absolute" };
      function Se() {
        for (var e = arguments.length, t = new Array(e), n = 0; n < e; n++)
          t[n] = arguments[n];
        return !t.some(function (e) {
          return !(e && "function" == typeof e.getBoundingClientRect);
        });
      }
      function je(e) {
        void 0 === e && (e = {});
        var t = e,
          n = t.defaultModifiers,
          i = void 0 === n ? [] : n,
          a = t.defaultOptions,
          r = void 0 === a ? Te : a;
        return function (e, t, n) {
          void 0 === n && (n = r);
          var a,
            l,
            o = {
              placement: "bottom",
              orderedModifiers: [],
              options: Object.assign({}, Te, r),
              modifiersData: {},
              elements: { reference: e, popper: t },
              attributes: {},
              styles: {},
            },
            s = [],
            d = !1,
            u = {
              state: o,
              setOptions: function (n) {
                var a = "function" == typeof n ? n(o.options) : n;
                c(),
                  (o.options = Object.assign({}, r, o.options, a)),
                  (o.scrollParents = {
                    reference: S(e)
                      ? me(e)
                      : e.contextElement
                      ? me(e.contextElement)
                      : [],
                    popper: me(t),
                  });
                var l,
                  d,
                  h = (function (e) {
                    var t = De(e);
                    return Y.reduce(function (e, n) {
                      return e.concat(
                        t.filter(function (e) {
                          return e.phase === n;
                        })
                      );
                    }, []);
                  })(
                    ((l = [].concat(i, o.options.modifiers)),
                    (d = l.reduce(function (e, t) {
                      var n = e[t.name];
                      return (
                        (e[t.name] = n
                          ? Object.assign({}, n, t, {
                              options: Object.assign({}, n.options, t.options),
                              data: Object.assign({}, n.data, t.data),
                            })
                          : t),
                        e
                      );
                    }, {})),
                    Object.keys(d).map(function (e) {
                      return d[e];
                    }))
                  );
                return (
                  (o.orderedModifiers = h.filter(function (e) {
                    return e.enabled;
                  })),
                  o.orderedModifiers.forEach(function (e) {
                    var t = e.name,
                      n = e.options,
                      i = void 0 === n ? {} : n,
                      a = e.effect;
                    if ("function" == typeof a) {
                      var r = a({ state: o, name: t, instance: u, options: i }),
                        l = function () {};
                      s.push(r || l);
                    }
                  }),
                  u.update()
                );
              },
              forceUpdate: function () {
                if (!d) {
                  var e = o.elements,
                    t = e.reference,
                    n = e.popper;
                  if (Se(t, n)) {
                    (o.rects = {
                      reference: Ye(t, $(n), "fixed" === o.options.strategy),
                      popper: z(n),
                    }),
                      (o.reset = !1),
                      (o.placement = o.options.placement),
                      o.orderedModifiers.forEach(function (e) {
                        return (o.modifiersData[e.name] = Object.assign(
                          {},
                          e.data
                        ));
                      });
                    for (var i = 0; i < o.orderedModifiers.length; i++)
                      if (!0 !== o.reset) {
                        var a = o.orderedModifiers[i],
                          r = a.fn,
                          l = a.options,
                          s = void 0 === l ? {} : l,
                          c = a.name;
                        "function" == typeof r &&
                          (o =
                            r({ state: o, options: s, name: c, instance: u }) ||
                            o);
                      } else (o.reset = !1), (i = -1);
                  }
                }
              },
              update:
                ((a = function () {
                  return new Promise(function (e) {
                    u.forceUpdate(), e(o);
                  });
                }),
                function () {
                  return (
                    l ||
                      (l = new Promise(function (e) {
                        Promise.resolve().then(function () {
                          (l = void 0), e(a());
                        });
                      })),
                    l
                  );
                }),
              destroy: function () {
                c(), (d = !0);
              },
            };
          if (!Se(e, t)) return u;
          function c() {
            s.forEach(function (e) {
              return e();
            }),
              (s = []);
          }
          return (
            u.setOptions(n).then(function (e) {
              !d && n.onFirstUpdate && n.onFirstUpdate(e);
            }),
            u
          );
        };
      }
      var Oe = je(),
        Ae = je({ defaultModifiers: [ae, we, ne, A, Le, ve, ke, K, xe] }),
        He = je({ defaultModifiers: [ae, we, ne, A] });
      const Ee = new Map(),
        Ce = {
          set(e, t, n) {
            Ee.has(e) || Ee.set(e, new Map());
            const i = Ee.get(e);
            i.has(t) || 0 === i.size
              ? i.set(t, n)
              : console.error(
                  `Bootstrap doesn't allow more than one instance per element. Bound instance: ${
                    Array.from(i.keys())[0]
                  }.`
                );
          },
          get(e, t) {
            return (Ee.has(e) && Ee.get(e).get(t)) || null;
          },
          remove(e, t) {
            if (!Ee.has(e)) return;
            const n = Ee.get(e);
            n.delete(t), 0 === n.size && Ee.delete(e);
          },
        },
        Pe = "transitionend",
        Fe = (e) => (
          e &&
            window.CSS &&
            window.CSS.escape &&
            (e = e.replace(/#([^\s"#']+)/g, (e, t) => `#${CSS.escape(t)}`)),
          e
        ),
        Ie = (e) => {
          e.dispatchEvent(new Event(Pe));
        },
        We = (e) =>
          !(!e || "object" != typeof e) &&
          (void 0 !== e.jquery && (e = e[0]), void 0 !== e.nodeType),
        ze = (e) =>
          We(e)
            ? e.jquery
              ? e[0]
              : e
            : "string" == typeof e && e.length > 0
            ? document.querySelector(Fe(e))
            : null,
        Ne = (e) => {
          if (!We(e) || 0 === e.getClientRects().length) return !1;
          const t =
              "visible" === getComputedStyle(e).getPropertyValue("visibility"),
            n = e.closest("details:not([open])");
          if (!n) return t;
          if (n !== e) {
            const t = e.closest("summary");
            if (t && t.parentNode !== n) return !1;
            if (null === t) return !1;
          }
          return t;
        },
        Re = (e) =>
          !e ||
          e.nodeType !== Node.ELEMENT_NODE ||
          !!e.classList.contains("disabled") ||
          (void 0 !== e.disabled
            ? e.disabled
            : e.hasAttribute("disabled") &&
              "false" !== e.getAttribute("disabled")),
        Be = (e) => {
          if (!document.documentElement.attachShadow) return null;
          if ("function" == typeof e.getRootNode) {
            const t = e.getRootNode();
            return t instanceof ShadowRoot ? t : null;
          }
          return e instanceof ShadowRoot
            ? e
            : e.parentNode
            ? Be(e.parentNode)
            : null;
        },
        Ve = () => {},
        Ze = (e) => {
          e.offsetHeight;
        },
        Ue = () =>
          window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")
            ? window.jQuery
            : null,
        $e = [],
        Je = () => "rtl" === document.documentElement.dir,
        qe = (e) => {
          var t;
          (t = () => {
            const t = Ue();
            if (t) {
              const n = e.NAME,
                i = t.fn[n];
              (t.fn[n] = e.jQueryInterface),
                (t.fn[n].Constructor = e),
                (t.fn[n].noConflict = () => ((t.fn[n] = i), e.jQueryInterface));
            }
          }),
            "loading" === document.readyState
              ? ($e.length ||
                  document.addEventListener("DOMContentLoaded", () => {
                    for (const e of $e) e();
                  }),
                $e.push(t))
              : t();
        },
        Ge = (e, t = [], n = e) => ("function" == typeof e ? e(...t) : n),
        Xe = (e, t, n = !0) => {
          if (!n) return void Ge(e);
          const i =
            ((e) => {
              if (!e) return 0;
              let { transitionDuration: t, transitionDelay: n } =
                window.getComputedStyle(e);
              const i = Number.parseFloat(t),
                a = Number.parseFloat(n);
              return i || a
                ? ((t = t.split(",")[0]),
                  (n = n.split(",")[0]),
                  1e3 * (Number.parseFloat(t) + Number.parseFloat(n)))
                : 0;
            })(t) + 5;
          let a = !1;
          const r = ({ target: n }) => {
            n === t && ((a = !0), t.removeEventListener(Pe, r), Ge(e));
          };
          t.addEventListener(Pe, r),
            setTimeout(() => {
              a || Ie(t);
            }, i);
        },
        Ke = (e, t, n, i) => {
          const a = e.length;
          let r = e.indexOf(t);
          return -1 === r
            ? !n && i
              ? e[a - 1]
              : e[0]
            : ((r += n ? 1 : -1),
              i && (r = (r + a) % a),
              e[Math.max(0, Math.min(r, a - 1))]);
        },
        Qe = /[^.]*(?=\..*)\.|.*/,
        et = /\..*/,
        tt = /::\d+$/,
        nt = {};
      let it = 1;
      const at = { mouseenter: "mouseover", mouseleave: "mouseout" },
        rt = new Set([
          "click",
          "dblclick",
          "mouseup",
          "mousedown",
          "contextmenu",
          "mousewheel",
          "DOMMouseScroll",
          "mouseover",
          "mouseout",
          "mousemove",
          "selectstart",
          "selectend",
          "keydown",
          "keypress",
          "keyup",
          "orientationchange",
          "touchstart",
          "touchmove",
          "touchend",
          "touchcancel",
          "pointerdown",
          "pointermove",
          "pointerup",
          "pointerleave",
          "pointercancel",
          "gesturestart",
          "gesturechange",
          "gestureend",
          "focus",
          "blur",
          "change",
          "reset",
          "select",
          "submit",
          "focusin",
          "focusout",
          "load",
          "unload",
          "beforeunload",
          "resize",
          "move",
          "DOMContentLoaded",
          "readystatechange",
          "error",
          "abort",
          "scroll",
        ]);
      function lt(e, t) {
        return (t && `${t}::${it++}`) || e.uidEvent || it++;
      }
      function ot(e) {
        const t = lt(e);
        return (e.uidEvent = t), (nt[t] = nt[t] || {}), nt[t];
      }
      function st(e, t, n = null) {
        return Object.values(e).find(
          (e) => e.callable === t && e.delegationSelector === n
        );
      }
      function dt(e, t, n) {
        const i = "string" == typeof t,
          a = i ? n : t || n;
        let r = mt(e);
        return rt.has(r) || (r = e), [i, a, r];
      }
      function ut(e, t, n, i, a) {
        if ("string" != typeof t || !e) return;
        let [r, l, o] = dt(t, n, i);
        if (t in at) {
          const e = (e) =>
            function (t) {
              if (
                !t.relatedTarget ||
                (t.relatedTarget !== t.delegateTarget &&
                  !t.delegateTarget.contains(t.relatedTarget))
              )
                return e.call(this, t);
            };
          l = e(l);
        }
        const s = ot(e),
          d = s[o] || (s[o] = {}),
          u = st(d, l, r ? n : null);
        if (u) return void (u.oneOff = u.oneOff && a);
        const c = lt(l, t.replace(Qe, "")),
          h = r
            ? (function (e, t, n) {
                return function i(a) {
                  const r = e.querySelectorAll(t);
                  for (let { target: l } = a; l && l !== this; l = l.parentNode)
                    for (const o of r)
                      if (o === l)
                        return (
                          _t(a, { delegateTarget: l }),
                          i.oneOff && ft.off(e, a.type, t, n),
                          n.apply(l, [a])
                        );
                };
              })(e, n, l)
            : (function (e, t) {
                return function n(i) {
                  return (
                    _t(i, { delegateTarget: e }),
                    n.oneOff && ft.off(e, i.type, t),
                    t.apply(e, [i])
                  );
                };
              })(e, l);
        (h.delegationSelector = r ? n : null),
          (h.callable = l),
          (h.oneOff = a),
          (h.uidEvent = c),
          (d[c] = h),
          e.addEventListener(o, h, r);
      }
      function ct(e, t, n, i, a) {
        const r = st(t[n], i, a);
        r && (e.removeEventListener(n, r, Boolean(a)), delete t[n][r.uidEvent]);
      }
      function ht(e, t, n, i) {
        const a = t[n] || {};
        for (const [r, l] of Object.entries(a))
          r.includes(i) && ct(e, t, n, l.callable, l.delegationSelector);
      }
      function mt(e) {
        return (e = e.replace(et, "")), at[e] || e;
      }
      const ft = {
        on(e, t, n, i) {
          ut(e, t, n, i, !1);
        },
        one(e, t, n, i) {
          ut(e, t, n, i, !0);
        },
        off(e, t, n, i) {
          if ("string" != typeof t || !e) return;
          const [a, r, l] = dt(t, n, i),
            o = l !== t,
            s = ot(e),
            d = s[l] || {},
            u = t.startsWith(".");
          if (void 0 === r) {
            if (u) for (const n of Object.keys(s)) ht(e, s, n, t.slice(1));
            for (const [n, i] of Object.entries(d)) {
              const a = n.replace(tt, "");
              (o && !t.includes(a)) ||
                ct(e, s, l, i.callable, i.delegationSelector);
            }
          } else {
            if (!Object.keys(d).length) return;
            ct(e, s, l, r, a ? n : null);
          }
        },
        trigger(e, t, n) {
          if ("string" != typeof t || !e) return null;
          const i = Ue();
          let a = null,
            r = !0,
            l = !0,
            o = !1;
          t !== mt(t) &&
            i &&
            ((a = i.Event(t, n)),
            i(e).trigger(a),
            (r = !a.isPropagationStopped()),
            (l = !a.isImmediatePropagationStopped()),
            (o = a.isDefaultPrevented()));
          const s = _t(new Event(t, { bubbles: r, cancelable: !0 }), n);
          return (
            o && s.preventDefault(),
            l && e.dispatchEvent(s),
            s.defaultPrevented && a && a.preventDefault(),
            s
          );
        },
      };
      function _t(e, t = {}) {
        for (const [n, i] of Object.entries(t))
          try {
            e[n] = i;
          } catch (t) {
            Object.defineProperty(e, n, {
              configurable: !0,
              get() {
                return i;
              },
            });
          }
        return e;
      }
      function pt(e) {
        if ("true" === e) return !0;
        if ("false" === e) return !1;
        if (e === Number(e).toString()) return Number(e);
        if ("" === e || "null" === e) return null;
        if ("string" != typeof e) return e;
        try {
          return JSON.parse(decodeURIComponent(e));
        } catch (t) {
          return e;
        }
      }
      function gt(e) {
        return e.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
      }
      const yt = {
        setDataAttribute(e, t, n) {
          e.setAttribute(`data-bs-${gt(t)}`, n);
        },
        removeDataAttribute(e, t) {
          e.removeAttribute(`data-bs-${gt(t)}`);
        },
        getDataAttributes(e) {
          if (!e) return {};
          const t = {},
            n = Object.keys(e.dataset).filter(
              (e) => e.startsWith("bs") && !e.startsWith("bsConfig")
            );
          for (const i of n) {
            let n = i.replace(/^bs/, "");
            (n = n.charAt(0).toLowerCase() + n.slice(1, n.length)),
              (t[n] = pt(e.dataset[i]));
          }
          return t;
        },
        getDataAttribute(e, t) {
          return pt(e.getAttribute(`data-bs-${gt(t)}`));
        },
      };
      class vt {
        static get Default() {
          return {};
        }
        static get DefaultType() {
          return {};
        }
        static get NAME() {
          throw new Error(
            'You have to implement the static method "NAME", for each component!'
          );
        }
        _getConfig(e) {
          return (
            (e = this._mergeConfigObj(e)),
            (e = this._configAfterMerge(e)),
            this._typeCheckConfig(e),
            e
          );
        }
        _configAfterMerge(e) {
          return e;
        }
        _mergeConfigObj(e, t) {
          const n = We(t) ? yt.getDataAttribute(t, "config") : {};
          return {
            ...this.constructor.Default,
            ...("object" == typeof n ? n : {}),
            ...(We(t) ? yt.getDataAttributes(t) : {}),
            ...("object" == typeof e ? e : {}),
          };
        }
        _typeCheckConfig(e, t = this.constructor.DefaultType) {
          for (const [i, a] of Object.entries(t)) {
            const t = e[i],
              r = We(t)
                ? "element"
                : null == (n = t)
                ? `${n}`
                : Object.prototype.toString
                    .call(n)
                    .match(/\s([a-z]+)/i)[1]
                    .toLowerCase();
            if (!new RegExp(a).test(r))
              throw new TypeError(
                `${this.constructor.NAME.toUpperCase()}: Option "${i}" provided type "${r}" but expected type "${a}".`
              );
          }
          var n;
        }
      }
      class Mt extends vt {
        constructor(e, t) {
          super(),
            (e = ze(e)) &&
              ((this._element = e),
              (this._config = this._getConfig(t)),
              Ce.set(this._element, this.constructor.DATA_KEY, this));
        }
        dispose() {
          Ce.remove(this._element, this.constructor.DATA_KEY),
            ft.off(this._element, this.constructor.EVENT_KEY);
          for (const e of Object.getOwnPropertyNames(this)) this[e] = null;
        }
        _queueCallback(e, t, n = !0) {
          Xe(e, t, n);
        }
        _getConfig(e) {
          return (
            (e = this._mergeConfigObj(e, this._element)),
            (e = this._configAfterMerge(e)),
            this._typeCheckConfig(e),
            e
          );
        }
        static getInstance(e) {
          return Ce.get(ze(e), this.DATA_KEY);
        }
        static getOrCreateInstance(e, t = {}) {
          return (
            this.getInstance(e) || new this(e, "object" == typeof t ? t : null)
          );
        }
        static get VERSION() {
          return "5.3.0";
        }
        static get DATA_KEY() {
          return `bs.${this.NAME}`;
        }
        static get EVENT_KEY() {
          return `.${this.DATA_KEY}`;
        }
        static eventName(e) {
          return `${e}${this.EVENT_KEY}`;
        }
      }
      const bt = (e) => {
          let t = e.getAttribute("data-bs-target");
          if (!t || "#" === t) {
            let n = e.getAttribute("href");
            if (!n || (!n.includes("#") && !n.startsWith("."))) return null;
            n.includes("#") &&
              !n.startsWith("#") &&
              (n = `#${n.split("#")[1]}`),
              (t = n && "#" !== n ? n.trim() : null);
          }
          return Fe(t);
        },
        xt = {
          find(e, t = document.documentElement) {
            return [].concat(...Element.prototype.querySelectorAll.call(t, e));
          },
          findOne(e, t = document.documentElement) {
            return Element.prototype.querySelector.call(t, e);
          },
          children(e, t) {
            return [].concat(...e.children).filter((e) => e.matches(t));
          },
          parents(e, t) {
            const n = [];
            let i = e.parentNode.closest(t);
            for (; i; ) n.push(i), (i = i.parentNode.closest(t));
            return n;
          },
          prev(e, t) {
            let n = e.previousElementSibling;
            for (; n; ) {
              if (n.matches(t)) return [n];
              n = n.previousElementSibling;
            }
            return [];
          },
          next(e, t) {
            let n = e.nextElementSibling;
            for (; n; ) {
              if (n.matches(t)) return [n];
              n = n.nextElementSibling;
            }
            return [];
          },
          focusableChildren(e) {
            const t = [
              "a",
              "button",
              "input",
              "textarea",
              "select",
              "details",
              "[tabindex]",
              '[contenteditable="true"]',
            ]
              .map((e) => `${e}:not([tabindex^="-"])`)
              .join(",");
            return this.find(t, e).filter((e) => !Re(e) && Ne(e));
          },
          getSelectorFromElement(e) {
            const t = bt(e);
            return t && xt.findOne(t) ? t : null;
          },
          getElementFromSelector(e) {
            const t = bt(e);
            return t ? xt.findOne(t) : null;
          },
          getMultipleElementsFromSelector(e) {
            const t = bt(e);
            return t ? xt.find(t) : [];
          },
        },
        Lt = (e, t = "hide") => {
          const n = `click.dismiss${e.EVENT_KEY}`,
            i = e.NAME;
          ft.on(document, n, `[data-bs-dismiss="${i}"]`, function (n) {
            if (
              (["A", "AREA"].includes(this.tagName) && n.preventDefault(),
              Re(this))
            )
              return;
            const a = xt.getElementFromSelector(this) || this.closest(`.${i}`);
            e.getOrCreateInstance(a)[t]();
          });
        },
        wt = ".bs.alert",
        kt = `close${wt}`,
        Yt = `closed${wt}`;
      class Dt extends Mt {
        static get NAME() {
          return "alert";
        }
        close() {
          if (ft.trigger(this._element, kt).defaultPrevented) return;
          this._element.classList.remove("show");
          const e = this._element.classList.contains("fade");
          this._queueCallback(() => this._destroyElement(), this._element, e);
        }
        _destroyElement() {
          this._element.remove(), ft.trigger(this._element, Yt), this.dispose();
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = Dt.getOrCreateInstance(this);
            if ("string" == typeof e) {
              if (void 0 === t[e] || e.startsWith("_") || "constructor" === e)
                throw new TypeError(`No method named "${e}"`);
              t[e](this);
            }
          });
        }
      }
      Lt(Dt, "close"), qe(Dt);
      const Tt = '[data-bs-toggle="button"]';
      class St extends Mt {
        static get NAME() {
          return "button";
        }
        toggle() {
          this._element.setAttribute(
            "aria-pressed",
            this._element.classList.toggle("active")
          );
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = St.getOrCreateInstance(this);
            "toggle" === e && t[e]();
          });
        }
      }
      ft.on(document, "click.bs.button.data-api", Tt, (e) => {
        e.preventDefault();
        const t = e.target.closest(Tt);
        St.getOrCreateInstance(t).toggle();
      }),
        qe(St);
      const jt = ".bs.swipe",
        Ot = `touchstart${jt}`,
        At = `touchmove${jt}`,
        Ht = `touchend${jt}`,
        Et = `pointerdown${jt}`,
        Ct = `pointerup${jt}`,
        Pt = { endCallback: null, leftCallback: null, rightCallback: null },
        Ft = {
          endCallback: "(function|null)",
          leftCallback: "(function|null)",
          rightCallback: "(function|null)",
        };
      class It extends vt {
        constructor(e, t) {
          super(),
            (this._element = e),
            e &&
              It.isSupported() &&
              ((this._config = this._getConfig(t)),
              (this._deltaX = 0),
              (this._supportPointerEvents = Boolean(window.PointerEvent)),
              this._initEvents());
        }
        static get Default() {
          return Pt;
        }
        static get DefaultType() {
          return Ft;
        }
        static get NAME() {
          return "swipe";
        }
        dispose() {
          ft.off(this._element, jt);
        }
        _start(e) {
          this._supportPointerEvents
            ? this._eventIsPointerPenTouch(e) && (this._deltaX = e.clientX)
            : (this._deltaX = e.touches[0].clientX);
        }
        _end(e) {
          this._eventIsPointerPenTouch(e) &&
            (this._deltaX = e.clientX - this._deltaX),
            this._handleSwipe(),
            Ge(this._config.endCallback);
        }
        _move(e) {
          this._deltaX =
            e.touches && e.touches.length > 1
              ? 0
              : e.touches[0].clientX - this._deltaX;
        }
        _handleSwipe() {
          const e = Math.abs(this._deltaX);
          if (e <= 40) return;
          const t = e / this._deltaX;
          (this._deltaX = 0),
            t &&
              Ge(
                t > 0 ? this._config.rightCallback : this._config.leftCallback
              );
        }
        _initEvents() {
          this._supportPointerEvents
            ? (ft.on(this._element, Et, (e) => this._start(e)),
              ft.on(this._element, Ct, (e) => this._end(e)),
              this._element.classList.add("pointer-event"))
            : (ft.on(this._element, Ot, (e) => this._start(e)),
              ft.on(this._element, At, (e) => this._move(e)),
              ft.on(this._element, Ht, (e) => this._end(e)));
        }
        _eventIsPointerPenTouch(e) {
          return (
            this._supportPointerEvents &&
            ("pen" === e.pointerType || "touch" === e.pointerType)
          );
        }
        static isSupported() {
          return (
            "ontouchstart" in document.documentElement ||
            navigator.maxTouchPoints > 0
          );
        }
      }
      const Wt = ".bs.carousel",
        zt = ".data-api",
        Nt = "ArrowLeft",
        Rt = "ArrowRight",
        Bt = "next",
        Vt = "prev",
        Zt = "left",
        Ut = "right",
        $t = `slide${Wt}`,
        Jt = `slid${Wt}`,
        qt = `keydown${Wt}`,
        Gt = `mouseenter${Wt}`,
        Xt = `mouseleave${Wt}`,
        Kt = `dragstart${Wt}`,
        Qt = `load${Wt}${zt}`,
        en = `click${Wt}${zt}`,
        tn = "carousel",
        nn = "active",
        an = ".active",
        rn = ".carousel-item",
        ln = an + rn,
        on = { [Nt]: Ut, [Rt]: Zt },
        sn = {
          interval: 5e3,
          keyboard: !0,
          pause: "hover",
          ride: !1,
          touch: !0,
          wrap: !0,
        },
        dn = {
          interval: "(number|boolean)",
          keyboard: "boolean",
          pause: "(string|boolean)",
          ride: "(boolean|string)",
          touch: "boolean",
          wrap: "boolean",
        };
      class un extends Mt {
        constructor(e, t) {
          super(e, t),
            (this._interval = null),
            (this._activeElement = null),
            (this._isSliding = !1),
            (this.touchTimeout = null),
            (this._swipeHelper = null),
            (this._indicatorsElement = xt.findOne(
              ".carousel-indicators",
              this._element
            )),
            this._addEventListeners(),
            this._config.ride === tn && this.cycle();
        }
        static get Default() {
          return sn;
        }
        static get DefaultType() {
          return dn;
        }
        static get NAME() {
          return "carousel";
        }
        next() {
          this._slide(Bt);
        }
        nextWhenVisible() {
          !document.hidden && Ne(this._element) && this.next();
        }
        prev() {
          this._slide(Vt);
        }
        pause() {
          this._isSliding && Ie(this._element), this._clearInterval();
        }
        cycle() {
          this._clearInterval(),
            this._updateInterval(),
            (this._interval = setInterval(
              () => this.nextWhenVisible(),
              this._config.interval
            ));
        }
        _maybeEnableCycle() {
          this._config.ride &&
            (this._isSliding
              ? ft.one(this._element, Jt, () => this.cycle())
              : this.cycle());
        }
        to(e) {
          const t = this._getItems();
          if (e > t.length - 1 || e < 0) return;
          if (this._isSliding)
            return void ft.one(this._element, Jt, () => this.to(e));
          const n = this._getItemIndex(this._getActive());
          if (n === e) return;
          const i = e > n ? Bt : Vt;
          this._slide(i, t[e]);
        }
        dispose() {
          this._swipeHelper && this._swipeHelper.dispose(), super.dispose();
        }
        _configAfterMerge(e) {
          return (e.defaultInterval = e.interval), e;
        }
        _addEventListeners() {
          this._config.keyboard &&
            ft.on(this._element, qt, (e) => this._keydown(e)),
            "hover" === this._config.pause &&
              (ft.on(this._element, Gt, () => this.pause()),
              ft.on(this._element, Xt, () => this._maybeEnableCycle())),
            this._config.touch &&
              It.isSupported() &&
              this._addTouchEventListeners();
        }
        _addTouchEventListeners() {
          for (const e of xt.find(".carousel-item img", this._element))
            ft.on(e, Kt, (e) => e.preventDefault());
          const e = {
            leftCallback: () => this._slide(this._directionToOrder(Zt)),
            rightCallback: () => this._slide(this._directionToOrder(Ut)),
            endCallback: () => {
              "hover" === this._config.pause &&
                (this.pause(),
                this.touchTimeout && clearTimeout(this.touchTimeout),
                (this.touchTimeout = setTimeout(
                  () => this._maybeEnableCycle(),
                  500 + this._config.interval
                )));
            },
          };
          this._swipeHelper = new It(this._element, e);
        }
        _keydown(e) {
          if (/input|textarea/i.test(e.target.tagName)) return;
          const t = on[e.key];
          t && (e.preventDefault(), this._slide(this._directionToOrder(t)));
        }
        _getItemIndex(e) {
          return this._getItems().indexOf(e);
        }
        _setActiveIndicatorElement(e) {
          if (!this._indicatorsElement) return;
          const t = xt.findOne(an, this._indicatorsElement);
          t.classList.remove(nn), t.removeAttribute("aria-current");
          const n = xt.findOne(
            `[data-bs-slide-to="${e}"]`,
            this._indicatorsElement
          );
          n && (n.classList.add(nn), n.setAttribute("aria-current", "true"));
        }
        _updateInterval() {
          const e = this._activeElement || this._getActive();
          if (!e) return;
          const t = Number.parseInt(e.getAttribute("data-bs-interval"), 10);
          this._config.interval = t || this._config.defaultInterval;
        }
        _slide(e, t = null) {
          if (this._isSliding) return;
          const n = this._getActive(),
            i = e === Bt,
            a = t || Ke(this._getItems(), n, i, this._config.wrap);
          if (a === n) return;
          const r = this._getItemIndex(a),
            l = (t) =>
              ft.trigger(this._element, t, {
                relatedTarget: a,
                direction: this._orderToDirection(e),
                from: this._getItemIndex(n),
                to: r,
              });
          if (l($t).defaultPrevented) return;
          if (!n || !a) return;
          const o = Boolean(this._interval);
          this.pause(),
            (this._isSliding = !0),
            this._setActiveIndicatorElement(r),
            (this._activeElement = a);
          const s = i ? "carousel-item-start" : "carousel-item-end",
            d = i ? "carousel-item-next" : "carousel-item-prev";
          a.classList.add(d), Ze(a), n.classList.add(s), a.classList.add(s);
          this._queueCallback(
            () => {
              a.classList.remove(s, d),
                a.classList.add(nn),
                n.classList.remove(nn, d, s),
                (this._isSliding = !1),
                l(Jt);
            },
            n,
            this._isAnimated()
          ),
            o && this.cycle();
        }
        _isAnimated() {
          return this._element.classList.contains("slide");
        }
        _getActive() {
          return xt.findOne(ln, this._element);
        }
        _getItems() {
          return xt.find(rn, this._element);
        }
        _clearInterval() {
          this._interval &&
            (clearInterval(this._interval), (this._interval = null));
        }
        _directionToOrder(e) {
          return Je() ? (e === Zt ? Vt : Bt) : e === Zt ? Bt : Vt;
        }
        _orderToDirection(e) {
          return Je() ? (e === Vt ? Zt : Ut) : e === Vt ? Ut : Zt;
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = un.getOrCreateInstance(this, e);
            if ("number" != typeof e) {
              if ("string" == typeof e) {
                if (void 0 === t[e] || e.startsWith("_") || "constructor" === e)
                  throw new TypeError(`No method named "${e}"`);
                t[e]();
              }
            } else t.to(e);
          });
        }
      }
      ft.on(document, en, "[data-bs-slide], [data-bs-slide-to]", function (e) {
        const t = xt.getElementFromSelector(this);
        if (!t || !t.classList.contains(tn)) return;
        e.preventDefault();
        const n = un.getOrCreateInstance(t),
          i = this.getAttribute("data-bs-slide-to");
        return i
          ? (n.to(i), void n._maybeEnableCycle())
          : "next" === yt.getDataAttribute(this, "slide")
          ? (n.next(), void n._maybeEnableCycle())
          : (n.prev(), void n._maybeEnableCycle());
      }),
        ft.on(window, Qt, () => {
          const e = xt.find('[data-bs-ride="carousel"]');
          for (const t of e) un.getOrCreateInstance(t);
        }),
        qe(un);
      const cn = ".bs.collapse",
        hn = `show${cn}`,
        mn = `shown${cn}`,
        fn = `hide${cn}`,
        _n = `hidden${cn}`,
        pn = `click${cn}.data-api`,
        gn = "show",
        yn = "collapse",
        vn = "collapsing",
        Mn = `:scope .${yn} .${yn}`,
        bn = '[data-bs-toggle="collapse"]',
        xn = { parent: null, toggle: !0 },
        Ln = { parent: "(null|element)", toggle: "boolean" };
      class wn extends Mt {
        constructor(e, t) {
          super(e, t), (this._isTransitioning = !1), (this._triggerArray = []);
          const n = xt.find(bn);
          for (const e of n) {
            const t = xt.getSelectorFromElement(e),
              n = xt.find(t).filter((e) => e === this._element);
            null !== t && n.length && this._triggerArray.push(e);
          }
          this._initializeChildren(),
            this._config.parent ||
              this._addAriaAndCollapsedClass(
                this._triggerArray,
                this._isShown()
              ),
            this._config.toggle && this.toggle();
        }
        static get Default() {
          return xn;
        }
        static get DefaultType() {
          return Ln;
        }
        static get NAME() {
          return "collapse";
        }
        toggle() {
          this._isShown() ? this.hide() : this.show();
        }
        show() {
          if (this._isTransitioning || this._isShown()) return;
          let e = [];
          if (
            (this._config.parent &&
              (e = this._getFirstLevelChildren(
                ".collapse.show, .collapse.collapsing"
              )
                .filter((e) => e !== this._element)
                .map((e) => wn.getOrCreateInstance(e, { toggle: !1 }))),
            e.length && e[0]._isTransitioning)
          )
            return;
          if (ft.trigger(this._element, hn).defaultPrevented) return;
          for (const t of e) t.hide();
          const t = this._getDimension();
          this._element.classList.remove(yn),
            this._element.classList.add(vn),
            (this._element.style[t] = 0),
            this._addAriaAndCollapsedClass(this._triggerArray, !0),
            (this._isTransitioning = !0);
          const n = `scroll${t[0].toUpperCase() + t.slice(1)}`;
          this._queueCallback(
            () => {
              (this._isTransitioning = !1),
                this._element.classList.remove(vn),
                this._element.classList.add(yn, gn),
                (this._element.style[t] = ""),
                ft.trigger(this._element, mn);
            },
            this._element,
            !0
          ),
            (this._element.style[t] = `${this._element[n]}px`);
        }
        hide() {
          if (this._isTransitioning || !this._isShown()) return;
          if (ft.trigger(this._element, fn).defaultPrevented) return;
          const e = this._getDimension();
          (this._element.style[e] = `${
            this._element.getBoundingClientRect()[e]
          }px`),
            Ze(this._element),
            this._element.classList.add(vn),
            this._element.classList.remove(yn, gn);
          for (const e of this._triggerArray) {
            const t = xt.getElementFromSelector(e);
            t && !this._isShown(t) && this._addAriaAndCollapsedClass([e], !1);
          }
          this._isTransitioning = !0;
          (this._element.style[e] = ""),
            this._queueCallback(
              () => {
                (this._isTransitioning = !1),
                  this._element.classList.remove(vn),
                  this._element.classList.add(yn),
                  ft.trigger(this._element, _n);
              },
              this._element,
              !0
            );
        }
        _isShown(e = this._element) {
          return e.classList.contains(gn);
        }
        _configAfterMerge(e) {
          return (e.toggle = Boolean(e.toggle)), (e.parent = ze(e.parent)), e;
        }
        _getDimension() {
          return this._element.classList.contains("collapse-horizontal")
            ? "width"
            : "height";
        }
        _initializeChildren() {
          if (!this._config.parent) return;
          const e = this._getFirstLevelChildren(bn);
          for (const t of e) {
            const e = xt.getElementFromSelector(t);
            e && this._addAriaAndCollapsedClass([t], this._isShown(e));
          }
        }
        _getFirstLevelChildren(e) {
          const t = xt.find(Mn, this._config.parent);
          return xt.find(e, this._config.parent).filter((e) => !t.includes(e));
        }
        _addAriaAndCollapsedClass(e, t) {
          if (e.length)
            for (const n of e)
              n.classList.toggle("collapsed", !t),
                n.setAttribute("aria-expanded", t);
        }
        static jQueryInterface(e) {
          const t = {};
          return (
            "string" == typeof e && /show|hide/.test(e) && (t.toggle = !1),
            this.each(function () {
              const n = wn.getOrCreateInstance(this, t);
              if ("string" == typeof e) {
                if (void 0 === n[e])
                  throw new TypeError(`No method named "${e}"`);
                n[e]();
              }
            })
          );
        }
      }
      ft.on(document, pn, bn, function (e) {
        ("A" === e.target.tagName ||
          (e.delegateTarget && "A" === e.delegateTarget.tagName)) &&
          e.preventDefault();
        for (const e of xt.getMultipleElementsFromSelector(this))
          wn.getOrCreateInstance(e, { toggle: !1 }).toggle();
      }),
        qe(wn);
      const kn = "dropdown",
        Yn = ".bs.dropdown",
        Dn = ".data-api",
        Tn = "ArrowUp",
        Sn = "ArrowDown",
        jn = `hide${Yn}`,
        On = `hidden${Yn}`,
        An = `show${Yn}`,
        Hn = `shown${Yn}`,
        En = `click${Yn}${Dn}`,
        Cn = `keydown${Yn}${Dn}`,
        Pn = `keyup${Yn}${Dn}`,
        Fn = "show",
        In = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)',
        Wn = `${In}.${Fn}`,
        zn = ".dropdown-menu",
        Nn = Je() ? "top-end" : "top-start",
        Rn = Je() ? "top-start" : "top-end",
        Bn = Je() ? "bottom-end" : "bottom-start",
        Vn = Je() ? "bottom-start" : "bottom-end",
        Zn = Je() ? "left-start" : "right-start",
        Un = Je() ? "right-start" : "left-start",
        $n = {
          autoClose: !0,
          boundary: "clippingParents",
          display: "dynamic",
          offset: [0, 2],
          popperConfig: null,
          reference: "toggle",
        },
        Jn = {
          autoClose: "(boolean|string)",
          boundary: "(string|element)",
          display: "string",
          offset: "(array|string|function)",
          popperConfig: "(null|object|function)",
          reference: "(string|element|object)",
        };
      class qn extends Mt {
        constructor(e, t) {
          super(e, t),
            (this._popper = null),
            (this._parent = this._element.parentNode),
            (this._menu =
              xt.next(this._element, zn)[0] ||
              xt.prev(this._element, zn)[0] ||
              xt.findOne(zn, this._parent)),
            (this._inNavbar = this._detectNavbar());
        }
        static get Default() {
          return $n;
        }
        static get DefaultType() {
          return Jn;
        }
        static get NAME() {
          return kn;
        }
        toggle() {
          return this._isShown() ? this.hide() : this.show();
        }
        show() {
          if (Re(this._element) || this._isShown()) return;
          const e = { relatedTarget: this._element };
          if (!ft.trigger(this._element, An, e).defaultPrevented) {
            if (
              (this._createPopper(),
              "ontouchstart" in document.documentElement &&
                !this._parent.closest(".navbar-nav"))
            )
              for (const e of [].concat(...document.body.children))
                ft.on(e, "mouseover", Ve);
            this._element.focus(),
              this._element.setAttribute("aria-expanded", !0),
              this._menu.classList.add(Fn),
              this._element.classList.add(Fn),
              ft.trigger(this._element, Hn, e);
          }
        }
        hide() {
          if (Re(this._element) || !this._isShown()) return;
          const e = { relatedTarget: this._element };
          this._completeHide(e);
        }
        dispose() {
          this._popper && this._popper.destroy(), super.dispose();
        }
        update() {
          (this._inNavbar = this._detectNavbar()),
            this._popper && this._popper.update();
        }
        _completeHide(e) {
          if (!ft.trigger(this._element, jn, e).defaultPrevented) {
            if ("ontouchstart" in document.documentElement)
              for (const e of [].concat(...document.body.children))
                ft.off(e, "mouseover", Ve);
            this._popper && this._popper.destroy(),
              this._menu.classList.remove(Fn),
              this._element.classList.remove(Fn),
              this._element.setAttribute("aria-expanded", "false"),
              yt.removeDataAttribute(this._menu, "popper"),
              ft.trigger(this._element, On, e);
          }
        }
        _getConfig(e) {
          if (
            "object" == typeof (e = super._getConfig(e)).reference &&
            !We(e.reference) &&
            "function" != typeof e.reference.getBoundingClientRect
          )
            throw new TypeError(
              `${kn.toUpperCase()}: Option "reference" provided type "object" without a required "getBoundingClientRect" method.`
            );
          return e;
        }
        _createPopper() {
          if (void 0 === e)
            throw new TypeError(
              "Bootstrap's dropdowns require Popper (https://popper.js.org)"
            );
          let t = this._element;
          "parent" === this._config.reference
            ? (t = this._parent)
            : We(this._config.reference)
            ? (t = ze(this._config.reference))
            : "object" == typeof this._config.reference &&
              (t = this._config.reference);
          const n = this._getPopperConfig();
          this._popper = Ae(t, this._menu, n);
        }
        _isShown() {
          return this._menu.classList.contains(Fn);
        }
        _getPlacement() {
          const e = this._parent;
          if (e.classList.contains("dropend")) return Zn;
          if (e.classList.contains("dropstart")) return Un;
          if (e.classList.contains("dropup-center")) return "top";
          if (e.classList.contains("dropdown-center")) return "bottom";
          const t =
            "end" ===
            getComputedStyle(this._menu)
              .getPropertyValue("--bs-position")
              .trim();
          return e.classList.contains("dropup") ? (t ? Rn : Nn) : t ? Vn : Bn;
        }
        _detectNavbar() {
          return null !== this._element.closest(".navbar");
        }
        _getOffset() {
          const { offset: e } = this._config;
          return "string" == typeof e
            ? e.split(",").map((e) => Number.parseInt(e, 10))
            : "function" == typeof e
            ? (t) => e(t, this._element)
            : e;
        }
        _getPopperConfig() {
          const e = {
            placement: this._getPlacement(),
            modifiers: [
              {
                name: "preventOverflow",
                options: { boundary: this._config.boundary },
              },
              { name: "offset", options: { offset: this._getOffset() } },
            ],
          };
          return (
            (this._inNavbar || "static" === this._config.display) &&
              (yt.setDataAttribute(this._menu, "popper", "static"),
              (e.modifiers = [{ name: "applyStyles", enabled: !1 }])),
            { ...e, ...Ge(this._config.popperConfig, [e]) }
          );
        }
        _selectMenuItem({ key: e, target: t }) {
          const n = xt
            .find(
              ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)",
              this._menu
            )
            .filter((e) => Ne(e));
          n.length && Ke(n, t, e === Sn, !n.includes(t)).focus();
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = qn.getOrCreateInstance(this, e);
            if ("string" == typeof e) {
              if (void 0 === t[e])
                throw new TypeError(`No method named "${e}"`);
              t[e]();
            }
          });
        }
        static clearMenus(e) {
          if (2 === e.button || ("keyup" === e.type && "Tab" !== e.key)) return;
          const t = xt.find(Wn);
          for (const n of t) {
            const t = qn.getInstance(n);
            if (!t || !1 === t._config.autoClose) continue;
            const i = e.composedPath(),
              a = i.includes(t._menu);
            if (
              i.includes(t._element) ||
              ("inside" === t._config.autoClose && !a) ||
              ("outside" === t._config.autoClose && a)
            )
              continue;
            if (
              t._menu.contains(e.target) &&
              (("keyup" === e.type && "Tab" === e.key) ||
                /input|select|option|textarea|form/i.test(e.target.tagName))
            )
              continue;
            const r = { relatedTarget: t._element };
            "click" === e.type && (r.clickEvent = e), t._completeHide(r);
          }
        }
        static dataApiKeydownHandler(e) {
          const t = /input|textarea/i.test(e.target.tagName),
            n = "Escape" === e.key,
            i = [Tn, Sn].includes(e.key);
          if (!i && !n) return;
          if (t && !n) return;
          e.preventDefault();
          const a = this.matches(In)
              ? this
              : xt.prev(this, In)[0] ||
                xt.next(this, In)[0] ||
                xt.findOne(In, e.delegateTarget.parentNode),
            r = qn.getOrCreateInstance(a);
          if (i)
            return e.stopPropagation(), r.show(), void r._selectMenuItem(e);
          r._isShown() && (e.stopPropagation(), r.hide(), a.focus());
        }
      }
      ft.on(document, Cn, In, qn.dataApiKeydownHandler),
        ft.on(document, Cn, zn, qn.dataApiKeydownHandler),
        ft.on(document, En, qn.clearMenus),
        ft.on(document, Pn, qn.clearMenus),
        ft.on(document, En, In, function (e) {
          e.preventDefault(), qn.getOrCreateInstance(this).toggle();
        }),
        qe(qn);
      const Gn = "backdrop",
        Xn = "show",
        Kn = `mousedown.bs.${Gn}`,
        Qn = {
          className: "modal-backdrop",
          clickCallback: null,
          isAnimated: !1,
          isVisible: !0,
          rootElement: "body",
        },
        ei = {
          className: "string",
          clickCallback: "(function|null)",
          isAnimated: "boolean",
          isVisible: "boolean",
          rootElement: "(element|string)",
        };
      class ti extends vt {
        constructor(e) {
          super(),
            (this._config = this._getConfig(e)),
            (this._isAppended = !1),
            (this._element = null);
        }
        static get Default() {
          return Qn;
        }
        static get DefaultType() {
          return ei;
        }
        static get NAME() {
          return Gn;
        }
        show(e) {
          if (!this._config.isVisible) return void Ge(e);
          this._append();
          const t = this._getElement();
          this._config.isAnimated && Ze(t),
            t.classList.add(Xn),
            this._emulateAnimation(() => {
              Ge(e);
            });
        }
        hide(e) {
          this._config.isVisible
            ? (this._getElement().classList.remove(Xn),
              this._emulateAnimation(() => {
                this.dispose(), Ge(e);
              }))
            : Ge(e);
        }
        dispose() {
          this._isAppended &&
            (ft.off(this._element, Kn),
            this._element.remove(),
            (this._isAppended = !1));
        }
        _getElement() {
          if (!this._element) {
            const e = document.createElement("div");
            (e.className = this._config.className),
              this._config.isAnimated && e.classList.add("fade"),
              (this._element = e);
          }
          return this._element;
        }
        _configAfterMerge(e) {
          return (e.rootElement = ze(e.rootElement)), e;
        }
        _append() {
          if (this._isAppended) return;
          const e = this._getElement();
          this._config.rootElement.append(e),
            ft.on(e, Kn, () => {
              Ge(this._config.clickCallback);
            }),
            (this._isAppended = !0);
        }
        _emulateAnimation(e) {
          Xe(e, this._getElement(), this._config.isAnimated);
        }
      }
      const ni = ".bs.focustrap",
        ii = `focusin${ni}`,
        ai = `keydown.tab${ni}`,
        ri = "backward",
        li = { autofocus: !0, trapElement: null },
        oi = { autofocus: "boolean", trapElement: "element" };
      class si extends vt {
        constructor(e) {
          super(),
            (this._config = this._getConfig(e)),
            (this._isActive = !1),
            (this._lastTabNavDirection = null);
        }
        static get Default() {
          return li;
        }
        static get DefaultType() {
          return oi;
        }
        static get NAME() {
          return "focustrap";
        }
        activate() {
          this._isActive ||
            (this._config.autofocus && this._config.trapElement.focus(),
            ft.off(document, ni),
            ft.on(document, ii, (e) => this._handleFocusin(e)),
            ft.on(document, ai, (e) => this._handleKeydown(e)),
            (this._isActive = !0));
        }
        deactivate() {
          this._isActive && ((this._isActive = !1), ft.off(document, ni));
        }
        _handleFocusin(e) {
          const { trapElement: t } = this._config;
          if (e.target === document || e.target === t || t.contains(e.target))
            return;
          const n = xt.focusableChildren(t);
          0 === n.length
            ? t.focus()
            : this._lastTabNavDirection === ri
            ? n[n.length - 1].focus()
            : n[0].focus();
        }
        _handleKeydown(e) {
          "Tab" === e.key &&
            (this._lastTabNavDirection = e.shiftKey ? ri : "forward");
        }
      }
      const di = ".fixed-top, .fixed-bottom, .is-fixed, .sticky-top",
        ui = ".sticky-top",
        ci = "padding-right",
        hi = "margin-right";
      class mi {
        constructor() {
          this._element = document.body;
        }
        getWidth() {
          const e = document.documentElement.clientWidth;
          return Math.abs(window.innerWidth - e);
        }
        hide() {
          const e = this.getWidth();
          this._disableOverFlow(),
            this._setElementAttributes(this._element, ci, (t) => t + e),
            this._setElementAttributes(di, ci, (t) => t + e),
            this._setElementAttributes(ui, hi, (t) => t - e);
        }
        reset() {
          this._resetElementAttributes(this._element, "overflow"),
            this._resetElementAttributes(this._element, ci),
            this._resetElementAttributes(di, ci),
            this._resetElementAttributes(ui, hi);
        }
        isOverflowing() {
          return this.getWidth() > 0;
        }
        _disableOverFlow() {
          this._saveInitialAttribute(this._element, "overflow"),
            (this._element.style.overflow = "hidden");
        }
        _setElementAttributes(e, t, n) {
          const i = this.getWidth();
          this._applyManipulationCallback(e, (e) => {
            if (e !== this._element && window.innerWidth > e.clientWidth + i)
              return;
            this._saveInitialAttribute(e, t);
            const a = window.getComputedStyle(e).getPropertyValue(t);
            e.style.setProperty(t, `${n(Number.parseFloat(a))}px`);
          });
        }
        _saveInitialAttribute(e, t) {
          const n = e.style.getPropertyValue(t);
          n && yt.setDataAttribute(e, t, n);
        }
        _resetElementAttributes(e, t) {
          this._applyManipulationCallback(e, (e) => {
            const n = yt.getDataAttribute(e, t);
            null !== n
              ? (yt.removeDataAttribute(e, t), e.style.setProperty(t, n))
              : e.style.removeProperty(t);
          });
        }
        _applyManipulationCallback(e, t) {
          if (We(e)) t(e);
          else for (const n of xt.find(e, this._element)) t(n);
        }
      }
      const fi = ".bs.modal",
        _i = `hide${fi}`,
        pi = `hidePrevented${fi}`,
        gi = `hidden${fi}`,
        yi = `show${fi}`,
        vi = `shown${fi}`,
        Mi = `resize${fi}`,
        bi = `click.dismiss${fi}`,
        xi = `mousedown.dismiss${fi}`,
        Li = `keydown.dismiss${fi}`,
        wi = `click${fi}.data-api`,
        ki = "modal-open",
        Yi = "show",
        Di = "modal-static",
        Ti = { backdrop: !0, focus: !0, keyboard: !0 },
        Si = {
          backdrop: "(boolean|string)",
          focus: "boolean",
          keyboard: "boolean",
        };
      class ji extends Mt {
        constructor(e, t) {
          super(e, t),
            (this._dialog = xt.findOne(".modal-dialog", this._element)),
            (this._backdrop = this._initializeBackDrop()),
            (this._focustrap = this._initializeFocusTrap()),
            (this._isShown = !1),
            (this._isTransitioning = !1),
            (this._scrollBar = new mi()),
            this._addEventListeners();
        }
        static get Default() {
          return Ti;
        }
        static get DefaultType() {
          return Si;
        }
        static get NAME() {
          return "modal";
        }
        toggle(e) {
          return this._isShown ? this.hide() : this.show(e);
        }
        show(e) {
          if (this._isShown || this._isTransitioning) return;
          ft.trigger(this._element, yi, { relatedTarget: e })
            .defaultPrevented ||
            ((this._isShown = !0),
            (this._isTransitioning = !0),
            this._scrollBar.hide(),
            document.body.classList.add(ki),
            this._adjustDialog(),
            this._backdrop.show(() => this._showElement(e)));
        }
        hide() {
          if (!this._isShown || this._isTransitioning) return;
          ft.trigger(this._element, _i).defaultPrevented ||
            ((this._isShown = !1),
            (this._isTransitioning = !0),
            this._focustrap.deactivate(),
            this._element.classList.remove(Yi),
            this._queueCallback(
              () => this._hideModal(),
              this._element,
              this._isAnimated()
            ));
        }
        dispose() {
          ft.off(window, fi),
            ft.off(this._dialog, fi),
            this._backdrop.dispose(),
            this._focustrap.deactivate(),
            super.dispose();
        }
        handleUpdate() {
          this._adjustDialog();
        }
        _initializeBackDrop() {
          return new ti({
            isVisible: Boolean(this._config.backdrop),
            isAnimated: this._isAnimated(),
          });
        }
        _initializeFocusTrap() {
          return new si({ trapElement: this._element });
        }
        _showElement(e) {
          document.body.contains(this._element) ||
            document.body.append(this._element),
            (this._element.style.display = "block"),
            this._element.removeAttribute("aria-hidden"),
            this._element.setAttribute("aria-modal", !0),
            this._element.setAttribute("role", "dialog"),
            (this._element.scrollTop = 0);
          const t = xt.findOne(".modal-body", this._dialog);
          t && (t.scrollTop = 0),
            Ze(this._element),
            this._element.classList.add(Yi);
          this._queueCallback(
            () => {
              this._config.focus && this._focustrap.activate(),
                (this._isTransitioning = !1),
                ft.trigger(this._element, vi, { relatedTarget: e });
            },
            this._dialog,
            this._isAnimated()
          );
        }
        _addEventListeners() {
          ft.on(this._element, Li, (e) => {
            "Escape" === e.key &&
              (this._config.keyboard
                ? this.hide()
                : this._triggerBackdropTransition());
          }),
            ft.on(window, Mi, () => {
              this._isShown && !this._isTransitioning && this._adjustDialog();
            }),
            ft.on(this._element, xi, (e) => {
              ft.one(this._element, bi, (t) => {
                this._element === e.target &&
                  this._element === t.target &&
                  ("static" !== this._config.backdrop
                    ? this._config.backdrop && this.hide()
                    : this._triggerBackdropTransition());
              });
            });
        }
        _hideModal() {
          (this._element.style.display = "none"),
            this._element.setAttribute("aria-hidden", !0),
            this._element.removeAttribute("aria-modal"),
            this._element.removeAttribute("role"),
            (this._isTransitioning = !1),
            this._backdrop.hide(() => {
              document.body.classList.remove(ki),
                this._resetAdjustments(),
                this._scrollBar.reset(),
                ft.trigger(this._element, gi);
            });
        }
        _isAnimated() {
          return this._element.classList.contains("fade");
        }
        _triggerBackdropTransition() {
          if (ft.trigger(this._element, pi).defaultPrevented) return;
          const e =
              this._element.scrollHeight >
              document.documentElement.clientHeight,
            t = this._element.style.overflowY;
          "hidden" === t ||
            this._element.classList.contains(Di) ||
            (e || (this._element.style.overflowY = "hidden"),
            this._element.classList.add(Di),
            this._queueCallback(() => {
              this._element.classList.remove(Di),
                this._queueCallback(() => {
                  this._element.style.overflowY = t;
                }, this._dialog);
            }, this._dialog),
            this._element.focus());
        }
        _adjustDialog() {
          const e =
              this._element.scrollHeight >
              document.documentElement.clientHeight,
            t = this._scrollBar.getWidth(),
            n = t > 0;
          if (n && !e) {
            const e = Je() ? "paddingLeft" : "paddingRight";
            this._element.style[e] = `${t}px`;
          }
          if (!n && e) {
            const e = Je() ? "paddingRight" : "paddingLeft";
            this._element.style[e] = `${t}px`;
          }
        }
        _resetAdjustments() {
          (this._element.style.paddingLeft = ""),
            (this._element.style.paddingRight = "");
        }
        static jQueryInterface(e, t) {
          return this.each(function () {
            const n = ji.getOrCreateInstance(this, e);
            if ("string" == typeof e) {
              if (void 0 === n[e])
                throw new TypeError(`No method named "${e}"`);
              n[e](t);
            }
          });
        }
      }
      ft.on(document, wi, '[data-bs-toggle="modal"]', function (e) {
        const t = xt.getElementFromSelector(this);
        ["A", "AREA"].includes(this.tagName) && e.preventDefault(),
          ft.one(t, yi, (e) => {
            e.defaultPrevented ||
              ft.one(t, gi, () => {
                Ne(this) && this.focus();
              });
          });
        const n = xt.findOne(".modal.show");
        n && ji.getInstance(n).hide();
        ji.getOrCreateInstance(t).toggle(this);
      }),
        Lt(ji),
        qe(ji);
      const Oi = ".bs.offcanvas",
        Ai = ".data-api",
        Hi = `load${Oi}${Ai}`,
        Ei = "show",
        Ci = "showing",
        Pi = "hiding",
        Fi = ".offcanvas.show",
        Ii = `show${Oi}`,
        Wi = `shown${Oi}`,
        zi = `hide${Oi}`,
        Ni = `hidePrevented${Oi}`,
        Ri = `hidden${Oi}`,
        Bi = `resize${Oi}`,
        Vi = `click${Oi}${Ai}`,
        Zi = `keydown.dismiss${Oi}`,
        Ui = { backdrop: !0, keyboard: !0, scroll: !1 },
        $i = {
          backdrop: "(boolean|string)",
          keyboard: "boolean",
          scroll: "boolean",
        };
      class Ji extends Mt {
        constructor(e, t) {
          super(e, t),
            (this._isShown = !1),
            (this._backdrop = this._initializeBackDrop()),
            (this._focustrap = this._initializeFocusTrap()),
            this._addEventListeners();
        }
        static get Default() {
          return Ui;
        }
        static get DefaultType() {
          return $i;
        }
        static get NAME() {
          return "offcanvas";
        }
        toggle(e) {
          return this._isShown ? this.hide() : this.show(e);
        }
        show(e) {
          if (this._isShown) return;
          if (
            ft.trigger(this._element, Ii, { relatedTarget: e }).defaultPrevented
          )
            return;
          (this._isShown = !0),
            this._backdrop.show(),
            this._config.scroll || new mi().hide(),
            this._element.setAttribute("aria-modal", !0),
            this._element.setAttribute("role", "dialog"),
            this._element.classList.add(Ci);
          this._queueCallback(
            () => {
              (this._config.scroll && !this._config.backdrop) ||
                this._focustrap.activate(),
                this._element.classList.add(Ei),
                this._element.classList.remove(Ci),
                ft.trigger(this._element, Wi, { relatedTarget: e });
            },
            this._element,
            !0
          );
        }
        hide() {
          if (!this._isShown) return;
          if (ft.trigger(this._element, zi).defaultPrevented) return;
          this._focustrap.deactivate(),
            this._element.blur(),
            (this._isShown = !1),
            this._element.classList.add(Pi),
            this._backdrop.hide();
          this._queueCallback(
            () => {
              this._element.classList.remove(Ei, Pi),
                this._element.removeAttribute("aria-modal"),
                this._element.removeAttribute("role"),
                this._config.scroll || new mi().reset(),
                ft.trigger(this._element, Ri);
            },
            this._element,
            !0
          );
        }
        dispose() {
          this._backdrop.dispose(),
            this._focustrap.deactivate(),
            super.dispose();
        }
        _initializeBackDrop() {
          const e = Boolean(this._config.backdrop);
          return new ti({
            className: "offcanvas-backdrop",
            isVisible: e,
            isAnimated: !0,
            rootElement: this._element.parentNode,
            clickCallback: e
              ? () => {
                  "static" !== this._config.backdrop
                    ? this.hide()
                    : ft.trigger(this._element, Ni);
                }
              : null,
          });
        }
        _initializeFocusTrap() {
          return new si({ trapElement: this._element });
        }
        _addEventListeners() {
          ft.on(this._element, Zi, (e) => {
            "Escape" === e.key &&
              (this._config.keyboard
                ? this.hide()
                : ft.trigger(this._element, Ni));
          });
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = Ji.getOrCreateInstance(this, e);
            if ("string" == typeof e) {
              if (void 0 === t[e] || e.startsWith("_") || "constructor" === e)
                throw new TypeError(`No method named "${e}"`);
              t[e](this);
            }
          });
        }
      }
      ft.on(document, Vi, '[data-bs-toggle="offcanvas"]', function (e) {
        const t = xt.getElementFromSelector(this);
        if (
          (["A", "AREA"].includes(this.tagName) && e.preventDefault(), Re(this))
        )
          return;
        ft.one(t, Ri, () => {
          Ne(this) && this.focus();
        });
        const n = xt.findOne(Fi);
        n && n !== t && Ji.getInstance(n).hide();
        Ji.getOrCreateInstance(t).toggle(this);
      }),
        ft.on(window, Hi, () => {
          for (const e of xt.find(Fi)) Ji.getOrCreateInstance(e).show();
        }),
        ft.on(window, Bi, () => {
          for (const e of xt.find(
            "[aria-modal][class*=show][class*=offcanvas-]"
          ))
            "fixed" !== getComputedStyle(e).position &&
              Ji.getOrCreateInstance(e).hide();
        }),
        Lt(Ji),
        qe(Ji);
      const qi = {
          "*": ["class", "dir", "id", "lang", "role", /^aria-[\w-]*$/i],
          a: ["target", "href", "title", "rel"],
          area: [],
          b: [],
          br: [],
          col: [],
          code: [],
          div: [],
          em: [],
          hr: [],
          h1: [],
          h2: [],
          h3: [],
          h4: [],
          h5: [],
          h6: [],
          i: [],
          img: ["src", "srcset", "alt", "title", "width", "height"],
          li: [],
          ol: [],
          p: [],
          pre: [],
          s: [],
          small: [],
          span: [],
          sub: [],
          sup: [],
          strong: [],
          u: [],
          ul: [],
        },
        Gi = new Set([
          "background",
          "cite",
          "href",
          "itemtype",
          "longdesc",
          "poster",
          "src",
          "xlink:href",
        ]),
        Xi = /^(?!javascript:)(?:[a-z0-9+.-]+:|[^&:/?#]*(?:[/?#]|$))/i,
        Ki = (e, t) => {
          const n = e.nodeName.toLowerCase();
          return t.includes(n)
            ? !Gi.has(n) || Boolean(Xi.test(e.nodeValue))
            : t.filter((e) => e instanceof RegExp).some((e) => e.test(n));
        };
      const Qi = {
          allowList: qi,
          content: {},
          extraClass: "",
          html: !1,
          sanitize: !0,
          sanitizeFn: null,
          template: "<div></div>",
        },
        ea = {
          allowList: "object",
          content: "object",
          extraClass: "(string|function)",
          html: "boolean",
          sanitize: "boolean",
          sanitizeFn: "(null|function)",
          template: "string",
        },
        ta = {
          entry: "(string|element|function|null)",
          selector: "(string|element)",
        };
      class na extends vt {
        constructor(e) {
          super(), (this._config = this._getConfig(e));
        }
        static get Default() {
          return Qi;
        }
        static get DefaultType() {
          return ea;
        }
        static get NAME() {
          return "TemplateFactory";
        }
        getContent() {
          return Object.values(this._config.content)
            .map((e) => this._resolvePossibleFunction(e))
            .filter(Boolean);
        }
        hasContent() {
          return this.getContent().length > 0;
        }
        changeContent(e) {
          return (
            this._checkContent(e),
            (this._config.content = { ...this._config.content, ...e }),
            this
          );
        }
        toHtml() {
          const e = document.createElement("div");
          e.innerHTML = this._maybeSanitize(this._config.template);
          for (const [t, n] of Object.entries(this._config.content))
            this._setContent(e, n, t);
          const t = e.children[0],
            n = this._resolvePossibleFunction(this._config.extraClass);
          return n && t.classList.add(...n.split(" ")), t;
        }
        _typeCheckConfig(e) {
          super._typeCheckConfig(e), this._checkContent(e.content);
        }
        _checkContent(e) {
          for (const [t, n] of Object.entries(e))
            super._typeCheckConfig({ selector: t, entry: n }, ta);
        }
        _setContent(e, t, n) {
          const i = xt.findOne(n, e);
          i &&
            ((t = this._resolvePossibleFunction(t))
              ? We(t)
                ? this._putElementInTemplate(ze(t), i)
                : this._config.html
                ? (i.innerHTML = this._maybeSanitize(t))
                : (i.textContent = t)
              : i.remove());
        }
        _maybeSanitize(e) {
          return this._config.sanitize
            ? (function (e, t, n) {
                if (!e.length) return e;
                if (n && "function" == typeof n) return n(e);
                const i = new window.DOMParser().parseFromString(
                    e,
                    "text/html"
                  ),
                  a = [].concat(...i.body.querySelectorAll("*"));
                for (const e of a) {
                  const n = e.nodeName.toLowerCase();
                  if (!Object.keys(t).includes(n)) {
                    e.remove();
                    continue;
                  }
                  const i = [].concat(...e.attributes),
                    a = [].concat(t["*"] || [], t[n] || []);
                  for (const t of i) Ki(t, a) || e.removeAttribute(t.nodeName);
                }
                return i.body.innerHTML;
              })(e, this._config.allowList, this._config.sanitizeFn)
            : e;
        }
        _resolvePossibleFunction(e) {
          return Ge(e, [this]);
        }
        _putElementInTemplate(e, t) {
          if (this._config.html) return (t.innerHTML = ""), void t.append(e);
          t.textContent = e.textContent;
        }
      }
      const ia = new Set(["sanitize", "allowList", "sanitizeFn"]),
        aa = "fade",
        ra = "show",
        la = ".tooltip-inner",
        oa = ".modal",
        sa = "hide.bs.modal",
        da = "hover",
        ua = "focus",
        ca = {
          AUTO: "auto",
          TOP: "top",
          RIGHT: Je() ? "left" : "right",
          BOTTOM: "bottom",
          LEFT: Je() ? "right" : "left",
        },
        ha = {
          allowList: qi,
          animation: !0,
          boundary: "clippingParents",
          container: !1,
          customClass: "",
          delay: 0,
          fallbackPlacements: ["top", "right", "bottom", "left"],
          html: !1,
          offset: [0, 6],
          placement: "top",
          popperConfig: null,
          sanitize: !0,
          sanitizeFn: null,
          selector: !1,
          template:
            '<div class="tooltip" role="tooltip"><div class="tooltip-arrow"></div><div class="tooltip-inner"></div></div>',
          title: "",
          trigger: "hover focus",
        },
        ma = {
          allowList: "object",
          animation: "boolean",
          boundary: "(string|element)",
          container: "(string|element|boolean)",
          customClass: "(string|function)",
          delay: "(number|object)",
          fallbackPlacements: "array",
          html: "boolean",
          offset: "(array|string|function)",
          placement: "(string|function)",
          popperConfig: "(null|object|function)",
          sanitize: "boolean",
          sanitizeFn: "(null|function)",
          selector: "(string|boolean)",
          template: "string",
          title: "(string|element|function)",
          trigger: "string",
        };
      class fa extends Mt {
        constructor(t, n) {
          if (void 0 === e)
            throw new TypeError(
              "Bootstrap's tooltips require Popper (https://popper.js.org)"
            );
          super(t, n),
            (this._isEnabled = !0),
            (this._timeout = 0),
            (this._isHovered = null),
            (this._activeTrigger = {}),
            (this._popper = null),
            (this._templateFactory = null),
            (this._newContent = null),
            (this.tip = null),
            this._setListeners(),
            this._config.selector || this._fixTitle();
        }
        static get Default() {
          return ha;
        }
        static get DefaultType() {
          return ma;
        }
        static get NAME() {
          return "tooltip";
        }
        enable() {
          this._isEnabled = !0;
        }
        disable() {
          this._isEnabled = !1;
        }
        toggleEnabled() {
          this._isEnabled = !this._isEnabled;
        }
        toggle() {
          this._isEnabled &&
            ((this._activeTrigger.click = !this._activeTrigger.click),
            this._isShown() ? this._leave() : this._enter());
        }
        dispose() {
          clearTimeout(this._timeout),
            ft.off(this._element.closest(oa), sa, this._hideModalHandler),
            this._element.getAttribute("data-bs-original-title") &&
              this._element.setAttribute(
                "title",
                this._element.getAttribute("data-bs-original-title")
              ),
            this._disposePopper(),
            super.dispose();
        }
        show() {
          if ("none" === this._element.style.display)
            throw new Error("Please use show on visible elements");
          if (!this._isWithContent() || !this._isEnabled) return;
          const e = ft.trigger(
              this._element,
              this.constructor.eventName("show")
            ),
            t = (
              Be(this._element) || this._element.ownerDocument.documentElement
            ).contains(this._element);
          if (e.defaultPrevented || !t) return;
          this._disposePopper();
          const n = this._getTipElement();
          this._element.setAttribute("aria-describedby", n.getAttribute("id"));
          const { container: i } = this._config;
          if (
            (this._element.ownerDocument.documentElement.contains(this.tip) ||
              (i.append(n),
              ft.trigger(
                this._element,
                this.constructor.eventName("inserted")
              )),
            (this._popper = this._createPopper(n)),
            n.classList.add(ra),
            "ontouchstart" in document.documentElement)
          )
            for (const e of [].concat(...document.body.children))
              ft.on(e, "mouseover", Ve);
          this._queueCallback(
            () => {
              ft.trigger(this._element, this.constructor.eventName("shown")),
                !1 === this._isHovered && this._leave(),
                (this._isHovered = !1);
            },
            this.tip,
            this._isAnimated()
          );
        }
        hide() {
          if (!this._isShown()) return;
          if (
            ft.trigger(this._element, this.constructor.eventName("hide"))
              .defaultPrevented
          )
            return;
          if (
            (this._getTipElement().classList.remove(ra),
            "ontouchstart" in document.documentElement)
          )
            for (const e of [].concat(...document.body.children))
              ft.off(e, "mouseover", Ve);
          (this._activeTrigger.click = !1),
            (this._activeTrigger[ua] = !1),
            (this._activeTrigger[da] = !1),
            (this._isHovered = null);
          this._queueCallback(
            () => {
              this._isWithActiveTrigger() ||
                (this._isHovered || this._disposePopper(),
                this._element.removeAttribute("aria-describedby"),
                ft.trigger(
                  this._element,
                  this.constructor.eventName("hidden")
                ));
            },
            this.tip,
            this._isAnimated()
          );
        }
        update() {
          this._popper && this._popper.update();
        }
        _isWithContent() {
          return Boolean(this._getTitle());
        }
        _getTipElement() {
          return (
            this.tip ||
              (this.tip = this._createTipElement(
                this._newContent || this._getContentForTemplate()
              )),
            this.tip
          );
        }
        _createTipElement(e) {
          const t = this._getTemplateFactory(e).toHtml();
          if (!t) return null;
          t.classList.remove(aa, ra),
            t.classList.add(`bs-${this.constructor.NAME}-auto`);
          const n = ((e) => {
            do {
              e += Math.floor(1e6 * Math.random());
            } while (document.getElementById(e));
            return e;
          })(this.constructor.NAME).toString();
          return (
            t.setAttribute("id", n),
            this._isAnimated() && t.classList.add(aa),
            t
          );
        }
        setContent(e) {
          (this._newContent = e),
            this._isShown() && (this._disposePopper(), this.show());
        }
        _getTemplateFactory(e) {
          return (
            this._templateFactory
              ? this._templateFactory.changeContent(e)
              : (this._templateFactory = new na({
                  ...this._config,
                  content: e,
                  extraClass: this._resolvePossibleFunction(
                    this._config.customClass
                  ),
                })),
            this._templateFactory
          );
        }
        _getContentForTemplate() {
          return { [la]: this._getTitle() };
        }
        _getTitle() {
          return (
            this._resolvePossibleFunction(this._config.title) ||
            this._element.getAttribute("data-bs-original-title")
          );
        }
        _initializeOnDelegatedTarget(e) {
          return this.constructor.getOrCreateInstance(
            e.delegateTarget,
            this._getDelegateConfig()
          );
        }
        _isAnimated() {
          return (
            this._config.animation ||
            (this.tip && this.tip.classList.contains(aa))
          );
        }
        _isShown() {
          return this.tip && this.tip.classList.contains(ra);
        }
        _createPopper(e) {
          const t = Ge(this._config.placement, [this, e, this._element]),
            n = ca[t.toUpperCase()];
          return Ae(this._element, e, this._getPopperConfig(n));
        }
        _getOffset() {
          const { offset: e } = this._config;
          return "string" == typeof e
            ? e.split(",").map((e) => Number.parseInt(e, 10))
            : "function" == typeof e
            ? (t) => e(t, this._element)
            : e;
        }
        _resolvePossibleFunction(e) {
          return Ge(e, [this._element]);
        }
        _getPopperConfig(e) {
          const t = {
            placement: e,
            modifiers: [
              {
                name: "flip",
                options: {
                  fallbackPlacements: this._config.fallbackPlacements,
                },
              },
              { name: "offset", options: { offset: this._getOffset() } },
              {
                name: "preventOverflow",
                options: { boundary: this._config.boundary },
              },
              {
                name: "arrow",
                options: { element: `.${this.constructor.NAME}-arrow` },
              },
              {
                name: "preSetPlacement",
                enabled: !0,
                phase: "beforeMain",
                fn: (e) => {
                  this._getTipElement().setAttribute(
                    "data-popper-placement",
                    e.state.placement
                  );
                },
              },
            ],
          };
          return { ...t, ...Ge(this._config.popperConfig, [t]) };
        }
        _setListeners() {
          const e = this._config.trigger.split(" ");
          for (const t of e)
            if ("click" === t)
              ft.on(
                this._element,
                this.constructor.eventName("click"),
                this._config.selector,
                (e) => {
                  this._initializeOnDelegatedTarget(e).toggle();
                }
              );
            else if ("manual" !== t) {
              const e =
                  t === da
                    ? this.constructor.eventName("mouseenter")
                    : this.constructor.eventName("focusin"),
                n =
                  t === da
                    ? this.constructor.eventName("mouseleave")
                    : this.constructor.eventName("focusout");
              ft.on(this._element, e, this._config.selector, (e) => {
                const t = this._initializeOnDelegatedTarget(e);
                (t._activeTrigger["focusin" === e.type ? ua : da] = !0),
                  t._enter();
              }),
                ft.on(this._element, n, this._config.selector, (e) => {
                  const t = this._initializeOnDelegatedTarget(e);
                  (t._activeTrigger["focusout" === e.type ? ua : da] =
                    t._element.contains(e.relatedTarget)),
                    t._leave();
                });
            }
          (this._hideModalHandler = () => {
            this._element && this.hide();
          }),
            ft.on(this._element.closest(oa), sa, this._hideModalHandler);
        }
        _fixTitle() {
          const e = this._element.getAttribute("title");
          e &&
            (this._element.getAttribute("aria-label") ||
              this._element.textContent.trim() ||
              this._element.setAttribute("aria-label", e),
            this._element.setAttribute("data-bs-original-title", e),
            this._element.removeAttribute("title"));
        }
        _enter() {
          this._isShown() || this._isHovered
            ? (this._isHovered = !0)
            : ((this._isHovered = !0),
              this._setTimeout(() => {
                this._isHovered && this.show();
              }, this._config.delay.show));
        }
        _leave() {
          this._isWithActiveTrigger() ||
            ((this._isHovered = !1),
            this._setTimeout(() => {
              this._isHovered || this.hide();
            }, this._config.delay.hide));
        }
        _setTimeout(e, t) {
          clearTimeout(this._timeout), (this._timeout = setTimeout(e, t));
        }
        _isWithActiveTrigger() {
          return Object.values(this._activeTrigger).includes(!0);
        }
        _getConfig(e) {
          const t = yt.getDataAttributes(this._element);
          for (const e of Object.keys(t)) ia.has(e) && delete t[e];
          return (
            (e = { ...t, ...("object" == typeof e && e ? e : {}) }),
            (e = this._mergeConfigObj(e)),
            (e = this._configAfterMerge(e)),
            this._typeCheckConfig(e),
            e
          );
        }
        _configAfterMerge(e) {
          return (
            (e.container =
              !1 === e.container ? document.body : ze(e.container)),
            "number" == typeof e.delay &&
              (e.delay = { show: e.delay, hide: e.delay }),
            "number" == typeof e.title && (e.title = e.title.toString()),
            "number" == typeof e.content && (e.content = e.content.toString()),
            e
          );
        }
        _getDelegateConfig() {
          const e = {};
          for (const [t, n] of Object.entries(this._config))
            this.constructor.Default[t] !== n && (e[t] = n);
          return (e.selector = !1), (e.trigger = "manual"), e;
        }
        _disposePopper() {
          this._popper && (this._popper.destroy(), (this._popper = null)),
            this.tip && (this.tip.remove(), (this.tip = null));
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = fa.getOrCreateInstance(this, e);
            if ("string" == typeof e) {
              if (void 0 === t[e])
                throw new TypeError(`No method named "${e}"`);
              t[e]();
            }
          });
        }
      }
      qe(fa);
      const _a = ".popover-header",
        pa = ".popover-body",
        ga = {
          ...fa.Default,
          content: "",
          offset: [0, 8],
          placement: "right",
          template:
            '<div class="popover" role="tooltip"><div class="popover-arrow"></div><h3 class="popover-header"></h3><div class="popover-body"></div></div>',
          trigger: "click",
        },
        ya = { ...fa.DefaultType, content: "(null|string|element|function)" };
      class va extends fa {
        static get Default() {
          return ga;
        }
        static get DefaultType() {
          return ya;
        }
        static get NAME() {
          return "popover";
        }
        _isWithContent() {
          return this._getTitle() || this._getContent();
        }
        _getContentForTemplate() {
          return { [_a]: this._getTitle(), [pa]: this._getContent() };
        }
        _getContent() {
          return this._resolvePossibleFunction(this._config.content);
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = va.getOrCreateInstance(this, e);
            if ("string" == typeof e) {
              if (void 0 === t[e])
                throw new TypeError(`No method named "${e}"`);
              t[e]();
            }
          });
        }
      }
      qe(va);
      const Ma = ".bs.scrollspy",
        ba = `activate${Ma}`,
        xa = `click${Ma}`,
        La = `load${Ma}.data-api`,
        wa = "active",
        ka = "[href]",
        Ya = ".nav-link",
        Da = `${Ya}, .nav-item > ${Ya}, .list-group-item`,
        Ta = {
          offset: null,
          rootMargin: "0px 0px -25%",
          smoothScroll: !1,
          target: null,
          threshold: [0.1, 0.5, 1],
        },
        Sa = {
          offset: "(number|null)",
          rootMargin: "string",
          smoothScroll: "boolean",
          target: "element",
          threshold: "array",
        };
      class ja extends Mt {
        constructor(e, t) {
          super(e, t),
            (this._targetLinks = new Map()),
            (this._observableSections = new Map()),
            (this._rootElement =
              "visible" === getComputedStyle(this._element).overflowY
                ? null
                : this._element),
            (this._activeTarget = null),
            (this._observer = null),
            (this._previousScrollData = {
              visibleEntryTop: 0,
              parentScrollTop: 0,
            }),
            this.refresh();
        }
        static get Default() {
          return Ta;
        }
        static get DefaultType() {
          return Sa;
        }
        static get NAME() {
          return "scrollspy";
        }
        refresh() {
          this._initializeTargetsAndObservables(),
            this._maybeEnableSmoothScroll(),
            this._observer
              ? this._observer.disconnect()
              : (this._observer = this._getNewObserver());
          for (const e of this._observableSections.values())
            this._observer.observe(e);
        }
        dispose() {
          this._observer.disconnect(), super.dispose();
        }
        _configAfterMerge(e) {
          return (
            (e.target = ze(e.target) || document.body),
            (e.rootMargin = e.offset ? `${e.offset}px 0px -30%` : e.rootMargin),
            "string" == typeof e.threshold &&
              (e.threshold = e.threshold
                .split(",")
                .map((e) => Number.parseFloat(e))),
            e
          );
        }
        _maybeEnableSmoothScroll() {
          this._config.smoothScroll &&
            (ft.off(this._config.target, xa),
            ft.on(this._config.target, xa, ka, (e) => {
              const t = this._observableSections.get(e.target.hash);
              if (t) {
                e.preventDefault();
                const n = this._rootElement || window,
                  i = t.offsetTop - this._element.offsetTop;
                if (n.scrollTo)
                  return void n.scrollTo({ top: i, behavior: "smooth" });
                n.scrollTop = i;
              }
            }));
        }
        _getNewObserver() {
          const e = {
            root: this._rootElement,
            threshold: this._config.threshold,
            rootMargin: this._config.rootMargin,
          };
          return new IntersectionObserver((e) => this._observerCallback(e), e);
        }
        _observerCallback(e) {
          const t = (e) => this._targetLinks.get(`#${e.target.id}`),
            n = (e) => {
              (this._previousScrollData.visibleEntryTop = e.target.offsetTop),
                this._process(t(e));
            },
            i = (this._rootElement || document.documentElement).scrollTop,
            a = i >= this._previousScrollData.parentScrollTop;
          this._previousScrollData.parentScrollTop = i;
          for (const r of e) {
            if (!r.isIntersecting) {
              (this._activeTarget = null), this._clearActiveClass(t(r));
              continue;
            }
            const e =
              r.target.offsetTop >= this._previousScrollData.visibleEntryTop;
            if (a && e) {
              if ((n(r), !i)) return;
            } else a || e || n(r);
          }
        }
        _initializeTargetsAndObservables() {
          (this._targetLinks = new Map()),
            (this._observableSections = new Map());
          const e = xt.find(ka, this._config.target);
          for (const t of e) {
            if (!t.hash || Re(t)) continue;
            const e = xt.findOne(decodeURI(t.hash), this._element);
            Ne(e) &&
              (this._targetLinks.set(decodeURI(t.hash), t),
              this._observableSections.set(t.hash, e));
          }
        }
        _process(e) {
          this._activeTarget !== e &&
            (this._clearActiveClass(this._config.target),
            (this._activeTarget = e),
            e.classList.add(wa),
            this._activateParents(e),
            ft.trigger(this._element, ba, { relatedTarget: e }));
        }
        _activateParents(e) {
          if (e.classList.contains("dropdown-item"))
            xt.findOne(
              ".dropdown-toggle",
              e.closest(".dropdown")
            ).classList.add(wa);
          else
            for (const t of xt.parents(e, ".nav, .list-group"))
              for (const e of xt.prev(t, Da)) e.classList.add(wa);
        }
        _clearActiveClass(e) {
          e.classList.remove(wa);
          const t = xt.find(`${ka}.${wa}`, e);
          for (const e of t) e.classList.remove(wa);
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = ja.getOrCreateInstance(this, e);
            if ("string" == typeof e) {
              if (void 0 === t[e] || e.startsWith("_") || "constructor" === e)
                throw new TypeError(`No method named "${e}"`);
              t[e]();
            }
          });
        }
      }
      ft.on(window, La, () => {
        for (const e of xt.find('[data-bs-spy="scroll"]'))
          ja.getOrCreateInstance(e);
      }),
        qe(ja);
      const Oa = ".bs.tab",
        Aa = `hide${Oa}`,
        Ha = `hidden${Oa}`,
        Ea = `show${Oa}`,
        Ca = `shown${Oa}`,
        Pa = `click${Oa}`,
        Fa = `keydown${Oa}`,
        Ia = `load${Oa}`,
        Wa = "ArrowLeft",
        za = "ArrowRight",
        Na = "ArrowUp",
        Ra = "ArrowDown",
        Ba = "active",
        Va = "fade",
        Za = "show",
        Ua = ":not(.dropdown-toggle)",
        $a =
          '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]',
        Ja = `${`.nav-link${Ua}, .list-group-item${Ua}, [role="tab"]${Ua}`}, ${$a}`,
        qa = `.${Ba}[data-bs-toggle="tab"], .${Ba}[data-bs-toggle="pill"], .${Ba}[data-bs-toggle="list"]`;
      class Ga extends Mt {
        constructor(e) {
          super(e),
            (this._parent = this._element.closest(
              '.list-group, .nav, [role="tablist"]'
            )),
            this._parent &&
              (this._setInitialAttributes(this._parent, this._getChildren()),
              ft.on(this._element, Fa, (e) => this._keydown(e)));
        }
        static get NAME() {
          return "tab";
        }
        show() {
          const e = this._element;
          if (this._elemIsActive(e)) return;
          const t = this._getActiveElem(),
            n = t ? ft.trigger(t, Aa, { relatedTarget: e }) : null;
          ft.trigger(e, Ea, { relatedTarget: t }).defaultPrevented ||
            (n && n.defaultPrevented) ||
            (this._deactivate(t, e), this._activate(e, t));
        }
        _activate(e, t) {
          if (!e) return;
          e.classList.add(Ba), this._activate(xt.getElementFromSelector(e));
          this._queueCallback(
            () => {
              "tab" === e.getAttribute("role")
                ? (e.removeAttribute("tabindex"),
                  e.setAttribute("aria-selected", !0),
                  this._toggleDropDown(e, !0),
                  ft.trigger(e, Ca, { relatedTarget: t }))
                : e.classList.add(Za);
            },
            e,
            e.classList.contains(Va)
          );
        }
        _deactivate(e, t) {
          if (!e) return;
          e.classList.remove(Ba),
            e.blur(),
            this._deactivate(xt.getElementFromSelector(e));
          this._queueCallback(
            () => {
              "tab" === e.getAttribute("role")
                ? (e.setAttribute("aria-selected", !1),
                  e.setAttribute("tabindex", "-1"),
                  this._toggleDropDown(e, !1),
                  ft.trigger(e, Ha, { relatedTarget: t }))
                : e.classList.remove(Za);
            },
            e,
            e.classList.contains(Va)
          );
        }
        _keydown(e) {
          if (![Wa, za, Na, Ra].includes(e.key)) return;
          e.stopPropagation(), e.preventDefault();
          const t = [za, Ra].includes(e.key),
            n = Ke(
              this._getChildren().filter((e) => !Re(e)),
              e.target,
              t,
              !0
            );
          n &&
            (n.focus({ preventScroll: !0 }), Ga.getOrCreateInstance(n).show());
        }
        _getChildren() {
          return xt.find(Ja, this._parent);
        }
        _getActiveElem() {
          return this._getChildren().find((e) => this._elemIsActive(e)) || null;
        }
        _setInitialAttributes(e, t) {
          this._setAttributeIfNotExists(e, "role", "tablist");
          for (const e of t) this._setInitialAttributesOnChild(e);
        }
        _setInitialAttributesOnChild(e) {
          e = this._getInnerElement(e);
          const t = this._elemIsActive(e),
            n = this._getOuterElement(e);
          e.setAttribute("aria-selected", t),
            n !== e && this._setAttributeIfNotExists(n, "role", "presentation"),
            t || e.setAttribute("tabindex", "-1"),
            this._setAttributeIfNotExists(e, "role", "tab"),
            this._setInitialAttributesOnTargetPanel(e);
        }
        _setInitialAttributesOnTargetPanel(e) {
          const t = xt.getElementFromSelector(e);
          t &&
            (this._setAttributeIfNotExists(t, "role", "tabpanel"),
            e.id &&
              this._setAttributeIfNotExists(t, "aria-labelledby", `${e.id}`));
        }
        _toggleDropDown(e, t) {
          const n = this._getOuterElement(e);
          if (!n.classList.contains("dropdown")) return;
          const i = (e, i) => {
            const a = xt.findOne(e, n);
            a && a.classList.toggle(i, t);
          };
          i(".dropdown-toggle", Ba),
            i(".dropdown-menu", Za),
            n.setAttribute("aria-expanded", t);
        }
        _setAttributeIfNotExists(e, t, n) {
          e.hasAttribute(t) || e.setAttribute(t, n);
        }
        _elemIsActive(e) {
          return e.classList.contains(Ba);
        }
        _getInnerElement(e) {
          return e.matches(Ja) ? e : xt.findOne(Ja, e);
        }
        _getOuterElement(e) {
          return e.closest(".nav-item, .list-group-item") || e;
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = Ga.getOrCreateInstance(this);
            if ("string" == typeof e) {
              if (void 0 === t[e] || e.startsWith("_") || "constructor" === e)
                throw new TypeError(`No method named "${e}"`);
              t[e]();
            }
          });
        }
      }
      ft.on(document, Pa, $a, function (e) {
        ["A", "AREA"].includes(this.tagName) && e.preventDefault(),
          Re(this) || Ga.getOrCreateInstance(this).show();
      }),
        ft.on(window, Ia, () => {
          for (const e of xt.find(qa)) Ga.getOrCreateInstance(e);
        }),
        qe(Ga);
      const Xa = ".bs.toast",
        Ka = `mouseover${Xa}`,
        Qa = `mouseout${Xa}`,
        er = `focusin${Xa}`,
        tr = `focusout${Xa}`,
        nr = `hide${Xa}`,
        ir = `hidden${Xa}`,
        ar = `show${Xa}`,
        rr = `shown${Xa}`,
        lr = "hide",
        or = "show",
        sr = "showing",
        dr = { animation: "boolean", autohide: "boolean", delay: "number" },
        ur = { animation: !0, autohide: !0, delay: 5e3 };
      class cr extends Mt {
        constructor(e, t) {
          super(e, t),
            (this._timeout = null),
            (this._hasMouseInteraction = !1),
            (this._hasKeyboardInteraction = !1),
            this._setListeners();
        }
        static get Default() {
          return ur;
        }
        static get DefaultType() {
          return dr;
        }
        static get NAME() {
          return "toast";
        }
        show() {
          if (ft.trigger(this._element, ar).defaultPrevented) return;
          this._clearTimeout(),
            this._config.animation && this._element.classList.add("fade");
          this._element.classList.remove(lr),
            Ze(this._element),
            this._element.classList.add(or, sr),
            this._queueCallback(
              () => {
                this._element.classList.remove(sr),
                  ft.trigger(this._element, rr),
                  this._maybeScheduleHide();
              },
              this._element,
              this._config.animation
            );
        }
        hide() {
          if (!this.isShown()) return;
          if (ft.trigger(this._element, nr).defaultPrevented) return;
          this._element.classList.add(sr),
            this._queueCallback(
              () => {
                this._element.classList.add(lr),
                  this._element.classList.remove(sr, or),
                  ft.trigger(this._element, ir);
              },
              this._element,
              this._config.animation
            );
        }
        dispose() {
          this._clearTimeout(),
            this.isShown() && this._element.classList.remove(or),
            super.dispose();
        }
        isShown() {
          return this._element.classList.contains(or);
        }
        _maybeScheduleHide() {
          this._config.autohide &&
            (this._hasMouseInteraction ||
              this._hasKeyboardInteraction ||
              (this._timeout = setTimeout(() => {
                this.hide();
              }, this._config.delay)));
        }
        _onInteraction(e, t) {
          switch (e.type) {
            case "mouseover":
            case "mouseout":
              this._hasMouseInteraction = t;
              break;
            case "focusin":
            case "focusout":
              this._hasKeyboardInteraction = t;
          }
          if (t) return void this._clearTimeout();
          const n = e.relatedTarget;
          this._element === n ||
            this._element.contains(n) ||
            this._maybeScheduleHide();
        }
        _setListeners() {
          ft.on(this._element, Ka, (e) => this._onInteraction(e, !0)),
            ft.on(this._element, Qa, (e) => this._onInteraction(e, !1)),
            ft.on(this._element, er, (e) => this._onInteraction(e, !0)),
            ft.on(this._element, tr, (e) => this._onInteraction(e, !1));
        }
        _clearTimeout() {
          clearTimeout(this._timeout), (this._timeout = null);
        }
        static jQueryInterface(e) {
          return this.each(function () {
            const t = cr.getOrCreateInstance(this, e);
            if ("string" == typeof e) {
              if (void 0 === t[e])
                throw new TypeError(`No method named "${e}"`);
              t[e](this);
            }
          });
        }
      }
      Lt(cr), qe(cr), (window.bootstrap = t);
      n(8945), n(8353);
      var hr,
        mr = n(1807),
        fr = n.n(mr),
        _r =
          (n(6369),
          n(6700),
          n(1888),
          n(9461),
          n(2930),
          n(7416),
          n(6235),
          n(3096)),
        pr = n.n(_r),
        gr = n(1296),
        yr = n.n(gr),
        vr = n(773),
        Mr = n.n(vr),
        br = [],
        xr = "ResizeObserver loop completed with undelivered notifications.";
      !(function (e) {
        (e.BORDER_BOX = "border-box"),
          (e.CONTENT_BOX = "content-box"),
          (e.DEVICE_PIXEL_CONTENT_BOX = "device-pixel-content-box");
      })(hr || (hr = {}));
      var Lr,
        wr = function (e) {
          return Object.freeze(e);
        },
        kr = function (e, t) {
          (this.inlineSize = e), (this.blockSize = t), wr(this);
        },
        Yr = (function () {
          function e(e, t, n, i) {
            return (
              (this.x = e),
              (this.y = t),
              (this.width = n),
              (this.height = i),
              (this.top = this.y),
              (this.left = this.x),
              (this.bottom = this.top + this.height),
              (this.right = this.left + this.width),
              wr(this)
            );
          }
          return (
            (e.prototype.toJSON = function () {
              var e = this;
              return {
                x: e.x,
                y: e.y,
                top: e.top,
                right: e.right,
                bottom: e.bottom,
                left: e.left,
                width: e.width,
                height: e.height,
              };
            }),
            (e.fromRect = function (t) {
              return new e(t.x, t.y, t.width, t.height);
            }),
            e
          );
        })(),
        Dr = function (e) {
          return e instanceof SVGElement && "getBBox" in e;
        },
        Tr = function (e) {
          if (Dr(e)) {
            var t = e.getBBox(),
              n = t.width,
              i = t.height;
            return !n && !i;
          }
          var a = e,
            r = a.offsetWidth,
            l = a.offsetHeight;
          return !(r || l || e.getClientRects().length);
        },
        Sr = function (e) {
          var t;
          if (e instanceof Element) return !0;
          var n =
            null === (t = null == e ? void 0 : e.ownerDocument) || void 0 === t
              ? void 0
              : t.defaultView;
          return !!(n && e instanceof n.Element);
        },
        jr = "undefined" != typeof window ? window : {},
        Or = new WeakMap(),
        Ar = /auto|scroll/,
        Hr = /^tb|vertical/,
        Er = /msie|trident/i.test(jr.navigator && jr.navigator.userAgent),
        Cr = function (e) {
          return parseFloat(e || "0");
        },
        Pr = function (e, t, n) {
          return (
            void 0 === e && (e = 0),
            void 0 === t && (t = 0),
            void 0 === n && (n = !1),
            new kr((n ? t : e) || 0, (n ? e : t) || 0)
          );
        },
        Fr = wr({
          devicePixelContentBoxSize: Pr(),
          borderBoxSize: Pr(),
          contentBoxSize: Pr(),
          contentRect: new Yr(0, 0, 0, 0),
        }),
        Ir = function (e, t) {
          if ((void 0 === t && (t = !1), Or.has(e) && !t)) return Or.get(e);
          if (Tr(e)) return Or.set(e, Fr), Fr;
          var n = getComputedStyle(e),
            i = Dr(e) && e.ownerSVGElement && e.getBBox(),
            a = !Er && "border-box" === n.boxSizing,
            r = Hr.test(n.writingMode || ""),
            l = !i && Ar.test(n.overflowY || ""),
            o = !i && Ar.test(n.overflowX || ""),
            s = i ? 0 : Cr(n.paddingTop),
            d = i ? 0 : Cr(n.paddingRight),
            u = i ? 0 : Cr(n.paddingBottom),
            c = i ? 0 : Cr(n.paddingLeft),
            h = i ? 0 : Cr(n.borderTopWidth),
            m = i ? 0 : Cr(n.borderRightWidth),
            f = i ? 0 : Cr(n.borderBottomWidth),
            _ = c + d,
            p = s + u,
            g = (i ? 0 : Cr(n.borderLeftWidth)) + m,
            y = h + f,
            v = o ? e.offsetHeight - y - e.clientHeight : 0,
            M = l ? e.offsetWidth - g - e.clientWidth : 0,
            b = a ? _ + g : 0,
            x = a ? p + y : 0,
            L = i ? i.width : Cr(n.width) - b - M,
            w = i ? i.height : Cr(n.height) - x - v,
            k = L + _ + M + g,
            Y = w + p + v + y,
            D = wr({
              devicePixelContentBoxSize: Pr(
                Math.round(L * devicePixelRatio),
                Math.round(w * devicePixelRatio),
                r
              ),
              borderBoxSize: Pr(k, Y, r),
              contentBoxSize: Pr(L, w, r),
              contentRect: new Yr(c, s, L, w),
            });
          return Or.set(e, D), D;
        },
        Wr = function (e, t, n) {
          var i = Ir(e, n),
            a = i.borderBoxSize,
            r = i.contentBoxSize,
            l = i.devicePixelContentBoxSize;
          switch (t) {
            case hr.DEVICE_PIXEL_CONTENT_BOX:
              return l;
            case hr.BORDER_BOX:
              return a;
            default:
              return r;
          }
        },
        zr = function (e) {
          var t = Ir(e);
          (this.target = e),
            (this.contentRect = t.contentRect),
            (this.borderBoxSize = wr([t.borderBoxSize])),
            (this.contentBoxSize = wr([t.contentBoxSize])),
            (this.devicePixelContentBoxSize = wr([
              t.devicePixelContentBoxSize,
            ]));
        },
        Nr = function (e) {
          if (Tr(e)) return 1 / 0;
          for (var t = 0, n = e.parentNode; n; ) (t += 1), (n = n.parentNode);
          return t;
        },
        Rr = function () {
          var e = 1 / 0,
            t = [];
          br.forEach(function (n) {
            if (0 !== n.activeTargets.length) {
              var i = [];
              n.activeTargets.forEach(function (t) {
                var n = new zr(t.target),
                  a = Nr(t.target);
                i.push(n),
                  (t.lastReportedSize = Wr(t.target, t.observedBox)),
                  a < e && (e = a);
              }),
                t.push(function () {
                  n.callback.call(n.observer, i, n.observer);
                }),
                n.activeTargets.splice(0, n.activeTargets.length);
            }
          });
          for (var n = 0, i = t; n < i.length; n++) {
            (0, i[n])();
          }
          return e;
        },
        Br = function (e) {
          br.forEach(function (t) {
            t.activeTargets.splice(0, t.activeTargets.length),
              t.skippedTargets.splice(0, t.skippedTargets.length),
              t.observationTargets.forEach(function (n) {
                n.isActive() &&
                  (Nr(n.target) > e
                    ? t.activeTargets.push(n)
                    : t.skippedTargets.push(n));
              });
          });
        },
        Vr = function () {
          var e,
            t = 0;
          for (
            Br(t);
            br.some(function (e) {
              return e.activeTargets.length > 0;
            });

          )
            (t = Rr()), Br(t);
          return (
            br.some(function (e) {
              return e.skippedTargets.length > 0;
            }) &&
              ("function" == typeof ErrorEvent
                ? (e = new ErrorEvent("error", { message: xr }))
                : ((e = document.createEvent("Event")).initEvent(
                    "error",
                    !1,
                    !1
                  ),
                  (e.message = xr)),
              window.dispatchEvent(e)),
            t > 0
          );
        },
        Zr = [],
        Ur = function (e) {
          if (!Lr) {
            var t = 0,
              n = document.createTextNode("");
            new MutationObserver(function () {
              return Zr.splice(0).forEach(function (e) {
                return e();
              });
            }).observe(n, { characterData: !0 }),
              (Lr = function () {
                n.textContent = "".concat(t ? t-- : t++);
              });
          }
          Zr.push(e), Lr();
        },
        $r = 0,
        Jr = { attributes: !0, characterData: !0, childList: !0, subtree: !0 },
        qr = [
          "resize",
          "load",
          "transitionend",
          "animationend",
          "animationstart",
          "animationiteration",
          "keyup",
          "keydown",
          "mouseup",
          "mousedown",
          "mouseover",
          "mouseout",
          "blur",
          "focus",
        ],
        Gr = function (e) {
          return void 0 === e && (e = 0), Date.now() + e;
        },
        Xr = !1,
        Kr = new ((function () {
          function e() {
            var e = this;
            (this.stopped = !0),
              (this.listener = function () {
                return e.schedule();
              });
          }
          return (
            (e.prototype.run = function (e) {
              var t = this;
              if ((void 0 === e && (e = 250), !Xr)) {
                Xr = !0;
                var n,
                  i = Gr(e);
                (n = function () {
                  var n = !1;
                  try {
                    n = Vr();
                  } finally {
                    if (((Xr = !1), (e = i - Gr()), !$r)) return;
                    n ? t.run(1e3) : e > 0 ? t.run(e) : t.start();
                  }
                }),
                  Ur(function () {
                    requestAnimationFrame(n);
                  });
              }
            }),
            (e.prototype.schedule = function () {
              this.stop(), this.run();
            }),
            (e.prototype.observe = function () {
              var e = this,
                t = function () {
                  return e.observer && e.observer.observe(document.body, Jr);
                };
              document.body ? t() : jr.addEventListener("DOMContentLoaded", t);
            }),
            (e.prototype.start = function () {
              var e = this;
              this.stopped &&
                ((this.stopped = !1),
                (this.observer = new MutationObserver(this.listener)),
                this.observe(),
                qr.forEach(function (t) {
                  return jr.addEventListener(t, e.listener, !0);
                }));
            }),
            (e.prototype.stop = function () {
              var e = this;
              this.stopped ||
                (this.observer && this.observer.disconnect(),
                qr.forEach(function (t) {
                  return jr.removeEventListener(t, e.listener, !0);
                }),
                (this.stopped = !0));
            }),
            e
          );
        })())(),
        Qr = function (e) {
          !$r && e > 0 && Kr.start(), !($r += e) && Kr.stop();
        },
        el = (function () {
          function e(e, t) {
            (this.target = e),
              (this.observedBox = t || hr.CONTENT_BOX),
              (this.lastReportedSize = { inlineSize: 0, blockSize: 0 });
          }
          return (
            (e.prototype.isActive = function () {
              var e,
                t = Wr(this.target, this.observedBox, !0);
              return (
                (e = this.target),
                Dr(e) ||
                  (function (e) {
                    switch (e.tagName) {
                      case "INPUT":
                        if ("image" !== e.type) break;
                      case "VIDEO":
                      case "AUDIO":
                      case "EMBED":
                      case "OBJECT":
                      case "CANVAS":
                      case "IFRAME":
                      case "IMG":
                        return !0;
                    }
                    return !1;
                  })(e) ||
                  "inline" !== getComputedStyle(e).display ||
                  (this.lastReportedSize = t),
                this.lastReportedSize.inlineSize !== t.inlineSize ||
                  this.lastReportedSize.blockSize !== t.blockSize
              );
            }),
            e
          );
        })(),
        tl = function (e, t) {
          (this.activeTargets = []),
            (this.skippedTargets = []),
            (this.observationTargets = []),
            (this.observer = e),
            (this.callback = t);
        },
        nl = new WeakMap(),
        il = function (e, t) {
          for (var n = 0; n < e.length; n += 1) if (e[n].target === t) return n;
          return -1;
        },
        al = (function () {
          function e() {}
          return (
            (e.connect = function (e, t) {
              var n = new tl(e, t);
              nl.set(e, n);
            }),
            (e.observe = function (e, t, n) {
              var i = nl.get(e),
                a = 0 === i.observationTargets.length;
              il(i.observationTargets, t) < 0 &&
                (a && br.push(i),
                i.observationTargets.push(new el(t, n && n.box)),
                Qr(1),
                Kr.schedule());
            }),
            (e.unobserve = function (e, t) {
              var n = nl.get(e),
                i = il(n.observationTargets, t),
                a = 1 === n.observationTargets.length;
              i >= 0 &&
                (a && br.splice(br.indexOf(n), 1),
                n.observationTargets.splice(i, 1),
                Qr(-1));
            }),
            (e.disconnect = function (e) {
              var t = this,
                n = nl.get(e);
              n.observationTargets.slice().forEach(function (n) {
                return t.unobserve(e, n.target);
              }),
                n.activeTargets.splice(0, n.activeTargets.length);
            }),
            e
          );
        })(),
        rl = (function () {
          function e(e) {
            if (0 === arguments.length)
              throw new TypeError(
                "Failed to construct 'ResizeObserver': 1 argument required, but only 0 present."
              );
            if ("function" != typeof e)
              throw new TypeError(
                "Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function."
              );
            al.connect(this, e);
          }
          return (
            (e.prototype.observe = function (e, t) {
              if (0 === arguments.length)
                throw new TypeError(
                  "Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present."
                );
              if (!Sr(e))
                throw new TypeError(
                  "Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element"
                );
              al.observe(this, e, t);
            }),
            (e.prototype.unobserve = function (e) {
              if (0 === arguments.length)
                throw new TypeError(
                  "Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present."
                );
              if (!Sr(e))
                throw new TypeError(
                  "Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element"
                );
              al.unobserve(this, e);
            }),
            (e.prototype.disconnect = function () {
              al.disconnect(this);
            }),
            (e.toString = function () {
              return "function ResizeObserver () { [polyfill code] }";
            }),
            e
          );
        })(),
        ll =
          (n(6648),
          n(8044),
          n(7570),
          n(3030),
          n(1845),
          function (e) {
            return Array.prototype.reduce.call(
              e,
              function (e, t) {
                var n = t.name.match(/data-simplebar-(.+)/);
                if (n) {
                  var i = n[1].replace(/\W+(.)/g, function (e, t) {
                    return t.toUpperCase();
                  });
                  switch (t.value) {
                    case "true":
                      e[i] = !0;
                      break;
                    case "false":
                      e[i] = !1;
                      break;
                    case void 0:
                      e[i] = !0;
                      break;
                    default:
                      e[i] = t.value;
                  }
                }
                return e;
              },
              {}
            );
          });
      function ol(e) {
        return e && e.ownerDocument && e.ownerDocument.defaultView
          ? e.ownerDocument.defaultView
          : window;
      }
      function sl(e) {
        return e && e.ownerDocument ? e.ownerDocument : document;
      }
      var dl = null,
        ul = null;
      function cl(e) {
        if (null === dl) {
          var t = sl(e);
          if (void 0 === t) return (dl = 0);
          var n = t.body,
            i = t.createElement("div");
          i.classList.add("simplebar-hide-scrollbar"), n.appendChild(i);
          var a = i.getBoundingClientRect().right;
          n.removeChild(i), (dl = a);
        }
        return dl;
      }
      fr() &&
        window.addEventListener("resize", function () {
          ul !== window.devicePixelRatio &&
            ((ul = window.devicePixelRatio), (dl = null));
        });
      var hl = (function () {
        function e(t, n) {
          var i = this;
          (this.onScroll = function () {
            var e = ol(i.el);
            i.scrollXTicking ||
              (e.requestAnimationFrame(i.scrollX), (i.scrollXTicking = !0)),
              i.scrollYTicking ||
                (e.requestAnimationFrame(i.scrollY), (i.scrollYTicking = !0));
          }),
            (this.scrollX = function () {
              i.axis.x.isOverflowing &&
                (i.showScrollbar("x"), i.positionScrollbar("x")),
                (i.scrollXTicking = !1);
            }),
            (this.scrollY = function () {
              i.axis.y.isOverflowing &&
                (i.showScrollbar("y"), i.positionScrollbar("y")),
                (i.scrollYTicking = !1);
            }),
            (this.onMouseEnter = function () {
              i.showScrollbar("x"), i.showScrollbar("y");
            }),
            (this.onMouseMove = function (e) {
              (i.mouseX = e.clientX),
                (i.mouseY = e.clientY),
                (i.axis.x.isOverflowing || i.axis.x.forceVisible) &&
                  i.onMouseMoveForAxis("x"),
                (i.axis.y.isOverflowing || i.axis.y.forceVisible) &&
                  i.onMouseMoveForAxis("y");
            }),
            (this.onMouseLeave = function () {
              i.onMouseMove.cancel(),
                (i.axis.x.isOverflowing || i.axis.x.forceVisible) &&
                  i.onMouseLeaveForAxis("x"),
                (i.axis.y.isOverflowing || i.axis.y.forceVisible) &&
                  i.onMouseLeaveForAxis("y"),
                (i.mouseX = -1),
                (i.mouseY = -1);
            }),
            (this.onWindowResize = function () {
              (i.scrollbarWidth = i.getScrollbarWidth()),
                i.hideNativeScrollbar();
            }),
            (this.hideScrollbars = function () {
              (i.axis.x.track.rect = i.axis.x.track.el.getBoundingClientRect()),
                (i.axis.y.track.rect =
                  i.axis.y.track.el.getBoundingClientRect()),
                i.isWithinBounds(i.axis.y.track.rect) ||
                  (i.axis.y.scrollbar.el.classList.remove(i.classNames.visible),
                  (i.axis.y.isVisible = !1)),
                i.isWithinBounds(i.axis.x.track.rect) ||
                  (i.axis.x.scrollbar.el.classList.remove(i.classNames.visible),
                  (i.axis.x.isVisible = !1));
            }),
            (this.onPointerEvent = function (e) {
              var t, n;
              (i.axis.x.track.rect = i.axis.x.track.el.getBoundingClientRect()),
                (i.axis.y.track.rect =
                  i.axis.y.track.el.getBoundingClientRect()),
                (i.axis.x.isOverflowing || i.axis.x.forceVisible) &&
                  (t = i.isWithinBounds(i.axis.x.track.rect)),
                (i.axis.y.isOverflowing || i.axis.y.forceVisible) &&
                  (n = i.isWithinBounds(i.axis.y.track.rect)),
                (t || n) &&
                  (e.preventDefault(),
                  e.stopPropagation(),
                  "mousedown" === e.type &&
                    (t &&
                      ((i.axis.x.scrollbar.rect =
                        i.axis.x.scrollbar.el.getBoundingClientRect()),
                      i.isWithinBounds(i.axis.x.scrollbar.rect)
                        ? i.onDragStart(e, "x")
                        : i.onTrackClick(e, "x")),
                    n &&
                      ((i.axis.y.scrollbar.rect =
                        i.axis.y.scrollbar.el.getBoundingClientRect()),
                      i.isWithinBounds(i.axis.y.scrollbar.rect)
                        ? i.onDragStart(e, "y")
                        : i.onTrackClick(e, "y"))));
            }),
            (this.drag = function (t) {
              var n = i.axis[i.draggedAxis].track,
                a = n.rect[i.axis[i.draggedAxis].sizeAttr],
                r = i.axis[i.draggedAxis].scrollbar,
                l = i.contentWrapperEl[i.axis[i.draggedAxis].scrollSizeAttr],
                o = parseInt(i.elStyles[i.axis[i.draggedAxis].sizeAttr], 10);
              t.preventDefault(), t.stopPropagation();
              var s =
                ((("y" === i.draggedAxis ? t.pageY : t.pageX) -
                  n.rect[i.axis[i.draggedAxis].offsetAttr] -
                  i.axis[i.draggedAxis].dragOffset) /
                  (a - r.size)) *
                (l - o);
              "x" === i.draggedAxis &&
                ((s =
                  i.isRtl && e.getRtlHelpers().isRtlScrollbarInverted
                    ? s - (a + r.size)
                    : s),
                (s =
                  i.isRtl && e.getRtlHelpers().isRtlScrollingInverted
                    ? -s
                    : s)),
                (i.contentWrapperEl[i.axis[i.draggedAxis].scrollOffsetAttr] =
                  s);
            }),
            (this.onEndDrag = function (e) {
              var t = sl(i.el),
                n = ol(i.el);
              e.preventDefault(),
                e.stopPropagation(),
                i.el.classList.remove(i.classNames.dragging),
                t.removeEventListener("mousemove", i.drag, !0),
                t.removeEventListener("mouseup", i.onEndDrag, !0),
                (i.removePreventClickId = n.setTimeout(function () {
                  t.removeEventListener("click", i.preventClick, !0),
                    t.removeEventListener("dblclick", i.preventClick, !0),
                    (i.removePreventClickId = null);
                }));
            }),
            (this.preventClick = function (e) {
              e.preventDefault(), e.stopPropagation();
            }),
            (this.el = t),
            (this.minScrollbarWidth = 20),
            (this.options = Object.assign({}, e.defaultOptions, n)),
            (this.classNames = Object.assign(
              {},
              e.defaultOptions.classNames,
              this.options.classNames
            )),
            (this.axis = {
              x: {
                scrollOffsetAttr: "scrollLeft",
                sizeAttr: "width",
                scrollSizeAttr: "scrollWidth",
                offsetSizeAttr: "offsetWidth",
                offsetAttr: "left",
                overflowAttr: "overflowX",
                dragOffset: 0,
                isOverflowing: !0,
                isVisible: !1,
                forceVisible: !1,
                track: {},
                scrollbar: {},
              },
              y: {
                scrollOffsetAttr: "scrollTop",
                sizeAttr: "height",
                scrollSizeAttr: "scrollHeight",
                offsetSizeAttr: "offsetHeight",
                offsetAttr: "top",
                overflowAttr: "overflowY",
                dragOffset: 0,
                isOverflowing: !0,
                isVisible: !1,
                forceVisible: !1,
                track: {},
                scrollbar: {},
              },
            }),
            (this.removePreventClickId = null),
            e.instances.has(this.el) ||
              ((this.recalculate = pr()(this.recalculate.bind(this), 64)),
              (this.onMouseMove = pr()(this.onMouseMove.bind(this), 64)),
              (this.hideScrollbars = yr()(
                this.hideScrollbars.bind(this),
                this.options.timeout
              )),
              (this.onWindowResize = yr()(this.onWindowResize.bind(this), 64, {
                leading: !0,
              })),
              (e.getRtlHelpers = Mr()(e.getRtlHelpers)),
              this.init());
        }
        (e.getRtlHelpers = function () {
          var t = document.createElement("div");
          t.innerHTML =
            '<div class="hs-dummy-scrollbar-size"><div style="height: 200%; width: 200%; margin: 10px 0;"></div></div>';
          var n = t.firstElementChild;
          document.body.appendChild(n);
          var i = n.firstElementChild;
          n.scrollLeft = 0;
          var a = e.getOffset(n),
            r = e.getOffset(i);
          n.scrollLeft = 999;
          var l = e.getOffset(i);
          return {
            isRtlScrollingInverted: a.left !== r.left && r.left - l.left != 0,
            isRtlScrollbarInverted: a.left !== r.left,
          };
        }),
          (e.getOffset = function (e) {
            var t = e.getBoundingClientRect(),
              n = sl(e),
              i = ol(e);
            return {
              top: t.top + (i.pageYOffset || n.documentElement.scrollTop),
              left: t.left + (i.pageXOffset || n.documentElement.scrollLeft),
            };
          });
        var t = e.prototype;
        return (
          (t.init = function () {
            e.instances.set(this.el, this),
              fr() &&
                (this.initDOM(),
                this.setAccessibilityAttributes(),
                (this.scrollbarWidth = this.getScrollbarWidth()),
                this.recalculate(),
                this.initListeners());
          }),
          (t.initDOM = function () {
            var e = this;
            if (
              Array.prototype.filter.call(this.el.children, function (t) {
                return t.classList.contains(e.classNames.wrapper);
              }).length
            )
              (this.wrapperEl = this.el.querySelector(
                "." + this.classNames.wrapper
              )),
                (this.contentWrapperEl =
                  this.options.scrollableNode ||
                  this.el.querySelector("." + this.classNames.contentWrapper)),
                (this.contentEl =
                  this.options.contentNode ||
                  this.el.querySelector("." + this.classNames.contentEl)),
                (this.offsetEl = this.el.querySelector(
                  "." + this.classNames.offset
                )),
                (this.maskEl = this.el.querySelector(
                  "." + this.classNames.mask
                )),
                (this.placeholderEl = this.findChild(
                  this.wrapperEl,
                  "." + this.classNames.placeholder
                )),
                (this.heightAutoObserverWrapperEl = this.el.querySelector(
                  "." + this.classNames.heightAutoObserverWrapperEl
                )),
                (this.heightAutoObserverEl = this.el.querySelector(
                  "." + this.classNames.heightAutoObserverEl
                )),
                (this.axis.x.track.el = this.findChild(
                  this.el,
                  "." + this.classNames.track + "." + this.classNames.horizontal
                )),
                (this.axis.y.track.el = this.findChild(
                  this.el,
                  "." + this.classNames.track + "." + this.classNames.vertical
                ));
            else {
              for (
                this.wrapperEl = document.createElement("div"),
                  this.contentWrapperEl = document.createElement("div"),
                  this.offsetEl = document.createElement("div"),
                  this.maskEl = document.createElement("div"),
                  this.contentEl = document.createElement("div"),
                  this.placeholderEl = document.createElement("div"),
                  this.heightAutoObserverWrapperEl =
                    document.createElement("div"),
                  this.heightAutoObserverEl = document.createElement("div"),
                  this.wrapperEl.classList.add(this.classNames.wrapper),
                  this.contentWrapperEl.classList.add(
                    this.classNames.contentWrapper
                  ),
                  this.offsetEl.classList.add(this.classNames.offset),
                  this.maskEl.classList.add(this.classNames.mask),
                  this.contentEl.classList.add(this.classNames.contentEl),
                  this.placeholderEl.classList.add(this.classNames.placeholder),
                  this.heightAutoObserverWrapperEl.classList.add(
                    this.classNames.heightAutoObserverWrapperEl
                  ),
                  this.heightAutoObserverEl.classList.add(
                    this.classNames.heightAutoObserverEl
                  );
                this.el.firstChild;

              )
                this.contentEl.appendChild(this.el.firstChild);
              this.contentWrapperEl.appendChild(this.contentEl),
                this.offsetEl.appendChild(this.contentWrapperEl),
                this.maskEl.appendChild(this.offsetEl),
                this.heightAutoObserverWrapperEl.appendChild(
                  this.heightAutoObserverEl
                ),
                this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl),
                this.wrapperEl.appendChild(this.maskEl),
                this.wrapperEl.appendChild(this.placeholderEl),
                this.el.appendChild(this.wrapperEl);
            }
            if (!this.axis.x.track.el || !this.axis.y.track.el) {
              var t = document.createElement("div"),
                n = document.createElement("div");
              t.classList.add(this.classNames.track),
                n.classList.add(this.classNames.scrollbar),
                t.appendChild(n),
                (this.axis.x.track.el = t.cloneNode(!0)),
                this.axis.x.track.el.classList.add(this.classNames.horizontal),
                (this.axis.y.track.el = t.cloneNode(!0)),
                this.axis.y.track.el.classList.add(this.classNames.vertical),
                this.el.appendChild(this.axis.x.track.el),
                this.el.appendChild(this.axis.y.track.el);
            }
            (this.axis.x.scrollbar.el = this.axis.x.track.el.querySelector(
              "." + this.classNames.scrollbar
            )),
              (this.axis.y.scrollbar.el = this.axis.y.track.el.querySelector(
                "." + this.classNames.scrollbar
              )),
              this.options.autoHide ||
                (this.axis.x.scrollbar.el.classList.add(
                  this.classNames.visible
                ),
                this.axis.y.scrollbar.el.classList.add(
                  this.classNames.visible
                )),
              this.el.setAttribute("data-simplebar", "init");
          }),
          (t.setAccessibilityAttributes = function () {
            var e = this.options.ariaLabel || "scrollable content";
            this.contentWrapperEl.setAttribute("tabindex", "0"),
              this.contentWrapperEl.setAttribute("role", "region"),
              this.contentWrapperEl.setAttribute("aria-label", e);
          }),
          (t.initListeners = function () {
            var e = this,
              t = ol(this.el);
            this.options.autoHide &&
              this.el.addEventListener("mouseenter", this.onMouseEnter),
              ["mousedown", "click", "dblclick"].forEach(function (t) {
                e.el.addEventListener(t, e.onPointerEvent, !0);
              }),
              ["touchstart", "touchend", "touchmove"].forEach(function (t) {
                e.el.addEventListener(t, e.onPointerEvent, {
                  capture: !0,
                  passive: !0,
                });
              }),
              this.el.addEventListener("mousemove", this.onMouseMove),
              this.el.addEventListener("mouseleave", this.onMouseLeave),
              this.contentWrapperEl.addEventListener("scroll", this.onScroll),
              t.addEventListener("resize", this.onWindowResize);
            var n = !1,
              i = null,
              a = t.ResizeObserver || rl;
            (this.resizeObserver = new a(function () {
              n &&
                null === i &&
                (i = t.requestAnimationFrame(function () {
                  e.recalculate(), (i = null);
                }));
            })),
              this.resizeObserver.observe(this.el),
              this.resizeObserver.observe(this.contentEl),
              t.requestAnimationFrame(function () {
                n = !0;
              }),
              (this.mutationObserver = new t.MutationObserver(
                this.recalculate
              )),
              this.mutationObserver.observe(this.contentEl, {
                childList: !0,
                subtree: !0,
                characterData: !0,
              });
          }),
          (t.recalculate = function () {
            var e = ol(this.el);
            (this.elStyles = e.getComputedStyle(this.el)),
              (this.isRtl = "rtl" === this.elStyles.direction);
            var t = this.heightAutoObserverEl.offsetHeight <= 1,
              n = this.heightAutoObserverEl.offsetWidth <= 1,
              i = this.contentEl.offsetWidth,
              a = this.contentWrapperEl.offsetWidth,
              r = this.elStyles.overflowX,
              l = this.elStyles.overflowY;
            (this.contentEl.style.padding =
              this.elStyles.paddingTop +
              " " +
              this.elStyles.paddingRight +
              " " +
              this.elStyles.paddingBottom +
              " " +
              this.elStyles.paddingLeft),
              (this.wrapperEl.style.margin =
                "-" +
                this.elStyles.paddingTop +
                " -" +
                this.elStyles.paddingRight +
                " -" +
                this.elStyles.paddingBottom +
                " -" +
                this.elStyles.paddingLeft);
            var o = this.contentEl.scrollHeight,
              s = this.contentEl.scrollWidth;
            (this.contentWrapperEl.style.height = t ? "auto" : "100%"),
              (this.placeholderEl.style.width = n ? i + "px" : "auto"),
              (this.placeholderEl.style.height = o + "px");
            var d = this.contentWrapperEl.offsetHeight;
            (this.axis.x.isOverflowing = s > i),
              (this.axis.y.isOverflowing = o > d),
              (this.axis.x.isOverflowing =
                "hidden" !== r && this.axis.x.isOverflowing),
              (this.axis.y.isOverflowing =
                "hidden" !== l && this.axis.y.isOverflowing),
              (this.axis.x.forceVisible =
                "x" === this.options.forceVisible ||
                !0 === this.options.forceVisible),
              (this.axis.y.forceVisible =
                "y" === this.options.forceVisible ||
                !0 === this.options.forceVisible),
              this.hideNativeScrollbar();
            var u = this.axis.x.isOverflowing ? this.scrollbarWidth : 0,
              c = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
            (this.axis.x.isOverflowing =
              this.axis.x.isOverflowing && s > a - c),
              (this.axis.y.isOverflowing =
                this.axis.y.isOverflowing && o > d - u),
              (this.axis.x.scrollbar.size = this.getScrollbarSize("x")),
              (this.axis.y.scrollbar.size = this.getScrollbarSize("y")),
              (this.axis.x.scrollbar.el.style.width =
                this.axis.x.scrollbar.size + "px"),
              (this.axis.y.scrollbar.el.style.height =
                this.axis.y.scrollbar.size + "px"),
              this.positionScrollbar("x"),
              this.positionScrollbar("y"),
              this.toggleTrackVisibility("x"),
              this.toggleTrackVisibility("y");
          }),
          (t.getScrollbarSize = function (e) {
            if ((void 0 === e && (e = "y"), !this.axis[e].isOverflowing))
              return 0;
            var t,
              n = this.contentEl[this.axis[e].scrollSizeAttr],
              i = this.axis[e].track.el[this.axis[e].offsetSizeAttr],
              a = i / n;
            return (
              (t = Math.max(~~(a * i), this.options.scrollbarMinSize)),
              this.options.scrollbarMaxSize &&
                (t = Math.min(t, this.options.scrollbarMaxSize)),
              t
            );
          }),
          (t.positionScrollbar = function (t) {
            if ((void 0 === t && (t = "y"), this.axis[t].isOverflowing)) {
              var n = this.contentWrapperEl[this.axis[t].scrollSizeAttr],
                i = this.axis[t].track.el[this.axis[t].offsetSizeAttr],
                a = parseInt(this.elStyles[this.axis[t].sizeAttr], 10),
                r = this.axis[t].scrollbar,
                l = this.contentWrapperEl[this.axis[t].scrollOffsetAttr],
                o =
                  (l =
                    "x" === t &&
                    this.isRtl &&
                    e.getRtlHelpers().isRtlScrollingInverted
                      ? -l
                      : l) /
                  (n - a),
                s = ~~((i - r.size) * o);
              (s =
                "x" === t &&
                this.isRtl &&
                e.getRtlHelpers().isRtlScrollbarInverted
                  ? s + (i - r.size)
                  : s),
                (r.el.style.transform =
                  "x" === t
                    ? "translate3d(" + s + "px, 0, 0)"
                    : "translate3d(0, " + s + "px, 0)");
            }
          }),
          (t.toggleTrackVisibility = function (e) {
            void 0 === e && (e = "y");
            var t = this.axis[e].track.el,
              n = this.axis[e].scrollbar.el;
            this.axis[e].isOverflowing || this.axis[e].forceVisible
              ? ((t.style.visibility = "visible"),
                (this.contentWrapperEl.style[this.axis[e].overflowAttr] =
                  "scroll"))
              : ((t.style.visibility = "hidden"),
                (this.contentWrapperEl.style[this.axis[e].overflowAttr] =
                  "hidden")),
              this.axis[e].isOverflowing
                ? (n.style.display = "block")
                : (n.style.display = "none");
          }),
          (t.hideNativeScrollbar = function () {
            (this.offsetEl.style[this.isRtl ? "left" : "right"] =
              this.axis.y.isOverflowing || this.axis.y.forceVisible
                ? "-" + this.scrollbarWidth + "px"
                : 0),
              (this.offsetEl.style.bottom =
                this.axis.x.isOverflowing || this.axis.x.forceVisible
                  ? "-" + this.scrollbarWidth + "px"
                  : 0);
          }),
          (t.onMouseMoveForAxis = function (e) {
            void 0 === e && (e = "y"),
              (this.axis[e].track.rect =
                this.axis[e].track.el.getBoundingClientRect()),
              (this.axis[e].scrollbar.rect =
                this.axis[e].scrollbar.el.getBoundingClientRect()),
              this.isWithinBounds(this.axis[e].scrollbar.rect)
                ? this.axis[e].scrollbar.el.classList.add(this.classNames.hover)
                : this.axis[e].scrollbar.el.classList.remove(
                    this.classNames.hover
                  ),
              this.isWithinBounds(this.axis[e].track.rect)
                ? (this.showScrollbar(e),
                  this.axis[e].track.el.classList.add(this.classNames.hover))
                : this.axis[e].track.el.classList.remove(this.classNames.hover);
          }),
          (t.onMouseLeaveForAxis = function (e) {
            void 0 === e && (e = "y"),
              this.axis[e].track.el.classList.remove(this.classNames.hover),
              this.axis[e].scrollbar.el.classList.remove(this.classNames.hover);
          }),
          (t.showScrollbar = function (e) {
            void 0 === e && (e = "y");
            var t = this.axis[e].scrollbar.el;
            this.axis[e].isVisible ||
              (t.classList.add(this.classNames.visible),
              (this.axis[e].isVisible = !0)),
              this.options.autoHide && this.hideScrollbars();
          }),
          (t.onDragStart = function (e, t) {
            void 0 === t && (t = "y");
            var n = sl(this.el),
              i = ol(this.el),
              a = this.axis[t].scrollbar,
              r = "y" === t ? e.pageY : e.pageX;
            (this.axis[t].dragOffset = r - a.rect[this.axis[t].offsetAttr]),
              (this.draggedAxis = t),
              this.el.classList.add(this.classNames.dragging),
              n.addEventListener("mousemove", this.drag, !0),
              n.addEventListener("mouseup", this.onEndDrag, !0),
              null === this.removePreventClickId
                ? (n.addEventListener("click", this.preventClick, !0),
                  n.addEventListener("dblclick", this.preventClick, !0))
                : (i.clearTimeout(this.removePreventClickId),
                  (this.removePreventClickId = null));
          }),
          (t.onTrackClick = function (e, t) {
            var n = this;
            if ((void 0 === t && (t = "y"), this.options.clickOnTrack)) {
              var i = ol(this.el);
              this.axis[t].scrollbar.rect =
                this.axis[t].scrollbar.el.getBoundingClientRect();
              var a = this.axis[t].scrollbar.rect[this.axis[t].offsetAttr],
                r = parseInt(this.elStyles[this.axis[t].sizeAttr], 10),
                l = this.contentWrapperEl[this.axis[t].scrollOffsetAttr],
                o =
                  ("y" === t ? this.mouseY - a : this.mouseX - a) < 0 ? -1 : 1,
                s = -1 === o ? l - r : l + r;
              !(function e() {
                var a, r;
                -1 === o
                  ? l > s &&
                    ((l -= n.options.clickOnTrackSpeed),
                    n.contentWrapperEl.scrollTo(
                      (((a = {})[n.axis[t].offsetAttr] = l), a)
                    ),
                    i.requestAnimationFrame(e))
                  : l < s &&
                    ((l += n.options.clickOnTrackSpeed),
                    n.contentWrapperEl.scrollTo(
                      (((r = {})[n.axis[t].offsetAttr] = l), r)
                    ),
                    i.requestAnimationFrame(e));
              })();
            }
          }),
          (t.getContentElement = function () {
            return this.contentEl;
          }),
          (t.getScrollElement = function () {
            return this.contentWrapperEl;
          }),
          (t.getScrollbarWidth = function () {
            try {
              return "none" ===
                getComputedStyle(this.contentWrapperEl, "::-webkit-scrollbar")
                  .display ||
                "scrollbarWidth" in document.documentElement.style ||
                "-ms-overflow-style" in document.documentElement.style
                ? 0
                : cl(this.el);
            } catch (e) {
              return cl(this.el);
            }
          }),
          (t.removeListeners = function () {
            var e = this,
              t = ol(this.el);
            this.options.autoHide &&
              this.el.removeEventListener("mouseenter", this.onMouseEnter),
              ["mousedown", "click", "dblclick"].forEach(function (t) {
                e.el.removeEventListener(t, e.onPointerEvent, !0);
              }),
              ["touchstart", "touchend", "touchmove"].forEach(function (t) {
                e.el.removeEventListener(t, e.onPointerEvent, {
                  capture: !0,
                  passive: !0,
                });
              }),
              this.el.removeEventListener("mousemove", this.onMouseMove),
              this.el.removeEventListener("mouseleave", this.onMouseLeave),
              this.contentWrapperEl &&
                this.contentWrapperEl.removeEventListener(
                  "scroll",
                  this.onScroll
                ),
              t.removeEventListener("resize", this.onWindowResize),
              this.mutationObserver && this.mutationObserver.disconnect(),
              this.resizeObserver && this.resizeObserver.disconnect(),
              this.recalculate.cancel(),
              this.onMouseMove.cancel(),
              this.hideScrollbars.cancel(),
              this.onWindowResize.cancel();
          }),
          (t.unMount = function () {
            this.removeListeners(), e.instances.delete(this.el);
          }),
          (t.isWithinBounds = function (e) {
            return (
              this.mouseX >= e.left &&
              this.mouseX <= e.left + e.width &&
              this.mouseY >= e.top &&
              this.mouseY <= e.top + e.height
            );
          }),
          (t.findChild = function (e, t) {
            var n =
              e.matches ||
              e.webkitMatchesSelector ||
              e.mozMatchesSelector ||
              e.msMatchesSelector;
            return Array.prototype.filter.call(e.children, function (e) {
              return n.call(e, t);
            })[0];
          }),
          e
        );
      })();
      (hl.defaultOptions = {
        autoHide: !0,
        forceVisible: !1,
        clickOnTrack: !0,
        clickOnTrackSpeed: 40,
        classNames: {
          contentEl: "simplebar-content",
          contentWrapper: "simplebar-content-wrapper",
          offset: "simplebar-offset",
          mask: "simplebar-mask",
          wrapper: "simplebar-wrapper",
          placeholder: "simplebar-placeholder",
          scrollbar: "simplebar-scrollbar",
          track: "simplebar-track",
          heightAutoObserverWrapperEl: "simplebar-height-auto-observer-wrapper",
          heightAutoObserverEl: "simplebar-height-auto-observer",
          visible: "simplebar-visible",
          horizontal: "simplebar-horizontal",
          vertical: "simplebar-vertical",
          hover: "simplebar-hover",
          dragging: "simplebar-dragging",
        },
        scrollbarMinSize: 25,
        scrollbarMaxSize: 0,
        timeout: 1e3,
      }),
        (hl.instances = new WeakMap()),
        (hl.initDOMLoadedElements = function () {
          document.removeEventListener(
            "DOMContentLoaded",
            this.initDOMLoadedElements
          ),
            window.removeEventListener("load", this.initDOMLoadedElements),
            Array.prototype.forEach.call(
              document.querySelectorAll("[data-simplebar]"),
              function (e) {
                "init" === e.getAttribute("data-simplebar") ||
                  hl.instances.has(e) ||
                  new hl(e, ll(e.attributes));
              }
            );
        }),
        (hl.removeObserver = function () {
          this.globalObserver.disconnect();
        }),
        (hl.initHtmlApi = function () {
          (this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this)),
            "undefined" != typeof MutationObserver &&
              ((this.globalObserver = new MutationObserver(hl.handleMutations)),
              this.globalObserver.observe(document, {
                childList: !0,
                subtree: !0,
              })),
            "complete" === document.readyState ||
            ("loading" !== document.readyState &&
              !document.documentElement.doScroll)
              ? window.setTimeout(this.initDOMLoadedElements)
              : (document.addEventListener(
                  "DOMContentLoaded",
                  this.initDOMLoadedElements
                ),
                window.addEventListener("load", this.initDOMLoadedElements));
        }),
        (hl.handleMutations = function (e) {
          e.forEach(function (e) {
            Array.prototype.forEach.call(e.addedNodes, function (e) {
              1 === e.nodeType &&
                (e.hasAttribute("data-simplebar")
                  ? !hl.instances.has(e) &&
                    document.documentElement.contains(e) &&
                    new hl(e, ll(e.attributes))
                  : Array.prototype.forEach.call(
                      e.querySelectorAll("[data-simplebar]"),
                      function (e) {
                        "init" !== e.getAttribute("data-simplebar") &&
                          !hl.instances.has(e) &&
                          document.documentElement.contains(e) &&
                          new hl(e, ll(e.attributes));
                      }
                    ));
            }),
              Array.prototype.forEach.call(e.removedNodes, function (e) {
                1 === e.nodeType &&
                  ("init" === e.getAttribute("data-simplebar")
                    ? hl.instances.has(e) &&
                      !document.documentElement.contains(e) &&
                      hl.instances.get(e).unMount()
                    : Array.prototype.forEach.call(
                        e.querySelectorAll('[data-simplebar="init"]'),
                        function (e) {
                          hl.instances.has(e) &&
                            !document.documentElement.contains(e) &&
                            hl.instances.get(e).unMount();
                        }
                      ));
              });
          });
        }),
        (hl.getOptions = ll),
        fr() && hl.initHtmlApi();
      var ml = hl;
      const fl = () => {
          if (document.getElementsByClassName("js-simplebar")[0]) {
            const e = new ml(
              document.getElementsByClassName("js-simplebar")[0]
            );
            document
              .querySelectorAll(".js-sidebar [data-bs-parent]")
              .forEach((t) => {
                t.addEventListener("shown.bs.collapse", () => {
                  e.recalculate();
                }),
                  t.addEventListener("hidden.bs.collapse", () => {
                    e.recalculate();
                  });
              });
          }
        },
        _l = () => {
          const e = document.getElementsByClassName("js-sidebar")[0],
            t = document.getElementsByClassName("js-sidebar-toggle")[0];
          e &&
            t &&
            t.addEventListener("click", () => {
              e.classList.toggle("collapsed"),
                e.addEventListener("transitionend", () => {
                  window.dispatchEvent(new Event("resize"));
                });
            });
        };
      document.addEventListener("DOMContentLoaded", () => (fl(), void _l()));
      n(5657);
      var pl = n(8508),
        gl = n.n(pl);
      document.addEventListener("DOMContentLoaded", () => {
        try {
          gl().replace();
        } catch (e) {
          console.log(
            "You might have made a typo with one of the feather icons"
          ),
            console.log(e);
        }
      }),
        (window.feather = gl());
      var yl = n(7757),
        vl = n.n(yl);
      (vl().defaults.global.defaultFontColor = window.theme["gray-600"]),
        (vl().defaults.global.defaultFontFamily =
          "'Inter', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif"),
        (window.Chart = vl());
      var Ml = [
          "onChange",
          "onClose",
          "onDayCreate",
          "onDestroy",
          "onKeyDown",
          "onMonthChange",
          "onOpen",
          "onParseConfig",
          "onReady",
          "onValueUpdate",
          "onYearChange",
          "onPreCalendarPosition",
        ],
        bl = {
          _disable: [],
          allowInput: !1,
          allowInvalidPreload: !1,
          altFormat: "F j, Y",
          altInput: !1,
          altInputClass: "form-control input",
          animate:
            "object" == typeof window &&
            -1 === window.navigator.userAgent.indexOf("MSIE"),
          ariaDateFormat: "F j, Y",
          autoFillDefaultTime: !0,
          clickOpens: !0,
          closeOnSelect: !0,
          conjunction: ", ",
          dateFormat: "Y-m-d",
          defaultHour: 12,
          defaultMinute: 0,
          defaultSeconds: 0,
          disable: [],
          disableMobile: !1,
          enableSeconds: !1,
          enableTime: !1,
          errorHandler: function (e) {
            return "undefined" != typeof console && console.warn(e);
          },
          getWeek: function (e) {
            var t = new Date(e.getTime());
            t.setHours(0, 0, 0, 0),
              t.setDate(t.getDate() + 3 - ((t.getDay() + 6) % 7));
            var n = new Date(t.getFullYear(), 0, 4);
            return (
              1 +
              Math.round(
                ((t.getTime() - n.getTime()) / 864e5 -
                  3 +
                  ((n.getDay() + 6) % 7)) /
                  7
              )
            );
          },
          hourIncrement: 1,
          ignoredFocusElements: [],
          inline: !1,
          locale: "default",
          minuteIncrement: 5,
          mode: "single",
          monthSelectorType: "dropdown",
          nextArrow:
            "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M13.207 8.472l-7.854 7.854-0.707-0.707 7.146-7.146-7.146-7.148 0.707-0.707 7.854 7.854z' /></svg>",
          noCalendar: !1,
          now: new Date(),
          onChange: [],
          onClose: [],
          onDayCreate: [],
          onDestroy: [],
          onKeyDown: [],
          onMonthChange: [],
          onOpen: [],
          onParseConfig: [],
          onReady: [],
          onValueUpdate: [],
          onYearChange: [],
          onPreCalendarPosition: [],
          plugins: [],
          position: "auto",
          positionElement: void 0,
          prevArrow:
            "<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' viewBox='0 0 17 17'><g></g><path d='M5.207 8.471l7.146 7.147-0.707 0.707-7.853-7.854 7.854-7.853 0.707 0.707-7.147 7.146z' /></svg>",
          shorthandCurrentMonth: !1,
          showMonths: 1,
          static: !1,
          time_24hr: !1,
          weekNumbers: !1,
          wrap: !1,
        },
        xl = {
          weekdays: {
            shorthand: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            longhand: [
              "Sunday",
              "Monday",
              "Tuesday",
              "Wednesday",
              "Thursday",
              "Friday",
              "Saturday",
            ],
          },
          months: {
            shorthand: [
              "Jan",
              "Feb",
              "Mar",
              "Apr",
              "May",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Oct",
              "Nov",
              "Dec",
            ],
            longhand: [
              "January",
              "February",
              "March",
              "April",
              "May",
              "June",
              "July",
              "August",
              "September",
              "October",
              "November",
              "December",
            ],
          },
          daysInMonth: [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31],
          firstDayOfWeek: 0,
          ordinal: function (e) {
            var t = e % 100;
            if (t > 3 && t < 21) return "th";
            switch (t % 10) {
              case 1:
                return "st";
              case 2:
                return "nd";
              case 3:
                return "rd";
              default:
                return "th";
            }
          },
          rangeSeparator: " to ",
          weekAbbreviation: "Wk",
          scrollTitle: "Scroll to increment",
          toggleTitle: "Click to toggle",
          amPM: ["AM", "PM"],
          yearAriaLabel: "Year",
          monthAriaLabel: "Month",
          hourAriaLabel: "Hour",
          minuteAriaLabel: "Minute",
          time_24hr: !1,
        },
        Ll = xl,
        wl = function (e, t) {
          return void 0 === t && (t = 2), ("000" + e).slice(-1 * t);
        },
        kl = function (e) {
          return !0 === e ? 1 : 0;
        };
      function Yl(e, t) {
        var n;
        return function () {
          var i = this,
            a = arguments;
          clearTimeout(n),
            (n = setTimeout(function () {
              return e.apply(i, a);
            }, t));
        };
      }
      var Dl = function (e) {
        return e instanceof Array ? e : [e];
      };
      function Tl(e, t, n) {
        if (!0 === n) return e.classList.add(t);
        e.classList.remove(t);
      }
      function Sl(e, t, n) {
        var i = window.document.createElement(e);
        return (
          (t = t || ""),
          (n = n || ""),
          (i.className = t),
          void 0 !== n && (i.textContent = n),
          i
        );
      }
      function jl(e) {
        for (; e.firstChild; ) e.removeChild(e.firstChild);
      }
      function Ol(e, t) {
        return t(e) ? e : e.parentNode ? Ol(e.parentNode, t) : void 0;
      }
      function Al(e, t) {
        var n = Sl("div", "numInputWrapper"),
          i = Sl("input", "numInput " + e),
          a = Sl("span", "arrowUp"),
          r = Sl("span", "arrowDown");
        if (
          (-1 === navigator.userAgent.indexOf("MSIE 9.0")
            ? (i.type = "number")
            : ((i.type = "text"), (i.pattern = "\\d*")),
          void 0 !== t)
        )
          for (var l in t) i.setAttribute(l, t[l]);
        return n.appendChild(i), n.appendChild(a), n.appendChild(r), n;
      }
      function Hl(e) {
        try {
          return "function" == typeof e.composedPath
            ? e.composedPath()[0]
            : e.target;
        } catch (t) {
          return e.target;
        }
      }
      var El = function () {},
        Cl = function (e, t, n) {
          return n.months[t ? "shorthand" : "longhand"][e];
        },
        Pl = {
          D: El,
          F: function (e, t, n) {
            e.setMonth(n.months.longhand.indexOf(t));
          },
          G: function (e, t) {
            e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(t));
          },
          H: function (e, t) {
            e.setHours(parseFloat(t));
          },
          J: function (e, t) {
            e.setDate(parseFloat(t));
          },
          K: function (e, t, n) {
            e.setHours(
              (e.getHours() % 12) + 12 * kl(new RegExp(n.amPM[1], "i").test(t))
            );
          },
          M: function (e, t, n) {
            e.setMonth(n.months.shorthand.indexOf(t));
          },
          S: function (e, t) {
            e.setSeconds(parseFloat(t));
          },
          U: function (e, t) {
            return new Date(1e3 * parseFloat(t));
          },
          W: function (e, t, n) {
            var i = parseInt(t),
              a = new Date(e.getFullYear(), 0, 2 + 7 * (i - 1), 0, 0, 0, 0);
            return a.setDate(a.getDate() - a.getDay() + n.firstDayOfWeek), a;
          },
          Y: function (e, t) {
            e.setFullYear(parseFloat(t));
          },
          Z: function (e, t) {
            return new Date(t);
          },
          d: function (e, t) {
            e.setDate(parseFloat(t));
          },
          h: function (e, t) {
            e.setHours((e.getHours() >= 12 ? 12 : 0) + parseFloat(t));
          },
          i: function (e, t) {
            e.setMinutes(parseFloat(t));
          },
          j: function (e, t) {
            e.setDate(parseFloat(t));
          },
          l: El,
          m: function (e, t) {
            e.setMonth(parseFloat(t) - 1);
          },
          n: function (e, t) {
            e.setMonth(parseFloat(t) - 1);
          },
          s: function (e, t) {
            e.setSeconds(parseFloat(t));
          },
          u: function (e, t) {
            return new Date(parseFloat(t));
          },
          w: El,
          y: function (e, t) {
            e.setFullYear(2e3 + parseFloat(t));
          },
        },
        Fl = {
          D: "",
          F: "",
          G: "(\\d\\d|\\d)",
          H: "(\\d\\d|\\d)",
          J: "(\\d\\d|\\d)\\w+",
          K: "",
          M: "",
          S: "(\\d\\d|\\d)",
          U: "(.+)",
          W: "(\\d\\d|\\d)",
          Y: "(\\d{4})",
          Z: "(.+)",
          d: "(\\d\\d|\\d)",
          h: "(\\d\\d|\\d)",
          i: "(\\d\\d|\\d)",
          j: "(\\d\\d|\\d)",
          l: "",
          m: "(\\d\\d|\\d)",
          n: "(\\d\\d|\\d)",
          s: "(\\d\\d|\\d)",
          u: "(.+)",
          w: "(\\d\\d|\\d)",
          y: "(\\d{2})",
        },
        Il = {
          Z: function (e) {
            return e.toISOString();
          },
          D: function (e, t, n) {
            return t.weekdays.shorthand[Il.w(e, t, n)];
          },
          F: function (e, t, n) {
            return Cl(Il.n(e, t, n) - 1, !1, t);
          },
          G: function (e, t, n) {
            return wl(Il.h(e, t, n));
          },
          H: function (e) {
            return wl(e.getHours());
          },
          J: function (e, t) {
            return void 0 !== t.ordinal
              ? e.getDate() + t.ordinal(e.getDate())
              : e.getDate();
          },
          K: function (e, t) {
            return t.amPM[kl(e.getHours() > 11)];
          },
          M: function (e, t) {
            return Cl(e.getMonth(), !0, t);
          },
          S: function (e) {
            return wl(e.getSeconds());
          },
          U: function (e) {
            return e.getTime() / 1e3;
          },
          W: function (e, t, n) {
            return n.getWeek(e);
          },
          Y: function (e) {
            return wl(e.getFullYear(), 4);
          },
          d: function (e) {
            return wl(e.getDate());
          },
          h: function (e) {
            return e.getHours() % 12 ? e.getHours() % 12 : 12;
          },
          i: function (e) {
            return wl(e.getMinutes());
          },
          j: function (e) {
            return e.getDate();
          },
          l: function (e, t) {
            return t.weekdays.longhand[e.getDay()];
          },
          m: function (e) {
            return wl(e.getMonth() + 1);
          },
          n: function (e) {
            return e.getMonth() + 1;
          },
          s: function (e) {
            return e.getSeconds();
          },
          u: function (e) {
            return e.getTime();
          },
          w: function (e) {
            return e.getDay();
          },
          y: function (e) {
            return String(e.getFullYear()).substring(2);
          },
        },
        Wl = function (e) {
          var t = e.config,
            n = void 0 === t ? bl : t,
            i = e.l10n,
            a = void 0 === i ? xl : i,
            r = e.isMobile,
            l = void 0 !== r && r;
          return function (e, t, i) {
            var r = i || a;
            return void 0 === n.formatDate || l
              ? t
                  .split("")
                  .map(function (t, i, a) {
                    return Il[t] && "\\" !== a[i - 1]
                      ? Il[t](e, r, n)
                      : "\\" !== t
                      ? t
                      : "";
                  })
                  .join("")
              : n.formatDate(e, t, r);
          };
        },
        zl = function (e) {
          var t = e.config,
            n = void 0 === t ? bl : t,
            i = e.l10n,
            a = void 0 === i ? xl : i;
          return function (e, t, i, r) {
            if (0 === e || e) {
              var l,
                o = r || a,
                s = e;
              if (e instanceof Date) l = new Date(e.getTime());
              else if ("string" != typeof e && void 0 !== e.toFixed)
                l = new Date(e);
              else if ("string" == typeof e) {
                var d = t || (n || bl).dateFormat,
                  u = String(e).trim();
                if ("today" === u) (l = new Date()), (i = !0);
                else if (n && n.parseDate) l = n.parseDate(e, d);
                else if (/Z$/.test(u) || /GMT$/.test(u)) l = new Date(e);
                else {
                  for (
                    var c = void 0, h = [], m = 0, f = 0, _ = "";
                    m < d.length;
                    m++
                  ) {
                    var p = d[m],
                      g = "\\" === p,
                      y = "\\" === d[m - 1] || g;
                    if (Fl[p] && !y) {
                      _ += Fl[p];
                      var v = new RegExp(_).exec(e);
                      v &&
                        (c = !0) &&
                        h["Y" !== p ? "push" : "unshift"]({
                          fn: Pl[p],
                          val: v[++f],
                        });
                    } else g || (_ += ".");
                  }
                  (l =
                    n && n.noCalendar
                      ? new Date(new Date().setHours(0, 0, 0, 0))
                      : new Date(new Date().getFullYear(), 0, 1, 0, 0, 0, 0)),
                    h.forEach(function (e) {
                      var t = e.fn,
                        n = e.val;
                      return (l = t(l, n, o) || l);
                    }),
                    (l = c ? l : void 0);
                }
              }
              if (l instanceof Date && !isNaN(l.getTime()))
                return !0 === i && l.setHours(0, 0, 0, 0), l;
              n.errorHandler(new Error("Invalid date provided: " + s));
            }
          };
        };
      function Nl(e, t, n) {
        return (
          void 0 === n && (n = !0),
          !1 !== n
            ? new Date(e.getTime()).setHours(0, 0, 0, 0) -
              new Date(t.getTime()).setHours(0, 0, 0, 0)
            : e.getTime() - t.getTime()
        );
      }
      var Rl = function (e, t, n) {
          return e > Math.min(t, n) && e < Math.max(t, n);
        },
        Bl = function (e, t, n) {
          return 3600 * e + 60 * t + n;
        },
        Vl = function (e) {
          var t = Math.floor(e / 3600),
            n = (e - 3600 * t) / 60;
          return [t, n, e - 3600 * t - 60 * n];
        },
        Zl = { DAY: 864e5 };
      function Ul(e) {
        var t = e.defaultHour,
          n = e.defaultMinute,
          i = e.defaultSeconds;
        if (void 0 !== e.minDate) {
          var a = e.minDate.getHours(),
            r = e.minDate.getMinutes(),
            l = e.minDate.getSeconds();
          t < a && (t = a),
            t === a && n < r && (n = r),
            t === a && n === r && i < l && (i = e.minDate.getSeconds());
        }
        if (void 0 !== e.maxDate) {
          var o = e.maxDate.getHours(),
            s = e.maxDate.getMinutes();
          (t = Math.min(t, o)) === o && (n = Math.min(s, n)),
            t === o && n === s && (i = e.maxDate.getSeconds());
        }
        return { hours: t, minutes: n, seconds: i };
      }
      n(1895);
      var $l = function () {
          return (
            ($l =
              Object.assign ||
              function (e) {
                for (var t, n = 1, i = arguments.length; n < i; n++)
                  for (var a in (t = arguments[n]))
                    Object.prototype.hasOwnProperty.call(t, a) && (e[a] = t[a]);
                return e;
              }),
            $l.apply(this, arguments)
          );
        },
        Jl = function () {
          for (var e = 0, t = 0, n = arguments.length; t < n; t++)
            e += arguments[t].length;
          var i = Array(e),
            a = 0;
          for (t = 0; t < n; t++)
            for (var r = arguments[t], l = 0, o = r.length; l < o; l++, a++)
              i[a] = r[l];
          return i;
        },
        ql = 300;
      function Gl(e, t) {
        var n = { config: $l($l({}, bl), Kl.defaultConfig), l10n: Ll };
        function i() {
          var e;
          return (
            (null === (e = n.calendarContainer) || void 0 === e
              ? void 0
              : e.getRootNode()
            ).activeElement || document.activeElement
          );
        }
        function a(e) {
          return e.bind(n);
        }
        function r() {
          var e = n.config;
          (!1 === e.weekNumbers && 1 === e.showMonths) ||
            (!0 !== e.noCalendar &&
              window.requestAnimationFrame(function () {
                if (
                  (void 0 !== n.calendarContainer &&
                    ((n.calendarContainer.style.visibility = "hidden"),
                    (n.calendarContainer.style.display = "block")),
                  void 0 !== n.daysContainer)
                ) {
                  var t = (n.days.offsetWidth + 1) * e.showMonths;
                  (n.daysContainer.style.width = t + "px"),
                    (n.calendarContainer.style.width =
                      t +
                      (void 0 !== n.weekWrapper
                        ? n.weekWrapper.offsetWidth
                        : 0) +
                      "px"),
                    n.calendarContainer.style.removeProperty("visibility"),
                    n.calendarContainer.style.removeProperty("display");
                }
              }));
        }
        function l(e) {
          if (0 === n.selectedDates.length) {
            var t =
                void 0 === n.config.minDate ||
                Nl(new Date(), n.config.minDate) >= 0
                  ? new Date()
                  : new Date(n.config.minDate.getTime()),
              i = Ul(n.config);
            t.setHours(i.hours, i.minutes, i.seconds, t.getMilliseconds()),
              (n.selectedDates = [t]),
              (n.latestSelectedDateObj = t);
          }
          void 0 !== e &&
            "blur" !== e.type &&
            (function (e) {
              e.preventDefault();
              var t = "keydown" === e.type,
                i = Hl(e),
                a = i;
              void 0 !== n.amPM &&
                i === n.amPM &&
                (n.amPM.textContent =
                  n.l10n.amPM[kl(n.amPM.textContent === n.l10n.amPM[0])]);
              var r = parseFloat(a.getAttribute("min")),
                l = parseFloat(a.getAttribute("max")),
                o = parseFloat(a.getAttribute("step")),
                s = parseInt(a.value, 10),
                d = e.delta || (t ? (38 === e.which ? 1 : -1) : 0),
                u = s + o * d;
              if (void 0 !== a.value && 2 === a.value.length) {
                var c = a === n.hourElement,
                  h = a === n.minuteElement;
                u < r
                  ? ((u = l + u + kl(!c) + (kl(c) && kl(!n.amPM))),
                    h && _(void 0, -1, n.hourElement))
                  : u > l &&
                    ((u = a === n.hourElement ? u - l - kl(!n.amPM) : r),
                    h && _(void 0, 1, n.hourElement)),
                  n.amPM &&
                    c &&
                    (1 === o ? u + s === 23 : Math.abs(u - s) > o) &&
                    (n.amPM.textContent =
                      n.l10n.amPM[kl(n.amPM.textContent === n.l10n.amPM[0])]),
                  (a.value = wl(u));
              }
            })(e);
          var a = n._input.value;
          o(), Q(), n._input.value !== a && n._debouncedChange();
        }
        function o() {
          if (void 0 !== n.hourElement && void 0 !== n.minuteElement) {
            var e,
              t,
              i = (parseInt(n.hourElement.value.slice(-2), 10) || 0) % 24,
              a = (parseInt(n.minuteElement.value, 10) || 0) % 60,
              r =
                void 0 !== n.secondElement
                  ? (parseInt(n.secondElement.value, 10) || 0) % 60
                  : 0;
            void 0 !== n.amPM &&
              ((e = i),
              (t = n.amPM.textContent),
              (i = (e % 12) + 12 * kl(t === n.l10n.amPM[1])));
            var l =
                void 0 !== n.config.minTime ||
                (n.config.minDate &&
                  n.minDateHasTime &&
                  n.latestSelectedDateObj &&
                  0 === Nl(n.latestSelectedDateObj, n.config.minDate, !0)),
              o =
                void 0 !== n.config.maxTime ||
                (n.config.maxDate &&
                  n.maxDateHasTime &&
                  n.latestSelectedDateObj &&
                  0 === Nl(n.latestSelectedDateObj, n.config.maxDate, !0));
            if (
              void 0 !== n.config.maxTime &&
              void 0 !== n.config.minTime &&
              n.config.minTime > n.config.maxTime
            ) {
              var s = Bl(
                  n.config.minTime.getHours(),
                  n.config.minTime.getMinutes(),
                  n.config.minTime.getSeconds()
                ),
                u = Bl(
                  n.config.maxTime.getHours(),
                  n.config.maxTime.getMinutes(),
                  n.config.maxTime.getSeconds()
                ),
                c = Bl(i, a, r);
              if (c > u && c < s) {
                var h = Vl(s);
                (i = h[0]), (a = h[1]), (r = h[2]);
              }
            } else {
              if (o) {
                var m =
                  void 0 !== n.config.maxTime
                    ? n.config.maxTime
                    : n.config.maxDate;
                (i = Math.min(i, m.getHours())) === m.getHours() &&
                  (a = Math.min(a, m.getMinutes())),
                  a === m.getMinutes() && (r = Math.min(r, m.getSeconds()));
              }
              if (l) {
                var f =
                  void 0 !== n.config.minTime
                    ? n.config.minTime
                    : n.config.minDate;
                (i = Math.max(i, f.getHours())) === f.getHours() &&
                  a < f.getMinutes() &&
                  (a = f.getMinutes()),
                  a === f.getMinutes() && (r = Math.max(r, f.getSeconds()));
              }
            }
            d(i, a, r);
          }
        }
        function s(e) {
          var t = e || n.latestSelectedDateObj;
          t &&
            t instanceof Date &&
            d(t.getHours(), t.getMinutes(), t.getSeconds());
        }
        function d(e, t, i) {
          void 0 !== n.latestSelectedDateObj &&
            n.latestSelectedDateObj.setHours(e % 24, t, i || 0, 0),
            n.hourElement &&
              n.minuteElement &&
              !n.isMobile &&
              ((n.hourElement.value = wl(
                n.config.time_24hr ? e : ((12 + e) % 12) + 12 * kl(e % 12 == 0)
              )),
              (n.minuteElement.value = wl(t)),
              void 0 !== n.amPM &&
                (n.amPM.textContent = n.l10n.amPM[kl(e >= 12)]),
              void 0 !== n.secondElement && (n.secondElement.value = wl(i)));
        }
        function u(e) {
          var t = Hl(e),
            n = parseInt(t.value) + (e.delta || 0);
          (n / 1e3 > 1 || ("Enter" === e.key && !/[^\d]/.test(n.toString()))) &&
            j(n);
        }
        function c(e, t, i, a) {
          return t instanceof Array
            ? t.forEach(function (t) {
                return c(e, t, i, a);
              })
            : e instanceof Array
            ? e.forEach(function (e) {
                return c(e, t, i, a);
              })
            : (e.addEventListener(t, i, a),
              void n._handlers.push({
                remove: function () {
                  return e.removeEventListener(t, i, a);
                },
              }));
        }
        function h() {
          J("onChange");
        }
        function m(e, t) {
          var i =
              void 0 !== e
                ? n.parseDate(e)
                : n.latestSelectedDateObj ||
                  (n.config.minDate && n.config.minDate > n.now
                    ? n.config.minDate
                    : n.config.maxDate && n.config.maxDate < n.now
                    ? n.config.maxDate
                    : n.now),
            a = n.currentYear,
            r = n.currentMonth;
          try {
            void 0 !== i &&
              ((n.currentYear = i.getFullYear()),
              (n.currentMonth = i.getMonth()));
          } catch (e) {
            (e.message = "Invalid date supplied: " + i),
              n.config.errorHandler(e);
          }
          t && n.currentYear !== a && (J("onYearChange"), x()),
            !t ||
              (n.currentYear === a && n.currentMonth === r) ||
              J("onMonthChange"),
            n.redraw();
        }
        function f(e) {
          var t = Hl(e);
          ~t.className.indexOf("arrow") &&
            _(e, t.classList.contains("arrowUp") ? 1 : -1);
        }
        function _(e, t, n) {
          var i = e && Hl(e),
            a = n || (i && i.parentNode && i.parentNode.firstChild),
            r = q("increment");
          (r.delta = t), a && a.dispatchEvent(r);
        }
        function p(e, t, i, a) {
          var r = O(t, !0),
            l = Sl("span", e, t.getDate().toString());
          return (
            (l.dateObj = t),
            (l.$i = a),
            l.setAttribute(
              "aria-label",
              n.formatDate(t, n.config.ariaDateFormat)
            ),
            -1 === e.indexOf("hidden") &&
              0 === Nl(t, n.now) &&
              ((n.todayDateElem = l),
              l.classList.add("today"),
              l.setAttribute("aria-current", "date")),
            r
              ? ((l.tabIndex = -1),
                G(t) &&
                  (l.classList.add("selected"),
                  (n.selectedDateElem = l),
                  "range" === n.config.mode &&
                    (Tl(
                      l,
                      "startRange",
                      n.selectedDates[0] && 0 === Nl(t, n.selectedDates[0], !0)
                    ),
                    Tl(
                      l,
                      "endRange",
                      n.selectedDates[1] && 0 === Nl(t, n.selectedDates[1], !0)
                    ),
                    "nextMonthDay" === e && l.classList.add("inRange"))))
              : l.classList.add("flatpickr-disabled"),
            "range" === n.config.mode &&
              (function (e) {
                return (
                  !("range" !== n.config.mode || n.selectedDates.length < 2) &&
                  Nl(e, n.selectedDates[0]) >= 0 &&
                  Nl(e, n.selectedDates[1]) <= 0
                );
              })(t) &&
              !G(t) &&
              l.classList.add("inRange"),
            n.weekNumbers &&
              1 === n.config.showMonths &&
              "prevMonthDay" !== e &&
              a % 7 == 6 &&
              n.weekNumbers.insertAdjacentHTML(
                "beforeend",
                "<span class='flatpickr-day'>" + n.config.getWeek(t) + "</span>"
              ),
            J("onDayCreate", l),
            l
          );
        }
        function g(e) {
          e.focus(), "range" === n.config.mode && C(e);
        }
        function y(e) {
          for (
            var t = e > 0 ? 0 : n.config.showMonths - 1,
              i = e > 0 ? n.config.showMonths : -1,
              a = t;
            a != i;
            a += e
          )
            for (
              var r = n.daysContainer.children[a],
                l = e > 0 ? 0 : r.children.length - 1,
                o = e > 0 ? r.children.length : -1,
                s = l;
              s != o;
              s += e
            ) {
              var d = r.children[s];
              if (-1 === d.className.indexOf("hidden") && O(d.dateObj))
                return d;
            }
        }
        function v(e, t) {
          var a = i(),
            r = A(a || document.body),
            l =
              void 0 !== e
                ? e
                : r
                ? a
                : void 0 !== n.selectedDateElem && A(n.selectedDateElem)
                ? n.selectedDateElem
                : void 0 !== n.todayDateElem && A(n.todayDateElem)
                ? n.todayDateElem
                : y(t > 0 ? 1 : -1);
          void 0 === l
            ? n._input.focus()
            : r
            ? (function (e, t) {
                for (
                  var i =
                      -1 === e.className.indexOf("Month")
                        ? e.dateObj.getMonth()
                        : n.currentMonth,
                    a = t > 0 ? n.config.showMonths : -1,
                    r = t > 0 ? 1 : -1,
                    l = i - n.currentMonth;
                  l != a;
                  l += r
                )
                  for (
                    var o = n.daysContainer.children[l],
                      s =
                        i - n.currentMonth === l
                          ? e.$i + t
                          : t < 0
                          ? o.children.length - 1
                          : 0,
                      d = o.children.length,
                      u = s;
                    u >= 0 && u < d && u != (t > 0 ? d : -1);
                    u += r
                  ) {
                    var c = o.children[u];
                    if (
                      -1 === c.className.indexOf("hidden") &&
                      O(c.dateObj) &&
                      Math.abs(e.$i - u) >= Math.abs(t)
                    )
                      return g(c);
                  }
                n.changeMonth(r), v(y(r), 0);
              })(l, t)
            : g(l);
        }
        function M(e, t) {
          for (
            var i =
                (new Date(e, t, 1).getDay() - n.l10n.firstDayOfWeek + 7) % 7,
              a = n.utils.getDaysInMonth((t - 1 + 12) % 12, e),
              r = n.utils.getDaysInMonth(t, e),
              l = window.document.createDocumentFragment(),
              o = n.config.showMonths > 1,
              s = o ? "prevMonthDay hidden" : "prevMonthDay",
              d = o ? "nextMonthDay hidden" : "nextMonthDay",
              u = a + 1 - i,
              c = 0;
            u <= a;
            u++, c++
          )
            l.appendChild(p("flatpickr-day " + s, new Date(e, t - 1, u), 0, c));
          for (u = 1; u <= r; u++, c++)
            l.appendChild(p("flatpickr-day", new Date(e, t, u), 0, c));
          for (
            var h = r + 1;
            h <= 42 - i && (1 === n.config.showMonths || c % 7 != 0);
            h++, c++
          )
            l.appendChild(
              p("flatpickr-day " + d, new Date(e, t + 1, h % r), 0, c)
            );
          var m = Sl("div", "dayContainer");
          return m.appendChild(l), m;
        }
        function b() {
          if (void 0 !== n.daysContainer) {
            jl(n.daysContainer), n.weekNumbers && jl(n.weekNumbers);
            for (
              var e = document.createDocumentFragment(), t = 0;
              t < n.config.showMonths;
              t++
            ) {
              var i = new Date(n.currentYear, n.currentMonth, 1);
              i.setMonth(n.currentMonth + t),
                e.appendChild(M(i.getFullYear(), i.getMonth()));
            }
            n.daysContainer.appendChild(e),
              (n.days = n.daysContainer.firstChild),
              "range" === n.config.mode && 1 === n.selectedDates.length && C();
          }
        }
        function x() {
          if (
            !(
              n.config.showMonths > 1 ||
              "dropdown" !== n.config.monthSelectorType
            )
          ) {
            var e = function (e) {
              return (
                !(
                  void 0 !== n.config.minDate &&
                  n.currentYear === n.config.minDate.getFullYear() &&
                  e < n.config.minDate.getMonth()
                ) &&
                !(
                  void 0 !== n.config.maxDate &&
                  n.currentYear === n.config.maxDate.getFullYear() &&
                  e > n.config.maxDate.getMonth()
                )
              );
            };
            (n.monthsDropdownContainer.tabIndex = -1),
              (n.monthsDropdownContainer.innerHTML = "");
            for (var t = 0; t < 12; t++)
              if (e(t)) {
                var i = Sl("option", "flatpickr-monthDropdown-month");
                (i.value = new Date(n.currentYear, t).getMonth().toString()),
                  (i.textContent = Cl(
                    t,
                    n.config.shorthandCurrentMonth,
                    n.l10n
                  )),
                  (i.tabIndex = -1),
                  n.currentMonth === t && (i.selected = !0),
                  n.monthsDropdownContainer.appendChild(i);
              }
          }
        }
        function L() {
          var e,
            t = Sl("div", "flatpickr-month"),
            i = window.document.createDocumentFragment();
          n.config.showMonths > 1 || "static" === n.config.monthSelectorType
            ? (e = Sl("span", "cur-month"))
            : ((n.monthsDropdownContainer = Sl(
                "select",
                "flatpickr-monthDropdown-months"
              )),
              n.monthsDropdownContainer.setAttribute(
                "aria-label",
                n.l10n.monthAriaLabel
              ),
              c(n.monthsDropdownContainer, "change", function (e) {
                var t = Hl(e),
                  i = parseInt(t.value, 10);
                n.changeMonth(i - n.currentMonth), J("onMonthChange");
              }),
              x(),
              (e = n.monthsDropdownContainer));
          var a = Al("cur-year", { tabindex: "-1" }),
            r = a.getElementsByTagName("input")[0];
          r.setAttribute("aria-label", n.l10n.yearAriaLabel),
            n.config.minDate &&
              r.setAttribute("min", n.config.minDate.getFullYear().toString()),
            n.config.maxDate &&
              (r.setAttribute("max", n.config.maxDate.getFullYear().toString()),
              (r.disabled =
                !!n.config.minDate &&
                n.config.minDate.getFullYear() ===
                  n.config.maxDate.getFullYear()));
          var l = Sl("div", "flatpickr-current-month");
          return (
            l.appendChild(e),
            l.appendChild(a),
            i.appendChild(l),
            t.appendChild(i),
            { container: t, yearElement: r, monthElement: e }
          );
        }
        function w() {
          jl(n.monthNav),
            n.monthNav.appendChild(n.prevMonthNav),
            n.config.showMonths &&
              ((n.yearElements = []), (n.monthElements = []));
          for (var e = n.config.showMonths; e--; ) {
            var t = L();
            n.yearElements.push(t.yearElement),
              n.monthElements.push(t.monthElement),
              n.monthNav.appendChild(t.container);
          }
          n.monthNav.appendChild(n.nextMonthNav);
        }
        function k() {
          n.weekdayContainer
            ? jl(n.weekdayContainer)
            : (n.weekdayContainer = Sl("div", "flatpickr-weekdays"));
          for (var e = n.config.showMonths; e--; ) {
            var t = Sl("div", "flatpickr-weekdaycontainer");
            n.weekdayContainer.appendChild(t);
          }
          return Y(), n.weekdayContainer;
        }
        function Y() {
          if (n.weekdayContainer) {
            var e = n.l10n.firstDayOfWeek,
              t = Jl(n.l10n.weekdays.shorthand);
            e > 0 &&
              e < t.length &&
              (t = Jl(t.splice(e, t.length), t.splice(0, e)));
            for (var i = n.config.showMonths; i--; )
              n.weekdayContainer.children[i].innerHTML =
                "\n      <span class='flatpickr-weekday'>\n        " +
                t.join("</span><span class='flatpickr-weekday'>") +
                "\n      </span>\n      ";
          }
        }
        function D(e, t) {
          void 0 === t && (t = !0);
          var i = t ? e : e - n.currentMonth;
          (i < 0 && !0 === n._hidePrevMonthArrow) ||
            (i > 0 && !0 === n._hideNextMonthArrow) ||
            ((n.currentMonth += i),
            (n.currentMonth < 0 || n.currentMonth > 11) &&
              ((n.currentYear += n.currentMonth > 11 ? 1 : -1),
              (n.currentMonth = (n.currentMonth + 12) % 12),
              J("onYearChange"),
              x()),
            b(),
            J("onMonthChange"),
            X());
        }
        function T(e) {
          return n.calendarContainer.contains(e);
        }
        function S(e) {
          if (n.isOpen && !n.config.inline) {
            var t = Hl(e),
              i = T(t),
              a =
                !(
                  t === n.input ||
                  t === n.altInput ||
                  n.element.contains(t) ||
                  (e.path &&
                    e.path.indexOf &&
                    (~e.path.indexOf(n.input) || ~e.path.indexOf(n.altInput)))
                ) &&
                !i &&
                !T(e.relatedTarget),
              r = !n.config.ignoredFocusElements.some(function (e) {
                return e.contains(t);
              });
            a &&
              r &&
              (n.config.allowInput &&
                n.setDate(
                  n._input.value,
                  !1,
                  n.config.altInput ? n.config.altFormat : n.config.dateFormat
                ),
              void 0 !== n.timeContainer &&
                void 0 !== n.minuteElement &&
                void 0 !== n.hourElement &&
                "" !== n.input.value &&
                void 0 !== n.input.value &&
                l(),
              n.close(),
              n.config &&
                "range" === n.config.mode &&
                1 === n.selectedDates.length &&
                n.clear(!1));
          }
        }
        function j(e) {
          if (
            !(
              !e ||
              (n.config.minDate && e < n.config.minDate.getFullYear()) ||
              (n.config.maxDate && e > n.config.maxDate.getFullYear())
            )
          ) {
            var t = e,
              i = n.currentYear !== t;
            (n.currentYear = t || n.currentYear),
              n.config.maxDate &&
              n.currentYear === n.config.maxDate.getFullYear()
                ? (n.currentMonth = Math.min(
                    n.config.maxDate.getMonth(),
                    n.currentMonth
                  ))
                : n.config.minDate &&
                  n.currentYear === n.config.minDate.getFullYear() &&
                  (n.currentMonth = Math.max(
                    n.config.minDate.getMonth(),
                    n.currentMonth
                  )),
              i && (n.redraw(), J("onYearChange"), x());
          }
        }
        function O(e, t) {
          var i;
          void 0 === t && (t = !0);
          var a = n.parseDate(e, void 0, t);
          if (
            (n.config.minDate &&
              a &&
              Nl(a, n.config.minDate, void 0 !== t ? t : !n.minDateHasTime) <
                0) ||
            (n.config.maxDate &&
              a &&
              Nl(a, n.config.maxDate, void 0 !== t ? t : !n.maxDateHasTime) > 0)
          )
            return !1;
          if (!n.config.enable && 0 === n.config.disable.length) return !0;
          if (void 0 === a) return !1;
          for (
            var r = !!n.config.enable,
              l =
                null !== (i = n.config.enable) && void 0 !== i
                  ? i
                  : n.config.disable,
              o = 0,
              s = void 0;
            o < l.length;
            o++
          ) {
            if ("function" == typeof (s = l[o]) && s(a)) return r;
            if (
              s instanceof Date &&
              void 0 !== a &&
              s.getTime() === a.getTime()
            )
              return r;
            if ("string" == typeof s) {
              var d = n.parseDate(s, void 0, !0);
              return d && d.getTime() === a.getTime() ? r : !r;
            }
            if (
              "object" == typeof s &&
              void 0 !== a &&
              s.from &&
              s.to &&
              a.getTime() >= s.from.getTime() &&
              a.getTime() <= s.to.getTime()
            )
              return r;
          }
          return !r;
        }
        function A(e) {
          return (
            void 0 !== n.daysContainer &&
            -1 === e.className.indexOf("hidden") &&
            -1 === e.className.indexOf("flatpickr-disabled") &&
            n.daysContainer.contains(e)
          );
        }
        function H(e) {
          var t = e.target === n._input,
            i = n._input.value.trimEnd() !== K();
          !t ||
            !i ||
            (e.relatedTarget && T(e.relatedTarget)) ||
            n.setDate(
              n._input.value,
              !0,
              e.target === n.altInput ? n.config.altFormat : n.config.dateFormat
            );
        }
        function E(t) {
          var a = Hl(t),
            r = n.config.wrap ? e.contains(a) : a === n._input,
            s = n.config.allowInput,
            d = n.isOpen && (!s || !r),
            u = n.config.inline && r && !s;
          if (13 === t.keyCode && r) {
            if (s)
              return (
                n.setDate(
                  n._input.value,
                  !0,
                  a === n.altInput ? n.config.altFormat : n.config.dateFormat
                ),
                n.close(),
                a.blur()
              );
            n.open();
          } else if (T(a) || d || u) {
            var c = !!n.timeContainer && n.timeContainer.contains(a);
            switch (t.keyCode) {
              case 13:
                c ? (t.preventDefault(), l(), R()) : B(t);
                break;
              case 27:
                t.preventDefault(), R();
                break;
              case 8:
              case 46:
                r && !n.config.allowInput && (t.preventDefault(), n.clear());
                break;
              case 37:
              case 39:
                if (c || r) n.hourElement && n.hourElement.focus();
                else {
                  t.preventDefault();
                  var h = i();
                  if (void 0 !== n.daysContainer && (!1 === s || (h && A(h)))) {
                    var m = 39 === t.keyCode ? 1 : -1;
                    t.ctrlKey
                      ? (t.stopPropagation(), D(m), v(y(1), 0))
                      : v(void 0, m);
                  }
                }
                break;
              case 38:
              case 40:
                t.preventDefault();
                var f = 40 === t.keyCode ? 1 : -1;
                (n.daysContainer && void 0 !== a.$i) ||
                a === n.input ||
                a === n.altInput
                  ? t.ctrlKey
                    ? (t.stopPropagation(), j(n.currentYear - f), v(y(1), 0))
                    : c || v(void 0, 7 * f)
                  : a === n.currentYearElement
                  ? j(n.currentYear - f)
                  : n.config.enableTime &&
                    (!c && n.hourElement && n.hourElement.focus(),
                    l(t),
                    n._debouncedChange());
                break;
              case 9:
                if (c) {
                  var _ = [
                      n.hourElement,
                      n.minuteElement,
                      n.secondElement,
                      n.amPM,
                    ]
                      .concat(n.pluginElements)
                      .filter(function (e) {
                        return e;
                      }),
                    p = _.indexOf(a);
                  if (-1 !== p) {
                    var g = _[p + (t.shiftKey ? -1 : 1)];
                    t.preventDefault(), (g || n._input).focus();
                  }
                } else
                  !n.config.noCalendar &&
                    n.daysContainer &&
                    n.daysContainer.contains(a) &&
                    t.shiftKey &&
                    (t.preventDefault(), n._input.focus());
            }
          }
          if (void 0 !== n.amPM && a === n.amPM)
            switch (t.key) {
              case n.l10n.amPM[0].charAt(0):
              case n.l10n.amPM[0].charAt(0).toLowerCase():
                (n.amPM.textContent = n.l10n.amPM[0]), o(), Q();
                break;
              case n.l10n.amPM[1].charAt(0):
              case n.l10n.amPM[1].charAt(0).toLowerCase():
                (n.amPM.textContent = n.l10n.amPM[1]), o(), Q();
            }
          (r || T(a)) && J("onKeyDown", t);
        }
        function C(e, t) {
          if (
            (void 0 === t && (t = "flatpickr-day"),
            1 === n.selectedDates.length &&
              (!e ||
                (e.classList.contains(t) &&
                  !e.classList.contains("flatpickr-disabled"))))
          ) {
            for (
              var i = e
                  ? e.dateObj.getTime()
                  : n.days.firstElementChild.dateObj.getTime(),
                a = n.parseDate(n.selectedDates[0], void 0, !0).getTime(),
                r = Math.min(i, n.selectedDates[0].getTime()),
                l = Math.max(i, n.selectedDates[0].getTime()),
                o = !1,
                s = 0,
                d = 0,
                u = r;
              u < l;
              u += Zl.DAY
            )
              O(new Date(u), !0) ||
                ((o = o || (u > r && u < l)),
                u < a && (!s || u > s)
                  ? (s = u)
                  : u > a && (!d || u < d) && (d = u));
            Array.from(
              n.rContainer.querySelectorAll(
                "*:nth-child(-n+" + n.config.showMonths + ") > ." + t
              )
            ).forEach(function (t) {
              var r = t.dateObj.getTime(),
                l = (s > 0 && r < s) || (d > 0 && r > d);
              if (l)
                return (
                  t.classList.add("notAllowed"),
                  void ["inRange", "startRange", "endRange"].forEach(function (
                    e
                  ) {
                    t.classList.remove(e);
                  })
                );
              (o && !l) ||
                (["startRange", "inRange", "endRange", "notAllowed"].forEach(
                  function (e) {
                    t.classList.remove(e);
                  }
                ),
                void 0 !== e &&
                  (e.classList.add(
                    i <= n.selectedDates[0].getTime()
                      ? "startRange"
                      : "endRange"
                  ),
                  a < i && r === a
                    ? t.classList.add("startRange")
                    : a > i && r === a && t.classList.add("endRange"),
                  r >= s &&
                    (0 === d || r <= d) &&
                    Rl(r, a, i) &&
                    t.classList.add("inRange")));
            });
          }
        }
        function P() {
          !n.isOpen || n.config.static || n.config.inline || z();
        }
        function F(e) {
          return function (t) {
            var i = (n.config["_" + e + "Date"] = n.parseDate(
                t,
                n.config.dateFormat
              )),
              a = n.config["_" + ("min" === e ? "max" : "min") + "Date"];
            void 0 !== i &&
              (n["min" === e ? "minDateHasTime" : "maxDateHasTime"] =
                i.getHours() > 0 || i.getMinutes() > 0 || i.getSeconds() > 0),
              n.selectedDates &&
                ((n.selectedDates = n.selectedDates.filter(function (e) {
                  return O(e);
                })),
                n.selectedDates.length || "min" !== e || s(i),
                Q()),
              n.daysContainer &&
                (N(),
                void 0 !== i
                  ? (n.currentYearElement[e] = i.getFullYear().toString())
                  : n.currentYearElement.removeAttribute(e),
                (n.currentYearElement.disabled =
                  !!a && void 0 !== i && a.getFullYear() === i.getFullYear()));
          };
        }
        function I() {
          return n.config.wrap ? e.querySelector("[data-input]") : e;
        }
        function W() {
          "object" != typeof n.config.locale &&
            void 0 === Kl.l10ns[n.config.locale] &&
            n.config.errorHandler(
              new Error("flatpickr: invalid locale " + n.config.locale)
            ),
            (n.l10n = $l(
              $l({}, Kl.l10ns.default),
              "object" == typeof n.config.locale
                ? n.config.locale
                : "default" !== n.config.locale
                ? Kl.l10ns[n.config.locale]
                : void 0
            )),
            (Fl.D = "(" + n.l10n.weekdays.shorthand.join("|") + ")"),
            (Fl.l = "(" + n.l10n.weekdays.longhand.join("|") + ")"),
            (Fl.M = "(" + n.l10n.months.shorthand.join("|") + ")"),
            (Fl.F = "(" + n.l10n.months.longhand.join("|") + ")"),
            (Fl.K =
              "(" +
              n.l10n.amPM[0] +
              "|" +
              n.l10n.amPM[1] +
              "|" +
              n.l10n.amPM[0].toLowerCase() +
              "|" +
              n.l10n.amPM[1].toLowerCase() +
              ")"),
            void 0 ===
              $l($l({}, t), JSON.parse(JSON.stringify(e.dataset || {})))
                .time_24hr &&
              void 0 === Kl.defaultConfig.time_24hr &&
              (n.config.time_24hr = n.l10n.time_24hr),
            (n.formatDate = Wl(n)),
            (n.parseDate = zl({ config: n.config, l10n: n.l10n }));
        }
        function z(e) {
          if ("function" != typeof n.config.position) {
            if (void 0 !== n.calendarContainer) {
              J("onPreCalendarPosition");
              var t = e || n._positionElement,
                i = Array.prototype.reduce.call(
                  n.calendarContainer.children,
                  function (e, t) {
                    return e + t.offsetHeight;
                  },
                  0
                ),
                a = n.calendarContainer.offsetWidth,
                r = n.config.position.split(" "),
                l = r[0],
                o = r.length > 1 ? r[1] : null,
                s = t.getBoundingClientRect(),
                d = window.innerHeight - s.bottom,
                u = "above" === l || ("below" !== l && d < i && s.top > i),
                c =
                  window.pageYOffset +
                  s.top +
                  (u ? -i - 2 : t.offsetHeight + 2);
              if (
                (Tl(n.calendarContainer, "arrowTop", !u),
                Tl(n.calendarContainer, "arrowBottom", u),
                !n.config.inline)
              ) {
                var h = window.pageXOffset + s.left,
                  m = !1,
                  f = !1;
                "center" === o
                  ? ((h -= (a - s.width) / 2), (m = !0))
                  : "right" === o && ((h -= a - s.width), (f = !0)),
                  Tl(n.calendarContainer, "arrowLeft", !m && !f),
                  Tl(n.calendarContainer, "arrowCenter", m),
                  Tl(n.calendarContainer, "arrowRight", f);
                var _ =
                    window.document.body.offsetWidth -
                    (window.pageXOffset + s.right),
                  p = h + a > window.document.body.offsetWidth,
                  g = _ + a > window.document.body.offsetWidth;
                if ((Tl(n.calendarContainer, "rightMost", p), !n.config.static))
                  if (((n.calendarContainer.style.top = c + "px"), p))
                    if (g) {
                      var y = (function () {
                        for (
                          var e = null, t = 0;
                          t < document.styleSheets.length;
                          t++
                        ) {
                          var n = document.styleSheets[t];
                          if (n.cssRules) {
                            try {
                              n.cssRules;
                            } catch (e) {
                              continue;
                            }
                            e = n;
                            break;
                          }
                        }
                        return null != e
                          ? e
                          : ((i = document.createElement("style")),
                            document.head.appendChild(i),
                            i.sheet);
                        var i;
                      })();
                      if (void 0 === y) return;
                      var v = window.document.body.offsetWidth,
                        M = Math.max(0, v / 2 - a / 2),
                        b = y.cssRules.length,
                        x = "{left:" + s.left + "px;right:auto;}";
                      Tl(n.calendarContainer, "rightMost", !1),
                        Tl(n.calendarContainer, "centerMost", !0),
                        y.insertRule(
                          ".flatpickr-calendar.centerMost:before,.flatpickr-calendar.centerMost:after" +
                            x,
                          b
                        ),
                        (n.calendarContainer.style.left = M + "px"),
                        (n.calendarContainer.style.right = "auto");
                    } else
                      (n.calendarContainer.style.left = "auto"),
                        (n.calendarContainer.style.right = _ + "px");
                  else
                    (n.calendarContainer.style.left = h + "px"),
                      (n.calendarContainer.style.right = "auto");
              }
            }
          } else n.config.position(n, e);
        }
        function N() {
          n.config.noCalendar || n.isMobile || (x(), X(), b());
        }
        function R() {
          n._input.focus(),
            -1 !== window.navigator.userAgent.indexOf("MSIE") ||
            void 0 !== navigator.msMaxTouchPoints
              ? setTimeout(n.close, 0)
              : n.close();
        }
        function B(e) {
          e.preventDefault(), e.stopPropagation();
          var t = Ol(Hl(e), function (e) {
            return (
              e.classList &&
              e.classList.contains("flatpickr-day") &&
              !e.classList.contains("flatpickr-disabled") &&
              !e.classList.contains("notAllowed")
            );
          });
          if (void 0 !== t) {
            var i = t,
              a = (n.latestSelectedDateObj = new Date(i.dateObj.getTime())),
              r =
                (a.getMonth() < n.currentMonth ||
                  a.getMonth() > n.currentMonth + n.config.showMonths - 1) &&
                "range" !== n.config.mode;
            if (((n.selectedDateElem = i), "single" === n.config.mode))
              n.selectedDates = [a];
            else if ("multiple" === n.config.mode) {
              var l = G(a);
              l
                ? n.selectedDates.splice(parseInt(l), 1)
                : n.selectedDates.push(a);
            } else
              "range" === n.config.mode &&
                (2 === n.selectedDates.length && n.clear(!1, !1),
                (n.latestSelectedDateObj = a),
                n.selectedDates.push(a),
                0 !== Nl(a, n.selectedDates[0], !0) &&
                  n.selectedDates.sort(function (e, t) {
                    return e.getTime() - t.getTime();
                  }));
            if ((o(), r)) {
              var s = n.currentYear !== a.getFullYear();
              (n.currentYear = a.getFullYear()),
                (n.currentMonth = a.getMonth()),
                s && (J("onYearChange"), x()),
                J("onMonthChange");
            }
            if (
              (X(),
              b(),
              Q(),
              r || "range" === n.config.mode || 1 !== n.config.showMonths
                ? void 0 !== n.selectedDateElem &&
                  void 0 === n.hourElement &&
                  n.selectedDateElem &&
                  n.selectedDateElem.focus()
                : g(i),
              void 0 !== n.hourElement &&
                void 0 !== n.hourElement &&
                n.hourElement.focus(),
              n.config.closeOnSelect)
            ) {
              var d = "single" === n.config.mode && !n.config.enableTime,
                u =
                  "range" === n.config.mode &&
                  2 === n.selectedDates.length &&
                  !n.config.enableTime;
              (d || u) && R();
            }
            h();
          }
        }
        (n.parseDate = zl({ config: n.config, l10n: n.l10n })),
          (n._handlers = []),
          (n.pluginElements = []),
          (n.loadedPlugins = []),
          (n._bind = c),
          (n._setHoursFromDate = s),
          (n._positionCalendar = z),
          (n.changeMonth = D),
          (n.changeYear = j),
          (n.clear = function (e, t) {
            void 0 === e && (e = !0);
            void 0 === t && (t = !0);
            (n.input.value = ""),
              void 0 !== n.altInput && (n.altInput.value = "");
            void 0 !== n.mobileInput && (n.mobileInput.value = "");
            (n.selectedDates = []),
              (n.latestSelectedDateObj = void 0),
              !0 === t &&
                ((n.currentYear = n._initialDate.getFullYear()),
                (n.currentMonth = n._initialDate.getMonth()));
            if (!0 === n.config.enableTime) {
              var i = Ul(n.config);
              d(i.hours, i.minutes, i.seconds);
            }
            n.redraw(), e && J("onChange");
          }),
          (n.close = function () {
            (n.isOpen = !1),
              n.isMobile ||
                (void 0 !== n.calendarContainer &&
                  n.calendarContainer.classList.remove("open"),
                void 0 !== n._input && n._input.classList.remove("active"));
            J("onClose");
          }),
          (n.onMouseOver = C),
          (n._createElement = Sl),
          (n.createDay = p),
          (n.destroy = function () {
            void 0 !== n.config && J("onDestroy");
            for (var e = n._handlers.length; e--; ) n._handlers[e].remove();
            if (((n._handlers = []), n.mobileInput))
              n.mobileInput.parentNode &&
                n.mobileInput.parentNode.removeChild(n.mobileInput),
                (n.mobileInput = void 0);
            else if (n.calendarContainer && n.calendarContainer.parentNode)
              if (n.config.static && n.calendarContainer.parentNode) {
                var t = n.calendarContainer.parentNode;
                if ((t.lastChild && t.removeChild(t.lastChild), t.parentNode)) {
                  for (; t.firstChild; )
                    t.parentNode.insertBefore(t.firstChild, t);
                  t.parentNode.removeChild(t);
                }
              } else
                n.calendarContainer.parentNode.removeChild(n.calendarContainer);
            n.altInput &&
              ((n.input.type = "text"),
              n.altInput.parentNode &&
                n.altInput.parentNode.removeChild(n.altInput),
              delete n.altInput);
            n.input &&
              ((n.input.type = n.input._type),
              n.input.classList.remove("flatpickr-input"),
              n.input.removeAttribute("readonly"));
            [
              "_showTimeInput",
              "latestSelectedDateObj",
              "_hideNextMonthArrow",
              "_hidePrevMonthArrow",
              "__hideNextMonthArrow",
              "__hidePrevMonthArrow",
              "isMobile",
              "isOpen",
              "selectedDateElem",
              "minDateHasTime",
              "maxDateHasTime",
              "days",
              "daysContainer",
              "_input",
              "_positionElement",
              "innerContainer",
              "rContainer",
              "monthNav",
              "todayDateElem",
              "calendarContainer",
              "weekdayContainer",
              "prevMonthNav",
              "nextMonthNav",
              "monthsDropdownContainer",
              "currentMonthElement",
              "currentYearElement",
              "navigationCurrentMonth",
              "selectedDateElem",
              "config",
            ].forEach(function (e) {
              try {
                delete n[e];
              } catch (e) {}
            });
          }),
          (n.isEnabled = O),
          (n.jumpToDate = m),
          (n.updateValue = Q),
          (n.open = function (e, t) {
            void 0 === t && (t = n._positionElement);
            if (!0 === n.isMobile) {
              if (e) {
                e.preventDefault();
                var i = Hl(e);
                i && i.blur();
              }
              return (
                void 0 !== n.mobileInput &&
                  (n.mobileInput.focus(), n.mobileInput.click()),
                void J("onOpen")
              );
            }
            if (n._input.disabled || n.config.inline) return;
            var a = n.isOpen;
            (n.isOpen = !0),
              a ||
                (n.calendarContainer.classList.add("open"),
                n._input.classList.add("active"),
                J("onOpen"),
                z(t));
            !0 === n.config.enableTime &&
              !0 === n.config.noCalendar &&
              (!1 !== n.config.allowInput ||
                (void 0 !== e && n.timeContainer.contains(e.relatedTarget)) ||
                setTimeout(function () {
                  return n.hourElement.select();
                }, 50));
          }),
          (n.redraw = N),
          (n.set = function (e, t) {
            if (null !== e && "object" == typeof e)
              for (var i in (Object.assign(n.config, e), e))
                void 0 !== V[i] &&
                  V[i].forEach(function (e) {
                    return e();
                  });
            else
              (n.config[e] = t),
                void 0 !== V[e]
                  ? V[e].forEach(function (e) {
                      return e();
                    })
                  : Ml.indexOf(e) > -1 && (n.config[e] = Dl(t));
            n.redraw(), Q(!0);
          }),
          (n.setDate = function (e, t, i) {
            void 0 === t && (t = !1);
            void 0 === i && (i = n.config.dateFormat);
            if ((0 !== e && !e) || (e instanceof Array && 0 === e.length))
              return n.clear(t);
            Z(e, i),
              (n.latestSelectedDateObj =
                n.selectedDates[n.selectedDates.length - 1]),
              n.redraw(),
              m(void 0, t),
              s(),
              0 === n.selectedDates.length && n.clear(!1);
            Q(t), t && J("onChange");
          }),
          (n.toggle = function (e) {
            if (!0 === n.isOpen) return n.close();
            n.open(e);
          });
        var V = {
          locale: [W, Y],
          showMonths: [w, r, k],
          minDate: [m],
          maxDate: [m],
          positionElement: [$],
          clickOpens: [
            function () {
              !0 === n.config.clickOpens
                ? (c(n._input, "focus", n.open), c(n._input, "click", n.open))
                : (n._input.removeEventListener("focus", n.open),
                  n._input.removeEventListener("click", n.open));
            },
          ],
        };
        function Z(e, t) {
          var i = [];
          if (e instanceof Array)
            i = e.map(function (e) {
              return n.parseDate(e, t);
            });
          else if (e instanceof Date || "number" == typeof e)
            i = [n.parseDate(e, t)];
          else if ("string" == typeof e)
            switch (n.config.mode) {
              case "single":
              case "time":
                i = [n.parseDate(e, t)];
                break;
              case "multiple":
                i = e.split(n.config.conjunction).map(function (e) {
                  return n.parseDate(e, t);
                });
                break;
              case "range":
                i = e.split(n.l10n.rangeSeparator).map(function (e) {
                  return n.parseDate(e, t);
                });
            }
          else
            n.config.errorHandler(
              new Error("Invalid date supplied: " + JSON.stringify(e))
            );
          (n.selectedDates = n.config.allowInvalidPreload
            ? i
            : i.filter(function (e) {
                return e instanceof Date && O(e, !1);
              })),
            "range" === n.config.mode &&
              n.selectedDates.sort(function (e, t) {
                return e.getTime() - t.getTime();
              });
        }
        function U(e) {
          return e
            .slice()
            .map(function (e) {
              return "string" == typeof e ||
                "number" == typeof e ||
                e instanceof Date
                ? n.parseDate(e, void 0, !0)
                : e && "object" == typeof e && e.from && e.to
                ? {
                    from: n.parseDate(e.from, void 0),
                    to: n.parseDate(e.to, void 0),
                  }
                : e;
            })
            .filter(function (e) {
              return e;
            });
        }
        function $() {
          n._positionElement = n.config.positionElement || n._input;
        }
        function J(e, t) {
          if (void 0 !== n.config) {
            var i = n.config[e];
            if (void 0 !== i && i.length > 0)
              for (var a = 0; i[a] && a < i.length; a++)
                i[a](n.selectedDates, n.input.value, n, t);
            "onChange" === e &&
              (n.input.dispatchEvent(q("change")),
              n.input.dispatchEvent(q("input")));
          }
        }
        function q(e) {
          var t = document.createEvent("Event");
          return t.initEvent(e, !0, !0), t;
        }
        function G(e) {
          for (var t = 0; t < n.selectedDates.length; t++) {
            var i = n.selectedDates[t];
            if (i instanceof Date && 0 === Nl(i, e)) return "" + t;
          }
          return !1;
        }
        function X() {
          n.config.noCalendar ||
            n.isMobile ||
            !n.monthNav ||
            (n.yearElements.forEach(function (e, t) {
              var i = new Date(n.currentYear, n.currentMonth, 1);
              i.setMonth(n.currentMonth + t),
                n.config.showMonths > 1 ||
                "static" === n.config.monthSelectorType
                  ? (n.monthElements[t].textContent =
                      Cl(i.getMonth(), n.config.shorthandCurrentMonth, n.l10n) +
                      " ")
                  : (n.monthsDropdownContainer.value = i.getMonth().toString()),
                (e.value = i.getFullYear().toString());
            }),
            (n._hidePrevMonthArrow =
              void 0 !== n.config.minDate &&
              (n.currentYear === n.config.minDate.getFullYear()
                ? n.currentMonth <= n.config.minDate.getMonth()
                : n.currentYear < n.config.minDate.getFullYear())),
            (n._hideNextMonthArrow =
              void 0 !== n.config.maxDate &&
              (n.currentYear === n.config.maxDate.getFullYear()
                ? n.currentMonth + 1 > n.config.maxDate.getMonth()
                : n.currentYear > n.config.maxDate.getFullYear())));
        }
        function K(e) {
          var t =
            e || (n.config.altInput ? n.config.altFormat : n.config.dateFormat);
          return n.selectedDates
            .map(function (e) {
              return n.formatDate(e, t);
            })
            .filter(function (e, t, i) {
              return (
                "range" !== n.config.mode ||
                n.config.enableTime ||
                i.indexOf(e) === t
              );
            })
            .join(
              "range" !== n.config.mode
                ? n.config.conjunction
                : n.l10n.rangeSeparator
            );
        }
        function Q(e) {
          void 0 === e && (e = !0),
            void 0 !== n.mobileInput &&
              n.mobileFormatStr &&
              (n.mobileInput.value =
                void 0 !== n.latestSelectedDateObj
                  ? n.formatDate(n.latestSelectedDateObj, n.mobileFormatStr)
                  : ""),
            (n.input.value = K(n.config.dateFormat)),
            void 0 !== n.altInput && (n.altInput.value = K(n.config.altFormat)),
            !1 !== e && J("onValueUpdate");
        }
        function ee(e) {
          var t = Hl(e),
            i = n.prevMonthNav.contains(t),
            a = n.nextMonthNav.contains(t);
          i || a
            ? D(i ? -1 : 1)
            : n.yearElements.indexOf(t) >= 0
            ? t.select()
            : t.classList.contains("arrowUp")
            ? n.changeYear(n.currentYear + 1)
            : t.classList.contains("arrowDown") &&
              n.changeYear(n.currentYear - 1);
        }
        return (
          (function () {
            (n.element = n.input = e),
              (n.isOpen = !1),
              (function () {
                var i = [
                    "wrap",
                    "weekNumbers",
                    "allowInput",
                    "allowInvalidPreload",
                    "clickOpens",
                    "time_24hr",
                    "enableTime",
                    "noCalendar",
                    "altInput",
                    "shorthandCurrentMonth",
                    "inline",
                    "static",
                    "enableSeconds",
                    "disableMobile",
                  ],
                  r = $l(
                    $l({}, JSON.parse(JSON.stringify(e.dataset || {}))),
                    t
                  ),
                  l = {};
                (n.config.parseDate = r.parseDate),
                  (n.config.formatDate = r.formatDate),
                  Object.defineProperty(n.config, "enable", {
                    get: function () {
                      return n.config._enable;
                    },
                    set: function (e) {
                      n.config._enable = U(e);
                    },
                  }),
                  Object.defineProperty(n.config, "disable", {
                    get: function () {
                      return n.config._disable;
                    },
                    set: function (e) {
                      n.config._disable = U(e);
                    },
                  });
                var o = "time" === r.mode;
                if (!r.dateFormat && (r.enableTime || o)) {
                  var s = Kl.defaultConfig.dateFormat || bl.dateFormat;
                  l.dateFormat =
                    r.noCalendar || o
                      ? "H:i" + (r.enableSeconds ? ":S" : "")
                      : s + " H:i" + (r.enableSeconds ? ":S" : "");
                }
                if (r.altInput && (r.enableTime || o) && !r.altFormat) {
                  var d = Kl.defaultConfig.altFormat || bl.altFormat;
                  l.altFormat =
                    r.noCalendar || o
                      ? "h:i" + (r.enableSeconds ? ":S K" : " K")
                      : d + " h:i" + (r.enableSeconds ? ":S" : "") + " K";
                }
                Object.defineProperty(n.config, "minDate", {
                  get: function () {
                    return n.config._minDate;
                  },
                  set: F("min"),
                }),
                  Object.defineProperty(n.config, "maxDate", {
                    get: function () {
                      return n.config._maxDate;
                    },
                    set: F("max"),
                  });
                var u = function (e) {
                  return function (t) {
                    n.config["min" === e ? "_minTime" : "_maxTime"] =
                      n.parseDate(t, "H:i:S");
                  };
                };
                Object.defineProperty(n.config, "minTime", {
                  get: function () {
                    return n.config._minTime;
                  },
                  set: u("min"),
                }),
                  Object.defineProperty(n.config, "maxTime", {
                    get: function () {
                      return n.config._maxTime;
                    },
                    set: u("max"),
                  }),
                  "time" === r.mode &&
                    ((n.config.noCalendar = !0), (n.config.enableTime = !0));
                Object.assign(n.config, l, r);
                for (var c = 0; c < i.length; c++)
                  n.config[i[c]] =
                    !0 === n.config[i[c]] || "true" === n.config[i[c]];
                Ml.filter(function (e) {
                  return void 0 !== n.config[e];
                }).forEach(function (e) {
                  n.config[e] = Dl(n.config[e] || []).map(a);
                }),
                  (n.isMobile =
                    !n.config.disableMobile &&
                    !n.config.inline &&
                    "single" === n.config.mode &&
                    !n.config.disable.length &&
                    !n.config.enable &&
                    !n.config.weekNumbers &&
                    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
                      navigator.userAgent
                    ));
                for (c = 0; c < n.config.plugins.length; c++) {
                  var h = n.config.plugins[c](n) || {};
                  for (var m in h)
                    Ml.indexOf(m) > -1
                      ? (n.config[m] = Dl(h[m]).map(a).concat(n.config[m]))
                      : void 0 === r[m] && (n.config[m] = h[m]);
                }
                r.altInputClass ||
                  (n.config.altInputClass =
                    I().className + " " + n.config.altInputClass);
                J("onParseConfig");
              })(),
              W(),
              (function () {
                if (((n.input = I()), !n.input))
                  return void n.config.errorHandler(
                    new Error("Invalid input element specified")
                  );
                (n.input._type = n.input.type),
                  (n.input.type = "text"),
                  n.input.classList.add("flatpickr-input"),
                  (n._input = n.input),
                  n.config.altInput &&
                    ((n.altInput = Sl(
                      n.input.nodeName,
                      n.config.altInputClass
                    )),
                    (n._input = n.altInput),
                    (n.altInput.placeholder = n.input.placeholder),
                    (n.altInput.disabled = n.input.disabled),
                    (n.altInput.required = n.input.required),
                    (n.altInput.tabIndex = n.input.tabIndex),
                    (n.altInput.type = "text"),
                    n.input.setAttribute("type", "hidden"),
                    !n.config.static &&
                      n.input.parentNode &&
                      n.input.parentNode.insertBefore(
                        n.altInput,
                        n.input.nextSibling
                      ));
                n.config.allowInput ||
                  n._input.setAttribute("readonly", "readonly");
                $();
              })(),
              (function () {
                (n.selectedDates = []),
                  (n.now = n.parseDate(n.config.now) || new Date());
                var e =
                  n.config.defaultDate ||
                  (("INPUT" !== n.input.nodeName &&
                    "TEXTAREA" !== n.input.nodeName) ||
                  !n.input.placeholder ||
                  n.input.value !== n.input.placeholder
                    ? n.input.value
                    : null);
                e && Z(e, n.config.dateFormat);
                (n._initialDate =
                  n.selectedDates.length > 0
                    ? n.selectedDates[0]
                    : n.config.minDate &&
                      n.config.minDate.getTime() > n.now.getTime()
                    ? n.config.minDate
                    : n.config.maxDate &&
                      n.config.maxDate.getTime() < n.now.getTime()
                    ? n.config.maxDate
                    : n.now),
                  (n.currentYear = n._initialDate.getFullYear()),
                  (n.currentMonth = n._initialDate.getMonth()),
                  n.selectedDates.length > 0 &&
                    (n.latestSelectedDateObj = n.selectedDates[0]);
                void 0 !== n.config.minTime &&
                  (n.config.minTime = n.parseDate(n.config.minTime, "H:i"));
                void 0 !== n.config.maxTime &&
                  (n.config.maxTime = n.parseDate(n.config.maxTime, "H:i"));
                (n.minDateHasTime =
                  !!n.config.minDate &&
                  (n.config.minDate.getHours() > 0 ||
                    n.config.minDate.getMinutes() > 0 ||
                    n.config.minDate.getSeconds() > 0)),
                  (n.maxDateHasTime =
                    !!n.config.maxDate &&
                    (n.config.maxDate.getHours() > 0 ||
                      n.config.maxDate.getMinutes() > 0 ||
                      n.config.maxDate.getSeconds() > 0));
              })(),
              (n.utils = {
                getDaysInMonth: function (e, t) {
                  return (
                    void 0 === e && (e = n.currentMonth),
                    void 0 === t && (t = n.currentYear),
                    1 === e && ((t % 4 == 0 && t % 100 != 0) || t % 400 == 0)
                      ? 29
                      : n.l10n.daysInMonth[e]
                  );
                },
              }),
              n.isMobile ||
                (function () {
                  var e = window.document.createDocumentFragment();
                  if (
                    ((n.calendarContainer = Sl("div", "flatpickr-calendar")),
                    (n.calendarContainer.tabIndex = -1),
                    !n.config.noCalendar)
                  ) {
                    if (
                      (e.appendChild(
                        ((n.monthNav = Sl("div", "flatpickr-months")),
                        (n.yearElements = []),
                        (n.monthElements = []),
                        (n.prevMonthNav = Sl("span", "flatpickr-prev-month")),
                        (n.prevMonthNav.innerHTML = n.config.prevArrow),
                        (n.nextMonthNav = Sl("span", "flatpickr-next-month")),
                        (n.nextMonthNav.innerHTML = n.config.nextArrow),
                        w(),
                        Object.defineProperty(n, "_hidePrevMonthArrow", {
                          get: function () {
                            return n.__hidePrevMonthArrow;
                          },
                          set: function (e) {
                            n.__hidePrevMonthArrow !== e &&
                              (Tl(n.prevMonthNav, "flatpickr-disabled", e),
                              (n.__hidePrevMonthArrow = e));
                          },
                        }),
                        Object.defineProperty(n, "_hideNextMonthArrow", {
                          get: function () {
                            return n.__hideNextMonthArrow;
                          },
                          set: function (e) {
                            n.__hideNextMonthArrow !== e &&
                              (Tl(n.nextMonthNav, "flatpickr-disabled", e),
                              (n.__hideNextMonthArrow = e));
                          },
                        }),
                        (n.currentYearElement = n.yearElements[0]),
                        X(),
                        n.monthNav)
                      ),
                      (n.innerContainer = Sl(
                        "div",
                        "flatpickr-innerContainer"
                      )),
                      n.config.weekNumbers)
                    ) {
                      var t = (function () {
                          n.calendarContainer.classList.add("hasWeeks");
                          var e = Sl("div", "flatpickr-weekwrapper");
                          e.appendChild(
                            Sl(
                              "span",
                              "flatpickr-weekday",
                              n.l10n.weekAbbreviation
                            )
                          );
                          var t = Sl("div", "flatpickr-weeks");
                          return (
                            e.appendChild(t), { weekWrapper: e, weekNumbers: t }
                          );
                        })(),
                        i = t.weekWrapper,
                        a = t.weekNumbers;
                      n.innerContainer.appendChild(i),
                        (n.weekNumbers = a),
                        (n.weekWrapper = i);
                    }
                    (n.rContainer = Sl("div", "flatpickr-rContainer")),
                      n.rContainer.appendChild(k()),
                      n.daysContainer ||
                        ((n.daysContainer = Sl("div", "flatpickr-days")),
                        (n.daysContainer.tabIndex = -1)),
                      b(),
                      n.rContainer.appendChild(n.daysContainer),
                      n.innerContainer.appendChild(n.rContainer),
                      e.appendChild(n.innerContainer);
                  }
                  n.config.enableTime &&
                    e.appendChild(
                      (function () {
                        n.calendarContainer.classList.add("hasTime"),
                          n.config.noCalendar &&
                            n.calendarContainer.classList.add("noCalendar");
                        var e = Ul(n.config);
                        (n.timeContainer = Sl("div", "flatpickr-time")),
                          (n.timeContainer.tabIndex = -1);
                        var t = Sl("span", "flatpickr-time-separator", ":"),
                          i = Al("flatpickr-hour", {
                            "aria-label": n.l10n.hourAriaLabel,
                          });
                        n.hourElement = i.getElementsByTagName("input")[0];
                        var a = Al("flatpickr-minute", {
                          "aria-label": n.l10n.minuteAriaLabel,
                        });
                        (n.minuteElement = a.getElementsByTagName("input")[0]),
                          (n.hourElement.tabIndex = n.minuteElement.tabIndex =
                            -1),
                          (n.hourElement.value = wl(
                            n.latestSelectedDateObj
                              ? n.latestSelectedDateObj.getHours()
                              : n.config.time_24hr
                              ? e.hours
                              : (function (e) {
                                  switch (e % 24) {
                                    case 0:
                                    case 12:
                                      return 12;
                                    default:
                                      return e % 12;
                                  }
                                })(e.hours)
                          )),
                          (n.minuteElement.value = wl(
                            n.latestSelectedDateObj
                              ? n.latestSelectedDateObj.getMinutes()
                              : e.minutes
                          )),
                          n.hourElement.setAttribute(
                            "step",
                            n.config.hourIncrement.toString()
                          ),
                          n.minuteElement.setAttribute(
                            "step",
                            n.config.minuteIncrement.toString()
                          ),
                          n.hourElement.setAttribute(
                            "min",
                            n.config.time_24hr ? "0" : "1"
                          ),
                          n.hourElement.setAttribute(
                            "max",
                            n.config.time_24hr ? "23" : "12"
                          ),
                          n.hourElement.setAttribute("maxlength", "2"),
                          n.minuteElement.setAttribute("min", "0"),
                          n.minuteElement.setAttribute("max", "59"),
                          n.minuteElement.setAttribute("maxlength", "2"),
                          n.timeContainer.appendChild(i),
                          n.timeContainer.appendChild(t),
                          n.timeContainer.appendChild(a),
                          n.config.time_24hr &&
                            n.timeContainer.classList.add("time24hr");
                        if (n.config.enableSeconds) {
                          n.timeContainer.classList.add("hasSeconds");
                          var r = Al("flatpickr-second");
                          (n.secondElement =
                            r.getElementsByTagName("input")[0]),
                            (n.secondElement.value = wl(
                              n.latestSelectedDateObj
                                ? n.latestSelectedDateObj.getSeconds()
                                : e.seconds
                            )),
                            n.secondElement.setAttribute(
                              "step",
                              n.minuteElement.getAttribute("step")
                            ),
                            n.secondElement.setAttribute("min", "0"),
                            n.secondElement.setAttribute("max", "59"),
                            n.secondElement.setAttribute("maxlength", "2"),
                            n.timeContainer.appendChild(
                              Sl("span", "flatpickr-time-separator", ":")
                            ),
                            n.timeContainer.appendChild(r);
                        }
                        n.config.time_24hr ||
                          ((n.amPM = Sl(
                            "span",
                            "flatpickr-am-pm",
                            n.l10n.amPM[
                              kl(
                                (n.latestSelectedDateObj
                                  ? n.hourElement.value
                                  : n.config.defaultHour) > 11
                              )
                            ]
                          )),
                          (n.amPM.title = n.l10n.toggleTitle),
                          (n.amPM.tabIndex = -1),
                          n.timeContainer.appendChild(n.amPM));
                        return n.timeContainer;
                      })()
                    );
                  Tl(
                    n.calendarContainer,
                    "rangeMode",
                    "range" === n.config.mode
                  ),
                    Tl(n.calendarContainer, "animate", !0 === n.config.animate),
                    Tl(
                      n.calendarContainer,
                      "multiMonth",
                      n.config.showMonths > 1
                    ),
                    n.calendarContainer.appendChild(e);
                  var r =
                    void 0 !== n.config.appendTo &&
                    void 0 !== n.config.appendTo.nodeType;
                  if (
                    (n.config.inline || n.config.static) &&
                    (n.calendarContainer.classList.add(
                      n.config.inline ? "inline" : "static"
                    ),
                    n.config.inline &&
                      (!r && n.element.parentNode
                        ? n.element.parentNode.insertBefore(
                            n.calendarContainer,
                            n._input.nextSibling
                          )
                        : void 0 !== n.config.appendTo &&
                          n.config.appendTo.appendChild(n.calendarContainer)),
                    n.config.static)
                  ) {
                    var l = Sl("div", "flatpickr-wrapper");
                    n.element.parentNode &&
                      n.element.parentNode.insertBefore(l, n.element),
                      l.appendChild(n.element),
                      n.altInput && l.appendChild(n.altInput),
                      l.appendChild(n.calendarContainer);
                  }
                  n.config.static ||
                    n.config.inline ||
                    (void 0 !== n.config.appendTo
                      ? n.config.appendTo
                      : window.document.body
                    ).appendChild(n.calendarContainer);
                })(),
              (function () {
                n.config.wrap &&
                  ["open", "close", "toggle", "clear"].forEach(function (e) {
                    Array.prototype.forEach.call(
                      n.element.querySelectorAll("[data-" + e + "]"),
                      function (t) {
                        return c(t, "click", n[e]);
                      }
                    );
                  });
                if (n.isMobile)
                  return void (function () {
                    var e = n.config.enableTime
                      ? n.config.noCalendar
                        ? "time"
                        : "datetime-local"
                      : "date";
                    (n.mobileInput = Sl(
                      "input",
                      n.input.className + " flatpickr-mobile"
                    )),
                      (n.mobileInput.tabIndex = 1),
                      (n.mobileInput.type = e),
                      (n.mobileInput.disabled = n.input.disabled),
                      (n.mobileInput.required = n.input.required),
                      (n.mobileInput.placeholder = n.input.placeholder),
                      (n.mobileFormatStr =
                        "datetime-local" === e
                          ? "Y-m-d\\TH:i:S"
                          : "date" === e
                          ? "Y-m-d"
                          : "H:i:S"),
                      n.selectedDates.length > 0 &&
                        (n.mobileInput.defaultValue = n.mobileInput.value =
                          n.formatDate(n.selectedDates[0], n.mobileFormatStr));
                    n.config.minDate &&
                      (n.mobileInput.min = n.formatDate(
                        n.config.minDate,
                        "Y-m-d"
                      ));
                    n.config.maxDate &&
                      (n.mobileInput.max = n.formatDate(
                        n.config.maxDate,
                        "Y-m-d"
                      ));
                    n.input.getAttribute("step") &&
                      (n.mobileInput.step = String(
                        n.input.getAttribute("step")
                      ));
                    (n.input.type = "hidden"),
                      void 0 !== n.altInput && (n.altInput.type = "hidden");
                    try {
                      n.input.parentNode &&
                        n.input.parentNode.insertBefore(
                          n.mobileInput,
                          n.input.nextSibling
                        );
                    } catch (e) {}
                    c(n.mobileInput, "change", function (e) {
                      n.setDate(Hl(e).value, !1, n.mobileFormatStr),
                        J("onChange"),
                        J("onClose");
                    });
                  })();
                var e = Yl(P, 50);
                (n._debouncedChange = Yl(h, ql)),
                  n.daysContainer &&
                    !/iPhone|iPad|iPod/i.test(navigator.userAgent) &&
                    c(n.daysContainer, "mouseover", function (e) {
                      "range" === n.config.mode && C(Hl(e));
                    });
                c(n._input, "keydown", E),
                  void 0 !== n.calendarContainer &&
                    c(n.calendarContainer, "keydown", E);
                n.config.inline || n.config.static || c(window, "resize", e);
                void 0 !== window.ontouchstart
                  ? c(window.document, "touchstart", S)
                  : c(window.document, "mousedown", S);
                c(window.document, "focus", S, { capture: !0 }),
                  !0 === n.config.clickOpens &&
                    (c(n._input, "focus", n.open),
                    c(n._input, "click", n.open));
                void 0 !== n.daysContainer &&
                  (c(n.monthNav, "click", ee),
                  c(n.monthNav, ["keyup", "increment"], u),
                  c(n.daysContainer, "click", B));
                if (
                  void 0 !== n.timeContainer &&
                  void 0 !== n.minuteElement &&
                  void 0 !== n.hourElement
                ) {
                  var t = function (e) {
                    return Hl(e).select();
                  };
                  c(n.timeContainer, ["increment"], l),
                    c(n.timeContainer, "blur", l, { capture: !0 }),
                    c(n.timeContainer, "click", f),
                    c([n.hourElement, n.minuteElement], ["focus", "click"], t),
                    void 0 !== n.secondElement &&
                      c(n.secondElement, "focus", function () {
                        return n.secondElement && n.secondElement.select();
                      }),
                    void 0 !== n.amPM &&
                      c(n.amPM, "click", function (e) {
                        l(e);
                      });
                }
                n.config.allowInput && c(n._input, "blur", H);
              })(),
              (n.selectedDates.length || n.config.noCalendar) &&
                (n.config.enableTime &&
                  s(n.config.noCalendar ? n.latestSelectedDateObj : void 0),
                Q(!1)),
              r();
            var i = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            !n.isMobile && i && z(), J("onReady");
          })(),
          n
        );
      }
      function Xl(e, t) {
        for (
          var n = Array.prototype.slice.call(e).filter(function (e) {
              return e instanceof HTMLElement;
            }),
            i = [],
            a = 0;
          a < n.length;
          a++
        ) {
          var r = n[a];
          try {
            if (null !== r.getAttribute("data-fp-omit")) continue;
            void 0 !== r._flatpickr &&
              (r._flatpickr.destroy(), (r._flatpickr = void 0)),
              (r._flatpickr = Gl(r, t || {})),
              i.push(r._flatpickr);
          } catch (e) {
            console.error(e);
          }
        }
        return 1 === i.length ? i[0] : i;
      }
      "undefined" != typeof HTMLElement &&
        "undefined" != typeof HTMLCollection &&
        "undefined" != typeof NodeList &&
        ((HTMLCollection.prototype.flatpickr = NodeList.prototype.flatpickr =
          function (e) {
            return Xl(this, e);
          }),
        (HTMLElement.prototype.flatpickr = function (e) {
          return Xl([this], e);
        }));
      var Kl = function (e, t) {
        return "string" == typeof e
          ? Xl(window.document.querySelectorAll(e), t)
          : e instanceof Node
          ? Xl([e], t)
          : Xl(e, t);
      };
      (Kl.defaultConfig = {}),
        (Kl.l10ns = { en: $l({}, Ll), default: $l({}, Ll) }),
        (Kl.localize = function (e) {
          Kl.l10ns.default = $l($l({}, Kl.l10ns.default), e);
        }),
        (Kl.setDefaults = function (e) {
          Kl.defaultConfig = $l($l({}, Kl.defaultConfig), e);
        }),
        (Kl.parseDate = zl({})),
        (Kl.formatDate = Wl({})),
        (Kl.compareDates = Nl),
        "undefined" != typeof jQuery &&
          void 0 !== jQuery.fn &&
          (jQuery.fn.flatpickr = function (e) {
            return Xl(this, e);
          }),
        (Date.prototype.fp_incr = function (e) {
          return new Date(
            this.getFullYear(),
            this.getMonth(),
            this.getDate() + ("string" == typeof e ? parseInt(e, 10) : e)
          );
        }),
        "undefined" != typeof window && (window.flatpickr = Kl);
      var Ql = Kl;
      window.flatpickr = Ql;
      n(1163), n(7386);
    })();
})();
//# sourceMappingURL=app.js.map
